/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 48);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = (typeof Symbol!=='undefined' && Symbol.for && Symbol.for('react.element')) || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol!=='undefined' ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};


var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vert|word|writing|x)[A-Z]/;


var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process==='undefined' || !Object({"NODE_ENV":"production"}) || "production"!=='production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() { return null; }



// make react think we're react.
var VNode = __WEBPACK_IMPORTED_MODULE_1_preact__["h"]('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function() { return this.nodeName; },
	set: function(v) { this.nodeName = v; },
	configurable:true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function() { return this.attributes; },
	set: function(v) { this.attributes = v; },
	configurable:true
});



var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) { e = oldEventHook(e); }
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};


var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
			attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag==='function') {
			if (tag[COMPONENT_WRAPPER_KEY]===true || (tag.prototype && 'isReactComponent' in tag.prototype)) {
				if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
				if (vnode.children) { attrs.children = vnode.children; }

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		}
		else {
			if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
			if (vnode.children) { attrs.children = vnode.children; }

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value!==0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) { oldVnodeHook(vnode); }
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
		a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) { extend(vnode.attributes, tag.defaultProps); }
	if (a) { extend(vnode.attributes, a); }
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) { if ((shouldSanitize = CAMEL_PROPS.test(i))) { break; } }
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[ CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i ] = a[i];
				}
			}
		}
	}
}



// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode!==parent) { prev = null; }

	// default to first Element child
	if (!prev) { prev = parent.children[0]; }

	// remove unaffected siblings
	for (var i=parent.childNodes.length; i--; ) {
		if (parent.childNodes[i]!==prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = __WEBPACK_IMPORTED_MODULE_1_preact__["render"](vnode, parent, prev);
	if (parent) { parent._preactCompatRendered = out && (out._component || { base: out }); }
	if (typeof callback==='function') { callback(); }
	return out && out._component || out;
}


var ContextProvider = function () {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = __WEBPACK_IMPORTED_MODULE_1_preact__["h"](ContextProvider, { context: parentComponent.context }, vnode);
	var c = render$1(wrap, container);
	if (callback) { callback(c); }
	return c._component || c.base;
}


function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode===container) {
		__WEBPACK_IMPORTED_MODULE_1_preact__["render"](__WEBPACK_IMPORTED_MODULE_1_preact__["h"](EmptyComponent), container, existing);
		return true;
	}
	return false;
}



var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		return children.map(fn);
	},
	forEach: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		children.forEach(fn);
	},
	count: function(children) {
		return children && children.length || 0;
	},
	only: function(children) {
		children = Children.toArray(children);
		if (children.length!==1) { throw new Error('Children.only() expects only one child.'); }
		return children[0];
	},
	toArray: function(children) {
		if (children == null) { return []; }
		return Array.isArray && Array.isArray(children) ? children : ARR.concat(children);
	}
};


/** Track current render() component for ref assignment */
var currentComponent;


function createFactory(type) {
	return createElement.bind(null, type);
}


var DOM = {};
for (var i=ELEMENTS.length; i--; ) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i=offset || 0; i<arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		}
		else if (obj && typeof obj==='object' && !isValidElement(obj) && ((obj.props && obj.type) || (obj.attributes && obj.nodeName) || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c==='function' && !(c.prototype && c.prototype.render);
}


// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function() {
			return WrappedComponent(this.props, this.context);
		}
	});
}


function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) { return Wrapped===true ? Ctor : Wrapped; }

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable:true, value:true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable:true, value:Wrapped });

	return Wrapped;
}


function createElement() {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}


function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
		type = ref && typeof ref;
	if (currentComponent && (type==='string' || type==='number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}


function cloneElement$1(element, props) {
	var children = [], len = arguments.length - 2;
	while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];

	if (!isValidElement(element)) { return element; }
	var elementProps = element.attributes || element.props;
	var node = __WEBPACK_IMPORTED_MODULE_1_preact__["h"](
		element.nodeName || element.type,
		elementProps,
		element.children || elementProps && elementProps.children
	);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	}
	else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}


function isValidElement(element) {
	return element && ((element instanceof VNode) || element.$$typeof===REACT_ELEMENT_TYPE);
}


function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved===null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}


function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName!=='string') { return; }
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName==='textarea' || (nodeName.toLowerCase()==='input' && !/^fil|che|rad/i.test(attributes.type)))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}


function applyClassName(ref) {
	var attributes = ref.attributes;

	if (!attributes) { return; }
	var cl = attributes.className || attributes.class;
	if (cl) { attributes.className = cl; }
}


function extend(base, props) {
	for (var key in props) {
		if (props.hasOwnProperty(key)) {
			base[key] = props[key];
		}
	}
	return base;
}


function shallowDiffers(a, b) {
	for (var i in a) { if (!(i in b)) { return true; } }
	for (var i$1 in b) { if (a[i$1]!==b[i$1]) { return true; } }
	return false;
}


function findDOMNode(component) {
	return component && component.base || component;
}


function F(){}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps();
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}


// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i=0; i<mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key]==='function') {
				(keyed[key] || (keyed[key]=[])).push(mixin[key]);
			}
		}
	}
	return keyed;
}


// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) { if (mixins.hasOwnProperty(key)) {
		proto[key] = multihook(
			mixins[key].concat(proto[key] || ARR),
			key==='getDefaultProps' || key==='getInitialState' || key==='getChildContext'
		);
	} }
}


function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v==='function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}


function callMethod(ctx, m, args) {
	if (typeof m==='string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m==='function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function() {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i=0; i<hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r!=null) {
				if (!ret) { ret = {}; }
				for (var key in r) { if (r.hasOwnProperty(key)) {
					ret[key] = r[key];
				} }
			}
			else if (typeof r!=='undefined') { ret = r; }
		}
		return ret;
	};
}


function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}


function propsHook(props, context) {
	if (!props) { return; }

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length===1) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children==='object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this==='function' ? this : this.constructor,
			propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}


function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent===this) {
		currentComponent = null;
	}
}



function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts!==BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function() {
		return this.base;
	},

	isMounted: function() {
		return !!this.base;
	}
});



function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function(props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};



var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=preact-compat.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(31)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(4);
var toSubscriber_1 = __webpack_require__(56);
var observable_1 = __webpack_require__(18);
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__(15);
var Subscription_1 = __webpack_require__(5);
var Observer_1 = __webpack_require__(33);
var rxSubscriber_1 = __webpack_require__(17);
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Landbot config
 * 
 * Las propiedades cuyo valor es null por defecto, deben
 * ser definidas en el snippet para funcionar.
 */
var c = UmiCoreConfig;
var emptyObj = function emptyObj(a) {
  return a ? Object.keys(a).length === 0 : true;
};
c.colors = !emptyObj(c.colors) ? c.colors : {};
c.text = !emptyObj(c.text) ? c.text : {};

var CONFIG = {
  staticUrl: c.staticUrl || null,
  messageLimit: c.messageLimit || 20,
  has_bot: typeof c.has_bot === 'boolean' ? c.has_bot : true,
  // soundUrl: c.soundUrl || null,
  // Colors
  colors: {
    header_text: c.colors.header_text || c.contrast || '#FFFFFF',
    bot_message_background: c.colors.bot_message_background || c.light || '#FFFFFF',
    bot_message_text: c.colors.bot_message_text || c.dark || '#34495E',
    user_message_background: c.colors.user_message_background || c.accent || '#F11952',
    user_message_text: c.colors.user_message_text || c.light || '#FFFFFF',
    button_background: c.colors.button_background || c.accent || '#F11952',
    button_text: c.colors.button_text || c.light || '#FFFFFF',
    textarea_background: c.colors.textarea_background || '#FFFFFF',
    textarea_text: c.colors.textarea_text || '#000000',
    textarea_border: c.colors.textarea_border || c.accent || '#F11952',
    inline_input: c.colors.inline_input || c.contrast || '#FFFFFF'
  },
  text: {
    inline_input_placeholder: c.text.inline_input_placeholder || 'Type your @field here...',
    text_input_placeholder: c.text.text_input_placeholder || 'Type here...',
    fields: c.text.fields || ['name', 'phone', 'email', 'postal code', 'address', 'country', 'birthdate'],
    input_menu_help: c.text.input_menu_help || 'Choose an option',
    input_multi_help: c.text.input_multi_help || 'Choose at least one',
    input_instant_search_help: c.text.input_instant_search_help || 'Filter the options',
    input_text_help: c.text.input_text_help || 'Press enter to send',
    send: c.text.send || 'Send',
    back: c.text.back || 'Back',
    search: c.text.search || 'Search',
    error: c.text.error || '⚠️  It seems there is a technical problem. Please reload this page'
  },
  accent: c.accent || '#F11952',
  dark: c.dark || '#34495E',
  light: c.light || '#FFFFFF',
  contrast: c.contrast || '#FFFFFF',
  header_background: c.header_background || 'transparent',
  // Avatar
  avatar_shape: c.avatar_shape || 'none', // circle, rect, none
  avatar_scale: c.avatar_scale || 1,
  avatar_url: c.avatar_url || (c.logo !== 'none' ? c.logo : false) || 'https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png',
  // Fonts
  font: c.font || 'Montserrat',
  font_size: c.font_size || '15', // XS, S, M, L, LG -> valor numérico?
  // Content variables
  logo: c.logo || 'https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png',
  brand_name: typeof c.brand_name === 'string' ? c.brand_name : 'landbot',
  tagline: typeof c.tagline === 'string' ? c.tagline : 'Get more leads using chatbots 🤖',
  // Background variables
  background_type: c.background_type || 'gradient', // color, gradient, image, video
  background_image_url: c.background_image_url || 'https://storage.googleapis.com/media.yexir.com/channels_back/31.png',
  background_color: c.background_color || '#FFFFFF',
  gradient_from: c.gradient_from || '#FF575B',
  gradient_to: c.gradient_to || '#F11952',
  videoname: c.videoname || 'video_1',
  video_url: c.video_url || null,
  // Filter variables
  filter_type: c.filter_type || 'none', // none, color, gradient, image
  filter_color: c.filter_color || '#000000',
  filter_gradient_from: c.filter_gradient_from || '#FFAD59',
  filter_gradient_to: c.filter_gradient_to || '#FFE199',
  filter_image_url: c.filter_image_url || 'https://storage.googleapis.com/media.yexir.com/channels_back/31.png',
  // External
  stylesheets: !emptyObj(c.stylesheets) ? c.stylesheets : [],
  // Custom
  style: c.style || false,
  // Keywords
  keywords: !emptyObj(c.keywords) ? c.keywords : {},
  persistent_menu: !emptyObj(c.persistent_menu) ? c.persistent_menu : {},
  // Progress
  progress: typeof c.progress === 'number' ? c.progress : false,
  // Test
  test: c.test || false,
  // Branding
  branding: c.branding !== false ? true : false,
  // General settings
  typing: typeof c.typing === 'boolean' ? c.typing : true,
  widget_hide_background: c.widget_hide_background || false,
  widget_hide_header: c.widget_hide_header || false
};

exports.default = CONFIG;
var referralHeaderURL = exports.referralHeaderURL = 'https://landbot.io/powered-by?utm_source=' + CONFIG.brand_name + '&utm_medium=landbot&utm_campaign=header';
var referralFooterURL = exports.referralFooterURL = 'https://landbot.io/powered-by?utm_source=' + CONFIG.brand_name + '&utm_medium=landbot&utm_campaign=footer';

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
exports.root = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(16);
var isObject_1 = __webpack_require__(32);
var isFunction_1 = __webpack_require__(15);
var tryCatch_1 = __webpack_require__(11);
var errorObject_1 = __webpack_require__(6);
var UnsubscriptionError_1 = __webpack_require__(57);
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(1);
var ScalarObservable_1 = __webpack_require__(20);
var EmptyObservable_1 = __webpack_require__(21);
var isScheduler_1 = __webpack_require__(8);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable = (function (_super) {
    __extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function (array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */
    ArrayObservable.of = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len > 1) {
            return new ArrayObservable(array, scheduler);
        }
        else if (len === 1) {
            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
        }
        else {
            return new EmptyObservable_1.EmptyObservable(scheduler);
        }
    };
    ArrayObservable.dispatch = function (state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ArrayObservable.dispatch, 0, {
                array: array, index: index, count: count, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < count && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayObservable;
}(Observable_1.Observable));
exports.ArrayObservable = ArrayObservable;
//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = __webpack_require__(72);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import EventEmitter from 'event-emitter';
// import EventEmitter from 'eventemitter3';

var ee = new _events2.default(); // ================
// EVENTS INTERFACE
// ================
// Ver documentación en:
// https://nodejs.org/api/events.html#events_class_eventemitter

// Escoger el que más nos guste...

ee.setMaxListeners(0);
// Esto funciona de lujo.
// ee.on('hu-start-connection', () => console.log('Connection started'));
// ee.on('hu-query-send-message', (a) => console.log(`Sending message: ${a.text}`))


// ee.on('hu-query-send-message',)
// Test
// setTimeout(() => ee.emit('hu-start-connection'), 1000);
// setTimeout(() => ee.emit('hu-query-send-message', { text: 'HOLA!' }), 2000);

exports.default = ee;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__(6);
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
exports.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(4);
var isArrayLike_1 = __webpack_require__(36);
var isPromise_1 = __webpack_require__(37);
var isObject_1 = __webpack_require__(32);
var Observable_1 = __webpack_require__(1);
var iterator_1 = __webpack_require__(22);
var InnerSubscriber_1 = __webpack_require__(62);
var observable_1 = __webpack_require__(18);
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            return result.subscribe(destination);
        }
    }
    else if (isArrayLike_1.isArrayLike(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root_1.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator_1.iterator] === 'function') {
        var iterator = result[iterator_1.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable_1.observable] === 'function') {
        var obs = result[observable_1.observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
exports.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EventDriver = __webpack_require__(9);

var _EventDriver2 = _interopRequireDefault(_EventDriver);

var _DateUtils = __webpack_require__(27);

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Chat Utils
 */

var ChatUtils = {
  /**
   * Sends a message to UmiCore
   * @param {String} text
   * @param {Array} images
   * @param {Array} image_flags
   */
  sendMessage: function sendMessage() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var images = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var image_flags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var render = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    // console.debug(`%cLandbot debug: Message sent ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue');
    _EventDriver2.default.emit('hu-lb-sending-message'); // For input hiding
    _EventDriver2.default.emit('hu-query-send-message', {
      message: text,
      payload: payload || text,
      images: images,
      image_flags: image_flags,
      render: render
    });
  },

  /**
   * Triggers enable user input
   */
  enableInput: function enableInput() {
    _EventDriver2.default.emit('hu-lb-enable-input');
  },

  /**
   * Triggers disable user input
   */
  disableInput: function disableInput() {
    _EventDriver2.default.emit('hu-lb-disable-input');
  },

  /**
   * 
   */
  randomKey: function randomKey() {
    var ncharacters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var text = "+";
    for (var i = 0; i < ncharacters; i++) {
      text = text.concat(chars.charAt(Math.floor(Math.random() * chars.length)));
    }return text;
  }
};

exports.default = ChatUtils;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(4);
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(4);
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var fromEvent_1 = __webpack_require__(58);
Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(1);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable = (function (_super) {
    __extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) {
            this._isScalar = false;
        }
    }
    ScalarObservable.create = function (value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function (state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        state.done = true;
        this.schedule(state);
    };
    ScalarObservable.prototype._subscribe = function (subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ScalarObservable.dispatch, 0, {
                done: false, value: value, subscriber: subscriber
            });
        }
        else {
            subscriber.next(value);
            if (!subscriber.closed) {
                subscriber.complete();
            }
        }
    };
    return ScalarObservable;
}(Observable_1.Observable));
exports.ScalarObservable = ScalarObservable;
//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(1);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var EmptyObservable = (function (_super) {
    __extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */
    EmptyObservable.create = function (scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function (arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    EmptyObservable.prototype._subscribe = function (subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
        }
        else {
            subscriber.complete();
        }
    };
    return EmptyObservable;
}(Observable_1.Observable));
exports.EmptyObservable = EmptyObservable;
//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__(4);
function symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) {
            Symbol.iterator = Symbol('iterator polyfill');
        }
        return Symbol.iterator;
    }
    else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
            return '@@iterator';
        }
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                    return key;
                }
            }
        }
        return '@@iterator';
    }
}
exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
exports.iterator = symbolIteratorPonyfill(root_1.root);
/**
 * @deprecated use iterator instead
 */
exports.$$iterator = exports.iterator;
//# sourceMappingURL=iterator.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var pairwise_1 = __webpack_require__(64);
Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.1.3
Build: rev-1234895
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
  value: true
});

var _firebase_app = __webpack_require__(74);

// Export a single instance of firebase app
var firebase = (0, _firebase_app.createFirebaseNamespace)(); /**
                                                             * Copyright 2017 Google Inc.
                                                             *
                                                             * Licensed under the Apache License, Version 2.0 (the "License");
                                                             * you may not use this file except in compliance with the License.
                                                             * You may obtain a copy of the License at
                                                             *
                                                             *   http://www.apache.org/licenses/LICENSE-2.0
                                                             *
                                                             * Unless required by applicable law or agreed to in writing, software
                                                             * distributed under the License is distributed on an "AS IS" BASIS,
                                                             * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                             * See the License for the specific language governing permissions and
                                                             * limitations under the License.
                                                             */
// Import the createFirebaseNamespace function
exports.default = firebase;
module.exports = exports['default'];
//# sourceMappingURL=app.js.map


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Common utils
 */
var Utils = {
  /**
   * @param {Number} ncharacters
   */
  randomKey: function randomKey() {
    var ncharacters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var text = "+";
    for (var i = 0; i < ncharacters; i++) {
      text = text.concat(chars.charAt(Math.floor(Math.random() * chars.length)));
    }return text;
  },
  /**
   * 
   */
  getOrigin: function getOrigin() {
    return window.location != window.parent.location ? document.referrer : document.location.href;
  },
  /**
   * getProp
   * @param {Object} data - Target Object
   * @param {Array} tree - Example: ['nodes', '1_0', 'responses', '0', 'text']
   * @param {*} def - Default value on tree error
   */
  getProp: function getProp(data, tree, def) {
    var iterator = JSON.parse(JSON.stringify(data));
    try {
      for (var i = 0; i < tree.length; i++) {
        iterator = iterator[tree[i]];
      }return iterator === undefined ? def : iterator;
    } catch (e) {
      return def;
    }
  }
};

exports.default = Utils;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UmiLogger = __webpack_require__(86);

var _UmiLogger2 = _interopRequireDefault(_UmiLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logger = new _UmiLogger2.default('Landbot');
window.landbotLogger = Logger;

exports.default = Logger;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Date Utils
 */

var DateUtils = {
  /**
   * Format a given numeric timestamp as a time string
   * @param {Number} t timestamp in miliseconds
   * @param {String} f format string
   */
  format: function format(t, f) {
    var result = '0';
    var date = null;
    var H = null;
    var m = null;
    var s = null;
    var ms = null;
    switch (f) {
      case 'HH:mm':
        date = new Date(t);
        H = ('0' + date.getHours()).slice(-2);
        m = ('0' + date.getMinutes()).slice(-2);
        return H + ':' + m;
      case 'HH:mm:ss.ff':
        date = new Date(t);
        H = ('0' + date.getHours()).slice(-2);
        m = ('0' + date.getMinutes()).slice(-2);
        s = ('0' + date.getSeconds()).slice(-2);
        ms = ('0000' + date.getMilliseconds()).slice(-4);
        return H + ':' + m + ':' + s + '.' + ms;
      default:
        return result;
    }
  }
};

exports.default = DateUtils;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Config = __webpack_require__(3);

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var c = _Config2.default;

/**
 * Object that contains all dynamic css rules
 * 
 * value: valor inicial que adquiere por defecto.
 * index: Nombre (único) de regla.
 *  -> Naming: {property}-{key}
 * type: Propiedad css.
 * selectors: Array de clases afectadas por esta regla.
 * 
 * relatives: Cuando una regla es cambiada, también lo son
 *  sus 'relatives'. Dichos 'relatives' adquieren el mismo
 *  'value', pero son procesados por un filtro.
 */
var CSSRules = {
  // DIRECT VARIABLES
  header_text: {
    value: c.colors.header_text,
    rules: [{
      index: 'color_header-text',
      type: 'color',
      selectors: ['.hu-color_header-text']
    }]
  },
  bot_message_background: {
    value: c.colors.bot_message_background,
    rules: [{
      index: 'background-color_bot-message-background',
      type: 'background-color',
      selectors: ['.hu-background-color_bot-message-background', '#hu-footer-input-mobile .hu-input-header', '.hu-message.brand .hu-message-info.visible + .hu-message-content::before']
    }]
  },
  bot_message_text: {
    value: c.colors.bot_message_text,
    rules: [{
      index: 'color_bot-message-text',
      type: 'color',
      selectors: ['.hu-color_bot-message-text']
    }]
  },
  user_message_background: {
    value: c.colors.user_message_background,
    rules: [{
      index: 'background-color_user-message-background',
      type: 'background-color',
      selectors: ['.hu-background-color_user-message-background']
    }]
  },
  user_message_text: {
    value: c.colors.user_message_text,
    rules: [{
      index: 'color_user-message-text',
      type: 'color',
      selectors: ['.hu-color_user-message-text']
    }]
  },
  button_background: {
    value: c.colors.button_background,
    rules: [{
      index: 'background-color_button-background',
      type: 'background-color',
      selectors: ['.hu-background-color_button-background', '.hu-header-btn-referral:hover, .hu-header-btn-referral:focus', '.multi-button.active', '#hu-message-input .left-arrow', '.open .keyword-switch', '#hu-footer-input-mobile .back-button', '#hu-footer-input-mobile .powered-by-text a', '#hu-footer-input-mobile .keyword-button', '#hu-footer-input-mobile .skip-pause-button']
    }, {
      index: 'color_button-background',
      type: 'color',
      selectors: ['.hu-color_button-background', '.multi-button:hover:not(.active) .button-text']
    }, {
      index: 'border-color_button-background',
      type: 'border-color',
      selectors: ['.multi-button:not(.active) .check-block', '.multi-button:not(.active) .check-label:after', '#hu-footer-input-mobile .multi-button']
    }],
    relatives: ['button-background-dark', 'button-background-light']
  },
  button_text: {
    value: c.colors.button_text,
    rules: [{
      index: 'color_button-text',
      type: 'color',
      selectors: ['.hu-color_button-text', '.multi-button.active .button-text', '#hu-footer-input-mobile .powered-by-text a', '#hu-footer-input-mobile .keyword-button']
    }, {
      index: 'border-color_button-text',
      type: 'border-color',
      selectors: ['.hu-border-color_button-text', '.multi-button.active .check-block', '.multi-button.active .check-label:after']
    }, {
      index: 'fill_button-text',
      type: 'fill',
      selectors: ['.hu-fill_button-text']
    }]
  },
  textarea_background: {
    value: c.colors.textarea_background,
    rules: [{
      index: 'background-color_textarea-background',
      type: 'background-color',
      selectors: ['.hu-background-color_textarea-background']
    }]
  },
  textarea_text: {
    value: c.colors.textarea_text,
    rules: [{
      index: 'color_textarea-text',
      type: 'color',
      selectors: ['.hu-color_textarea-text', '.hu-textarea-heavy .hu-textarea:empty:before', '#hu-footer-input-mobile .hu-textarea:empty:before']
    }]
  },
  textarea_border: {
    value: c.colors.textarea_border,
    rules: [{
      index: 'border-color_textarea-border',
      type: 'border-color',
      selectors: ['.hu-border-color_textarea-border', '#hu-message-input .hu-textarea-heavy .hu-textarea-input-container.focus, #hu-footer-input-fixed .hu-textarea-heavy .hu-textarea-input-container.focus', '.hu-textarea-heavy .hu-textarea']
    }, {
      index: 'fill_textarea-text',
      type: 'fill',
      selectors: ['.hu-textarea-heavy .send svg']
    }]
  },
  inline_input: {
    value: c.colors.inline_input,
    rules: [{
      index: 'color_inline-input',
      type: 'color',
      selectors: ['.hu-color_inline-input', '.hu-textarea-light .hu-textarea', '.hu-textarea-light .hu-textarea:empty:before']
    },
    // START PLACEHOLDERS
    {
      index: 'color_inline-input_webkit-placeholder',
      type: 'color',
      selectors: ['.hu-textarea-light .hu-textarea::-webkit-input-placeholder']
    }, {
      index: 'color_inline-input_webkit-placeholder',
      type: 'color',
      selectors: ['.hu-textarea-light .hu-textarea::-moz-placeholder']
    }, {
      index: 'color_inline-input_webkit-placeholder',
      type: 'color',
      selectors: ['.hu-textarea-light .hu-textarea::-ms-input-placeholder']
    }, {
      index: 'color_inline-input_webkit-placeholder',
      type: 'color',
      selectors: ['.hu-textarea-light .hu-textarea:-moz-placeholder']
    },
    // END PLACEHOLDERS
    {
      index: 'background-color_inline-input',
      type: 'background-color',
      selectors: ['.hu-background-color_inline-input']
    }, {
      index: 'fill_inline-input',
      type: 'fill',
      selectors: ['.hu-fill_inline-input', '.hu-textarea-light .send']
    }]
  },
  accent: {
    value: c.accent,
    rules: [{
      index: 'background-color_accent',
      type: 'background-color',
      selectors: ['.hu-background-color_accent',
      // '.hu-header-btn-referral:hover, .hu-header-btn-referral:focus',
      // '.multi-button.active',
      // '#hu-message-input .left-arrow',
      // '.open .keyword-switch',
      '#hu-bot-progress-bar::after']
    }, {
      index: 'color-accent',
      type: 'color',
      selectors: ['.hu-color_accent',
      // '.hu-textarea-heavy .hu-textarea::-webkit-input-placeholder',
      // '.hu-textarea-heavy .hu-textarea::-moz-placeholder',
      // '.hu-textarea-heavy .hu-textarea:-ms-input-placeholder',
      // '.hu-textarea-heavy .hu-textarea:-moz-placeholder',
      // '.hu-textarea-heavy .hu-textarea:empty:before',
      // '.multi-button:hover:not(.active) .button-text',
      '#hu-footer-input-mobile .hu-input-multi-info', '#hu-footer-input-mobile .hu-input-menu-info', '#hu-footer-input-mobile .multi-button:not(.active) .button-text',
      // '#hu-footer-input-mobile .hu-textarea::-webkit-input-placeholder',
      // '#hu-footer-input-mobile .hu-textarea::-moz-placeholder',
      // '#hu-footer-input-mobile .hu-textarea:-ms-input-placeholder',
      // '#hu-footer-input-mobile .hu-textarea:-moz-placeholder',
      // '#hu-footer-input-mobile .hu-textarea:empty:before',
      '#hu-footer-input-mobile .drop-search-input-container i', '#hu-footer-input-mobile .drop-search-input']
    }, {
      index: 'border-color_accent',
      type: 'border-color',
      selectors: [
        // '#hu-message-input .hu-textarea-heavy .hu-textarea-input-container.focus, #hu-footer-input-fixed .hu-textarea-heavy .hu-textarea-input-container.focus',
        // '.multi-button:not(.active) .check-block',
        // '.multi-button:not(.active) .check-label:after',
        // '#hu-footer-input-mobile .multi-button',
      ]
    }, {
      index: 'fill_accent',
      type: 'fill',
      selectors: ['.hu-fill_accent',
      // '.hu-textarea-heavy .send svg',
      '#hu-footer-input-mobile .send svg, #hu-footer-input-mobile .attach svg, #hu-footer-input-mobile .emoji svg']
    }, {
      index: 'stroke_accent',
      type: 'stroke',
      selectors: ['.hu-stroke_accent']
    }, {
      index: 'border-bottom_accent',
      type: 'border-bottom',
      selectors: ['#hu-footer-input-mobile .drop-search-input-container']
    }],
    relatives: ['accent-light', 'accent-dark']
  },
  dark: {
    value: c.dark,
    rules: [{
      index: 'background-color_dark',
      type: 'background-color',
      selectors: []
    }, {
      index: 'color_dark',
      type: 'color',
      selectors: ['.hu-color_dark', '.multi-button:not(.active) .button-text']
    }, {
      index: 'border-color_dark',
      type: 'border-color',
      selectors: []
    }]
  },
  light: {
    value: c.light,
    rules: [{
      index: 'background-color_light',
      type: 'background-color',
      selectors: ['.hu-background-color_light', '.sk-folding-cube .sk-cube::before', '.multi-button:not(.active)']
    }, {
      index: 'color_light',
      type: 'color',
      selectors: ['.hu-color_light',
      // '.multi-button.active .button-text',
      '.hu-keyword-selector.open .keyword-switch']
    }, {
      index: 'border-color_light',
      type: 'border-color',
      selectors: ['.hu-border-color_light',
      // '#hu-message-input .dual .menu-button:not(.icon):not(.image):last-child:not(:hover)',
      '#hu-message-input .dual .menu-button:not(.image):last-child:not(:hover)']
    }, {
      index: 'fill_light',
      type: 'fill',
      selectors: ['.hu-fill_light']
    }]
  },
  contrast: {
    value: c.contrast,
    rules: [{
      index: 'background-color_contrast',
      type: 'background-color',
      selectors: ['.hu-background-color_contrast']
    }, {
      index: 'color_contrast',
      type: 'color',
      selectors: ['.hu-color_contrast',
      // '.hu-textarea-light .hu-textarea::-webkit-input-placeholder',
      // '.hu-textarea-light .hu-textarea::-moz-placeholder',
      // '.hu-textarea-light .hu-textarea:-ms-input-placeholder',
      // '.hu-textarea-light .hu-textarea:-moz-placeholder',
      // '.hu-textarea-light .hu-textarea:empty:before',
      '#hu-message-input .hu-input-multi-info',
      // '.hu-message-bubble.typing::before',
      '#hu-footer .hu-keyword-selector::before']
    }, {
      index: 'border-color_contrast',
      type: 'border-color',
      selectors: ['.hu-border-color_contrast']
    }, {
      index: 'fill_contrast',
      type: 'fill',
      selectors: ['.hu-fill_contrast']
    }, {
      index: 'stroke_contrast',
      type: 'stroke',
      selectors: ['.hu-stroke_contrast']
    }],
    relatives: ['contrast-fade', 'contrast-fade-0.7']
  },
  header_background: {
    value: c.header_background,
    rules: [{
      index: 'background-color_header-background',
      type: 'background-color',
      selectors: ['.hu-background-color_header-background']
    }]
  },
  avatar_scale: {
    value: 'scale(' + c.avatar_scale + ')',
    rules: [{
      index: 'transform_avatar-scale',
      type: 'transform',
      selectors: ['.hu-message-avatar::before']
    }]
  },
  avatar_url: {
    value: c.avatar_url ? 'url("' + c.avatar_url + '")' : 'url("https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png")',
    rules: [{
      index: 'background-image_logo',
      type: 'background-image',
      selectors: ['.hu-message-avatar:before']
    }]
  },
  font: {
    value: c.font ? c.font + ',sans-serif' : 'Montserrat,sans-serif',
    rules: [{
      index: 'font-family_font',
      type: 'font-family',
      selectors: ['#app-landbot, button, input, textarea']
    }]
  },
  font_size: {
    value: c.font_size ? c.font_size + 'px' : '13px',
    rules: [{
      index: 'font-size_font-size',
      type: 'font-size',
      selectors: ['#app-landbot, button, input, textarea']
    }]
  },
  // logo: {
  //   value: c.logo ? `url("${c.logo}")` : `url("https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png")`,
  //   rules: [
  //     {
  //       index: 'background-image_logo',
  //       type: 'background-image',
  //       selectors: [
  //         '.hu-message-avatar:before',
  //       ],
  //     },
  //   ],
  // },
  background_color: {
    value: c.background_color,
    rules: [{
      index: 'background-color_background-color',
      type: 'background-color',
      selectors: ['#hu-background .hu-background-color']
    }]
  },
  background_gradient: {
    value: 'linear-gradient(to bottom, ' + c.gradient_from + ' 0%, ' + c.gradient_to + ' 100%)' || 'linear-gradient(to bottom, #FFAD59 0%, #FFE199 100%)',
    rules: [{
      index: 'background_background-gradient',
      type: 'background',
      selectors: ['#hu-background .hu-background-gradient']
    }]
  },
  background_image_url: {
    value: 'url("' + c.background_image_url + '")' || 'url("https://storage.googleapis.com/media.yexir.com/channels_back/31.png")',
    rules: [{
      index: 'background-image_background-image-url',
      type: 'background-image',
      selectors: ['#hu-background .hu-background-image']
    }]
  },
  background_video_fallback: { // TODO: Esto necesita un repaso
    value: c.video_url ? 'url("https://storage.googleapis.com/static.helloumi.com/landbot/video/' + c.video_url + '.jpg")' : 'url("https://storage.googleapis.com/static.helloumi.com/landbot/video/video_1.jpg")',
    rules: [{
      index: 'background-image_background_video_fallback',
      type: 'background-image',
      selectors: ['#hu-background .hu-background-video video']
    }]
  },
  filter_color: {
    value: c.filter_color,
    rules: [{
      index: 'background_filter-color',
      type: 'background-color',
      selectors: ['#hu-filter .hu-filter-color']
    }]
  },
  filter_gradient: {
    value: c.filter_gradient_from && c.filter_gradient_to ? 'linear-gradient(to bottom, ' + c.filter_gradient_from + ' 0%, ' + c.filter_gradient_to + ' 100%)' : 'linear-gradient(to bottom, #FFAD59 0%, #FFE199 100%)',
    rules: [{
      index: 'background_filter-gradient',
      type: 'background',
      selectors: ['#hu-filter .hu-filter-gradient']
    }]
  },
  filter_image_url: {
    value: c.filter_image_url ? 'url("' + c.filter_image_url + '")' : 'url("https://storage.googleapis.com/media.yexir.com/channels_back/31.png")',
    rules: [{
      index: 'background-image_filter-image-url',
      type: 'background-image',
      selectors: ['#hu-filter .hu-filter-image']
    }]
  },

  // RELATIVE VARIABLES
  'button-background-dark': {
    tasks: [{
      filter: 'lightenDarkenColor',
      factor: -.5
    }],
    rules: [{
      index: 'border-color_button-background-dark',
      type: 'border-color',
      selectors: ['.hu-border-color_button-background-dark', '#hu-message-input .dual .menu-button:last-child:hover', '.multi-button.active']
    }]
  },
  'button-background-light': {
    tasks: [{
      filter: 'lightenDarkenColor',
      factor: 0.3 // 0.3?
    }],
    rules: [{
      index: 'background-color_button-background-light',
      type: 'background-color',
      selectors: ['.hu-background-color_button-background-light', '.hu-background-color_button-background-light_hover:hover', '#hu-message-input .hu-input-box .hu-input-menu .hu-input-menu-buttons .menu-button:hover', '.hu-input-multi .submit-button:hover:not(:disabled)', '#hu-message-input .left-arrow:hover', '.multi-button.active:hover', '.p-menu-button:hover']
    }]
  },
  'accent-light': {
    // value: '#F23164', // F7205D?
    tasks: [{
      filter: 'lightenDarkenColor',
      factor: 0.3 // 0.3?
    }],
    rules: [{
      index: 'background-color_accent-light',
      type: 'background-color',
      selectors: ['.hu-background-color_accent-light', '.hu-background-color_accent-light_hover:hover']
    }]
  },
  'accent-dark': {
    // value: '#000000',//'#CB0C3F',
    tasks: [{
      filter: 'lightenDarkenColor',
      factor: -.5
    }],
    rules: [{
      index: 'border-color_accent-dark',
      type: 'border-color',
      selectors: ['.hu-border-color_accent-dark']
    }]
  },
  'contrast-fade': {
    // value: 'rgba(255, 255, 255, .4)',
    tasks: [{
      filter: 'fadeColor',
      factor: 0.4
    }],
    rules: [{
      index: 'border-color_contrast-fade',
      type: 'border-color',
      selectors: ['.hu-border-color_contrast-fade']
    }, {
      index: 'background-color_contrast-fade',
      type: 'background-color',
      selectors: ['.hu-background-color_contrast-fade']
    }]
  },
  'contrast-fade-0.7': {
    tasks: [{
      filter: 'fadeColor',
      factor: 0.7
    }],
    rules: [{
      index: 'border-color_contrast-fade-07',
      type: 'border-color',
      selectors: ['.hu-border-color_contrast-fade-07']
    }]
  }
};

exports.default = CSSRules;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncAction_1 = __webpack_require__(112);
var AsyncScheduler_1 = __webpack_require__(114);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */
exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
//# sourceMappingURL=async.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ChatUtils = __webpack_require__(14);

var _ChatUtils2 = _interopRequireDefault(_ChatUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeywordSelector = function (_React$Component) {
  _inherits(KeywordSelector, _React$Component);

  function KeywordSelector(props) {
    _classCallCheck(this, KeywordSelector);

    var _this = _possibleConstructorReturn(this, (KeywordSelector.__proto__ || Object.getPrototypeOf(KeywordSelector)).call(this, props));

    _this.state = {
      keywords: props.keywords,
      // oneClickMenu: Object.keys(props.keywords)
      //   .filter((k) => props.keywords[k] !== 'back')
      //   .length === 1,
      disabled: true,
      open: true
    };
    _this.ee = props.ee;
    _this.setupListeners();
    return _this;
  }

  _createClass(KeywordSelector, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      this.ee.on('hu-lb-enable-input', function () {
        _this2.setState({
          disabled: false
          // open: false,
        });
      });

      this.ee.on('hu-lb-disable-input', function () {
        _this2.setState({
          disabled: true
          // open: false,
        });
      });
    }
  }, {
    key: 'clickHandler',
    value: function clickHandler(keyword) {
      if (!this.state.disabled) {
        this.setState({
          disabled: true
          // open: false,
        });
        _ChatUtils2.default.sendMessage(keyword);
      }
    }
  }, {
    key: 'getKeyButton',
    value: function getKeyButton(keyword) {
      var _this3 = this;

      var keywords = this.props.keywords;

      return _react2.default.createElement(
        'button',
        {
          className: 'keyword-button hu-background-color_light hu-color_accent',
          onClick: function onClick() {
            return _this3.clickHandler(keyword);
          }
        },
        keyword
      );
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu() {
      var state = this.state.open;
      this.setState({
        // open: !state,
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var keywords = this.props.keywords;
      var _state = this.state,
          disabled = _state.disabled,
          open = _state.open,
          oneClickMenu = _state.oneClickMenu;

      var keys = Object.keys(keywords).filter(function (k) {
        return k !== '#back' && k !== '#init';
      });
      var bulbIcon = _react2.default.createElement(
        'svg',
        { className: 'bulb-icon hu-fill_accent', version: '1.1', id: 'Capa_1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px',
          viewBox: '0 0 81.6 82.1', 'enable-background': 'new 0 0 81.6 82.1', xmlSpace: 'preserve' },
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: 'M67.3,45.3c-2.8,4.6-6.5,8.2-11.2,10.8V61c0,1.6-0.6,2.9-1.7,4.1s-2.5,1.7-4.1,1.7H31.3c-1.6,0-2.9-0.6-4.1-1.7 s-1.7-2.5-1.7-4.1v-4.9c-4.7-2.6-8.4-6.2-11.2-10.8c-2.8-4.6-4.1-9.6-4.1-15c0-8.2,3-15.3,9-21.1c6-5.8,13.2-8.7,21.6-8.7 c8.5,0,15.7,2.9,21.6,8.7c6,5.8,9,12.8,9,21.1C71.4,35.6,70.1,40.7,67.3,45.3z M63.8,39.6c1.3-3,1.9-6.1,1.9-9.3 c0-3.2-0.6-6.4-1.9-9.3c-1.3-2.9-3.1-5.4-5.3-7.7c-2.3-2.2-4.9-4-7.9-5.2c-3.1-1.3-6.3-1.9-9.7-1.9c-3.4,0-6.6,0.6-9.7,1.9 c-3,1.2-5.6,2.9-7.9,5.2c-2.3,2.2-4.1,4.8-5.3,7.7c-1.3,3-1.9,6.1-1.9,9.3c0,3.2,0.6,6.4,1.9,9.3c1.3,2.9,3.1,5.4,5.3,7.7 c2.3,2.2,4.9,4,7.9,5.2l0.2,0.1V61h19.1v-8.5l0.2-0.1c3-1.2,5.6-2.9,7.9-5.2c2.3-2.2,3.4-3.3,3.4-3.3S62.5,42.4,63.8,39.6z M53.1,77.1c0.6,0.6,0.8,1.2,0.8,2c0,0.8-0.3,1.5-0.8,2S51.8,82,51,82H30.6c-0.8,0-1.5-0.3-2-0.8s-0.8-1.2-0.8-2 c0-0.8,0.3-1.5,0.8-2s1.2-0.8,2-0.8H51C51.8,76.3,52.5,76.6,53.1,77.1z' })
        )
      );
      var crossIcon = _react2.default.createElement(
        'svg',
        { className: 'cross-icon hu-fill_light', version: '1.1', id: 'Capa_1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink', x: '0px', y: '0px',
          viewBox: '0 0 81.6 82.1', 'enable-background': 'new 0 0 81.6 82.1', xmlSpace: 'preserve' },
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: 'M65.5,61.8c0.6,0.6,1,1.3,1,2.2s-0.3,1.6-0.9,2.2c-0.6,0.6-1.4,0.9-2.2,0.9s-1.6-0.3-2.2-1L40.8,45.9L20.5,66.2 c-0.6,0.6-1.3,1-2.2,1s-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.4-0.9-2.2s0.3-1.6,1-2.2l20.3-20.3L16.1,21.1c-0.6-0.6-1-1.3-1-2.2 s0.3-1.6,0.9-2.2c0.6-0.6,1.4-0.9,2.2-0.9s1.6,0.3,2.2,1L40.8,37l20.3-20.3c0.6-0.6,1.3-1,2.2-1s1.6,0.3,2.2,0.9 c0.6,0.6,0.9,1.4,0.9,2.2s-0.3,1.6-1,2.2L45.3,41.5L65.5,61.8z' })
        )
      );

      if (keys.length > 0) return _react2.default.createElement(
        'div',
        { className: 'hu-keyword-selector' + (disabled ? ' disabled' : '') + (open ? ' open' : '') },
        _react2.default.createElement(
          'button',
          {
            className: 'keyword-switch hu-s-18 hu-color_contrast',
            onClick: this.toggleMenu.bind(this)
          },
          bulbIcon,
          crossIcon,
          _react2.default.createElement(
            'span',
            { className: 'keyword-switch-text' },
            'Menu'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'keyword-menu' },
          _react2.default.createElement(
            'div',
            { className: 'keyword-buttons' },
            keys.map(this.getKeyButton.bind(this))
          )
        )
      );else return null;
    }
  }]);

  return KeywordSelector;
}(_react2.default.Component);

exports.default = KeywordSelector;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var merge_1 = __webpack_require__(60);
Observable_1.Observable.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__(12);
var subscribeToResult_1 = __webpack_require__(13);
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return this.lift(new MergeAllOperator(concurrent));
}
exports.mergeAll = mergeAll;
var MergeAllOperator = (function () {
    function MergeAllOperator(concurrent) {
        this.concurrent = concurrent;
    }
    MergeAllOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeAllSubscriber(observer, this.concurrent));
    };
    return MergeAllOperator;
}());
exports.MergeAllOperator = MergeAllOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeAllSubscriber = (function (_super) {
    __extends(MergeAllSubscriber, _super);
    function MergeAllSubscriber(destination, concurrent) {
        _super.call(this, destination);
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
    }
    MergeAllSubscriber.prototype._next = function (observable) {
        if (this.active < this.concurrent) {
            this.active++;
            this.add(subscribeToResult_1.subscribeToResult(this, observable));
        }
        else {
            this.buffer.push(observable);
        }
    };
    MergeAllSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeAllSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeAllSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeAllSubscriber = MergeAllSubscriber;
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var distinctUntilChanged_1 = __webpack_require__(63);
Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var first_1 = __webpack_require__(65);
Observable_1.Observable.prototype.first = first_1.first;
//# sourceMappingURL=first.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v4.1.3
Build: rev-1234895
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
* Copyright 2017 Google Inc.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/
var scope = void 0;
if (typeof global !== 'undefined') {
    scope = global;
} else if (typeof self !== 'undefined') {
    scope = self;
} else {
    try {
        scope = Function('return this')();
    } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
    }
}
var PromiseImpl = scope.Promise || __webpack_require__(76);
var local = exports.local = {
    Promise: PromiseImpl,
    GoogPromise: PromiseImpl
};
//# sourceMappingURL=shared_promise.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Date Utils
 */

var DateUtils = {
  /**
   * Format a given numeric timestamp as a time string
   * @param {Number} t timestamp in miliseconds
   * @param {String} f format string
   */
  format: function format(t, f) {
    var result = '0';
    var date = null;
    var H = null;
    var m = null;
    var s = null;
    var ms = null;
    switch (f) {
      case 'HH:mm':
        date = new Date(t);
        H = ('0' + date.getHours()).slice(-2);
        m = ('0' + date.getMinutes()).slice(-2);
        return H + ':' + m;
      case 'HH:mm:ss.ff':
        date = new Date(t);
        H = ('0' + date.getHours()).slice(-2);
        m = ('0' + date.getMinutes()).slice(-2);
        s = ('0' + date.getSeconds()).slice(-2);
        ms = ('0000' + date.getMilliseconds()).slice(-4);
        return H + ':' + m + ':' + s + '.' + ms;
      default:
        return result;
    }
  }
};

exports.default = DateUtils;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(1);
var Subscriber_1 = __webpack_require__(2);
var Subscription_1 = __webpack_require__(5);
var ObjectUnsubscribedError_1 = __webpack_require__(43);
var SubjectSubscription_1 = __webpack_require__(97);
var rxSubscriber_1 = __webpack_require__(17);
/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}(Subscriber_1.Subscriber));
exports.SubjectSubscriber = SubjectSubscriber;
/**
 * @class Subject<T>
 */
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable_1.Observable));
exports.Subject = Subject;
/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription_1.Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));
exports.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = (function (_super) {
    __extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error));
exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Observable_1.Observable.of(this.value);
            case 'E':
                return Observable_1.Observable.throw(this.error);
            case 'C':
                return Observable_1.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
exports.isDate = isDate;
//# sourceMappingURL=isDate.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChatUtils = __webpack_require__(14);

var _ChatUtils2 = _interopRequireDefault(_ChatUtils);

var _EventDriver = __webpack_require__(9);

var _EventDriver2 = _interopRequireDefault(_EventDriver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// SPECIAL MESSAGES FUNCTIONS
/**
 * Special Utils
 */
window.jsReferral = function (ref) {
  // ee.emit('hu-lb-message-referral', ref);
};

window.fakeMessage = function (message) {
  _ChatUtils2.default.sendMessage(message);
};

window.ghostMessage = function (message) {
  _EventDriver2.default.emit('hu-receive-ghost-message', Object.assign({ key: _ChatUtils2.default.randomKey() }, message));
};

var SpecialUtils = {
  getReferralUrl: function getReferralUrl(type, _ref) {
    var brand = _ref.brand;

    var url_referral = window.location != window.parent.location ? document.referrer : document.location.href;
    switch (type) {
      case 'facebook':
        return 'https://facebook.com/sharer/sharer.php?u=' + encodeURI(url_referral);
      case 'twitter':
        return 'https://twitter.com/intent/tweet/?text=Try%20this%20conversational%20website%20made%20with%20Landbot.io%20%F0%9F%A4%96%20%F0%9F%92%AC%20%20&amp;url=' + encodeURI(url_referral);
      case 'linkedin':
        return 'https://www.linkedin.com/shareArticle?mini=true&amp;url=' + encodeURI(url_referral) + '&amp;title=Try%20this%20conversational%20website%20made%20with%20Landbot.io%20%F0%9F%A4%96%20%F0%9F%92%AC%20%20&amp;summary=Landbot.io%20is%20a%20tool%20to%20create%20conversational%20interfaces%20in%20substitution%20of%20forms.%20No%20coding%20required!&amp;source=' + encodeURI(url_referral);
      case 'whatsapp':
        return 'https://api.whatsapp.com/send?text=Try%20this%20conversational%20website%20made%20with%20Landbot.io%20%F0%9F%A4%96%20%F0%9F%92%AC%20%20%20' + encodeURI(url_referral);
    }
  }
};

exports.default = SpecialUtils;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollButton = function (_React$Component) {
  _inherits(ScrollButton, _React$Component);

  function ScrollButton(props) {
    _classCallCheck(this, ScrollButton);

    var _this = _possibleConstructorReturn(this, (ScrollButton.__proto__ || Object.getPrototypeOf(ScrollButton)).call(this, props));

    _this.state = {
      enabled: false
    };
    _this.ee = props.ee;

    // ee.on('hu-display-scrollbottom', (display) => {
    //   this.setState({
    //     enabled: display,
    //   });
    // });
    return _this;
  }

  _createClass(ScrollButton, [{
    key: 'onClick',
    value: function onClick() {
      this.ee.emit('hu-scroll-button-click');
      this.ee.emit('hu-lb-key-arrowdown');
    }
  }, {
    key: 'render',
    value: function render() {
      // const { clickHandler } = this.props;
      var enabled = this.state.enabled;

      // if (!enabled)
      //   return null;

      return _react2.default.createElement(
        'div',
        { className: 'hu-scroll-bottom' },
        _react2.default.createElement(
          'button',
          { className: 'scroll-bottom-button', onClick: this.onClick.bind(this) },
          _react2.default.createElement(
            'svg',
            { width: '14px', height: '15px', viewBox: '0 0 14 15', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
            _react2.default.createElement(
              'g',
              { id: 'Page-1', stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
              _react2.default.createElement('path', { className: 'hu-fill_accent', d: 'M7.8984375,0.83984375 L7.8984375,12.0507812 L11.9609375,7.83203125 C12.1302092,7.64973867 12.3320301,7.55859375 12.5664062,7.55859375 C12.8007824,7.55859375 13.0058585,7.63997314 13.1816406,7.80273437 C13.3574228,7.96549561 13.4453125,8.16406133 13.4453125,8.3984375 C13.4453125,8.63281367 13.3671883,8.84114492 13.2109375,9.0234375 L7.6640625,14.765625 C7.49479082,14.9479176 7.28971475,15.0390625 7.04882812,15.0390625 C6.8079415,15.0390625 6.60286543,14.9479176 6.43359375,14.765625 L0.8671875,8.984375 C0.710936719,8.81510332 0.6328125,8.61979277 0.6328125,8.3984375 C0.6328125,8.15104043 0.723957422,7.94270918 0.90625,7.7734375 C1.07552168,7.60416582 1.27734258,7.52278643 1.51171875,7.52929687 C1.74609492,7.53580732 1.94791582,7.62369707 2.1171875,7.79296875 L6.1796875,12.0117188 L6.1796875,0.8203125 C6.1796875,0.598957227 6.25781172,0.40364668 6.4140625,0.234375 C6.57031328,0.0651033203 6.75911348,-0.0260416016 6.98046875,-0.0390625 C7.22786582,-0.0520833984 7.44270742,0.0292959961 7.625,0.205078125 C7.80729258,0.380860254 7.8984375,0.59244668 7.8984375,0.83984375 Z', id: '\uE619', fill: '#FFFFFF' })
            )
          )
        )
      );
    }
  }]);

  return ScrollButton;
}(_react2.default.Component);

exports.default = ScrollButton;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(49);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(0);

var _Observable = __webpack_require__(1);

__webpack_require__(19);

__webpack_require__(34);

__webpack_require__(38);

__webpack_require__(23);

__webpack_require__(39);

__webpack_require__(67);

__webpack_require__(69);

__webpack_require__(70);

var _UmiCore = __webpack_require__(71);

var _UmiCore2 = _interopRequireDefault(_UmiCore);

var _EventDriver = __webpack_require__(9);

var _EventDriver2 = _interopRequireDefault(_EventDriver);

var _Config = __webpack_require__(3);

var _Config2 = _interopRequireDefault(_Config);

var _ComIface = __webpack_require__(88);

var _ComIface2 = _interopRequireDefault(_ComIface);

var _DynamicStylesTag = __webpack_require__(89);

var _DynamicStylesTag2 = _interopRequireDefault(_DynamicStylesTag);

var _CSSRules = __webpack_require__(28);

var _CSSRules2 = _interopRequireDefault(_CSSRules);

var _GUI = __webpack_require__(92);

var _GUI2 = _interopRequireDefault(_GUI);

var _Background = __webpack_require__(150);

var _Background2 = _interopRequireDefault(_Background);

var _Filter = __webpack_require__(155);

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import Rx from 'rxjs';


// Velocity


// Styles


// Core & Events


// Components


var C = _Config2.default;

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));

    _this.state = {
      isLoading: true,
      rendered: false,
      staticUrl: C.staticUrl,
      // soundUrl: C.soundUrl,
      // Colors
      colors: C.colors,
      accent: C.accent,
      dark: C.dark,
      light: C.light,
      contrast: C.contrast,
      header_background: C.header_background,
      // Avatar
      avatar_shape: C.avatar_shape, // circle, rect, none
      avatar_scale: C.avatar_scale,
      avatar_url: C.avatar_url,
      // Fonts
      font: C.font,
      font_size: C.font_size,
      // Content variables
      logo: C.logo,
      brand_name: C.brand_name,
      tagline: C.tagline,
      // Background variables
      background_type: C.background_type, // color, gradient, image, video
      background_image_url: C.background_image_url,
      background_color: C.background_color,
      gradient_from: C.gradient_from,
      gradient_to: C.gradient_to,
      videoname: C.videoname,
      video_url: C.video_url,
      // Filter variables
      filter_type: C.filter_type, // none, color, gradient, image
      filter_color: C.filter_color,
      filter_gradient_from: C.filter_gradient_from,
      filter_gradient_to: C.filter_gradient_to,
      filter_image_url: C.filter_image_url,
      // External
      stylesheets: C.stylesheets,
      // Custom
      style: C.style,
      // Keywords
      keywords: C.keywords,
      persistent_menu: C.persistent_menu,
      // Progress
      progress: C.progress,
      // Test
      test: C.test,
      // Branding
      branding: C.branding,
      // General settings
      typing: C.typing,
      widget_hide_background: C.widget_hide_background,
      widget_hide_header: C.widget_hide_header
    };
    _this.GOOGLE_API_KEY = 'AIzaSyCsJun2zDaXACKwuR-0dJefAhBwIwR5PP8';

    _this.setupListeners();
    _this.umicore = new _UmiCore2.default();
    _this.appElem = null;

    window.setGlobalState = _this.setGlobalState.bind(_this);
    window.ee = _EventDriver2.default;
    return _this;
  }

  /**
   * state = {
   *   background_color: red,
   *   ...
   * }
   */


  _createClass(App, [{
    key: 'setGlobalState',
    value: function setGlobalState(state) {
      this.setState(state);
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      var umicoreReady$ = _Observable.Observable.fromEvent(_EventDriver2.default, 'hu-umicore-ready');
      var landbotReady$ = _Observable.Observable.fromEvent(_EventDriver2.default, 'hu-landbot-ready');

      var appReady$ = _Observable.Observable.merge(umicoreReady$, landbotReady$).distinctUntilChanged().pairwise().first().subscribe({
        next: function next(v) {
          return _EventDriver2.default.emit('hu-start-connection');
        }
      });

      var reception1$ = _Observable.Observable.fromEvent(_EventDriver2.default, 'hu-receive-message');
      var reception2$ = _Observable.Observable.fromEvent(_EventDriver2.default, 'hu-initial-chat');

      var hideLoader$ = _Observable.Observable.merge(reception1$, reception2$).first().subscribe({
        next: function next(v) {
          return _this2.setState({ isLoading: false });
        }
      });

      _EventDriver2.default.on('hu-lb-rendered', function () {
        _this2.setState({
          rendered: true
        });
      });

      _EventDriver2.default.on('hu-load-config', function (config) {
        _this2.setState(config);
      });

      _EventDriver2.default.on('hu-error-wrong-customer', function () {
        // Manejar error de recepción de firebase token
      });

      _EventDriver2.default.on('hu-error-wrong-channel', function () {
        // Manejar error de recepción de firebase token
      });

      _EventDriver2.default.on('hu-error-auth-connection', function () {
        // Manejar error de conexión de firebase
      });

      _EventDriver2.default.on('hu-error-server-connection', function () {
        // Manejar error de conexión con servidor de Django
      });

      // AUDIO?
      // if (this.state.soundUrl) {
      //   const audio = new Audio(this.state.soundUrl);
      //   ee.on('hu-lb-audio-notification', () => {
      //     audio.play()
      //   });
      // } // Ver además document.activeElement
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // TESTS ================

      // setInterval(() => {
      // let bools = [true, false];
      // let val0 = bools[Math.floor(Math.random()*bools.length)];
      // let colors1 = ['#FF199F', '#E87F55', '#FFD16A', '#9867E8', '#86BDFF'];
      // let colors2 = ['#6250FF', '#FFAB54', '#78E87B', '#E8A786', '#95FF54'];
      // let val1 = colors1[Math.floor(Math.random()*colors1.length)];
      // let val2 = colors2[Math.floor(Math.random()*colors2.length)];
      // let bgs = ['video', 'image', 'gradient', 'color'];
      // let val3 = bgs[Math.floor(Math.random()*bgs.length)];
      // let bgimgs = [
      //   'https://storage.googleapis.com/media.yexir.com/channels_back/31.png',
      //   'http://pre06.deviantart.net/c55d/th/pre/f/2011/210/3/a/3aac8c61503090b3dae6743dc8d5cd4c-d421d5s.jpg',
      //   'http://img04.deviantart.net/ee5b/i/2009/088/3/c/droideka_by_avaruus_apina.jpg'
      // ];
      // let val4 = bgimgs[Math.floor(Math.random()*bgimgs.length)];
      // let videos = ['video_1', 'video_2', 'video_3', 'video_4'];
      // let val5 = videos[Math.floor(Math.random()*videos.length)];
      // let fil_types = ['color', 'gradient', 'image'];
      // let val6 = fil_types[Math.floor(Math.random()*fil_types.length)];
      // let fonts = ['Inconsolata', 'Montserrat', 'Lato'];
      // let val7 = fonts[Math.floor(Math.random()*fonts.length)];
      // let fonts_sizes = ['14', '15', '16', '17', '18'];
      // let val8 = fonts_sizes[Math.floor(Math.random()*fonts_sizes.length)];
      // let avatar_shapes = ['none', 'circle', 'rect'];
      // let val9 = avatar_shapes[Math.floor(Math.random()*avatar_shapes.length)];
      // let styles = [
      //   '#hu-header { background-color: red; }',
      //   '#hu-header { background-color: transparent; }',
      //   '#hu-header { background-color: green; }', 
      // ];
      // let val10 = styles[Math.floor(Math.random()*styles.length)];
      // let colors = {
      //   header_text: val1,
      //   bot_message_background: val2,
      //   bot_message_text: val1,
      //   user_message_background: val1,
      //   user_message_text: val2,
      //   button_background: 'black',//val1,
      //   button_text: val2,
      //   textarea_background: val1,
      //   textarea_text: val2,
      //   textarea_border: val2,
      //   inline_input: val2,
      // };
      // let val12 = 'video';

      // this.setState({ gradient_from: val1, gradient_to: val2 });
      // this.setState({ accent: val1 });
      // this.setState({ background_color: val1, background_type: val3 });
      // this.setState({ background_image_url: val4 });
      // this.setState({ video_url: val5 });
      // console.log(val3, val5)
      // this.setState({ background_type: val12, videoname: val5 });
      // this.setState({ header_background: val1 });
      // this.setState({ background_type: val3, filter_type: val6 });
      // this.setState({ font: val7 });
      // this.setState({ font_size: val8 });
      // this.setState({tagline: val7});
      // this.setState({avatar_shape: val9});
      // this.setState({style: val10})
      // this.setState({ colors: colors });

      // }, 4000);

      // TESTS ==============================
    }
  }, {
    key: 'render',
    value: function render() {
      var _React$createElement;

      var _state = this.state,
          isLoading = _state.isLoading,
          rendered = _state.rendered,
          staticUrl = _state.staticUrl,
          colors = _state.colors,
          accent = _state.accent,
          dark = _state.dark,
          light = _state.light,
          contrast = _state.contrast,
          header_background = _state.header_background,
          avatar_shape = _state.avatar_shape,
          avatar_scale = _state.avatar_scale,
          avatar_url = _state.avatar_url,
          font = _state.font,
          font_size = _state.font_size,
          logo = _state.logo,
          brand_name = _state.brand_name,
          tagline = _state.tagline,
          background_type = _state.background_type,
          background_image_url = _state.background_image_url,
          background_color = _state.background_color,
          gradient_from = _state.gradient_from,
          gradient_to = _state.gradient_to,
          videoname = _state.videoname,
          video_url = _state.video_url,
          filter_type = _state.filter_type,
          filter_color = _state.filter_color,
          filter_gradient_from = _state.filter_gradient_from,
          filter_gradient_to = _state.filter_gradient_to,
          filter_image_url = _state.filter_image_url,
          stylesheets = _state.stylesheets,
          style = _state.style,
          keywords = _state.keywords,
          persistent_menu = _state.persistent_menu,
          progress = _state.progress,
          test = _state.test,
          branding = _state.branding,
          typing = _state.typing,
          widget_hide_background = _state.widget_hide_background,
          widget_hide_header = _state.widget_hide_header;


      return _react2.default.createElement(
        'div',
        { id: 'app-modules', className: '' + (rendered ? 'rendered' : '') },
        _react2.default.createElement(_DynamicStylesTag2.default, {
          ee: _EventDriver2.default,
          colors: colors,
          accent: accent,
          dark: dark,
          light: light,
          contrast: contrast,
          avatar_scale: avatar_scale,
          avatar_url: avatar_url,
          logo: logo,
          header_background: header_background,
          font: font,
          font_size: font_size,
          background_image_url: background_image_url,
          background_color: background_color,
          gradient_from: gradient_from,
          gradient_to: gradient_to,
          filter_color: filter_color,
          filter_gradient_from: filter_gradient_from,
          filter_gradient_to: filter_gradient_to,
          filter_image_url: filter_image_url,
          stylesheets: stylesheets,
          style: style
        }),
        _react2.default.createElement(_GUI2.default, (_React$createElement = {
          ee: _EventDriver2.default,
          staticUrl: staticUrl,
          isLoading: isLoading,
          avatar_shape: avatar_shape,
          brand_name: brand_name,
          logo: logo
        }, _defineProperty(_React$createElement, 'brand_name', brand_name), _defineProperty(_React$createElement, 'tagline', tagline), _defineProperty(_React$createElement, 'keywords', keywords), _defineProperty(_React$createElement, 'persistent_menu', persistent_menu), _defineProperty(_React$createElement, 'progress', progress), _defineProperty(_React$createElement, 'test', test), _defineProperty(_React$createElement, 'branding', branding), _defineProperty(_React$createElement, 'typing', typing), _defineProperty(_React$createElement, 'widget_hide_header', widget_hide_header), _React$createElement)),
        _react2.default.createElement(_Filter2.default, {
          staticUrl: staticUrl,
          filter_type: filter_type,
          filter_color: filter_color,
          filter_gradient_from: filter_gradient_from,
          filter_gradient_to: filter_gradient_to,
          filter_image_url: filter_image_url,
          widget_hide_background: widget_hide_background
        }),
        _react2.default.createElement(_Background2.default, {
          staticUrl: staticUrl,
          background_type: background_type,
          background_image_url: background_image_url,
          background_color: background_color,
          gradient_from: gradient_from,
          gradient_to: gradient_to,
          videoname: videoname,
          video_url: video_url,
          widget_hide_background: widget_hide_background
        }),
        _react2.default.createElement('script', { src: 'https://maps.googleapis.com/maps/api/js?key=' + this.GOOGLE_API_KEY + '&libraries=places' })
      );
    }
  }]);

  return App;
}(_react2.default.Component);

(0, _reactDom.render)(_react2.default.createElement(App, null), document.getElementById('app-landbot'));

/**
 * Module Hot Replacement
 * Determine actions made when code changes, instead of refreshing the whole page.
 */
if (false) {
  // module.hot.accept();
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(51)();
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(52);
var invariant = __webpack_require__(53);
var ReactPropTypesSecret = __webpack_require__(54);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

!function() {
    'use strict';
    function VNode() {}
    function h(nodeName, attributes) {
        var lastSimple, child, simple, i, children = EMPTY_CHILDREN;
        for (i = arguments.length; i-- > 2; ) stack.push(arguments[i]);
        if (attributes && null != attributes.children) {
            if (!stack.length) stack.push(attributes.children);
            delete attributes.children;
        }
        while (stack.length) if ((child = stack.pop()) && void 0 !== child.pop) for (i = child.length; i--; ) stack.push(child[i]); else {
            if (child === !0 || child === !1) child = null;
            if (simple = 'function' != typeof nodeName) if (null == child) child = ''; else if ('number' == typeof child) child = String(child); else if ('string' != typeof child) simple = !1;
            if (simple && lastSimple) children[children.length - 1] += child; else if (children === EMPTY_CHILDREN) children = [ child ]; else children.push(child);
            lastSimple = simple;
        }
        var p = new VNode();
        p.nodeName = nodeName;
        p.children = children;
        p.attributes = null == attributes ? void 0 : attributes;
        p.key = null == attributes ? void 0 : attributes.key;
        if (void 0 !== options.vnode) options.vnode(p);
        return p;
    }
    function extend(obj, props) {
        for (var i in props) obj[i] = props[i];
        return obj;
    }
    function cloneElement(vnode, props) {
        return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
    }
    function enqueueRender(component) {
        if (!component.__d && (component.__d = !0) && 1 == items.push(component)) (options.debounceRendering || setTimeout)(rerender);
    }
    function rerender() {
        var p, list = items;
        items = [];
        while (p = list.pop()) if (p.__d) renderComponent(p);
    }
    function isSameNodeType(node, vnode, hydrating) {
        if ('string' == typeof vnode || 'number' == typeof vnode) return void 0 !== node.splitText;
        if ('string' == typeof vnode.nodeName) return !node._componentConstructor && isNamedNode(node, vnode.nodeName); else return hydrating || node._componentConstructor === vnode.nodeName;
    }
    function isNamedNode(node, nodeName) {
        return node.__n === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
    }
    function getNodeProps(vnode) {
        var props = extend({}, vnode.attributes);
        props.children = vnode.children;
        var defaultProps = vnode.nodeName.defaultProps;
        if (void 0 !== defaultProps) for (var i in defaultProps) if (void 0 === props[i]) props[i] = defaultProps[i];
        return props;
    }
    function createNode(nodeName, isSvg) {
        var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
        node.__n = nodeName;
        return node;
    }
    function removeNode(node) {
        if (node.parentNode) node.parentNode.removeChild(node);
    }
    function setAccessor(node, name, old, value, isSvg) {
        if ('className' === name) name = 'class';
        if ('key' === name) ; else if ('ref' === name) {
            if (old) old(null);
            if (value) value(node);
        } else if ('class' === name && !isSvg) node.className = value || ''; else if ('style' === name) {
            if (!value || 'string' == typeof value || 'string' == typeof old) node.style.cssText = value || '';
            if (value && 'object' == typeof value) {
                if ('string' != typeof old) for (var i in old) if (!(i in value)) node.style[i] = '';
                for (var i in value) node.style[i] = 'number' == typeof value[i] && IS_NON_DIMENSIONAL.test(i) === !1 ? value[i] + 'px' : value[i];
            }
        } else if ('dangerouslySetInnerHTML' === name) {
            if (value) node.innerHTML = value.__html || '';
        } else if ('o' == name[0] && 'n' == name[1]) {
            var useCapture = name !== (name = name.replace(/Capture$/, ''));
            name = name.toLowerCase().substring(2);
            if (value) {
                if (!old) node.addEventListener(name, eventProxy, useCapture);
            } else node.removeEventListener(name, eventProxy, useCapture);
            (node.__l || (node.__l = {}))[name] = value;
        } else if ('list' !== name && 'type' !== name && !isSvg && name in node) {
            setProperty(node, name, null == value ? '' : value);
            if (null == value || value === !1) node.removeAttribute(name);
        } else {
            var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
            if (null == value || value === !1) if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase()); else node.removeAttribute(name); else if ('function' != typeof value) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value); else node.setAttribute(name, value);
        }
    }
    function setProperty(node, name, value) {
        try {
            node[name] = value;
        } catch (e) {}
    }
    function eventProxy(e) {
        return this.__l[e.type](options.event && options.event(e) || e);
    }
    function flushMounts() {
        var c;
        while (c = mounts.pop()) {
            if (options.afterMount) options.afterMount(c);
            if (c.componentDidMount) c.componentDidMount();
        }
    }
    function diff(dom, vnode, context, mountAll, parent, componentRoot) {
        if (!diffLevel++) {
            isSvgMode = null != parent && void 0 !== parent.ownerSVGElement;
            hydrating = null != dom && !('__preactattr_' in dom);
        }
        var ret = idiff(dom, vnode, context, mountAll, componentRoot);
        if (parent && ret.parentNode !== parent) parent.appendChild(ret);
        if (!--diffLevel) {
            hydrating = !1;
            if (!componentRoot) flushMounts();
        }
        return ret;
    }
    function idiff(dom, vnode, context, mountAll, componentRoot) {
        var out = dom, prevSvgMode = isSvgMode;
        if (null == vnode) vnode = '';
        if ('string' == typeof vnode) {
            if (dom && void 0 !== dom.splitText && dom.parentNode && (!dom._component || componentRoot)) {
                if (dom.nodeValue != vnode) dom.nodeValue = vnode;
            } else {
                out = document.createTextNode(vnode);
                if (dom) {
                    if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
                    recollectNodeTree(dom, !0);
                }
            }
            out.__preactattr_ = !0;
            return out;
        }
        if ('function' == typeof vnode.nodeName) return buildComponentFromVNode(dom, vnode, context, mountAll);
        isSvgMode = 'svg' === vnode.nodeName ? !0 : 'foreignObject' === vnode.nodeName ? !1 : isSvgMode;
        if (!dom || !isNamedNode(dom, String(vnode.nodeName))) {
            out = createNode(String(vnode.nodeName), isSvgMode);
            if (dom) {
                while (dom.firstChild) out.appendChild(dom.firstChild);
                if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
                recollectNodeTree(dom, !0);
            }
        }
        var fc = out.firstChild, props = out.__preactattr_ || (out.__preactattr_ = {}), vchildren = vnode.children;
        if (!hydrating && vchildren && 1 === vchildren.length && 'string' == typeof vchildren[0] && null != fc && void 0 !== fc.splitText && null == fc.nextSibling) {
            if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
        } else if (vchildren && vchildren.length || null != fc) innerDiffNode(out, vchildren, context, mountAll, hydrating || null != props.dangerouslySetInnerHTML);
        diffAttributes(out, vnode.attributes, props);
        isSvgMode = prevSvgMode;
        return out;
    }
    function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
        var j, c, vchild, child, originalChildren = dom.childNodes, children = [], keyed = {}, keyedLen = 0, min = 0, len = originalChildren.length, childrenLen = 0, vlen = vchildren ? vchildren.length : 0;
        if (0 !== len) for (var i = 0; i < len; i++) {
            var _child = originalChildren[i], props = _child.__preactattr_, key = vlen && props ? _child._component ? _child._component.__k : props.key : null;
            if (null != key) {
                keyedLen++;
                keyed[key] = _child;
            } else if (props || (void 0 !== _child.splitText ? isHydrating ? _child.nodeValue.trim() : !0 : isHydrating)) children[childrenLen++] = _child;
        }
        if (0 !== vlen) for (var i = 0; i < vlen; i++) {
            vchild = vchildren[i];
            child = null;
            var key = vchild.key;
            if (null != key) {
                if (keyedLen && void 0 !== keyed[key]) {
                    child = keyed[key];
                    keyed[key] = void 0;
                    keyedLen--;
                }
            } else if (!child && min < childrenLen) for (j = min; j < childrenLen; j++) if (void 0 !== children[j] && isSameNodeType(c = children[j], vchild, isHydrating)) {
                child = c;
                children[j] = void 0;
                if (j === childrenLen - 1) childrenLen--;
                if (j === min) min++;
                break;
            }
            child = idiff(child, vchild, context, mountAll);
            if (child && child !== dom) if (i >= len) dom.appendChild(child); else if (child !== originalChildren[i]) if (child === originalChildren[i + 1]) removeNode(originalChildren[i]); else dom.insertBefore(child, originalChildren[i] || null);
        }
        if (keyedLen) for (var i in keyed) if (void 0 !== keyed[i]) recollectNodeTree(keyed[i], !1);
        while (min <= childrenLen) if (void 0 !== (child = children[childrenLen--])) recollectNodeTree(child, !1);
    }
    function recollectNodeTree(node, unmountOnly) {
        var component = node._component;
        if (component) unmountComponent(component); else {
            if (null != node.__preactattr_ && node.__preactattr_.ref) node.__preactattr_.ref(null);
            if (unmountOnly === !1 || null == node.__preactattr_) removeNode(node);
            removeChildren(node);
        }
    }
    function removeChildren(node) {
        node = node.lastChild;
        while (node) {
            var next = node.previousSibling;
            recollectNodeTree(node, !0);
            node = next;
        }
    }
    function diffAttributes(dom, attrs, old) {
        var name;
        for (name in old) if ((!attrs || null == attrs[name]) && null != old[name]) setAccessor(dom, name, old[name], old[name] = void 0, isSvgMode);
        for (name in attrs) if (!('children' === name || 'innerHTML' === name || name in old && attrs[name] === ('value' === name || 'checked' === name ? dom[name] : old[name]))) setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
    }
    function collectComponent(component) {
        var name = component.constructor.name;
        (components[name] || (components[name] = [])).push(component);
    }
    function createComponent(Ctor, props, context) {
        var inst, list = components[Ctor.name];
        if (Ctor.prototype && Ctor.prototype.render) {
            inst = new Ctor(props, context);
            Component.call(inst, props, context);
        } else {
            inst = new Component(props, context);
            inst.constructor = Ctor;
            inst.render = doRender;
        }
        if (list) for (var i = list.length; i--; ) if (list[i].constructor === Ctor) {
            inst.__b = list[i].__b;
            list.splice(i, 1);
            break;
        }
        return inst;
    }
    function doRender(props, state, context) {
        return this.constructor(props, context);
    }
    function setComponentProps(component, props, opts, context, mountAll) {
        if (!component.__x) {
            component.__x = !0;
            if (component.__r = props.ref) delete props.ref;
            if (component.__k = props.key) delete props.key;
            if (!component.base || mountAll) {
                if (component.componentWillMount) component.componentWillMount();
            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);
            if (context && context !== component.context) {
                if (!component.__c) component.__c = component.context;
                component.context = context;
            }
            if (!component.__p) component.__p = component.props;
            component.props = props;
            component.__x = !1;
            if (0 !== opts) if (1 === opts || options.syncComponentUpdates !== !1 || !component.base) renderComponent(component, 1, mountAll); else enqueueRender(component);
            if (component.__r) component.__r(component);
        }
    }
    function renderComponent(component, opts, mountAll, isChild) {
        if (!component.__x) {
            var rendered, inst, cbase, props = component.props, state = component.state, context = component.context, previousProps = component.__p || props, previousState = component.__s || state, previousContext = component.__c || context, isUpdate = component.base, nextBase = component.__b, initialBase = isUpdate || nextBase, initialChildComponent = component._component, skip = !1;
            if (isUpdate) {
                component.props = previousProps;
                component.state = previousState;
                component.context = previousContext;
                if (2 !== opts && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === !1) skip = !0; else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
                component.props = props;
                component.state = state;
                component.context = context;
            }
            component.__p = component.__s = component.__c = component.__b = null;
            component.__d = !1;
            if (!skip) {
                rendered = component.render(props, state, context);
                if (component.getChildContext) context = extend(extend({}, context), component.getChildContext());
                var toUnmount, base, childComponent = rendered && rendered.nodeName;
                if ('function' == typeof childComponent) {
                    var childProps = getNodeProps(rendered);
                    inst = initialChildComponent;
                    if (inst && inst.constructor === childComponent && childProps.key == inst.__k) setComponentProps(inst, childProps, 1, context, !1); else {
                        toUnmount = inst;
                        component._component = inst = createComponent(childComponent, childProps, context);
                        inst.__b = inst.__b || nextBase;
                        inst.__u = component;
                        setComponentProps(inst, childProps, 0, context, !1);
                        renderComponent(inst, 1, mountAll, !0);
                    }
                    base = inst.base;
                } else {
                    cbase = initialBase;
                    toUnmount = initialChildComponent;
                    if (toUnmount) cbase = component._component = null;
                    if (initialBase || 1 === opts) {
                        if (cbase) cbase._component = null;
                        base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, !0);
                    }
                }
                if (initialBase && base !== initialBase && inst !== initialChildComponent) {
                    var baseParent = initialBase.parentNode;
                    if (baseParent && base !== baseParent) {
                        baseParent.replaceChild(base, initialBase);
                        if (!toUnmount) {
                            initialBase._component = null;
                            recollectNodeTree(initialBase, !1);
                        }
                    }
                }
                if (toUnmount) unmountComponent(toUnmount);
                component.base = base;
                if (base && !isChild) {
                    var componentRef = component, t = component;
                    while (t = t.__u) (componentRef = t).base = base;
                    base._component = componentRef;
                    base._componentConstructor = componentRef.constructor;
                }
            }
            if (!isUpdate || mountAll) mounts.unshift(component); else if (!skip) {
                flushMounts();
                if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, previousContext);
                if (options.afterUpdate) options.afterUpdate(component);
            }
            if (null != component.__h) while (component.__h.length) component.__h.pop().call(component);
            if (!diffLevel && !isChild) flushMounts();
        }
    }
    function buildComponentFromVNode(dom, vnode, context, mountAll) {
        var c = dom && dom._component, originalComponent = c, oldDom = dom, isDirectOwner = c && dom._componentConstructor === vnode.nodeName, isOwner = isDirectOwner, props = getNodeProps(vnode);
        while (c && !isOwner && (c = c.__u)) isOwner = c.constructor === vnode.nodeName;
        if (c && isOwner && (!mountAll || c._component)) {
            setComponentProps(c, props, 3, context, mountAll);
            dom = c.base;
        } else {
            if (originalComponent && !isDirectOwner) {
                unmountComponent(originalComponent);
                dom = oldDom = null;
            }
            c = createComponent(vnode.nodeName, props, context);
            if (dom && !c.__b) {
                c.__b = dom;
                oldDom = null;
            }
            setComponentProps(c, props, 1, context, mountAll);
            dom = c.base;
            if (oldDom && dom !== oldDom) {
                oldDom._component = null;
                recollectNodeTree(oldDom, !1);
            }
        }
        return dom;
    }
    function unmountComponent(component) {
        if (options.beforeUnmount) options.beforeUnmount(component);
        var base = component.base;
        component.__x = !0;
        if (component.componentWillUnmount) component.componentWillUnmount();
        component.base = null;
        var inner = component._component;
        if (inner) unmountComponent(inner); else if (base) {
            if (base.__preactattr_ && base.__preactattr_.ref) base.__preactattr_.ref(null);
            component.__b = base;
            removeNode(base);
            collectComponent(component);
            removeChildren(base);
        }
        if (component.__r) component.__r(null);
    }
    function Component(props, context) {
        this.__d = !0;
        this.context = context;
        this.props = props;
        this.state = this.state || {};
    }
    function render(vnode, parent, merge) {
        return diff(merge, vnode, {}, !1, parent, !1);
    }
    var options = {};
    var stack = [];
    var EMPTY_CHILDREN = [];
    var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
    var items = [];
    var mounts = [];
    var diffLevel = 0;
    var isSvgMode = !1;
    var hydrating = !1;
    var components = {};
    extend(Component.prototype, {
        setState: function(state, callback) {
            var s = this.state;
            if (!this.__s) this.__s = extend({}, s);
            extend(s, 'function' == typeof state ? state(s, this.props) : state);
            if (callback) (this.__h = this.__h || []).push(callback);
            enqueueRender(this);
        },
        forceUpdate: function(callback) {
            if (callback) (this.__h = this.__h || []).push(callback);
            renderComponent(this, 2);
        },
        render: function() {}
    });
    var preact = {
        h: h,
        createElement: h,
        cloneElement: cloneElement,
        Component: Component,
        render: render,
        rerender: rerender,
        options: options
    };
    if (true) module.exports = preact; else self.preact = preact;
}();
//# sourceMappingURL=preact.js.map

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__(2);
var rxSubscriber_1 = __webpack_require__(17);
var Observer_1 = __webpack_require__(33);
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventObservable_1 = __webpack_require__(59);
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(1);
var tryCatch_1 = __webpack_require__(11);
var isFunction_1 = __webpack_require__(15);
var errorObject_1 = __webpack_require__(6);
var Subscription_1 = __webpack_require__(5);
var toString = Object.prototype.toString;
function isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isNodeList(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
}
function isHTMLCollection(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
}
function isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventObservable = (function (_super) {
    __extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */
    /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * Creates an Observable by attaching an event listener to an "event target",
     * which may be an object with `addEventListener` and `removeEventListener`,
     * a Node.js EventEmitter, a jQuery style EventEmitter, a NodeList from the
     * DOM, or an HTMLCollection from the DOM. The event handler is attached when
     * the output Observable is subscribed, and removed when the Subscription is
     * unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console everytime a click
     * // occurs on the document.
     *
     * @see {@link from}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOMElement, event target, Node.js
     * EventEmitter, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */
    FromEventObservable.create = function (target, eventName, options, selector) {
        if (isFunction_1.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
            for (var i = 0, len = sourceObj.length; i < len; i++) {
                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
            }
        }
        else if (isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function () { return source_1.removeEventListener(eventName, handler); };
        }
        else if (isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function () { return source_2.off(eventName, handler); };
        }
        else if (isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
        }
        else {
            throw new TypeError('Invalid event target');
        }
        subscriber.add(new Subscription_1.Subscription(unsubscribe));
    };
    FromEventObservable.prototype._subscribe = function (subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
            if (result === errorObject_1.errorObject) {
                subscriber.error(errorObject_1.errorObject.e);
            }
            else {
                subscriber.next(result);
            }
        } : function (e) { return subscriber.next(e); };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}(Observable_1.Observable));
exports.FromEventObservable = FromEventObservable;
//# sourceMappingURL=FromEventObservable.js.map

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var merge_1 = __webpack_require__(61);
exports.merge = merge_1.mergeStatic;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var ArrayObservable_1 = __webpack_require__(7);
var mergeAll_1 = __webpack_require__(35);
var isScheduler_1 = __webpack_require__(8);
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return this.lift.call(mergeStatic.apply(void 0, [this].concat(observables)));
}
exports.merge = merge;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */
function mergeStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler_1.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new mergeAll_1.MergeAllOperator(concurrent));
}
exports.mergeStatic = mergeStatic;
//# sourceMappingURL=merge.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
exports.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
var tryCatch_1 = __webpack_require__(11);
var errorObject_1 = __webpack_require__(6);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return this.lift(new DistinctUntilChangedOperator(compare, keySelector));
}
exports.distinctUntilChanged = distinctUntilChanged;
var DistinctUntilChangedOperator = (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctUntilChangedSubscriber = (function (_super) {
    __extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') {
            this.compare = compare;
        }
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = tryCatch_1.tryCatch(this.keySelector)(value);
            if (key === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        var result = false;
        if (this.hasKey) {
            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
            if (result === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        else {
            this.hasKey = true;
        }
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return this.lift(new PairwiseOperator());
}
exports.pairwise = pairwise;
var PairwiseOperator = (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var PairwiseSubscriber = (function (_super) {
    __extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        if (this.hasPrev) {
            this.destination.next([this.prev, value]);
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
    };
    return PairwiseSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
var EmptyError_1 = __webpack_require__(66);
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first(predicate, resultSelector, defaultValue) {
    return this.lift(new FirstOperator(predicate, resultSelector, defaultValue, this));
}
exports.first = first;
var FirstOperator = (function () {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FirstSubscriber = (function (_super) {
    __extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._emit = function (value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function (value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        }
        else if (!this.hasCompleted) {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return FirstSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=first.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */
var EmptyError = (function (_super) {
    __extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error));
exports.EmptyError = EmptyError;
//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! VelocityJS.org (1.5.0). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
!function (a) {
  "use strict";
  function b(a) {
    var b = a.length,
        d = c.type(a);return "function" !== d && !c.isWindow(a) && (!(1 !== a.nodeType || !b) || "array" === d || 0 === b || "number" == typeof b && b > 0 && b - 1 in a);
  }if (!a.jQuery) {
    var c = function c(a, b) {
      return new c.fn.init(a, b);
    };c.isWindow = function (a) {
      return a && a === a.window;
    }, c.type = function (a) {
      return a ? "object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) || "function" == typeof a ? e[g.call(a)] || "object" : typeof a === "undefined" ? "undefined" : _typeof(a) : a + "";
    }, c.isArray = Array.isArray || function (a) {
      return "array" === c.type(a);
    }, c.isPlainObject = function (a) {
      var b;if (!a || "object" !== c.type(a) || a.nodeType || c.isWindow(a)) return !1;try {
        if (a.constructor && !f.call(a, "constructor") && !f.call(a.constructor.prototype, "isPrototypeOf")) return !1;
      } catch (d) {
        return !1;
      }for (b in a) {}return b === undefined || f.call(a, b);
    }, c.each = function (a, c, d) {
      var e = 0,
          f = a.length,
          g = b(a);if (d) {
        if (g) for (; e < f && c.apply(a[e], d) !== !1; e++) {} else for (e in a) {
          if (a.hasOwnProperty(e) && c.apply(a[e], d) === !1) break;
        }
      } else if (g) for (; e < f && c.call(a[e], e, a[e]) !== !1; e++) {} else for (e in a) {
        if (a.hasOwnProperty(e) && c.call(a[e], e, a[e]) === !1) break;
      }return a;
    }, c.data = function (a, b, e) {
      if (e === undefined) {
        var f = a[c.expando],
            g = f && d[f];if (b === undefined) return g;if (g && b in g) return g[b];
      } else if (b !== undefined) {
        var h = a[c.expando] || (a[c.expando] = ++c.uuid);return d[h] = d[h] || {}, d[h][b] = e, e;
      }
    }, c.removeData = function (a, b) {
      var e = a[c.expando],
          f = e && d[e];f && (b ? c.each(b, function (a, b) {
        delete f[b];
      }) : delete d[e]);
    }, c.extend = function () {
      var a,
          b,
          d,
          e,
          f,
          g,
          h = arguments[0] || {},
          i = 1,
          j = arguments.length,
          k = !1;for ("boolean" == typeof h && (k = h, h = arguments[i] || {}, i++), "object" != (typeof h === "undefined" ? "undefined" : _typeof(h)) && "function" !== c.type(h) && (h = {}), i === j && (h = this, i--); i < j; i++) {
        if (f = arguments[i]) for (e in f) {
          f.hasOwnProperty(e) && (a = h[e], d = f[e], h !== d && (k && d && (c.isPlainObject(d) || (b = c.isArray(d))) ? (b ? (b = !1, g = a && c.isArray(a) ? a : []) : g = a && c.isPlainObject(a) ? a : {}, h[e] = c.extend(k, g, d)) : d !== undefined && (h[e] = d)));
        }
      }return h;
    }, c.queue = function (a, d, e) {
      if (a) {
        d = (d || "fx") + "queue";var f = c.data(a, d);return e ? (!f || c.isArray(e) ? f = c.data(a, d, function (a, c) {
          var d = c || [];return a && (b(Object(a)) ? function (a, b) {
            for (var c = +b.length, d = 0, e = a.length; d < c;) {
              a[e++] = b[d++];
            }if (c !== c) for (; b[d] !== undefined;) {
              a[e++] = b[d++];
            }a.length = e, a;
          }(d, "string" == typeof a ? [a] : a) : [].push.call(d, a)), d;
        }(e)) : f.push(e), f) : f || [];
      }
    }, c.dequeue = function (a, b) {
      c.each(a.nodeType ? [a] : a, function (a, d) {
        b = b || "fx";var e = c.queue(d, b),
            f = e.shift();"inprogress" === f && (f = e.shift()), f && ("fx" === b && e.unshift("inprogress"), f.call(d, function () {
          c.dequeue(d, b);
        }));
      });
    }, c.fn = c.prototype = { init: function init(a) {
        if (a.nodeType) return this[0] = a, this;throw new Error("Not a DOM node.");
      }, offset: function offset() {
        var b = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : { top: 0, left: 0 };return { top: b.top + (a.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0), left: b.left + (a.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0) };
      }, position: function position() {
        var a = this[0],
            b = function (a) {
          for (var b = a.offsetParent; b && "html" !== b.nodeName.toLowerCase() && b.style && "static" === b.style.position;) {
            b = b.offsetParent;
          }return b || document;
        }(a),
            d = this.offset(),
            e = /^(?:body|html)$/i.test(b.nodeName) ? { top: 0, left: 0 } : c(b).offset();return d.top -= parseFloat(a.style.marginTop) || 0, d.left -= parseFloat(a.style.marginLeft) || 0, b.style && (e.top += parseFloat(b.style.borderTopWidth) || 0, e.left += parseFloat(b.style.borderLeftWidth) || 0), { top: d.top - e.top, left: d.left - e.left };
      } };var d = {};c.expando = "velocity" + new Date().getTime(), c.uuid = 0;for (var e = {}, f = e.hasOwnProperty, g = e.toString, h = "Boolean Number String Function Array Date RegExp Object Error".split(" "), i = 0; i < h.length; i++) {
      e["[object " + h[i] + "]"] = h[i].toLowerCase();
    }c.fn.init.prototype = c.fn, a.Velocity = { Utilities: c };
  }
}(window), function (a) {
  "use strict";
  "object" == ( false ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = a() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : a();
}(function () {
  "use strict";
  return function (a, b, c, d) {
    function e(a) {
      for (var b = -1, c = a ? a.length : 0, d = []; ++b < c;) {
        var e = a[b];e && d.push(e);
      }return d;
    }function f(a) {
      return u.isWrapped(a) ? a = s.call(a) : u.isNode(a) && (a = [a]), a;
    }function g(a) {
      var b = o.data(a, "velocity");return null === b ? d : b;
    }function h(a, b) {
      var c = g(a);c && c.delayTimer && !c.delayPaused && (c.delayRemaining = c.delay - b + c.delayBegin, c.delayPaused = !0, clearTimeout(c.delayTimer.setTimeout));
    }function i(a, b) {
      var c = g(a);c && c.delayTimer && c.delayPaused && (c.delayPaused = !1, c.delayTimer.setTimeout = setTimeout(c.delayTimer.next, c.delayRemaining));
    }function j(a) {
      return function (b) {
        return Math.round(b * a) * (1 / a);
      };
    }function k(a, c, d, e) {
      function f(a, b) {
        return 1 - 3 * b + 3 * a;
      }function g(a, b) {
        return 3 * b - 6 * a;
      }function h(a) {
        return 3 * a;
      }function i(a, b, c) {
        return ((f(b, c) * a + g(b, c)) * a + h(b)) * a;
      }function j(a, b, c) {
        return 3 * f(b, c) * a * a + 2 * g(b, c) * a + h(b);
      }function k(b, c) {
        for (var e = 0; e < p; ++e) {
          var f = j(c, a, d);if (0 === f) return c;c -= (i(c, a, d) - b) / f;
        }return c;
      }function l() {
        for (var b = 0; b < t; ++b) {
          x[b] = i(b * u, a, d);
        }
      }function m(b, c, e) {
        var f,
            g,
            h = 0;do {
          g = c + (e - c) / 2, f = i(g, a, d) - b, f > 0 ? e = g : c = g;
        } while (Math.abs(f) > r && ++h < s);return g;
      }function n(b) {
        for (var c = 0, e = 1, f = t - 1; e !== f && x[e] <= b; ++e) {
          c += u;
        }--e;var g = (b - x[e]) / (x[e + 1] - x[e]),
            h = c + g * u,
            i = j(h, a, d);return i >= q ? k(b, h) : 0 === i ? h : m(b, c, c + u);
      }function o() {
        y = !0, a === c && d === e || l();
      }var p = 4,
          q = .001,
          r = 1e-7,
          s = 10,
          t = 11,
          u = 1 / (t - 1),
          v = "Float32Array" in b;if (4 !== arguments.length) return !1;for (var w = 0; w < 4; ++w) {
        if ("number" != typeof arguments[w] || isNaN(arguments[w]) || !isFinite(arguments[w])) return !1;
      }a = Math.min(a, 1), d = Math.min(d, 1), a = Math.max(a, 0), d = Math.max(d, 0);var x = v ? new Float32Array(t) : new Array(t),
          y = !1,
          z = function z(b) {
        return y || o(), a === c && d === e ? b : 0 === b ? 0 : 1 === b ? 1 : i(n(b), c, e);
      };z.getControlPoints = function () {
        return [{ x: a, y: c }, { x: d, y: e }];
      };var A = "generateBezier(" + [a, c, d, e] + ")";return z.toString = function () {
        return A;
      }, z;
    }function l(a, b) {
      var c = a;return u.isString(a) ? y.Easings[a] || (c = !1) : c = u.isArray(a) && 1 === a.length ? j.apply(null, a) : u.isArray(a) && 2 === a.length ? z.apply(null, a.concat([b])) : !(!u.isArray(a) || 4 !== a.length) && k.apply(null, a), c === !1 && (c = y.Easings[y.defaults.easing] ? y.defaults.easing : x), c;
    }function m(a) {
      if (a) {
        var b = y.timestamp && a !== !0 ? a : r.now(),
            c = y.State.calls.length;c > 1e4 && (y.State.calls = e(y.State.calls), c = y.State.calls.length);for (var f = 0; f < c; f++) {
          if (y.State.calls[f]) {
            var h = y.State.calls[f],
                i = h[0],
                j = h[2],
                k = h[3],
                l = !!k,
                q = null,
                s = h[5],
                t = h[6];if (k || (k = y.State.calls[f][3] = b - 16), s) {
              if (s.resume !== !0) continue;k = h[3] = Math.round(b - t - 16), h[5] = null;
            }t = h[6] = b - k;for (var v = Math.min(t / j.duration, 1), w = 0, x = i.length; w < x; w++) {
              var z = i[w],
                  B = z.element;if (g(B)) {
                var D = !1;if (j.display !== d && null !== j.display && "none" !== j.display) {
                  if ("flex" === j.display) {
                    var E = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];o.each(E, function (a, b) {
                      A.setPropertyValue(B, "display", b);
                    });
                  }A.setPropertyValue(B, "display", j.display);
                }j.visibility !== d && "hidden" !== j.visibility && A.setPropertyValue(B, "visibility", j.visibility);for (var F in z) {
                  if (z.hasOwnProperty(F) && "element" !== F) {
                    var G,
                        H = z[F],
                        I = u.isString(H.easing) ? y.Easings[H.easing] : H.easing;if (u.isString(H.pattern)) {
                      var J = 1 === v ? function (a, b, c) {
                        var d = H.endValue[b];return c ? Math.round(d) : d;
                      } : function (a, b, c) {
                        var d = H.startValue[b],
                            e = H.endValue[b] - d,
                            f = d + e * I(v, j, e);return c ? Math.round(f) : f;
                      };G = H.pattern.replace(/{(\d+)(!)?}/g, J);
                    } else if (1 === v) G = H.endValue;else {
                      var K = H.endValue - H.startValue;G = H.startValue + K * I(v, j, K);
                    }if (!l && G === H.currentValue) continue;if (H.currentValue = G, "tween" === F) q = G;else {
                      var L;if (A.Hooks.registered[F]) {
                        L = A.Hooks.getRoot(F);var M = g(B).rootPropertyValueCache[L];M && (H.rootPropertyValue = M);
                      }var N = A.setPropertyValue(B, F, H.currentValue + (p < 9 && 0 === parseFloat(G) ? "" : H.unitType), H.rootPropertyValue, H.scrollData);A.Hooks.registered[F] && (A.Normalizations.registered[L] ? g(B).rootPropertyValueCache[L] = A.Normalizations.registered[L]("extract", null, N[1]) : g(B).rootPropertyValueCache[L] = N[1]), "transform" === N[0] && (D = !0);
                    }
                  }
                }j.mobileHA && g(B).transformCache.translate3d === d && (g(B).transformCache.translate3d = "(0px, 0px, 0px)", D = !0), D && A.flushTransformCache(B);
              }
            }j.display !== d && "none" !== j.display && (y.State.calls[f][2].display = !1), j.visibility !== d && "hidden" !== j.visibility && (y.State.calls[f][2].visibility = !1), j.progress && j.progress.call(h[1], h[1], v, Math.max(0, k + j.duration - b), k, q), 1 === v && n(f);
          }
        }
      }y.State.isTicking && C(m);
    }function n(a, b) {
      if (!y.State.calls[a]) return !1;for (var c = y.State.calls[a][0], e = y.State.calls[a][1], f = y.State.calls[a][2], h = y.State.calls[a][4], i = !1, j = 0, k = c.length; j < k; j++) {
        var l = c[j].element;b || f.loop || ("none" === f.display && A.setPropertyValue(l, "display", f.display), "hidden" === f.visibility && A.setPropertyValue(l, "visibility", f.visibility));var m = g(l);if (f.loop !== !0 && (o.queue(l)[1] === d || !/\.velocityQueueEntryFlag/i.test(o.queue(l)[1])) && m) {
          m.isAnimating = !1, m.rootPropertyValueCache = {};var n = !1;o.each(A.Lists.transforms3D, function (a, b) {
            var c = /^scale/.test(b) ? 1 : 0,
                e = m.transformCache[b];m.transformCache[b] !== d && new RegExp("^\\(" + c + "[^.]").test(e) && (n = !0, delete m.transformCache[b]);
          }), f.mobileHA && (n = !0, delete m.transformCache.translate3d), n && A.flushTransformCache(l), A.Values.removeClass(l, "velocity-animating");
        }if (!b && f.complete && !f.loop && j === k - 1) try {
          f.complete.call(e, e);
        } catch (r) {
          setTimeout(function () {
            throw r;
          }, 1);
        }h && f.loop !== !0 && h(e), m && f.loop === !0 && !b && (o.each(m.tweensContainer, function (a, b) {
          if (/^rotate/.test(a) && (parseFloat(b.startValue) - parseFloat(b.endValue)) % 360 == 0) {
            var c = b.startValue;b.startValue = b.endValue, b.endValue = c;
          }/^backgroundPosition/.test(a) && 100 === parseFloat(b.endValue) && "%" === b.unitType && (b.endValue = 0, b.startValue = 100);
        }), y(l, "reverse", { loop: !0, delay: f.delay })), f.queue !== !1 && o.dequeue(l, f.queue);
      }y.State.calls[a] = !1;for (var p = 0, q = y.State.calls.length; p < q; p++) {
        if (y.State.calls[p] !== !1) {
          i = !0;break;
        }
      }i === !1 && (y.State.isTicking = !1, delete y.State.calls, y.State.calls = []);
    }var o,
        p = function () {
      if (c.documentMode) return c.documentMode;for (var a = 7; a > 4; a--) {
        var b = c.createElement("div");if (b.innerHTML = "<!--[if IE " + a + "]><span></span><![endif]-->", b.getElementsByTagName("span").length) return b = null, a;
      }return d;
    }(),
        q = function () {
      var a = 0;return b.webkitRequestAnimationFrame || b.mozRequestAnimationFrame || function (b) {
        var c,
            d = new Date().getTime();return c = Math.max(0, 16 - (d - a)), a = d + c, setTimeout(function () {
          b(d + c);
        }, c);
      };
    }(),
        r = function () {
      var a = b.performance || {};if ("function" != typeof a.now) {
        var c = a.timing && a.timing.navigationStart ? a.timing.navigationStart : new Date().getTime();a.now = function () {
          return new Date().getTime() - c;
        };
      }return a;
    }(),
        s = function () {
      var a = Array.prototype.slice;try {
        return a.call(c.documentElement), a;
      } catch (b) {
        return function (b, c) {
          var d = this.length;if ("number" != typeof b && (b = 0), "number" != typeof c && (c = d), this.slice) return a.call(this, b, c);var e,
              f = [],
              g = b >= 0 ? b : Math.max(0, d + b),
              h = c < 0 ? d + c : Math.min(c, d),
              i = h - g;if (i > 0) if (f = new Array(i), this.charAt) for (e = 0; e < i; e++) {
            f[e] = this.charAt(g + e);
          } else for (e = 0; e < i; e++) {
            f[e] = this[g + e];
          }return f;
        };
      }
    }(),
        t = function t() {
      return Array.prototype.includes ? function (a, b) {
        return a.includes(b);
      } : Array.prototype.indexOf ? function (a, b) {
        return a.indexOf(b) >= 0;
      } : function (a, b) {
        for (var c = 0; c < a.length; c++) {
          if (a[c] === b) return !0;
        }return !1;
      };
    },
        u = { isNumber: function isNumber(a) {
        return "number" == typeof a;
      }, isString: function isString(a) {
        return "string" == typeof a;
      }, isArray: Array.isArray || function (a) {
        return "[object Array]" === Object.prototype.toString.call(a);
      }, isFunction: function isFunction(a) {
        return "[object Function]" === Object.prototype.toString.call(a);
      }, isNode: function isNode(a) {
        return a && a.nodeType;
      }, isWrapped: function isWrapped(a) {
        return a && a !== b && u.isNumber(a.length) && !u.isString(a) && !u.isFunction(a) && !u.isNode(a) && (0 === a.length || u.isNode(a[0]));
      }, isSVG: function isSVG(a) {
        return b.SVGElement && a instanceof b.SVGElement;
      }, isEmptyObject: function isEmptyObject(a) {
        for (var b in a) {
          if (a.hasOwnProperty(b)) return !1;
        }return !0;
      } },
        v = !1;if (a.fn && a.fn.jquery ? (o = a, v = !0) : o = b.Velocity.Utilities, p <= 8 && !v) throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");if (p <= 7) return void (jQuery.fn.velocity = jQuery.fn.animate);var w = 400,
        x = "swing",
        y = { State: { isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), isAndroid: /Android/i.test(navigator.userAgent), isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent), isChrome: b.chrome, isFirefox: /Firefox/i.test(navigator.userAgent), prefixElement: c.createElement("div"), prefixMatches: {}, scrollAnchor: null, scrollPropertyLeft: null, scrollPropertyTop: null, isTicking: !1, calls: [], delayedElements: { count: 0 } }, CSS: {}, Utilities: o, Redirects: {}, Easings: {}, Promise: b.Promise, defaults: { queue: "", duration: w, easing: x, begin: d, complete: d, progress: d, display: d, visibility: d, loop: !1, delay: !1, mobileHA: !0, _cacheValues: !0, promiseRejectEmpty: !0 }, init: function init(a) {
        o.data(a, "velocity", { isSVG: u.isSVG(a), isAnimating: !1, computedStyle: null, tweensContainer: null, rootPropertyValueCache: {}, transformCache: {} });
      }, hook: null, mock: !1, version: { major: 1, minor: 5, patch: 0 }, debug: !1, timestamp: !0, pauseAll: function pauseAll(a) {
        var b = new Date().getTime();o.each(y.State.calls, function (b, c) {
          if (c) {
            if (a !== d && (c[2].queue !== a || c[2].queue === !1)) return !0;c[5] = { resume: !1 };
          }
        }), o.each(y.State.delayedElements, function (a, c) {
          c && h(c, b);
        });
      }, resumeAll: function resumeAll(a) {
        var b = new Date().getTime();o.each(y.State.calls, function (b, c) {
          if (c) {
            if (a !== d && (c[2].queue !== a || c[2].queue === !1)) return !0;c[5] && (c[5].resume = !0);
          }
        }), o.each(y.State.delayedElements, function (a, c) {
          c && i(c, b);
        });
      } };b.pageYOffset !== d ? (y.State.scrollAnchor = b, y.State.scrollPropertyLeft = "pageXOffset", y.State.scrollPropertyTop = "pageYOffset") : (y.State.scrollAnchor = c.documentElement || c.body.parentNode || c.body, y.State.scrollPropertyLeft = "scrollLeft", y.State.scrollPropertyTop = "scrollTop");var z = function () {
      function a(a) {
        return -a.tension * a.x - a.friction * a.v;
      }function b(b, c, d) {
        var e = { x: b.x + d.dx * c, v: b.v + d.dv * c, tension: b.tension, friction: b.friction };return { dx: e.v, dv: a(e) };
      }function c(c, d) {
        var e = { dx: c.v, dv: a(c) },
            f = b(c, .5 * d, e),
            g = b(c, .5 * d, f),
            h = b(c, d, g),
            i = 1 / 6 * (e.dx + 2 * (f.dx + g.dx) + h.dx),
            j = 1 / 6 * (e.dv + 2 * (f.dv + g.dv) + h.dv);return c.x = c.x + i * d, c.v = c.v + j * d, c;
      }return function d(a, b, e) {
        var f,
            g,
            h,
            i = { x: -1, v: 0, tension: null, friction: null },
            j = [0],
            k = 0;for (a = parseFloat(a) || 500, b = parseFloat(b) || 20, e = e || null, i.tension = a, i.friction = b, f = null !== e, f ? (k = d(a, b), g = k / e * .016) : g = .016;;) {
          if (h = c(h || i, g), j.push(1 + h.x), k += 16, !(Math.abs(h.x) > 1e-4 && Math.abs(h.v) > 1e-4)) break;
        }return f ? function (a) {
          return j[a * (j.length - 1) | 0];
        } : k;
      };
    }();y.Easings = { linear: function linear(a) {
        return a;
      }, swing: function swing(a) {
        return .5 - Math.cos(a * Math.PI) / 2;
      }, spring: function spring(a) {
        return 1 - Math.cos(4.5 * a * Math.PI) * Math.exp(6 * -a);
      } }, o.each([["ease", [.25, .1, .25, 1]], ["ease-in", [.42, 0, 1, 1]], ["ease-out", [0, 0, .58, 1]], ["ease-in-out", [.42, 0, .58, 1]], ["easeInSine", [.47, 0, .745, .715]], ["easeOutSine", [.39, .575, .565, 1]], ["easeInOutSine", [.445, .05, .55, .95]], ["easeInQuad", [.55, .085, .68, .53]], ["easeOutQuad", [.25, .46, .45, .94]], ["easeInOutQuad", [.455, .03, .515, .955]], ["easeInCubic", [.55, .055, .675, .19]], ["easeOutCubic", [.215, .61, .355, 1]], ["easeInOutCubic", [.645, .045, .355, 1]], ["easeInQuart", [.895, .03, .685, .22]], ["easeOutQuart", [.165, .84, .44, 1]], ["easeInOutQuart", [.77, 0, .175, 1]], ["easeInQuint", [.755, .05, .855, .06]], ["easeOutQuint", [.23, 1, .32, 1]], ["easeInOutQuint", [.86, 0, .07, 1]], ["easeInExpo", [.95, .05, .795, .035]], ["easeOutExpo", [.19, 1, .22, 1]], ["easeInOutExpo", [1, 0, 0, 1]], ["easeInCirc", [.6, .04, .98, .335]], ["easeOutCirc", [.075, .82, .165, 1]], ["easeInOutCirc", [.785, .135, .15, .86]]], function (a, b) {
      y.Easings[b[0]] = k.apply(null, b[1]);
    });var A = y.CSS = { RegEx: { isHex: /^#([A-f\d]{3}){1,2}$/i, valueUnwrap: /^[A-z]+\((.*)\)$/i, wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/, valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi }, Lists: { colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"], transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"], transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"], units: ["%", "em", "ex", "ch", "rem", "vw", "vh", "vmin", "vmax", "cm", "mm", "Q", "in", "pc", "pt", "px", "deg", "grad", "rad", "turn", "s", "ms"], colorNames: { aliceblue: "240,248,255", antiquewhite: "250,235,215", aquamarine: "127,255,212", aqua: "0,255,255", azure: "240,255,255", beige: "245,245,220", bisque: "255,228,196", black: "0,0,0", blanchedalmond: "255,235,205", blueviolet: "138,43,226", blue: "0,0,255", brown: "165,42,42", burlywood: "222,184,135", cadetblue: "95,158,160", chartreuse: "127,255,0", chocolate: "210,105,30", coral: "255,127,80", cornflowerblue: "100,149,237", cornsilk: "255,248,220", crimson: "220,20,60", cyan: "0,255,255", darkblue: "0,0,139", darkcyan: "0,139,139", darkgoldenrod: "184,134,11", darkgray: "169,169,169", darkgrey: "169,169,169", darkgreen: "0,100,0", darkkhaki: "189,183,107", darkmagenta: "139,0,139", darkolivegreen: "85,107,47", darkorange: "255,140,0", darkorchid: "153,50,204", darkred: "139,0,0", darksalmon: "233,150,122", darkseagreen: "143,188,143", darkslateblue: "72,61,139", darkslategray: "47,79,79", darkturquoise: "0,206,209", darkviolet: "148,0,211", deeppink: "255,20,147", deepskyblue: "0,191,255", dimgray: "105,105,105", dimgrey: "105,105,105", dodgerblue: "30,144,255", firebrick: "178,34,34", floralwhite: "255,250,240", forestgreen: "34,139,34", fuchsia: "255,0,255", gainsboro: "220,220,220", ghostwhite: "248,248,255", gold: "255,215,0", goldenrod: "218,165,32", gray: "128,128,128", grey: "128,128,128", greenyellow: "173,255,47", green: "0,128,0", honeydew: "240,255,240", hotpink: "255,105,180", indianred: "205,92,92", indigo: "75,0,130", ivory: "255,255,240", khaki: "240,230,140", lavenderblush: "255,240,245", lavender: "230,230,250", lawngreen: "124,252,0", lemonchiffon: "255,250,205", lightblue: "173,216,230", lightcoral: "240,128,128", lightcyan: "224,255,255", lightgoldenrodyellow: "250,250,210", lightgray: "211,211,211", lightgrey: "211,211,211", lightgreen: "144,238,144", lightpink: "255,182,193", lightsalmon: "255,160,122", lightseagreen: "32,178,170", lightskyblue: "135,206,250", lightslategray: "119,136,153", lightsteelblue: "176,196,222", lightyellow: "255,255,224", limegreen: "50,205,50", lime: "0,255,0", linen: "250,240,230", magenta: "255,0,255", maroon: "128,0,0", mediumaquamarine: "102,205,170", mediumblue: "0,0,205", mediumorchid: "186,85,211", mediumpurple: "147,112,219", mediumseagreen: "60,179,113", mediumslateblue: "123,104,238", mediumspringgreen: "0,250,154", mediumturquoise: "72,209,204", mediumvioletred: "199,21,133", midnightblue: "25,25,112", mintcream: "245,255,250", mistyrose: "255,228,225", moccasin: "255,228,181", navajowhite: "255,222,173", navy: "0,0,128", oldlace: "253,245,230", olivedrab: "107,142,35", olive: "128,128,0", orangered: "255,69,0", orange: "255,165,0", orchid: "218,112,214", palegoldenrod: "238,232,170", palegreen: "152,251,152", paleturquoise: "175,238,238", palevioletred: "219,112,147", papayawhip: "255,239,213", peachpuff: "255,218,185", peru: "205,133,63", pink: "255,192,203", plum: "221,160,221", powderblue: "176,224,230", purple: "128,0,128", red: "255,0,0", rosybrown: "188,143,143", royalblue: "65,105,225", saddlebrown: "139,69,19", salmon: "250,128,114", sandybrown: "244,164,96", seagreen: "46,139,87", seashell: "255,245,238", sienna: "160,82,45", silver: "192,192,192", skyblue: "135,206,235", slateblue: "106,90,205", slategray: "112,128,144", snow: "255,250,250", springgreen: "0,255,127", steelblue: "70,130,180", tan: "210,180,140", teal: "0,128,128", thistle: "216,191,216", tomato: "255,99,71", turquoise: "64,224,208", violet: "238,130,238", wheat: "245,222,179", whitesmoke: "245,245,245", white: "255,255,255", yellowgreen: "154,205,50", yellow: "255,255,0" } }, Hooks: { templates: { textShadow: ["Color X Y Blur", "black 0px 0px 0px"], boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"], clip: ["Top Right Bottom Left", "0px 0px 0px 0px"], backgroundPosition: ["X Y", "0% 0%"], transformOrigin: ["X Y Z", "50% 50% 0px"], perspectiveOrigin: ["X Y", "50% 50%"] }, registered: {}, register: function register() {
          for (var a = 0; a < A.Lists.colors.length; a++) {
            var b = "color" === A.Lists.colors[a] ? "0 0 0 1" : "255 255 255 1";A.Hooks.templates[A.Lists.colors[a]] = ["Red Green Blue Alpha", b];
          }var c, d, e;if (p) for (c in A.Hooks.templates) {
            if (A.Hooks.templates.hasOwnProperty(c)) {
              d = A.Hooks.templates[c], e = d[0].split(" ");var f = d[1].match(A.RegEx.valueSplit);"Color" === e[0] && (e.push(e.shift()), f.push(f.shift()), A.Hooks.templates[c] = [e.join(" "), f.join(" ")]);
            }
          }for (c in A.Hooks.templates) {
            if (A.Hooks.templates.hasOwnProperty(c)) {
              d = A.Hooks.templates[c], e = d[0].split(" ");for (var g in e) {
                if (e.hasOwnProperty(g)) {
                  var h = c + e[g],
                      i = g;A.Hooks.registered[h] = [c, i];
                }
              }
            }
          }
        }, getRoot: function getRoot(a) {
          var b = A.Hooks.registered[a];return b ? b[0] : a;
        }, getUnit: function getUnit(a, b) {
          var c = (a.substr(b || 0, 5).match(/^[a-z%]+/) || [])[0] || "";return c && t(A.Lists.units, c) ? c : "";
        }, fixColors: function fixColors(a) {
          return a.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function (a, b, c) {
            return A.Lists.colorNames.hasOwnProperty(c) ? (b ? b : "rgba(") + A.Lists.colorNames[c] + (b ? "" : ",1)") : b + c;
          });
        }, cleanRootPropertyValue: function cleanRootPropertyValue(a, b) {
          return A.RegEx.valueUnwrap.test(b) && (b = b.match(A.RegEx.valueUnwrap)[1]), A.Values.isCSSNullValue(b) && (b = A.Hooks.templates[a][1]), b;
        }, extractValue: function extractValue(a, b) {
          var c = A.Hooks.registered[a];if (c) {
            var d = c[0],
                e = c[1];return b = A.Hooks.cleanRootPropertyValue(d, b), b.toString().match(A.RegEx.valueSplit)[e];
          }return b;
        }, injectValue: function injectValue(a, b, c) {
          var d = A.Hooks.registered[a];if (d) {
            var e,
                f = d[0],
                g = d[1];return c = A.Hooks.cleanRootPropertyValue(f, c), e = c.toString().match(A.RegEx.valueSplit), e[g] = b, e.join(" ");
          }return c;
        } }, Normalizations: { registered: { clip: function clip(a, b, c) {
            switch (a) {case "name":
                return "clip";case "extract":
                var d;return A.RegEx.wrappedValueAlreadyExtracted.test(c) ? d = c : (d = c.toString().match(A.RegEx.valueUnwrap), d = d ? d[1].replace(/,(\s+)?/g, " ") : c), d;case "inject":
                return "rect(" + c + ")";}
          }, blur: function blur(a, b, c) {
            switch (a) {case "name":
                return y.State.isFirefox ? "filter" : "-webkit-filter";case "extract":
                var d = parseFloat(c);if (!d && 0 !== d) {
                  var e = c.toString().match(/blur\(([0-9]+[A-z]+)\)/i);d = e ? e[1] : 0;
                }return d;case "inject":
                return parseFloat(c) ? "blur(" + c + ")" : "none";}
          }, opacity: function opacity(a, b, c) {
            if (p <= 8) switch (a) {case "name":
                return "filter";case "extract":
                var d = c.toString().match(/alpha\(opacity=(.*)\)/i);return c = d ? d[1] / 100 : 1;case "inject":
                return b.style.zoom = 1, parseFloat(c) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(c), 10) + ")";} else switch (a) {case "name":
                return "opacity";case "extract":
                return c;case "inject":
                return c;}
          } }, register: function register() {
          function a(a, b, c) {
            if ("border-box" === A.getPropertyValue(b, "boxSizing").toString().toLowerCase() === (c || !1)) {
              var d,
                  e,
                  f = 0,
                  g = "width" === a ? ["Left", "Right"] : ["Top", "Bottom"],
                  h = ["padding" + g[0], "padding" + g[1], "border" + g[0] + "Width", "border" + g[1] + "Width"];for (d = 0; d < h.length; d++) {
                e = parseFloat(A.getPropertyValue(b, h[d])), isNaN(e) || (f += e);
              }return c ? -f : f;
            }return 0;
          }function b(b, c) {
            return function (d, e, f) {
              switch (d) {case "name":
                  return b;case "extract":
                  return parseFloat(f) + a(b, e, c);case "inject":
                  return parseFloat(f) - a(b, e, c) + "px";}
            };
          }p && !(p > 9) || y.State.isGingerbread || (A.Lists.transformsBase = A.Lists.transformsBase.concat(A.Lists.transforms3D));for (var c = 0; c < A.Lists.transformsBase.length; c++) {
            !function () {
              var a = A.Lists.transformsBase[c];A.Normalizations.registered[a] = function (b, c, e) {
                switch (b) {case "name":
                    return "transform";case "extract":
                    return g(c) === d || g(c).transformCache[a] === d ? /^scale/i.test(a) ? 1 : 0 : g(c).transformCache[a].replace(/[()]/g, "");case "inject":
                    var f = !1;switch (a.substr(0, a.length - 1)) {case "translate":
                        f = !/(%|px|em|rem|vw|vh|\d)$/i.test(e);break;case "scal":case "scale":
                        y.State.isAndroid && g(c).transformCache[a] === d && e < 1 && (e = 1), f = !/(\d)$/i.test(e);break;case "skew":
                        f = !/(deg|\d)$/i.test(e);break;case "rotate":
                        f = !/(deg|\d)$/i.test(e);}return f || (g(c).transformCache[a] = "(" + e + ")"), g(c).transformCache[a];}
              };
            }();
          }for (var e = 0; e < A.Lists.colors.length; e++) {
            !function () {
              var a = A.Lists.colors[e];A.Normalizations.registered[a] = function (b, c, e) {
                switch (b) {case "name":
                    return a;case "extract":
                    var f;if (A.RegEx.wrappedValueAlreadyExtracted.test(e)) f = e;else {
                      var g,
                          h = { black: "rgb(0, 0, 0)", blue: "rgb(0, 0, 255)", gray: "rgb(128, 128, 128)", green: "rgb(0, 128, 0)", red: "rgb(255, 0, 0)", white: "rgb(255, 255, 255)" };/^[A-z]+$/i.test(e) ? g = h[e] !== d ? h[e] : h.black : A.RegEx.isHex.test(e) ? g = "rgb(" + A.Values.hexToRgb(e).join(" ") + ")" : /^rgba?\(/i.test(e) || (g = h.black), f = (g || e).toString().match(A.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
                    }return (!p || p > 8) && 3 === f.split(" ").length && (f += " 1"), f;case "inject":
                    return (/^rgb/.test(e) ? e : (p <= 8 ? 4 === e.split(" ").length && (e = e.split(/\s+/).slice(0, 3).join(" ")) : 3 === e.split(" ").length && (e += " 1"), (p <= 8 ? "rgb" : "rgba") + "(" + e.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")")
                    );}
              };
            }();
          }A.Normalizations.registered.innerWidth = b("width", !0), A.Normalizations.registered.innerHeight = b("height", !0), A.Normalizations.registered.outerWidth = b("width"), A.Normalizations.registered.outerHeight = b("height");
        } }, Names: { camelCase: function camelCase(a) {
          return a.replace(/-(\w)/g, function (a, b) {
            return b.toUpperCase();
          });
        }, SVGAttribute: function SVGAttribute(a) {
          var b = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";return (p || y.State.isAndroid && !y.State.isChrome) && (b += "|transform"), new RegExp("^(" + b + ")$", "i").test(a);
        }, prefixCheck: function prefixCheck(a) {
          if (y.State.prefixMatches[a]) return [y.State.prefixMatches[a], !0];for (var b = ["", "Webkit", "Moz", "ms", "O"], c = 0, d = b.length; c < d; c++) {
            var e;if (e = 0 === c ? a : b[c] + a.replace(/^\w/, function (a) {
              return a.toUpperCase();
            }), u.isString(y.State.prefixElement.style[e])) return y.State.prefixMatches[a] = e, [e, !0];
          }return [a, !1];
        } }, Values: { hexToRgb: function hexToRgb(a) {
          var b,
              c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;return a = a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (a, b, c, d) {
            return b + b + c + c + d + d;
          }), b = c.exec(a), b ? [parseInt(b[1], 16), parseInt(b[2], 16), parseInt(b[3], 16)] : [0, 0, 0];
        }, isCSSNullValue: function isCSSNullValue(a) {
          return !a || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(a);
        }, getUnitType: function getUnitType(a) {
          return (/^(rotate|skew)/i.test(a) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(a) ? "" : "px"
          );
        }, getDisplayType: function getDisplayType(a) {
          var b = a && a.tagName.toString().toLowerCase();return (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(b) ? "inline" : /^(li)$/i.test(b) ? "list-item" : /^(tr)$/i.test(b) ? "table-row" : /^(table)$/i.test(b) ? "table" : /^(tbody)$/i.test(b) ? "table-row-group" : "block"
          );
        }, addClass: function addClass(a, b) {
          if (a) if (a.classList) a.classList.add(b);else if (u.isString(a.className)) a.className += (a.className.length ? " " : "") + b;else {
            var c = a.getAttribute(p <= 7 ? "className" : "class") || "";a.setAttribute("class", c + (c ? " " : "") + b);
          }
        }, removeClass: function removeClass(a, b) {
          if (a) if (a.classList) a.classList.remove(b);else if (u.isString(a.className)) a.className = a.className.toString().replace(new RegExp("(^|\\s)" + b.split(" ").join("|") + "(\\s|$)", "gi"), " ");else {
            var c = a.getAttribute(p <= 7 ? "className" : "class") || "";a.setAttribute("class", c.replace(new RegExp("(^|s)" + b.split(" ").join("|") + "(s|$)", "gi"), " "));
          }
        } }, getPropertyValue: function getPropertyValue(a, c, e, f) {
        function h(a, c) {
          var e = 0;if (p <= 8) e = o.css(a, c);else {
            var i = !1;/^(width|height)$/.test(c) && 0 === A.getPropertyValue(a, "display") && (i = !0, A.setPropertyValue(a, "display", A.Values.getDisplayType(a)));var j = function j() {
              i && A.setPropertyValue(a, "display", "none");
            };if (!f) {
              if ("height" === c && "border-box" !== A.getPropertyValue(a, "boxSizing").toString().toLowerCase()) {
                var k = a.offsetHeight - (parseFloat(A.getPropertyValue(a, "borderTopWidth")) || 0) - (parseFloat(A.getPropertyValue(a, "borderBottomWidth")) || 0) - (parseFloat(A.getPropertyValue(a, "paddingTop")) || 0) - (parseFloat(A.getPropertyValue(a, "paddingBottom")) || 0);return j(), k;
              }if ("width" === c && "border-box" !== A.getPropertyValue(a, "boxSizing").toString().toLowerCase()) {
                var l = a.offsetWidth - (parseFloat(A.getPropertyValue(a, "borderLeftWidth")) || 0) - (parseFloat(A.getPropertyValue(a, "borderRightWidth")) || 0) - (parseFloat(A.getPropertyValue(a, "paddingLeft")) || 0) - (parseFloat(A.getPropertyValue(a, "paddingRight")) || 0);return j(), l;
              }
            }var m;m = g(a) === d ? b.getComputedStyle(a, null) : g(a).computedStyle ? g(a).computedStyle : g(a).computedStyle = b.getComputedStyle(a, null), "borderColor" === c && (c = "borderTopColor"), e = 9 === p && "filter" === c ? m.getPropertyValue(c) : m[c], "" !== e && null !== e || (e = a.style[c]), j();
          }if ("auto" === e && /^(top|right|bottom|left)$/i.test(c)) {
            var n = h(a, "position");("fixed" === n || "absolute" === n && /top|left/i.test(c)) && (e = o(a).position()[c] + "px");
          }return e;
        }var i;if (A.Hooks.registered[c]) {
          var j = c,
              k = A.Hooks.getRoot(j);e === d && (e = A.getPropertyValue(a, A.Names.prefixCheck(k)[0])), A.Normalizations.registered[k] && (e = A.Normalizations.registered[k]("extract", a, e)), i = A.Hooks.extractValue(j, e);
        } else if (A.Normalizations.registered[c]) {
          var l, m;l = A.Normalizations.registered[c]("name", a), "transform" !== l && (m = h(a, A.Names.prefixCheck(l)[0]), A.Values.isCSSNullValue(m) && A.Hooks.templates[c] && (m = A.Hooks.templates[c][1])), i = A.Normalizations.registered[c]("extract", a, m);
        }if (!/^[\d-]/.test(i)) {
          var n = g(a);if (n && n.isSVG && A.Names.SVGAttribute(c)) {
            if (/^(height|width)$/i.test(c)) try {
              i = a.getBBox()[c];
            } catch (q) {
              i = 0;
            } else i = a.getAttribute(c);
          } else i = h(a, A.Names.prefixCheck(c)[0]);
        }return A.Values.isCSSNullValue(i) && (i = 0), y.debug >= 2 && console.log("Get " + c + ": " + i), i;
      }, setPropertyValue: function setPropertyValue(a, c, d, e, f) {
        var h = c;if ("scroll" === c) f.container ? f.container["scroll" + f.direction] = d : "Left" === f.direction ? b.scrollTo(d, f.alternateValue) : b.scrollTo(f.alternateValue, d);else if (A.Normalizations.registered[c] && "transform" === A.Normalizations.registered[c]("name", a)) A.Normalizations.registered[c]("inject", a, d), h = "transform", d = g(a).transformCache[c];else {
          if (A.Hooks.registered[c]) {
            var i = c,
                j = A.Hooks.getRoot(c);e = e || A.getPropertyValue(a, j), d = A.Hooks.injectValue(i, d, e), c = j;
          }if (A.Normalizations.registered[c] && (d = A.Normalizations.registered[c]("inject", a, d), c = A.Normalizations.registered[c]("name", a)), h = A.Names.prefixCheck(c)[0], p <= 8) try {
            a.style[h] = d;
          } catch (l) {
            y.debug && console.log("Browser does not support [" + d + "] for [" + h + "]");
          } else {
            var k = g(a);k && k.isSVG && A.Names.SVGAttribute(c) ? a.setAttribute(c, d) : a.style[h] = d;
          }y.debug >= 2 && console.log("Set " + c + " (" + h + "): " + d);
        }return [h, d];
      }, flushTransformCache: function flushTransformCache(a) {
        var b = "",
            c = g(a);if ((p || y.State.isAndroid && !y.State.isChrome) && c && c.isSVG) {
          var d = function d(b) {
            return parseFloat(A.getPropertyValue(a, b));
          },
              e = { translate: [d("translateX"), d("translateY")], skewX: [d("skewX")], skewY: [d("skewY")], scale: 1 !== d("scale") ? [d("scale"), d("scale")] : [d("scaleX"), d("scaleY")], rotate: [d("rotateZ"), 0, 0] };o.each(g(a).transformCache, function (a) {
            /^translate/i.test(a) ? a = "translate" : /^scale/i.test(a) ? a = "scale" : /^rotate/i.test(a) && (a = "rotate"), e[a] && (b += a + "(" + e[a].join(" ") + ") ", delete e[a]);
          });
        } else {
          var f, h;o.each(g(a).transformCache, function (c) {
            if (f = g(a).transformCache[c], "transformPerspective" === c) return h = f, !0;9 === p && "rotateZ" === c && (c = "rotate"), b += c + f + " ";
          }), h && (b = "perspective" + h + " " + b);
        }A.setPropertyValue(a, "transform", b);
      } };A.Hooks.register(), A.Normalizations.register(), y.hook = function (a, b, c) {
      var e;return a = f(a), o.each(a, function (a, f) {
        if (g(f) === d && y.init(f), c === d) e === d && (e = A.getPropertyValue(f, b));else {
          var h = A.setPropertyValue(f, b, c);"transform" === h[0] && y.CSS.flushTransformCache(f), e = h;
        }
      }), e;
    };var B = function B() {
      function a() {
        return k ? z.promise || null : p;
      }function e(a, e) {
        function f(f) {
          var k, n;if (i.begin && 0 === D) try {
            i.begin.call(r, r);
          } catch (V) {
            setTimeout(function () {
              throw V;
            }, 1);
          }if ("scroll" === G) {
            var p,
                q,
                w,
                x = /^x$/i.test(i.axis) ? "Left" : "Top",
                B = parseFloat(i.offset) || 0;i.container ? u.isWrapped(i.container) || u.isNode(i.container) ? (i.container = i.container[0] || i.container, p = i.container["scroll" + x], w = p + o(a).position()[x.toLowerCase()] + B) : i.container = null : (p = y.State.scrollAnchor[y.State["scrollProperty" + x]], q = y.State.scrollAnchor[y.State["scrollProperty" + ("Left" === x ? "Top" : "Left")]], w = o(a).offset()[x.toLowerCase()] + B), j = { scroll: { rootPropertyValue: !1, startValue: p, currentValue: p, endValue: w, unitType: "", easing: i.easing, scrollData: { container: i.container, direction: x, alternateValue: q } }, element: a }, y.debug && console.log("tweensContainer (scroll): ", j.scroll, a);
          } else if ("reverse" === G) {
            if (!(k = g(a))) return;if (!k.tweensContainer) return void o.dequeue(a, i.queue);"none" === k.opts.display && (k.opts.display = "auto"), "hidden" === k.opts.visibility && (k.opts.visibility = "visible"), k.opts.loop = !1, k.opts.begin = null, k.opts.complete = null, v.easing || delete i.easing, v.duration || delete i.duration, i = o.extend({}, k.opts, i), n = o.extend(!0, {}, k ? k.tweensContainer : null);for (var E in n) {
              if (n.hasOwnProperty(E) && "element" !== E) {
                var F = n[E].startValue;n[E].startValue = n[E].currentValue = n[E].endValue, n[E].endValue = F, u.isEmptyObject(v) || (n[E].easing = i.easing), y.debug && console.log("reverse tweensContainer (" + E + "): " + JSON.stringify(n[E]), a);
              }
            }j = n;
          } else if ("start" === G) {
            k = g(a), k && k.tweensContainer && k.isAnimating === !0 && (n = k.tweensContainer);var H = function H(e, f) {
              var g,
                  l = A.Hooks.getRoot(e),
                  m = !1,
                  p = f[0],
                  q = f[1],
                  r = f[2];if (!(k && k.isSVG || "tween" === l || A.Names.prefixCheck(l)[1] !== !1 || A.Normalizations.registered[l] !== d)) return void (y.debug && console.log("Skipping [" + l + "] due to a lack of browser support."));(i.display !== d && null !== i.display && "none" !== i.display || i.visibility !== d && "hidden" !== i.visibility) && /opacity|filter/.test(e) && !r && 0 !== p && (r = 0), i._cacheValues && n && n[e] ? (r === d && (r = n[e].endValue + n[e].unitType), m = k.rootPropertyValueCache[l]) : A.Hooks.registered[e] ? r === d ? (m = A.getPropertyValue(a, l), r = A.getPropertyValue(a, e, m)) : m = A.Hooks.templates[l][1] : r === d && (r = A.getPropertyValue(a, e));var s,
                  t,
                  v,
                  w = !1,
                  x = function x(a, b) {
                var c, d;return d = (b || "0").toString().toLowerCase().replace(/[%A-z]+$/, function (a) {
                  return c = a, "";
                }), c || (c = A.Values.getUnitType(a)), [d, c];
              };if (r !== p && u.isString(r) && u.isString(p)) {
                g = "";var z = 0,
                    B = 0,
                    C = [],
                    D = [],
                    E = 0,
                    F = 0,
                    G = 0;for (r = A.Hooks.fixColors(r), p = A.Hooks.fixColors(p); z < r.length && B < p.length;) {
                  var H = r[z],
                      I = p[B];if (/[\d\.-]/.test(H) && /[\d\.-]/.test(I)) {
                    for (var J = H, K = I, L = ".", N = "."; ++z < r.length;) {
                      if ((H = r[z]) === L) L = "..";else if (!/\d/.test(H)) break;J += H;
                    }for (; ++B < p.length;) {
                      if ((I = p[B]) === N) N = "..";else if (!/\d/.test(I)) break;K += I;
                    }var O = A.Hooks.getUnit(r, z),
                        P = A.Hooks.getUnit(p, B);if (z += O.length, B += P.length, O === P) J === K ? g += J + O : (g += "{" + C.length + (F ? "!" : "") + "}" + O, C.push(parseFloat(J)), D.push(parseFloat(K)));else {
                      var Q = parseFloat(J),
                          R = parseFloat(K);g += (E < 5 ? "calc" : "") + "(" + (Q ? "{" + C.length + (F ? "!" : "") + "}" : "0") + O + " + " + (R ? "{" + (C.length + (Q ? 1 : 0)) + (F ? "!" : "") + "}" : "0") + P + ")", Q && (C.push(Q), D.push(0)), R && (C.push(0), D.push(R));
                    }
                  } else {
                    if (H !== I) {
                      E = 0;break;
                    }g += H, z++, B++, 0 === E && "c" === H || 1 === E && "a" === H || 2 === E && "l" === H || 3 === E && "c" === H || E >= 4 && "(" === H ? E++ : (E && E < 5 || E >= 4 && ")" === H && --E < 5) && (E = 0), 0 === F && "r" === H || 1 === F && "g" === H || 2 === F && "b" === H || 3 === F && "a" === H || F >= 3 && "(" === H ? (3 === F && "a" === H && (G = 1), F++) : G && "," === H ? ++G > 3 && (F = G = 0) : (G && F < (G ? 5 : 4) || F >= (G ? 4 : 3) && ")" === H && --F < (G ? 5 : 4)) && (F = G = 0);
                  }
                }z === r.length && B === p.length || (y.debug && console.error('Trying to pattern match mis-matched strings ["' + p + '", "' + r + '"]'), g = d), g && (C.length ? (y.debug && console.log('Pattern found "' + g + '" -> ', C, D, "[" + r + "," + p + "]"), r = C, p = D, t = v = "") : g = d);
              }g || (s = x(e, r), r = s[0], v = s[1], s = x(e, p), p = s[0].replace(/^([+-\/*])=/, function (a, b) {
                return w = b, "";
              }), t = s[1], r = parseFloat(r) || 0, p = parseFloat(p) || 0, "%" === t && (/^(fontSize|lineHeight)$/.test(e) ? (p /= 100, t = "em") : /^scale/.test(e) ? (p /= 100, t = "") : /(Red|Green|Blue)$/i.test(e) && (p = p / 100 * 255, t = "")));if (/[\/*]/.test(w)) t = v;else if (v !== t && 0 !== r) if (0 === p) t = v;else {
                h = h || function () {
                  var d = { myParent: a.parentNode || c.body, position: A.getPropertyValue(a, "position"), fontSize: A.getPropertyValue(a, "fontSize") },
                      e = d.position === M.lastPosition && d.myParent === M.lastParent,
                      f = d.fontSize === M.lastFontSize;M.lastParent = d.myParent, M.lastPosition = d.position, M.lastFontSize = d.fontSize;var g = {};if (f && e) g.emToPx = M.lastEmToPx, g.percentToPxWidth = M.lastPercentToPxWidth, g.percentToPxHeight = M.lastPercentToPxHeight;else {
                    var h = k && k.isSVG ? c.createElementNS("http://www.w3.org/2000/svg", "rect") : c.createElement("div");y.init(h), d.myParent.appendChild(h), o.each(["overflow", "overflowX", "overflowY"], function (a, b) {
                      y.CSS.setPropertyValue(h, b, "hidden");
                    }), y.CSS.setPropertyValue(h, "position", d.position), y.CSS.setPropertyValue(h, "fontSize", d.fontSize), y.CSS.setPropertyValue(h, "boxSizing", "content-box"), o.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function (a, b) {
                      y.CSS.setPropertyValue(h, b, "100%");
                    }), y.CSS.setPropertyValue(h, "paddingLeft", "100em"), g.percentToPxWidth = M.lastPercentToPxWidth = (parseFloat(A.getPropertyValue(h, "width", null, !0)) || 1) / 100, g.percentToPxHeight = M.lastPercentToPxHeight = (parseFloat(A.getPropertyValue(h, "height", null, !0)) || 1) / 100, g.emToPx = M.lastEmToPx = (parseFloat(A.getPropertyValue(h, "paddingLeft")) || 1) / 100, d.myParent.removeChild(h);
                  }return null === M.remToPx && (M.remToPx = parseFloat(A.getPropertyValue(c.body, "fontSize")) || 16), null === M.vwToPx && (M.vwToPx = parseFloat(b.innerWidth) / 100, M.vhToPx = parseFloat(b.innerHeight) / 100), g.remToPx = M.remToPx, g.vwToPx = M.vwToPx, g.vhToPx = M.vhToPx, y.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(g), a), g;
                }();var S = /margin|padding|left|right|width|text|word|letter/i.test(e) || /X$/.test(e) || "x" === e ? "x" : "y";switch (v) {case "%":
                    r *= "x" === S ? h.percentToPxWidth : h.percentToPxHeight;break;case "px":
                    break;default:
                    r *= h[v + "ToPx"];}switch (t) {case "%":
                    r *= 1 / ("x" === S ? h.percentToPxWidth : h.percentToPxHeight);break;case "px":
                    break;default:
                    r *= 1 / h[t + "ToPx"];}
              }switch (w) {case "+":
                  p = r + p;break;case "-":
                  p = r - p;break;case "*":
                  p *= r;break;case "/":
                  p = r / p;}j[e] = { rootPropertyValue: m, startValue: r, currentValue: r, endValue: p, unitType: t, easing: q }, g && (j[e].pattern = g), y.debug && console.log("tweensContainer (" + e + "): " + JSON.stringify(j[e]), a);
            };for (var I in s) {
              if (s.hasOwnProperty(I)) {
                var J = A.Names.camelCase(I),
                    K = function (b, c) {
                  var d, f, g;return u.isFunction(b) && (b = b.call(a, e, C)), u.isArray(b) ? (d = b[0], !u.isArray(b[1]) && /^[\d-]/.test(b[1]) || u.isFunction(b[1]) || A.RegEx.isHex.test(b[1]) ? g = b[1] : u.isString(b[1]) && !A.RegEx.isHex.test(b[1]) && y.Easings[b[1]] || u.isArray(b[1]) ? (f = c ? b[1] : l(b[1], i.duration), g = b[2]) : g = b[1] || b[2]) : d = b, c || (f = f || i.easing), u.isFunction(d) && (d = d.call(a, e, C)), u.isFunction(g) && (g = g.call(a, e, C)), [d || 0, f, g];
                }(s[I]);if (t(A.Lists.colors, J)) {
                  var L = K[0],
                      O = K[1],
                      P = K[2];if (A.RegEx.isHex.test(L)) {
                    for (var Q = ["Red", "Green", "Blue"], R = A.Values.hexToRgb(L), S = P ? A.Values.hexToRgb(P) : d, T = 0; T < Q.length; T++) {
                      var U = [R[T]];O && U.push(O), S !== d && U.push(S[T]), H(J + Q[T], U);
                    }continue;
                  }
                }H(J, K);
              }
            }j.element = a;
          }j.element && (A.Values.addClass(a, "velocity-animating"), N.push(j), k = g(a), k && ("" === i.queue && (k.tweensContainer = j, k.opts = i), k.isAnimating = !0), D === C - 1 ? (y.State.calls.push([N, r, i, null, z.resolver, null, 0]), y.State.isTicking === !1 && (y.State.isTicking = !0, m())) : D++);
        }var h,
            i = o.extend({}, y.defaults, v),
            j = {};switch (g(a) === d && y.init(a), parseFloat(i.delay) && i.queue !== !1 && o.queue(a, i.queue, function (b) {
          y.velocityQueueEntryFlag = !0;var c = y.State.delayedElements.count++;y.State.delayedElements[c] = a;var d = function (a) {
            return function () {
              y.State.delayedElements[a] = !1, b();
            };
          }(c);g(a).delayBegin = new Date().getTime(), g(a).delay = parseFloat(i.delay), g(a).delayTimer = { setTimeout: setTimeout(b, parseFloat(i.delay)), next: d };
        }), i.duration.toString().toLowerCase()) {case "fast":
            i.duration = 200;break;case "normal":
            i.duration = w;break;case "slow":
            i.duration = 600;break;default:
            i.duration = parseFloat(i.duration) || 1;}if (y.mock !== !1 && (y.mock === !0 ? i.duration = i.delay = 1 : (i.duration *= parseFloat(y.mock) || 1, i.delay *= parseFloat(y.mock) || 1)), i.easing = l(i.easing, i.duration), i.begin && !u.isFunction(i.begin) && (i.begin = null), i.progress && !u.isFunction(i.progress) && (i.progress = null), i.complete && !u.isFunction(i.complete) && (i.complete = null), i.display !== d && null !== i.display && (i.display = i.display.toString().toLowerCase(), "auto" === i.display && (i.display = y.CSS.Values.getDisplayType(a))), i.visibility !== d && null !== i.visibility && (i.visibility = i.visibility.toString().toLowerCase()), i.mobileHA = i.mobileHA && y.State.isMobile && !y.State.isGingerbread, i.queue === !1) {
          if (i.delay) {
            var k = y.State.delayedElements.count++;y.State.delayedElements[k] = a;var n = function (a) {
              return function () {
                y.State.delayedElements[a] = !1, f();
              };
            }(k);g(a).delayBegin = new Date().getTime(), g(a).delay = parseFloat(i.delay), g(a).delayTimer = { setTimeout: setTimeout(f, parseFloat(i.delay)), next: n };
          } else f();
        } else o.queue(a, i.queue, function (a, b) {
          if (b === !0) return z.promise && z.resolver(r), !0;y.velocityQueueEntryFlag = !0, f(a);
        });"" !== i.queue && "fx" !== i.queue || "inprogress" === o.queue(a)[0] || o.dequeue(a);
      }var j,
          k,
          p,
          q,
          r,
          s,
          v,
          x = arguments[0] && (arguments[0].p || o.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || u.isString(arguments[0].properties));u.isWrapped(this) ? (k = !1, q = 0, r = this, p = this) : (k = !0, q = 1, r = x ? arguments[0].elements || arguments[0].e : arguments[0]);var z = { promise: null, resolver: null, rejecter: null };if (k && y.Promise && (z.promise = new y.Promise(function (a, b) {
        z.resolver = a, z.rejecter = b;
      })), x ? (s = arguments[0].properties || arguments[0].p, v = arguments[0].options || arguments[0].o) : (s = arguments[q], v = arguments[q + 1]), !(r = f(r))) return void (z.promise && (s && v && v.promiseRejectEmpty === !1 ? z.resolver() : z.rejecter()));var C = r.length,
          D = 0;if (!/^(stop|finish|finishAll|pause|resume)$/i.test(s) && !o.isPlainObject(v)) {
        var E = q + 1;v = {};for (var F = E; F < arguments.length; F++) {
          u.isArray(arguments[F]) || !/^(fast|normal|slow)$/i.test(arguments[F]) && !/^\d/.test(arguments[F]) ? u.isString(arguments[F]) || u.isArray(arguments[F]) ? v.easing = arguments[F] : u.isFunction(arguments[F]) && (v.complete = arguments[F]) : v.duration = arguments[F];
        }
      }var G;switch (s) {case "scroll":
          G = "scroll";break;case "reverse":
          G = "reverse";break;case "pause":
          var H = new Date().getTime();return o.each(r, function (a, b) {
            h(b, H);
          }), o.each(y.State.calls, function (a, b) {
            var c = !1;b && o.each(b[1], function (a, e) {
              var f = v === d ? "" : v;return f !== !0 && b[2].queue !== f && (v !== d || b[2].queue !== !1) || (o.each(r, function (a, d) {
                if (d === e) return b[5] = { resume: !1 }, c = !0, !1;
              }), !c && void 0);
            });
          }), a();case "resume":
          return o.each(r, function (a, b) {
            i(b, H);
          }), o.each(y.State.calls, function (a, b) {
            var c = !1;b && o.each(b[1], function (a, e) {
              var f = v === d ? "" : v;return f !== !0 && b[2].queue !== f && (v !== d || b[2].queue !== !1) || !b[5] || (o.each(r, function (a, d) {
                if (d === e) return b[5].resume = !0, c = !0, !1;
              }), !c && void 0);
            });
          }), a();case "finish":case "finishAll":case "stop":
          o.each(r, function (a, b) {
            g(b) && g(b).delayTimer && (clearTimeout(g(b).delayTimer.setTimeout), g(b).delayTimer.next && g(b).delayTimer.next(), delete g(b).delayTimer), "finishAll" !== s || v !== !0 && !u.isString(v) || (o.each(o.queue(b, u.isString(v) ? v : ""), function (a, b) {
              u.isFunction(b) && b();
            }), o.queue(b, u.isString(v) ? v : "", []));
          });var I = [];return o.each(y.State.calls, function (a, b) {
            b && o.each(b[1], function (c, e) {
              var f = v === d ? "" : v;if (f !== !0 && b[2].queue !== f && (v !== d || b[2].queue !== !1)) return !0;o.each(r, function (c, d) {
                if (d === e) if ((v === !0 || u.isString(v)) && (o.each(o.queue(d, u.isString(v) ? v : ""), function (a, b) {
                  u.isFunction(b) && b(null, !0);
                }), o.queue(d, u.isString(v) ? v : "", [])), "stop" === s) {
                  var h = g(d);h && h.tweensContainer && f !== !1 && o.each(h.tweensContainer, function (a, b) {
                    b.endValue = b.currentValue;
                  }), I.push(a);
                } else "finish" !== s && "finishAll" !== s || (b[2].duration = 1);
              });
            });
          }), "stop" === s && (o.each(I, function (a, b) {
            n(b, !0);
          }), z.promise && z.resolver(r)), a();default:
          if (!o.isPlainObject(s) || u.isEmptyObject(s)) {
            if (u.isString(s) && y.Redirects[s]) {
              j = o.extend({}, v);var J = j.duration,
                  K = j.delay || 0;return j.backwards === !0 && (r = o.extend(!0, [], r).reverse()), o.each(r, function (a, b) {
                parseFloat(j.stagger) ? j.delay = K + parseFloat(j.stagger) * a : u.isFunction(j.stagger) && (j.delay = K + j.stagger.call(b, a, C)), j.drag && (j.duration = parseFloat(J) || (/^(callout|transition)/.test(s) ? 1e3 : w), j.duration = Math.max(j.duration * (j.backwards ? 1 - a / C : (a + 1) / C), .75 * j.duration, 200)), y.Redirects[s].call(b, b, j || {}, a, C, r, z.promise ? z : d);
              }), a();
            }var L = "Velocity: First argument (" + s + ") was not a property map, a known action, or a registered redirect. Aborting.";return z.promise ? z.rejecter(new Error(L)) : b.console && console.log(L), a();
          }G = "start";}var M = { lastParent: null, lastPosition: null, lastFontSize: null, lastPercentToPxWidth: null, lastPercentToPxHeight: null, lastEmToPx: null, remToPx: null, vwToPx: null, vhToPx: null },
          N = [];o.each(r, function (a, b) {
        u.isNode(b) && e(b, a);
      }), j = o.extend({}, y.defaults, v), j.loop = parseInt(j.loop, 10);var O = 2 * j.loop - 1;if (j.loop) for (var P = 0; P < O; P++) {
        var Q = { delay: j.delay, progress: j.progress };P === O - 1 && (Q.display = j.display, Q.visibility = j.visibility, Q.complete = j.complete), B(r, "reverse", Q);
      }return a();
    };y = o.extend(B, y), y.animate = B;var C = b.requestAnimationFrame || q;if (!y.State.isMobile && c.hidden !== d) {
      var D = function D() {
        c.hidden ? (C = function C(a) {
          return setTimeout(function () {
            a(!0);
          }, 16);
        }, m()) : C = b.requestAnimationFrame || q;
      };D(), c.addEventListener("visibilitychange", D);
    }return a.Velocity = y, a !== b && (a.fn.velocity = B, a.fn.velocity.defaults = y.defaults), o.each(["Down", "Up"], function (a, b) {
      y.Redirects["slide" + b] = function (a, c, e, f, g, h) {
        var i = o.extend({}, c),
            j = i.begin,
            k = i.complete,
            l = {},
            m = { height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: "" };i.display === d && (i.display = "Down" === b ? "inline" === y.CSS.Values.getDisplayType(a) ? "inline-block" : "block" : "none"), i.begin = function () {
          0 === e && j && j.call(g, g);for (var c in m) {
            if (m.hasOwnProperty(c)) {
              l[c] = a.style[c];var d = A.getPropertyValue(a, c);m[c] = "Down" === b ? [d, 0] : [0, d];
            }
          }l.overflow = a.style.overflow, a.style.overflow = "hidden";
        }, i.complete = function () {
          for (var b in l) {
            l.hasOwnProperty(b) && (a.style[b] = l[b]);
          }e === f - 1 && (k && k.call(g, g), h && h.resolver(g));
        }, y(a, m, i);
      };
    }), o.each(["In", "Out"], function (a, b) {
      y.Redirects["fade" + b] = function (a, c, e, f, g, h) {
        var i = o.extend({}, c),
            j = i.complete,
            k = { opacity: "In" === b ? 1 : 0 };0 !== e && (i.begin = null), i.complete = e !== f - 1 ? null : function () {
          j && j.call(g, g), h && h.resolver(g);
        }, i.display === d && (i.display = "In" === b ? "auto" : "none"), y(this, k, i);
      };
    }), y;
  }(window.jQuery || window.Zepto || window, window, window ? window.document : undefined);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _EventDriver = __webpack_require__(9);

var _EventDriver2 = _interopRequireDefault(_EventDriver);

var _FirebaseInterface = __webpack_require__(73);

var _FirebaseInterface2 = _interopRequireDefault(_FirebaseInterface);

var _UmiStorage = __webpack_require__(83);

var _UmiStorage2 = _interopRequireDefault(_UmiStorage);

var _MultiLangSupport = __webpack_require__(84);

var _MultiLangSupport2 = _interopRequireDefault(_MultiLangSupport);

var _InterAppCom = __webpack_require__(85);

var _InterAppCom2 = _interopRequireDefault(_InterAppCom);

var _Logger = __webpack_require__(26);

var _Logger2 = _interopRequireDefault(_Logger);

var _Utils = __webpack_require__(25);

var _Utils2 = _interopRequireDefault(_Utils);

var _DateUtils = __webpack_require__(41);

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * UmiCore
 */
var UmiCore = function () {
  function UmiCore() {
    _classCallCheck(this, UmiCore);

    this.settings = this.getSettings();
    this.interAppCom = new _InterAppCom2.default(name); // Global "name" param
    window.Landbot = this.interAppCom; // Global usage
    this.interAppCom.send('landbot-init');
    this.fi = new _FirebaseInterface2.default();
    this.umiStorage = new _UmiStorage2.default(this.settings.storage_off);
    this.multiLang = new _MultiLangSupport2.default();
    _Logger2.default.append('Multilanguage support [' + this.multiLang.lang + ']', 'umicore.multilang');

    this.settings.serverUrl = this.settings.serverUrl || 'https://app.landbot.io/';
    this.settings.messageLimit = this.settings.messageLimit || 20;
    this.metaDataInfo = this.getMetadataInfo();
    this.provisionalWelcome = null;
    this.tempInitialMessages = [];
    this.welcomeLaunched = false;
    this.firstMessageDate = Date.now();
    this.agentsInfo = this.getStoredAgents();
    if (!this.agentsInfo['brand']) this.agentsInfo['brand'] = {
      name: this.settings.brand_name || 'landbot',
      avatar: this.settings.logo || 'https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png'
    };

    this.setupListeners();
    this.ready();
  }

  _createClass(UmiCore, [{
    key: 'getSettings',
    value: function getSettings() {
      var settings = UmiCoreConfig || {};
      // Obtain Queries
      var queries = {};
      var params = window.location.search.substring(1).split('&');

      var pair = null;
      for (var i = 0; i < params.length; i++) {
        pair = params[i].split('=');
        queries[pair[0]] = pair[1];
      }
      return Object.assign(settings, queries);
    }
  }, {
    key: 'extendSettings',
    value: function extendSettings(external) {
      var settings = JSON.parse(JSON.stringify(this.settings));
      this.settings = Object.assign(settings, external);
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      // InterAppCom
      _EventDriver2.default.on('hu-start-connection', function () {
        return _this.interAppCom.send('landbot-load');
      });
      _EventDriver2.default.on('hu-receive-message', function (message) {
        return _this.interAppCom.send('landbot-msg-receive', message);
      });
      this.interAppCom.on('landbot-config', function (config) {
        return _this.extendSettings(config);
      });
      this.interAppCom.on('landbot-msg-send', function (messageInfo) {
        _this.sendMessage(messageInfo);
      });
      this.interAppCom.on('landbot-custom-data', function (customData) {
        _this.settings.customData = Object.assign(_this.settings.customData ? { customData: _this.settings.customData } : {}, customData);
      });

      // Events Emitter
      _EventDriver2.default.on('hu-query-send-message', function (messageInfo) {
        return _this.sendMessage(messageInfo);
      });
      _EventDriver2.default.on('hu-start-connection', function () {
        return _this.startConnnection();
      });
      // ee.on('hu-database-auth', (e) => this.authProvider(e));
      // ee.on('hu-auth', () => this.loadConfig());
      // ee.on('hu-load-config', () => this.ready());
      // ee.on('hu-fi-broadcast-message', (listmessage) => this.broadCastMessage(listmessage));
      // ee.on('hu-customer-identify', (initial) => this.startMessage(initial));
      _EventDriver2.default.on('hu-sent-message', function (data) {
        return _this.checkCustomerToken(data);
      });
      _EventDriver2.default.on('hu-query-old-messages', function () {
        return _this.oldChats();
      });
      _EventDriver2.default.on('hu-query-stored-agents', function () {
        return _this.sendStoredAgents();
      });
      _EventDriver2.default.on('hu-query-get-agent', function (agentID) {
        return _this.fetchAgentData(agentID);
      });
      _EventDriver2.default.on('hu-receive-last-group-message', function (message) {
        return _this.interAppCom.send('landbot-proactive-msg-receive', message);
      });
      _EventDriver2.default.on('hu-receive-last-brand-message', function (message) {
        return _this.interAppCom.send('landbot-last-brand-msg-receive', message);
      });
    }
  }, {
    key: 'fetchAgentData',
    value: function fetchAgentData(agentID) {
      var _this2 = this;

      if (agentID < 1) return;
      if (this.agentsInfo[agentID]) {
        return;
      }
      this.agentsInfo[agentID] = {};
      this.fi.getAgentData(agentID).then(function (agentData) {
        _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Agent info received', 'umicore.agents[' + agentID + ']').append(agentData, 'umicore.agents[' + agentID + ']');
        _EventDriver2.default.emit('hu-get-agent', {
          name: agentData.name,
          avatar: agentData.avatar,
          samurai: agentID
        });
        _this2.agentsInfo[agentID] = {
          name: agentData.name,
          avatar: agentData.avatar
        };
        _this2.interAppCom.send('landbot-proactive-agents-info', _this2.agentsInfo);
        _this2.storeAgents();
      }).catch(function () {
        delete _this2.agentsInfo[agentID];
      });
    }
  }, {
    key: 'sendStoredAgents',
    value: function sendStoredAgents() {
      _EventDriver2.default.emit('hu-get-stored-agents', this.agentsInfo);
      this.interAppCom.send('landbot-proactive-agents-info', this.agentsInfo);
      _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Got stored agents', 'umicore.agents.info').append(this.agentsInfo, 'umicore.agents.info');
      // console.debug('%cUmicore debug: Got stored agents', 'color:green');
      // console.debug(this.agentsInfo);
    }
  }, {
    key: 'getStoredAgents',
    value: function getStoredAgents() {
      return JSON.parse(this.umiStorage.getItem('agents-info-' + this.settings.channelToken) || '{}');
    }
  }, {
    key: 'storeAgents',
    value: function storeAgents() {
      this.umiStorage.setItem('agents-info-' + this.settings.channelToken, JSON.stringify(this.agentsInfo));
    }
  }, {
    key: 'oldChats',
    value: function oldChats() {
      var _this3 = this;

      this.fi.getOldChats().then(function (messages) {
        messages = _this3.fixTimestamp(messages);
        _EventDriver2.default.emit('hu-old-chat', messages);
        // console.debug(messages);
      }).catch();
    }
  }, {
    key: 'authProvider',
    value: function authProvider() {
      this.fi.auth().then(function (user) {
        if (user !== undefined) {
          _EventDriver2.default.emit('hu-auth');
        }
      }).catch(function (err) {
        _EventDriver2.default.emit('hu-error-auth');
      });
    }
  }, {
    key: 'loadConfig',
    value: function loadConfig() {
      _EventDriver2.default.emit('hu-load-config', this.settings);
    }
  }, {
    key: 'ready',
    value: function ready() {
      _EventDriver2.default.emit('hu-umicore-ready', 'hu-umicore-ready');
    }
  }, {
    key: 'broadCastMessage',
    value: function broadCastMessage(listmessage) {
      // TODO
    }
  }, {
    key: 'randomId',
    value: function randomId() {
      return 'H-' + this.settings.brandID + _Utils2.default.randomKey(10);
    }
  }, {
    key: 'getRandomWelcome',
    value: function getRandomWelcome() {
      var defaultMessages = [{
        'type': 'dialog',
        'title': 'Hello there!',
        'buttons': ['Hi!'],
        'payloads': ['Hi!'],
        'samurai': '-1'
      }, {
        'type': 'dialog',
        'title': 'Howdy!',
        'buttons': ['Hello!'],
        'payloads': ['Hello!'],
        'samurai': '-1'
      }, {
        'type': 'dialog',
        'title': 'Welcome!',
        'buttons': ['Howdy!'],
        'payloads': ['Howdy!'],
        'samurai': '-1'
      }];
      return [defaultMessages[Math.floor(Math.random() * defaultMessages.length)]];
    }
  }, {
    key: 'getWelcomeMessages',
    value: function getWelcomeMessages() {
      var ignoreStorage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.umiStorage.hasOwnProperty('welcomeMessage-' + this.settings.channelToken) && !ignoreStorage && !this.settings.test) {
        // console.debug('%cUmiCore debug: Welcome messages obtained from local Storage', 'color:green');
        _Logger2.default.append('Welcome messages obtained from local Storage', 'umicore.welcome');
        return JSON.parse(this.umiStorage.getItem('welcomeMessage-' + this.settings.channelToken));
      }

      var welcome = this.settings.welcome || [];
      welcome = welcome.length > 0 ? welcome : this.getRandomWelcome();
      // console.debug('%cUmiCore debug: Welcome message', 'color:green');
      // console.debug(welcome);
      _Logger2.default.append('Welcome message', 'umicore.welcome');
      _Logger2.default.append(welcome, 'umicore.welcome');

      var messagesList = welcome;
      if (messagesList.hasOwnProperty('messages')) messagesList = Object.values(messagesList.messages);

      var now = Date.now();
      if (messagesList.length === 0) {
        return [];
      }
      messagesList.forEach(function (message, counter) {
        message.timestamp = counter + now;
        message.key = _Utils2.default.randomKey();
        message.role = message.role ? message.role.concat('welcome') : ['welcome'];
      });
      return messagesList;
    }
  }, {
    key: 'welcomeMessages',
    value: function welcomeMessages() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var messagesList = _this4.getWelcomeMessages();
        messagesList.forEach(function (message) {
          _EventDriver2.default.emit('hu-receive-message', message);
        });
        _this4.provisionalWelcome = messagesList;
        // console.debug('%cUmiCore debug: provisional welcome is:', 'color:green');
        // console.debug(this.provisionalWelcome);
        _this4.welcomeLaunched = true;
        resolve(true);
      });
    }
  }, {
    key: 'storeWelcomeMessage',
    value: function storeWelcomeMessage() {
      // console.debug('%cUmiCore debug: Welcome messages stored in local Storage', 'color:green');
      this.umiStorage.removeItem('welcomeMessage-' + this.settings.channelToken);
      this.umiStorage.setItem('welcomeMessage-' + this.settings.channelToken, JSON.stringify(this.provisionalWelcome));
      this.provisionalWelcome = null;
    }
  }, {
    key: 'getRandomRevisit',
    value: function getRandomRevisit() {
      return this.multiLang.getObject('revisit');
    }
  }, {
    key: 'getRevisitMessages',
    value: function getRevisitMessages() {
      var revisit = this.settings.revisit || [];
      revisit = revisit.length > 0 ? revisit : this.getRandomRevisit();
      // console.debug('%cUmiCore debug: Revisit message', 'color:green');
      // console.debug(revisit);
      _Logger2.default.append(revisit, 'umicore.revisit');

      var messagesList = revisit;

      var now = Date.now();
      if (messagesList.length === 0) {
        return [];
      }
      messagesList.forEach(function (message, counter) {
        message.timestamp = counter + now;
        message.key = _Utils2.default.randomKey();
        message.role = message.role ? message.role.concat('revisit') : ['revisit'];
      });
      return messagesList;
    }
  }, {
    key: 'revisitMessages',
    value: function revisitMessages() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var messagesList = _this5.getRevisitMessages();
        messagesList.forEach(function (message) {
          _EventDriver2.default.emit('hu-receive-message', message);
        });
        // console.debug('%cUmiCore debug: Launched revisit messages', 'color:green');
        resolve(true);
      });
    }
  }, {
    key: 'fixTimestamp',
    value: function fixTimestamp(listMessage) {
      listMessage.forEach(function (message) {
        message.timestamp *= 1000;
      });
      return listMessage;
    }
  }, {
    key: 'getAllMessages',
    value: function getAllMessages() {
      var _this6 = this;

      var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      _EventDriver2.default.emit('hu-fetching-data');
      return new Promise(function (resolve, reject) {
        _this6.fi.getAllMessages(_this6.settings.messageLimit).then(function (messages) {
          messages = _this6.fixTimestamp(messages);
          if (messages.length < _this6.settings.messageLimit && !_this6.welcomeLaunched) {
            // console.debug('%cUmiCore debug: Messages loaded are less than the limit. Concatenating welcome messages...', 'color;');
            _Logger2.default.append('Messages loaded are less than the limit. Concatenating welcome messages...', 'umicore.welcome');
            var welcome = _this6.getWelcomeMessages();
            // let timestamp = messages[0].timestamp - welcome.length;
            messages = welcome.concat(messages);
          }

          if (!initial) {
            // Nueva conversación
            messages.forEach(function (message) {
              if (message.samurai !== undefined) _EventDriver2.default.emit('hu-receive-message', message);
            });
          } else // Conversación iniciada previamente
            _EventDriver2.default.emit('hu-initial-chat', messages);

          // console.debug('%cUmiCore debug: messages loaded successfuly from firebase', 'color:blue');
          // console.debug(messages);
          _Logger2.default.append(messages, 'umicore.messages');

          resolve();
        }).catch(function (error) {
          // No es que haya errores, sino que no hay mensajes
          // console.debug('%cUmiCore debug: could not load messages from firebase', 'color:red');
          // console.debug(error);
          _Logger2.default.append('Could not load messages from firebase', 'umicore.messages', 'error');
          // ee.emit('hu-initial-chat', this.getWelcomeMessages(true));

          reject();
        });
      });
    }

    /**
     * setReceiveListener
     * @param {Boolean} newCustomer 
     *    If true, firebase will retrieve all incoming messages, with no filter. 
     *    This is true when it's called from a first user interaction (welcome).
     */

  }, {
    key: 'setReceiveListener',
    value: function setReceiveListener(newCustomer) {
      this.fi.setEventListener('addMessage', this.callbackMessageReceive.bind(this));
      this.fi.startConnection(newCustomer);
    }
  }, {
    key: 'callbackMessageReceive',
    value: function callbackMessageReceive(message) {
      message = this.fixTimestamp([message]);
      _EventDriver2.default.emit('hu-receive-message', message[0]);

      // Fetch agent data
      if (message[0].samurai && !this.agentsInfo[message[0].samurai]) this.fetchAgentData(message[0].samurai);

      // Confirm welcome messages
      if (this.provisionalWelcome !== null) this.storeWelcomeMessage();
    }
  }, {
    key: 'customerIdentify',
    value: function customerIdentify() {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        _this7.fi.customerIdentify(_this7.settings.customerToken).then(function (data) {
          // console.debug('%cUmiCore debug: customer identified', 'color:green');
          _Logger2.default.append('Customer identified [' + _this7.settings.customerToken + ']', 'umicore.auth');
          _this7.umiStorage.setItem('umicore-customer-' + _this7.settings.channelToken, _this7.settings.customerToken);
          _EventDriver2.default.emit('hu-customer-identify');
          resolve();
        }).catch(function (error) {
          // console.debug('%cUmiCore debug: customer could not be identified', 'color:red');
          _Logger2.default.append('Customer could not be identified <' + _this7.settings.customerToken + '>', 'umicore.auth', 'error');
          _this7.umiStorage.removeItem('umicore-customer-' + _this7.settings.channelToken);
          _this7.settings.customerToken = null;

          if (error.code === 1) _EventDriver2.default.emit('hu-error-wrong-entity', error);else if (error.code === 2) _EventDriver2.default.emit('hu-error-wrong-customer', error);else if (error.code === 3) _EventDriver2.default.emit('hu-error-wrong-channel', error);else if (error.code === 0) _EventDriver2.default.emit('hu-error-server-connection', error);else if (error.code === -1) _EventDriver2.default.emit('hu-error-auth-connection', error);
          reject();
        });
      });
    }

    /**
     * Start connection steps:
     * – Checks if customer token is defined in config or storage
     * – Then, launch messenger service:
     *    · Welcome messages when no customer token found
     *    · Revisit messages when customer token found
     *    · Normal start, loads previous messages.
     */

  }, {
    key: 'startConnnection',
    value: function startConnnection() {
      var _this8 = this;

      // this.fi.startbroadCastMessage();
      if (!this.settings.customerToken) this.settings.customerToken = this.settings.channelToken ? this.umiStorage.getItem('umicore-customer-' + this.settings.channelToken) : null;
      // console.debug(`%cUmiCore debug: customerToken => ${this.settings.customerToken}`, 'color:green');

      // Welcome start
      if (!this.settings.customerToken) {
        this.welcomeMessages();
        return;

        // Revisit start
      } else if (this.settings.revisit_off !== true) {
        this.umiStorage.removeItem('umicore-customer-' + this.settings.channelToken);
        this.umiStorage.setItem('umicore-customer-' + this.settings.channelToken, this.settings.customerToken);
        this.revisitMessages();
        this.customerIdentify().then(function () {
          return _this8.setReceiveListener();
        });
        // .catch();
        return;

        // Normal start
      } else {
        this.umiStorage.removeItem('umicore-customer-' + this.settings.channelToken);
        this.umiStorage.setItem('umicore-customer-' + this.settings.channelToken, this.settings.customerToken);
        this.customerIdentify().then(function () {
          _this8.getAllMessages(true).then(function () {
            return _this8.setReceiveListener();
          }).catch(function () {
            return _this8.welcomeMessages();
          });
        });
        // .catch(() => {
        //   this.welcomeMessages()
        // });
        return;
      }
    }
  }, {
    key: 'getMetadataInfo',
    value: function getMetadataInfo() {
      return {
        'navigator': {
          'userAgent': navigator.userAgent,
          'languages': navigator.languages,
          'language': navigator.language || navigator.userLanguage,
          'plugins': navigator.plugins
        },
        'screen': {
          'colorDepth': screen.colorDepth,
          'size': {
            'height': screen.height,
            'width': screen.width
          },
          'orientation': {
            'type': screen.orientation ? screen.orientation.type : null,
            'angle': screen.orientation ? screen.orientation.angle : null
          },
          'touchdevice': 'ontouchstart' in window || navigator.maxTouchPoints
        },
        'location': {
          'origin': _Utils2.default.getOrigin(),
          'timezoneOffset': new Date().getTimezoneOffset() / 60
        }
        // 'os': {
        //   'system': window.gatico,
        // }
      };
    }
  }, {
    key: 'validateInfomessage',
    value: function validateInfomessage(message) {
      // TODO
      if (message.message || message.images && message.image_flags) return true;
      return true; // Provisional
    }
  }, {
    key: 'checkCustomerToken',
    value: function checkCustomerToken(jData) {
      var _this9 = this;

      if (!this.settings.customerToken) // First auth
        _EventDriver2.default.emit('hu-first-auth');

      if (!this.settings.customerToken || this.settings.customerToken && jData.customer_token !== this.settings.customerToken) {
        this.settings.customerToken = jData.customer_token;
        this.customerIdentify().then(function () {
          return _this9.setReceiveListener(true);
        });
      }
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage(messageInfo) {
      var _this10 = this;

      // Por ahora no hay validación ninguna
      if (!this.validateInfomessage(messageInfo)) {
        _EventDriver2.default.emit('hu-error-malformed-message', messageInfo);
        return;
      }
      // Comprobación de reinicio o continuación del chat inicial
      if (messageInfo.payload === '#_continue') {
        _EventDriver2.default.emit('hu-reset-chat');
        this.getAllMessages(true);
        // .then(() => this.setReceiveListener());
        return;
      } else if (messageInfo.payload === '#init') {
        _EventDriver2.default.emit('hu-reset-chat');
        messageInfo.message = '#init';
        messageInfo.render = false;
      }

      var _populateFormData = this.populateFormData(messageInfo),
          _populateFormData2 = _slicedToArray(_populateFormData, 2),
          formdata = _populateFormData2[0],
          message = _populateFormData2[1];

      if (!this.settings.customerToken) _EventDriver2.default.emit('hu-first-message');
      var request = new XMLHttpRequest();
      request.open('POST', this.settings.serverUrl + "webchat/send/");
      request.onload = function (oEvent) {
        var jData = JSON.parse(oEvent.target.response);
        if (request.status == 200 && typeof jData.errors === "undefined") {

          // console.debug('%cUmiCore debug: message sent successfuly', 'color:green');
          // console.debug(message);
          _Logger2.default.append(message, 'umicore.send');
          _this10.umiStorage.removeItem('umicore-customer-' + _this10.settings.channelToken);
          _this10.umiStorage.setItem('umicore-customer-' + _this10.settings.channelToken, jData.customer_token);
          _EventDriver2.default.emit('hu-sent-message', jData); // Checks customer token in case of updates
        } else {
          // console.debug('%cUmiCore debug: message couldn\'t be sent', 'color:red');
          // console.debug(message);
          _Logger2.default.append(message, 'umicore.send', 'error');
          _EventDriver2.default.emit('hu-error-sending-message', oEvent);
        }
      };
      request.onerror = function (oEvent) {
        _EventDriver2.default.emit('hu-error-sending-message', oEvent);
      };
      request.send(formdata);

      // Este mensaje es renderizado de manera síncrona en la GUI, a diferencia de los recibidos
      _EventDriver2.default.emit('hu-sending-message', message);
    }
  }, {
    key: 'populateFormData',
    value: function populateFormData(messageInfo) {
      var formdata = new FormData();
      var image_flags = [];
      var images = [];
      var message_id = this.randomId();

      formdata.append('message', messageInfo.message);
      formdata.append('payload', messageInfo.payload);
      if (messageInfo.images) {
        for (var i = 0; i < messageInfo.images.length; i++) {
          if (messageInfo.image_flags[i]) {
            formdata.append('images', messageInfo.images[i]);
            images.push(messageInfo.images[i]);
            image_flags.push(true);
          }
        }
      }
      formdata.append('image_flags', image_flags);
      formdata.append('version', this.settings.version);
      formdata.append('channel_token', this.settings.channelToken);
      formdata.append('customer_token', this.settings.customerToken);
      formdata.append('message_id', message_id);
      formdata.append('origin', _Utils2.default.getOrigin());

      if (this.settings.customData) formdata.append('custom_data', JSON.stringify(this.settings.customData));
      if (this.metaDataInfo) {
        formdata.append('metadata_info', JSON.stringify(this.metaDataInfo));
        this.metaDataInfo = null;
      }
      if (this.settings.customerName) formdata.append('customer_name', this.settings.customerName);

      messageInfo.message_id = message_id;
      messageInfo.images = images;
      messageInfo.image_flags = image_flags;

      var messageStructure = {
        "message": messageInfo.message,
        "message_id": message_id,
        "render": messageInfo.render
      };

      if (images.length === 0) {
        messageStructure['type'] = 'text';
      } else if (images.length === 1) {
        messageStructure['type'] = 'image';
        messageStructure['url'] = images[0];
      } else if (images.length > 1) {
        messageStructure['type'] = 'multiple_images';
        messageStructure['urls'] = images;
      }
      return [formdata, messageStructure];
    }
  }]);

  return UmiCore;
}();

exports.default = UmiCore;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // ==================
// FIREBASE INTERFACE
// ==================
// Ver documentación en:
// https://firebase.google.com/docs/reference/js/

var _app = __webpack_require__(24);

var firebase = _interopRequireWildcard(_app);

__webpack_require__(81);

__webpack_require__(82);

var _Utils = __webpack_require__(25);

var _Utils2 = _interopRequireDefault(_Utils);

var _DateUtils = __webpack_require__(41);

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FirebaseInterface = function () {
  function FirebaseInterface() {
    _classCallCheck(this, FirebaseInterface);

    this.config = UmiCoreConfig;
    this.firebaseApp = firebase.initializeApp(this.config, 'landbot-' + this.config.channelToken + '-' + (UmiCoreConfig.test /*false*/ ? 'test' : _Utils2.default.randomKey(4)));
    this.configRef = null;
    this.lastTimestamp = Date.now();
    this.firstTimestamp = Date.now();
    this.callbacks = {};
  }

  // NOT USED


  _createClass(FirebaseInterface, [{
    key: 'setConfigRef',
    value: function setConfigRef() {
      this.configRef = this.firebaseApp.database().ref(this.config.brandID + '/public/config/' + this.config.channelToken);
    }
  }, {
    key: 'auth',
    value: function auth() {
      return this.firebaseApp.auth().signInAnonymously();
    }
  }, {
    key: 'customerIdentify',
    value: function customerIdentify(customerToken) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        var formdata = new FormData();
        formdata.append('channel_token', _this.config.channelToken);
        // TODO: Probar en back como procesa campos como null
        formdata.append('customer_token', customerToken);

        request.open('POST', _this.config.serverUrl + "webchat/get_firebase/");
        request.onload = function (oEvent) {
          // TODO: view request.onerror == 404 (channel not exists)
          var jData = JSON.parse(oEvent.target.response);
          if (request.status == 200) {
            // console.debug(`%cUmiCore debug: Firebase authentication complete ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue');
            var firebaseToken = jData.firebase_token;
            var firebasePath = jData.database_url.split('.com')[1];
            _this.lastTimestamp = jData.lastTimestamp * 1000 || _this.lastTimestamp;
            _this.firstTimestamp = jData.lastTimestamp * 1000 || _this.firstTimestamp;

            _this.firebaseApp.auth().signInWithCustomToken(firebaseToken).catch(function (err) {
              reject({
                'code': -1,
                'msg': err
              });
            }).then(function (user) {
              _this.chatRef = _this.firebaseApp.database().ref(firebasePath);
              _this.statBrandRef = _this.firebaseApp.database().ref(firebasePath.split('/')[0] + '/presence');
              _this.typingRef = _this.firebaseApp.database().ref(firebasePath.substring(0, firebasePath.lastIndexOf("messages")) + "typing");
              resolve(user);
            });
          } else if (request.status == 403) {
            reject({ 'code': 2, 'msg': jData.error });
            return;
          } else {
            reject({ 'code': 1, 'msg': jData.error });
            return;
          }
        };
        request.onerror = function (oEvent) {
          reject({ 'code': 0, 'msg': 'Server connection error' });
        };
        request.send(formdata);
      });
    }
  }, {
    key: 'setEventListener',
    value: function setEventListener(event, callback) {
      this.callbacks[event] = callback;
    }
  }, {
    key: 'updateFirstTimestamp',
    value: function updateFirstTimestamp(timestamp) {
      if (this.firstTimestamp > timestamp) this.firstTimestamp = timestamp - 0.001;
    }
  }, {
    key: 'startConnection',
    value: function startConnection(newCustomer) {
      var _this2 = this;

      // Infalible nene
      var lastKey = null;
      var ignoreFirst = false;

      var customRef = this.chatRef
      // .orderByKey();
      .orderByChild("timestamp");

      customRef.limitToLast(1).once('value').then(function (messageSnapshot) {
        var obj = messageSnapshot.toJSON() ? messageSnapshot.toJSON() : { timestamp: 0 };
        // lastKey = Object.keys(obj)[0];
        lastKey = Object.values(obj)[0].timestamp;
        if (lastKey && !newCustomer) {
          ignoreFirst = true;
          customRef = customRef.startAt(lastKey);
        }

        customRef.on('child_added', function (messageSnapshot) {
          if (ignoreFirst === true) {
            ignoreFirst = false;
          } else {
            _this2.onChildAdded(messageSnapshot);
          }
        });
      });
    }
  }, {
    key: 'onChildAdded',
    value: function onChildAdded(messageSnapshot) {
      var message = messageSnapshot.toJSON();
      message.key = messageSnapshot.key;
      this.callbacks['addMessage'](message);
    }
  }, {
    key: 'getAllMessages',
    value: function getAllMessages() {
      var _this3 = this;

      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

      return new Promise(function (resolve, reject) {
        var query = _this3.chatRef.orderByChild("timestamp").limitToLast(limit).once('value').then(function (messageSnapshot) {
          var listmessage = [];
          messageSnapshot.forEach(function (message) {
            var auxmessage = message.toJSON();
            auxmessage.key = message.key;
            listmessage.push(auxmessage);
          });
          if (listmessage.length > 0) {
            // this.lastTimestamp = listmessage[listmessage.length - 1].timestamp + 0.001;
            _this3.updateFirstTimestamp(listmessage[0].timestamp);
          }
          resolve(listmessage);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'getOldChats',
    value: function getOldChats(datelimit) {
      var _this4 = this;

      var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

      return new Promise(function (resolve, reject) {
        var query = _this4.chatRef.orderByChild("timestamp").endAt(_this4.firstTimestamp).limitToLast(limit).once('value').then(function (messageSnapshot) {
          var listmessage = [];
          messageSnapshot.forEach(function (message) {
            var auxmessage = message.toJSON();
            auxmessage.key = message.key;
            listmessage.push(auxmessage);
          });
          if (listmessage.length > 0) {
            // this.lastTimestamp = listmessage[listmessage.length - 1].timestamp + 0.001;
            _this4.updateFirstTimestamp(listmessage[0].timestamp);
          }
          resolve(listmessage);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'getAgentData',
    value: function getAgentData(agentID) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open('POST', _this5.config.serverUrl + "webchat/get_agent/");
        request.onload = function (oEvent) {
          var jData = JSON.parse(oEvent.target.response);
          if (request.status == 200) {
            resolve(jData);
          } else if (request.status == 403) {
            reject({ 'code': 2, 'msg': jData.error });
            return;
          } else {
            reject({ 'code': 1, 'msg': jData.error });
            return;
          }
        };
        request.onerror = function (oEvent) {
          reject({ 'code': 0, 'msg': 'Server connection error' });
        };
        request.send(JSON.stringify({
          agent_id: agentID,
          channel_token: _this5.config.channelToken
        }));
      });
    }
  }]);

  return FirebaseInterface;
}();

exports.default = FirebaseInterface;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.1.3
Build: rev-1234895
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * Copyright 2017 Google Inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * you may not use this file except in compliance with the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * You may obtain a copy of the License at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *   http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * See the License for the specific language governing permissions and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * limitations under the License.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */


exports.createFirebaseNamespace = createFirebaseNamespace;

var _subscribe = __webpack_require__(75);

var _errors = __webpack_require__(79);

var _shared_promise = __webpack_require__(40);

var _deep_copy = __webpack_require__(80);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var LocalPromise = _shared_promise.local.Promise;
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */

var FirebaseAppImpl = function () {
    function FirebaseAppImpl(options, name, firebase_) {
        _classCallCheck(this, FirebaseAppImpl);

        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = name;
        this.options_ = (0, _deep_copy.deepCopy)(options);
        this.INTERNAL = {
            'getUid': function getUid() {
                return null;
            },
            'getToken': function getToken() {
                return LocalPromise.resolve(null);
            },
            'addAuthTokenListener': function addAuthTokenListener(callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () {
                    return callback(null);
                }, 0);
            },
            'removeAuthTokenListener': function removeAuthTokenListener(callback) {
                tokenListeners = tokenListeners.filter(function (listener) {
                    return listener !== callback;
                });
            }
        };
    }

    _createClass(FirebaseAppImpl, [{
        key: 'delete',
        value: function _delete() {
            var _this = this;

            return new LocalPromise(function (resolve) {
                _this.checkDestroyed_();
                resolve();
            }).then(function () {
                _this.firebase_.INTERNAL.removeApp(_this.name_);
                var services = [];
                Object.keys(_this.services_).forEach(function (serviceKey) {
                    Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                        services.push(_this.services_[serviceKey][instanceKey]);
                    });
                });
                return LocalPromise.all(services.map(function (service) {
                    return service.INTERNAL.delete();
                }));
            }).then(function () {
                _this.isDeleted_ = true;
                _this.services_ = {};
            });
        }
        /**
         * Return a service instance associated with this app (creating it
         * on demand), identified by the passed instanceIdentifier.
         *
         * NOTE: Currently storage is the only one that is leveraging this
         * functionality. They invoke it by calling:
         *
         * ```javascript
         * firebase.app().storage('STORAGE BUCKET ID')
         * ```
         *
         * The service name is passed to this already
         * @internal
         */

    }, {
        key: '_getService',
        value: function _getService(name) {
            var instanceIdentifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_ENTRY_NAME;

            this.checkDestroyed_();
            if (!this.services_[name]) {
                this.services_[name] = {};
            }
            if (!this.services_[name][instanceIdentifier]) {
                /**
                 * If a custom instance has been defined (i.e. not '[DEFAULT]')
                 * then we will pass that instance on, otherwise we pass `null`
                 */
                var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME ? instanceIdentifier : undefined;
                var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
                this.services_[name][instanceIdentifier] = service;
            }
            return this.services_[name][instanceIdentifier];
        }
        /**
         * Callback function used to extend an App instance at the time
         * of service instance creation.
         */

    }, {
        key: 'extendApp',
        value: function extendApp(props) {
            var _this2 = this;

            // Copy the object onto the FirebaseAppImpl prototype
            (0, _deep_copy.deepExtend)(this, props);
            /**
             * If the app has overwritten the addAuthTokenListener stub, forward
             * the active token listeners on to the true fxn.
             *
             * TODO: This function is required due to our current module
             * structure. Once we are able to rely strictly upon a single module
             * implementation, this code should be refactored and Auth should
             * provide these stubs and the upgrade logic
             */
            if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
                tokenListeners.forEach(function (listener) {
                    _this2.INTERNAL.addAuthTokenListener(listener);
                });
                tokenListeners = [];
            }
        }
        /**
         * This function will throw an Error if the App has already been deleted -
         * use before performing API actions on the App.
         */

    }, {
        key: 'checkDestroyed_',
        value: function checkDestroyed_() {
            if (this.isDeleted_) {
                error('app-deleted', { 'name': this.name_ });
            }
        }
    }, {
        key: 'name',
        get: function get() {
            this.checkDestroyed_();
            return this.name_;
        }
    }, {
        key: 'options',
        get: function get() {
            this.checkDestroyed_();
            return this.options_;
        }
    }]);

    return FirebaseAppImpl;
}();

// Prevent dead-code elimination of these methods w/o invalid property
// copying.
FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options || FirebaseAppImpl.prototype.delete || console.log("dc");
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        '__esModule': true,
        'initializeApp':
        /**
         * Create a new App instance (name must be unique).
         */
        function (options, name) {
            if (name === undefined) {
                name = DEFAULT_ENTRY_NAME;
            } else {
                if (typeof name !== 'string' || name === '') {
                    error('bad-app-name', { 'name': name + '' });
                }
            }
            if (contains(apps_, name)) {
                error('duplicate-app', { 'name': name });
            }
            var app = new FirebaseAppImpl(options, name, namespace);
            apps_[name] = app;
            callAppHooks(app, 'create');
            return app;
        }
        /*
         * Return an array of all the non-deleted FirebaseApps.
         */
        ,
        'app': app,
        'apps': null,
        'Promise': LocalPromise,
        'SDK_VERSION': '4.1.3',
        'INTERNAL': {
            'registerService':
            /*
             * Register a Firebase Service.
             *
             * firebase.INTERNAL.registerService()
             *
             * TODO: Implement serviceProperties.
             */
            function (name, createService, serviceProperties, appHook, allowMultipleInstances) {
                // Cannot re-register a service that already exists
                if (factories[name]) {
                    error('duplicate-service', { 'name': name });
                }
                // Capture the service factory for later service instantiation
                factories[name] = createService;
                // Capture the appHook, if passed
                if (appHook) {
                    appHooks[name] = appHook;
                    // Run the **new** app hook on all existing apps
                    getApps().forEach(function (app) {
                        appHook('create', app);
                    });
                }
                // The Service namespace is an accessor function ...
                var serviceNamespace = function () {
                    var appArg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : app();

                    if (typeof appArg[name] !== 'function') {
                        // Invalid argument.
                        // This happens in the following case: firebase.storage('gs:/')
                        error('invalid-app-argument', { 'name': name });
                    }
                    // Forward service instance lookup to the FirebaseApp.
                    return appArg[name]();
                };
                // ... and a container for service-level properties.
                if (serviceProperties !== undefined) {
                    (0, _deep_copy.deepExtend)(serviceNamespace, serviceProperties);
                }
                // Monkey-patch the serviceNamespace onto the firebase namespace
                namespace[name] = serviceNamespace;
                // Patch the FirebaseAppImpl prototype
                FirebaseAppImpl.prototype[name] = function () {
                    var serviceFxn = this._getService.bind(this, name);

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    return serviceFxn.apply(this, allowMultipleInstances ? args : []);
                };
                return serviceNamespace;
            }
            /**
             * Patch the top-level firebase namespace with additional properties.
             *
             * firebase.INTERNAL.extendNamespace()
             */
            ,
            'createFirebaseNamespace': createFirebaseNamespace,
            'extendNamespace': function (props) {
                (0, _deep_copy.deepExtend)(namespace, props);
            },
            'createSubscribe': _subscribe.createSubscribe,
            'ErrorFactory': _errors.ErrorFactory,
            'removeApp':
            /**
             * Called by App.delete() - but before any services associated with the App
             * are deleted.
             */
            function (name) {
                var app = apps_[name];
                callAppHooks(app, 'delete');
                delete apps_[name];
            }
            /**
             * Get the App object for a given name (or DEFAULT).
             */
            ,
            'factories': factories,
            'useAsService': useAsService,
            'Promise': _shared_promise.local.GoogPromise,
            'deepExtend': _deep_copy.deepExtend
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    (0, _deep_copy.patchProperty)(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { 'name': name });
        }
        return apps_[name];
    }
    (0, _deep_copy.patchProperty)(app, 'App', FirebaseAppImpl);function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) {
            return apps_[name];
        });
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        app.options;

        return name;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': 'No Firebase App \'{$name}\' has been created - ' + 'call Firebase App.initializeApp()',
    'bad-app-name': 'Illegal App name: \'{$name}',
    'duplicate-app': 'Firebase App named \'{$name}\' already exists',
    'app-deleted': 'Firebase App named \'{$name}\' already deleted',
    'duplicate-service': 'Firebase service named \'{$name}\' already registered',
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' + 'account is only allowed in a Node.js environment. On client ' + 'devices, you should instead initialize the SDK with an api key and ' + 'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' + 'Firebase App instance.'
};
var appErrors = new _errors.ErrorFactory('app', 'Firebase', errors);
//# sourceMappingURL=firebase_app.js.map


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.1.3
Build: rev-1234895
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createSubscribe = createSubscribe;
exports.async = async;

var _shared_promise = __webpack_require__(40);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LocalPromise = _shared_promise.local.Promise;
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */

var ObserverProxy = function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;

        _classCallCheck(this, ObserverProxy);

        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = LocalPromise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function () {
            executor(_this);
        }).catch(function (e) {
            _this.error(e);
        });
    }

    _createClass(ObserverProxy, [{
        key: 'next',
        value: function next(value) {
            this.forEachObserver(function (observer) {
                observer.next(value);
            });
        }
    }, {
        key: 'error',
        value: function error(_error) {
            this.forEachObserver(function (observer) {
                observer.error(_error);
            });
            this.close(_error);
        }
    }, {
        key: 'complete',
        value: function complete() {
            this.forEachObserver(function (observer) {
                observer.complete();
            });
            this.close();
        }
        /**
         * Subscribe function that can be used to add an Observer to the fan-out list.
         *
         * - We require that no event is sent to a subscriber sychronously to their
         *   call to subscribe().
         */

    }, {
        key: 'subscribe',
        value: function subscribe(nextOrObserver, error, complete) {
            var _this2 = this;

            var observer = void 0;
            if (nextOrObserver === undefined && error === undefined && complete === undefined) {
                throw new Error("Missing Observer.");
            }
            // Assemble an Observer object when passed as callback functions.
            if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
                observer = nextOrObserver;
            } else {
                observer = {
                    next: nextOrObserver,
                    error: error,
                    complete: complete
                };
            }
            if (observer.next === undefined) {
                observer.next = noop;
            }
            if (observer.error === undefined) {
                observer.error = noop;
            }
            if (observer.complete === undefined) {
                observer.complete = noop;
            }
            var unsub = this.unsubscribeOne.bind(this, this.observers.length);
            // Attempt to subscribe to a terminated Observable - we
            // just respond to the Observer with the final error or complete
            // event.
            if (this.finalized) {
                this.task.then(function () {
                    try {
                        if (_this2.finalError) {
                            observer.error(_this2.finalError);
                        } else {
                            observer.complete();
                        }
                    } catch (e) {
                        // nothing
                    }
                });
            }
            this.observers.push(observer);
            return unsub;
        }
        // Unsubscribe is synchronous - we guarantee that no events are sent to
        // any unsubscribed Observer.

    }, {
        key: 'unsubscribeOne',
        value: function unsubscribeOne(i) {
            if (this.observers === undefined || this.observers[i] === undefined) {
                return;
            }
            delete this.observers[i];
            this.observerCount -= 1;
            if (this.observerCount === 0 && this.onNoObservers !== undefined) {
                this.onNoObservers(this);
            }
        }
    }, {
        key: 'forEachObserver',
        value: function forEachObserver(fn) {
            if (this.finalized) {
                // Already closed by previous event....just eat the additional values.
                return;
            }
            // Since sendOne calls asynchronously - there is no chance that
            // this.observers will become undefined.
            for (var i = 0; i < this.observers.length; i++) {
                this.sendOne(i, fn);
            }
        }
        // Call the Observer via one of it's callback function. We are careful to
        // confirm that the observe has not been unsubscribed since this asynchronous
        // function had been queued.

    }, {
        key: 'sendOne',
        value: function sendOne(i, fn) {
            var _this3 = this;

            // Execute the callback asynchronously
            this.task.then(function () {
                if (_this3.observers !== undefined && _this3.observers[i] !== undefined) {
                    try {
                        fn(_this3.observers[i]);
                    } catch (e) {
                        // Ignore exceptions raised in Observers or missing methods of an
                        // Observer.
                        // Log error to console. b/31404806
                        if (typeof console !== "undefined" && console.error) {
                            console.error(e);
                        }
                    }
                }
            });
        }
    }, {
        key: 'close',
        value: function close(err) {
            var _this4 = this;

            if (this.finalized) {
                return;
            }
            this.finalized = true;
            if (err !== undefined) {
                this.finalError = err;
            }
            // Proxy is no longer needed - garbage collect references
            this.task.then(function () {
                _this4.observers = undefined;
                _this4.onNoObservers = undefined;
            });
        }
    }]);

    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */


function async(fn, onError) {
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        LocalPromise.resolve(true).then(function () {
            fn.apply(undefined, args);
        }).catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
        return false;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var method = _step.value;

            if (method in obj && typeof obj[method] === 'function') {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return false;
}
function noop() {
    // do nothing
}
//# sourceMappingURL=subscribe.js.map


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    var args = Array.prototype.slice.call(arr);

    return new Promise(function (resolve, reject) {
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77).setImmediate))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(78);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(31)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.1.3
Build: rev-1234895
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.patchCapture = patchCapture;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error.captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}

var FirebaseError = exports.FirebaseError = function FirebaseError(code, message) {
    _classCallCheck(this, FirebaseError);

    this.code = code;
    this.message = message;

    // We want the stack value, if implemented by Error
    if (captureStackTrace) {
        // Patches this.stack, omitted calls above ErrorFactory#create
        captureStackTrace(this, ErrorFactory.prototype.create);
    } else {
        var err = Error.apply(this, arguments);
        this.name = ERROR_NAME;
        // Make non-enumerable getter for the property.
        Object.defineProperty(this, 'stack', {
            get: function get() {
                return err.stack;
            }
        });
    }
};
// Back-door inheritance


FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;

var ErrorFactory = exports.ErrorFactory = function () {
    function ErrorFactory(service, serviceName, errors) {
        _classCallCheck(this, ErrorFactory);

        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }

    _createClass(ErrorFactory, [{
        key: 'create',
        value: function create(code, data) {
            if (data === undefined) {
                data = {};
            }
            var template = this.errors[code];
            var fullCode = this.service + '/' + code;
            var message = void 0;
            if (template === undefined) {
                message = "Error";
            } else {
                message = template.replace(this.pattern, function (match, key) {
                    var value = data[key];
                    return value !== undefined ? value.toString() : '<' + key + '?>';
                });
            }
            // Service: Error message (service/code).
            message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
            var err = new FirebaseError(fullCode, message);
            // Populate the Error object with message parts for programmatic
            // accesses (e.g., e.file).
            for (var prop in data) {
                if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                    continue;
                }
                err[prop] = data[prop];
            }
            return err;
        }
    }]);

    return ErrorFactory;
}();
//# sourceMappingURL=errors.js.map


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v4.1.3
Build: rev-1234895
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.patchProperty = patchProperty;
/**
* Copyright 2017 Google Inc.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
/**
* Copyright 2017 Google Inc.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            return new Date(source.getTime());
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!

        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}
//# sourceMappingURL=deep_copy.js.map


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v4.1.3
Build: rev-1234895
Terms: https://firebase.google.com/terms/ */

var firebase = __webpack_require__(24);
(function(){(function(){var h,aa=aa||{},k=this,m=function(a){return void 0!==a},p=function(a){return"string"==typeof a},ba=function(a){return"boolean"==typeof a},ca=function(a){return"number"==typeof a},da=function(){},ea=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&
!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},fa=function(a){return null===a},ga=function(a){return"array"==ea(a)},ha=function(a){var b=ea(a);return"array"==b||"object"==b&&"number"==typeof a.length},q=function(a){return"function"==ea(a)},r=function(a){var b=
typeof a;return"object"==b&&null!=a||"function"==b},ia=function(a,b,c){return a.call.apply(a.bind,arguments)},ja=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},t=function(a,b,c){t=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ia:ja;return t.apply(null,
arguments)},ka=function(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}},la=Date.now||function(){return+new Date},u=function(a,b){function c(){}c.prototype=b.prototype;a.Nc=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.dg=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};var v=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,v);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};u(v,Error);v.prototype.name="CustomError";var ma=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")},na=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},va=function(a){if(!oa.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(pa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(qa,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(ra,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(sa,"&quot;"));-1!=a.indexOf("'")&&
(a=a.replace(ta,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(ua,"&#0;"));return a},pa=/&/g,qa=/</g,ra=/>/g,sa=/"/g,ta=/'/g,ua=/\x00/g,oa=/[\x00&<>"']/,w=function(a,b){return-1!=a.indexOf(b)},wa=function(a,b){return a<b?-1:a>b?1:0};var xa=function(a,b){b.unshift(a);v.call(this,ma.apply(null,b));b.shift()};u(xa,v);xa.prototype.name="AssertionError";
var ya=function(a,b,c,d){var e="Assertion failed";if(c){e+=": "+c;var f=d}else a&&(e+=": "+a,f=b);throw new xa(""+e,f||[]);},x=function(a,b,c){a||ya("",null,b,Array.prototype.slice.call(arguments,2))},za=function(a,b){throw new xa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},Aa=function(a,b,c){ca(a)||ya("Expected number but got %s: %s.",[ea(a),a],b,Array.prototype.slice.call(arguments,2));return a},Ba=function(a,b,c){p(a)||ya("Expected string but got %s: %s.",[ea(a),a],b,Array.prototype.slice.call(arguments,
2))},Ca=function(a,b,c){q(a)||ya("Expected function but got %s: %s.",[ea(a),a],b,Array.prototype.slice.call(arguments,2))};var Ea=function(){this.Mc="";this.He=Da};Ea.prototype.Jb=!0;Ea.prototype.Gb=function(){return this.Mc};Ea.prototype.toString=function(){return"Const{"+this.Mc+"}"};var Fa=function(a){if(a instanceof Ea&&a.constructor===Ea&&a.He===Da)return a.Mc;za("expected object of type Const, got '"+a+"'");return"type_error:Const"},Da={},Ga=function(a){var b=new Ea;b.Mc=a;return b};Ga("");var Ia=function(){this.Fc="";this.Ie=Ha};Ia.prototype.Jb=!0;Ia.prototype.Gb=function(){return this.Fc};Ia.prototype.toString=function(){return"TrustedResourceUrl{"+this.Fc+"}"};
var Ja=function(a){if(a instanceof Ia&&a.constructor===Ia&&a.Ie===Ha)return a.Fc;za("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ea(a));return"type_error:TrustedResourceUrl"},La=function(a,b){a=Ka(a,b);b=new Ia;b.Fc=a;return b},Ka=function(a,b){var c=Fa(a);if(!Ma.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);return c.replace(Na,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+
JSON.stringify(b));a=b[e];return a instanceof Ea?Fa(a):encodeURIComponent(String(a))})},Na=/%{(\w+)}/g,Ma=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank(#|$)/i,Ha={};var Oa=Array.prototype.indexOf?function(a,b,c){x(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(p(a))return p(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},y=Array.prototype.forEach?function(a,b,c){x(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},Pa=function(a,b){for(var c=p(a)?
a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)},Qa=Array.prototype.map?function(a,b,c){x(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=p(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Ra=Array.prototype.some?function(a,b,c){x(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1},
Ta=function(a){a:{var b=Sa;for(var c=a.length,d=p(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:p(a)?a.charAt(b):a[b]},Ua=function(a,b){return 0<=Oa(a,b)},Wa=function(a,b){b=Oa(a,b);var c;(c=0<=b)&&Va(a,b);return c},Va=function(a,b){x(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length},Xa=function(a,b){var c=0;Pa(a,function(d,e){b.call(void 0,d,e,a)&&Va(a,e)&&c++})},Ya=function(a){return Array.prototype.concat.apply([],arguments)},
Za=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var $a=function(a){return Qa(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var ab;a:{var bb=k.navigator;if(bb){var cb=bb.userAgent;if(cb){ab=cb;break a}}ab=""}var z=function(a){return w(ab,a)};var db=function(a,b){for(var c in a)b.call(void 0,a[c],c,a)},eb=function(a,b){for(var c in a)if(b.call(void 0,a[c],c,a))return!0;return!1},fb=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b},gb=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b},hb=function(a){for(var b in a)return!1;return!0},ib=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0},jb=function(a){var b={},c;for(c in a)b[c]=a[c];return b},kb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
lb=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<kb.length;f++)c=kb[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};var mb=function(a){mb[" "](a);return a};mb[" "]=da;var ob=function(a,b){var c=nb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var qb=z("Opera"),A=z("Trident")||z("MSIE"),rb=z("Edge"),sb=rb||A,tb=z("Gecko")&&!(w(ab.toLowerCase(),"webkit")&&!z("Edge"))&&!(z("Trident")||z("MSIE"))&&!z("Edge"),ub=w(ab.toLowerCase(),"webkit")&&!z("Edge"),vb=function(){var a=k.document;return a?a.documentMode:void 0},wb;
a:{var xb="",yb=function(){var a=ab;if(tb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(rb)return/Edge\/([\d\.]+)/.exec(a);if(A)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(ub)return/WebKit\/(\S+)/.exec(a);if(qb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();yb&&(xb=yb?yb[1]:"");if(A){var zb=vb();if(null!=zb&&zb>parseFloat(xb)){wb=String(zb);break a}}wb=xb}
var Ab=wb,nb={},B=function(a){return ob(a,function(){for(var b=0,c=na(String(Ab)).split("."),d=na(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",l=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];l=/(\d*)(\D*)(.*)/.exec(l)||["","","",""];if(0==g[0].length&&0==l[0].length)break;b=wa(0==g[1].length?0:parseInt(g[1],10),0==l[1].length?0:parseInt(l[1],10))||wa(0==g[2].length,0==l[2].length)||wa(g[2],l[2]);g=g[3];l=l[3]}while(0==b)}return 0<=b})},Bb;var Cb=k.document;
Bb=Cb&&A?vb()||("CSS1Compat"==Cb.compatMode?parseInt(Ab,10):5):void 0;var Db=null,Eb=null,Gb=function(a){var b="";Fb(a,function(a){b+=String.fromCharCode(a)});return b},Fb=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=Eb[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}Hb();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),l=c(64);if(64===l&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=l&&b(g<<6&192|l))}},Hb=function(){if(!Db){Db={};Eb={};for(var a=0;65>a;a++)Db[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),
Eb[Db[a]]=a,62<=a&&(Eb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};var Ib=function(){this.Fa=-1};var Lb=function(a,b){this.Fa=64;this.lc=k.Uint8Array?new Uint8Array(this.Fa):Array(this.Fa);this.Rc=this.kb=0;this.i=[];this.wf=a;this.ge=b;this.Xf=k.Int32Array?new Int32Array(64):Array(64);m(Jb)||(Jb=k.Int32Array?new Int32Array(Kb):Kb);this.reset()},Jb;u(Lb,Ib);for(var Mb=[],Nb=0;63>Nb;Nb++)Mb[Nb]=0;var Ob=Ya(128,Mb);Lb.prototype.reset=function(){this.Rc=this.kb=0;this.i=k.Int32Array?new Int32Array(this.ge):Za(this.ge)};
var Pb=function(a){var b=a.lc;x(b.length==a.Fa);for(var c=a.Xf,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){d=c[b-15]|0;e=c[b-2]|0;e=(e>>>17|e<<15)^(e>>>19|e<<13)^e>>>10;var f=(c[b-16]|0)+((d>>>7|d<<25)^(d>>>18|d<<14)^d>>>3)|0;var g=(c[b-7]|0)+e|0;c[b]=f+g|0}var d=a.i[0]|0,e=a.i[1]|0,l=a.i[2]|0,n=a.i[3]|0,C=a.i[4]|0,pb=a.i[5]|0,Xb=a.i[6]|0;f=a.i[7]|0;for(b=0;64>b;b++){var Wh=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&l^e&l)|0;g=C&pb^~C&Xb;f=f+
((C>>>6|C<<26)^(C>>>11|C<<21)^(C>>>25|C<<7))|0;g=g+(Jb[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=Xb;Xb=pb;pb=C;C=n+g|0;n=l;l=e;e=d;d=g+Wh|0}a.i[0]=a.i[0]+d|0;a.i[1]=a.i[1]+e|0;a.i[2]=a.i[2]+l|0;a.i[3]=a.i[3]+n|0;a.i[4]=a.i[4]+C|0;a.i[5]=a.i[5]+pb|0;a.i[6]=a.i[6]+Xb|0;a.i[7]=a.i[7]+f|0};
Lb.prototype.update=function(a,b){m(b)||(b=a.length);var c=0,d=this.kb;if(p(a))for(;c<b;)this.lc[d++]=a.charCodeAt(c++),d==this.Fa&&(Pb(this),d=0);else if(ha(a))for(;c<b;){var e=a[c++];if(!("number"==typeof e&&0<=e&&255>=e&&e==(e|0)))throw Error("message must be a byte array");this.lc[d++]=e;d==this.Fa&&(Pb(this),d=0)}else throw Error("message must be string or array");this.kb=d;this.Rc+=b};
Lb.prototype.digest=function(){var a=[],b=8*this.Rc;56>this.kb?this.update(Ob,56-this.kb):this.update(Ob,this.Fa-(this.kb-56));for(var c=63;56<=c;c--)this.lc[c]=b&255,b/=256;Pb(this);for(c=b=0;c<this.wf;c++)for(var d=24;0<=d;d-=8)a[b++]=this.i[c]>>d&255;return a};
var Kb=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var Rb=function(){Lb.call(this,8,Qb)};u(Rb,Lb);var Qb=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];var Sb=function(){this.Ia=this.Ia;this.Cc=this.Cc};Sb.prototype.Ia=!1;Sb.prototype.isDisposed=function(){return this.Ia};Sb.prototype.hb=function(){if(this.Cc)for(;this.Cc.length;)this.Cc.shift()()};var Tb=!A||9<=Number(Bb),Ub=A&&!B("9");!ub||B("528");tb&&B("1.9b")||A&&B("8")||qb&&B("9.5")||ub&&B("528");tb&&!B("8")||A&&B("9");var Vb=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",null,b);k.removeEventListener("test",null,b);return a}();var Wb=function(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.Ta=!1;this.re=!0};Wb.prototype.stopPropagation=function(){this.Ta=!0};Wb.prototype.preventDefault=function(){this.defaultPrevented=!0;this.re=!1};var Yb=function(a,b){Wb.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.la=this.state=null;a&&this.init(a,b)};u(Yb,Wb);
Yb.prototype.init=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(tb){a:{try{mb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=ub||void 0!==a.offsetX?a.offsetX:a.layerX,this.offsetY=ub||void 0!==a.offsetY?a.offsetY:a.layerY,this.clientX=void 0!==a.clientX?a.clientX:a.pageX,
this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.state=a.state;this.la=a;a.defaultPrevented&&
this.preventDefault()};Yb.prototype.stopPropagation=function(){Yb.Nc.stopPropagation.call(this);this.la.stopPropagation?this.la.stopPropagation():this.la.cancelBubble=!0};Yb.prototype.preventDefault=function(){Yb.Nc.preventDefault.call(this);var a=this.la;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Ub)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Yb.prototype.af=function(){return this.la};var Zb="closure_listenable_"+(1E6*Math.random()|0),$b=0;var ac=function(a,b,c,d,e){this.listener=a;this.Gc=null;this.src=b;this.type=c;this.capture=!!d;this.qc=e;this.key=++$b;this.tb=this.kc=!1},bc=function(a){a.tb=!0;a.listener=null;a.Gc=null;a.src=null;a.qc=null};var cc=function(a){this.src=a;this.I={};this.fc=0};cc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.I[f];a||(a=this.I[f]=[],this.fc++);var g=dc(a,b,d,e);-1<g?(b=a[g],c||(b.kc=!1)):(b=new ac(b,this.src,f,!!d,e),b.kc=c,a.push(b));return b};cc.prototype.remove=function(a,b,c,d){a=a.toString();if(!(a in this.I))return!1;var e=this.I[a];b=dc(e,b,c,d);return-1<b?(bc(e[b]),Va(e,b),0==e.length&&(delete this.I[a],this.fc--),!0):!1};
var ec=function(a,b){var c=b.type;c in a.I&&Wa(a.I[c],b)&&(bc(b),0==a.I[c].length&&(delete a.I[c],a.fc--))};cc.prototype.gd=function(a,b,c,d){a=this.I[a.toString()];var e=-1;a&&(e=dc(a,b,c,d));return-1<e?a[e]:null};cc.prototype.hasListener=function(a,b){var c=m(a),d=c?a.toString():"",e=m(b);return eb(this.I,function(a){for(var f=0;f<a.length;++f)if(!(c&&a[f].type!=d||e&&a[f].capture!=b))return!0;return!1})};
var dc=function(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.tb&&f.listener==b&&f.capture==!!c&&f.qc==d)return e}return-1};var fc="closure_lm_"+(1E6*Math.random()|0),gc={},hc=0,jc=function(a,b,c,d,e){if(d&&d.once)ic(a,b,c,d,e);else if(ga(b))for(var f=0;f<b.length;f++)jc(a,b[f],c,d,e);else c=kc(c),a&&a[Zb]?a.listen(b,c,r(d)?!!d.capture:!!d,e):lc(a,b,c,!1,d,e)},lc=function(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=r(e)?!!e.capture:!!e,l=mc(a);l||(a[fc]=l=new cc(a));c=l.add(b,c,d,g,f);if(!c.Gc){d=nc();c.Gc=d;d.src=a;d.listener=c;if(a.addEventListener)Vb||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),
d,e);else if(a.attachEvent)a.attachEvent(oc(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");hc++}},nc=function(){var a=pc,b=Tb?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b},ic=function(a,b,c,d,e){if(ga(b))for(var f=0;f<b.length;f++)ic(a,b[f],c,d,e);else c=kc(c),a&&a[Zb]?qc(a,b,c,r(d)?!!d.capture:!!d,e):lc(a,b,c,!0,d,e)},rc=function(a,b,c,d,e){if(ga(b))for(var f=0;f<b.length;f++)rc(a,b[f],c,d,
e);else d=r(d)?!!d.capture:!!d,c=kc(c),a&&a[Zb]?a.da.remove(String(b),c,d,e):a&&(a=mc(a))&&(b=a.gd(b,c,d,e))&&sc(b)},sc=function(a){if(!ca(a)&&a&&!a.tb){var b=a.src;if(b&&b[Zb])ec(b.da,a);else{var c=a.type,d=a.Gc;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent(oc(c),d);hc--;(c=mc(b))?(ec(c,a),0==c.fc&&(c.src=null,b[fc]=null)):bc(a)}}},oc=function(a){return a in gc?gc[a]:gc[a]="on"+a},uc=function(a,b,c,d){var e=!0;if(a=mc(a))if(b=a.I[b.toString()])for(b=b.concat(),
a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.tb&&(f=tc(f,d),e=e&&!1!==f)}return e},tc=function(a,b){var c=a.listener,d=a.qc||a.src;a.kc&&sc(a);return c.call(d,b)},pc=function(a,b){if(a.tb)return!0;if(!Tb){if(!b)a:{b=["window","event"];for(var c=k,d;d=b.shift();)if(null!=c[d])c=c[d];else{b=null;break a}b=c}d=b;b=new Yb(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=
b.currentTarget;e;e=e.parentNode)d.push(e);for(var e=a.type,f=d.length-1;!b.Ta&&0<=f;f--)b.currentTarget=d[f],a=uc(d[f],e,!0,b),c=c&&a;for(f=0;!b.Ta&&f<d.length;f++)b.currentTarget=d[f],a=uc(d[f],e,!1,b),c=c&&a}return c}return tc(a,new Yb(b,this))},mc=function(a){a=a[fc];return a instanceof cc?a:null},vc="__closure_events_fn_"+(1E9*Math.random()>>>0),kc=function(a){x(a,"Listener can not be null.");if(q(a))return a;x(a.handleEvent,"An object listener must have handleEvent method.");a[vc]||(a[vc]=function(b){return a.handleEvent(b)});
return a[vc]};var wc=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var yc=function(){this.ta="";this.Ge=xc};yc.prototype.Jb=!0;yc.prototype.Gb=function(){return this.ta};yc.prototype.toString=function(){return"SafeUrl{"+this.ta+"}"};
var zc=function(a){if(a instanceof yc&&a.constructor===yc&&a.Ge===xc)return a.ta;za("expected object of type SafeUrl, got '"+a+"' of type "+ea(a));return"type_error:SafeUrl"},Ac=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i,Cc=function(a){if(a instanceof yc)return a;a=a.Jb?a.Gb():String(a);Ac.test(a)||(a="about:invalid#zClosurez");return Bc(a)},xc={},Bc=function(a){var b=new yc;b.ta=a;return b};Bc("about:blank");var Fc=function(a){var b=[];Dc(new Ec,a,b);return b.join("")},Ec=function(){this.Hc=void 0},Dc=function(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ga(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),e=d[f],Dc(a,a.Hc?a.Hc.call(d,String(f),e):e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");f="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(f),
Gc(d,c),c.push(":"),Dc(a,a.Hc?a.Hc.call(b,d,e):e,c),f=","));c.push("}");return}}switch(typeof b){case "string":Gc(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}},Hc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ic=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g,
Gc=function(a,b){b.push('"',a.replace(Ic,function(a){var b=Hc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Hc[a]=b);return b}),'"')};var Jc=function(){};Jc.prototype.Nd=null;var Kc=function(a){return a.Nd||(a.Nd=a.nd())};var Lc,Mc=function(){};u(Mc,Jc);Mc.prototype.mc=function(){var a=Nc(this);return a?new ActiveXObject(a):new XMLHttpRequest};Mc.prototype.nd=function(){var a={};Nc(this)&&(a[0]=!0,a[1]=!0);return a};
var Nc=function(a){if(!a.fe&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.fe=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.fe};Lc=new Mc;var Oc=function(){};u(Oc,Jc);Oc.prototype.mc=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Pc;throw Error("Unsupported browser");};Oc.prototype.nd=function(){return{}};
var Pc=function(){this.ja=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.ja.onload=t(this.df,this);this.ja.onerror=t(this.be,this);this.ja.onprogress=t(this.ef,this);this.ja.ontimeout=t(this.ff,this)};h=Pc.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.ja.open(a,b)};
h.send=function(a){if(a)if("string"==typeof a)this.ja.send(a);else throw Error("Only string data is supported");else this.ja.send()};h.abort=function(){this.ja.abort()};h.setRequestHeader=function(){};h.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.ja.contentType:""};h.df=function(){this.status=200;this.responseText=this.ja.responseText;Qc(this,4)};h.be=function(){this.status=500;this.responseText="";Qc(this,4)};h.ff=function(){this.be()};
h.ef=function(){this.status=200;Qc(this,1)};var Qc=function(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()};Pc.prototype.getAllResponseHeaders=function(){return"content-type: "+this.ja.contentType};var Rc=function(a,b,c){this.sf=c;this.Qe=a;this.Hf=b;this.Bc=0;this.rc=null};Rc.prototype.get=function(){if(0<this.Bc){this.Bc--;var a=this.rc;this.rc=a.next;a.next=null}else a=this.Qe();return a};Rc.prototype.put=function(a){this.Hf(a);this.Bc<this.sf&&(this.Bc++,a.next=this.rc,this.rc=a)};var Sc=function(a){k.setTimeout(function(){throw a;},0)},Tc,Uc=function(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!z("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,
a=t(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!z("Trident")&&!z("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(m(c.next)){c=c.next;var a=c.Qd;c.Qd=null;a()}};return function(a){d.next={Qd:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?
function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};var Vc=function(){this.Wc=this.cb=null},Xc=new Rc(function(){return new Wc},function(a){a.reset()},100);Vc.prototype.add=function(a,b){var c=Xc.get();c.set(a,b);this.Wc?this.Wc.next=c:(x(!this.cb),this.cb=c);this.Wc=c};Vc.prototype.remove=function(){var a=null;this.cb&&(a=this.cb,this.cb=this.cb.next,this.cb||(this.Wc=null),a.next=null);return a};var Wc=function(){this.next=this.scope=this.fd=null};Wc.prototype.set=function(a,b){this.fd=a;this.scope=b;this.next=null};
Wc.prototype.reset=function(){this.next=this.scope=this.fd=null};var bd=function(a,b){Yc||Zc();$c||(Yc(),$c=!0);ad.add(a,b)},Yc,Zc=function(){if(-1!=String(k.Promise).indexOf("[native code]")){var a=k.Promise.resolve(void 0);Yc=function(){a.then(cd)}}else Yc=function(){var a=cd;!q(k.setImmediate)||k.Window&&k.Window.prototype&&!z("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(Tc||(Tc=Uc()),Tc(a)):k.setImmediate(a)}},$c=!1,ad=new Vc,cd=function(){for(var a;a=ad.remove();){try{a.fd.call(a.scope)}catch(b){Sc(b)}Xc.put(a)}$c=!1};var dd=function(a){return r(a)?a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a):void 0===a?"undefined":null===a?"null":typeof a},ed=function(a){return(a=a&&a.ownerDocument)&&(a.defaultView||a.parentWindow)||window};var fd=!A||9<=Number(Bb);!tb&&!A||A&&9<=Number(Bb)||tb&&B("1.9.1");A&&B("9");var hd=function(){this.ta="";this.Fe=gd};hd.prototype.Jb=!0;hd.prototype.Gb=function(){return this.ta};hd.prototype.toString=function(){return"SafeHtml{"+this.ta+"}"};var id=function(a){if(a instanceof hd&&a.constructor===hd&&a.Fe===gd)return a.ta;za("expected object of type SafeHtml, got '"+a+"' of type "+ea(a));return"type_error:SafeHtml"},gd={};hd.prototype.mf=function(a){this.ta=a;return this};var jd=function(a,b){var c=ed(a);"undefined"!=typeof c.HTMLScriptElement&&"undefined"!=typeof c.Element&&x(a&&(a instanceof c.HTMLScriptElement||!(a instanceof c.Element)),"Argument is not a HTMLScriptElement (or a non-Element mock); got: %s",dd(a));a.src=Ja(b)};var kd=function(a){var b=document;return p(a)?b.getElementById(a):a},md=function(a,b){db(b,function(b,d){b&&b.Jb&&(b=b.Gb());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:ld.hasOwnProperty(d)?a.setAttribute(ld[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})},ld={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",
type:"type",usemap:"useMap",valign:"vAlign",width:"width"},od=function(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!fd&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',va(g.name),'"');if(g.type){f.push(' type="',va(g.type),'"');var l={};lb(l,g);delete l.type;g=l}f.push(">");f=f.join("")}f=e.createElement(f);g&&(p(g)?f.className=g:ga(g)?f.className=g.join(" "):md(f,g));2<d.length&&nd(e,f,d);return f},nd=function(a,b,c){function d(c){c&&b.appendChild(p(c)?a.createTextNode(c):
c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||r(f)&&0<f.nodeType?d(f):y(pd(f)?Za(f):f,d)}},pd=function(a){if(a&&"number"==typeof a.length){if(r(a))return"function"==typeof a.item||"string"==typeof a.item;if(q(a))return"function"==typeof a.item}return!1};var qd=function(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0},rd=function(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};var D=function(a,b){this.X=0;this.va=void 0;this.gb=this.qa=this.u=null;this.pc=this.ed=!1;if(a!=da)try{var c=this;a.call(b,function(a){sd(c,2,a)},function(a){if(!(a instanceof td))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}sd(c,3,a)})}catch(d){sd(this,3,d)}},ud=function(){this.next=this.context=this.mb=this.Qa=this.child=null;this.yb=!1};ud.prototype.reset=function(){this.context=this.mb=this.Qa=this.child=null;this.yb=!1};
var vd=new Rc(function(){return new ud},function(a){a.reset()},100),wd=function(a,b,c){var d=vd.get();d.Qa=a;d.mb=b;d.context=c;return d},E=function(a){if(a instanceof D)return a;var b=new D(da);sd(b,2,a);return b},F=function(a){return new D(function(b,c){c(a)})},yd=function(a,b,c){xd(a,b,c,null)||bd(ka(b,a))},zd=function(a){return new D(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Ze:!0,value:f}:{Ze:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],yd(g,ka(e,f,!0),
ka(e,f,!1));else b(d)})};D.prototype.then=function(a,b,c){null!=a&&Ca(a,"opt_onFulfilled should be a function.");null!=b&&Ca(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return Ad(this,q(a)?a:null,q(b)?b:null,c)};qd(D);var Cd=function(a,b){b=wd(b,b,void 0);b.yb=!0;Bd(a,b);return a};D.prototype.f=function(a,b){return Ad(this,null,a,b)};D.prototype.cancel=function(a){0==this.X&&bd(function(){var b=new td(a);Dd(this,b)},this)};
var Dd=function(a,b){if(0==a.X)if(a.u){var c=a.u;if(c.qa){for(var d=0,e=null,f=null,g=c.qa;g&&(g.yb||(d++,g.child==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(0==c.X&&1==d?Dd(c,b):(f?(d=f,x(c.qa),x(null!=d),d.next==c.gb&&(c.gb=d),d.next=d.next.next):Ed(c),Fd(c,e,3,b)))}a.u=null}else sd(a,3,b)},Bd=function(a,b){a.qa||2!=a.X&&3!=a.X||Gd(a);x(null!=b.Qa);a.gb?a.gb.next=b:a.qa=b;a.gb=b},Ad=function(a,b,c,d){var e=wd(null,null,null);e.child=new D(function(a,g){e.Qa=b?function(c){try{var e=b.call(d,c);a(e)}catch(C){g(C)}}:
a;e.mb=c?function(b){try{var e=c.call(d,b);!m(e)&&b instanceof td?g(b):a(e)}catch(C){g(C)}}:g});e.child.u=a;Bd(a,e);return e.child};D.prototype.Uf=function(a){x(1==this.X);this.X=0;sd(this,2,a)};D.prototype.Vf=function(a){x(1==this.X);this.X=0;sd(this,3,a)};
var sd=function(a,b,c){0==a.X&&(a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself")),a.X=1,xd(c,a.Uf,a.Vf,a)||(a.va=c,a.X=b,a.u=null,Gd(a),3!=b||c instanceof td||Hd(a,c)))},xd=function(a,b,c,d){if(a instanceof D)return null!=b&&Ca(b,"opt_onFulfilled should be a function."),null!=c&&Ca(c,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),Bd(a,wd(b||da,c||null,d)),!0;if(rd(a))return a.then(b,c,d),!0;if(r(a))try{var e=a.then;if(q(e))return Id(a,
e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1},Id=function(a,b,c,d,e){var f=!1,g=function(a){f||(f=!0,c.call(e,a))},l=function(a){f||(f=!0,d.call(e,a))};try{b.call(a,g,l)}catch(n){l(n)}},Gd=function(a){a.ed||(a.ed=!0,bd(a.Ve,a))},Ed=function(a){var b=null;a.qa&&(b=a.qa,a.qa=b.next,b.next=null);a.qa||(a.gb=null);null!=b&&x(null!=b.Qa);return b};D.prototype.Ve=function(){for(var a;a=Ed(this);)Fd(this,a,this.X,this.va);this.ed=!1};
var Fd=function(a,b,c,d){if(3==c&&b.mb&&!b.yb)for(;a&&a.pc;a=a.u)a.pc=!1;if(b.child)b.child.u=null,Jd(b,c,d);else try{b.yb?b.Qa.call(b.context):Jd(b,c,d)}catch(e){Kd.call(null,e)}vd.put(b)},Jd=function(a,b,c){2==b?a.Qa.call(a.context,c):a.mb&&a.mb.call(a.context,c)},Hd=function(a,b){a.pc=!0;bd(function(){a.pc&&Kd.call(null,b)})},Kd=Sc,td=function(a){v.call(this,a)};u(td,v);td.prototype.name="cancel";
var Ld=function(a,b){this.Jc=[];this.me=a;this.Ud=b||null;this.Hb=this.ib=!1;this.va=void 0;this.Gd=this.Ld=this.$c=!1;this.Sc=0;this.u=null;this.ad=0};Ld.prototype.cancel=function(a){if(this.ib)this.va instanceof Ld&&this.va.cancel();else{if(this.u){var b=this.u;delete this.u;a?b.cancel(a):(b.ad--,0>=b.ad&&b.cancel())}this.me?this.me.call(this.Ud,this):this.Gd=!0;this.ib||Md(this,new Nd)}};Ld.prototype.Sd=function(a,b){this.$c=!1;Od(this,a,b)};
var Od=function(a,b,c){a.ib=!0;a.va=c;a.Hb=!b;Pd(a)},Rd=function(a){if(a.ib){if(!a.Gd)throw new Qd;a.Gd=!1}};Ld.prototype.callback=function(a){Rd(this);Sd(a);Od(this,!0,a)};var Md=function(a,b){Rd(a);Sd(b);Od(a,!1,b)},Sd=function(a){x(!(a instanceof Ld),"An execution sequence may not be initiated with a blocking Deferred.")},Ud=function(a,b){Td(a,null,b,void 0)},Td=function(a,b,c,d){x(!a.Ld,"Blocking Deferreds can not be re-used");a.Jc.push([b,c,d]);a.ib&&Pd(a)};
Ld.prototype.then=function(a,b,c){var d,e,f=new D(function(a,b){d=a;e=b});Td(this,d,function(a){a instanceof Nd?f.cancel():e(a)});return f.then(a,b,c)};qd(Ld);
var Vd=function(a){return Ra(a.Jc,function(a){return q(a[1])})},Pd=function(a){if(a.Sc&&a.ib&&Vd(a)){var b=a.Sc,c=Wd[b];c&&(k.clearTimeout(c.Ib),delete Wd[b]);a.Sc=0}a.u&&(a.u.ad--,delete a.u);for(var b=a.va,d=c=!1;a.Jc.length&&!a.$c;){var e=a.Jc.shift(),f=e[0],g=e[1],e=e[2];if(f=a.Hb?g:f)try{var l=f.call(e||a.Ud,b);m(l)&&(a.Hb=a.Hb&&(l==b||l instanceof Error),a.va=b=l);if(rd(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.$c=!0}catch(n){b=n,a.Hb=!0,Vd(a)||(c=!0)}}a.va=b;d&&(l=t(a.Sd,
a,!0),d=t(a.Sd,a,!1),b instanceof Ld?(Td(b,l,d),b.Ld=!0):b.then(l,d));c&&(b=new Xd(b),Wd[b.Ib]=b,a.Sc=b.Ib)},Qd=function(){v.call(this)};u(Qd,v);Qd.prototype.message="Deferred has already fired";Qd.prototype.name="AlreadyCalledError";var Nd=function(){v.call(this)};u(Nd,v);Nd.prototype.message="Deferred was canceled";Nd.prototype.name="CanceledError";var Xd=function(a){this.Ib=k.setTimeout(t(this.Tf,this),0);this.Y=a};
Xd.prototype.Tf=function(){x(Wd[this.Ib],"Cannot throw an error that is not scheduled.");delete Wd[this.Ib];throw this.Y;};var Wd={};var be=function(a){var b={},c=b.document||document,d=Ja(a),e=document.createElement("SCRIPT"),f={se:e,ec:void 0},g=new Ld(Yd,f),l=null,n=null!=b.timeout?b.timeout:5E3;0<n&&(l=window.setTimeout(function(){Zd(e,!0);Md(g,new $d(1,"Timeout reached for loading script "+d))},n),f.ec=l);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Zd(e,b.eg||!1,l),g.callback(null))};e.onerror=function(){Zd(e,!0,l);Md(g,new $d(0,"Error while loading script "+d))};
f=b.attributes||{};lb(f,{type:"text/javascript",charset:"UTF-8"});md(e,f);jd(e,a);ae(c).appendChild(e);return g},ae=function(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement},Yd=function(){if(this&&this.se){var a=this.se;a&&"SCRIPT"==a.tagName&&Zd(a,!0,this.ec)}},Zd=function(a,b,c){null!=c&&k.clearTimeout(c);a.onload=da;a.onerror=da;a.onreadystatechange=da;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)},$d=function(a,
b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);v.call(this,c);this.code=a};u($d,v);var ce=function(a,b,c,d,e){this.reset(a,b,c,d,e)};ce.prototype.Wd=null;var de=0;ce.prototype.reset=function(a,b,c,d,e){"number"==typeof e||de++;d||la();this.Ob=a;this.vf=b;delete this.Wd};ce.prototype.ue=function(a){this.Ob=a};var ee=function(a){this.ke=a;this.ce=this.bd=this.Ob=this.u=null},fe=function(a,b){this.name=a;this.value=b};fe.prototype.toString=function(){return this.name};var ge=new fe("SEVERE",1E3),he=new fe("INFO",800),ie=new fe("CONFIG",700),je=new fe("FINE",500);ee.prototype.getName=function(){return this.ke};ee.prototype.getParent=function(){return this.u};ee.prototype.ue=function(a){this.Ob=a};var ke=function(a){if(a.Ob)return a.Ob;if(a.u)return ke(a.u);za("Root logger has no level set.");return null};
ee.prototype.log=function(a,b,c){if(a.value>=ke(this).value)for(q(b)&&(b=b()),a=new ce(a,String(b),this.ke),c&&(a.Wd=c),c="log:"+a.vf,k.console&&(k.console.timeStamp?k.console.timeStamp(c):k.console.markTimeline&&k.console.markTimeline(c)),k.msWriteProfilerMark&&k.msWriteProfilerMark(c),c=this;c;){var d=c,e=a;if(d.ce)for(var f=0;b=d.ce[f];f++)b(e);c=c.getParent()}};ee.prototype.info=function(a,b){this.log(he,a,b)};ee.prototype.config=function(a,b){this.log(ie,a,b)};
var le={},me=null,ne=function(a){me||(me=new ee(""),le[""]=me,me.ue(ie));var b;if(!(b=le[a])){b=new ee(a);var c=a.lastIndexOf("."),d=a.substr(c+1),c=ne(a.substr(0,c));c.bd||(c.bd={});c.bd[d]=b;b.u=c;le[a]=b}return b};var oe=function(){Sb.call(this);this.da=new cc(this);this.Ke=this;this.sd=null};u(oe,Sb);oe.prototype[Zb]=!0;h=oe.prototype;h.addEventListener=function(a,b,c,d){jc(this,a,b,c,d)};h.removeEventListener=function(a,b,c,d){rc(this,a,b,c,d)};
h.dispatchEvent=function(a){pe(this);var b=this.sd;if(b){var c=[];for(var d=1;b;b=b.sd)c.push(b),x(1E3>++d,"infinite loop")}b=this.Ke;d=a.type||a;if(p(a))a=new Wb(a,b);else if(a instanceof Wb)a.target=a.target||b;else{var e=a;a=new Wb(d,b);lb(a,e)}var e=!0;if(c)for(var f=c.length-1;!a.Ta&&0<=f;f--){var g=a.currentTarget=c[f];e=qe(g,d,!0,a)&&e}a.Ta||(g=a.currentTarget=b,e=qe(g,d,!0,a)&&e,a.Ta||(e=qe(g,d,!1,a)&&e));if(c)for(f=0;!a.Ta&&f<c.length;f++)g=a.currentTarget=c[f],e=qe(g,d,!1,a)&&e;return e};
h.hb=function(){oe.Nc.hb.call(this);if(this.da){var a=this.da,b=0,c;for(c in a.I){for(var d=a.I[c],e=0;e<d.length;e++)++b,bc(d[e]);delete a.I[c];a.fc--}}this.sd=null};h.listen=function(a,b,c,d){pe(this);return this.da.add(String(a),b,!1,c,d)};
var qc=function(a,b,c,d,e){a.da.add(String(b),c,!0,d,e)},qe=function(a,b,c,d){b=a.da.I[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.tb&&g.capture==c){var l=g.listener,n=g.qc||g.src;g.kc&&ec(a.da,g);e=!1!==l.call(n,d)&&e}}return e&&0!=d.re};oe.prototype.gd=function(a,b,c,d){return this.da.gd(String(a),b,c,d)};oe.prototype.hasListener=function(a,b){return this.da.hasListener(m(a)?String(a):void 0,b)};var pe=function(a){x(a.da,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")};var re="StopIteration"in k?k.StopIteration:{message:"StopIteration",stack:""},se=function(){};se.prototype.next=function(){throw re;};se.prototype.Je=function(){return this};var G=function(a,b){a&&a.log(je,b,void 0)};var te=function(a,b){this.fa={};this.A=[];this.bb=this.o=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)};h=te.prototype;h.ea=function(){ue(this);for(var a=[],b=0;b<this.A.length;b++)a.push(this.fa[this.A[b]]);return a};h.ra=function(){ue(this);return this.A.concat()};h.Ab=function(a){return ve(this.fa,a)};h.clear=function(){this.fa={};this.bb=this.o=this.A.length=0};
h.remove=function(a){return ve(this.fa,a)?(delete this.fa[a],this.o--,this.bb++,this.A.length>2*this.o&&ue(this),!0):!1};var ue=function(a){var b,c;if(a.o!=a.A.length){for(b=c=0;c<a.A.length;){var d=a.A[c];ve(a.fa,d)&&(a.A[b++]=d);c++}a.A.length=b}if(a.o!=a.A.length){var e={};for(b=c=0;c<a.A.length;)d=a.A[c],ve(e,d)||(a.A[b++]=d,e[d]=1),c++;a.A.length=b}};h=te.prototype;h.get=function(a,b){return ve(this.fa,a)?this.fa[a]:b};
h.set=function(a,b){ve(this.fa,a)||(this.o++,this.A.push(a),this.bb++);this.fa[a]=b};h.addAll=function(a){if(a instanceof te){var b=a.ra();a=a.ea()}else b=gb(a),a=fb(a);for(var c=0;c<b.length;c++)this.set(b[c],a[c])};h.forEach=function(a,b){for(var c=this.ra(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.clone=function(){return new te(this)};
h.Je=function(a){ue(this);var b=0,c=this.bb,d=this,e=new se;e.next=function(){if(c!=d.bb)throw Error("The map has changed since the iterator was created");if(b>=d.A.length)throw re;var e=d.A[b++];return a?e:d.fa[e]};return e};var ve=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var we=function(a){if(a.ea&&"function"==typeof a.ea)return a.ea();if(p(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return fb(a)},xe=function(a){if(a.ra&&"function"==typeof a.ra)return a.ra();if(!a.ea||"function"!=typeof a.ea){if(ha(a)||p(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return gb(a)}},ye=function(a,b,c){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,c);else if(ha(a)||p(a))y(a,b,c);else for(var d=xe(a),e=we(a),f=e.length,
g=0;g<f;g++)b.call(c,e[g],d&&d[g],a)};var ze=function(a,b,c){if(q(a))c&&(a=t(a,c));else if(a&&"function"==typeof a.handleEvent)a=t(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)},Ae=function(a){var b=null;return(new D(function(c,d){b=ze(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).f(function(a){k.clearTimeout(b);throw a;})};var Be=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,Ce=function(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};var H=function(a){oe.call(this);this.headers=new te;this.Yc=a||null;this.ya=!1;this.Xc=this.b=null;this.Nb=this.je=this.yc="";this.Ma=this.ld=this.uc=this.dd=!1;this.ub=0;this.Pc=null;this.Ic="";this.Tc=this.Cf=this.Ee=!1};u(H,oe);var De=H.prototype,Ee=ne("goog.net.XhrIo");De.M=Ee;var Fe=/^https?$/i,Ge=["POST","PUT"];
H.prototype.send=function(a,b,c,d){if(this.b)throw Error("[goog.net.XhrIo] Object is active with another request="+this.yc+"; newUri="+a);b=b?b.toUpperCase():"GET";this.yc=a;this.Nb="";this.je=b;this.dd=!1;this.ya=!0;this.b=this.Yc?this.Yc.mc():Lc.mc();this.Xc=this.Yc?Kc(this.Yc):Kc(Lc);this.b.onreadystatechange=t(this.oe,this);this.Cf&&"onprogress"in this.b&&(this.b.onprogress=t(function(a){this.ne(a,!0)},this),this.b.upload&&(this.b.upload.onprogress=t(this.ne,this)));try{G(this.M,He(this,"Opening Xhr")),
this.ld=!0,this.b.open(b,String(a),!0),this.ld=!1}catch(f){G(this.M,He(this,"Error opening Xhr: "+f.message));this.Y(5,f);return}a=c||"";var e=this.headers.clone();d&&ye(d,function(a,b){e.set(b,a)});d=Ta(e.ra());c=k.FormData&&a instanceof k.FormData;!Ua(Ge,b)||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.b.setRequestHeader(b,a)},this);this.Ic&&(this.b.responseType=this.Ic);"withCredentials"in this.b&&this.b.withCredentials!==this.Ee&&(this.b.withCredentials=
this.Ee);try{Ie(this),0<this.ub&&(this.Tc=Je(this.b),G(this.M,He(this,"Will abort after "+this.ub+"ms if incomplete, xhr2 "+this.Tc)),this.Tc?(this.b.timeout=this.ub,this.b.ontimeout=t(this.ec,this)):this.Pc=ze(this.ec,this.ub,this)),G(this.M,He(this,"Sending request")),this.uc=!0,this.b.send(a),this.uc=!1}catch(f){G(this.M,He(this,"Send error: "+f.message)),this.Y(5,f)}};var Je=function(a){return A&&B(9)&&ca(a.timeout)&&m(a.ontimeout)},Sa=function(a){return"content-type"==a.toLowerCase()};
H.prototype.ec=function(){"undefined"!=typeof aa&&this.b&&(this.Nb="Timed out after "+this.ub+"ms, aborting",G(this.M,He(this,this.Nb)),this.dispatchEvent("timeout"),this.abort(8))};H.prototype.Y=function(a,b){this.ya=!1;this.b&&(this.Ma=!0,this.b.abort(),this.Ma=!1);this.Nb=b;Ke(this);Le(this)};var Ke=function(a){a.dd||(a.dd=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))};
H.prototype.abort=function(){this.b&&this.ya&&(G(this.M,He(this,"Aborting")),this.ya=!1,this.Ma=!0,this.b.abort(),this.Ma=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),Le(this))};H.prototype.hb=function(){this.b&&(this.ya&&(this.ya=!1,this.Ma=!0,this.b.abort(),this.Ma=!1),Le(this,!0));H.Nc.hb.call(this)};H.prototype.oe=function(){this.isDisposed()||(this.ld||this.uc||this.Ma?Me(this):this.yf())};H.prototype.yf=function(){Me(this)};
var Me=function(a){if(a.ya&&"undefined"!=typeof aa)if(a.Xc[1]&&4==Ne(a)&&2==Oe(a))G(a.M,He(a,"Local request error detected and ignored"));else if(a.uc&&4==Ne(a))ze(a.oe,0,a);else if(a.dispatchEvent("readystatechange"),4==Ne(a)){G(a.M,He(a,"Request complete"));a.ya=!1;try{var b=Oe(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.yc).match(Be)[1]||null;if(!f&&k.self&&k.self.location)var g=k.self.location.protocol,
f=g.substr(0,g.length-1);e=!Fe.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var l=2<Ne(a)?a.b.statusText:""}catch(n){G(a.M,"Can not get status: "+n.message),l=""}a.Nb=l+" ["+Oe(a)+"]";Ke(a)}}finally{Le(a)}}};H.prototype.ne=function(a,b){x("progress"===a.type,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Pe(a,"progress"));this.dispatchEvent(Pe(a,b?"downloadprogress":"uploadprogress"))};
var Pe=function(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}},Le=function(a,b){if(a.b){Ie(a);var c=a.b,d=a.Xc[0]?da:null;a.b=null;a.Xc=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.M)&&a.log(ge,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}},Ie=function(a){a.b&&a.Tc&&(a.b.ontimeout=null);ca(a.Pc)&&(k.clearTimeout(a.Pc),a.Pc=null)},Ne=function(a){return a.b?a.b.readyState:0},Oe=function(a){try{return 2<Ne(a)?
a.b.status:-1}catch(b){return-1}},Qe=function(a){try{return a.b?a.b.responseText:""}catch(b){return G(a.M,"Can not get responseText: "+b.message),""}};
H.prototype.getResponse=function(){try{if(!this.b)return null;if("response"in this.b)return this.b.response;switch(this.Ic){case "":case "text":return this.b.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.b)return this.b.mozResponseArrayBuffer}var a=this.M;a&&a.log(ge,"Response type "+this.Ic+" is not supported on this browser",void 0);return null}catch(b){return G(this.M,"Can not get response: "+b.message),null}};
H.prototype.getResponseHeader=function(a){if(this.b&&4==Ne(this))return a=this.b.getResponseHeader(a),null===a?void 0:a};H.prototype.getAllResponseHeaders=function(){return this.b&&4==Ne(this)?this.b.getAllResponseHeaders():""};var He=function(a,b){return b+" ["+a.je+" "+a.yc+" "+Oe(a)+"]"};var Re=function(a,b){this.ka=this.$a=this.ma="";this.ob=null;this.La=this.Aa="";this.$=this.rf=!1;if(a instanceof Re){this.$=m(b)?b:a.$;Se(this,a.ma);var c=a.$a;I(this);this.$a=c;Te(this,a.ka);Ue(this,a.ob);Ve(this,a.Aa);We(this,a.ba.clone());a=a.La;I(this);this.La=a}else a&&(c=String(a).match(Be))?(this.$=!!b,Se(this,c[1]||"",!0),a=c[2]||"",I(this),this.$a=Xe(a),Te(this,c[3]||"",!0),Ue(this,c[4]),Ve(this,c[5]||"",!0),We(this,c[6]||"",!0),a=c[7]||"",I(this),this.La=Xe(a)):(this.$=!!b,this.ba=new Ye(null,
0,this.$))};Re.prototype.toString=function(){var a=[],b=this.ma;b&&a.push(Ze(b,$e,!0),":");var c=this.ka;if(c||"file"==b)a.push("//"),(b=this.$a)&&a.push(Ze(b,$e,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.ob,null!=c&&a.push(":",String(c));if(c=this.Aa)this.ka&&"/"!=c.charAt(0)&&a.push("/"),a.push(Ze(c,"/"==c.charAt(0)?af:bf,!0));(c=this.ba.toString())&&a.push("?",c);(c=this.La)&&a.push("#",Ze(c,cf));return a.join("")};
Re.prototype.resolve=function(a){var b=this.clone(),c=!!a.ma;c?Se(b,a.ma):c=!!a.$a;if(c){var d=a.$a;I(b);b.$a=d}else c=!!a.ka;c?Te(b,a.ka):c=null!=a.ob;d=a.Aa;if(c)Ue(b,a.ob);else if(c=!!a.Aa){if("/"!=d.charAt(0))if(this.ka&&!this.Aa)d="/"+d;else{var e=b.Aa.lastIndexOf("/");-1!=e&&(d=b.Aa.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(w(e,"./")||w(e,"/.")){for(var d=0==e.lastIndexOf("/",0),e=e.split("/"),f=[],g=0;g<e.length;){var l=e[g++];"."==l?d&&g==e.length&&f.push(""):".."==l?((1<f.length||
1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(l),d=!0)}d=f.join("/")}else d=e}c?Ve(b,d):c=""!==a.ba.toString();c?We(b,a.ba.clone()):c=!!a.La;c&&(a=a.La,I(b),b.La=a);return b};Re.prototype.clone=function(){return new Re(this)};
var Se=function(a,b,c){I(a);a.ma=c?Xe(b,!0):b;a.ma&&(a.ma=a.ma.replace(/:$/,""))},Te=function(a,b,c){I(a);a.ka=c?Xe(b,!0):b},Ue=function(a,b){I(a);if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.ob=b}else a.ob=null},Ve=function(a,b,c){I(a);a.Aa=c?Xe(b,!0):b},We=function(a,b,c){I(a);b instanceof Ye?(a.ba=b,a.ba.Ed(a.$)):(c||(b=Ze(b,df)),a.ba=new Ye(b,0,a.$))},J=function(a,b,c){I(a);a.ba.set(b,c)},ef=function(a,b){return a.ba.get(b)};
Re.prototype.removeParameter=function(a){I(this);this.ba.remove(a);return this};var I=function(a){if(a.rf)throw Error("Tried to modify a read-only Uri");};Re.prototype.Ed=function(a){this.$=a;this.ba&&this.ba.Ed(a);return this};
var ff=function(a){return a instanceof Re?a.clone():new Re(a,void 0)},gf=function(a,b){var c=new Re(null,void 0);Se(c,"https");a&&Te(c,a);b&&Ve(c,b);return c},Xe=function(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""},Ze=function(a,b,c){return p(a)?(a=encodeURI(a).replace(b,hf),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null},hf=function(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)},$e=/[#\/\?@]/g,bf=/[\#\?:]/g,af=/[\#\?]/g,df=/[\#\?@]/g,
cf=/#/g,Ye=function(a,b,c){this.o=this.j=null;this.R=a||null;this.$=!!c},jf=function(a){a.j||(a.j=new te,a.o=0,a.R&&Ce(a.R,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))},lf=function(a){var b=xe(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Ye(null,0,void 0);a=we(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];ga(f)?kf(c,e,f):c.add(e,f)}return c};h=Ye.prototype;
h.add=function(a,b){jf(this);this.R=null;a=this.Z(a);var c=this.j.get(a);c||this.j.set(a,c=[]);c.push(b);this.o=Aa(this.o)+1;return this};h.remove=function(a){jf(this);a=this.Z(a);return this.j.Ab(a)?(this.R=null,this.o=Aa(this.o)-this.j.get(a).length,this.j.remove(a)):!1};h.clear=function(){this.j=this.R=null;this.o=0};h.Ab=function(a){jf(this);a=this.Z(a);return this.j.Ab(a)};h.forEach=function(a,b){jf(this);this.j.forEach(function(c,d){y(c,function(c){a.call(b,c,d,this)},this)},this)};
h.ra=function(){jf(this);for(var a=this.j.ea(),b=this.j.ra(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};h.ea=function(a){jf(this);var b=[];if(p(a))this.Ab(a)&&(b=Ya(b,this.j.get(this.Z(a))));else{a=this.j.ea();for(var c=0;c<a.length;c++)b=Ya(b,a[c])}return b};h.set=function(a,b){jf(this);this.R=null;a=this.Z(a);this.Ab(a)&&(this.o=Aa(this.o)-this.j.get(a).length);this.j.set(a,[b]);this.o=Aa(this.o)+1;return this};
h.get=function(a,b){a=a?this.ea(a):[];return 0<a.length?String(a[0]):b};var kf=function(a,b,c){a.remove(b);0<c.length&&(a.R=null,a.j.set(a.Z(b),Za(c)),a.o=Aa(a.o)+c.length)};h=Ye.prototype;h.toString=function(){if(this.R)return this.R;if(!this.j)return"";for(var a=[],b=this.j.ra(),c=0;c<b.length;c++)for(var d=b[c],e=encodeURIComponent(String(d)),d=this.ea(d),f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}return this.R=a.join("&")};
h.clone=function(){var a=new Ye;a.R=this.R;this.j&&(a.j=this.j.clone(),a.o=this.o);return a};h.Z=function(a){a=String(a);this.$&&(a=a.toLowerCase());return a};h.Ed=function(a){a&&!this.$&&(jf(this),this.R=null,this.j.forEach(function(a,c){var b=c.toLowerCase();c!=b&&(this.remove(c),kf(this,b,a))},this));this.$=a};h.extend=function(a){for(var b=0;b<arguments.length;b++)ye(arguments[b],function(a,b){this.add(b,a)},this)};var mf=function(){var a=K();return A&&!!Bb&&11==Bb||/Edge\/\d+/.test(a)},nf=function(){return k.window&&k.window.location.href||""},of=function(a,b){b=b||k.window;var c="about:blank";a&&(c=zc(Cc(a)));b.location.href=c},pf=function(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):ga(a[d])?ib(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<pf(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c},rf=function(){var a=
K();a="Chrome"!=qf(a)?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!A||!Bb||9<Bb},sf=function(a){a=(a||K()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1},tf=function(a){a=a||k.window;try{a.close()}catch(b){}},uf=function(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-
b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=K().toLowerCase();d&&(b.target=d,w(c,"crios/")&&(b.target="_blank"));"Firefox"==qf(K())&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"about:blank";(d=b)||(d={});a=window;b=c instanceof yc?c:Cc("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;
default:e.push(g+"="+(d[g]?1:0))}var g=e.join(",");(z("iPhone")&&!z("iPod")&&!z("iPad")||z("iPad")||z("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),e=ed(g),"undefined"!=typeof e.HTMLAnchorElement&&"undefined"!=typeof e.Location&&"undefined"!=typeof e.Element&&x(g&&(g instanceof e.HTMLAnchorElement||!(g instanceof e.Location||g instanceof e.Element)),"Argument is not a HTMLAnchorElement (or a non-Element mock); got: %s",dd(g)),b=b instanceof yc?b:Cc(b),
g.href=zc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel","noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),d=zc(b),g&&(sb&&w(d,";")&&(d="'"+d.replace(/'/g,"%27")+"'"),g.opener=null,a=Ga("b/12014412, meta tag with sanitized URL"),d='<META HTTP-EQUIV="refresh" content="0; url='+va(d)+'">',Ba(Fa(a),"must provide justification"),x(!/^[\s\xa0]*$/.test(Fa(a)),"must provide non-empty justification"),
g.document.write(id((new hd).mf(d))),g.document.close())):g=a.open(zc(b),c,g);if(g)try{g.focus()}catch(l){}return g},vf=function(a){return new D(function(b){var c=function(){Ae(2E3).then(function(){if(!a||a.closed)b();else return c()})};return c()})},wf=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,xf=function(){var a=null;return(new D(function(b){"complete"==k.document.readyState?b():(a=function(){b()},ic(window,"load",a))})).f(function(b){rc(window,"load",a);throw b;})},zf=function(){return yf(void 0)?
xf().then(function(){return new D(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):F(Error("Cordova must run in an Android or iOS file scheme."))},yf=function(a){a=a||K();return!("file:"!==Af()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))},Bf=function(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}},Cf=function(){return firebase.INTERNAL.hasOwnProperty("reactNative")?
"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"},Df=function(){var a=Cf();return"ReactNative"===a||"Node"===a},qf=function(a){var b=a.toLowerCase();if(w(b,"opera/")||w(b,"opr/")||w(b,"opios/"))return"Opera";if(w(b,"iemobile"))return"IEMobile";if(w(b,"msie")||w(b,"trident/"))return"IE";if(w(b,"edge/"))return"Edge";if(w(b,"firefox/"))return"Firefox";if(w(b,"silk/"))return"Silk";if(w(b,"blackberry"))return"Blackberry";if(w(b,"webos"))return"Webos";if(!w(b,"safari/")||w(b,"chrome/")||
w(b,"crios/")||w(b,"android"))if(!w(b,"chrome/")&&!w(b,"crios/")||w(b,"edge/")){if(w(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&2==a.length)return a[1]}else return"Chrome";else return"Safari";return"Other"},Ef=function(a){var b=Cf();return("Browser"===b?qf(K()):b)+"/JsCore/"+a},K=function(){return k.navigator&&k.navigator.userAgent||""},L=function(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);
return b},Hf=function(){var a;if(a=(Ff()||"chrome-extension:"===Af()||yf())&&!Df())a:{try{var b=k.localStorage,c=Gf();if(b){b.setItem(c,"1");b.removeItem(c);a=mf()?!!k.indexedDB:!0;break a}}catch(d){}a=!1}return a},Ff=function(){return"http:"===Af()||"https:"===Af()},Af=function(){return k.location&&k.location.protocol||null},If=function(a){a=a||K();return sf(a)||"Firefox"==qf(a)?!1:!0},Jf=function(a){return"undefined"===typeof a?null:Fc(a)},Kf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&
null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b},Lf=function(a){if(null!==a)return JSON.parse(a)},Gf=function(a){return a?a:""+Math.floor(1E9*Math.random()).toString()},Mf=function(a){a=a||K();return"Safari"==qf(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0},Nf=function(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null},Of=function(){return k.navigator&&"boolean"===typeof k.navigator.onLine?
k.navigator.onLine:!0},Pf=function(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");this.Qf=a;this.uf=b;a=c||K();d=d||Cf();this.qf=sf(a)||"ReactNative"===d};Pf.prototype.get=function(){return this.qf?this.uf:this.Qf};
var Qf=function(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0},Rf=function(){var a=k.document,b=null;return Qf()||!a?E():(new D(function(c){b=function(){Qf()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).f(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})};var Sf={};var Tf;try{var Uf={};Object.defineProperty(Uf,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Uf,"abcd",{configurable:!0,enumerable:!0,value:2});Tf=2==Uf.abcd}catch(a){Tf=!1}
var M=function(a,b,c){Tf?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c},Vf=function(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&M(a,c,b[c])},Wf=function(a){var b={};Vf(b,a);return b},Xf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b},Yf=function(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0},Zf=function(a){var b=a;if("object"==typeof a&&null!=a){var b=
"length"in a?[]:{},c;for(c in a)M(b,c,Zf(a[c]))}return b};var $f="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),ag=["client_id","response_type","scope","redirect_uri","state"],bg={$f:{Sb:500,Rb:600,providerId:"facebook.com",Ad:ag},ag:{Sb:500,Rb:620,providerId:"github.com",Ad:ag},bg:{Sb:515,Rb:680,providerId:"google.com",Ad:ag},cg:{Sb:485,Rb:705,providerId:"twitter.com",Ad:$f}},cg=function(a){for(var b in bg)if(bg[b].providerId==a)return bg[b];return null};var N=function(a,b){this.code="auth/"+a;this.message=b||dg[a]||""};u(N,Error);N.prototype.G=function(){return{code:this.code,message:this.message}};N.prototype.toJSON=function(){return this.G()};
var eg=function(a){var b=a&&a.code;return b?new N(b.substring(5),a.message):null},dg={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
"invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
"invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.",
"invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
"invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-iframe-start":"An internal error has occurred.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.",
"missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.","network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
"no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The SMS quota for this project has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.",
"user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var O=function(a,b,c,d,e){this.ia=a;this.S=b||null;this.vb=c||null;this.Dd=d||null;this.Y=e||null;if(this.vb||this.Y){if(this.vb&&this.Y)throw new N("invalid-auth-event");if(this.vb&&!this.Dd)throw new N("invalid-auth-event");}else throw new N("invalid-auth-event");};O.prototype.oc=function(){return this.Dd};O.prototype.getError=function(){return this.Y};O.prototype.G=function(){return{type:this.ia,eventId:this.S,urlResponse:this.vb,sessionId:this.Dd,error:this.Y&&this.Y.G()}};
var fg=function(a){a=a||{};return a.type?new O(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&eg(a.error)):null};var gg=function(a){var b="unauthorized-domain",c=void 0,d=ff(a);a=d.ka;d=d.ma;"chrome-extension"==d?c=ma("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=ma("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b=
"operation-not-supported-in-this-environment";N.call(this,b,c)};u(gg,N);var hg=function(a){this.tf=a.sub;la();this.Db=a.email||null;this.Df=a.provider_id||null;this.Me=!!a.is_anonymous||"anonymous"==this.Df};hg.prototype.getEmail=function(){return this.Db};hg.prototype.isAnonymous=function(){return this.Me};var ig=function(a,b){return a.then(function(a){if(a.idToken){a:{var c=a.idToken.split(".");if(3==c.length){for(var c=c[1],e=(4-c.length%4)%4,f=0;f<e;f++)c+=".";try{var g=JSON.parse(Gb(c));if(g.sub&&g.iss&&g.aud&&g.exp){var l=new hg(g);break a}}catch(n){}}l=null}if(!l||b!=l.tf)throw new N("user-mismatch");return a}throw new N("user-mismatch");}).f(function(a){throw a&&a.code&&"auth/user-not-found"==a.code?new N("user-mismatch"):a;})},jg=function(a,b){if(b.idToken||b.accessToken)b.idToken&&M(this,"idToken",
b.idToken),b.accessToken&&M(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)M(this,"accessToken",b.oauthToken),M(this,"secret",b.oauthTokenSecret);else throw new N("internal-error","failed to construct a credential");M(this,"providerId",a)};jg.prototype.Fb=function(a){return kg(a,lg(this))};jg.prototype.zc=function(a,b){var c=lg(this);c.idToken=b;return mg(a,c)};jg.prototype.pd=function(a,b){var c=lg(this);return ig(ng(a,c),b)};
var lg=function(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:lf(b).toString(),requestUri:"http://localhost"}};jg.prototype.G=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};
var og=function(a,b){this.Gf=b||[];Vf(this,{providerId:a,isOAuthProvider:!0});this.Td={}};og.prototype.setCustomParameters=function(a){this.Td=jb(a);return this};var P=function(a){og.call(this,a,ag);this.Bd=[]};u(P,og);P.prototype.addScope=function(a){Ua(this.Bd,a)||this.Bd.push(a);return this};P.prototype.ae=function(){return Za(this.Bd)};
P.prototype.credential=function(a,b){if(!a&&!b)throw new N("argument-error","credential failed: must provide the ID token and/or the access token.");return new jg(this.providerId,{idToken:a||null,accessToken:b||null})};var pg=function(){P.call(this,"facebook.com")};u(pg,P);M(pg,"PROVIDER_ID","facebook.com");
var qg=function(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new pg).credential(null,b)},rg=function(){P.call(this,"github.com")};u(rg,P);M(rg,"PROVIDER_ID","github.com");var sg=function(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new rg).credential(null,b)},tg=function(){P.call(this,"google.com");this.addScope("profile")};
u(tg,P);M(tg,"PROVIDER_ID","google.com");var ug=function(a,b){var c=a;r(a)&&(c=a.idToken,b=a.accessToken);return(new tg).credential(c,b)},vg=function(){og.call(this,"twitter.com",$f)};u(vg,og);M(vg,"PROVIDER_ID","twitter.com");
var wg=function(a,b){var c=a;r(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new N("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new jg("twitter.com",c)},xg=function(a,b){this.Db=a;this.td=b;M(this,"providerId","password")};xg.prototype.Fb=function(a){return Q(a,yg,{email:this.Db,password:this.td})};xg.prototype.zc=function(a,b){return Q(a,zg,{idToken:b,email:this.Db,password:this.td})};
xg.prototype.pd=function(a,b){return ig(this.Fb(a),b)};xg.prototype.G=function(){return{email:this.Db,password:this.td}};var Ag=function(){Vf(this,{providerId:"password",isOAuthProvider:!1})};Vf(Ag,{PROVIDER_ID:"password"});var Bg=function(a){if(!(a.verificationId&&a.Uc||a.dc&&a.phoneNumber))throw new N("internal-error");this.N=a;M(this,"providerId","phone")};Bg.prototype.Fb=function(a){return a.verifyPhoneNumber(Cg(this))};Bg.prototype.zc=function(a,b){var c=Cg(this);c.idToken=b;return Q(a,Dg,c)};
Bg.prototype.pd=function(a,b){var c=Cg(this);c.operation="REAUTH";a=Q(a,Eg,c);return ig(a,b)};Bg.prototype.G=function(){var a={providerId:"phone"};this.N.verificationId&&(a.verificationId=this.N.verificationId);this.N.Uc&&(a.verificationCode=this.N.Uc);this.N.dc&&(a.temporaryProof=this.N.dc);this.N.phoneNumber&&(a.phoneNumber=this.N.phoneNumber);return a};
var Cg=function(a){return a.N.dc&&a.N.phoneNumber?{temporaryProof:a.N.dc,phoneNumber:a.N.phoneNumber}:{sessionInfo:a.N.verificationId,code:a.N.Uc}},Fg=function(a){try{this.Oe=a||firebase.auth()}catch(b){throw new N("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}Vf(this,{providerId:"phone",isOAuthProvider:!1})};
Fg.prototype.verifyPhoneNumber=function(a,b){var c=this.Oe.g;return E(b.verify()).then(function(d){if(!p(d))throw new N("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return Q(c,Gg,{phoneNumber:a,recaptchaToken:d});default:throw new N("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};
var Hg=function(a,b){if(!a)throw new N("missing-verification-id");if(!b)throw new N("missing-verification-code");return new Bg({verificationId:a,Uc:b})};Vf(Fg,{PROVIDER_ID:"phone"});
var Ig=function(a){if(a.temporaryProof&&a.phoneNumber)return new Bg({dc:a.temporaryProof,phoneNumber:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return ug(a,c);case "facebook.com":return qg(c);case "github.com":return sg(c);case "twitter.com":return wg(c,d);default:return(new P(b)).credential(a,c)}}catch(e){return null}},Jg=function(a){if(!a.isOAuthProvider)throw new N("invalid-oauth-provider");
};var Kg=function(a,b,c){N.call(this,a,c);a=b||{};a.email&&M(this,"email",a.email);a.phoneNumber&&M(this,"phoneNumber",a.phoneNumber);a.credential&&M(this,"credential",a.credential)};u(Kg,N);Kg.prototype.G=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.G();b&&lb(a,b);return a};Kg.prototype.toJSON=function(){return this.G()};
var Lg=function(a){if(a.code){var b=a.code||"";0==b.indexOf("auth/")&&(b=b.substring(5));var c={credential:Ig(a)};if(a.email)c.email=a.email;else if(a.phoneNumber)c.phoneNumber=a.phoneNumber;else return new N(b,a.message||void 0);return new Kg(b,c,a.message)}return null};var Mg=function(a){this.Zf=a};u(Mg,Jc);Mg.prototype.mc=function(){return new this.Zf};Mg.prototype.nd=function(){return{}};
var R=function(a,b,c){var d="Node"==Cf();d=k.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new N("internal-error","The XMLHttpRequest compatibility library was not found.");this.m=a;a=b||{};this.Mf=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.Nf=a.secureTokenTimeout||Ng;this.te=jb(a.secureTokenHeaders||Og);this.Xe=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.Ye=a.firebaseTimeout||
Pg;this.Zd=jb(a.firebaseHeaders||Qg);c&&(this.Zd["X-Client-Version"]=c,this.te["X-Client-Version"]=c);this.Pe=new Oc;this.Yf=new Mg(d)},Rg,Ng=new Pf(3E4,6E4),Og={"Content-Type":"application/x-www-form-urlencoded"},Pg=new Pf(3E4,6E4),Qg={"Content-Type":"application/json"},Tg=function(a,b,c,d,e,f,g){Of()?(rf()?a=t(a.Pf,a):(Rg||(Rg=new D(function(a,b){Sg(a,b)})),a=t(a.Of,a)),a(b,c,d,e,f,g)):c&&c(null)};
R.prototype.Pf=function(a,b,c,d,e,f){var g="Node"==Cf(),l=Df()?g?new H(this.Yf):new H:new H(this.Pe);if(f){l.ub=Math.max(0,f);var n=setTimeout(function(){l.dispatchEvent("timeout")},f)}l.listen("complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(Qe(this))||null}catch(pb){a=null}b&&b(a)});qc(l,"ready",function(){n&&clearTimeout(n);this.Ia||(this.Ia=!0,this.hb())});qc(l,"timeout",function(){n&&clearTimeout(n);this.Ia||(this.Ia=!0,this.hb());b&&b(null)});l.send(a,c,d,e)};
var Ug=Ga("https://apis.google.com/js/client.js?onload=%{onload}"),Vg="__fcb"+Math.floor(1E6*Math.random()).toString(),Sg=function(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Vg]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=La(Ug,{onload:Vg});Ud(be(c),function(){b(Error("CORS_UNSUPPORTED"))})}};
R.prototype.Of=function(a,b,c,d,e){var f=this;Rg.then(function(){window.gapi.client.setApiKey(f.m);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).f(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
var Xg=function(a,b){return new D(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Tg(a,a.Mf+"?key="+encodeURIComponent(a.m),function(a){a?a.error?d(Wg(a)):a.access_token&&a.refresh_token?c(a):d(new N("internal-error")):d(new N("network-request-failed"))},"POST",lf(b).toString(),a.te,a.Nf.get()):d(new N("internal-error"))})},Yg=function(a,b,c,d,e,f){var g=ff(a.Xe+b);J(g,"key",a.m);f&&J(g,"cb",la().toString());var l="GET"==c;if(l)for(var n in d)d.hasOwnProperty(n)&&
J(g,n,d[n]);return new D(function(b,f){Tg(a,g.toString(),function(a){a?a.error?f(Wg(a,e||{})):b(a):f(new N("network-request-failed"))},c,l?void 0:Fc(Kf(d)),a.Zd,a.Ye.get())})},Zg=function(a){if(!wc.test(a.email))throw new N("invalid-email");},$g=function(a){"email"in a&&Zg(a)},bh=function(a,b){return Q(a,ah,{identifier:b,continueUri:Ff()?nf():"http://localhost"}).then(function(a){return a.allProviders||[]})},dh=function(a){return Q(a,ch,{}).then(function(a){return a.authorizedDomains||[]})},eh=function(a){if(!a.idToken)throw new N("internal-error");
},fh=function(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new N("internal-error");}else{if(!a.sessionInfo)throw new N("missing-verification-id");if(!a.code)throw new N("missing-verification-code");}};R.prototype.signInAnonymously=function(){return Q(this,gh,{})};R.prototype.updateEmail=function(a,b){return Q(this,hh,{idToken:a,email:b})};R.prototype.updatePassword=function(a,b){return Q(this,zg,{idToken:a,password:b})};var ih={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};
R.prototype.updateProfile=function(a,b){var c={idToken:a},d=[];db(ih,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return Q(this,hh,c)};R.prototype.sendPasswordResetEmail=function(a){return Q(this,jh,{requestType:"PASSWORD_RESET",email:a})};R.prototype.sendEmailVerification=function(a){return Q(this,kh,{requestType:"VERIFY_EMAIL",idToken:a})};R.prototype.verifyPhoneNumber=function(a){return Q(this,lh,a)};
var nh=function(a,b,c){return Q(a,mh,{idToken:b,deleteProvider:c})},oh=function(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new N("internal-error");},ph=function(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Lg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Lg(a)):"EMAIL_EXISTS"==a.errorMessage&&(a.code="email-already-in-use",b=Lg(a));if(b)throw b;if(!a.idToken)throw new N("internal-error");},kg=function(a,
b){b.returnIdpCredential=!0;return Q(a,qh,b)},mg=function(a,b){b.returnIdpCredential=!0;return Q(a,rh,b)},ng=function(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return Q(a,sh,b)},th=function(a){if(!a.oobCode)throw new N("invalid-action-code");};R.prototype.confirmPasswordReset=function(a,b){return Q(this,uh,{oobCode:a,newPassword:b})};R.prototype.checkActionCode=function(a){return Q(this,vh,{oobCode:a})};R.prototype.applyActionCode=function(a){return Q(this,wh,{oobCode:a})};
var wh={endpoint:"setAccountInfo",D:th,Za:"email"},vh={endpoint:"resetPassword",D:th,W:function(a){if(!a.email||!a.requestType)throw new N("internal-error");}},xh={endpoint:"signupNewUser",D:function(a){Zg(a);if(!a.password)throw new N("weak-password");},W:eh,wa:!0},ah={endpoint:"createAuthUri"},yh={endpoint:"deleteAccount",Xa:["idToken"]},mh={endpoint:"setAccountInfo",Xa:["idToken","deleteProvider"],D:function(a){if(!ga(a.deleteProvider))throw new N("internal-error");}},zh={endpoint:"getAccountInfo"},
kh={endpoint:"getOobConfirmationCode",Xa:["idToken","requestType"],D:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new N("internal-error");},Za:"email"},jh={endpoint:"getOobConfirmationCode",Xa:["requestType"],D:function(a){if("PASSWORD_RESET"!=a.requestType)throw new N("internal-error");Zg(a)},Za:"email"},ch={Md:!0,endpoint:"getProjectConfig",ee:"GET"},Ah={Md:!0,endpoint:"getRecaptchaParam",ee:"GET",W:function(a){if(!a.recaptchaSiteKey)throw new N("internal-error");}},uh={endpoint:"resetPassword",
D:th,Za:"email"},Gg={endpoint:"sendVerificationCode",Xa:["phoneNumber","recaptchaToken"],Za:"sessionInfo"},hh={endpoint:"setAccountInfo",Xa:["idToken"],D:$g,wa:!0},zg={endpoint:"setAccountInfo",Xa:["idToken"],D:function(a){$g(a);if(!a.password)throw new N("weak-password");},W:eh,wa:!0},gh={endpoint:"signupNewUser",W:eh,wa:!0},qh={endpoint:"verifyAssertion",D:oh,W:ph,wa:!0},sh={endpoint:"verifyAssertion",D:oh,W:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new N("user-not-found");
if(!a.idToken)throw new N("internal-error");},wa:!0},rh={endpoint:"verifyAssertion",D:function(a){oh(a);if(!a.idToken)throw new N("internal-error");},W:ph,wa:!0},Bh={endpoint:"verifyCustomToken",D:function(a){if(!a.token)throw new N("invalid-custom-token");},W:eh,wa:!0},yg={endpoint:"verifyPassword",D:function(a){Zg(a);if(!a.password)throw new N("wrong-password");},W:eh,wa:!0},lh={endpoint:"verifyPhoneNumber",D:fh,W:eh},Dg={endpoint:"verifyPhoneNumber",D:function(a){if(!a.idToken)throw new N("internal-error");
fh(a)},W:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Lg(a);eh(a)}},Eg={Se:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",D:fh,W:eh},Q=function(a,b,c){if(!Yf(c,b.Xa))return F(new N("internal-error"));var d=b.ee||"POST",e;return E(c).then(b.D).then(function(){b.wa&&(c.returnSecureToken=!0);return Yg(a,b.endpoint,d,c,b.Se,b.Md||!1)}).then(function(a){return e=a}).then(b.W).then(function(){if(!b.Za)return e;if(!(b.Za in e))throw new N("internal-error");return e[b.Za]})},
Wg=function(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new N(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",
INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",
INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired"};lb(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new N(d[e],
b);!b&&a&&(b=Jf(a));return new N("internal-error",b)};var Ch=function(a){this.C=a};Ch.prototype.value=function(){return this.C};Ch.prototype.ve=function(a){this.C.style=a;return this};Ch.prototype.getStyle=function(){return this.C.style};var Dh=function(a){this.C=a||{}};h=Dh.prototype;h.value=function(){return this.C};h.getUrl=function(){return this.C.url};h.ve=function(a){this.C.style=a;return this};h.getStyle=function(){return this.C.style};h.getId=function(){return this.C.id};h.getContext=function(){return this.C.context};var Fh=function(a){this.Wf=a;this.tc=null;this.rd=Eh(this)},Gh=function(a){var b=new Dh;b.C.where=document.body;b.C.url=a.Wf;b.C.messageHandlersFilter=L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER");b.C.attributes=b.C.attributes||{};(new Ch(b.C.attributes)).ve({position:"absolute",top:"-100px",width:"1px",height:"1px"});b.C.dontclear=!0;return b},Eh=function(a){return Hh().then(function(){return new D(function(b,c){L("gapi.iframes.getContext")().open(Gh(a).value(),function(d){a.tc=d;a.tc.restyle({setHideOnLeave:!1});
var e=setTimeout(function(){c(Error("Network Error"))},Ih.get()),f=function(){clearTimeout(e);b()};d.ping(f).then(f,function(){c(Error("Network Error"))})})})})};Fh.prototype.sendMessage=function(a){var b=this;return this.rd.then(function(){return new D(function(c){b.tc.send(a.type,a,c,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})};
var Jh=function(a,b){a.rd.then(function(){a.tc.register("authEvent",b,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})},Kh=Ga("https://apis.google.com/js/api.js?onload=%{onload}"),Lh=new Pf(3E4,6E4),Ih=new Pf(5E3,15E3),Mh=null,Hh=function(){return Mh?Mh:Mh=(new D(function(a,b){if(Of()){var c=function(){Nf();L("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Nf();b(Error("Network Error"))},timeout:Lh.get()})};if(L("gapi.iframes.Iframe"))a();else if(L("gapi.load"))c();else{var d="__iframefcb"+
Math.floor(1E6*Math.random()).toString();k[d]=function(){L("gapi.load")?c():b(Error("Network Error"))};d=La(Kh,{onload:d});E(be(d)).f(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})).f(function(a){Mh=null;throw a;})};var Nh=function(a,b,c){this.B=a;this.m=b;this.w=c;this.ab=null;this.gc=gf(this.B,"/__/auth/iframe");J(this.gc,"apiKey",this.m);J(this.gc,"appName",this.w)};Nh.prototype.Fd=function(a){this.ab=a;return this};Nh.prototype.toString=function(){this.ab?J(this.gc,"v",this.ab):this.gc.removeParameter("v");return this.gc.toString()};var Oh=function(a,b,c,d,e){this.B=a;this.m=b;this.w=c;this.Ne=d;this.ab=this.S=this.zd=null;this.Vb=e};Oh.prototype.Fd=function(a){this.ab=a;return this};
Oh.prototype.toString=function(){var a=gf(this.B,"/__/auth/handler");J(a,"apiKey",this.m);J(a,"appName",this.w);J(a,"authType",this.Ne);if(this.Vb.isOAuthProvider){J(a,"providerId",this.Vb.providerId);var b=this.Vb,c=Kf(b.Td),d;for(d in c)c[d]=c[d].toString();b=b.Gf;c=jb(c);for(d=0;d<b.length;d++){var e=b[d];e in c&&delete c[e]}hb(c)||J(a,"customParameters",Jf(c))}"function"===typeof this.Vb.ae&&(b=this.Vb.ae(),b.length&&J(a,"scopes",b.join(",")));this.zd?J(a,"redirectUrl",this.zd):a.removeParameter("redirectUrl");
this.S?J(a,"eventId",this.S):a.removeParameter("eventId");this.ab?J(a,"v",this.ab):a.removeParameter("v");if(this.ic)for(var f in this.ic)this.ic.hasOwnProperty(f)&&!ef(a,f)&&J(a,f,this.ic[f]);return a.toString()};
var Ph=function(a,b,c,d){this.B=a;this.m=b;this.w=c;this.$e=(this.Ga=d||null)?Ef(this.Ga):null;d=this.Ga;this.jf=(new Nh(a,b,c)).Fd(d).toString();this.pa=[];this.g=new R(b,null,this.$e);this.vc=this.sa=null},Qh=function(a){var b=nf();return dh(a).then(function(a){a:{for(var c=ff(b),e=c.ma,c=c.ka,f=0;f<a.length;f++){var g=a[f];var l=c;var n=e;0==g.indexOf("chrome-extension://")?l=ff(g).ka==l&&"chrome-extension"==n:"http"!=n&&"https"!=n?l=!1:wf.test(g)?l=l==g:(g=g.split(".").join("\\."),l=(new RegExp("^(.+\\."+
g+"|"+g+")$","i")).test(l));if(l){a=!0;break a}}a=!1}if(!a)throw new gg(nf());})};h=Ph.prototype;h.Lb=function(){if(this.vc)return this.vc;var a=this;return this.vc=xf().then(function(){a.sc=new Fh(a.jf);Rh(a)})};h.ac=function(a,b,c){var d=new N("popup-closed-by-user"),e=new N("web-storage-unsupported"),f=this,g=!1;return this.Na().then(function(){Sh(f).then(function(c){c||(a&&tf(a),b(e),g=!0)})}).f(function(){}).then(function(){if(!g)return vf(a)}).then(function(){if(!g)return Ae(c).then(function(){b(d)})})};
h.we=function(){var a=K();return!If(a)&&!Mf(a)};h.de=function(){return!1};h.Tb=function(a,b,c,d,e,f,g){if(!a)return F(new N("popup-blocked"));if(g&&!If())return this.Na().f(function(b){tf(a);e(b)}),d(),E();this.sa||(this.sa=Qh(this.g));var l=this;return this.sa.then(function(){var b=l.Na().f(function(b){tf(a);e(b);throw b;});d();return b}).then(function(){Jg(c);if(!g){var d=Th(l.B,l.m,l.w,b,c,null,f,l.Ga);of(d,a)}}).f(function(a){"auth/network-request-failed"==a.code&&(l.sa=null);throw a;})};
h.Ub=function(a,b,c){this.sa||(this.sa=Qh(this.g));var d=this;return this.sa.then(function(){Jg(b);var e=Th(d.B,d.m,d.w,a,b,nf(),c,d.Ga);of(e)}).f(function(a){"auth/network-request-failed"==a.code&&(d.sa=null);throw a;})};h.Na=function(){var a=this;return this.Lb().then(function(){return a.sc.rd}).f(function(){a.sa=null;throw new N("network-request-failed");})};h.ze=function(){return!0};
var Th=function(a,b,c,d,e,f,g,l,n){a=new Oh(a,b,c,d,e);a.zd=f;a.S=g;f=a.Fd(l);f.ic=jb(n||null);return f.toString()},Rh=function(a){if(!a.sc)throw Error("IfcHandler must be initialized!");Jh(a.sc,function(b){var c={};if(b&&b.authEvent){var d=!1;b=fg(b.authEvent);for(c=0;c<a.pa.length;c++)d=a.pa[c](b)||d;c={};c.status=d?"ACK":"ERROR";return E(c)}c.status="ERROR";return E(c)})},Sh=function(a){var b={type:"webStorageSupport"};return a.Lb().then(function(){return a.sc.sendMessage(b)}).then(function(a){if(a&&
a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})};Ph.prototype.eb=function(a){this.pa.push(a)};Ph.prototype.Zb=function(a){Xa(this.pa,function(b){return b==a})};var Uh=function(a,b,c){M(this,"type","recaptcha");this.Vc=this.zb=null;this.Bb=!1;this.Rd=a;this.za=b||{theme:"light",type:"image"};this.J=[];if(this.za.sitekey)throw new N("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.wc="invisible"===this.za.size;if(!kd(a)||!this.wc&&kd(a).hasChildNodes())throw new N("argument-error","reCAPTCHA container is either not found or already contains inner elements!");try{this.h=c||firebase.app()}catch(g){throw new N("argument-error",
"No firebase.app.App instance is currently initialized.");}if(this.h.options&&this.h.options.apiKey)a=firebase.SDK_VERSION?Ef(firebase.SDK_VERSION):null,this.g=new R(this.h.options&&this.h.options.apiKey,null,a);else throw new N("invalid-api-key");var d=this;this.Qc=[];var e=this.za.callback;this.za.callback=function(a){d.Cb(a);if("function"===typeof e)e(a);else if("string"===typeof e){var b=L(e,k);"function"===typeof b&&b(a)}};var f=this.za["expired-callback"];this.za["expired-callback"]=function(){d.Cb(null);
if("function"===typeof f)f();else if("string"===typeof f){var a=L(f,k);"function"===typeof a&&a()}}};Uh.prototype.Cb=function(a){for(var b=0;b<this.Qc.length;b++)try{this.Qc[b](a)}catch(c){}};var Vh=function(a,b){Xa(a.Qc,function(a){return a==b})};Uh.prototype.c=function(a){var b=this;this.J.push(a);Cd(a,function(){Wa(b.J,a)});return a};
Uh.prototype.Mb=function(){var a=this;return this.zb?this.zb:this.zb=this.c(E().then(function(){if(Ff())return xf();throw new N("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return Xh()}).then(function(){return Q(a.g,Ah,{})}).then(function(b){a.za.sitekey=b.recaptchaSiteKey}).f(function(b){a.zb=null;throw b;}))};
Uh.prototype.render=function(){Yh(this);var a=this;return this.c(this.Mb().then(function(){if(null===a.Vc){var b=a.Rd;if(!a.wc){var c=kd(b),b=od("DIV");c.appendChild(b)}a.Vc=grecaptcha.render(b,a.za)}return a.Vc}))};Uh.prototype.verify=function(){Yh(this);var a=this;return this.c(this.render().then(function(b){return new D(function(c){var d=grecaptcha.getResponse(b);if(d)c(d);else{var e=function(b){b&&(Vh(a,e),c(b))};a.Qc.push(e);a.wc&&grecaptcha.execute(a.Vc)}})}))};
var Yh=function(a){if(a.Bb)throw new N("internal-error","RecaptchaVerifier instance has been destroyed.");};Uh.prototype.clear=function(){Yh(this);this.Bb=!0;for(var a=0;a<this.J.length;a++)this.J[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.wc)for(var a=kd(this.Rd),b;b=a.firstChild;)a.removeChild(b)};
var Zh=Ga("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit"),Xh=function(){return new D(function(a,b){if(Of())if(k.grecaptcha)a();else{var c="__rcb"+Math.floor(1E6*Math.random()).toString();k[c]=function(){k.grecaptcha?a():b(new N("internal-error"));delete k[c]};var d=La(Zh,{onload:c});E(be(d)).f(function(){b(new N("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else b(new N("network-request-failed"))})};var $h=function(a){this.F=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.F)throw new N("internal-error","The React Native compatibility library was not found.");};h=$h.prototype;h.get=function(a){return E(this.F.getItem(a)).then(function(a){return a&&Lf(a)})};h.set=function(a,b){return E(this.F.setItem(a,Jf(b)))};h.remove=function(a){return E(this.F.removeItem(a))};h.fb=function(){};h.Wa=function(){};var ai=function(){this.F={}};h=ai.prototype;h.get=function(a){return E(this.F[a])};h.set=function(a,b){this.F[a]=b;return E()};h.remove=function(a){delete this.F[a];return E()};h.fb=function(){};h.Wa=function(){};var ci=function(){if(!bi()){if("Node"==Cf())throw new N("internal-error","The LocalStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.F=k.localStorage||firebase.INTERNAL.node.localStorage},bi=function(){var a="Node"==Cf(),a=k.localStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=ci.prototype;
h.get=function(a){var b=this;return E().then(function(){var c=b.F.getItem(a);return Lf(c)})};h.set=function(a,b){var c=this;return E().then(function(){var d=Jf(b);null===d?c.remove(a):c.F.setItem(a,d)})};h.remove=function(a){var b=this;return E().then(function(){b.F.removeItem(a)})};h.fb=function(a){k.window&&jc(k.window,"storage",a)};h.Wa=function(a){k.window&&rc(k.window,"storage",a)};var di=function(){this.F={}};h=di.prototype;h.get=function(){return E(null)};h.set=function(){return E()};h.remove=function(){return E()};h.fb=function(){};h.Wa=function(){};var fi=function(){if(!ei()){if("Node"==Cf())throw new N("internal-error","The SessionStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.F=k.sessionStorage||firebase.INTERNAL.node.sessionStorage},ei=function(){var a="Node"==Cf(),a=k.sessionStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=fi.prototype;
h.get=function(a){var b=this;return E().then(function(){var c=b.F.getItem(a);return Lf(c)})};h.set=function(a,b){var c=this;return E().then(function(){var d=Jf(b);null===d?c.remove(a):c.F.setItem(a,d)})};h.remove=function(a){var b=this;return E().then(function(){b.F.removeItem(a)})};h.fb=function(){};h.Wa=function(){};var gi=function(a,b,c,d,e,f){if(!window.indexedDB)throw new N("web-storage-unsupported");this.Te=a;this.qd=b;this.cd=c;this.De=d;this.bb=e;this.aa={};this.bc=[];this.Pb=0;this.kf=f||k.indexedDB},hi,ii=function(a){return new D(function(b,c){var d=a.kf.open(a.Te,a.bb);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.qd,{keyPath:a.cd})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})},ji=function(a){a.he||(a.he=
ii(a));return a.he},ki=function(a,b){return b.objectStore(a.qd)},li=function(a,b,c){return b.transaction([a.qd],c?"readwrite":"readonly")},mi=function(a){return new D(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})};h=gi.prototype;
h.set=function(a,b){var c=!1,d,e=this;return Cd(ji(this).then(function(b){d=b;b=ki(e,li(e,d,!0));return mi(b.get(a))}).then(function(f){var g=ki(e,li(e,d,!0));if(f)return f.value=b,mi(g.put(f));e.Pb++;c=!0;f={};f[e.cd]=a;f[e.De]=b;return mi(g.add(f))}).then(function(){e.aa[a]=b}),function(){c&&e.Pb--})};h.get=function(a){var b=this;return ji(this).then(function(c){return mi(ki(b,li(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
h.remove=function(a){var b=!1,c=this;return Cd(ji(this).then(function(d){b=!0;c.Pb++;return mi(ki(c,li(c,d,!0))["delete"](a))}).then(function(){delete c.aa[a]}),function(){b&&c.Pb--})};
h.Sf=function(){var a=this;return ji(this).then(function(b){var c=ki(a,li(a,b,!1));return c.getAll?mi(c.getAll()):new D(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.Pb){for(d=0;d<b.length;d++)c[b[d][a.cd]]=b[d][a.De];d=pf(a.aa,c);a.aa=c}return d})};h.fb=function(a){0==this.bc.length&&this.Hd();this.bc.push(a)};
h.Wa=function(a){Xa(this.bc,function(b){return b==a});0==this.bc.length&&this.Lc()};h.Hd=function(){var a=this;this.Lc();var b=function(){a.ud=Ae(800).then(t(a.Sf,a)).then(function(b){0<b.length&&y(a.bc,function(a){a(b)})}).then(b).f(function(a){"STOP_EVENT"!=a.message&&b()});return a.ud};b()};h.Lc=function(){this.ud&&this.ud.cancel("STOP_EVENT")};var qi=function(){this.Vd={Browser:ni,Node:oi,ReactNative:pi}[Cf()]},ri,ni={V:ci,Jd:fi},oi={V:ci,Jd:fi},pi={V:$h,Jd:di};var si=function(a,b){this.Re=b;M(this,"verificationId",a)};si.prototype.confirm=function(a){a=Hg(this.verificationId,a);return this.Re(a)};var ti=function(a,b,c,d){return(new Fg(a)).verifyPhoneNumber(b,c).then(function(a){return new si(a,d)})};var ui=function(a){var b={},c=a.email,d=a.newEmail;a=a.requestType;if(!c||!a)throw Error("Invalid provider user info!");b.fromEmail=d||null;b.email=c;M(this,"operation",a);M(this,"data",Zf(b))};var vi=function(a,b,c,d,e,f){this.Af=a;this.If=b;this.cf=c;this.Ac=d;this.Kd=e;this.Jf=!!f;this.nb=null;this.Oa=this.Ac;if(this.Kd<this.Ac)throw Error("Proactive refresh lower bound greater than upper bound!");};vi.prototype.start=function(){this.Oa=this.Ac;wi(this,!0)};
var xi=function(a,b){if(b)return a.Oa=a.Ac,a.cf();b=a.Oa;a.Oa*=2;a.Oa>a.Kd&&(a.Oa=a.Kd);return b},wi=function(a,b){a.stop();a.nb=Ae(xi(a,b)).then(function(){return a.Jf?E():Rf()}).then(function(){return a.Af()}).then(function(){wi(a,!0)}).f(function(b){a.If(b)&&wi(a,!1)})};vi.prototype.stop=function(){this.nb&&(this.nb.cancel(),this.nb=null)};var Di=function(a){var b={};b["facebook.com"]=yi;b["google.com"]=zi;b["github.com"]=Ai;b["twitter.com"]=Bi;var c=a&&a.providerId;return c?b[c]?new b[c](a):new Ci(a):null},Ci=function(a){var b=Lf(a.rawUserInfo||"{}");a=a.providerId;if(!a)throw Error("Invalid additional user info!");M(this,"profile",Zf(b||{}));M(this,"providerId",a)},yi=function(a){Ci.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider id!");};u(yi,Ci);
var Ai=function(a){Ci.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider id!");M(this,"username",this.profile&&this.profile.login||null)};u(Ai,Ci);var zi=function(a){Ci.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider id!");};u(zi,Ci);var Bi=function(a){Ci.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider id!");M(this,"username",a.screenName||null)};u(Bi,Ci);var Ei=function(a,b,c,d){this.le=a;this.Cd=b;this.Kf=c;this.$b=d;this.T={};ri||(ri=new qi);a=ri;try{if(mf()){hi||(hi=new gi("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1));var e=hi}else e=new a.Vd.V;this.Sa=e}catch(f){this.Sa=new ai,this.$b=!0}try{this.Oc=new a.Vd.Jd}catch(f){this.Oc=new ai}this.Id=t(this.xe,this);this.aa={}},Fi,Gi=function(){Fi||(Fi=new Ei("firebase",":",!Mf(K())&&Bf()?!0:!1,If()));return Fi};h=Ei.prototype;
h.Z=function(a,b){return this.le+this.Cd+a.name+(b?this.Cd+b:"")};h.get=function(a,b){return(a.V?this.Sa:this.Oc).get(this.Z(a,b))};h.remove=function(a,b){b=this.Z(a,b);a.V&&!this.$b&&(this.aa[b]=null);return(a.V?this.Sa:this.Oc).remove(b)};h.set=function(a,b,c){var d=this.Z(a,c),e=this,f=a.V?this.Sa:this.Oc;return f.set(d,b).then(function(){return f.get(d)}).then(function(b){a.V&&!this.$b&&(e.aa[d]=b)})};
h.addListener=function(a,b,c){a=this.Z(a,b);this.$b||(this.aa[a]=k.localStorage.getItem(a));hb(this.T)&&this.Hd();this.T[a]||(this.T[a]=[]);this.T[a].push(c)};h.removeListener=function(a,b,c){a=this.Z(a,b);this.T[a]&&(Xa(this.T[a],function(a){return a==c}),0==this.T[a].length&&delete this.T[a]);hb(this.T)&&this.Lc()};h.Hd=function(){this.Sa.fb(this.Id);this.$b||mf()||Hi(this)};
var Hi=function(a){Ii(a);a.od=setInterval(function(){for(var b in a.T){var c=k.localStorage.getItem(b),d=a.aa[b];c!=d&&(a.aa[b]=c,c=new Yb({type:"storage",key:b,target:window,oldValue:d,newValue:c,pe:!0}),a.xe(c))}},1E3)},Ii=function(a){a.od&&(clearInterval(a.od),a.od=null)};Ei.prototype.Lc=function(){this.Sa.Wa(this.Id);Ii(this)};
Ei.prototype.xe=function(a){if(a&&a.af){var b=a.la.key;if(0==b.indexOf(this.le+this.Cd)&&this.T[b]){"undefined"!==typeof a.la.pe?this.Sa.Wa(this.Id):Ii(this);if(this.Kf){var c=k.localStorage.getItem(b),d=a.la.newValue;if(d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.aa[b]===d&&"undefined"===typeof a.la.pe)return}this.aa[b]=k.localStorage.getItem(b);this.Od(b)}}else y(a,t(this.Od,this))};Ei.prototype.Od=function(a){this.T[a]&&y(this.T[a],function(a){a()})};var Ji=function(a,b){this.v=a;this.l=b||Gi()},Ki={name:"authEvent",V:!0},Li=function(a){return a.l.get(Ki,a.v).then(function(a){return fg(a)})};Ji.prototype.eb=function(a){this.l.addListener(Ki,this.v,a)};Ji.prototype.Zb=function(a){this.l.removeListener(Ki,this.v,a)};var Mi=function(a){this.l=a||Gi()},Ni={name:"sessionId",V:!1};Mi.prototype.oc=function(a){return this.l.get(Ni,a)};var Oi=function(a,b,c,d,e,f){this.B=a;this.m=b;this.w=c;this.Ga=d||null;this.ye=b+":"+c;this.Lf=new Mi;this.$d=new Ji(this.ye);this.md=null;this.pa=[];this.pf=e||500;this.Ef=f||2E3;this.Kb=this.Dc=null},Pi=function(a){return new N("invalid-cordova-configuration",a)};
Oi.prototype.Na=function(){return this.Mb?this.Mb:this.Mb=zf().then(function(){if("function"!==typeof L("universalLinks.subscribe",k))throw Pi("cordova-universal-links-plugin is not installed");if("undefined"===typeof L("BuildInfo.packageName",k))throw Pi("cordova-plugin-buildinfo is not installed");if("function"!==typeof L("cordova.plugins.browsertab.openUrl",k))throw Pi("cordova-plugin-browsertab is not installed");if("function"!==typeof L("cordova.InAppBrowser.open",k))throw Pi("cordova-plugin-inappbrowser is not installed");
},function(){throw new N("cordova-not-ready");})};var Qi=function(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")},Ri=function(a){var b=new Rb;b.update(a);return $a(b.digest())};h=Oi.prototype;h.ac=function(a,b){b(new N("operation-not-supported-in-this-environment"));return E()};h.Tb=function(){return F(new N("operation-not-supported-in-this-environment"))};h.ze=function(){return!1};h.we=function(){return!0};
h.de=function(){return!0};
h.Ub=function(a,b,c){if(this.Dc)return F(new N("redirect-operation-pending"));var d=this,e=k.document,f=null,g=null,l=null,n=null;return this.Dc=Cd(E().then(function(){Jg(b);return Si(d)}).then(function(){return Ti(d,a,b,c)}).then(function(){return(new D(function(a,b){g=function(){var b=L("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.Kb&&"function"===typeof d.Kb.close&&(d.Kb.close(),d.Kb=null);return!1};d.eb(g);l=function(){f||(f=Ae(d.Ef).then(function(){b(new N("redirect-cancelled-by-user"))}))};n=
function(){Qf()&&l()};e.addEventListener("resume",l,!1);K().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).f(function(a){return Ui(d).then(function(){throw a;})})}),function(){l&&e.removeEventListener("resume",l,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Zb(g);d.Dc=null})};
var Ti=function(a,b,c,d){var e=Qi(),f=new O(b,d,null,e,new N("no-auth-event")),g=L("BuildInfo.packageName",k);if("string"!==typeof g)throw new N("invalid-cordova-configuration");var l=L("BuildInfo.displayName",k),n={};if(K().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(K().toLowerCase().match(/android/))n.apn=g;else return F(new N("operation-not-supported-in-this-environment"));l&&(n.appDisplayName=l);e=Ri(e);n.sessionId=e;var C=Th(a.B,a.m,a.w,b,c,null,d,a.Ga,n);return a.Na().then(function(){var b=
a.ye;return a.Lf.l.set(Ki,f.G(),b)}).then(function(){var b=L("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new N("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=L("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");c(C)}else{c=L("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");b=c;var d=K();d=!(!d.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!d.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
a.Kb=b(C,d?"_blank":"_system","location=yes")}})})};Oi.prototype.Cb=function(a){for(var b=0;b<this.pa.length;b++)try{this.pa[b](a)}catch(c){}};
var Si=function(a){a.md||(a.md=a.Na().then(function(){return new D(function(b){var c=function(d){b(d);a.Zb(c);return!1};a.eb(c);Vi(a)})}));return a.md},Ui=function(a){var b=null;return Li(a.$d).then(function(c){b=c;c=a.$d;return c.l.remove(Ki,c.v)}).then(function(){return b})},Vi=function(a){var b=L("universalLinks.subscribe",k);if("function"!==typeof b)throw new N("invalid-cordova-configuration");var c=new O("unknown",null,null,null,new N("no-auth-event")),d=!1,e=Ae(a.pf).then(function(){return Ui(a).then(function(){d||
a.Cb(c)})}),f=function(b){d=!0;e&&e.cancel();Ui(a).then(function(d){var e=c;if(d&&b&&b.url){var e=null;var f=b.url;var g=ff(f),l=ef(g,"link"),n=ef(ff(l),"link"),g=ef(g,"deep_link_id");f=ef(ff(g),"link")||g||n||l||f;-1!=f.indexOf("/__/auth/callback")&&(e=ff(f),e=Lf(ef(e,"firebaseError")||null),e=(e="object"===typeof e?eg(e):null)?new O(d.ia,d.S,null,null,e):new O(d.ia,d.S,f,d.oc()));e=e||c}a.Cb(e)})},g=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(L("BuildInfo.packageName",
k).toLowerCase()+"://")&&f({url:a});if("function"===typeof g)try{g(a)}catch(n){console.error(n)}};b(null,f)};Oi.prototype.eb=function(a){this.pa.push(a);Si(this).f(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new O("unknown",null,null,null,new N("no-auth-event")),a(b))})};Oi.prototype.Zb=function(a){Xa(this.pa,function(b){return b==a})};var Wi=function(a){this.v=a;this.l=Gi()},Xi={name:"pendingRedirect",V:!1},Yi=function(a){return a.l.set(Xi,"pending",a.v)},Zi=function(a){return a.l.remove(Xi,a.v)},$i=function(a){return a.l.get(Xi,a.v).then(function(a){return"pending"==a})};var dj=function(a,b,c){this.B=a;this.m=b;this.w=c;this.cc=[];this.lb=!1;this.Zc=t(this.jd,this);this.Ua=new aj(this);this.vd=new bj(this);this.Qb=new Wi(this.m+":"+this.w);this.Ca={};this.Ca.unknown=this.Ua;this.Ca.signInViaRedirect=this.Ua;this.Ca.linkViaRedirect=this.Ua;this.Ca.reauthViaRedirect=this.Ua;this.Ca.signInViaPopup=this.vd;this.Ca.linkViaPopup=this.vd;this.Ca.reauthViaPopup=this.vd;this.U=cj(this.B,this.m,this.w)},cj=function(a,b,c){var d=firebase.SDK_VERSION||null;return yf()?new Oi(a,
b,c,d):new Ph(a,b,c,d)};dj.prototype.reset=function(){this.lb=!1;this.U.Zb(this.Zc);this.U=cj(this.B,this.m,this.w)};dj.prototype.Lb=function(){var a=this;this.lb||(this.lb=!0,this.U.eb(this.Zc));var b=this.U;return this.U.Na().f(function(c){a.U==b&&a.reset();throw c;})};var gj=function(a){a.U.we()&&a.Lb().f(function(b){var c=new O("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));ej(b)&&a.jd(c)});a.U.de()||fj(a.Ua)};
dj.prototype.subscribe=function(a){Ua(this.cc,a)||this.cc.push(a);if(!this.lb){var b=this;$i(this.Qb).then(function(a){a?Zi(b.Qb).then(function(){b.Lb().f(function(a){var c=new O("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));ej(a)&&b.jd(c)})}):gj(b)}).f(function(){gj(b)})}};dj.prototype.unsubscribe=function(a){Xa(this.cc,function(b){return b==a})};
dj.prototype.jd=function(a){if(!a)throw new N("invalid-auth-event");for(var b=!1,c=0;c<this.cc.length;c++){var d=this.cc[c];if(d.Pd(a.ia,a.S)){(b=this.Ca[a.ia])&&b.qe(a,d);b=!0;break}}fj(this.Ua);return b};var hj=new Pf(2E3,1E4),ij=new Pf(3E4,6E4);dj.prototype.getRedirectResult=function(){return this.Ua.getRedirectResult()};dj.prototype.Tb=function(a,b,c,d,e){var f=this;return this.U.Tb(a,b,c,function(){f.lb||(f.lb=!0,f.U.eb(f.Zc))},function(){f.reset()},d,e)};
var ej=function(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1};dj.prototype.Ub=function(a,b,c){var d=this,e;return Yi(this.Qb).then(function(){return d.U.Ub(a,b,c).f(function(a){if(ej(a))throw new N("operation-not-supported-in-this-environment");e=a;return Zi(d.Qb).then(function(){throw e;})}).then(function(){return d.U.ze()?new D(function(){}):Zi(d.Qb).then(function(){return d.getRedirectResult()}).then(function(){}).f(function(){})})})};
dj.prototype.ac=function(a,b,c,d){return this.U.ac(c,function(c){a.Ya(b,null,c,d)},hj.get())};var jj={},kj=function(a,b,c){var d=b+":"+c;jj[d]||(jj[d]=new dj(a,b,c));return jj[d]},aj=function(a){this.l=a;this.sb=null;this.Xb=[];this.Wb=[];this.qb=null;this.yd=!1};aj.prototype.reset=function(){this.sb=null;this.qb&&(this.qb.cancel(),this.qb=null)};
aj.prototype.qe=function(a,b){if(!a)return F(new N("invalid-auth-event"));this.reset();this.yd=!0;var c=a.ia,d=a.S,e=a.getError()&&"auth/web-storage-unsupported"==a.getError().code,f=a.getError()&&"auth/operation-not-supported-in-this-environment"==a.getError().code;"unknown"!=c||e||f?a=a.Y?this.wd(a,b):b.Eb(c,d)?this.xd(a,b):F(new N("invalid-auth-event")):(lj(this,!1,null,null),a=E());return a};var fj=function(a){a.yd||(a.yd=!0,lj(a,!1,null,null))};
aj.prototype.wd=function(a){lj(this,!0,null,a.getError());return E()};aj.prototype.xd=function(a,b){var c=this;b=b.Eb(a.ia,a.S);var d=a.vb,e=a.oc(),f=!!a.ia.match(/Redirect$/);return b(d,e).then(function(a){lj(c,f,a,null)}).f(function(a){lj(c,f,null,a)})};
var mj=function(a,b){a.sb=function(){return F(b)};if(a.Wb.length)for(var c=0;c<a.Wb.length;c++)a.Wb[c](b)},nj=function(a,b){a.sb=function(){return E(b)};if(a.Xb.length)for(var c=0;c<a.Xb.length;c++)a.Xb[c](b)},lj=function(a,b,c,d){b?d?mj(a,d):nj(a,c):nj(a,{user:null});a.Xb=[];a.Wb=[]};aj.prototype.getRedirectResult=function(){var a=this;return new D(function(b,c){a.sb?a.sb().then(b,c):(a.Xb.push(b),a.Wb.push(c),oj(a))})};
var oj=function(a){var b=new N("timeout");a.qb&&a.qb.cancel();a.qb=Ae(ij.get()).then(function(){a.sb||lj(a,!0,null,b)})},bj=function(a){this.l=a};bj.prototype.qe=function(a,b){if(!a)return F(new N("invalid-auth-event"));var c=a.ia,d=a.S;return a.Y?this.wd(a,b):b.Eb(c,d)?this.xd(a,b):F(new N("invalid-auth-event"))};bj.prototype.wd=function(a,b){b.Ya(a.ia,null,a.getError(),a.S);return E()};
bj.prototype.xd=function(a,b){var c=a.S,d=a.ia,e=b.Eb(d,c),f=a.vb;a=a.oc();return e(f,a).then(function(a){b.Ya(d,a,null,c)}).f(function(a){b.Ya(d,null,a,c)})};var pj=function(a){this.g=a;this.Da=this.ca=null;this.Ja=0};pj.prototype.G=function(){return{apiKey:this.g.m,refreshToken:this.ca,accessToken:this.Da,expirationTime:this.Ja}};
var rj=function(a,b){var c=b.idToken,d=b.refreshToken;b=qj(b.expiresIn);a.Da=c;a.Ja=b;a.ca=d},qj=function(a){return la()+1E3*parseInt(a,10)},sj=function(a,b){return Xg(a.g,b).then(function(b){a.Da=b.access_token;a.Ja=qj(b.expires_in);a.ca=b.refresh_token;return{accessToken:a.Da,expirationTime:a.Ja,refreshToken:a.ca}}).f(function(b){"auth/user-token-expired"==b.code&&(a.ca=null);throw b;})};
pj.prototype.getToken=function(a){a=!!a;return this.Da&&!this.ca?F(new N("user-token-expired")):a||!this.Da||la()>this.Ja-3E4?this.ca?sj(this,{grant_type:"refresh_token",refresh_token:this.ca}):E(null):E({accessToken:this.Da,expirationTime:this.Ja,refreshToken:this.ca})};var tj=function(a,b,c,d,e){Vf(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,providerId:b})},uj=function(a,b){Wb.call(this,a);for(var c in b)this[c]=b[c]};u(uj,Wb);
var S=function(a,b,c){this.J=[];this.m=a.apiKey;this.w=a.appName;this.B=a.authDomain||null;a=firebase.SDK_VERSION?Ef(firebase.SDK_VERSION):null;this.g=new R(this.m,null,a);this.na=new pj(this.g);vj(this,b.idToken);rj(this.na,b);M(this,"refreshToken",this.na.ca);wj(this,c||{});oe.call(this);this.Ec=!1;this.B&&Hf()&&(this.s=kj(this.B,this.m,this.w));this.Kc=[];this.oa=null;this.pb=xj(this);this.xb=t(this.kd,this)};u(S,oe);S.prototype.kd=function(){this.pb.nb&&(this.pb.stop(),this.pb.start())};
var yj=function(a){try{return firebase.app(a.w).auth()}catch(b){throw new N("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.w+"'!");}},xj=function(a){return new vi(function(){return a.getIdToken(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.na.Ja-la()-3E5;return 0<b?b:0},3E4,96E4,!1)},zj=function(a){a.Bb||a.pb.nb||(a.pb.start(),rc(a,"tokenChanged",a.xb),jc(a,"tokenChanged",a.xb))},Aj=function(a){rc(a,"tokenChanged",
a.xb);a.pb.stop()},vj=function(a,b){a.ie=b;M(a,"_lat",b)},Bj=function(a,b){Xa(a.Kc,function(a){return a==b})},Cj=function(a){for(var b=[],c=0;c<a.Kc.length;c++)b.push(a.Kc[c](a));return zd(b).then(function(){return a})},Dj=function(a){a.s&&!a.Ec&&(a.Ec=!0,a.s.subscribe(a))},wj=function(a,b){Vf(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,providerData:[]})};
M(S.prototype,"providerId","firebase");var Ej=function(){},Fj=function(a){return E().then(function(){if(a.Bb)throw new N("app-deleted");})},Gj=function(a){return Qa(a.providerData,function(a){return a.providerId})},Ij=function(a,b){b&&(Hj(a,b.providerId),a.providerData.push(b))},Hj=function(a,b){Xa(a.providerData,function(a){return a.providerId==b})},Jj=function(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&M(a,b,c)};
S.prototype.copy=function(a){var b=this;b!=a&&(Vf(this,{uid:a.uid,displayName:a.displayName,photoURL:a.photoURL,email:a.email,emailVerified:a.emailVerified,phoneNumber:a.phoneNumber,isAnonymous:a.isAnonymous,providerData:[]}),y(a.providerData,function(a){Ij(b,a)}),this.na=a.na,M(this,"refreshToken",this.na.ca))};S.prototype.reload=function(){var a=this;return this.c(Fj(this).then(function(){return Kj(a).then(function(){return Cj(a)}).then(Ej)}))};
var Kj=function(a){return a.getIdToken().then(function(b){var c=a.isAnonymous;return Lj(a,b).then(function(){c||Jj(a,"isAnonymous",!1);return b})})};S.prototype.getIdToken=function(a){var b=this;return this.c(Fj(this).then(function(){return b.na.getToken(a)}).then(function(a){if(!a)throw new N("internal-error");a.accessToken!=b.ie&&(vj(b,a.accessToken),b.Pa());Jj(b,"refreshToken",a.refreshToken);return a.accessToken}))};
S.prototype.getToken=function(a){Sf["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]||(Sf["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn("firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."));return this.getIdToken(a)};
var Mj=function(a,b){b.idToken&&a.ie!=b.idToken&&(rj(a.na,b),a.Pa(),vj(a,b.idToken),Jj(a,"refreshToken",a.na.ca))};S.prototype.Pa=function(){this.dispatchEvent(new uj("tokenChanged"))};var Lj=function(a,b){return Q(a.g,zh,{idToken:b}).then(t(a.Bf,a))};
S.prototype.Bf=function(a){a=a.users;if(!a||!a.length)throw new N("internal-error");a=a[0];wj(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber});for(var b=Nj(a),c=0;c<b.length;c++)Ij(this,b[c]);Jj(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
var Nj=function(a){return(a=a.providerUserInfo)&&a.length?Qa(a,function(a){return new tj(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl)}):[]};S.prototype.reauthenticateAndRetrieveDataWithCredential=function(a){var b=this,c=null;return this.c(a.pd(this.g,this.uid).then(function(a){Mj(b,a);c=Oj(b,a,"reauthenticate");b.oa=null;return b.reload()}).then(function(){return c}),!0)};S.prototype.reauthenticateWithCredential=function(a){return this.reauthenticateAndRetrieveDataWithCredential(a).then(function(){})};
var Pj=function(a,b){return Kj(a).then(function(){if(Ua(Gj(a),b))return Cj(a).then(function(){throw new N("provider-already-linked");})})};S.prototype.linkAndRetrieveDataWithCredential=function(a){var b=this,c=null;return this.c(Pj(this,a.providerId).then(function(){return b.getIdToken()}).then(function(c){return a.zc(b.g,c)}).then(function(a){c=Oj(b,a,"link");return Qj(b,a)}).then(function(){return c}))};S.prototype.linkWithCredential=function(a){return this.linkAndRetrieveDataWithCredential(a).then(function(a){return a.user})};
S.prototype.linkWithPhoneNumber=function(a,b){var c=this;return this.c(Pj(this,"phone").then(function(){return ti(yj(c),a,b,t(c.linkAndRetrieveDataWithCredential,c))}))};S.prototype.reauthenticateWithPhoneNumber=function(a,b){var c=this;return this.c(E().then(function(){return ti(yj(c),a,b,t(c.reauthenticateAndRetrieveDataWithCredential,c))}),!0)};var Oj=function(a,b,c){var d=Ig(b);b=Di(b);return Wf({user:a,credential:d,additionalUserInfo:b,operationType:c})},Qj=function(a,b){Mj(a,b);return a.reload().then(function(){return a})};
h=S.prototype;h.updateEmail=function(a){var b=this;return this.c(this.getIdToken().then(function(c){return b.g.updateEmail(c,a)}).then(function(a){Mj(b,a);return b.reload()}))};h.updatePhoneNumber=function(a){var b=this;return this.c(this.getIdToken().then(function(c){return a.zc(b.g,c)}).then(function(a){Mj(b,a);return b.reload()}))};h.updatePassword=function(a){var b=this;return this.c(this.getIdToken().then(function(c){return b.g.updatePassword(c,a)}).then(function(a){Mj(b,a);return b.reload()}))};
h.updateProfile=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Fj(this);var b=this;return this.c(this.getIdToken().then(function(c){return b.g.updateProfile(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){Mj(b,a);Jj(b,"displayName",a.displayName||null);Jj(b,"photoURL",a.photoUrl||null);y(b.providerData,function(a){"password"===a.providerId&&(M(a,"displayName",b.displayName),M(a,"photoURL",b.photoURL))});return Cj(b)}).then(Ej))};
h.unlink=function(a){var b=this;return this.c(Kj(this).then(function(c){return Ua(Gj(b),a)?nh(b.g,c,[a]).then(function(a){var c={};y(a.providerUserInfo||[],function(a){c[a.providerId]=!0});y(Gj(b),function(a){c[a]||Hj(b,a)});c[Fg.PROVIDER_ID]||M(b,"phoneNumber",null);return Cj(b)}):Cj(b).then(function(){throw new N("no-such-provider");})}))};
h["delete"]=function(){var a=this;return this.c(this.getIdToken().then(function(b){return Q(a.g,yh,{idToken:b})}).then(function(){a.dispatchEvent(new uj("userDeleted"))})).then(function(){for(var b=0;b<a.J.length;b++)a.J[b].cancel("app-deleted");a.J=[];a.Bb=!0;Aj(a);M(a,"refreshToken",null);a.s&&a.s.unsubscribe(a)})};
h.Pd=function(a,b){return"linkViaPopup"==a&&(this.ha||null)==b&&this.ga||"reauthViaPopup"==a&&(this.ha||null)==b&&this.ga||"linkViaRedirect"==a&&(this.Ba||null)==b||"reauthViaRedirect"==a&&(this.Ba||null)==b?!0:!1};h.Ya=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.ha||null)||(c&&this.Ra?this.Ra(c):b&&!c&&this.ga&&this.ga(b),this.K&&(this.K.cancel(),this.K=null),delete this.ga,delete this.Ra)};
h.Eb=function(a,b){return"linkViaPopup"==a&&b==(this.ha||null)?t(this.Xd,this):"reauthViaPopup"==a&&b==(this.ha||null)?t(this.Yd,this):"linkViaRedirect"==a&&(this.Ba||null)==b?t(this.Xd,this):"reauthViaRedirect"==a&&(this.Ba||null)==b?t(this.Yd,this):null};h.nc=function(){return Gf(this.uid+":::")};h.linkWithPopup=function(a){var b=this;return Rj(this,"linkViaPopup",a,function(){return Pj(b,a.providerId).then(function(){return Cj(b)})},!1)};
h.reauthenticateWithPopup=function(a){return Rj(this,"reauthViaPopup",a,function(){return E()},!0)};
var Rj=function(a,b,c,d,e){if(!Hf())return F(new N("operation-not-supported-in-this-environment"));if(a.oa&&!e)return F(a.oa);var f=cg(c.providerId),g=a.nc(),l=null;(!If()||Bf())&&a.B&&c.isOAuthProvider&&(l=Th(a.B,a.m,a.w,b,c,null,g,firebase.SDK_VERSION||null));var n=uf(l,f&&f.Sb,f&&f.Rb);d=d().then(function(){Sj(a);if(!e)return a.getIdToken().then(function(){})}).then(function(){return a.s.Tb(n,b,c,g,!!l)}).then(function(){return new D(function(c,d){a.Ya(b,null,new N("cancelled-popup-request"),a.ha||
null);a.ga=c;a.Ra=d;a.ha=g;a.K=a.s.ac(a,b,n,g)})}).then(function(a){n&&tf(n);return a?Wf(a):null}).f(function(a){n&&tf(n);throw a;});return a.c(d,e)};S.prototype.linkWithRedirect=function(a){var b=this;return Tj(this,"linkViaRedirect",a,function(){return Pj(b,a.providerId)},!1)};S.prototype.reauthenticateWithRedirect=function(a){return Tj(this,"reauthViaRedirect",a,function(){return E()},!0)};
var Tj=function(a,b,c,d,e){if(!Hf())return F(new N("operation-not-supported-in-this-environment"));if(a.oa&&!e)return F(a.oa);var f=null,g=a.nc();d=d().then(function(){Sj(a);if(!e)return a.getIdToken().then(function(){})}).then(function(){a.Ba=g;return Cj(a)}).then(function(b){a.Va&&(b=a.Va,b=b.l.set(Uj,a.G(),b.v));return b}).then(function(){return a.s.Ub(b,c,g)}).f(function(b){f=b;if(a.Va)return Vj(a.Va);throw f;}).then(function(){if(f)throw f;});return a.c(d,e)},Sj=function(a){if(!a.s||!a.Ec){if(a.s&&
!a.Ec)throw new N("internal-error");throw new N("auth-domain-config-required");}};S.prototype.Xd=function(a,b){var c=this;this.K&&(this.K.cancel(),this.K=null);var d=null,e=this.getIdToken().then(function(d){return mg(c.g,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=Oj(c,a,"link");return Qj(c,a)}).then(function(){return d});return this.c(e)};
S.prototype.Yd=function(a,b){var c=this;this.K&&(this.K.cancel(),this.K=null);var d=null,e=E().then(function(){return ig(ng(c.g,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=Oj(c,a,"reauthenticate");Mj(c,a);c.oa=null;return c.reload()}).then(function(){return d});return this.c(e,!0)};S.prototype.sendEmailVerification=function(){var a=this;return this.c(this.getIdToken().then(function(b){return a.g.sendEmailVerification(b)}).then(function(b){if(a.email!=b)return a.reload()}).then(function(){}))};
S.prototype.c=function(a,b){var c=this,d=Wj(this,a,b);this.J.push(d);Cd(d,function(){Wa(c.J,d)});return d};var Wj=function(a,b,c){return a.oa&&!c?(b.cancel(),F(a.oa)):b.f(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.oa||a.dispatchEvent(new uj("userInvalidated")),a.oa=b);throw b;})};S.prototype.toJSON=function(){return this.G()};
S.prototype.G=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.m,appName:this.w,authDomain:this.B,stsTokenManager:this.na.G(),redirectEventId:this.Ba||null};y(this.providerData,function(b){a.providerData.push(Xf(b))});return a};
var Xj=function(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c.idToken=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-la())/1E3;else return null;var d=new S(b,c,a);a.providerData&&y(a.providerData,function(a){a&&Ij(d,Wf(a))});a.redirectEventId&&(d.Ba=a.redirectEventId);return d},
Yj=function(a,b,c){var d=new S(a,b);c&&(d.Va=c);return d.reload().then(function(){return d})};var Zj=function(a){this.v=a;this.l=Gi()},Uj={name:"redirectUser",V:!1},Vj=function(a){return a.l.remove(Uj,a.v)},ak=function(a,b){return a.l.get(Uj,a.v).then(function(a){a&&b&&(a.authDomain=b);return Xj(a||{})})};var bk=function(a){this.v=a;this.l=Gi()},ck={name:"authUser",V:!0},dk=function(a,b){return a.l.set(ck,b.G(),a.v)},ek=function(a){return a.l.remove(ck,a.v)},fk=function(a,b){return a.l.get(ck,a.v).then(function(a){a&&b&&(a.authDomain=b);return Xj(a||{})})};var T=function(a){this.Ha=!1;M(this,"app",a);if(this.h().options&&this.h().options.apiKey)a=firebase.SDK_VERSION?Ef(firebase.SDK_VERSION):null,this.g=new R(this.h().options&&this.h().options.apiKey,null,a);else throw new N("invalid-api-key");this.J=[];this.Ea=[];this.wb=[];this.xf=firebase.INTERNAL.createSubscribe(t(this.lf,this));this.hc=void 0;this.zf=firebase.INTERNAL.createSubscribe(t(this.nf,this));gk(this,null);a=this.h().options.apiKey;var b=this.h().name;this.xa=new bk(a+":"+b);a=this.h().options.apiKey;
b=this.h().name;this.rb=new Zj(a+":"+b);this.jc=this.c(hk(this));this.ua=this.c(ik(this));this.xc=!1;this.hd=t(this.Rf,this);this.Ce=t(this.jb,this);this.xb=t(this.kd,this);this.Ae=t(this.gf,this);this.Be=t(this.hf,this);jk(this);this.INTERNAL={};this.INTERNAL["delete"]=t(this["delete"],this);this.Ka=0};T.prototype.toJSON=function(){return{apiKey:this.h().options.apiKey,authDomain:this.h().options.authDomain,appName:this.h().name,currentUser:U(this)&&U(this).G()}};
var kk=function(a){return a.Ue||F(new N("auth-domain-config-required"))},jk=function(a){var b=a.h().options.authDomain,c=a.h().options.apiKey;b&&Hf()&&(a.Ue=a.jc.then(function(){if(!a.Ha)return a.s=kj(b,c,a.h().name),a.s.subscribe(a),U(a)&&Dj(U(a)),a.Yb&&(Dj(a.Yb),a.Yb=null),a.s}))};h=T.prototype;h.Pd=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.ha==b&&!!this.ga;default:return!1}};
h.Ya=function(a,b,c,d){"signInViaPopup"==a&&this.ha==d&&(c&&this.Ra?this.Ra(c):b&&!c&&this.ga&&this.ga(b),this.K&&(this.K.cancel(),this.K=null),delete this.ga,delete this.Ra)};h.Eb=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.ha==b&&this.ga?t(this.We,this):null};
h.We=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.K&&(this.K.cancel(),this.K=null);var d=null,e=null,f=kg(c.g,a).then(function(a){d=Ig(a);e=Di(a);return a});a=c.jc.then(function(){return f}).then(function(a){return lk(c,a)}).then(function(){return Wf({user:U(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return this.c(a)};h.nc=function(){return Gf()};
h.signInWithPopup=function(a){if(!Hf())return F(new N("operation-not-supported-in-this-environment"));var b=this,c=cg(a.providerId),d=this.nc(),e=null;(!If()||Bf())&&this.h().options.authDomain&&a.isOAuthProvider&&(e=Th(this.h().options.authDomain,this.h().options.apiKey,this.h().name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null));var f=uf(e,c&&c.Sb,c&&c.Rb),c=kk(this).then(function(b){return b.Tb(f,"signInViaPopup",a,d,!!e)}).then(function(){return new D(function(a,c){b.Ya("signInViaPopup",
null,new N("cancelled-popup-request"),b.ha);b.ga=a;b.Ra=c;b.ha=d;b.K=b.s.ac(b,"signInViaPopup",f,d)})}).then(function(a){f&&tf(f);return a?Wf(a):null}).f(function(a){f&&tf(f);throw a;});return this.c(c)};h.signInWithRedirect=function(a){if(!Hf())return F(new N("operation-not-supported-in-this-environment"));var b=this,c=kk(this).then(function(){return b.s.Ub("signInViaRedirect",a)});return this.c(c)};
h.getRedirectResult=function(){if(!Hf())return F(new N("operation-not-supported-in-this-environment"));var a=this,b=kk(this).then(function(){return a.s.getRedirectResult()}).then(function(a){return a?Wf(a):null});return this.c(b)};
var lk=function(a,b){var c={};c.apiKey=a.h().options.apiKey;c.authDomain=a.h().options.authDomain;c.appName=a.h().name;return a.jc.then(function(){return Yj(c,b,a.rb)}).then(function(b){if(U(a)&&b.uid==U(a).uid)return U(a).copy(b),a.jb(b);gk(a,b);Dj(b);return a.jb(b)}).then(function(){a.Pa()})},gk=function(a,b){U(a)&&(Bj(U(a),a.Ce),rc(U(a),"tokenChanged",a.xb),rc(U(a),"userDeleted",a.Ae),rc(U(a),"userInvalidated",a.Be),Aj(U(a)));b&&(b.Kc.push(a.Ce),jc(b,"tokenChanged",a.xb),jc(b,"userDeleted",a.Ae),
jc(b,"userInvalidated",a.Be),0<a.Ka&&zj(b));M(a,"currentUser",b)};T.prototype.signOut=function(){var a=this,b=this.ua.then(function(){if(!U(a))return E();gk(a,null);return ek(a.xa).then(function(){a.Pa()})});return this.c(b)};
var mk=function(a){var b=a.h().options.authDomain,b=ak(a.rb,b).then(function(b){if(a.Yb=b)b.Va=a.rb;return Vj(a.rb)});return a.c(b)},hk=function(a){var b=a.h().options.authDomain,c=mk(a).then(function(){return fk(a.xa,b)}).then(function(b){return b?(b.Va=a.rb,a.Yb&&(a.Yb.Ba||null)==(b.Ba||null)?b:b.reload().then(function(){return dk(a.xa,b).then(function(){return b})}).f(function(c){return"auth/network-request-failed"==c.code?b:ek(a.xa)})):null}).then(function(b){gk(a,b||null)});return a.c(c)},ik=
function(a){return a.jc.then(function(){return a.getRedirectResult()}).f(function(){}).then(function(){if(!a.Ha)return a.hd()}).f(function(){}).then(function(){if(!a.Ha){a.xc=!0;var b=a.xa;b.l.addListener(ck,b.v,a.hd)}})};h=T.prototype;
h.Rf=function(){var a=this,b=this.h().options.authDomain;return fk(this.xa,b).then(function(b){if(!a.Ha){var c;if(c=U(a)&&b){c=U(a).uid;var e=b.uid;c=void 0===c||null===c||""===c||void 0===e||null===e||""===e?!1:c==e}if(c)return U(a).copy(b),U(a).getIdToken();if(U(a)||b)gk(a,b),b&&(Dj(b),b.Va=a.rb),a.s&&a.s.subscribe(a),a.Pa()}})};h.jb=function(a){return dk(this.xa,a)};h.kd=function(){this.Pa();this.jb(U(this))};h.gf=function(){this.signOut()};h.hf=function(){this.signOut()};
var nk=function(a,b){var c=null,d=null;return a.c(b.then(function(b){c=Ig(b);d=Di(b);return lk(a,b)}).then(function(){return Wf({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))};h=T.prototype;h.lf=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};h.nf=function(a){var b=this;ok(this,function(){a.next(U(b))})};
h.onIdTokenChanged=function(a,b,c){var d=this;this.xc&&firebase.Promise.resolve().then(function(){q(a)?a(U(d)):q(a.next)&&a.next(U(d))});return this.xf(a,b,c)};h.onAuthStateChanged=function(a,b,c){var d=this;this.xc&&firebase.Promise.resolve().then(function(){d.hc=d.getUid();q(a)?a(U(d)):q(a.next)&&a.next(U(d))});return this.zf(a,b,c)};h.bf=function(a){var b=this,c=this.ua.then(function(){return U(b)?U(b).getIdToken(a).then(function(a){return{accessToken:a}}):null});return this.c(c)};
h.signInWithCustomToken=function(a){var b=this;return this.ua.then(function(){return nk(b,Q(b.g,Bh,{token:a}))}).then(function(a){a=a.user;Jj(a,"isAnonymous",!1);return b.jb(a)}).then(function(){return U(b)})};h.signInWithEmailAndPassword=function(a,b){var c=this;return this.ua.then(function(){return nk(c,Q(c.g,yg,{email:a,password:b}))}).then(function(a){return a.user})};h.createUserWithEmailAndPassword=function(a,b){var c=this;return this.ua.then(function(){return nk(c,Q(c.g,xh,{email:a,password:b}))}).then(function(a){return a.user})};
h.signInWithCredential=function(a){return this.signInAndRetrieveDataWithCredential(a).then(function(a){return a.user})};h.signInAndRetrieveDataWithCredential=function(a){var b=this;return this.ua.then(function(){return nk(b,a.Fb(b.g))})};h.signInAnonymously=function(){var a=this;return this.ua.then(function(){var b=U(a);return b&&b.isAnonymous?b:nk(a,a.g.signInAnonymously()).then(function(b){b=b.user;Jj(b,"isAnonymous",!0);return a.jb(b)}).then(function(){return U(a)})})};h.h=function(){return this.app};
var U=function(a){return a.currentUser};T.prototype.getUid=function(){return U(this)&&U(this).uid||null};var pk=function(a){return U(a)&&U(a)._lat||null};h=T.prototype;h.Pa=function(){if(this.xc){for(var a=0;a<this.Ea.length;a++)if(this.Ea[a])this.Ea[a](pk(this));if(this.hc!==this.getUid()&&this.wb.length)for(this.hc=this.getUid(),a=0;a<this.wb.length;a++)if(this.wb[a])this.wb[a](pk(this))}};h.Le=function(a){this.addAuthTokenListener(a);this.Ka++;0<this.Ka&&U(this)&&zj(U(this))};
h.Ff=function(a){var b=this;y(this.Ea,function(c){c==a&&b.Ka--});0>this.Ka&&(this.Ka=0);0==this.Ka&&U(this)&&Aj(U(this));this.removeAuthTokenListener(a)};h.addAuthTokenListener=function(a){var b=this;this.Ea.push(a);this.c(this.ua.then(function(){b.Ha||Ua(b.Ea,a)&&a(pk(b))}))};h.removeAuthTokenListener=function(a){Xa(this.Ea,function(b){return b==a})};var ok=function(a,b){a.wb.push(b);a.c(a.ua.then(function(){!a.Ha&&Ua(a.wb,b)&&a.hc!==a.getUid()&&(a.hc=a.getUid(),b(pk(a)))}))};h=T.prototype;
h["delete"]=function(){this.Ha=!0;for(var a=0;a<this.J.length;a++)this.J[a].cancel("app-deleted");this.J=[];this.xa&&(a=this.xa,a.l.removeListener(ck,a.v,this.hd));this.s&&this.s.unsubscribe(this);return firebase.Promise.resolve()};h.c=function(a){var b=this;this.J.push(a);Cd(a,function(){Wa(b.J,a)});return a};h.fetchProvidersForEmail=function(a){return this.c(bh(this.g,a))};h.verifyPasswordResetCode=function(a){return this.checkActionCode(a).then(function(a){return a.data.email})};
h.confirmPasswordReset=function(a,b){return this.c(this.g.confirmPasswordReset(a,b).then(function(){}))};h.checkActionCode=function(a){return this.c(this.g.checkActionCode(a).then(function(a){return new ui(a)}))};h.applyActionCode=function(a){return this.c(this.g.applyActionCode(a).then(function(){}))};h.sendPasswordResetEmail=function(a){return this.c(this.g.sendPasswordResetEmail(a).then(function(){}))};
h.signInWithPhoneNumber=function(a,b){return this.c(ti(this,a,b,t(this.signInAndRetrieveDataWithCredential,this)))};var qk="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),V=function(a,b){return{name:a||"",O:"a valid string",optional:!!b,P:p}},rk=function(){return{name:"opt_forceRefresh",O:"a boolean",optional:!0,P:ba}},W=function(a,b){return{name:a||"",O:"a valid object",optional:!!b,P:r}},sk=function(a,b){return{name:a||"",O:"a function",optional:!!b,P:q}},tk=function(){return{name:"",O:"null",optional:!1,P:fa}},uk=function(){return{name:"",O:"an HTML element",optional:!1,P:function(a){return!!(a&&
a instanceof Element)}}},vk=function(){return{name:"auth",O:"an instance of Firebase Auth",optional:!0,P:function(a){return!!(a&&a instanceof T)}}},wk=function(){return{name:"app",O:"an instance of Firebase App",optional:!0,P:function(a){return!!(a&&a instanceof firebase.app.App)}}},xk=function(a){return{name:a?a+"Credential":"credential",O:a?"a valid "+a+" credential":"a valid credential",optional:!1,P:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.Fb||!c)}}},yk=function(){return{name:"authProvider",
O:"a valid Auth provider",optional:!1,P:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}},zk=function(){return{name:"applicationVerifier",O:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,P:function(a){return!!(a&&p(a.type)&&q(a.verify))}}},X=function(a,b,c,d){return{name:c||"",O:a.O+" or "+b.O,optional:!!d,P:function(c){return a.P(c)||b.P(c)}}};var Y=function(a,b){for(var c in b){var d=b[c].name;a[d]=Ak(d,a[c],b[c].a)}},Z=function(a,b,c,d){a[b]=Ak(b,c,d)},Ak=function(a,b,c){if(!c)return b;var d=Bk(a);a=function(){var a=Array.prototype.slice.call(arguments);a:{var e=Array.prototype.slice.call(a);var l=0;for(var n=!1,C=0;C<c.length;C++)if(c[C].optional)n=!0;else{if(n)throw new N("internal-error","Argument validator encountered a required argument after an optional argument.");l++}n=c.length;if(e.length<l||n<e.length)e="Expected "+(l==n?1==
l?"1 argument":l+" arguments":l+"-"+n+" arguments")+" but got "+e.length+".";else{for(l=0;l<e.length;l++)if(n=c[l].optional&&void 0===e[l],!c[l].P(e[l])&&!n){e=c[l];if(0>l||l>=qk.length)throw new N("internal-error","Argument validator received an unsupported number of arguments.");e=qk[l]+" argument "+(e.name?'"'+e.name+'" ':"")+"must be "+e.O+".";break a}e=null}}if(e)throw new N("argument-error",d+" failed: "+e);return b.apply(this,a)};for(var e in b)a[e]=b[e];for(e in b.prototype)a.prototype[e]=
b.prototype[e];return a},Bk=function(a){a=a.split(".");return a[a.length-1]};Y(T.prototype,{applyActionCode:{name:"applyActionCode",a:[V("code")]},checkActionCode:{name:"checkActionCode",a:[V("code")]},confirmPasswordReset:{name:"confirmPasswordReset",a:[V("code"),V("newPassword")]},createUserWithEmailAndPassword:{name:"createUserWithEmailAndPassword",a:[V("email"),V("password")]},fetchProvidersForEmail:{name:"fetchProvidersForEmail",a:[V("email")]},getRedirectResult:{name:"getRedirectResult",a:[]},onAuthStateChanged:{name:"onAuthStateChanged",a:[X(W(),sk(),"nextOrObserver"),
sk("opt_error",!0),sk("opt_completed",!0)]},onIdTokenChanged:{name:"onIdTokenChanged",a:[X(W(),sk(),"nextOrObserver"),sk("opt_error",!0),sk("opt_completed",!0)]},sendPasswordResetEmail:{name:"sendPasswordResetEmail",a:[V("email")]},signInAndRetrieveDataWithCredential:{name:"signInAndRetrieveDataWithCredential",a:[xk()]},signInAnonymously:{name:"signInAnonymously",a:[]},signInWithCredential:{name:"signInWithCredential",a:[xk()]},signInWithCustomToken:{name:"signInWithCustomToken",a:[V("token")]},signInWithEmailAndPassword:{name:"signInWithEmailAndPassword",
a:[V("email"),V("password")]},signInWithPhoneNumber:{name:"signInWithPhoneNumber",a:[V("phoneNumber"),zk()]},signInWithPopup:{name:"signInWithPopup",a:[yk()]},signInWithRedirect:{name:"signInWithRedirect",a:[yk()]},signOut:{name:"signOut",a:[]},toJSON:{name:"toJSON",a:[V(null,!0)]},verifyPasswordResetCode:{name:"verifyPasswordResetCode",a:[V("code")]}});
Y(S.prototype,{"delete":{name:"delete",a:[]},getIdToken:{name:"getIdToken",a:[rk()]},getToken:{name:"getToken",a:[rk()]},linkAndRetrieveDataWithCredential:{name:"linkAndRetrieveDataWithCredential",a:[xk()]},linkWithCredential:{name:"linkWithCredential",a:[xk()]},linkWithPhoneNumber:{name:"linkWithPhoneNumber",a:[V("phoneNumber"),zk()]},linkWithPopup:{name:"linkWithPopup",a:[yk()]},linkWithRedirect:{name:"linkWithRedirect",a:[yk()]},reauthenticateAndRetrieveDataWithCredential:{name:"reauthenticateAndRetrieveDataWithCredential",
a:[xk()]},reauthenticateWithCredential:{name:"reauthenticateWithCredential",a:[xk()]},reauthenticateWithPhoneNumber:{name:"reauthenticateWithPhoneNumber",a:[V("phoneNumber"),zk()]},reauthenticateWithPopup:{name:"reauthenticateWithPopup",a:[yk()]},reauthenticateWithRedirect:{name:"reauthenticateWithRedirect",a:[yk()]},reload:{name:"reload",a:[]},sendEmailVerification:{name:"sendEmailVerification",a:[]},toJSON:{name:"toJSON",a:[V(null,!0)]},unlink:{name:"unlink",a:[V("provider")]},updateEmail:{name:"updateEmail",
a:[V("email")]},updatePassword:{name:"updatePassword",a:[V("password")]},updatePhoneNumber:{name:"updatePhoneNumber",a:[xk("phone")]},updateProfile:{name:"updateProfile",a:[W("profile")]}});Y(D.prototype,{f:{name:"catch"},then:{name:"then"}});Y(si.prototype,{confirm:{name:"confirm",a:[V("verificationCode")]}});Z(Ag,"credential",function(a,b){return new xg(a,b)},[V("email"),V("password")]);Y(pg.prototype,{addScope:{name:"addScope",a:[V("scope")]},setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});
Z(pg,"credential",qg,[X(V(),W(),"token")]);Y(rg.prototype,{addScope:{name:"addScope",a:[V("scope")]},setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});Z(rg,"credential",sg,[X(V(),W(),"token")]);Y(tg.prototype,{addScope:{name:"addScope",a:[V("scope")]},setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});Z(tg,"credential",ug,[X(V(),X(W(),tk()),"idToken"),X(V(),tk(),"accessToken",!0)]);
Y(vg.prototype,{setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});Z(vg,"credential",wg,[X(V(),W(),"token"),V("secret",!0)]);Y(P.prototype,{addScope:{name:"addScope",a:[V("scope")]},credential:{name:"credential",a:[X(V(),tk(),"idToken",!0),X(V(),tk(),"accessToken",!0)]},setCustomParameters:{name:"setCustomParameters",a:[W("customOAuthParameters")]}});Z(Fg,"credential",Hg,[V("verificationId"),V("verificationCode")]);
Y(Fg.prototype,{verifyPhoneNumber:{name:"verifyPhoneNumber",a:[V("phoneNumber"),zk()]}});Y(N.prototype,{toJSON:{name:"toJSON",a:[V(null,!0)]}});Y(Kg.prototype,{toJSON:{name:"toJSON",a:[V(null,!0)]}});Y(gg.prototype,{toJSON:{name:"toJSON",a:[V(null,!0)]}});Y(Uh.prototype,{clear:{name:"clear",a:[]},render:{name:"render",a:[]},verify:{name:"verify",a:[]}});
(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:T,Error:N};Z(a,"EmailAuthProvider",Ag,[]);Z(a,"FacebookAuthProvider",pg,[]);Z(a,"GithubAuthProvider",rg,[]);Z(a,"GoogleAuthProvider",tg,[]);Z(a,"TwitterAuthProvider",vg,[]);Z(a,"OAuthProvider",P,[V("providerId")]);Z(a,"PhoneAuthProvider",Fg,[vk()]);Z(a,"RecaptchaVerifier",Uh,[X(V(),uk(),"recaptchaContainer"),W("recaptchaParameters",!0),wk()]);firebase.INTERNAL.registerService("auth",function(a,
c){a=new T(a);c({INTERNAL:{getUid:t(a.getUid,a),getToken:t(a.bf,a),addAuthTokenListener:t(a.Le,a),removeAuthTokenListener:t(a.Ff,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:S})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).call(this);
}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/*! @license Firebase v4.1.3
Build: rev-1234895
Terms: https://firebase.google.com/terms/

---

typedarray.js
Copyright (c) 2010, Linden Research, Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

(function() {
            var firebase = __webpack_require__(24);
            var g,aa=this;function n(a){return void 0!==a}function ba(){}function ca(a){a.Vb=function(){return a.Ye?a.Ye:a.Ye=new a}}
function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return"array"==da(a)}function fa(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function p(a){return"string"==typeof a}function ga(a){return"number"==typeof a}function ha(a){return"function"==da(a)}function ia(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}function ja(a,b,c){return a.call.apply(a.bind,arguments)}
function ka(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function q(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ja:ka;return q.apply(null,arguments)}
function la(a,b){function c(){}c.prototype=b.prototype;a.wg=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.sg=function(a,c,f){for(var h=Array(arguments.length-2),k=2;k<arguments.length;k++)h[k-2]=arguments[k];return b.prototype[c].apply(a,h)}};function ma(a){a=String(a);if(/^\s*$/.test(a)?0:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,"")))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function na(){this.Fd=void 0}
function oa(a,b,c){switch(typeof b){case "string":pa(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?b:"null");break;case "boolean":c.push(b);break;case "undefined":c.push("null");break;case "object":if(null==b){c.push("null");break}if(ea(b)){var d=b.length;c.push("[");for(var e="",f=0;f<d;f++)c.push(e),e=b[f],oa(a,a.Fd?a.Fd.call(b,String(f),e):e,c),e=",";c.push("]");break}c.push("{");d="";for(f in b)Object.prototype.hasOwnProperty.call(b,f)&&(e=b[f],"function"!=typeof e&&(c.push(d),pa(f,c),
c.push(":"),oa(a,a.Fd?a.Fd.call(b,f,e):e,c),d=","));c.push("}");break;case "function":break;default:throw Error("Unknown type: "+typeof b);}}var qa={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},ra=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
function pa(a,b){b.push('"',a.replace(ra,function(a){if(a in qa)return qa[a];var b=a.charCodeAt(0),e="\\u";16>b?e+="000":256>b?e+="00":4096>b&&(e+="0");return qa[a]=e+b.toString(16)}),'"')};function sa(){this.Wa=-1};function ta(){this.Wa=-1;this.Wa=64;this.M=[];this.Wd=[];this.Af=[];this.zd=[];this.zd[0]=128;for(var a=1;a<this.Wa;++a)this.zd[a]=0;this.Pd=this.$b=0;this.reset()}la(ta,sa);ta.prototype.reset=function(){this.M[0]=1732584193;this.M[1]=4023233417;this.M[2]=2562383102;this.M[3]=271733878;this.M[4]=3285377520;this.Pd=this.$b=0};
function ua(a,b,c){c||(c=0);var d=a.Af;if(p(b))for(var e=0;16>e;e++)d[e]=b.charCodeAt(c)<<24|b.charCodeAt(c+1)<<16|b.charCodeAt(c+2)<<8|b.charCodeAt(c+3),c+=4;else for(e=0;16>e;e++)d[e]=b[c]<<24|b[c+1]<<16|b[c+2]<<8|b[c+3],c+=4;for(e=16;80>e;e++){var f=d[e-3]^d[e-8]^d[e-14]^d[e-16];d[e]=(f<<1|f>>>31)&4294967295}b=a.M[0];c=a.M[1];for(var h=a.M[2],k=a.M[3],m=a.M[4],l,e=0;80>e;e++)40>e?20>e?(f=k^c&(h^k),l=1518500249):(f=c^h^k,l=1859775393):60>e?(f=c&h|k&(c|h),l=2400959708):(f=c^h^k,l=3395469782),f=(b<<
5|b>>>27)+f+m+l+d[e]&4294967295,m=k,k=h,h=(c<<30|c>>>2)&4294967295,c=b,b=f;a.M[0]=a.M[0]+b&4294967295;a.M[1]=a.M[1]+c&4294967295;a.M[2]=a.M[2]+h&4294967295;a.M[3]=a.M[3]+k&4294967295;a.M[4]=a.M[4]+m&4294967295}
ta.prototype.update=function(a,b){if(null!=a){n(b)||(b=a.length);for(var c=b-this.Wa,d=0,e=this.Wd,f=this.$b;d<b;){if(0==f)for(;d<=c;)ua(this,a,d),d+=this.Wa;if(p(a))for(;d<b;){if(e[f]=a.charCodeAt(d),++f,++d,f==this.Wa){ua(this,e);f=0;break}}else for(;d<b;)if(e[f]=a[d],++f,++d,f==this.Wa){ua(this,e);f=0;break}}this.$b=f;this.Pd+=b}};var r;a:{var va=aa.navigator;if(va){var wa=va.userAgent;if(wa){r=wa;break a}}r=""};var t=Array.prototype,xa=t.indexOf?function(a,b,c){return t.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(p(a))return p(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ya=t.forEach?function(a,b,c){t.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},za=t.filter?function(a,b,c){return t.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,h=p(a)?
a.split(""):a,k=0;k<d;k++)if(k in h){var m=h[k];b.call(c,m,k,a)&&(e[f++]=m)}return e},Aa=t.map?function(a,b,c){return t.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=p(a)?a.split(""):a,h=0;h<d;h++)h in f&&(e[h]=b.call(c,f[h],h,a));return e},Ba=t.reduce?function(a,b,c,d){for(var e=[],f=1,h=arguments.length;f<h;f++)e.push(arguments[f]);d&&(e[0]=q(b,d));return t.reduce.apply(a,e)}:function(a,b,c,d){var e=c;ya(a,function(c,h){e=b.call(d,e,c,h,a)});return e},Ca=t.every?function(a,b,
c){return t.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};function Da(a,b){var c=Ea(a,b,void 0);return 0>c?null:p(a)?a.charAt(c):a[c]}function Ea(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}function Fa(a,b){var c=xa(a,b);0<=c&&t.splice.call(a,c,1)}function Ga(a,b,c){return 2>=arguments.length?t.slice.call(a,b):t.slice.call(a,b,c)}
function Ha(a,b){a.sort(b||Ia)}function Ia(a,b){return a>b?1:a<b?-1:0};function v(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ja(a,b){var c={},d;for(d in a)c[d]=b.call(void 0,a[d],d,a);return c}function Ka(a,b){for(var c in a)if(!b.call(void 0,a[c],c,a))return!1;return!0}function La(a){var b=0,c;for(c in a)b++;return b}function Ma(a){for(var b in a)return b}function Na(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Oa(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Pa(a,b){for(var c in a)if(a[c]==b)return!0;return!1}
function Qa(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d}function Ra(a,b){var c=Qa(a,b,void 0);return c&&a[c]}function Sa(a){for(var b in a)return!1;return!0}function Ta(a){var b={},c;for(c in a)b[c]=a[c];return b};var Ua=-1!=r.indexOf("Opera")||-1!=r.indexOf("OPR"),Va=-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE"),Wa=-1!=r.indexOf("Gecko")&&-1==r.toLowerCase().indexOf("webkit")&&!(-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE")),Xa=-1!=r.toLowerCase().indexOf("webkit");
(function(){var a="",b;if(Ua&&aa.opera)return a=aa.opera.version,ha(a)?a():a;Wa?b=/rv\:([^\);]+)(\)|;)/:Va?b=/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/:Xa&&(b=/WebKit\/(\S+)/);b&&(a=(a=b.exec(r))?a[1]:"");return Va&&(b=(b=aa.document)?b.documentMode:void 0,b>parseFloat(a))?String(b):a})();var Ya=null,Za=null,$a=null;function ab(a,b){if(!fa(a))throw Error("encodeByteArray takes an array as a parameter");bb();for(var c=b?Za:Ya,d=[],e=0;e<a.length;e+=3){var f=a[e],h=e+1<a.length,k=h?a[e+1]:0,m=e+2<a.length,l=m?a[e+2]:0,u=f>>2,f=(f&3)<<4|k>>4,k=(k&15)<<2|l>>6,l=l&63;m||(l=64,h||(k=64));d.push(c[u],c[f],c[k],c[l])}return d.join("")}
function bb(){if(!Ya){Ya={};Za={};$a={};for(var a=0;65>a;a++)Ya[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Za[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a),$a[Za[a]]=a,62<=a&&($a["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a)]=a)}};function cb(a,b){if(!a)throw db(b);}function db(a){return Error("Firebase Database ("+firebase.SDK_VERSION+") INTERNAL ASSERT FAILED: "+a)};function eb(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function w(a,b){if(Object.prototype.hasOwnProperty.call(a,b))return a[b]}function fb(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])};function gb(a){var b=[];fb(a,function(a,d){ea(d)?ya(d,function(d){b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))}):b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))});return b.length?"&"+b.join("&"):""};var hb=firebase.Promise;function ib(){var a=this;this.reject=this.resolve=null;this.ra=new hb(function(b,c){a.resolve=b;a.reject=c})}function jb(a,b){return function(c,d){c?a.reject(c):a.resolve(d);ha(b)&&(kb(a.ra),1===b.length?b(c):b(c,d))}}function kb(a){a.then(void 0,ba)};function lb(a){return"undefined"!==typeof JSON&&n(JSON.parse)?JSON.parse(a):ma(a)}function x(a){if("undefined"!==typeof JSON&&n(JSON.stringify))a=JSON.stringify(a);else{var b=[];oa(new na,a,b);a=b.join("")}return a};function mb(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);55296<=e&&56319>=e&&(e-=55296,d++,cb(d<a.length,"Surrogate pair missing trail surrogate."),e=65536+(e<<10)+(a.charCodeAt(d)-56320));128>e?b[c++]=e:(2048>e?b[c++]=e>>6|192:(65536>e?b[c++]=e>>12|224:(b[c++]=e>>18|240,b[c++]=e>>12&63|128),b[c++]=e>>6&63|128),b[c++]=e&63|128)}return b}function nb(a){for(var b=0,c=0;c<a.length;c++){var d=a.charCodeAt(c);128>d?b++:2048>d?b+=2:55296<=d&&56319>=d?(b+=4,c++):b+=3}return b};function y(a,b,c,d){var e;d<b?e="at least "+b:d>c&&(e=0===c?"none":"no more than "+c);if(e)throw Error(a+" failed: Was called with "+d+(1===d?" argument.":" arguments.")+" Expects "+e+".");}function A(a,b,c){var d="";switch(b){case 1:d=c?"first":"First";break;case 2:d=c?"second":"Second";break;case 3:d=c?"third":"Third";break;case 4:d=c?"fourth":"Fourth";break;default:throw Error("errorPrefix called with argumentNumber > 4.  Need to update it?");}return a=a+" failed: "+(d+" argument ")}
function B(a,b,c,d){if((!d||n(c))&&!ha(c))throw Error(A(a,b,d)+"must be a valid function.");}function ob(a,b,c){if(n(c)&&(!ia(c)||null===c))throw Error(A(a,b,!0)+"must be a valid context object.");};function pb(){return"undefined"!==typeof window&&!!(window.cordova||window.phonegap||window.PhoneGap)&&/ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test("undefined"!==typeof navigator&&"string"===typeof navigator.userAgent?navigator.userAgent:"")};function C(a,b){this.name=a;this.R=b}function qb(a,b){return new C(a,b)};function rb(a,b){return sb(a.name,b.name)}function tb(a,b){return sb(a,b)};function ub(a){this.uc=a;this.Cd="firebase:"}g=ub.prototype;g.set=function(a,b){null==b?this.uc.removeItem(this.Cd+a):this.uc.setItem(this.Cd+a,x(b))};g.get=function(a){a=this.uc.getItem(this.Cd+a);return null==a?null:lb(a)};g.remove=function(a){this.uc.removeItem(this.Cd+a)};g.Ze=!1;g.toString=function(){return this.uc.toString()};function vb(){this.pc={}}vb.prototype.set=function(a,b){null==b?delete this.pc[a]:this.pc[a]=b};vb.prototype.get=function(a){return eb(this.pc,a)?this.pc[a]:null};vb.prototype.remove=function(a){delete this.pc[a]};vb.prototype.Ze=!0;function wb(a){try{if("undefined"!==typeof window&&"undefined"!==typeof window[a]){var b=window[a];b.setItem("firebase:sentinel","cache");b.removeItem("firebase:sentinel");return new ub(b)}}catch(c){}return new vb}var xb=wb("localStorage"),yb=wb("sessionStorage");function zb(a,b,c,d,e){this.host=a.toLowerCase();this.domain=this.host.substr(this.host.indexOf(".")+1);this.Sc=b;this.pe=c;this.qg=d;this.gf=e||"";this.$a=xb.get("host:"+a)||this.host}function Ab(a,b){b!==a.$a&&(a.$a=b,"s-"===a.$a.substr(0,2)&&xb.set("host:"+a.host,a.$a))}
function Bb(a,b,c){D("string"===typeof b,"typeof type must == string");D("object"===typeof c,"typeof params must == object");if(b===Cb)b=(a.Sc?"wss://":"ws://")+a.$a+"/.ws?";else if(b===Db)b=(a.Sc?"https://":"http://")+a.$a+"/.lp?";else throw Error("Unknown connection type: "+b);a.host!==a.$a&&(c.ns=a.pe);var d=[];v(c,function(a,b){d.push(b+"="+a)});return b+d.join("&")}zb.prototype.toString=function(){var a=(this.Sc?"https://":"http://")+this.host;this.gf&&(a+="<"+this.gf+">");return a};function Eb(a,b){return a&&"object"===typeof a?(D(".sv"in a,"Unexpected leaf node or priority contents"),b[a[".sv"]]):a}function Fb(a,b){var c=new Gb;Hb(a,new E(""),function(a,e){Ib(c,a,Jb(e,b))});return c}function Jb(a,b){var c=a.C().H(),c=Eb(c,b),d;if(a.J()){var e=Eb(a.Ca(),b);return e!==a.Ca()||c!==a.C().H()?new Kb(e,G(c)):a}d=a;c!==a.C().H()&&(d=d.fa(new Kb(c)));a.O(H,function(a,c){var e=Jb(c,b);e!==c&&(d=d.T(a,e))});return d};var Lb=function(){var a=1;return function(){return a++}}(),D=cb,Mb=db;
function Nb(a){try{var b;bb();for(var c=$a,d=[],e=0;e<a.length;){var f=c[a.charAt(e++)],h=e<a.length?c[a.charAt(e)]:0;++e;var k=e<a.length?c[a.charAt(e)]:64;++e;var m=e<a.length?c[a.charAt(e)]:64;++e;if(null==f||null==h||null==k||null==m)throw Error();d.push(f<<2|h>>4);64!=k&&(d.push(h<<4&240|k>>2),64!=m&&d.push(k<<6&192|m))}if(8192>d.length)b=String.fromCharCode.apply(null,d);else{a="";for(c=0;c<d.length;c+=8192)a+=String.fromCharCode.apply(null,Ga(d,c,c+8192));b=a}return b}catch(l){I("base64Decode failed: ",
l)}return null}function Ob(a){var b=mb(a);a=new ta;a.update(b);var b=[],c=8*a.Pd;56>a.$b?a.update(a.zd,56-a.$b):a.update(a.zd,a.Wa-(a.$b-56));for(var d=a.Wa-1;56<=d;d--)a.Wd[d]=c&255,c/=256;ua(a,a.Wd);for(d=c=0;5>d;d++)for(var e=24;0<=e;e-=8)b[c]=a.M[d]>>e&255,++c;return ab(b)}function Pb(a){for(var b="",c=0;c<arguments.length;c++)b=fa(arguments[c])?b+Pb.apply(null,arguments[c]):"object"===typeof arguments[c]?b+x(arguments[c]):b+arguments[c],b+=" ";return b}var Qb=null,Rb=!0;
function Sb(a,b){cb(!b||!0===a||!1===a,"Can't turn on custom loggers persistently.");!0===a?("undefined"!==typeof console&&("function"===typeof console.log?Qb=q(console.log,console):"object"===typeof console.log&&(Qb=function(a){console.log(a)})),b&&yb.set("logging_enabled",!0)):ha(a)?Qb=a:(Qb=null,yb.remove("logging_enabled"))}function I(a){!0===Rb&&(Rb=!1,null===Qb&&!0===yb.get("logging_enabled")&&Sb(!0));if(Qb){var b=Pb.apply(null,arguments);Qb(b)}}
function Tb(a){return function(){I(a,arguments)}}function Ub(a){if("undefined"!==typeof console){var b="FIREBASE INTERNAL ERROR: "+Pb.apply(null,arguments);"undefined"!==typeof console.error?console.error(b):console.log(b)}}function Vb(a){var b=Pb.apply(null,arguments);throw Error("FIREBASE FATAL ERROR: "+b);}function J(a){if("undefined"!==typeof console){var b="FIREBASE WARNING: "+Pb.apply(null,arguments);"undefined"!==typeof console.warn?console.warn(b):console.log(b)}}
function Wb(a){var b,c,d,e,f,h=a;f=c=a=b="";d=!0;e="https";if(p(h)){var k=h.indexOf("//");0<=k&&(e=h.substring(0,k-1),h=h.substring(k+2));k=h.indexOf("/");-1===k&&(k=h.length);b=h.substring(0,k);f="";h=h.substring(k).split("/");for(k=0;k<h.length;k++)if(0<h[k].length){var m=h[k];try{m=decodeURIComponent(m.replace(/\+/g," "))}catch(l){}f+="/"+m}h=b.split(".");3===h.length?(a=h[1],c=h[0].toLowerCase()):2===h.length&&(a=h[0]);k=b.indexOf(":");0<=k&&(d="https"===e||"wss"===e)}"firebase"===a&&Vb(b+" is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
c&&"undefined"!=c||Vb("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");d||"undefined"!==typeof window&&window.location&&window.location.protocol&&-1!==window.location.protocol.indexOf("https:")&&J("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");return{jc:new zb(b,d,c,"ws"===e||"wss"===e),path:new E(f)}}function Xb(a){return ga(a)&&(a!=a||a==Number.POSITIVE_INFINITY||a==Number.NEGATIVE_INFINITY)}
function Yb(a){if("complete"===document.readyState)a();else{var b=!1,c=function(){document.body?b||(b=!0,a()):setTimeout(c,Math.floor(10))};document.addEventListener?(document.addEventListener("DOMContentLoaded",c,!1),window.addEventListener("load",c,!1)):document.attachEvent&&(document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&c()}),window.attachEvent("onload",c))}}
function sb(a,b){if(a===b)return 0;if("[MIN_NAME]"===a||"[MAX_NAME]"===b)return-1;if("[MIN_NAME]"===b||"[MAX_NAME]"===a)return 1;var c=Zb(a),d=Zb(b);return null!==c?null!==d?0==c-d?a.length-b.length:c-d:-1:null!==d?1:a<b?-1:1}function $b(a,b){if(b&&a in b)return b[a];throw Error("Missing required key ("+a+") in object: "+x(b));}
function ac(a){if("object"!==typeof a||null===a)return x(a);var b=[],c;for(c in a)b.push(c);b.sort();c="{";for(var d=0;d<b.length;d++)0!==d&&(c+=","),c+=x(b[d]),c+=":",c+=ac(a[b[d]]);return c+"}"}function bc(a,b){if(a.length<=b)return[a];for(var c=[],d=0;d<a.length;d+=b)d+b>a?c.push(a.substring(d,a.length)):c.push(a.substring(d,d+b));return c}function cc(a,b){if(ea(a))for(var c=0;c<a.length;++c)b(c,a[c]);else v(a,b)}
function dc(a){D(!Xb(a),"Invalid JSON number");var b,c,d,e;0===a?(d=c=0,b=-Infinity===1/a?1:0):(b=0>a,a=Math.abs(a),a>=Math.pow(2,-1022)?(d=Math.min(Math.floor(Math.log(a)/Math.LN2),1023),c=d+1023,d=Math.round(a*Math.pow(2,52-d)-Math.pow(2,52))):(c=0,d=Math.round(a/Math.pow(2,-1074))));e=[];for(a=52;a;--a)e.push(d%2?1:0),d=Math.floor(d/2);for(a=11;a;--a)e.push(c%2?1:0),c=Math.floor(c/2);e.push(b?1:0);e.reverse();b=e.join("");c="";for(a=0;64>a;a+=8)d=parseInt(b.substr(a,8),2).toString(16),1===d.length&&
(d="0"+d),c+=d;return c.toLowerCase()}var ec=/^-?\d{1,10}$/;function Zb(a){return ec.test(a)&&(a=Number(a),-2147483648<=a&&2147483647>=a)?a:null}function fc(a){try{a()}catch(b){setTimeout(function(){J("Exception was thrown by user callback.",b.stack||"");throw b;},Math.floor(0))}}function gc(a,b,c){Object.defineProperty(a,b,{get:c})}function hc(a,b){var c=setTimeout(a,b);"object"===typeof c&&c.unref&&c.unref();return c};function ic(a){var b={},c={},d={},e="";try{var f=a.split("."),b=lb(Nb(f[0])||""),c=lb(Nb(f[1])||""),e=f[2],d=c.d||{};delete c.d}catch(h){}return{tg:b,Je:c,data:d,mg:e}}function jc(a){a=ic(a);var b=a.Je;return!!a.mg&&!!b&&"object"===typeof b&&b.hasOwnProperty("iat")}function kc(a){a=ic(a).Je;return"object"===typeof a&&!0===w(a,"admin")};function lc(){}var mc={};function nc(a){return q(a.compare,a)}lc.prototype.nd=function(a,b){return 0!==this.compare(new C("[MIN_NAME]",a),new C("[MIN_NAME]",b))};lc.prototype.Hc=function(){return oc};function pc(a){D(!a.e()&&".priority"!==K(a),"Can't create PathIndex with empty path or .priority key");this.bc=a}la(pc,lc);g=pc.prototype;g.xc=function(a){return!a.P(this.bc).e()};g.compare=function(a,b){var c=a.R.P(this.bc),d=b.R.P(this.bc),c=c.sc(d);return 0===c?sb(a.name,b.name):c};
g.Ec=function(a,b){var c=G(a),c=L.F(this.bc,c);return new C(b,c)};g.Fc=function(){var a=L.F(this.bc,qc);return new C("[MAX_NAME]",a)};g.toString=function(){return this.bc.slice().join("/")};function rc(){}la(rc,lc);g=rc.prototype;g.compare=function(a,b){var c=a.R.C(),d=b.R.C(),c=c.sc(d);return 0===c?sb(a.name,b.name):c};g.xc=function(a){return!a.C().e()};g.nd=function(a,b){return!a.C().Z(b.C())};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",new Kb("[PRIORITY-POST]",qc))};
g.Ec=function(a,b){var c=G(a);return new C(b,new Kb("[PRIORITY-POST]",c))};g.toString=function(){return".priority"};var H=new rc;function sc(){}la(sc,lc);g=sc.prototype;g.compare=function(a,b){return sb(a.name,b.name)};g.xc=function(){throw Mb("KeyIndex.isDefinedOn not expected to be called.");};g.nd=function(){return!1};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",L)};g.Ec=function(a){D(p(a),"KeyIndex indexValue must always be a string.");return new C(a,L)};g.toString=function(){return".key"};
var tc=new sc;function uc(){}la(uc,lc);g=uc.prototype;g.compare=function(a,b){var c=a.R.sc(b.R);return 0===c?sb(a.name,b.name):c};g.xc=function(){return!0};g.nd=function(a,b){return!a.Z(b)};g.Hc=function(){return oc};g.Fc=function(){return vc};g.Ec=function(a,b){var c=G(a);return new C(b,c)};g.toString=function(){return".value"};var wc=new uc;function xc(a,b){this.od=a;this.cc=b}xc.prototype.get=function(a){var b=w(this.od,a);if(!b)throw Error("No index defined for "+a);return b===mc?null:b};function yc(a,b,c){var d=Ja(a.od,function(d,f){var h=w(a.cc,f);D(h,"Missing index implementation for "+f);if(d===mc){if(h.xc(b.R)){for(var k=[],m=c.Wb(qb),l=M(m);l;)l.name!=b.name&&k.push(l),l=M(m);k.push(b);return zc(k,nc(h))}return mc}h=c.get(b.name);k=d;h&&(k=k.remove(new C(b.name,h)));return k.Oa(b,b.R)});return new xc(d,a.cc)}
function Ac(a,b,c){var d=Ja(a.od,function(a){if(a===mc)return a;var d=c.get(b.name);return d?a.remove(new C(b.name,d)):a});return new xc(d,a.cc)}var Bc=new xc({".priority":mc},{".priority":H});function Kb(a,b){this.B=a;D(n(this.B)&&null!==this.B,"LeafNode shouldn't be created with null/undefined value.");this.aa=b||L;Cc(this.aa);this.Db=null}var Dc=["object","boolean","number","string"];g=Kb.prototype;g.J=function(){return!0};g.C=function(){return this.aa};g.fa=function(a){return new Kb(this.B,a)};g.Q=function(a){return".priority"===a?this.aa:L};g.P=function(a){return a.e()?this:".priority"===K(a)?this.aa:L};g.Da=function(){return!1};g.Ve=function(){return null};
g.T=function(a,b){return".priority"===a?this.fa(b):b.e()&&".priority"!==a?this:L.T(a,b).fa(this.aa)};g.F=function(a,b){var c=K(a);if(null===c)return b;if(b.e()&&".priority"!==c)return this;D(".priority"!==c||1===Ec(a),".priority must be the last token in a path");return this.T(c,L.F(N(a),b))};g.e=function(){return!1};g.Eb=function(){return 0};g.O=function(){return!1};g.H=function(a){return a&&!this.C().e()?{".value":this.Ca(),".priority":this.C().H()}:this.Ca()};
g.hash=function(){if(null===this.Db){var a="";this.aa.e()||(a+="priority:"+Fc(this.aa.H())+":");var b=typeof this.B,a=a+(b+":"),a="number"===b?a+dc(this.B):a+this.B;this.Db=Ob(a)}return this.Db};g.Ca=function(){return this.B};g.sc=function(a){if(a===L)return 1;if(a instanceof O)return-1;D(a.J(),"Unknown node type");var b=typeof a.B,c=typeof this.B,d=xa(Dc,b),e=xa(Dc,c);D(0<=d,"Unknown leaf type: "+b);D(0<=e,"Unknown leaf type: "+c);return d===e?"object"===c?0:this.B<a.B?-1:this.B===a.B?0:1:e-d};
g.nb=function(){return this};g.yc=function(){return!0};g.Z=function(a){return a===this?!0:a.J()?this.B===a.B&&this.aa.Z(a.aa):!1};g.toString=function(){return x(this.H(!0))};function Gc(){this.set={}}g=Gc.prototype;g.add=function(a,b){this.set[a]=null!==b?b:!0};g.contains=function(a){return eb(this.set,a)};g.get=function(a){return this.contains(a)?this.set[a]:void 0};g.remove=function(a){delete this.set[a]};g.clear=function(){this.set={}};g.e=function(){return Sa(this.set)};g.count=function(){return La(this.set)};function Hc(a,b){v(a.set,function(a,d){b(d,a)})}g.keys=function(){var a=[];v(this.set,function(b,c){a.push(c)});return a};function Ic(a){D(ea(a)&&0<a.length,"Requires a non-empty array");this.Bf=a;this.Dc={}}Ic.prototype.Ge=function(a,b){var c;c=this.Dc[a]||[];var d=c.length;if(0<d){for(var e=Array(d),f=0;f<d;f++)e[f]=c[f];c=e}else c=[];for(d=0;d<c.length;d++)c[d].Ie.apply(c[d].Ma,Array.prototype.slice.call(arguments,1))};Ic.prototype.gc=function(a,b,c){Jc(this,a);this.Dc[a]=this.Dc[a]||[];this.Dc[a].push({Ie:b,Ma:c});(a=this.Ue(a))&&b.apply(c,a)};
Ic.prototype.Ic=function(a,b,c){Jc(this,a);a=this.Dc[a]||[];for(var d=0;d<a.length;d++)if(a[d].Ie===b&&(!c||c===a[d].Ma)){a.splice(d,1);break}};function Jc(a,b){D(Da(a.Bf,function(a){return a===b}),"Unknown event: "+b)};var Kc=function(){var a=0,b=[];return function(c){var d=c===a;a=c;for(var e=Array(8),f=7;0<=f;f--)e[f]="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(c%64),c=Math.floor(c/64);D(0===c,"Cannot push at time == 0");c=e.join("");if(d){for(f=11;0<=f&&63===b[f];f--)b[f]=0;b[f]++}else for(f=0;12>f;f++)b[f]=Math.floor(64*Math.random());for(f=0;12>f;f++)c+="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(b[f]);D(20===c.length,"nextPushId: Length should be 20.");
return c}}();function Lc(){Ic.call(this,["online"]);this.hc=!0;if("undefined"!==typeof window&&"undefined"!==typeof window.addEventListener&&!pb()){var a=this;window.addEventListener("online",function(){a.hc||(a.hc=!0,a.Ge("online",!0))},!1);window.addEventListener("offline",function(){a.hc&&(a.hc=!1,a.Ge("online",!1))},!1)}}la(Lc,Ic);Lc.prototype.Ue=function(a){D("online"===a,"Unknown event type: "+a);return[this.hc]};ca(Lc);function Mc(){Ic.call(this,["visible"]);var a,b;"undefined"!==typeof document&&"undefined"!==typeof document.addEventListener&&("undefined"!==typeof document.hidden?(b="visibilitychange",a="hidden"):"undefined"!==typeof document.mozHidden?(b="mozvisibilitychange",a="mozHidden"):"undefined"!==typeof document.msHidden?(b="msvisibilitychange",a="msHidden"):"undefined"!==typeof document.webkitHidden&&(b="webkitvisibilitychange",a="webkitHidden"));this.Mb=!0;if(b){var c=this;document.addEventListener(b,
function(){var b=!document[a];b!==c.Mb&&(c.Mb=b,c.Ge("visible",b))},!1)}}la(Mc,Ic);Mc.prototype.Ue=function(a){D("visible"===a,"Unknown event type: "+a);return[this.Mb]};ca(Mc);function E(a,b){if(1==arguments.length){this.o=a.split("/");for(var c=0,d=0;d<this.o.length;d++)0<this.o[d].length&&(this.o[c]=this.o[d],c++);this.o.length=c;this.Y=0}else this.o=a,this.Y=b}function P(a,b){var c=K(a);if(null===c)return b;if(c===K(b))return P(N(a),N(b));throw Error("INTERNAL ERROR: innerPath ("+b+") is not within outerPath ("+a+")");}
function Nc(a,b){for(var c=a.slice(),d=b.slice(),e=0;e<c.length&&e<d.length;e++){var f=sb(c[e],d[e]);if(0!==f)return f}return c.length===d.length?0:c.length<d.length?-1:1}function K(a){return a.Y>=a.o.length?null:a.o[a.Y]}function Ec(a){return a.o.length-a.Y}function N(a){var b=a.Y;b<a.o.length&&b++;return new E(a.o,b)}function Oc(a){return a.Y<a.o.length?a.o[a.o.length-1]:null}g=E.prototype;
g.toString=function(){for(var a="",b=this.Y;b<this.o.length;b++)""!==this.o[b]&&(a+="/"+this.o[b]);return a||"/"};g.slice=function(a){return this.o.slice(this.Y+(a||0))};g.parent=function(){if(this.Y>=this.o.length)return null;for(var a=[],b=this.Y;b<this.o.length-1;b++)a.push(this.o[b]);return new E(a,0)};
g.n=function(a){for(var b=[],c=this.Y;c<this.o.length;c++)b.push(this.o[c]);if(a instanceof E)for(c=a.Y;c<a.o.length;c++)b.push(a.o[c]);else for(a=a.split("/"),c=0;c<a.length;c++)0<a[c].length&&b.push(a[c]);return new E(b,0)};g.e=function(){return this.Y>=this.o.length};g.Z=function(a){if(Ec(this)!==Ec(a))return!1;for(var b=this.Y,c=a.Y;b<=this.o.length;b++,c++)if(this.o[b]!==a.o[c])return!1;return!0};
g.contains=function(a){var b=this.Y,c=a.Y;if(Ec(this)>Ec(a))return!1;for(;b<this.o.length;){if(this.o[b]!==a.o[c])return!1;++b;++c}return!0};var Q=new E("");function Pc(a,b){this.Qa=a.slice();this.Ha=Math.max(1,this.Qa.length);this.Qe=b;for(var c=0;c<this.Qa.length;c++)this.Ha+=nb(this.Qa[c]);Qc(this)}Pc.prototype.push=function(a){0<this.Qa.length&&(this.Ha+=1);this.Qa.push(a);this.Ha+=nb(a);Qc(this)};Pc.prototype.pop=function(){var a=this.Qa.pop();this.Ha-=nb(a);0<this.Qa.length&&--this.Ha};
function Qc(a){if(768<a.Ha)throw Error(a.Qe+"has a key path longer than 768 bytes ("+a.Ha+").");if(32<a.Qa.length)throw Error(a.Qe+"path specified exceeds the maximum depth that can be written (32) or object contains a cycle "+Rc(a));}function Rc(a){return 0==a.Qa.length?"":"in property '"+a.Qa.join(".")+"'"};function Sc(){this.children={};this.bd=0;this.value=null}function Tc(a,b,c){this.ud=a?a:"";this.Pc=b?b:null;this.A=c?c:new Sc}function Uc(a,b){for(var c=b instanceof E?b:new E(b),d=a,e;null!==(e=K(c));)d=new Tc(e,d,w(d.A.children,e)||new Sc),c=N(c);return d}g=Tc.prototype;g.Ca=function(){return this.A.value};function Vc(a,b){D("undefined"!==typeof b,"Cannot set value to undefined");a.A.value=b;Wc(a)}g.clear=function(){this.A.value=null;this.A.children={};this.A.bd=0;Wc(this)};
g.kd=function(){return 0<this.A.bd};g.e=function(){return null===this.Ca()&&!this.kd()};g.O=function(a){var b=this;v(this.A.children,function(c,d){a(new Tc(d,b,c))})};function Xc(a,b,c,d){c&&!d&&b(a);a.O(function(a){Xc(a,b,!0,d)});c&&d&&b(a)}function Yc(a,b){for(var c=a.parent();null!==c&&!b(c);)c=c.parent()}g.path=function(){return new E(null===this.Pc?this.ud:this.Pc.path()+"/"+this.ud)};g.name=function(){return this.ud};g.parent=function(){return this.Pc};
function Wc(a){if(null!==a.Pc){var b=a.Pc,c=a.ud,d=a.e(),e=eb(b.A.children,c);d&&e?(delete b.A.children[c],b.A.bd--,Wc(b)):d||e||(b.A.children[c]=a.A,b.A.bd++,Wc(b))}};function Zc(a,b){this.La=a;this.ba=b?b:$c}g=Zc.prototype;g.Oa=function(a,b){return new Zc(this.La,this.ba.Oa(a,b,this.La).X(null,null,!1,null,null))};g.remove=function(a){return new Zc(this.La,this.ba.remove(a,this.La).X(null,null,!1,null,null))};g.get=function(a){for(var b,c=this.ba;!c.e();){b=this.La(a,c.key);if(0===b)return c.value;0>b?c=c.left:0<b&&(c=c.right)}return null};
function ad(a,b){for(var c,d=a.ba,e=null;!d.e();){c=a.La(b,d.key);if(0===c){if(d.left.e())return e?e.key:null;for(d=d.left;!d.right.e();)d=d.right;return d.key}0>c?d=d.left:0<c&&(e=d,d=d.right)}throw Error("Attempted to find predecessor key for a nonexistent key.  What gives?");}g.e=function(){return this.ba.e()};g.count=function(){return this.ba.count()};g.Gc=function(){return this.ba.Gc()};g.ec=function(){return this.ba.ec()};g.ha=function(a){return this.ba.ha(a)};
g.Wb=function(a){return new bd(this.ba,null,this.La,!1,a)};g.Xb=function(a,b){return new bd(this.ba,a,this.La,!1,b)};g.Zb=function(a,b){return new bd(this.ba,a,this.La,!0,b)};g.We=function(a){return new bd(this.ba,null,this.La,!0,a)};function bd(a,b,c,d,e){this.Hd=e||null;this.le=d;this.Pa=[];for(e=1;!a.e();)if(e=b?c(a.key,b):1,d&&(e*=-1),0>e)a=this.le?a.left:a.right;else if(0===e){this.Pa.push(a);break}else this.Pa.push(a),a=this.le?a.right:a.left}
function M(a){if(0===a.Pa.length)return null;var b=a.Pa.pop(),c;c=a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value};if(a.le)for(b=b.left;!b.e();)a.Pa.push(b),b=b.right;else for(b=b.right;!b.e();)a.Pa.push(b),b=b.left;return c}function cd(a){if(0===a.Pa.length)return null;var b;b=a.Pa;b=b[b.length-1];return a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value}}function dd(a,b,c,d,e){this.key=a;this.value=b;this.color=null!=c?c:!0;this.left=null!=d?d:$c;this.right=null!=e?e:$c}g=dd.prototype;
g.X=function(a,b,c,d,e){return new dd(null!=a?a:this.key,null!=b?b:this.value,null!=c?c:this.color,null!=d?d:this.left,null!=e?e:this.right)};g.count=function(){return this.left.count()+1+this.right.count()};g.e=function(){return!1};g.ha=function(a){return this.left.ha(a)||a(this.key,this.value)||this.right.ha(a)};function ed(a){return a.left.e()?a:ed(a.left)}g.Gc=function(){return ed(this).key};g.ec=function(){return this.right.e()?this.key:this.right.ec()};
g.Oa=function(a,b,c){var d,e;e=this;d=c(a,e.key);e=0>d?e.X(null,null,null,e.left.Oa(a,b,c),null):0===d?e.X(null,b,null,null,null):e.X(null,null,null,null,e.right.Oa(a,b,c));return gd(e)};function hd(a){if(a.left.e())return $c;a.left.ea()||a.left.left.ea()||(a=id(a));a=a.X(null,null,null,hd(a.left),null);return gd(a)}
g.remove=function(a,b){var c,d;c=this;if(0>b(a,c.key))c.left.e()||c.left.ea()||c.left.left.ea()||(c=id(c)),c=c.X(null,null,null,c.left.remove(a,b),null);else{c.left.ea()&&(c=jd(c));c.right.e()||c.right.ea()||c.right.left.ea()||(c=kd(c),c.left.left.ea()&&(c=jd(c),c=kd(c)));if(0===b(a,c.key)){if(c.right.e())return $c;d=ed(c.right);c=c.X(d.key,d.value,null,null,hd(c.right))}c=c.X(null,null,null,null,c.right.remove(a,b))}return gd(c)};g.ea=function(){return this.color};
function gd(a){a.right.ea()&&!a.left.ea()&&(a=ld(a));a.left.ea()&&a.left.left.ea()&&(a=jd(a));a.left.ea()&&a.right.ea()&&(a=kd(a));return a}function id(a){a=kd(a);a.right.left.ea()&&(a=a.X(null,null,null,null,jd(a.right)),a=ld(a),a=kd(a));return a}function ld(a){return a.right.X(null,null,a.color,a.X(null,null,!0,null,a.right.left),null)}function jd(a){return a.left.X(null,null,a.color,null,a.X(null,null,!0,a.left.right,null))}
function kd(a){return a.X(null,null,!a.color,a.left.X(null,null,!a.left.color,null,null),a.right.X(null,null,!a.right.color,null,null))}function md(){}g=md.prototype;g.X=function(){return this};g.Oa=function(a,b){return new dd(a,b,null)};g.remove=function(){return this};g.count=function(){return 0};g.e=function(){return!0};g.ha=function(){return!1};g.Gc=function(){return null};g.ec=function(){return null};g.ea=function(){return!1};var $c=new md;function O(a,b,c){this.k=a;(this.aa=b)&&Cc(this.aa);a.e()&&D(!this.aa||this.aa.e(),"An empty node cannot have a priority");this.yb=c;this.Db=null}g=O.prototype;g.J=function(){return!1};g.C=function(){return this.aa||L};g.fa=function(a){return this.k.e()?this:new O(this.k,a,this.yb)};g.Q=function(a){if(".priority"===a)return this.C();a=this.k.get(a);return null===a?L:a};g.P=function(a){var b=K(a);return null===b?this:this.Q(b).P(N(a))};g.Da=function(a){return null!==this.k.get(a)};
g.T=function(a,b){D(b,"We should always be passing snapshot nodes");if(".priority"===a)return this.fa(b);var c=new C(a,b),d,e;b.e()?(d=this.k.remove(a),c=Ac(this.yb,c,this.k)):(d=this.k.Oa(a,b),c=yc(this.yb,c,this.k));e=d.e()?L:this.aa;return new O(d,e,c)};g.F=function(a,b){var c=K(a);if(null===c)return b;D(".priority"!==K(a)||1===Ec(a),".priority must be the last token in a path");var d=this.Q(c).F(N(a),b);return this.T(c,d)};g.e=function(){return this.k.e()};g.Eb=function(){return this.k.count()};
var nd=/^(0|[1-9]\d*)$/;g=O.prototype;g.H=function(a){if(this.e())return null;var b={},c=0,d=0,e=!0;this.O(H,function(f,h){b[f]=h.H(a);c++;e&&nd.test(f)?d=Math.max(d,Number(f)):e=!1});if(!a&&e&&d<2*c){var f=[],h;for(h in b)f[h]=b[h];return f}a&&!this.C().e()&&(b[".priority"]=this.C().H());return b};g.hash=function(){if(null===this.Db){var a="";this.C().e()||(a+="priority:"+Fc(this.C().H())+":");this.O(H,function(b,c){var d=c.hash();""!==d&&(a+=":"+b+":"+d)});this.Db=""===a?"":Ob(a)}return this.Db};
g.Ve=function(a,b,c){return(c=od(this,c))?(a=ad(c,new C(a,b)))?a.name:null:ad(this.k,a)};function pd(a,b){var c;c=(c=od(a,b))?(c=c.Gc())&&c.name:a.k.Gc();return c?new C(c,a.k.get(c)):null}function qd(a,b){var c;c=(c=od(a,b))?(c=c.ec())&&c.name:a.k.ec();return c?new C(c,a.k.get(c)):null}g.O=function(a,b){var c=od(this,a);return c?c.ha(function(a){return b(a.name,a.R)}):this.k.ha(b)};g.Wb=function(a){return this.Xb(a.Hc(),a)};
g.Xb=function(a,b){var c=od(this,b);if(c)return c.Xb(a,function(a){return a});for(var c=this.k.Xb(a.name,qb),d=cd(c);null!=d&&0>b.compare(d,a);)M(c),d=cd(c);return c};g.We=function(a){return this.Zb(a.Fc(),a)};g.Zb=function(a,b){var c=od(this,b);if(c)return c.Zb(a,function(a){return a});for(var c=this.k.Zb(a.name,qb),d=cd(c);null!=d&&0<b.compare(d,a);)M(c),d=cd(c);return c};g.sc=function(a){return this.e()?a.e()?0:-1:a.J()||a.e()?1:a===qc?-1:0};
g.nb=function(a){if(a===tc||Pa(this.yb.cc,a.toString()))return this;var b=this.yb,c=this.k;D(a!==tc,"KeyIndex always exists and isn't meant to be added to the IndexMap.");for(var d=[],e=!1,c=c.Wb(qb),f=M(c);f;)e=e||a.xc(f.R),d.push(f),f=M(c);d=e?zc(d,nc(a)):mc;e=a.toString();c=Ta(b.cc);c[e]=a;a=Ta(b.od);a[e]=d;return new O(this.k,this.aa,new xc(a,c))};g.yc=function(a){return a===tc||Pa(this.yb.cc,a.toString())};
g.Z=function(a){if(a===this)return!0;if(a.J())return!1;if(this.C().Z(a.C())&&this.k.count()===a.k.count()){var b=this.Wb(H);a=a.Wb(H);for(var c=M(b),d=M(a);c&&d;){if(c.name!==d.name||!c.R.Z(d.R))return!1;c=M(b);d=M(a)}return null===c&&null===d}return!1};function od(a,b){return b===tc?null:a.yb.get(b.toString())}g.toString=function(){return x(this.H(!0))};function G(a,b){if(null===a)return L;var c=null;"object"===typeof a&&".priority"in a?c=a[".priority"]:"undefined"!==typeof b&&(c=b);D(null===c||"string"===typeof c||"number"===typeof c||"object"===typeof c&&".sv"in c,"Invalid priority type found: "+typeof c);"object"===typeof a&&".value"in a&&null!==a[".value"]&&(a=a[".value"]);if("object"!==typeof a||".sv"in a)return new Kb(a,G(c));if(a instanceof Array){var d=L,e=a;v(e,function(a,b){if(eb(e,b)&&"."!==b.substring(0,1)){var c=G(a);if(c.J()||!c.e())d=
d.T(b,c)}});return d.fa(G(c))}var f=[],h=!1,k=a;fb(k,function(a){if("string"!==typeof a||"."!==a.substring(0,1)){var b=G(k[a]);b.e()||(h=h||!b.C().e(),f.push(new C(a,b)))}});if(0==f.length)return L;var m=zc(f,rb,function(a){return a.name},tb);if(h){var l=zc(f,nc(H));return new O(m,G(c),new xc({".priority":l},{".priority":H}))}return new O(m,G(c),Bc)}var rd=Math.log(2);
function sd(a){this.count=parseInt(Math.log(a+1)/rd,10);this.Oe=this.count-1;this.Cf=a+1&parseInt(Array(this.count+1).join("1"),2)}function td(a){var b=!(a.Cf&1<<a.Oe);a.Oe--;return b}
function zc(a,b,c,d){function e(b,d){var f=d-b;if(0==f)return null;if(1==f){var l=a[b],u=c?c(l):l;return new dd(u,l.R,!1,null,null)}var l=parseInt(f/2,10)+b,f=e(b,l),z=e(l+1,d),l=a[l],u=c?c(l):l;return new dd(u,l.R,!1,f,z)}a.sort(b);var f=function(b){function d(b,h){var k=u-b,z=u;u-=b;var z=e(k+1,z),k=a[k],F=c?c(k):k,z=new dd(F,k.R,h,null,z);f?f.left=z:l=z;f=z}for(var f=null,l=null,u=a.length,z=0;z<b.count;++z){var F=td(b),fd=Math.pow(2,b.count-(z+1));F?d(fd,!1):(d(fd,!1),d(fd,!0))}return l}(new sd(a.length));
return null!==f?new Zc(d||b,f):new Zc(d||b)}function Fc(a){return"number"===typeof a?"number:"+dc(a):"string:"+a}function Cc(a){if(a.J()){var b=a.H();D("string"===typeof b||"number"===typeof b||"object"===typeof b&&eb(b,".sv"),"Priority must be a string or number.")}else D(a===qc||a.e(),"priority of unexpected type.");D(a===qc||a.C().e(),"Priority nodes can't have a priority of their own.")}var L=new O(new Zc(tb),null,Bc);function ud(){O.call(this,new Zc(tb),L,Bc)}la(ud,O);g=ud.prototype;
g.sc=function(a){return a===this?0:1};g.Z=function(a){return a===this};g.C=function(){return this};g.Q=function(){return L};g.e=function(){return!1};var qc=new ud,oc=new C("[MIN_NAME]",L),vc=new C("[MAX_NAME]",qc);function vd(a,b){this.value=a;this.children=b||wd}var wd=new Zc(function(a,b){return a===b?0:a<b?-1:1});function xd(a){var b=R;v(a,function(a,d){b=b.set(new E(d),a)});return b}g=vd.prototype;g.e=function(){return null===this.value&&this.children.e()};function yd(a,b,c){if(null!=a.value&&c(a.value))return{path:Q,value:a.value};if(b.e())return null;var d=K(b);a=a.children.get(d);return null!==a?(b=yd(a,N(b),c),null!=b?{path:(new E(d)).n(b.path),value:b.value}:null):null}
function zd(a,b){return yd(a,b,function(){return!0})}g.subtree=function(a){if(a.e())return this;var b=this.children.get(K(a));return null!==b?b.subtree(N(a)):R};g.set=function(a,b){if(a.e())return new vd(b,this.children);var c=K(a),d=(this.children.get(c)||R).set(N(a),b),c=this.children.Oa(c,d);return new vd(this.value,c)};
g.remove=function(a){if(a.e())return this.children.e()?R:new vd(null,this.children);var b=K(a),c=this.children.get(b);return c?(a=c.remove(N(a)),b=a.e()?this.children.remove(b):this.children.Oa(b,a),null===this.value&&b.e()?R:new vd(this.value,b)):this};g.get=function(a){if(a.e())return this.value;var b=this.children.get(K(a));return b?b.get(N(a)):null};
function Ad(a,b,c){if(b.e())return c;var d=K(b);b=Ad(a.children.get(d)||R,N(b),c);d=b.e()?a.children.remove(d):a.children.Oa(d,b);return new vd(a.value,d)}function Bd(a,b){return Cd(a,Q,b)}function Cd(a,b,c){var d={};a.children.ha(function(a,f){d[a]=Cd(f,b.n(a),c)});return c(b,a.value,d)}function Dd(a,b,c){return Ed(a,b,Q,c)}function Ed(a,b,c,d){var e=a.value?d(c,a.value):!1;if(e)return e;if(b.e())return null;e=K(b);return(a=a.children.get(e))?Ed(a,N(b),c.n(e),d):null}
function Fd(a,b,c){Gd(a,b,Q,c)}function Gd(a,b,c,d){if(b.e())return a;a.value&&d(c,a.value);var e=K(b);return(a=a.children.get(e))?Gd(a,N(b),c.n(e),d):R}function Hd(a,b){Id(a,Q,b)}function Id(a,b,c){a.children.ha(function(a,e){Id(e,b.n(a),c)});a.value&&c(b,a.value)}function Jd(a,b){a.children.ha(function(a,d){d.value&&b(a,d.value)})}var R=new vd(null);vd.prototype.toString=function(){var a={};Hd(this,function(b,c){a[b.toString()]=c.toString()});return x(a)};var Kd=/[\[\].#$\/\u0000-\u001F\u007F]/,Ld=/[\[\].#$\u0000-\u001F\u007F]/;function Md(a){return p(a)&&0!==a.length&&!Kd.test(a)}function Nd(a){return null===a||p(a)||ga(a)&&!Xb(a)||ia(a)&&eb(a,".sv")}function Od(a,b,c,d){d&&!n(b)||Pd(A(a,1,d),b,c)}
function Pd(a,b,c){c instanceof E&&(c=new Pc(c,a));if(!n(b))throw Error(a+"contains undefined "+Rc(c));if(ha(b))throw Error(a+"contains a function "+Rc(c)+" with contents: "+b.toString());if(Xb(b))throw Error(a+"contains "+b.toString()+" "+Rc(c));if(p(b)&&b.length>10485760/3&&10485760<nb(b))throw Error(a+"contains a string greater than 10485760 utf8 bytes "+Rc(c)+" ('"+b.substring(0,50)+"...')");if(ia(b)){var d=!1,e=!1;fb(b,function(b,h){if(".value"===b)d=!0;else if(".priority"!==b&&".sv"!==b&&(e=
!0,!Md(b)))throw Error(a+" contains an invalid key ("+b+") "+Rc(c)+'.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');c.push(b);Pd(a,h,c);c.pop()});if(d&&e)throw Error(a+' contains ".value" child '+Rc(c)+" in addition to actual children.");}}
function Qd(a,b){var c,d;for(c=0;c<b.length;c++){d=b[c];for(var e=d.slice(),f=0;f<e.length;f++)if((".priority"!==e[f]||f!==e.length-1)&&!Md(e[f]))throw Error(a+"contains an invalid key ("+e[f]+") in path "+d.toString()+'. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');}b.sort(Nc);e=null;for(c=0;c<b.length;c++){d=b[c];if(null!==e&&e.contains(d))throw Error(a+"contains a path "+e.toString()+" that is ancestor of another path "+d.toString());e=d}}
function Rd(a,b,c){var d=A(a,1,!1);if(!ia(b)||ea(b))throw Error(d+" must be an object containing the children to replace.");var e=[];fb(b,function(a,b){var k=new E(a);Pd(d,b,c.n(k));if(".priority"===Oc(k)&&!Nd(b))throw Error(d+"contains an invalid value for '"+k.toString()+"', which must be a valid Firebase priority (a string, finite number, server value, or null).");e.push(k)});Qd(d,e)}
function Sd(a,b,c){if(Xb(c))throw Error(A(a,b,!1)+"is "+c.toString()+", but must be a valid Firebase priority (a string, finite number, server value, or null).");if(!Nd(c))throw Error(A(a,b,!1)+"must be a valid Firebase priority (a string, finite number, server value, or null).");}
function Td(a,b,c){if(!c||n(b))switch(b){case "value":case "child_added":case "child_removed":case "child_changed":case "child_moved":break;default:throw Error(A(a,1,c)+'must be a valid event type: "value", "child_added", "child_removed", "child_changed", or "child_moved".');}}function Ud(a,b){if(n(b)&&!Md(b))throw Error(A(a,2,!0)+'was an invalid key: "'+b+'".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');}
function Vd(a,b){if(!p(b)||0===b.length||Ld.test(b))throw Error(A(a,1,!1)+'was an invalid path: "'+b+'". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');}function Wd(a,b){if(".info"===K(b))throw Error(a+" failed: Can't modify data under /.info/");}
function Xd(a,b){var c=b.path.toString(),d;!(d=!p(b.jc.host)||0===b.jc.host.length||!Md(b.jc.pe))&&(d=0!==c.length)&&(c&&(c=c.replace(/^\/*\.info(\/|$)/,"/")),d=!(p(c)&&0!==c.length&&!Ld.test(c)));if(d)throw Error(A(a,1,!1)+'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');};function Gb(){this.k=this.B=null}Gb.prototype.find=function(a){if(null!=this.B)return this.B.P(a);if(a.e()||null==this.k)return null;var b=K(a);a=N(a);return this.k.contains(b)?this.k.get(b).find(a):null};function Ib(a,b,c){if(b.e())a.B=c,a.k=null;else if(null!==a.B)a.B=a.B.F(b,c);else{null==a.k&&(a.k=new Gc);var d=K(b);a.k.contains(d)||a.k.add(d,new Gb);a=a.k.get(d);b=N(b);Ib(a,b,c)}}
function Yd(a,b){if(b.e())return a.B=null,a.k=null,!0;if(null!==a.B){if(a.B.J())return!1;var c=a.B;a.B=null;c.O(H,function(b,c){Ib(a,new E(b),c)});return Yd(a,b)}return null!==a.k?(c=K(b),b=N(b),a.k.contains(c)&&Yd(a.k.get(c),b)&&a.k.remove(c),a.k.e()?(a.k=null,!0):!1):!0}function Hb(a,b,c){null!==a.B?c(b,a.B):a.O(function(a,e){var f=new E(b.toString()+"/"+a);Hb(e,f,c)})}Gb.prototype.O=function(a){null!==this.k&&Hc(this.k,function(b,c){a(b,c)})};function Zd(a,b){this.type=$d;this.source=a;this.path=b}Zd.prototype.Mc=function(){return this.path.e()?new Zd(this.source,Q):new Zd(this.source,N(this.path))};Zd.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" listen_complete)"};function ae(a,b,c){this.type=be;this.source=a;this.path=b;this.children=c}ae.prototype.Mc=function(a){if(this.path.e())return a=this.children.subtree(new E(a)),a.e()?null:a.value?new ce(this.source,Q,a.value):new ae(this.source,Q,a);D(K(this.path)===a,"Can't get a merge for a child not on the path of the operation");return new ae(this.source,N(this.path),this.children)};ae.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" merge: "+this.children.toString()+")"};function de(a,b,c){this.type=ee;this.source=fe;this.path=a;this.Ob=b;this.Id=c}de.prototype.Mc=function(a){if(this.path.e()){if(null!=this.Ob.value)return D(this.Ob.children.e(),"affectedTree should not have overlapping affected paths."),this;a=this.Ob.subtree(new E(a));return new de(Q,a,this.Id)}D(K(this.path)===a,"operationForChild called for unrelated child.");return new de(N(this.path),this.Ob,this.Id)};
de.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" ack write revert="+this.Id+" affectedTree="+this.Ob+")"};function ce(a,b,c){this.type=ge;this.source=a;this.path=b;this.Ga=c}ce.prototype.Mc=function(a){return this.path.e()?new ce(this.source,Q,this.Ga.Q(a)):new ce(this.source,N(this.path),this.Ga)};ce.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" overwrite: "+this.Ga.toString()+")"};var ge=0,be=1,ee=2,$d=3;function he(a,b,c,d){this.ee=a;this.Se=b;this.Hb=c;this.Ee=d;D(!d||b,"Tagged queries must be from server.")}var fe=new he(!0,!1,null,!1),ie=new he(!1,!0,null,!1);he.prototype.toString=function(){return this.ee?"user":this.Ee?"server(queryID="+this.Hb+")":"server"};function je(a,b,c){this.A=a;this.da=b;this.Sb=c}function ke(a){return a.da}function le(a){return a.Sb}function me(a,b){return b.e()?a.da&&!a.Sb:ne(a,K(b))}function ne(a,b){return a.da&&!a.Sb||a.A.Da(b)}je.prototype.j=function(){return this.A};function oe(a,b){this.N=a;this.Ld=b}function pe(a,b,c,d){return new oe(new je(b,c,d),a.Ld)}function qe(a){return a.N.da?a.N.j():null}oe.prototype.w=function(){return this.Ld};function re(a){return a.Ld.da?a.Ld.j():null};function se(){}se.prototype.Te=function(){return null};se.prototype.fe=function(){return null};var te=new se;function ue(a,b,c){this.xf=a;this.Ka=b;this.yd=c}ue.prototype.Te=function(a){var b=this.Ka.N;if(ne(b,a))return b.j().Q(a);b=null!=this.yd?new je(this.yd,!0,!1):this.Ka.w();return this.xf.qc(a,b)};ue.prototype.fe=function(a,b,c){var d=null!=this.yd?this.yd:re(this.Ka);a=this.xf.Xd(d,b,1,c,a);return 0===a.length?null:a[0]};function ve(a,b){this.Sd=a;this.Df=b}function we(a){this.U=a}
we.prototype.eb=function(a,b,c,d){var e=new xe,f;if(b.type===ge)b.source.ee?c=ye(this,a,b.path,b.Ga,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w())&&!b.path.e(),c=ze(this,a,b.path,b.Ga,c,d,f,e));else if(b.type===be)b.source.ee?c=Ae(this,a,b.path,b.children,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w()),c=Be(this,a,b.path,b.children,c,d,f,e));else if(b.type===ee)if(b.Id)if(b=b.path,null!=c.lc(b))c=a;else{f=new ue(c,a,d);d=a.N.j();if(b.e()||".priority"===K(b))ke(a.w())?
b=c.Aa(re(a)):(b=a.w().j(),D(b instanceof O,"serverChildren would be complete if leaf node"),b=c.rc(b)),b=this.U.ya(d,b,e);else{var h=K(b),k=c.qc(h,a.w());null==k&&ne(a.w(),h)&&(k=d.Q(h));b=null!=k?this.U.F(d,h,k,N(b),f,e):a.N.j().Da(h)?this.U.F(d,h,L,N(b),f,e):d;b.e()&&ke(a.w())&&(d=c.Aa(re(a)),d.J()&&(b=this.U.ya(b,d,e)))}d=ke(a.w())||null!=c.lc(Q);c=pe(a,b,d,this.U.Na())}else c=Ce(this,a,b.path,b.Ob,c,d,e);else if(b.type===$d)d=b.path,b=a.w(),f=b.j(),h=b.da||d.e(),c=De(this,new oe(a.N,new je(f,
h,b.Sb)),d,c,te,e);else throw Mb("Unknown operation type: "+b.type);e=Na(e.fb);d=c;b=d.N;b.da&&(f=b.j().J()||b.j().e(),h=qe(a),(0<e.length||!a.N.da||f&&!b.j().Z(h)||!b.j().C().Z(h.C()))&&e.push(Ee(qe(d))));return new ve(c,e)};
function De(a,b,c,d,e,f){var h=b.N;if(null!=d.lc(c))return b;var k;if(c.e())D(ke(b.w()),"If change path is empty, we must have complete server data"),le(b.w())?(e=re(b),d=d.rc(e instanceof O?e:L)):d=d.Aa(re(b)),f=a.U.ya(b.N.j(),d,f);else{var m=K(c);if(".priority"==m)D(1==Ec(c),"Can't have a priority with additional path components"),f=h.j(),k=b.w().j(),d=d.ad(c,f,k),f=null!=d?a.U.fa(f,d):h.j();else{var l=N(c);ne(h,m)?(k=b.w().j(),d=d.ad(c,h.j(),k),d=null!=d?h.j().Q(m).F(l,d):h.j().Q(m)):d=d.qc(m,
b.w());f=null!=d?a.U.F(h.j(),m,d,l,e,f):h.j()}}return pe(b,f,h.da||c.e(),a.U.Na())}function ze(a,b,c,d,e,f,h,k){var m=b.w();h=h?a.U:a.U.Ub();if(c.e())d=h.ya(m.j(),d,null);else if(h.Na()&&!m.Sb)d=m.j().F(c,d),d=h.ya(m.j(),d,null);else{var l=K(c);if(!me(m,c)&&1<Ec(c))return b;var u=N(c);d=m.j().Q(l).F(u,d);d=".priority"==l?h.fa(m.j(),d):h.F(m.j(),l,d,u,te,null)}m=m.da||c.e();b=new oe(b.N,new je(d,m,h.Na()));return De(a,b,c,e,new ue(e,b,f),k)}
function ye(a,b,c,d,e,f,h){var k=b.N;e=new ue(e,b,f);if(c.e())h=a.U.ya(b.N.j(),d,h),a=pe(b,h,!0,a.U.Na());else if(f=K(c),".priority"===f)h=a.U.fa(b.N.j(),d),a=pe(b,h,k.da,k.Sb);else{c=N(c);var m=k.j().Q(f);if(!c.e()){var l=e.Te(f);d=null!=l?".priority"===Oc(c)&&l.P(c.parent()).e()?l:l.F(c,d):L}m.Z(d)?a=b:(h=a.U.F(k.j(),f,d,c,e,h),a=pe(b,h,k.da,a.U.Na()))}return a}
function Ae(a,b,c,d,e,f,h){var k=b;Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))&&(k=ye(a,k,u,l,e,f,h))});Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))||(k=ye(a,k,u,l,e,f,h))});return k}function Fe(a,b){Hd(b,function(b,d){a=a.F(b,d)});return a}
function Be(a,b,c,d,e,f,h,k){if(b.w().j().e()&&!ke(b.w()))return b;var m=b;c=c.e()?d:Ad(R,c,d);var l=b.w().j();c.children.ha(function(c,d){if(l.Da(c)){var F=b.w().j().Q(c),F=Fe(F,d);m=ze(a,m,new E(c),F,e,f,h,k)}});c.children.ha(function(c,d){var F=!ne(b.w(),c)&&null==d.value;l.Da(c)||F||(F=b.w().j().Q(c),F=Fe(F,d),m=ze(a,m,new E(c),F,e,f,h,k))});return m}
function Ce(a,b,c,d,e,f,h){if(null!=e.lc(c))return b;var k=le(b.w()),m=b.w();if(null!=d.value){if(c.e()&&m.da||me(m,c))return ze(a,b,c,m.j().P(c),e,f,k,h);if(c.e()){var l=R;m.j().O(tc,function(a,b){l=l.set(new E(a),b)});return Be(a,b,c,l,e,f,k,h)}return b}l=R;Hd(d,function(a){var b=c.n(a);me(m,b)&&(l=l.set(a,m.j().P(b)))});return Be(a,b,c,l,e,f,k,h)};function Ge(a){this.V=a;this.g=a.m.g}function He(a,b,c,d){var e=[],f=[];ya(b,function(b){b.type===Ie&&a.g.nd(b.qe,b.Ja)&&f.push(new S(Je,b.Ja,b.Xa))});Ke(a,e,Le,b,d,c);Ke(a,e,Me,b,d,c);Ke(a,e,Je,f,d,c);Ke(a,e,Ie,b,d,c);Ke(a,e,Ne,b,d,c);return e}function Ke(a,b,c,d,e,f){d=za(d,function(a){return a.type===c});Ha(d,q(a.Ff,a));ya(d,function(c){var d=Oe(a,c,f);ya(e,function(e){e.nf(c.type)&&b.push(e.createEvent(d,a.V))})})}
function Oe(a,b,c){"value"!==b.type&&"child_removed"!==b.type&&(b.Dd=c.Ve(b.Xa,b.Ja,a.g));return b}Ge.prototype.Ff=function(a,b){if(null==a.Xa||null==b.Xa)throw Mb("Should only compare child_ events.");return this.g.compare(new C(a.Xa,a.Ja),new C(b.Xa,b.Ja))};function Pe(a,b){this.V=a;var c=a.m,d=new Qe(c.g),c=T(c)?new Qe(c.g):c.xa?new Re(c):new Se(c);this.hf=new we(c);var e=b.w(),f=b.N,h=d.ya(L,e.j(),null),k=c.ya(L,f.j(),null);this.Ka=new oe(new je(k,f.da,c.Na()),new je(h,e.da,d.Na()));this.Za=[];this.Jf=new Ge(a)}function Te(a){return a.V}g=Pe.prototype;g.w=function(){return this.Ka.w().j()};g.hb=function(a){var b=re(this.Ka);return b&&(T(this.V.m)||!a.e()&&!b.Q(K(a)).e())?b.P(a):null};g.e=function(){return 0===this.Za.length};g.Nb=function(a){this.Za.push(a)};
g.kb=function(a,b){var c=[];if(b){D(null==a,"A cancel should cancel all event registrations.");var d=this.V.path;ya(this.Za,function(a){(a=a.Me(b,d))&&c.push(a)})}if(a){for(var e=[],f=0;f<this.Za.length;++f){var h=this.Za[f];if(!h.matches(a))e.push(h);else if(a.Xe()){e=e.concat(this.Za.slice(f+1));break}}this.Za=e}else this.Za=[];return c};
g.eb=function(a,b,c){a.type===be&&null!==a.source.Hb&&(D(re(this.Ka),"We should always have a full cache before handling merges"),D(qe(this.Ka),"Missing event cache, even though we have a server cache"));var d=this.Ka;a=this.hf.eb(d,a,b,c);b=this.hf;c=a.Sd;D(c.N.j().yc(b.U.g),"Event snap not indexed");D(c.w().j().yc(b.U.g),"Server snap not indexed");D(ke(a.Sd.w())||!ke(d.w()),"Once a server snap is complete, it should never go back");this.Ka=a.Sd;return Ue(this,a.Df,a.Sd.N.j(),null)};
function Ve(a,b){var c=a.Ka.N,d=[];c.j().J()||c.j().O(H,function(a,b){d.push(new S(Me,b,a))});c.da&&d.push(Ee(c.j()));return Ue(a,d,c.j(),b)}function Ue(a,b,c,d){return He(a.Jf,b,c,d?[d]:a.Za)};function We(a,b,c,d){this.ae=b;this.Md=c;this.Dd=d;this.hd=a}We.prototype.Yb=function(){var a=this.Md.wb();return"value"===this.hd?a.path:a.getParent().path};We.prototype.ge=function(){return this.hd};We.prototype.Tb=function(){return this.ae.Tb(this)};We.prototype.toString=function(){return this.Yb().toString()+":"+this.hd+":"+x(this.Md.be())};function Xe(a,b,c){this.ae=a;this.error=b;this.path=c}Xe.prototype.Yb=function(){return this.path};Xe.prototype.ge=function(){return"cancel"};
Xe.prototype.Tb=function(){return this.ae.Tb(this)};Xe.prototype.toString=function(){return this.path.toString()+":cancel"};function Ye(){this.vb=[]}function Ze(a,b){for(var c=null,d=0;d<b.length;d++){var e=b[d],f=e.Yb();null===c||f.Z(c.Yb())||(a.vb.push(c),c=null);null===c&&(c=new $e(f));c.add(e)}c&&a.vb.push(c)}function af(a,b,c){Ze(a,c);bf(a,function(a){return a.Z(b)})}function cf(a,b,c){Ze(a,c);bf(a,function(a){return a.contains(b)||b.contains(a)})}
function bf(a,b){for(var c=!0,d=0;d<a.vb.length;d++){var e=a.vb[d];if(e)if(e=e.Yb(),b(e)){for(var e=a.vb[d],f=0;f<e.jd.length;f++){var h=e.jd[f];if(null!==h){e.jd[f]=null;var k=h.Tb();Qb&&I("event: "+h.toString());fc(k)}}a.vb[d]=null}else c=!1}c&&(a.vb=[])}function $e(a){this.qa=a;this.jd=[]}$e.prototype.add=function(a){this.jd.push(a)};$e.prototype.Yb=function(){return this.qa};function Qe(a){this.g=a}g=Qe.prototype;g.F=function(a,b,c,d,e,f){D(a.yc(this.g),"A node must be indexed if only a child is updated");e=a.Q(b);if(e.P(d).Z(c.P(d))&&e.e()==c.e())return a;null!=f&&(c.e()?a.Da(b)?df(f,new S(Le,e,b)):D(a.J(),"A child remove without an old child only makes sense on a leaf node"):e.e()?df(f,new S(Me,c,b)):df(f,new S(Ie,c,b,e)));return a.J()&&c.e()?a:a.T(b,c).nb(this.g)};
g.ya=function(a,b,c){null!=c&&(a.J()||a.O(H,function(a,e){b.Da(a)||df(c,new S(Le,e,a))}),b.J()||b.O(H,function(b,e){if(a.Da(b)){var f=a.Q(b);f.Z(e)||df(c,new S(Ie,e,b,f))}else df(c,new S(Me,e,b))}));return b.nb(this.g)};g.fa=function(a,b){return a.e()?L:a.fa(b)};g.Na=function(){return!1};g.Ub=function(){return this};function Se(a){this.he=new Qe(a.g);this.g=a.g;var b;a.ka?(b=ef(a),b=a.g.Ec(ff(a),b)):b=a.g.Hc();this.Uc=b;a.na?(b=gf(a),a=a.g.Ec(hf(a),b)):a=a.g.Fc();this.vc=a}g=Se.prototype;g.matches=function(a){return 0>=this.g.compare(this.Uc,a)&&0>=this.g.compare(a,this.vc)};g.F=function(a,b,c,d,e,f){this.matches(new C(b,c))||(c=L);return this.he.F(a,b,c,d,e,f)};
g.ya=function(a,b,c){b.J()&&(b=L);var d=b.nb(this.g),d=d.fa(L),e=this;b.O(H,function(a,b){e.matches(new C(a,b))||(d=d.T(a,L))});return this.he.ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.he};function Re(a){this.sa=new Se(a);this.g=a.g;D(a.xa,"Only valid if limit has been set");this.oa=a.oa;this.Ib=!jf(a)}g=Re.prototype;g.F=function(a,b,c,d,e,f){this.sa.matches(new C(b,c))||(c=L);return a.Q(b).Z(c)?a:a.Eb()<this.oa?this.sa.Ub().F(a,b,c,d,e,f):kf(this,a,b,c,e,f)};
g.ya=function(a,b,c){var d;if(b.J()||b.e())d=L.nb(this.g);else if(2*this.oa<b.Eb()&&b.yc(this.g)){d=L.nb(this.g);b=this.Ib?b.Zb(this.sa.vc,this.g):b.Xb(this.sa.Uc,this.g);for(var e=0;0<b.Pa.length&&e<this.oa;){var f=M(b),h;if(h=this.Ib?0>=this.g.compare(this.sa.Uc,f):0>=this.g.compare(f,this.sa.vc))d=d.T(f.name,f.R),e++;else break}}else{d=b.nb(this.g);d=d.fa(L);var k,m,l;if(this.Ib){b=d.We(this.g);k=this.sa.vc;m=this.sa.Uc;var u=nc(this.g);l=function(a,b){return u(b,a)}}else b=d.Wb(this.g),k=this.sa.Uc,
m=this.sa.vc,l=nc(this.g);for(var e=0,z=!1;0<b.Pa.length;)f=M(b),!z&&0>=l(k,f)&&(z=!0),(h=z&&e<this.oa&&0>=l(f,m))?e++:d=d.T(f.name,L)}return this.sa.Ub().ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.sa.Ub()};
function kf(a,b,c,d,e,f){var h;if(a.Ib){var k=nc(a.g);h=function(a,b){return k(b,a)}}else h=nc(a.g);D(b.Eb()==a.oa,"");var m=new C(c,d),l=a.Ib?pd(b,a.g):qd(b,a.g),u=a.sa.matches(m);if(b.Da(c)){for(var z=b.Q(c),l=e.fe(a.g,l,a.Ib);null!=l&&(l.name==c||b.Da(l.name));)l=e.fe(a.g,l,a.Ib);e=null==l?1:h(l,m);if(u&&!d.e()&&0<=e)return null!=f&&df(f,new S(Ie,d,c,z)),b.T(c,d);null!=f&&df(f,new S(Le,z,c));b=b.T(c,L);return null!=l&&a.sa.matches(l)?(null!=f&&df(f,new S(Me,l.R,l.name)),b.T(l.name,l.R)):b}return d.e()?
b:u&&0<=h(l,m)?(null!=f&&(df(f,new S(Le,l.R,l.name)),df(f,new S(Me,d,c))),b.T(c,d).T(l.name,L)):b};function S(a,b,c,d){this.type=a;this.Ja=b;this.Xa=c;this.qe=d;this.Dd=void 0}function Ee(a){return new S(Ne,a)}var Me="child_added",Le="child_removed",Ie="child_changed",Je="child_moved",Ne="value";function xe(){this.fb={}}
function df(a,b){var c=b.type,d=b.Xa;D(c==Me||c==Ie||c==Le,"Only child changes supported for tracking");D(".priority"!==d,"Only non-priority child changes can be tracked.");var e=w(a.fb,d);if(e){var f=e.type;if(c==Me&&f==Le)a.fb[d]=new S(Ie,b.Ja,d,e.Ja);else if(c==Le&&f==Me)delete a.fb[d];else if(c==Le&&f==Ie)a.fb[d]=new S(Le,e.qe,d);else if(c==Ie&&f==Me)a.fb[d]=new S(Me,b.Ja,d);else if(c==Ie&&f==Ie)a.fb[d]=new S(Ie,b.Ja,d,e.qe);else throw Mb("Illegal combination of changes: "+b+" occurred after "+
e);}else a.fb[d]=b};function lf(){this.Rb=this.na=this.Kb=this.ka=this.xa=!1;this.oa=0;this.mb="";this.dc=null;this.zb="";this.ac=null;this.xb="";this.g=H}var mf=new lf;function jf(a){return""===a.mb?a.ka:"l"===a.mb}function ff(a){D(a.ka,"Only valid if start has been set");return a.dc}function ef(a){D(a.ka,"Only valid if start has been set");return a.Kb?a.zb:"[MIN_NAME]"}function hf(a){D(a.na,"Only valid if end has been set");return a.ac}
function gf(a){D(a.na,"Only valid if end has been set");return a.Rb?a.xb:"[MAX_NAME]"}function nf(a){var b=new lf;b.xa=a.xa;b.oa=a.oa;b.ka=a.ka;b.dc=a.dc;b.Kb=a.Kb;b.zb=a.zb;b.na=a.na;b.ac=a.ac;b.Rb=a.Rb;b.xb=a.xb;b.g=a.g;b.mb=a.mb;return b}g=lf.prototype;g.ne=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="l";return b};g.oe=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="r";return b};g.Nd=function(a,b){var c=nf(this);c.ka=!0;n(a)||(a=null);c.dc=a;null!=b?(c.Kb=!0,c.zb=b):(c.Kb=!1,c.zb="");return c};
g.gd=function(a,b){var c=nf(this);c.na=!0;n(a)||(a=null);c.ac=a;n(b)?(c.Rb=!0,c.xb=b):(c.vg=!1,c.xb="");return c};function of(a,b){var c=nf(a);c.g=b;return c}function pf(a){var b={};a.ka&&(b.sp=a.dc,a.Kb&&(b.sn=a.zb));a.na&&(b.ep=a.ac,a.Rb&&(b.en=a.xb));if(a.xa){b.l=a.oa;var c=a.mb;""===c&&(c=jf(a)?"l":"r");b.vf=c}a.g!==H&&(b.i=a.g.toString());return b}function T(a){return!(a.ka||a.na||a.xa)}function qf(a){return T(a)&&a.g==H}
function rf(a){var b={};if(qf(a))return b;var c;a.g===H?c="$priority":a.g===wc?c="$value":a.g===tc?c="$key":(D(a.g instanceof pc,"Unrecognized index type!"),c=a.g.toString());b.orderBy=x(c);a.ka&&(b.startAt=x(a.dc),a.Kb&&(b.startAt+=","+x(a.zb)));a.na&&(b.endAt=x(a.ac),a.Rb&&(b.endAt+=","+x(a.xb)));a.xa&&(jf(a)?b.limitToFirst=a.oa:b.limitToLast=a.oa);return b}g.toString=function(){return x(pf(this))};function sf(a){this.W=a}var tf=new sf(new vd(null));function uf(a,b,c){if(b.e())return new sf(new vd(c));var d=zd(a.W,b);if(null!=d){var e=d.path,d=d.value;b=P(e,b);d=d.F(b,c);return new sf(a.W.set(e,d))}a=Ad(a.W,b,new vd(c));return new sf(a)}function vf(a,b,c){var d=a;fb(c,function(a,c){d=uf(d,b.n(a),c)});return d}sf.prototype.Ed=function(a){if(a.e())return tf;a=Ad(this.W,a,R);return new sf(a)};function wf(a,b){var c=zd(a.W,b);return null!=c?a.W.get(c.path).P(P(c.path,b)):null}
function xf(a){var b=[],c=a.W.value;null!=c?c.J()||c.O(H,function(a,c){b.push(new C(a,c))}):a.W.children.ha(function(a,c){null!=c.value&&b.push(new C(a,c.value))});return b}function yf(a,b){if(b.e())return a;var c=wf(a,b);return null!=c?new sf(new vd(c)):new sf(a.W.subtree(b))}sf.prototype.e=function(){return this.W.e()};sf.prototype.apply=function(a){return zf(Q,this.W,a)};
function zf(a,b,c){if(null!=b.value)return c.F(a,b.value);var d=null;b.children.ha(function(b,f){".priority"===b?(D(null!==f.value,"Priority writes must always be leaf nodes"),d=f.value):c=zf(a.n(b),f,c)});c.P(a).e()||null===d||(c=c.F(a.n(".priority"),d));return c};function Af(){this.Jd=L}Af.prototype.j=function(a){return this.Jd.P(a)};Af.prototype.toString=function(){return this.Jd.toString()};function Bf(a){this.oc=a}Bf.prototype.getToken=function(a){return this.oc.INTERNAL.getToken(a).then(null,function(a){return a&&"auth/token-not-initialized"===a.code?(I("Got auth/token-not-initialized error.  Treating as null token."),null):Promise.reject(a)})};function Cf(a,b){a.oc.INTERNAL.addAuthTokenListener(b)};function Df(){this.S=tf;this.la=[];this.Bc=-1}function Ef(a,b){for(var c=0;c<a.la.length;c++){var d=a.la[c];if(d.Zc===b)return d}return null}g=Df.prototype;
g.Ed=function(a){var b=Ea(this.la,function(b){return b.Zc===a});D(0<=b,"removeWrite called with nonexistent writeId.");var c=this.la[b];this.la.splice(b,1);for(var d=c.visible,e=!1,f=this.la.length-1;d&&0<=f;){var h=this.la[f];h.visible&&(f>=b&&Ff(h,c.path)?d=!1:c.path.contains(h.path)&&(e=!0));f--}if(d){if(e)this.S=Gf(this.la,Hf,Q),this.Bc=0<this.la.length?this.la[this.la.length-1].Zc:-1;else if(c.Ga)this.S=this.S.Ed(c.path);else{var k=this;v(c.children,function(a,b){k.S=k.S.Ed(c.path.n(b))})}return!0}return!1};
g.Aa=function(a,b,c,d){if(c||d){var e=yf(this.S,a);return!d&&e.e()?b:d||null!=b||null!=wf(e,Q)?(e=Gf(this.la,function(b){return(b.visible||d)&&(!c||!(0<=xa(c,b.Zc)))&&(b.path.contains(a)||a.contains(b.path))},a),b=b||L,e.apply(b)):null}e=wf(this.S,a);if(null!=e)return e;e=yf(this.S,a);return e.e()?b:null!=b||null!=wf(e,Q)?(b=b||L,e.apply(b)):null};
g.rc=function(a,b){var c=L,d=wf(this.S,a);if(d)d.J()||d.O(H,function(a,b){c=c.T(a,b)});else if(b){var e=yf(this.S,a);b.O(H,function(a,b){var d=yf(e,new E(a)).apply(b);c=c.T(a,d)});ya(xf(e),function(a){c=c.T(a.name,a.R)})}else e=yf(this.S,a),ya(xf(e),function(a){c=c.T(a.name,a.R)});return c};g.ad=function(a,b,c,d){D(c||d,"Either existingEventSnap or existingServerSnap must exist");a=a.n(b);if(null!=wf(this.S,a))return null;a=yf(this.S,a);return a.e()?d.P(b):a.apply(d.P(b))};
g.qc=function(a,b,c){a=a.n(b);var d=wf(this.S,a);return null!=d?d:ne(c,b)?yf(this.S,a).apply(c.j().Q(b)):null};g.lc=function(a){return wf(this.S,a)};g.Xd=function(a,b,c,d,e,f){var h;a=yf(this.S,a);h=wf(a,Q);if(null==h)if(null!=b)h=a.apply(b);else return[];h=h.nb(f);if(h.e()||h.J())return[];b=[];a=nc(f);e=e?h.Zb(c,f):h.Xb(c,f);for(f=M(e);f&&b.length<d;)0!==a(f,c)&&b.push(f),f=M(e);return b};
function Ff(a,b){return a.Ga?a.path.contains(b):!!Qa(a.children,function(c,d){return a.path.n(d).contains(b)})}function Hf(a){return a.visible}
function Gf(a,b,c){for(var d=tf,e=0;e<a.length;++e){var f=a[e];if(b(f)){var h=f.path;if(f.Ga)c.contains(h)?(h=P(c,h),d=uf(d,h,f.Ga)):h.contains(c)&&(h=P(h,c),d=uf(d,Q,f.Ga.P(h)));else if(f.children)if(c.contains(h))h=P(c,h),d=vf(d,h,f.children);else{if(h.contains(c))if(h=P(h,c),h.e())d=vf(d,Q,f.children);else if(f=w(f.children,K(h)))f=f.P(N(h)),d=uf(d,Q,f)}else throw Mb("WriteRecord should have .snap or .children");}}return d}function If(a,b){this.Lb=a;this.W=b}g=If.prototype;
g.Aa=function(a,b,c){return this.W.Aa(this.Lb,a,b,c)};g.rc=function(a){return this.W.rc(this.Lb,a)};g.ad=function(a,b,c){return this.W.ad(this.Lb,a,b,c)};g.lc=function(a){return this.W.lc(this.Lb.n(a))};g.Xd=function(a,b,c,d,e){return this.W.Xd(this.Lb,a,b,c,d,e)};g.qc=function(a,b){return this.W.qc(this.Lb,a,b)};g.n=function(a){return new If(this.Lb.n(a),this.W)};function Jf(a,b){this.rf={};this.Vc=new Kf(a);this.va=b;var c=1E4+2E4*Math.random();hc(q(this.lf,this),Math.floor(c))}Jf.prototype.lf=function(){var a=this.Vc.get(),b={},c=!1,d;for(d in a)0<a[d]&&eb(this.rf,d)&&(b[d]=a[d],c=!0);c&&this.va.ye(b);hc(q(this.lf,this),Math.floor(6E5*Math.random()))};function Lf(){this.tc={}}function Mf(a,b,c){n(c)||(c=1);eb(a.tc,b)||(a.tc[b]=0);a.tc[b]+=c}Lf.prototype.get=function(){return Ta(this.tc)};function Kf(a){this.Ef=a;this.rd=null}Kf.prototype.get=function(){var a=this.Ef.get(),b=Ta(a);if(this.rd)for(var c in this.rd)b[c]-=this.rd[c];this.rd=a;return b};var Nf={},Of={};function Pf(a){a=a.toString();Nf[a]||(Nf[a]=new Lf);return Nf[a]}function Qf(a,b){var c=a.toString();Of[c]||(Of[c]=b());return Of[c]};function Rf(a,b,c){this.f=Tb("p:rest:");this.L=a;this.Gb=b;this.$c=c;this.$={}}function Sf(a,b){if(n(b))return"tag$"+b;D(qf(a.m),"should have a tag if it's not a default query.");return a.path.toString()}g=Rf.prototype;
g.$e=function(a,b,c,d){var e=a.path.toString();this.f("Listen called for "+e+" "+a.ja());var f=Sf(a,c),h={};this.$[f]=h;a=rf(a.m);var k=this;Tf(this,e+".json",a,function(a,b){var u=b;404===a&&(a=u=null);null===a&&k.Gb(e,u,!1,c);w(k.$,f)===h&&d(a?401==a?"permission_denied":"rest_error:"+a:"ok",null)})};g.uf=function(a,b){var c=Sf(a,b);delete this.$[c]};g.kf=function(){};g.re=function(){};g.cf=function(){};g.xd=function(){};g.put=function(){};g.af=function(){};g.ye=function(){};
function Tf(a,b,c,d){c=c||{};c.format="export";a.$c.getToken(!1).then(function(e){(e=e&&e.accessToken)&&(c.auth=e);var f=(a.L.Sc?"https://":"http://")+a.L.host+b+"?"+gb(c);a.f("Sending REST request for "+f);var h=new XMLHttpRequest;h.onreadystatechange=function(){if(d&&4===h.readyState){a.f("REST Response for "+f+" received. status:",h.status,"response:",h.responseText);var b=null;if(200<=h.status&&300>h.status){try{b=lb(h.responseText)}catch(c){J("Failed to parse JSON response for "+f+": "+h.responseText)}d(null,
b)}else 401!==h.status&&404!==h.status&&J("Got unsuccessful REST response for "+f+" Status: "+h.status),d(h.status);d=null}};h.open("GET",f,!0);h.send()})};function Uf(a){this.te=a;this.Bd=[];this.Qb=0;this.Yd=-1;this.Fb=null}function Vf(a,b,c){a.Yd=b;a.Fb=c;a.Yd<a.Qb&&(a.Fb(),a.Fb=null)}function Wf(a,b,c){for(a.Bd[b]=c;a.Bd[a.Qb];){var d=a.Bd[a.Qb];delete a.Bd[a.Qb];for(var e=0;e<d.length;++e)if(d[e]){var f=a;fc(function(){f.te(d[e])})}if(a.Qb===a.Yd){a.Fb&&(clearTimeout(a.Fb),a.Fb(),a.Fb=null);break}a.Qb++}};var Cb="websocket",Db="long_polling";var Xf=null;"undefined"!==typeof MozWebSocket?Xf=MozWebSocket:"undefined"!==typeof WebSocket&&(Xf=WebSocket);function Yf(a,b,c,d){this.Zd=a;this.f=Tb(this.Zd);this.frames=this.zc=null;this.pb=this.qb=this.Fe=0;this.Va=Pf(b);a={v:"5"};"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");c&&(a.s=c);d&&(a.ls=d);this.Ke=Bb(b,Cb,a)}var Zf;
Yf.prototype.open=function(a,b){this.ib=b;this.Xf=a;this.f("Websocket connecting to "+this.Ke);this.wc=!1;xb.set("previous_websocket_failure",!0);try{this.Ia=new Xf(this.Ke)}catch(c){this.f("Error instantiating WebSocket.");var d=c.message||c.data;d&&this.f(d);this.bb();return}var e=this;this.Ia.onopen=function(){e.f("Websocket connected.");e.wc=!0};this.Ia.onclose=function(){e.f("Websocket connection was disconnected.");e.Ia=null;e.bb()};this.Ia.onmessage=function(a){if(null!==e.Ia)if(a=a.data,e.pb+=
a.length,Mf(e.Va,"bytes_received",a.length),$f(e),null!==e.frames)ag(e,a);else{a:{D(null===e.frames,"We already have a frame buffer");if(6>=a.length){var b=Number(a);if(!isNaN(b)){e.Fe=b;e.frames=[];a=null;break a}}e.Fe=1;e.frames=[]}null!==a&&ag(e,a)}};this.Ia.onerror=function(a){e.f("WebSocket error.  Closing connection.");(a=a.message||a.data)&&e.f(a);e.bb()}};Yf.prototype.start=function(){};
Yf.isAvailable=function(){var a=!1;if("undefined"!==typeof navigator&&navigator.userAgent){var b=navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);b&&1<b.length&&4.4>parseFloat(b[1])&&(a=!0)}return!a&&null!==Xf&&!Zf};Yf.responsesRequiredToBeHealthy=2;Yf.healthyTimeout=3E4;g=Yf.prototype;g.sd=function(){xb.remove("previous_websocket_failure")};function ag(a,b){a.frames.push(b);if(a.frames.length==a.Fe){var c=a.frames.join("");a.frames=null;c=lb(c);a.Xf(c)}}
g.send=function(a){$f(this);a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=bc(a,16384);1<a.length&&bg(this,String(a.length));for(var b=0;b<a.length;b++)bg(this,a[b])};g.Tc=function(){this.Ab=!0;this.zc&&(clearInterval(this.zc),this.zc=null);this.Ia&&(this.Ia.close(),this.Ia=null)};g.bb=function(){this.Ab||(this.f("WebSocket is closing itself"),this.Tc(),this.ib&&(this.ib(this.wc),this.ib=null))};g.close=function(){this.Ab||(this.f("WebSocket is being closed"),this.Tc())};
function $f(a){clearInterval(a.zc);a.zc=setInterval(function(){a.Ia&&bg(a,"0");$f(a)},Math.floor(45E3))}function bg(a,b){try{a.Ia.send(b)}catch(c){a.f("Exception thrown from WebSocket.send():",c.message||c.data,"Closing connection."),setTimeout(q(a.bb,a),0)}};function cg(a,b,c,d){this.Zd=a;this.f=Tb(a);this.jc=b;this.pb=this.qb=0;this.Va=Pf(b);this.tf=c;this.wc=!1;this.Cb=d;this.Yc=function(a){return Bb(b,Db,a)}}var dg,eg;
cg.prototype.open=function(a,b){this.Ne=0;this.ia=b;this.bf=new Uf(a);this.Ab=!1;var c=this;this.sb=setTimeout(function(){c.f("Timed out trying to connect.");c.bb();c.sb=null},Math.floor(3E4));Yb(function(){if(!c.Ab){c.Ta=new fg(function(a,b,d,k,m){gg(c,arguments);if(c.Ta)if(c.sb&&(clearTimeout(c.sb),c.sb=null),c.wc=!0,"start"==a)c.id=b,c.ff=d;else if("close"===a)b?(c.Ta.Kd=!1,Vf(c.bf,b,function(){c.bb()})):c.bb();else throw Error("Unrecognized command received: "+a);},function(a,b){gg(c,arguments);
Wf(c.bf,a,b)},function(){c.bb()},c.Yc);var a={start:"t"};a.ser=Math.floor(1E8*Math.random());c.Ta.Qd&&(a.cb=c.Ta.Qd);a.v="5";c.tf&&(a.s=c.tf);c.Cb&&(a.ls=c.Cb);"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");a=c.Yc(a);c.f("Connecting via long-poll to "+a);hg(c.Ta,a,function(){})}})};
cg.prototype.start=function(){var a=this.Ta,b=this.ff;a.Vf=this.id;a.Wf=b;for(a.Ud=!0;ig(a););a=this.id;b=this.ff;this.fc=document.createElement("iframe");var c={dframe:"t"};c.id=a;c.pw=b;this.fc.src=this.Yc(c);this.fc.style.display="none";document.body.appendChild(this.fc)};
cg.isAvailable=function(){return dg||!eg&&"undefined"!==typeof document&&null!=document.createElement&&!("object"===typeof window&&window.chrome&&window.chrome.extension&&!/^chrome/.test(window.location.href))&&!("object"===typeof Windows&&"object"===typeof Windows.rg)&&!0};g=cg.prototype;g.sd=function(){};g.Tc=function(){this.Ab=!0;this.Ta&&(this.Ta.close(),this.Ta=null);this.fc&&(document.body.removeChild(this.fc),this.fc=null);this.sb&&(clearTimeout(this.sb),this.sb=null)};
g.bb=function(){this.Ab||(this.f("Longpoll is closing itself"),this.Tc(),this.ia&&(this.ia(this.wc),this.ia=null))};g.close=function(){this.Ab||(this.f("Longpoll is being closed."),this.Tc())};g.send=function(a){a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=mb(a);a=ab(a,!0);a=bc(a,1840);for(var b=0;b<a.length;b++){var c=this.Ta;c.Qc.push({jg:this.Ne,pg:a.length,Pe:a[b]});c.Ud&&ig(c);this.Ne++}};function gg(a,b){var c=x(b).length;a.pb+=c;Mf(a.Va,"bytes_received",c)}
function fg(a,b,c,d){this.Yc=d;this.ib=c;this.ve=new Gc;this.Qc=[];this.$d=Math.floor(1E8*Math.random());this.Kd=!0;this.Qd=Lb();window["pLPCommand"+this.Qd]=a;window["pRTLPCB"+this.Qd]=b;a=document.createElement("iframe");a.style.display="none";if(document.body){document.body.appendChild(a);try{a.contentWindow.document||I("No IE domain setting required")}catch(e){a.src="javascript:void((function(){document.open();document.domain='"+document.domain+"';document.close();})())"}}else throw"Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
a.contentDocument?a.gb=a.contentDocument:a.contentWindow?a.gb=a.contentWindow.document:a.document&&(a.gb=a.document);this.Ea=a;a="";this.Ea.src&&"javascript:"===this.Ea.src.substr(0,11)&&(a='<script>document.domain="'+document.domain+'";\x3c/script>');a="<html><body>"+a+"</body></html>";try{this.Ea.gb.open(),this.Ea.gb.write(a),this.Ea.gb.close()}catch(f){I("frame writing exception"),f.stack&&I(f.stack),I(f)}}
fg.prototype.close=function(){this.Ud=!1;if(this.Ea){this.Ea.gb.body.innerHTML="";var a=this;setTimeout(function(){null!==a.Ea&&(document.body.removeChild(a.Ea),a.Ea=null)},Math.floor(0))}var b=this.ib;b&&(this.ib=null,b())};
function ig(a){if(a.Ud&&a.Kd&&a.ve.count()<(0<a.Qc.length?2:1)){a.$d++;var b={};b.id=a.Vf;b.pw=a.Wf;b.ser=a.$d;for(var b=a.Yc(b),c="",d=0;0<a.Qc.length;)if(1870>=a.Qc[0].Pe.length+30+c.length){var e=a.Qc.shift(),c=c+"&seg"+d+"="+e.jg+"&ts"+d+"="+e.pg+"&d"+d+"="+e.Pe;d++}else break;jg(a,b+c,a.$d);return!0}return!1}function jg(a,b,c){function d(){a.ve.remove(c);ig(a)}a.ve.add(c,1);var e=setTimeout(d,Math.floor(25E3));hg(a,b,function(){clearTimeout(e);d()})}
function hg(a,b,c){setTimeout(function(){try{if(a.Kd){var d=a.Ea.gb.createElement("script");d.type="text/javascript";d.async=!0;d.src=b;d.onload=d.onreadystatechange=function(){var a=d.readyState;a&&"loaded"!==a&&"complete"!==a||(d.onload=d.onreadystatechange=null,d.parentNode&&d.parentNode.removeChild(d),c())};d.onerror=function(){I("Long-poll script failed to load: "+b);a.Kd=!1;a.close()};a.Ea.gb.body.appendChild(d)}}catch(e){}},Math.floor(1))};function kg(a){lg(this,a)}var mg=[cg,Yf];function lg(a,b){var c=Yf&&Yf.isAvailable(),d=c&&!(xb.Ze||!0===xb.get("previous_websocket_failure"));b.qg&&(c||J("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."),d=!0);if(d)a.Wc=[Yf];else{var e=a.Wc=[];cc(mg,function(a,b){b&&b.isAvailable()&&e.push(b)})}}function ng(a){if(0<a.Wc.length)return a.Wc[0];throw Error("No transports available");};function og(a,b,c,d,e,f,h){this.id=a;this.f=Tb("c:"+this.id+":");this.te=c;this.Lc=d;this.ia=e;this.se=f;this.L=b;this.Ad=[];this.Le=0;this.sf=new kg(b);this.Ua=0;this.Cb=h;this.f("Connection created");pg(this)}
function pg(a){var b=ng(a.sf);a.I=new b("c:"+a.id+":"+a.Le++,a.L,void 0,a.Cb);a.xe=b.responsesRequiredToBeHealthy||0;var c=qg(a,a.I),d=rg(a,a.I);a.Xc=a.I;a.Rc=a.I;a.D=null;a.Bb=!1;setTimeout(function(){a.I&&a.I.open(c,d)},Math.floor(0));b=b.healthyTimeout||0;0<b&&(a.md=hc(function(){a.md=null;a.Bb||(a.I&&102400<a.I.pb?(a.f("Connection exceeded healthy timeout but has received "+a.I.pb+" bytes.  Marking connection healthy."),a.Bb=!0,a.I.sd()):a.I&&10240<a.I.qb?a.f("Connection exceeded healthy timeout but has sent "+
a.I.qb+" bytes.  Leaving connection alive."):(a.f("Closing unhealthy connection after timeout."),a.close()))},Math.floor(b)))}function rg(a,b){return function(c){b===a.I?(a.I=null,c||0!==a.Ua?1===a.Ua&&a.f("Realtime connection lost."):(a.f("Realtime connection failed."),"s-"===a.L.$a.substr(0,2)&&(xb.remove("host:"+a.L.host),a.L.$a=a.L.host)),a.close()):b===a.D?(a.f("Secondary connection lost."),c=a.D,a.D=null,a.Xc!==c&&a.Rc!==c||a.close()):a.f("closing an old connection")}}
function qg(a,b){return function(c){if(2!=a.Ua)if(b===a.Rc){var d=$b("t",c);c=$b("d",c);if("c"==d){if(d=$b("t",c),"d"in c)if(c=c.d,"h"===d){var d=c.ts,e=c.v,f=c.h;a.qf=c.s;Ab(a.L,f);0==a.Ua&&(a.I.start(),sg(a,a.I,d),"5"!==e&&J("Protocol version mismatch detected"),c=a.sf,(c=1<c.Wc.length?c.Wc[1]:null)&&tg(a,c))}else if("n"===d){a.f("recvd end transmission on primary");a.Rc=a.D;for(c=0;c<a.Ad.length;++c)a.wd(a.Ad[c]);a.Ad=[];ug(a)}else"s"===d?(a.f("Connection shutdown command received. Shutting down..."),
a.se&&(a.se(c),a.se=null),a.ia=null,a.close()):"r"===d?(a.f("Reset packet received.  New host: "+c),Ab(a.L,c),1===a.Ua?a.close():(vg(a),pg(a))):"e"===d?Ub("Server Error: "+c):"o"===d?(a.f("got pong on primary."),wg(a),xg(a)):Ub("Unknown control packet command: "+d)}else"d"==d&&a.wd(c)}else if(b===a.D)if(d=$b("t",c),c=$b("d",c),"c"==d)"t"in c&&(c=c.t,"a"===c?yg(a):"r"===c?(a.f("Got a reset on secondary, closing it"),a.D.close(),a.Xc!==a.D&&a.Rc!==a.D||a.close()):"o"===c&&(a.f("got pong on secondary."),
a.pf--,yg(a)));else if("d"==d)a.Ad.push(c);else throw Error("Unknown protocol layer: "+d);else a.f("message on old connection")}}og.prototype.ua=function(a){zg(this,{t:"d",d:a})};function ug(a){a.Xc===a.D&&a.Rc===a.D&&(a.f("cleaning up and promoting a connection: "+a.D.Zd),a.I=a.D,a.D=null)}
function yg(a){0>=a.pf?(a.f("Secondary connection is healthy."),a.Bb=!0,a.D.sd(),a.D.start(),a.f("sending client ack on secondary"),a.D.send({t:"c",d:{t:"a",d:{}}}),a.f("Ending transmission on primary"),a.I.send({t:"c",d:{t:"n",d:{}}}),a.Xc=a.D,ug(a)):(a.f("sending ping on secondary."),a.D.send({t:"c",d:{t:"p",d:{}}}))}og.prototype.wd=function(a){wg(this);this.te(a)};function wg(a){a.Bb||(a.xe--,0>=a.xe&&(a.f("Primary connection is healthy."),a.Bb=!0,a.I.sd()))}
function tg(a,b){a.D=new b("c:"+a.id+":"+a.Le++,a.L,a.qf);a.pf=b.responsesRequiredToBeHealthy||0;a.D.open(qg(a,a.D),rg(a,a.D));hc(function(){a.D&&(a.f("Timed out trying to upgrade."),a.D.close())},Math.floor(6E4))}function sg(a,b,c){a.f("Realtime connection established.");a.I=b;a.Ua=1;a.Lc&&(a.Lc(c,a.qf),a.Lc=null);0===a.xe?(a.f("Primary connection is healthy."),a.Bb=!0):hc(function(){xg(a)},Math.floor(5E3))}
function xg(a){a.Bb||1!==a.Ua||(a.f("sending ping on primary."),zg(a,{t:"c",d:{t:"p",d:{}}}))}function zg(a,b){if(1!==a.Ua)throw"Connection is not connected";a.Xc.send(b)}og.prototype.close=function(){2!==this.Ua&&(this.f("Closing realtime connection."),this.Ua=2,vg(this),this.ia&&(this.ia(),this.ia=null))};function vg(a){a.f("Shutting down all connections");a.I&&(a.I.close(),a.I=null);a.D&&(a.D.close(),a.D=null);a.md&&(clearTimeout(a.md),a.md=null)};function Ag(a,b,c,d,e,f){this.id=Bg++;this.f=Tb("p:"+this.id+":");this.qd={};this.$={};this.pa=[];this.Oc=0;this.Kc=[];this.ma=!1;this.Sa=1E3;this.td=3E5;this.Gb=b;this.Jc=c;this.ue=d;this.L=a;this.ob=this.Fa=this.Cb=this.ze=null;this.$c=e;this.de=!1;this.ke=0;if(f)throw Error("Auth override specified in options, but not supported on non Node.js platforms");this.Vd=f;this.ub=null;this.Mb=!1;this.Gd={};this.ig=0;this.Re=!0;this.Ac=this.me=null;Cg(this,0);Mc.Vb().gc("visible",this.Zf,this);-1===a.host.indexOf("fblocal")&&
Lc.Vb().gc("online",this.Yf,this)}var Bg=0,Dg=0;g=Ag.prototype;g.ua=function(a,b,c){var d=++this.ig;a={r:d,a:a,b:b};this.f(x(a));D(this.ma,"sendRequest call when we're not connected not allowed.");this.Fa.ua(a);c&&(this.Gd[d]=c)};
g.$e=function(a,b,c,d){var e=a.ja(),f=a.path.toString();this.f("Listen called for "+f+" "+e);this.$[f]=this.$[f]||{};D(qf(a.m)||!T(a.m),"listen() called for non-default but complete query");D(!this.$[f][e],"listen() called twice for same path/queryId.");a={G:d,ld:b,eg:a,tag:c};this.$[f][e]=a;this.ma&&Eg(this,a)};
function Eg(a,b){var c=b.eg,d=c.path.toString(),e=c.ja();a.f("Listen on "+d+" for "+e);var f={p:d};b.tag&&(f.q=pf(c.m),f.t=b.tag);f.h=b.ld();a.ua("q",f,function(f){var k=f.d,m=f.s;if(k&&"object"===typeof k&&eb(k,"w")){var l=w(k,"w");ea(l)&&0<=xa(l,"no_index")&&J("Using an unspecified index. Consider adding "+('".indexOn": "'+c.m.g.toString()+'"')+" at "+c.path.toString()+" to your security rules for better performance")}(a.$[d]&&a.$[d][e])===b&&(a.f("listen response",f),"ok"!==m&&Fg(a,d,e),b.G&&b.G(m,
k))})}g.kf=function(a){this.ob=a;this.f("Auth token refreshed");this.ob?Gg(this):this.ma&&this.ua("unauth",{},function(){});if(a&&40===a.length||kc(a))this.f("Admin auth credential detected.  Reducing max reconnect time."),this.td=3E4};function Gg(a){if(a.ma&&a.ob){var b=a.ob,c=jc(b)?"auth":"gauth",d={cred:b};null===a.Vd?d.noauth=!0:"object"===typeof a.Vd&&(d.authvar=a.Vd);a.ua(c,d,function(c){var d=c.s;c=c.d||"error";a.ob===b&&("ok"===d?a.ke=0:Hg(a,d,c))})}}
g.uf=function(a,b){var c=a.path.toString(),d=a.ja();this.f("Unlisten called for "+c+" "+d);D(qf(a.m)||!T(a.m),"unlisten() called for non-default but complete query");if(Fg(this,c,d)&&this.ma){var e=pf(a.m);this.f("Unlisten on "+c+" for "+d);c={p:c};b&&(c.q=e,c.t=b);this.ua("n",c)}};g.re=function(a,b,c){this.ma?Ig(this,"o",a,b,c):this.Kc.push({we:a,action:"o",data:b,G:c})};g.cf=function(a,b,c){this.ma?Ig(this,"om",a,b,c):this.Kc.push({we:a,action:"om",data:b,G:c})};
g.xd=function(a,b){this.ma?Ig(this,"oc",a,null,b):this.Kc.push({we:a,action:"oc",data:null,G:b})};function Ig(a,b,c,d,e){c={p:c,d:d};a.f("onDisconnect "+b,c);a.ua(b,c,function(a){e&&setTimeout(function(){e(a.s,a.d)},Math.floor(0))})}g.put=function(a,b,c,d){Jg(this,"p",a,b,c,d)};g.af=function(a,b,c,d){Jg(this,"m",a,b,c,d)};function Jg(a,b,c,d,e,f){d={p:c,d:d};n(f)&&(d.h=f);a.pa.push({action:b,mf:d,G:e});a.Oc++;b=a.pa.length-1;a.ma?Kg(a,b):a.f("Buffering put: "+c)}
function Kg(a,b){var c=a.pa[b].action,d=a.pa[b].mf,e=a.pa[b].G;a.pa[b].fg=a.ma;a.ua(c,d,function(d){a.f(c+" response",d);delete a.pa[b];a.Oc--;0===a.Oc&&(a.pa=[]);e&&e(d.s,d.d)})}g.ye=function(a){this.ma&&(a={c:a},this.f("reportStats",a),this.ua("s",a,function(a){"ok"!==a.s&&this.f("reportStats","Error sending stats: "+a.d)}))};
g.wd=function(a){if("r"in a){this.f("from server: "+x(a));var b=a.r,c=this.Gd[b];c&&(delete this.Gd[b],c(a.b))}else{if("error"in a)throw"A server-side error has occurred: "+a.error;"a"in a&&(b=a.a,a=a.b,this.f("handleServerMessage",b,a),"d"===b?this.Gb(a.p,a.d,!1,a.t):"m"===b?this.Gb(a.p,a.d,!0,a.t):"c"===b?Lg(this,a.p,a.q):"ac"===b?Hg(this,a.s,a.d):"sd"===b?this.ze?this.ze(a):"msg"in a&&"undefined"!==typeof console&&console.log("FIREBASE: "+a.msg.replace("\n","\nFIREBASE: ")):Ub("Unrecognized action received from server: "+
x(b)+"\nAre you using the latest client?"))}};g.Lc=function(a,b){this.f("connection ready");this.ma=!0;this.Ac=(new Date).getTime();this.ue({serverTimeOffset:a-(new Date).getTime()});this.Cb=b;if(this.Re){var c={};c["sdk.js."+firebase.SDK_VERSION.replace(/\./g,"-")]=1;pb()?c["framework.cordova"]=1:"object"===typeof navigator&&"ReactNative"===navigator.product&&(c["framework.reactnative"]=1);this.ye(c)}Mg(this);this.Re=!1;this.Jc(!0)};
function Cg(a,b){D(!a.Fa,"Scheduling a connect when we're already connected/ing?");a.ub&&clearTimeout(a.ub);a.ub=setTimeout(function(){a.ub=null;Ng(a)},Math.floor(b))}g.Zf=function(a){a&&!this.Mb&&this.Sa===this.td&&(this.f("Window became visible.  Reducing delay."),this.Sa=1E3,this.Fa||Cg(this,0));this.Mb=a};g.Yf=function(a){a?(this.f("Browser went online."),this.Sa=1E3,this.Fa||Cg(this,0)):(this.f("Browser went offline.  Killing connection."),this.Fa&&this.Fa.close())};
g.df=function(){this.f("data client disconnected");this.ma=!1;this.Fa=null;for(var a=0;a<this.pa.length;a++){var b=this.pa[a];b&&"h"in b.mf&&b.fg&&(b.G&&b.G("disconnect"),delete this.pa[a],this.Oc--)}0===this.Oc&&(this.pa=[]);this.Gd={};Og(this)&&(this.Mb?this.Ac&&(3E4<(new Date).getTime()-this.Ac&&(this.Sa=1E3),this.Ac=null):(this.f("Window isn't visible.  Delaying reconnect."),this.Sa=this.td,this.me=(new Date).getTime()),a=Math.max(0,this.Sa-((new Date).getTime()-this.me)),a*=Math.random(),this.f("Trying to reconnect in "+
a+"ms"),Cg(this,a),this.Sa=Math.min(this.td,1.3*this.Sa));this.Jc(!1)};
function Ng(a){if(Og(a)){a.f("Making a connection attempt");a.me=(new Date).getTime();a.Ac=null;var b=q(a.wd,a),c=q(a.Lc,a),d=q(a.df,a),e=a.id+":"+Dg++,f=a.Cb,h=!1,k=null,m=function(){k?k.close():(h=!0,d())};a.Fa={close:m,ua:function(a){D(k,"sendRequest call when we're not connected not allowed.");k.ua(a)}};var l=a.de;a.de=!1;a.$c.getToken(l).then(function(l){h?I("getToken() completed but was canceled"):(I("getToken() completed. Creating connection."),a.ob=l&&l.accessToken,k=new og(e,a.L,b,c,d,function(b){J(b+
" ("+a.L.toString()+")");a.ab("server_kill")},f))}).then(null,function(b){a.f("Failed to get token: "+b);h||m()})}}g.ab=function(a){I("Interrupting connection for reason: "+a);this.qd[a]=!0;this.Fa?this.Fa.close():(this.ub&&(clearTimeout(this.ub),this.ub=null),this.ma&&this.df())};g.kc=function(a){I("Resuming connection for reason: "+a);delete this.qd[a];Sa(this.qd)&&(this.Sa=1E3,this.Fa||Cg(this,0))};
function Lg(a,b,c){c=c?Aa(c,function(a){return ac(a)}).join("$"):"default";(a=Fg(a,b,c))&&a.G&&a.G("permission_denied")}function Fg(a,b,c){b=(new E(b)).toString();var d;n(a.$[b])?(d=a.$[b][c],delete a.$[b][c],0===La(a.$[b])&&delete a.$[b]):d=void 0;return d}
function Hg(a,b,c){I("Auth token revoked: "+b+"/"+c);a.ob=null;a.de=!0;a.Fa.close();if("invalid_token"===b||"permission_denied"===b)a.ke++,3<=a.ke&&(a.Sa=3E4,a=a.$c,b='Provided authentication credentials for the app named "'+a.oc.name+'" are invalid. This usually indicates your app was not initialized correctly. ',b="credential"in a.oc.options?b+'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':"serviceAccount"in
a.oc.options?b+'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':b+'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.',J(b))}
function Mg(a){Gg(a);v(a.$,function(b){v(b,function(b){Eg(a,b)})});for(var b=0;b<a.pa.length;b++)a.pa[b]&&Kg(a,b);for(;a.Kc.length;)b=a.Kc.shift(),Ig(a,b.action,b.we,b.data,b.G)}function Og(a){var b;b=Lc.Vb().hc;return Sa(a.qd)&&b};function Pg(a){a instanceof Qg||Vb("Don't call new Database() directly - please use firebase.database().");this.ta=a;this.ba=new U(a,Q);this.INTERNAL=new Rg(this)}var Sg={TIMESTAMP:{".sv":"timestamp"}};g=Pg.prototype;g.app=null;g.jf=function(a){Tg(this,"ref");y("database.ref",0,1,arguments.length);return n(a)?this.ba.n(a):this.ba};
g.gg=function(a){Tg(this,"database.refFromURL");y("database.refFromURL",1,1,arguments.length);var b=Wb(a);Xd("database.refFromURL",b);var c=b.jc;c.host!==this.ta.L.host&&Vb("database.refFromURL: Host name does not match the current database: (found "+c.host+" but expected "+this.ta.L.host+")");return this.jf(b.path.toString())};function Tg(a,b){null===a.ta&&Vb("Cannot call "+b+" on a deleted database.")}g.Pf=function(){y("database.goOffline",0,0,arguments.length);Tg(this,"goOffline");this.ta.ab()};
g.Qf=function(){y("database.goOnline",0,0,arguments.length);Tg(this,"goOnline");this.ta.kc()};Object.defineProperty(Pg.prototype,"app",{get:function(){return this.ta.app}});function Rg(a){this.Ya=a}Rg.prototype.delete=function(){Tg(this.Ya,"delete");var a=Ug.Vb(),b=this.Ya.ta;w(a.lb,b.app.name)!==b&&Vb("Database "+b.app.name+" has already been deleted.");b.ab();delete a.lb[b.app.name];this.Ya.ta=null;this.Ya.ba=null;this.Ya=this.Ya.INTERNAL=null;return firebase.Promise.resolve()};
Pg.prototype.ref=Pg.prototype.jf;Pg.prototype.refFromURL=Pg.prototype.gg;Pg.prototype.goOnline=Pg.prototype.Qf;Pg.prototype.goOffline=Pg.prototype.Pf;Rg.prototype["delete"]=Rg.prototype.delete;function V(a,b,c){this.A=a;this.V=b;this.g=c}V.prototype.H=function(){y("Firebase.DataSnapshot.val",0,0,arguments.length);return this.A.H()};V.prototype.val=V.prototype.H;V.prototype.be=function(){y("Firebase.DataSnapshot.exportVal",0,0,arguments.length);return this.A.H(!0)};V.prototype.exportVal=V.prototype.be;V.prototype.toJSON=function(){y("Firebase.DataSnapshot.toJSON",0,1,arguments.length);return this.be()};V.prototype.toJSON=V.prototype.toJSON;
V.prototype.Lf=function(){y("Firebase.DataSnapshot.exists",0,0,arguments.length);return!this.A.e()};V.prototype.exists=V.prototype.Lf;V.prototype.n=function(a){y("Firebase.DataSnapshot.child",0,1,arguments.length);ga(a)&&(a=String(a));Vd("Firebase.DataSnapshot.child",a);var b=new E(a),c=this.V.n(b);return new V(this.A.P(b),c,H)};V.prototype.child=V.prototype.n;
V.prototype.Da=function(a){y("Firebase.DataSnapshot.hasChild",1,1,arguments.length);Vd("Firebase.DataSnapshot.hasChild",a);var b=new E(a);return!this.A.P(b).e()};V.prototype.hasChild=V.prototype.Da;V.prototype.C=function(){y("Firebase.DataSnapshot.getPriority",0,0,arguments.length);return this.A.C().H()};V.prototype.getPriority=V.prototype.C;
V.prototype.forEach=function(a){y("Firebase.DataSnapshot.forEach",1,1,arguments.length);B("Firebase.DataSnapshot.forEach",1,a,!1);if(this.A.J())return!1;var b=this;return!!this.A.O(this.g,function(c,d){return a(new V(d,b.V.n(c),H))})};V.prototype.forEach=V.prototype.forEach;V.prototype.kd=function(){y("Firebase.DataSnapshot.hasChildren",0,0,arguments.length);return this.A.J()?!1:!this.A.e()};V.prototype.hasChildren=V.prototype.kd;
V.prototype.getKey=function(){y("Firebase.DataSnapshot.key",0,0,arguments.length);return this.V.getKey()};gc(V.prototype,"key",V.prototype.getKey);V.prototype.Eb=function(){y("Firebase.DataSnapshot.numChildren",0,0,arguments.length);return this.A.Eb()};V.prototype.numChildren=V.prototype.Eb;V.prototype.wb=function(){y("Firebase.DataSnapshot.ref",0,0,arguments.length);return this.V};gc(V.prototype,"ref",V.prototype.wb);function Vg(a,b,c){this.Pb=a;this.rb=b;this.tb=c||null}g=Vg.prototype;g.nf=function(a){return"value"===a};g.createEvent=function(a,b){var c=b.m.g;return new We("value",this,new V(a.Ja,b.wb(),c))};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.Pb;return function(){d.call(b,a.Md)}};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
g.matches=function(a){return a instanceof Vg?a.Pb&&this.Pb?a.Pb===this.Pb&&a.tb===this.tb:!0:!1};g.Xe=function(){return null!==this.Pb};function Wg(a,b,c){this.ga=a;this.rb=b;this.tb=c}g=Wg.prototype;g.nf=function(a){a="children_added"===a?"child_added":a;return("children_removed"===a?"child_removed":a)in this.ga};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
g.createEvent=function(a,b){D(null!=a.Xa,"Child events should have a childName.");var c=b.wb().n(a.Xa);return new We(a.type,this,new V(a.Ja,c,b.m.g),a.Dd)};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.ga[a.hd];return function(){d.call(b,a.Md,a.Dd)}};
g.matches=function(a){if(a instanceof Wg){if(!this.ga||!a.ga)return!0;if(this.tb===a.tb){var b=La(a.ga);if(b===La(this.ga)){if(1===b){var b=Ma(a.ga),c=Ma(this.ga);return c===b&&(!a.ga[b]||!this.ga[c]||a.ga[b]===this.ga[c])}return Ka(this.ga,function(b,c){return a.ga[c]===b})}}}return!1};g.Xe=function(){return null!==this.ga};function Xg(){this.za={}}g=Xg.prototype;g.e=function(){return Sa(this.za)};g.eb=function(a,b,c){var d=a.source.Hb;if(null!==d)return d=w(this.za,d),D(null!=d,"SyncTree gave us an op for an invalid query."),d.eb(a,b,c);var e=[];v(this.za,function(d){e=e.concat(d.eb(a,b,c))});return e};g.Nb=function(a,b,c,d,e){var f=a.ja(),h=w(this.za,f);if(!h){var h=c.Aa(e?d:null),k=!1;h?k=!0:(h=d instanceof O?c.rc(d):L,k=!1);h=new Pe(a,new oe(new je(h,k,!1),new je(d,e,!1)));this.za[f]=h}h.Nb(b);return Ve(h,b)};
g.kb=function(a,b,c){var d=a.ja(),e=[],f=[],h=null!=Yg(this);if("default"===d){var k=this;v(this.za,function(a,d){f=f.concat(a.kb(b,c));a.e()&&(delete k.za[d],T(a.V.m)||e.push(a.V))})}else{var m=w(this.za,d);m&&(f=f.concat(m.kb(b,c)),m.e()&&(delete this.za[d],T(m.V.m)||e.push(m.V)))}h&&null==Yg(this)&&e.push(new U(a.u,a.path));return{hg:e,Kf:f}};function Zg(a){return za(Na(a.za),function(a){return!T(a.V.m)})}g.hb=function(a){var b=null;v(this.za,function(c){b=b||c.hb(a)});return b};
function $g(a,b){if(T(b.m))return Yg(a);var c=b.ja();return w(a.za,c)}function Yg(a){return Ra(a.za,function(a){return T(a.V.m)})||null};function ah(a){this.wa=R;this.jb=new Df;this.De={};this.ic={};this.Cc=a}function bh(a,b,c,d,e){var f=a.jb,h=e;D(d>f.Bc,"Stacking an older write on top of newer ones");n(h)||(h=!0);f.la.push({path:b,Ga:c,Zc:d,visible:h});h&&(f.S=uf(f.S,b,c));f.Bc=d;return e?ch(a,new ce(fe,b,c)):[]}function dh(a,b,c,d){var e=a.jb;D(d>e.Bc,"Stacking an older merge on top of newer ones");e.la.push({path:b,children:c,Zc:d,visible:!0});e.S=vf(e.S,b,c);e.Bc=d;c=xd(c);return ch(a,new ae(fe,b,c))}
function eh(a,b,c){c=c||!1;var d=Ef(a.jb,b);if(a.jb.Ed(b)){var e=R;null!=d.Ga?e=e.set(Q,!0):fb(d.children,function(a,b){e=e.set(new E(a),b)});return ch(a,new de(d.path,e,c))}return[]}function fh(a,b,c){c=xd(c);return ch(a,new ae(ie,b,c))}function gh(a,b,c,d){d=hh(a,d);if(null!=d){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=new ce(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
function kh(a,b,c,d){if(d=hh(a,d)){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=xd(c);c=new ae(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
ah.prototype.Nb=function(a,b){var c=a.path,d=null,e=!1;Fd(this.wa,c,function(a,b){var f=P(a,c);d=d||b.hb(f);e=e||null!=Yg(b)});var f=this.wa.get(c);f?(e=e||null!=Yg(f),d=d||f.hb(Q)):(f=new Xg,this.wa=this.wa.set(c,f));var h;null!=d?h=!0:(h=!1,d=L,Jd(this.wa.subtree(c),function(a,b){var c=b.hb(Q);c&&(d=d.T(a,c))}));var k=null!=$g(f,a);if(!k&&!T(a.m)){var m=lh(a);D(!(m in this.ic),"View does not exist, but we have a tag");var l=mh++;this.ic[m]=l;this.De["_"+l]=m}h=f.Nb(a,b,new If(c,this.jb),d,h);k||
e||(f=$g(f,a),h=h.concat(nh(this,a,f)));return h};
ah.prototype.kb=function(a,b,c){var d=a.path,e=this.wa.get(d),f=[];if(e&&("default"===a.ja()||null!=$g(e,a))){f=e.kb(a,b,c);e.e()&&(this.wa=this.wa.remove(d));e=f.hg;f=f.Kf;b=-1!==Ea(e,function(a){return T(a.m)});var h=Dd(this.wa,d,function(a,b){return null!=Yg(b)});if(b&&!h&&(d=this.wa.subtree(d),!d.e()))for(var d=oh(d),k=0;k<d.length;++k){var m=d[k],l=m.V,m=ph(this,m);this.Cc.Ae(qh(l),rh(this,l),m.ld,m.G)}if(!h&&0<e.length&&!c)if(b)this.Cc.Od(qh(a),null);else{var u=this;ya(e,function(a){a.ja();
var b=u.ic[lh(a)];u.Cc.Od(qh(a),b)})}sh(this,e)}return f};ah.prototype.Aa=function(a,b){var c=this.jb,d=Dd(this.wa,a,function(b,c){var d=P(b,a);if(d=c.hb(d))return d});return c.Aa(a,d,b,!0)};function oh(a){return Bd(a,function(a,c,d){if(c&&null!=Yg(c))return[Yg(c)];var e=[];c&&(e=Zg(c));v(d,function(a){e=e.concat(a)});return e})}function sh(a,b){for(var c=0;c<b.length;++c){var d=b[c];if(!T(d.m)){var d=lh(d),e=a.ic[d];delete a.ic[d];delete a.De["_"+e]}}}
function qh(a){return T(a.m)&&!qf(a.m)?a.wb():a}function nh(a,b,c){var d=b.path,e=rh(a,b);c=ph(a,c);b=a.Cc.Ae(qh(b),e,c.ld,c.G);d=a.wa.subtree(d);if(e)D(null==Yg(d.value),"If we're adding a query, it shouldn't be shadowed");else for(e=Bd(d,function(a,b,c){if(!a.e()&&b&&null!=Yg(b))return[Te(Yg(b))];var d=[];b&&(d=d.concat(Aa(Zg(b),function(a){return a.V})));v(c,function(a){d=d.concat(a)});return d}),d=0;d<e.length;++d)c=e[d],a.Cc.Od(qh(c),rh(a,c));return b}
function ph(a,b){var c=b.V,d=rh(a,c);return{ld:function(){return(b.w()||L).hash()},G:function(b){if("ok"===b){if(d){var f=c.path;if(b=hh(a,d)){var h=ih(b);b=h.path;h=h.Hb;f=P(b,f);f=new Zd(new he(!1,!0,h,!0),f);b=jh(a,b,f)}else b=[]}else b=ch(a,new Zd(ie,c.path));return b}f="Unknown Error";"too_big"===b?f="The data requested exceeds the maximum size that can be accessed with a single request.":"permission_denied"==b?f="Client doesn't have permission to access the desired data.":"unavailable"==b&&
(f="The service is unavailable");f=Error(b+" at "+c.path.toString()+": "+f);f.code=b.toUpperCase();return a.kb(c,null,f)}}}function lh(a){return a.path.toString()+"$"+a.ja()}function ih(a){var b=a.indexOf("$");D(-1!==b&&b<a.length-1,"Bad queryKey.");return{Hb:a.substr(b+1),path:new E(a.substr(0,b))}}function hh(a,b){var c=a.De,d="_"+b;return d in c?c[d]:void 0}function rh(a,b){var c=lh(b);return w(a.ic,c)}var mh=1;
function jh(a,b,c){var d=a.wa.get(b);D(d,"Missing sync point for query tag that we're tracking");return d.eb(c,new If(b,a.jb),null)}function ch(a,b){return th(a,b,a.wa,null,new If(Q,a.jb))}function th(a,b,c,d,e){if(b.path.e())return uh(a,b,c,d,e);var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[],k=K(b.path),m=b.Mc(k);if((c=c.children.get(k))&&m)var l=d?d.Q(k):null,k=e.n(k),h=h.concat(th(a,m,c,l,k));f&&(h=h.concat(f.eb(b,e,d)));return h}
function uh(a,b,c,d,e){var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[];c.children.ha(function(c,f){var l=d?d.Q(c):null,u=e.n(c),z=b.Mc(c);z&&(h=h.concat(uh(a,z,f,l,u)))});f&&(h=h.concat(f.eb(b,e,d)));return h};function Qg(a,b,c){this.app=c;var d=new Bf(c);this.L=a;this.Va=Pf(a);this.Vc=null;this.ca=new Ye;this.vd=1;this.Ra=null;if(b||0<=("object"===typeof window&&window.navigator&&window.navigator.userAgent||"").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i))this.va=new Rf(this.L,q(this.Gb,this),d),setTimeout(q(this.Jc,this,!0),0);else{b=c.options.databaseAuthVariableOverride;if("undefined"!==da(b)&&null!==b){if("object"!==da(b))throw Error("Only objects are supported for option databaseAuthVariableOverride");
try{x(b)}catch(e){throw Error("Invalid authOverride provided: "+e);}}this.va=this.Ra=new Ag(this.L,q(this.Gb,this),q(this.Jc,this),q(this.ue,this),d,b)}var f=this;Cf(d,function(a){f.va.kf(a)});this.og=Qf(a,q(function(){return new Jf(this.Va,this.va)},this));this.mc=new Tc;this.ie=new Af;this.pd=new ah({Ae:function(a,b,c,d){b=[];c=f.ie.j(a.path);c.e()||(b=ch(f.pd,new ce(ie,a.path,c)),setTimeout(function(){d("ok")},0));return b},Od:ba});vh(this,"connected",!1);this.ia=new Gb;this.Ya=new Pg(this);this.fd=
0;this.je=null;this.K=new ah({Ae:function(a,b,c,d){f.va.$e(a,c,b,function(b,c){var e=d(b,c);cf(f.ca,a.path,e)});return[]},Od:function(a,b){f.va.uf(a,b)}})}g=Qg.prototype;g.toString=function(){return(this.L.Sc?"https://":"http://")+this.L.host};g.name=function(){return this.L.pe};function wh(a){a=a.ie.j(new E(".info/serverTimeOffset")).H()||0;return(new Date).getTime()+a}function xh(a){a=a={timestamp:wh(a)};a.timestamp=a.timestamp||(new Date).getTime();return a}
g.Gb=function(a,b,c,d){this.fd++;var e=new E(a);b=this.je?this.je(a,b):b;a=[];d?c?(b=Ja(b,function(a){return G(a)}),a=kh(this.K,e,b,d)):(b=G(b),a=gh(this.K,e,b,d)):c?(d=Ja(b,function(a){return G(a)}),a=fh(this.K,e,d)):(d=G(b),a=ch(this.K,new ce(ie,e,d)));d=e;0<a.length&&(d=yh(this,e));cf(this.ca,d,a)};g.Jc=function(a){vh(this,"connected",a);!1===a&&zh(this)};g.ue=function(a){var b=this;cc(a,function(a,d){vh(b,d,a)})};
function vh(a,b,c){b=new E("/.info/"+b);c=G(c);var d=a.ie;d.Jd=d.Jd.F(b,c);c=ch(a.pd,new ce(ie,b,c));cf(a.ca,b,c)}g.Jb=function(a,b,c,d){this.f("set",{path:a.toString(),value:b,ug:c});var e=xh(this);b=G(b,c);var e=Jb(b,e),f=this.vd++,e=bh(this.K,a,e,f,!0);Ze(this.ca,e);var h=this;this.va.put(a.toString(),b.H(!0),function(b,c){var e="ok"===b;e||J("set at "+a+" failed: "+b);e=eh(h.K,f,!e);cf(h.ca,a,e);Ah(d,b,c)});e=Bh(this,a);yh(this,e);cf(this.ca,e,[])};
g.update=function(a,b,c){this.f("update",{path:a.toString(),value:b});var d=!0,e=xh(this),f={};v(b,function(a,b){d=!1;var c=G(a);f[b]=Jb(c,e)});if(d)I("update() called with empty data.  Don't do anything."),Ah(c,"ok");else{var h=this.vd++,k=dh(this.K,a,f,h);Ze(this.ca,k);var m=this;this.va.af(a.toString(),b,function(b,d){var e="ok"===b;e||J("update at "+a+" failed: "+b);var e=eh(m.K,h,!e),f=a;0<e.length&&(f=yh(m,a));cf(m.ca,f,e);Ah(c,b,d)});v(b,function(b,c){var d=Bh(m,a.n(c));yh(m,d)});cf(this.ca,
a,[])}};function zh(a){a.f("onDisconnectEvents");var b=xh(a),c=[];Hb(Fb(a.ia,b),Q,function(b,e){c=c.concat(ch(a.K,new ce(ie,b,e)));var f=Bh(a,b);yh(a,f)});a.ia=new Gb;cf(a.ca,Q,c)}g.xd=function(a,b){var c=this;this.va.xd(a.toString(),function(d,e){"ok"===d&&Yd(c.ia,a);Ah(b,d,e)})};function Ch(a,b,c,d){var e=G(c);a.va.re(b.toString(),e.H(!0),function(c,h){"ok"===c&&Ib(a.ia,b,e);Ah(d,c,h)})}
function Dh(a,b,c,d,e){var f=G(c,d);a.va.re(b.toString(),f.H(!0),function(c,d){"ok"===c&&Ib(a.ia,b,f);Ah(e,c,d)})}function Eh(a,b,c,d){var e=!0,f;for(f in c)e=!1;e?(I("onDisconnect().update() called with empty data.  Don't do anything."),Ah(d,"ok")):a.va.cf(b.toString(),c,function(e,f){if("ok"===e)for(var m in c){var l=G(c[m]);Ib(a.ia,b.n(m),l)}Ah(d,e,f)})}function Fh(a,b,c){c=".info"===K(b.path)?a.pd.Nb(b,c):a.K.Nb(b,c);af(a.ca,b.path,c)}g.ab=function(){this.Ra&&this.Ra.ab("repo_interrupt")};
g.kc=function(){this.Ra&&this.Ra.kc("repo_interrupt")};g.Be=function(a){if("undefined"!==typeof console){a?(this.Vc||(this.Vc=new Kf(this.Va)),a=this.Vc.get()):a=this.Va.get();var b=Ba(Oa(a),function(a,b){return Math.max(b.length,a)},0),c;for(c in a){for(var d=a[c],e=c.length;e<b+2;e++)c+=" ";console.log(c+d)}}};g.Ce=function(a){Mf(this.Va,a);this.og.rf[a]=!0};g.f=function(a){var b="";this.Ra&&(b=this.Ra.id+":");I(b,arguments)};
function Ah(a,b,c){a&&fc(function(){if("ok"==b)a(null);else{var d=(b||"error").toUpperCase(),e=d;c&&(e+=": "+c);e=Error(e);e.code=d;a(e)}})};function Gh(a,b,c,d,e){function f(){}a.f("transaction on "+b);var h=new U(a,b);h.gc("value",f);c={path:b,update:c,G:d,status:null,ef:Lb(),He:e,of:0,Rd:function(){h.Ic("value",f)},Td:null,Ba:null,cd:null,dd:null,ed:null};d=a.K.Aa(b,void 0)||L;c.cd=d;d=c.update(d.H());if(n(d)){Pd("transaction failed: Data returned ",d,c.path);c.status=1;e=Uc(a.mc,b);var k=e.Ca()||[];k.push(c);Vc(e,k);"object"===typeof d&&null!==d&&eb(d,".priority")?(k=w(d,".priority"),D(Nd(k),"Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.")):
k=(a.K.Aa(b)||L).C().H();e=xh(a);d=G(d,k);e=Jb(d,e);c.dd=d;c.ed=e;c.Ba=a.vd++;c=bh(a.K,b,e,c.Ba,c.He);cf(a.ca,b,c);Hh(a)}else c.Rd(),c.dd=null,c.ed=null,c.G&&(a=new V(c.cd,new U(a,c.path),H),c.G(null,!1,a))}function Hh(a,b){var c=b||a.mc;b||Ih(a,c);if(null!==c.Ca()){var d=Jh(a,c);D(0<d.length,"Sending zero length transaction queue");Ca(d,function(a){return 1===a.status})&&Kh(a,c.path(),d)}else c.kd()&&c.O(function(b){Hh(a,b)})}
function Kh(a,b,c){for(var d=Aa(c,function(a){return a.Ba}),e=a.K.Aa(b,d)||L,d=e,e=e.hash(),f=0;f<c.length;f++){var h=c[f];D(1===h.status,"tryToSendTransactionQueue_: items in queue should all be run.");h.status=2;h.of++;var k=P(b,h.path),d=d.F(k,h.dd)}d=d.H(!0);a.va.put(b.toString(),d,function(d){a.f("transaction put response",{path:b.toString(),status:d});var e=[];if("ok"===d){d=[];for(f=0;f<c.length;f++){c[f].status=3;e=e.concat(eh(a.K,c[f].Ba));if(c[f].G){var h=c[f].ed,k=new U(a,c[f].path);d.push(q(c[f].G,
null,null,!0,new V(h,k,H)))}c[f].Rd()}Ih(a,Uc(a.mc,b));Hh(a);cf(a.ca,b,e);for(f=0;f<d.length;f++)fc(d[f])}else{if("datastale"===d)for(f=0;f<c.length;f++)c[f].status=4===c[f].status?5:1;else for(J("transaction at "+b.toString()+" failed: "+d),f=0;f<c.length;f++)c[f].status=5,c[f].Td=d;yh(a,b)}},e)}function yh(a,b){var c=Lh(a,b),d=c.path(),c=Jh(a,c);Mh(a,c,d);return d}
function Mh(a,b,c){if(0!==b.length){for(var d=[],e=[],f=za(b,function(a){return 1===a.status}),f=Aa(f,function(a){return a.Ba}),h=0;h<b.length;h++){var k=b[h],m=P(c,k.path),l=!1,u;D(null!==m,"rerunTransactionsUnderNode_: relativePath should not be null.");if(5===k.status)l=!0,u=k.Td,e=e.concat(eh(a.K,k.Ba,!0));else if(1===k.status)if(25<=k.of)l=!0,u="maxretry",e=e.concat(eh(a.K,k.Ba,!0));else{var z=a.K.Aa(k.path,f)||L;k.cd=z;var F=b[h].update(z.H());n(F)?(Pd("transaction failed: Data returned ",F,
k.path),m=G(F),"object"===typeof F&&null!=F&&eb(F,".priority")||(m=m.fa(z.C())),z=k.Ba,F=xh(a),F=Jb(m,F),k.dd=m,k.ed=F,k.Ba=a.vd++,Fa(f,z),e=e.concat(bh(a.K,k.path,F,k.Ba,k.He)),e=e.concat(eh(a.K,z,!0))):(l=!0,u="nodata",e=e.concat(eh(a.K,k.Ba,!0)))}cf(a.ca,c,e);e=[];l&&(b[h].status=3,setTimeout(b[h].Rd,Math.floor(0)),b[h].G&&("nodata"===u?(k=new U(a,b[h].path),d.push(q(b[h].G,null,null,!1,new V(b[h].cd,k,H)))):d.push(q(b[h].G,null,Error(u),!1,null))))}Ih(a,a.mc);for(h=0;h<d.length;h++)fc(d[h]);Hh(a)}}
function Lh(a,b){for(var c,d=a.mc;null!==(c=K(b))&&null===d.Ca();)d=Uc(d,c),b=N(b);return d}function Jh(a,b){var c=[];Nh(a,b,c);c.sort(function(a,b){return a.ef-b.ef});return c}function Nh(a,b,c){var d=b.Ca();if(null!==d)for(var e=0;e<d.length;e++)c.push(d[e]);b.O(function(b){Nh(a,b,c)})}function Ih(a,b){var c=b.Ca();if(c){for(var d=0,e=0;e<c.length;e++)3!==c[e].status&&(c[d]=c[e],d++);c.length=d;Vc(b,0<c.length?c:null)}b.O(function(b){Ih(a,b)})}
function Bh(a,b){var c=Lh(a,b).path(),d=Uc(a.mc,b);Yc(d,function(b){Oh(a,b)});Oh(a,d);Xc(d,function(b){Oh(a,b)});return c}
function Oh(a,b){var c=b.Ca();if(null!==c){for(var d=[],e=[],f=-1,h=0;h<c.length;h++)4!==c[h].status&&(2===c[h].status?(D(f===h-1,"All SENT items should be at beginning of queue."),f=h,c[h].status=4,c[h].Td="set"):(D(1===c[h].status,"Unexpected transaction status in abort"),c[h].Rd(),e=e.concat(eh(a.K,c[h].Ba,!0)),c[h].G&&d.push(q(c[h].G,null,Error("set"),!1,null))));-1===f?Vc(b,null):c.length=f+1;cf(a.ca,b.path(),e);for(h=0;h<d.length;h++)fc(d[h])}};function Ug(){this.lb={};this.wf=!1}Ug.prototype.ab=function(){for(var a in this.lb)this.lb[a].ab()};Ug.prototype.kc=function(){for(var a in this.lb)this.lb[a].kc()};Ug.prototype.ce=function(a){this.wf=a};ca(Ug);Ug.prototype.interrupt=Ug.prototype.ab;Ug.prototype.resume=Ug.prototype.kc;var W={};W.nc=Ag;W.DataConnection=W.nc;Ag.prototype.ng=function(a,b){this.ua("q",{p:a},b)};W.nc.prototype.simpleListen=W.nc.prototype.ng;Ag.prototype.Hf=function(a,b){this.ua("echo",{d:a},b)};W.nc.prototype.echo=W.nc.prototype.Hf;Ag.prototype.interrupt=Ag.prototype.ab;W.zf=og;W.RealTimeConnection=W.zf;og.prototype.sendRequest=og.prototype.ua;og.prototype.close=og.prototype.close;
W.Rf=function(a){var b=Ag.prototype.put;Ag.prototype.put=function(c,d,e,f){n(f)&&(f=a());b.call(this,c,d,e,f)};return function(){Ag.prototype.put=b}};W.hijackHash=W.Rf;W.yf=zb;W.ConnectionTarget=W.yf;W.ja=function(a){return a.ja()};W.queryIdentifier=W.ja;W.Uf=function(a){return a.u.Ra.$};W.listens=W.Uf;W.ce=function(a){Ug.Vb().ce(a)};W.forceRestClient=W.ce;W.Context=Ug;function Ph(a,b){this.committed=a;this.snapshot=b};function X(a,b,c,d){this.u=a;this.path=b;this.m=c;this.Nc=d}
function Qh(a){var b=null,c=null;a.ka&&(b=ff(a));a.na&&(c=hf(a));if(a.g===tc){if(a.ka){if("[MIN_NAME]"!=ef(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==typeof b)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}if(a.na){if("[MAX_NAME]"!=gf(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==
typeof c)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}}else if(a.g===H){if(null!=b&&!Nd(b)||null!=c&&!Nd(c))throw Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");}else if(D(a.g instanceof pc||a.g===wc,"unknown index type."),null!=b&&"object"===typeof b||null!=c&&"object"===typeof c)throw Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
}function Rh(a){if(a.ka&&a.na&&a.xa&&(!a.xa||""===a.mb))throw Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");}function Sh(a,b){if(!0===a.Nc)throw Error(b+": You can't combine multiple orderBy calls.");}g=X.prototype;g.wb=function(){y("Query.ref",0,0,arguments.length);return new U(this.u,this.path)};
g.gc=function(a,b,c,d){y("Query.on",2,4,arguments.length);Td("Query.on",a,!1);B("Query.on",2,b,!1);var e=Th("Query.on",c,d);if("value"===a)Fh(this.u,this,new Vg(b,e.cancel||null,e.Ma||null));else{var f={};f[a]=b;Fh(this.u,this,new Wg(f,e.cancel,e.Ma))}return b};
g.Ic=function(a,b,c){y("Query.off",0,3,arguments.length);Td("Query.off",a,!0);B("Query.off",2,b,!0);ob("Query.off",3,c);var d=null,e=null;"value"===a?d=new Vg(b||null,null,c||null):a&&(b&&(e={},e[a]=b),d=new Wg(e,null,c||null));e=this.u;d=".info"===K(this.path)?e.pd.kb(this,d):e.K.kb(this,d);af(e.ca,this.path,d)};
g.$f=function(a,b){function c(k){f&&(f=!1,e.Ic(a,c),b&&b.call(d.Ma,k),h.resolve(k))}y("Query.once",1,4,arguments.length);Td("Query.once",a,!1);B("Query.once",2,b,!0);var d=Th("Query.once",arguments[2],arguments[3]),e=this,f=!0,h=new ib;kb(h.ra);this.gc(a,c,function(b){e.Ic(a,c);d.cancel&&d.cancel.call(d.Ma,b);h.reject(b)});return h.ra};
g.ne=function(a){y("Query.limitToFirst",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToFirst: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.ne(a),this.Nc)};
g.oe=function(a){y("Query.limitToLast",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToLast: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.oe(a),this.Nc)};
g.ag=function(a){y("Query.orderByChild",1,1,arguments.length);if("$key"===a)throw Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');if("$priority"===a)throw Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');if("$value"===a)throw Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');Vd("Query.orderByChild",a);Sh(this,"Query.orderByChild");var b=new E(a);if(b.e())throw Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
b=new pc(b);b=of(this.m,b);Qh(b);return new X(this.u,this.path,b,!0)};g.bg=function(){y("Query.orderByKey",0,0,arguments.length);Sh(this,"Query.orderByKey");var a=of(this.m,tc);Qh(a);return new X(this.u,this.path,a,!0)};g.cg=function(){y("Query.orderByPriority",0,0,arguments.length);Sh(this,"Query.orderByPriority");var a=of(this.m,H);Qh(a);return new X(this.u,this.path,a,!0)};
g.dg=function(){y("Query.orderByValue",0,0,arguments.length);Sh(this,"Query.orderByValue");var a=of(this.m,wc);Qh(a);return new X(this.u,this.path,a,!0)};g.Nd=function(a,b){y("Query.startAt",0,2,arguments.length);Od("Query.startAt",a,this.path,!0);Ud("Query.startAt",b);var c=this.m.Nd(a,b);Rh(c);Qh(c);if(this.m.ka)throw Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");n(a)||(b=a=null);return new X(this.u,this.path,c,this.Nc)};
g.gd=function(a,b){y("Query.endAt",0,2,arguments.length);Od("Query.endAt",a,this.path,!0);Ud("Query.endAt",b);var c=this.m.gd(a,b);Rh(c);Qh(c);if(this.m.na)throw Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");return new X(this.u,this.path,c,this.Nc)};
g.If=function(a,b){y("Query.equalTo",1,2,arguments.length);Od("Query.equalTo",a,this.path,!1);Ud("Query.equalTo",b);if(this.m.ka)throw Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");if(this.m.na)throw Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");return this.Nd(a,b).gd(a,b)};
g.toString=function(){y("Query.toString",0,0,arguments.length);for(var a=this.path,b="",c=a.Y;c<a.o.length;c++)""!==a.o[c]&&(b+="/"+encodeURIComponent(String(a.o[c])));return this.u.toString()+(b||"/")};g.toJSON=function(){y("Query.toJSON",0,1,arguments.length);return this.toString()};g.ja=function(){var a=ac(pf(this.m));return"{}"===a?"default":a};
g.isEqual=function(a){y("Query.isEqual",1,1,arguments.length);if(!(a instanceof X))throw Error("Query.isEqual failed: First argument must be an instance of firebase.database.Query.");var b=this.u===a.u,c=this.path.Z(a.path),d=this.ja()===a.ja();return b&&c&&d};
function Th(a,b,c){var d={cancel:null,Ma:null};if(b&&c)d.cancel=b,B(a,3,d.cancel,!0),d.Ma=c,ob(a,4,d.Ma);else if(b)if("object"===typeof b&&null!==b)d.Ma=b;else if("function"===typeof b)d.cancel=b;else throw Error(A(a,3,!0)+" must either be a cancel callback or a context object.");return d}X.prototype.on=X.prototype.gc;X.prototype.off=X.prototype.Ic;X.prototype.once=X.prototype.$f;X.prototype.limitToFirst=X.prototype.ne;X.prototype.limitToLast=X.prototype.oe;X.prototype.orderByChild=X.prototype.ag;
X.prototype.orderByKey=X.prototype.bg;X.prototype.orderByPriority=X.prototype.cg;X.prototype.orderByValue=X.prototype.dg;X.prototype.startAt=X.prototype.Nd;X.prototype.endAt=X.prototype.gd;X.prototype.equalTo=X.prototype.If;X.prototype.toString=X.prototype.toString;X.prototype.isEqual=X.prototype.isEqual;gc(X.prototype,"ref",X.prototype.wb);function Y(a,b){this.ta=a;this.qa=b}Y.prototype.cancel=function(a){y("Firebase.onDisconnect().cancel",0,1,arguments.length);B("Firebase.onDisconnect().cancel",1,a,!0);var b=new ib;this.ta.xd(this.qa,jb(b,a));return b.ra};Y.prototype.cancel=Y.prototype.cancel;Y.prototype.remove=function(a){y("Firebase.onDisconnect().remove",0,1,arguments.length);Wd("Firebase.onDisconnect().remove",this.qa);B("Firebase.onDisconnect().remove",1,a,!0);var b=new ib;Ch(this.ta,this.qa,null,jb(b,a));return b.ra};
Y.prototype.remove=Y.prototype.remove;Y.prototype.set=function(a,b){y("Firebase.onDisconnect().set",1,2,arguments.length);Wd("Firebase.onDisconnect().set",this.qa);Od("Firebase.onDisconnect().set",a,this.qa,!1);B("Firebase.onDisconnect().set",2,b,!0);var c=new ib;Ch(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.set=Y.prototype.set;
Y.prototype.Jb=function(a,b,c){y("Firebase.onDisconnect().setWithPriority",2,3,arguments.length);Wd("Firebase.onDisconnect().setWithPriority",this.qa);Od("Firebase.onDisconnect().setWithPriority",a,this.qa,!1);Sd("Firebase.onDisconnect().setWithPriority",2,b);B("Firebase.onDisconnect().setWithPriority",3,c,!0);var d=new ib;Dh(this.ta,this.qa,a,b,jb(d,c));return d.ra};Y.prototype.setWithPriority=Y.prototype.Jb;
Y.prototype.update=function(a,b){y("Firebase.onDisconnect().update",1,2,arguments.length);Wd("Firebase.onDisconnect().update",this.qa);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.onDisconnect().update",a,this.qa);B("Firebase.onDisconnect().update",2,b,!0);
c=new ib;Eh(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.update=Y.prototype.update;var Z={Mf:function(){dg=Zf=!0}};Z.forceLongPolling=Z.Mf;Z.Nf=function(){eg=!0};Z.forceWebSockets=Z.Nf;Z.Tf=function(){return Yf.isAvailable()};Z.isWebSocketsAvailable=Z.Tf;Z.lg=function(a,b){a.u.Ra.ze=b};Z.setSecurityDebugCallback=Z.lg;Z.Be=function(a,b){a.u.Be(b)};Z.stats=Z.Be;Z.Ce=function(a,b){a.u.Ce(b)};Z.statsIncrementCounter=Z.Ce;Z.fd=function(a){return a.u.fd};Z.dataUpdateCount=Z.fd;Z.Sf=function(a,b){a.u.je=b};Z.interceptServerData=Z.Sf;function U(a,b){if(!(a instanceof Qg))throw Error("new Firebase() no longer supported - use app.database().");X.call(this,a,b,mf,!1);this.then=void 0;this["catch"]=void 0}la(U,X);g=U.prototype;g.getKey=function(){y("Firebase.key",0,0,arguments.length);return this.path.e()?null:Oc(this.path)};
g.n=function(a){y("Firebase.child",1,1,arguments.length);if(ga(a))a=String(a);else if(!(a instanceof E))if(null===K(this.path)){var b=a;b&&(b=b.replace(/^\/*\.info(\/|$)/,"/"));Vd("Firebase.child",b)}else Vd("Firebase.child",a);return new U(this.u,this.path.n(a))};g.getParent=function(){y("Firebase.parent",0,0,arguments.length);var a=this.path.parent();return null===a?null:new U(this.u,a)};
g.Of=function(){y("Firebase.ref",0,0,arguments.length);for(var a=this;null!==a.getParent();)a=a.getParent();return a};g.Gf=function(){return this.u.Ya};g.set=function(a,b){y("Firebase.set",1,2,arguments.length);Wd("Firebase.set",this.path);Od("Firebase.set",a,this.path,!1);B("Firebase.set",2,b,!0);var c=new ib;this.u.Jb(this.path,a,null,jb(c,b));return c.ra};
g.update=function(a,b){y("Firebase.update",1,2,arguments.length);Wd("Firebase.update",this.path);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.update",a,this.path);B("Firebase.update",2,b,!0);c=new ib;this.u.update(this.path,a,jb(c,b));return c.ra};
g.Jb=function(a,b,c){y("Firebase.setWithPriority",2,3,arguments.length);Wd("Firebase.setWithPriority",this.path);Od("Firebase.setWithPriority",a,this.path,!1);Sd("Firebase.setWithPriority",2,b);B("Firebase.setWithPriority",3,c,!0);if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.setWithPriority failed: "+this.getKey()+" is a read-only object.";var d=new ib;this.u.Jb(this.path,a,b,jb(d,c));return d.ra};
g.remove=function(a){y("Firebase.remove",0,1,arguments.length);Wd("Firebase.remove",this.path);B("Firebase.remove",1,a,!0);return this.set(null,a)};
g.transaction=function(a,b,c){y("Firebase.transaction",1,3,arguments.length);Wd("Firebase.transaction",this.path);B("Firebase.transaction",1,a,!1);B("Firebase.transaction",2,b,!0);if(n(c)&&"boolean"!=typeof c)throw Error(A("Firebase.transaction",3,!0)+"must be a boolean.");if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.transaction failed: "+this.getKey()+" is a read-only object.";"undefined"===typeof c&&(c=!0);var d=new ib;ha(b)&&kb(d.ra);Gh(this.u,this.path,a,function(a,c,h){a?
d.reject(a):d.resolve(new Ph(c,h));ha(b)&&b(a,c,h)},c);return d.ra};g.kg=function(a,b){y("Firebase.setPriority",1,2,arguments.length);Wd("Firebase.setPriority",this.path);Sd("Firebase.setPriority",1,a);B("Firebase.setPriority",2,b,!0);var c=new ib;this.u.Jb(this.path.n(".priority"),a,null,jb(c,b));return c.ra};
g.push=function(a,b){y("Firebase.push",0,2,arguments.length);Wd("Firebase.push",this.path);Od("Firebase.push",a,this.path,!0);B("Firebase.push",2,b,!0);var c=wh(this.u),d=Kc(c),c=this.n(d),e=this.n(d),d=null!=a?c.set(a,b).then(function(){return e}):hb.resolve(e);c.then=q(d.then,d);c["catch"]=q(d.then,d,void 0);ha(b)&&kb(d);return c};g.ib=function(){Wd("Firebase.onDisconnect",this.path);return new Y(this.u,this.path)};U.prototype.child=U.prototype.n;U.prototype.set=U.prototype.set;
U.prototype.update=U.prototype.update;U.prototype.setWithPriority=U.prototype.Jb;U.prototype.remove=U.prototype.remove;U.prototype.transaction=U.prototype.transaction;U.prototype.setPriority=U.prototype.kg;U.prototype.push=U.prototype.push;U.prototype.onDisconnect=U.prototype.ib;gc(U.prototype,"database",U.prototype.Gf);gc(U.prototype,"key",U.prototype.getKey);gc(U.prototype,"parent",U.prototype.getParent);gc(U.prototype,"root",U.prototype.Of);if("undefined"===typeof firebase)throw Error("Cannot install Firebase Database - be sure to load firebase-app.js first.");
try{firebase.INTERNAL.registerService("database",function(a){var b=Ug.Vb(),c=a.options.databaseURL;n(c)||Vb("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.intializeApp().");var d=Wb(c),c=d.jc;Xd("Invalid Firebase Database URL",d);d.path.e()||Vb("Database URL must point to the root of a Firebase Database (not including a child path).");(d=w(b.lb,a.name))&&Vb("FIREBASE INTERNAL ERROR: Database initialized multiple times.");d=new Qg(c,b.wf,a);b.lb[a.name]=
d;return d.Ya},{Reference:U,Query:X,Database:Pg,enableLogging:Sb,INTERNAL:Z,TEST_ACCESS:W,ServerValue:Sg})}catch(Uh){Vb("Failed to register the Firebase Database Service ("+Uh+")")};
            module.exports = firebase.database;
          })();
          //# sourceMappingURL=database.js.map
          


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UmiStorage = function () {
  function UmiStorage(fallback) {
    _classCallCheck(this, UmiStorage);

    this.store = this.storageAvailability('localStorage') && !fallback ? localStorage : new DummyStore();
  }

  _createClass(UmiStorage, [{
    key: 'storageAvailability',
    value: function storageAvailability(type) {
      try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return e instanceof DOMException && (
        // everything except Firefox
        e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage.length !== 0;
      }
    }
  }, {
    key: 'getItem',
    value: function getItem(item) {
      return this.store.getItem(item);
    }
  }, {
    key: 'setItem',
    value: function setItem(item, value) {
      this.store.setItem(item, value);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(item) {
      this.store.removeItem(item);
    }
  }]);

  return UmiStorage;
}();

exports.default = UmiStorage;

/**
 * DummyStore represents a Storage fallback
 * Fallback may be intended or not
 */

var DummyStore = function () {
  function DummyStore() {
    _classCallCheck(this, DummyStore);

    this.store = {};
  }

  _createClass(DummyStore, [{
    key: 'getItem',
    value: function getItem(item) {
      return this.store[item];
    }
  }, {
    key: 'setItem',
    value: function setItem(item, value) {
      this.store[item] = value;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(item) {
      delete this.store[item];
    }
  }]);

  return DummyStore;
}();

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TEXTS = {
  'en': {
    revisit: [{
      'type': 'text',
      'message': 'Hey! It seems like you\'ve already been around this site.',
      'samurai': '-1',
      'extra': { hide_textbox: true }
    }, {
      'type': 'dialog',
      'title': 'Would you like to continue the conversation where you left it or start again?',
      'buttons': ['START AGAIN', 'CONTINUE'],
      'payloads': ['#init', '#_continue'],
      'samurai': '-1'
    }]
  },
  'es': {
    revisit: [{
      'type': 'text',
      'message': '¡Hola! Parece que no es la primera vez que visitas esta página.',
      'samurai': '-1',
      'extra': { hide_textbox: true }
    }, {
      'type': 'dialog',
      'title': '¿Quieres continuar con la conversación donde la dejaste, o empezar de nuevo?',
      'buttons': ['EMPEZAR', 'CONTINUAR'],
      'payloads': ['#init', '#_continue'],
      'samurai': '-1'
    }]
  },
  'fr': {
    revisit: [{
      'type': 'text',
      'message': 'Salut! Il semble que ce n’est pas la première fois que vous visitez cette page.',
      'samurai': '-1',
      'extra': { hide_textbox: true }
    }, {
      'type': 'dialog',
      'title': 'Voulez-vous continuer la conversation là où vous l’avez laissée ou recommencer?',
      'buttons': ['COMMENCER', 'CONTINUER'],
      'payloads': ['#init', '#_continue'],
      'samurai': '-1'
    }]
  },
  'it': {
    revisit: [{
      'type': 'text',
      'message': 'Ciao! Sembra che non sia la prima volta che visiti questa pagina.',
      'samurai': '-1',
      'extra': { hide_textbox: true }
    }, {
      'type': 'dialog',
      'title': 'Vuoi continuare con la conversazione da dove l’hai lasciata o preferisci cominciare dall’inizio?',
      'buttons': ['RICOMINCIARE', 'CONTINUARE'],
      'payloads': ['#init', '#_continue'],
      'samurai': '-1'
    }]
  },
  'de': {
    revisit: [{
      'type': 'text',
      'message': 'Hallo! Es scheint, dass es nicht das erste Mal ist, dass Sie diese Seite besuchen.',
      'samurai': '-1',
      'extra': { hide_textbox: true }
    }, {
      'type': 'dialog',
      'title': 'Wollen Sie mit der Unterhaltung fortfahren, wo Sie aufgehört haben, oder von vorne beginnen?',
      'buttons': ['START', 'WEITER'],
      'payloads': ['#init', '#_continue'],
      'samurai': '-1'
    }]
  },
  'pt': {
    revisit: [{
      'type': 'text',
      'message': 'Olá! Parece que não é a primeira vez que você visita esta página.',
      'samurai': '-1',
      'extra': { hide_textbox: true }
    }, {
      'type': 'dialog',
      'title': 'Você quer continuar com a conversa onde você parou ou começar de novo?',
      'buttons': ['INICIAR', 'CONTINUAR'],
      'payloads': ['#init', '#_continue'],
      'samurai': '-1'
    }]
  },
  'nl': {
    revisit: [{
      'type': 'text',
      'message': 'Hallo! Het lijkt erop dat dit niet de eerste keer is dat u deze pagina bezoekt.',
      'samurai': '-1',
      'extra': { hide_textbox: true }
    }, {
      'type': 'dialog',
      'title': 'Wil je doorgaan met het gesprek waar je bent gebleven, of opnieuw beginnen?',
      'buttons': ['START', 'DOORGAAN'],
      'payloads': ['#init', '#_continue'],
      'samurai': '-1'
    }]
  },
  'zh': {
    revisit: [{
      'type': 'text',
      'message': '你好！ 看来，这不是您第一次访问此页面。',
      'samurai': '-1',
      'extra': { hide_textbox: true }
    }, {
      'type': 'dialog',
      'title': '你想继续谈话，还是从头开始？',
      'buttons': ['开始', '继续'],
      'payloads': ['#init', '#_continue'],
      'samurai': '-1'
    }]
  }
};

var MultiLangSupport = function () {
  function MultiLangSupport() {
    _classCallCheck(this, MultiLangSupport);

    this.lang = this.getLang();
  }

  /**
   * Get language from navigator
   */


  _createClass(MultiLangSupport, [{
    key: 'getLang',
    value: function getLang() {
      var _lang = navigator.language || navigator.userLanguage;
      return _lang.substring(0, 2);
    }

    /**
     * Returns the group of messages literals
     * @param {Object} type - group of messages: revisit, ...
     */

  }, {
    key: 'getObject',
    value: function getObject(type) {
      if (TEXTS[this.lang]) {
        return TEXTS[this.lang][type] ? TEXTS[this.lang][type] : TEXTS['en'][type];
      } else return TEXTS['en'][type];
    }
  }]);

  return MultiLangSupport;
}();

exports.default = MultiLangSupport;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(25);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inter-Applications Communication
 * Communications engine used between windows
 */
var InterAppCom = function () {
  function InterAppCom(name) {
    _classCallCheck(this, InterAppCom);

    this.name = name;
    this.actions = {};
    this.setupStandards();
  }

  _createClass(InterAppCom, [{
    key: 'setupStandards',
    value: function setupStandards() {
      var _this = this;

      window.addEventListener('message', function (_ref) {
        var data = _ref.data;

        var _data = {};
        try {
          _data = JSON.parse(data);
        } catch (e) {
          return;
        }
        for (var key in _data) {
          if (_this.actions[key]) _this.exec(key, _data[key]);
        }
      });

      this.on('landbot-listen', function () {
        return console.log('[' + _this.name + '-LB] listener is active');
      });
    }

    /**
     * Set an action for an emitted event name
     * @param {String} eventName 
     * @param {Function} cb 
     */

  }, {
    key: 'on',
    value: function on(eventName, cb) {
      var _cb = cb || new Function();
      if (this.actions[eventName]) this.actions[eventName].push(_cb);else this.actions[eventName] = [_cb];
    }

    /**
     * Removes a listener for given event name
     * @param {String} eventName 
     */

  }, {
    key: 'off',
    value: function off(eventName, cb) {
      if (this.actions[eventName] && cb) {
        var index = this.actions[eventName].indexOf(cb);
        if (index > -1) this.actions[eventName].splice(index, 1);
      } else delete this.actions[eventName];
    }

    /**
     * Emits an action with given data
     * @param {String} eventName 
     * @param {Object} data 
     */

  }, {
    key: 'exec',
    value: function exec(eventName) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (this.actions[eventName]) {
        for (var i = 0; i < this.actions[eventName].length; i++) {
          this.actions[eventName][i](data);
        }
      }
    }

    /**
     * message: { eventName: data }
     */

  }, {
    key: 'send',
    value: function send(channel) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var _message = Object.assign(_defineProperty({}, channel, data), { name: this.name });
      parent.postMessage(JSON.stringify(_message), _Utils2.default.getOrigin() || '*');
    }
  }]);

  return InterAppCom;
}();

exports.default = InterAppCom;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ObjectUtils = __webpack_require__(87);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Description:
 *  UmiLogger is a tool for developers. 
 *  It's used for debugging some applications.
 * 
 * Setup:
 *  umicoreDebugger = new UmiLogger('myApp');
 */
var UmiLogger = function () {
  function UmiLogger(name) {
    _classCallCheck(this, UmiLogger);

    this.name = name;
    this.logs = {};
    if (!('log' in console && 'group' in console && 'groupCollapsed' in console && 'groupEnd' in console)) {
      this.append = new Function();
    }
  }

  /**
   * Example: 
   *  umicoreDebugger.append('Logging something', 'umicore.something', 'warn')
   * @param {String} level - log | warn | error | debug
   */


  _createClass(UmiLogger, [{
    key: 'append',
    value: function append(log, path, level) {
      var newLog = [].concat(_toConsumableArray((0, _ObjectUtils._get)(this.logs, path, [])), [// Previous logs or [] if no logs
      { log: log, level: level // New log
      }]);
      (0, _ObjectUtils._set)(this.logs, path, newLog);
      return this;
    }

    /**
     * Prints all logs
     */

  }, {
    key: 'report',
    value: function report() {
      console.groupCollapsed('[' + this.name + ']: Logger Report Details');
      this.breakDown(this.logs);
      console.groupEnd();
    }

    /**
     * breakDown
     * @param {Array|Object} section 
     */

  }, {
    key: 'breakDown',
    value: function breakDown(section) {
      for (var key in section) {
        if (!section.hasOwnProperty(key)) continue;
        var _section = section[key];
        if (_section instanceof Array) {
          // Ready to log
          this.print(_section, key);
        } else if ((typeof _section === 'undefined' ? 'undefined' : _typeof(_section)) === 'object') {
          // Needs breakdown
          this.breakDown(_section);
        }
      }
    }

    /**
     * print
     * @param {Array} page 
     * @param {String} title 
     */

  }, {
    key: 'print',
    value: function print(page, title) {
      console.group(title);
      for (var i = 0; i < page.length; i++) {
        console[page[i].level || 'log'].apply(null, (0, _ObjectUtils.toArray)(page[i].log));
      }
      console.groupEnd();
    }
  }]);

  return UmiLogger;
}();

exports.default = UmiLogger;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;

var stringToPath = function stringToPath(string) {
  var result = [];
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
};

function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
};

var isKey = function isKey(value, object) {
  return object != null && value in Object(object);
};

var isIndex = function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
};

var castPath = function castPath(value, object) {
  if (value instanceof Array) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(value);
};

var assignValue = function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(Object.prototype.hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
};

var eq = function eq(value, other) {
  return value === other || value !== value && other !== other;
};

/**
 * _get
 * @param {*} object 
 * @param {*} path 
 * @param {*} defaultValue 
 */
var _get = exports._get = function _get(object, path, defaultValue) {

  var baseGet = function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0,
        length = path.length;
    while (object != null && index < length) {
      object = object[path[index++]];
    }
    return index && index == length ? object : undefined;
  };

  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
};

/**
 * _set
 * @param {*} object 
 * @param {*} path 
 * @param {*} value 
 */
var _set = exports._set = function _set(object, path, value) {

  var baseSet = function baseSet(object, path, value, customizer) {
    if (!isObject(object)) {
      return object;
    }
    path = castPath(path, object);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        nested = object;

    while (nested != null && ++index < length) {
      var key = path[index],
          newValue = value;

      if (index != lastIndex) {
        var objValue = nested[key];
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
      assignValue(nested, key, newValue);
      nested = nested[key];
    }
    return object;
  };

  return object == null ? object : baseSet(object, path, value);
};

var toArray = exports.toArray = function toArray(value) {
  return value instanceof Array ? value : [value];
};

var ObjectUtils = {
  get: _get,
  set: _set,
  toArray: toArray
};

exports.default = ObjectUtils;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Communications Interface
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Stablish communications between this window and others.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This is just a listener. It doesn't send any message.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _EventDriver = __webpack_require__(9);

var _EventDriver2 = _interopRequireDefault(_EventDriver);

var _ChatUtils = __webpack_require__(14);

var _ChatUtils2 = _interopRequireDefault(_ChatUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ComIface = function () {
  function ComIface() {
    _classCallCheck(this, ComIface);

    this.setupListener();
  }

  _createClass(ComIface, [{
    key: 'setupListener',
    value: function setupListener() {
      window.addEventListener('message', function (ev) {
        var state = ev.data.landbotState;
        if (state) _EventDriver2.default.emit('hu-load-config', state);

        var userMessage = ev.data.userMessage;
        if (userMessage) _ChatUtils2.default.sendMessage(userMessage, userMessage, [], [], false);
      });
    }
  }]);

  return ComIface;
}();

var comIface = new ComIface();
exports.default = comIface;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DynStyles = __webpack_require__(90);

var _DynStyles2 = _interopRequireDefault(_DynStyles);

var _CSSRules = __webpack_require__(28);

var _CSSRules2 = _interopRequireDefault(_CSSRules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DynamicStylesTag = function (_React$Component) {
  _inherits(DynamicStylesTag, _React$Component);

  function DynamicStylesTag(props) {
    _classCallCheck(this, DynamicStylesTag);

    var _this = _possibleConstructorReturn(this, (DynamicStylesTag.__proto__ || Object.getPrototypeOf(DynamicStylesTag)).call(this, props));

    _this.state = {
      // Colors
      colors: props.colors,
      accent: props.accent,
      dark: props.dark,
      light: props.light,
      contrast: props.contrast,
      // Avatar
      avatar_scale: props.avatar_scale,
      avatar_url: props.avatar_url,
      // Fonts
      font: props.font,
      font_size: props.font_size,
      // Content variables
      logo: props.logo,
      // Background variables
      background_image_url: props.background_image_url,
      background_color: props.background_color,
      gradient_from: props.gradient_from,
      gradient_to: props.gradient_to,
      // Filter variables
      filter_color: props.filter_color,
      filter_gradient_from: props.filter_gradient_from,
      filter_gradient_to: props.filter_gradient_to,
      filter_image_url: props.filter_image_url,
      // External
      stylesheets: props.stylesheets,
      // Custom
      style: props.style
    };
    _this.dynStyles = new _DynStyles2.default('custom-styles');
    _this.ee = props.ee;
    return _this;
  }

  _createClass(DynamicStylesTag, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.stablishRules();
      this.ee.emit('hu-lb-rendered');
    }
  }, {
    key: 'stablishRules',
    value: function stablishRules() {
      this.dynStyles.setupStylesheet();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // Sólo son re-renderizadas aquellas reglas que son diferentes a un estado anterior.
      var diffProps = Object.keys(this.props).filter(function (a) {
        return _this2.props[a] !== nextProps[a];
      });
      for (var i = 0; i < diffProps.length; i++) {
        switch (diffProps[i]) {
          case 'avatar_scale':
            this.dynStyles.setVariable('avatar_scale', 'scale(' + nextProps.avatar_scale + ')');
            break;
          case 'font':
            this.dynStyles.setVariable('font', nextProps.font + ',sans-serif');
            break;
          case 'font_size':
            this.dynStyles.setVariable('font_size', nextProps.font_size + 'px');
            break;
          case 'gradient_to':
          case 'gradient_from':
            this.dynStyles.setVariable('background_gradient', 'linear-gradient(to bottom, ' + nextProps.gradient_from + ' 0%, ' + nextProps.gradient_to + ' 100%)');
            break;
          case 'filter_gradient_to':
          case 'filter_gradient_from':
            this.dynStyles.setVariable('background_gradient', 'linear-gradient(to bottom, ' + nextProps.gradient_from + ' 0%, ' + nextProps.gradient_to + ' 100%)');
            break;
          case 'avatar_url':
            this.dynStyles.setVariable('avatar_url', 'url("' + nextProps.avatar_url + '")');
            break;
          case 'logo':
            //   this.dynStyles.setVariable('logo', `url("${nextProps.logo}")`);
            break;
          case 'background_image_url':
            this.dynStyles.setVariable('background_image_url', 'url("' + nextProps.background_image_url + '")');
            break;
          case 'filter_image_url':
            this.dynStyles.setVariable('filter_image_url', 'url("' + nextProps.filter_image_url + '")');
            break;
          case 'videoname':
            this.dynStyles.setVariable('background_video_fallback', 'url("https://storage.googleapis.com/static.helloumi.com/landbot/video/' + videoname + '.jpg")');
            break;
          // Excluding cases. Don't use dynStyles with this params.
          case 'colors':
          case 'stylesheets':
          case 'style':
            break;
          // By default
          default:
            this.dynStyles.setVariable(diffProps[i], nextProps[diffProps[i]]);
            break;
        }
      }
      // Complex properties
      var colors = this.props.colors;

      if (JSON.stringify(colors) !== JSON.stringify(nextProps.colors)) {
        for (var _var in colors) {
          if (nextProps.colors[_var]) {
            this.dynStyles.setVariable(_var, nextProps.colors[_var]);
          }
        }
      }
    }
  }, {
    key: 'cleanFont',
    value: function cleanFont(font) {
      var FONTS = ['Droid Serif', 'Inconsolata', 'Montserrat', 'Open Sans', 'Oswald', 'Raleway', 'Roboto', 'Roboto slab', 'Lato'];
      // return (FONTS.indexOf(font) > -1) ? font : 'Montserrat';
      return font;
    }
  }, {
    key: 'getLink',
    value: function getLink(link) {
      return _react2.default.createElement('link', { href: link, rel: 'stylesheet' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          font = _props.font,
          stylesheets = _props.stylesheets,
          style = _props.style;

      var _font = this.cleanFont(font);
      var fontUrl = 'https://fonts.googleapis.com/css?family=' + _font + ':400,400i,700,700i';

      return _react2.default.createElement(
        'div',
        { id: 'styles' },
        _react2.default.createElement(
          'style',
          null,
          style
        ),
        _react2.default.createElement('link', { href: fontUrl, rel: 'stylesheet' }),
        _react2.default.createElement('style', { id: this.dynStyles.getID() }),
        stylesheets.map(this.getLink)
      );
    }
  }]);

  return DynamicStylesTag;
}(_react2.default.Component);

exports.default = DynamicStylesTag;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CSSRules = __webpack_require__(28);

var _CSSRules2 = _interopRequireDefault(_CSSRules);

var _StyleUtils = __webpack_require__(91);

var _StyleUtils2 = _interopRequireDefault(_StyleUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DynStyles = function () {
  function DynStyles(sheetID) {
    _classCallCheck(this, DynStyles);

    this.sheetID = sheetID;
    this.sheetNode = null;
    this.stylesheet = null;
    this.rulesMap = {};
  }

  // Only for testing purposes


  _createClass(DynStyles, [{
    key: 'connectStylesheet',
    value: function connectStylesheet() {
      this.sheetNode = document.getElementById(this.sheetID);
      this.stylesheet = this.sheetNode.sheet;
    }

    /**
     * Connects stylesheet + set initial rules
     */

  }, {
    key: 'setupStylesheet',
    value: function setupStylesheet() {
      var _this = this;

      // setTimeout used as fix for Safari
      setTimeout(function () {
        _this.sheetNode = document.getElementById(_this.sheetID);
        _this.stylesheet = _this.sheetNode.sheet;
        _this.addRules();
      }, 0);
    }

    /**
     * If prop given, add only involved css rules. If not, add all rules from CSSRules
     * @param {String} prop CSSRule property
     * @param {String} value CSSRule value
     */

  }, {
    key: 'addRules',
    value: function addRules(prop, value) {
      if (this.stylesheet) {
        if (prop !== undefined) {
          // Only add rules concerning certain prop
          if (_CSSRules2.default.hasOwnProperty(prop)) {
            var _CSSRules$prop = _CSSRules2.default[prop],
                rules = _CSSRules$prop.rules,
                relatives = _CSSRules$prop.relatives;

            for (var rule = 0; rule < rules.length; rule++) {
              var _rules$rule = rules[rule],
                  index = _rules$rule.index,
                  type = _rules$rule.type,
                  selectors = _rules$rule.selectors;

              if (selectors.length > 0) this.addRule(selectors.join(', '), type + ': ' + value, index);
            }
            if (relatives) // Relative colors
              for (var i = 0; i < relatives.length; i++) {
                this.addRelativesRules(relatives[i], value);
              }
          }
        } else {
          // Add all default rules
          for (var _prop in _CSSRules2.default) {
            if (_CSSRules2.default.hasOwnProperty(_prop)) {
              var _CSSRules$_prop = _CSSRules2.default[_prop],
                  _value = _CSSRules$_prop.value,
                  _rules = _CSSRules$_prop.rules,
                  _relatives = _CSSRules$_prop.relatives,
                  tasks = _CSSRules$_prop.tasks;

              if (tasks === undefined) // Avoid relatives rules
                for (var _rule = 0; _rule < _rules.length; _rule++) {
                  var _rules$_rule = _rules[_rule],
                      index = _rules$_rule.index,
                      type = _rules$_rule.type,
                      selectors = _rules$_rule.selectors;

                  if (selectors.length > 0) this.addRule(selectors.join(', '), type + ': ' + _value, index);
                }
              if (_relatives) // Relative colors
                for (var _i = 0; _i < _relatives.length; _i++) {
                  this.addRelativesRules(_relatives[_i], _value);
                }
            }
          }
        }
      }
      return this.stylesheet;
    }

    /**
     * Add rules with a value that is relative to another given value
     * @param {String} prop CSSRule property
     * @param {String} value Given value
     */

  }, {
    key: 'addRelativesRules',
    value: function addRelativesRules(prop, value) {
      if (_CSSRules2.default.hasOwnProperty(prop)) {
        var _CSSRules$prop2 = _CSSRules2.default[prop],
            rules = _CSSRules$prop2.rules,
            tasks = _CSSRules$prop2.tasks;
        // Process value

        var processedValue = value;
        for (var t = 0; t < tasks.length; t++) {
          // Apply transformations to value
          var _tasks$t = tasks[t],
              filter = _tasks$t.filter,
              factor = _tasks$t.factor;

          processedValue = _StyleUtils2.default[filter](value, factor);
        }
        for (var rule = 0; rule < rules.length; rule++) {
          var _rules$rule2 = rules[rule],
              index = _rules$rule2.index,
              type = _rules$rule2.type,
              selectors = _rules$rule2.selectors;

          if (selectors.length > 0) this.addRule(selectors.join(', '), type + ': ' + processedValue, index);
        }
      }
    }

    /**
     * Add a new rule to stylesheet
     * @param {String} selector 
     * @param {String} rule
     * @param {Number} index cssRule identifier
     */

  }, {
    key: 'addRule',
    value: function addRule(selector, rule, index) {
      try {
        if ('insertRule' in this.stylesheet) this.stylesheet.insertRule(selector + " { " + rule + " } ", 0);else if ('addRule' in this.stylesheet) // IE < 9
          this.stylesheet.addRule(selector, rule, 0);
        this.rulesMap[index] = this.getCssRule(0);
      } catch (e) {}
      return this;
    }

    /**
     * Get cssRule object from stylesheet
     * @param {Number} id cssRule identifier, Examples: "0", "1"
     * @return {CSSStyleRule}
     */

  }, {
    key: 'getCssRule',
    value: function getCssRule(id) {
      if (this.stylesheet.cssRules) return this.stylesheet.cssRules[id];else if (this.stylesheet.rules) // IE < 9
        return this.stylesheet.rules[id];else return null;
    }

    /**
     * Get cssRule identifier of given CSSStyleRule
     * @param {CSSStyleRule} cssRule CSSStyleRule of interest
     * @return {Number} index of cssRule in stylesheet. Return -1 if not found
     */

  }, {
    key: 'getCssRuleIndex',
    value: function getCssRuleIndex(cssRule) {
      var cssRules = [];
      if (this.stylesheet.cssRules) cssRules = this.stylesheet.cssRules;else if (this.stylesheet.rules) // IE < 9
        cssRules = this.stylesheet.rules;
      for (var rule in cssRules) {
        if (cssRules.hasOwnProperty(rule)) {
          if (cssRules[rule] === cssRule) {
            return rule;
          }
        }
      }
      return -1;
    }

    /**
     * Set a css variable. Delete involved css rules first, then overwrite with new ones
     * @param {String} prop CSSRule property
     * @param {String} value CSSRule value
     */

  }, {
    key: 'setVariable',
    value: function setVariable(prop, value) {
      var group = this.getRulesGroup(prop);
      if (group.length === 0) return this;
      for (var i = 0; i < group.length; i++) {
        this.deleteRule(group[i]);
      }
      var relatives = this.getRelativesRulesGroup(prop);
      for (var _i2 = 0; _i2 < relatives.length; _i2++) {
        this.deleteRule(relatives[_i2]);
      }
      this.addRules(prop, value);
      return this;
    }

    /**
     * Get rule from rulesMap
     * @param {String} index CSSRule identifier
     * @return {CSSStyleRule}
     */

  }, {
    key: 'getRule',
    value: function getRule(index) {
      return this.rulesMap[index] || {};
    }

    /**
     * Get all rules that use given variable (prop)
     * @param {String} prop CSSRule variable
     * @return {Array} array of index's
     */

  }, {
    key: 'getRulesGroup',
    value: function getRulesGroup(prop) {
      return _CSSRules2.default[prop] ? _CSSRules2.default[prop].rules.map(function (r) {
        return r.index;
      }) : [];
    }
  }, {
    key: 'getRelativesRulesGroup',
    value: function getRelativesRulesGroup(prop) {
      if (!_CSSRules2.default[prop]) return [];
      var relativesGroup = [];
      var relatives = _CSSRules2.default[prop].relatives;
      if (relatives) for (var i = 0; i < relatives.length; i++) {
        relativesGroup = relativesGroup.concat(this.getRulesGroup(relatives[i]));
      }
      return relativesGroup;
    }

    /**
     * Removes rule from stylesheet
     * @param {String} key rulesMap key
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(key) {
      var rule = this.rulesMap[key];
      if (!rule) return this;

      var ruleIndex = this.getCssRuleIndex(rule);
      if (this.stylesheet.deleteRule) this.stylesheet.deleteRule(ruleIndex);else if (this.stylesheet.removeRule) // IE < 9
        this.stylesheet.removeRule(ruleIndex);
      this.rulesMap[key] = null;
      return this;
    }
  }, {
    key: 'deleteAllRules',
    value: function deleteAllRules() {
      var rulesIds = Object.keys(this.rulesMap);
      for (var i = 0; i < rulesIds.length; i++) {
        this.deleteRule(rulesIds[i]);
      }
    }

    /**
     * Get style node ID
     */

  }, {
    key: 'getID',
    value: function getID() {
      return this.sheetID;
    }
  }, {
    key: 'toString',
    value: function toString() {
      return 'Dynamic Styles Generator';
    }
  }]);

  return DynStyles;
}();

exports.default = DynStyles;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Style Utils
 */

var StyleUtils = {
  /**
   * Lighten or Darken color (hex value) a certain percentage
   * @param {String} color Example color: '#F61152'
   * @param {String} percent [-1:1]
   * @return {String} result: #000000
   */
  // lightenDarkenColor: function(color, percent) {
  //   var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
  //   return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
  // },
  lightenDarkenColor: function lightenDarkenColor(color, percent) {
    var col = color;
    var amt = percent * 100;

    var usePound = false;

    if (col[0] == "#") {
      col = col.slice(1);
      usePound = true;
    }

    var num = parseInt(col, 16);

    var r = (num >> 16) + amt;

    if (r > 255) r = 255;else if (r < 0) r = 0;

    var b = (num >> 8 & 0x00FF) + amt;

    if (b > 255) b = 255;else if (b < 0) b = 0;

    var g = (num & 0x0000FF) + amt;

    if (g > 255) g = 255;else if (g < 0) g = 0;

    return (usePound ? "#" : "") + String("000000" + (g | b << 8 | r << 16).toString(16)).slice(-6);
  },
  /**
   * Fade color (hex value) a given percentage
   * @param {String} color Example color: '#F61152'
   * @param {String} percent [-1:1]
   * @return {String} result: rgba(0,0,0,0)
   */
  fadeColor: function fadeColor(color, percent) {
    var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    rgb = rgb ? {
      r: parseInt(rgb[1], 16),
      g: parseInt(rgb[2], 16),
      b: parseInt(rgb[3], 16)
    } : { r: '255', g: '255', b: '255' };
    return "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + percent + ")";
  }
};

exports.default = StyleUtils;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Loader = __webpack_require__(93);

var _Loader2 = _interopRequireDefault(_Loader);

var _Header = __webpack_require__(94);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(95);

var _Body2 = _interopRequireDefault(_Body);

var _Footer = __webpack_require__(147);

var _Footer2 = _interopRequireDefault(_Footer);

__webpack_require__(46);

var _KeyboardDriver = __webpack_require__(149);

var _KeyboardDriver2 = _interopRequireDefault(_KeyboardDriver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUI = function (_React$Component) {
  _inherits(GUI, _React$Component);

  function GUI(props) {
    _classCallCheck(this, GUI);

    var _this = _possibleConstructorReturn(this, (GUI.__proto__ || Object.getPrototypeOf(GUI)).call(this, props));

    _this.state = {
      isLoading: props.isLoading,
      // Avatar
      avatar_shape: props.avatar_shape,
      // Content variables
      logo: props.logo,
      brand_name: props.brand_name,
      tagline: props.tagline,
      // Keywords
      keywords: props.keywords,
      // Progress
      progress: props.progress,
      // Test
      test: props.test,
      // Branding
      branding: props.branding,
      // General settings
      typing: props.typing,
      widget_hide_header: props.widget_hide_header
    };
    _this.ee = props.ee;

    // Keyboard shortcuts interface
    _this.keyboardDriver = new _KeyboardDriver2.default({
      ee: _this.ee
    });
    return _this;
  }

  _createClass(GUI, [{
    key: 'isMobile',
    value: function isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var ee = this.ee;
      var _props = this.props,
          isLoading = _props.isLoading,
          avatar_shape = _props.avatar_shape,
          logo = _props.logo,
          brand_name = _props.brand_name,
          tagline = _props.tagline,
          keywords = _props.keywords,
          persistent_menu = _props.persistent_menu,
          progress = _props.progress,
          test = _props.test,
          branding = _props.branding,
          typing = _props.typing,
          widget_hide_header = _props.widget_hide_header;

      var isMobile = this.isMobile();
      window.isMobile = isMobile;

      return _react2.default.createElement(
        'div',
        { id: 'gui', ref: function ref(elem) {
            return _this2.guiRef = elem;
          } },
        _react2.default.createElement(_Loader2.default, {
          isLoading: isLoading
        }),
        _react2.default.createElement(_Header2.default, {
          logo: logo,
          brand_name: brand_name,
          tagline: tagline,
          test: test,
          keywords: keywords,
          persistent_menu: persistent_menu,
          branding: branding,
          widget_hide_header: widget_hide_header,
          ee: ee
        }),
        _react2.default.createElement(_Body2.default, {
          isMobile: isMobile,
          avatar_shape: avatar_shape,
          logo: logo,
          brand_name: brand_name,
          tagline: tagline,
          keywords: keywords,
          progress: progress,
          branding: branding,
          typing: typing,
          widget_hide_header: widget_hide_header,
          ee: ee
        }),
        _react2.default.createElement(_Footer2.default, {
          brand_name: brand_name,
          keywords: keywords,
          branding: branding,
          typing: typing,
          ee: ee
        })
      );
    }
  }]);

  return GUI;
}(_react2.default.Component);

exports.default = GUI;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Loader = function (_React$Component) {
  _inherits(Loader, _React$Component);

  function Loader(props) {
    _classCallCheck(this, Loader);

    var _this = _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).call(this, props));

    _this.state = {
      isLoading: props.isLoading
    };
    return _this;
  }

  _createClass(Loader, [{
    key: "render",
    value: function render() {
      var isLoading = this.props.isLoading;


      if (isLoading) return _react2.default.createElement(
        "div",
        { className: "hu-loader" },
        _react2.default.createElement(
          "div",
          { className: "sk-folding-cube" },
          _react2.default.createElement("div", { className: "sk-cube1 sk-cube" }),
          _react2.default.createElement("div", { className: "sk-cube2 sk-cube" }),
          _react2.default.createElement("div", { className: "sk-cube4 sk-cube" }),
          _react2.default.createElement("div", { className: "sk-cube3 sk-cube" })
        ),
        _react2.default.createElement(
          "div",
          { className: "hu-loader-referral" },
          _react2.default.createElement(
            "p",
            { className: "hu-loader-referral_text hu-color_contrast" },
            "POWERED BY",
            _react2.default.createElement("br", null),
            _react2.default.createElement(
              "b",
              null,
              "LANDBOT"
            ),
            ".io \uD83E\uDD16"
          )
        )
      );else return null;
    }
  }]);

  return Loader;
}(_react2.default.Component);

exports.default = Loader;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Config = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import KeywordSelector from './keywords/KeywordSelector';
// import PersistentMenu from './keywords/PersistentMenu';

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.state = {
      logo: props.logo,
      brand_name: props.brand_name,
      tagline: props.tagline,
      test: props.test,
      keywords: props.keywords,
      persistent_menu: props.persistent_menu,
      branding: props.branding,
      widget_hide_header: props.widget_hide_header
    };
    _this.ee = props.ee;
    return _this;
  }

  _createClass(Header, [{
    key: 'renderButton',
    value: function renderButton() {
      var _props = this.props,
          test = _props.test,
          brand_name = _props.brand_name,
          branding = _props.branding;
      // return ( branding !== false &&
      //     <a 
      //       href={referralHeaderURL} 
      //       className="hu-header-btn-referral hu-a-center hu-d-none hu-s-12 hu-w-bold hu-color_contrast hu-border-color_contrast-fade-07"
      //     >
      //       <div className="primary">
      //         <span>
      //           Powered by <b>Landbot.io</b>
      //         </span>
      //       </div>
      //       <div className="secondary">
      //         <span>
      //           Get your Landbot 🤖
      //         </span>
      //       </div>
      //     </a>
      //   );

      return (/*!test*/true ? branding !== false && _react2.default.createElement(
          'a',
          {
            href: _Config.referralHeaderURL,
            target: '_blank',
            className: 'hu-header-btn-referral hu-a-center hu-d-none hu-s-12 hu-w-bold hu-color_contrast hu-border-color_contrast-fade-07'
          },
          _react2.default.createElement(
            'div',
            { className: 'primary' },
            _react2.default.createElement(
              'span',
              null,
              'Powered by ',
              _react2.default.createElement(
                'b',
                null,
                'Landbot.io'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'secondary' },
            _react2.default.createElement(
              'span',
              null,
              'Get your Landbot \uD83E\uDD16'
            )
          )
        ) : _react2.default.createElement(
          'a',
          {
            href: '#',
            className: 'hu-header-btn-referral hu-a-center hu-d-none hu-s-12 hu-w-bold hu-color_contrast hu-border-color_contrast-fade-07',
            onClick: function onClick() {
              return location.reload();
            }
          },
          _react2.default.createElement(
            'div',
            { className: 'test' },
            _react2.default.createElement(
              'span',
              null,
              'Reset chatbot'
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          logo = _props2.logo,
          brand_name = _props2.brand_name,
          tagline = _props2.tagline,
          test = _props2.test,
          keywords = _props2.keywords,
          persistent_menu = _props2.persistent_menu,
          branding = _props2.branding,
          widget_hide_header = _props2.widget_hide_header;


      return !widget_hide_header && _react2.default.createElement(
        'header',
        { id: 'hu-header', className: 'hu-border-color_contrast-fade hu-background-color_header-background' },
        _react2.default.createElement(
          'div',
          { className: 'hu-header-content' },
          logo !== 'none' && _react2.default.createElement('img', { className: 'hu-header-logo', src: logo, alt: '' }),
          _react2.default.createElement(
            'h1',
            { className: 'hu-header-brand_name hu-w-bold hu-s-20 hu-color_header-text' },
            brand_name
          ),
          _react2.default.createElement(
            'p',
            { className: 'hu-header-tagline hu-s-14 hu-x-ellipsis hu-color_header-text', title: tagline },
            tagline
          ),
          this.renderButton()
        )
      );
    }
  }]);

  return Header;
}(_react2.default.Component);

exports.default = Header;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Messenger = __webpack_require__(96);

var _Messenger2 = _interopRequireDefault(_Messenger);

var _ProgressBar = __webpack_require__(146);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = function (_React$Component) {
  _inherits(Body, _React$Component);

  function Body(props) {
    _classCallCheck(this, Body);

    var _this = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this, props));

    _this.state = {
      isMobile: props.isMobile,
      avatar_shape: props.avatar_shape,
      keywords: props.keywords,
      logo: props.logo,
      branding: props.branding,
      tagline: props.tagline
    };
    _this.ee = props.ee;
    return _this;
  }

  _createClass(Body, [{
    key: 'render',
    value: function render() {
      var ee = this.ee;
      var _props = this.props,
          isMobile = _props.isMobile,
          avatar_shape = _props.avatar_shape,
          logo = _props.logo,
          brand_name = _props.brand_name,
          tagline = _props.tagline,
          keywords = _props.keywords,
          progress = _props.progress,
          branding = _props.branding,
          typing = _props.typing,
          widget_hide_header = _props.widget_hide_header;


      return _react2.default.createElement(
        'section',
        { id: 'hu-body' },
        _react2.default.createElement(_ProgressBar2.default, { progress: progress }),
        _react2.default.createElement(_Messenger2.default, {
          isMobile: isMobile,
          avatar_shape: avatar_shape,
          logo: logo,
          brand_name: brand_name,
          tagline: tagline,
          keywords: keywords,
          branding: branding,
          typing: typing,
          widget_hide_header: widget_hide_header,
          ee: ee
        })
      );
    }
  }]);

  return Body;
}(_react2.default.Component);

exports.default = Body;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Observable = __webpack_require__(1);

var _Subject = __webpack_require__(42);

var _BehaviorSubject = __webpack_require__(98);

__webpack_require__(19);

__webpack_require__(99);

__webpack_require__(106);

__webpack_require__(108);

__webpack_require__(116);

__webpack_require__(23);

__webpack_require__(119);

__webpack_require__(122);

__webpack_require__(124);

__webpack_require__(126);

__webpack_require__(128);

var _Config = __webpack_require__(3);

var _Config2 = _interopRequireDefault(_Config);

var _Message = __webpack_require__(130);

var _Message2 = _interopRequireDefault(_Message);

var _InputBase = __webpack_require__(134);

var _InputBase2 = _interopRequireDefault(_InputBase);

var _FixedInputBase = __webpack_require__(135);

var _FixedInputBase2 = _interopRequireDefault(_FixedInputBase);

var _MobileInputBase = __webpack_require__(136);

var _MobileInputBase2 = _interopRequireDefault(_MobileInputBase);

var _InputBox = __webpack_require__(137);

var _InputBox2 = _interopRequireDefault(_InputBox);

var _ScrollButton = __webpack_require__(47);

var _ScrollButton2 = _interopRequireDefault(_ScrollButton);

var _KeywordSelector = __webpack_require__(30);

var _KeywordSelector2 = _interopRequireDefault(_KeywordSelector);

var _Logger = __webpack_require__(26);

var _Logger2 = _interopRequireDefault(_Logger);

var _ChatUtils = __webpack_require__(14);

var _ChatUtils2 = _interopRequireDefault(_ChatUtils);

var _DateUtils = __webpack_require__(27);

var _DateUtils2 = _interopRequireDefault(_DateUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import Rx from 'rxjs';


// Test purposes
// import sampleMessages from './sample-messages';

var Messenger = function (_React$Component) {
  _inherits(Messenger, _React$Component);

  function Messenger(props) {
    _classCallCheck(this, Messenger);

    var _this = _possibleConstructorReturn(this, (Messenger.__proto__ || Object.getPrototypeOf(Messenger)).call(this, props));

    _this.state = {
      isMobile: props.isMobile,
      avatar_shape: props.avatar_shape,
      logo: props.logo,
      brand_name: props.brand_name,
      tagline: props.tagline,
      keywords: props.keywords,
      branding: props.branding,
      typing: props.typing,
      widget_hide_header: props.widget_hide_header,
      messagesList: [],
      agentsInfo: {},
      loadingOldMessages: false,
      disabled: true,
      input_motion: true,
      input_type: null,
      field: null,
      field_type: null,
      buttons: null,
      payloads: null,
      extra: null,
      backButton: _this.showBackButton(),
      fixed: false
    };

    _this.ee = props.ee;
    _this.messagesContainer = null;
    _this.moreMessagesButton = null;
    _this.setupListeners();
    _this.getAgentsInfo();

    _this.scrollTopFixer = null;
    _this.scrollFixer = null;
    _this.scrollAuto = true;

    _this.mobileHA = true;
    _this.animationsDelay = 500;
    _this.typingState$ = new _BehaviorSubject.BehaviorSubject(false);
    _this.engageIndex = 0;
    _this.initialChatFlag = true;
    _this.endEngageFlag = false;
    _this.endFlowFlag = false;
    _this.restarting = false;

    _this.inputAnimation$ = new _Subject.Subject();

    // Temporal chat data
    window.temp_data = {
      name: '',
      phone: '',
      email: ''
      // Add fields
    };
    return _this;
  }

  _createClass(Messenger, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      // MESSAGES BUFFER
      var queueMessagesRender$ = new _Subject.Subject();
      queueMessagesRender$.startWith(null).pairwise(queueMessagesRender$).concatMap(function (messages) {
        var prevMessage = messages[0];
        var message = messages[1];

        if (message === null || _this2.restarting) {
          _this2.endFlowFlag = true;
          return _Observable.Observable.of(null).delay(0);
        }

        message.typing = false;

        if (_this2.hasRoleType(prevMessage, 'error')) {
          _this2.endFlowFlag = false;
          return _Observable.Observable.of(null).delay(0);
        }

        /**
         * Los mensajes cuyo previo era de tipo engage aparecen al instante.
         */
        if (_this2.hasRoleType(prevMessage, 'engage')) {

          _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Previous message is "engage"', 'landbot.messages[' + message.key + ']');

          message.key = prevMessage.key;
          message.typingDelay = 0;
          _this2.endFlowFlag = false;
          return _Observable.Observable.of(message).delay(0);

          /**
           * Los mensajes de tipo engage aparecen al instante
           */
        } else if (_this2.hasRoleType(message, 'engage')) {

          _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Current message is "engage"', 'landbot.messages[' + message.key + ']');

          message.typing = _this2.typingState$;
          message.typingDelay = 20000;
          _this2.endFlowFlag = false;
          return _Observable.Observable.of(message).delay(0);

          /**
           * Los mensajes de bot, si typing === true y no ha sido activado
           * el flag de salto de group, aparecen al finalizar el flujo del 
           * mensaje anterior.
           */
        } else if (message.samurai < 0 && _this2.props.typing === true) {
          message.typing = _this2.typingState$;
          message.typingDelay = _this2.getTypingDelay(prevMessage, message).typing;

          // El primer mensaje aparece sin delay
          if (prevMessage === null) {

            _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': First group message', 'landbot.messages[' + message.key + ']');

            _this2.endFlowFlag = false;
            return _Observable.Observable.of(message).delay(0);
          }

          // Mensajes que no tienen que esperar el fin de flujo
          if (_this2.hasRoleType(prevMessage, 'end-flow')) {

            _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Previous message has role type "end-flow", so current launches', 'landbot.messages[' + message.key + ']');

            _this2.endFlowFlag = false;
            return _Observable.Observable.of(message).delay(0);
          }

          if (_this2.endFlowFlag) {

            _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': "end-flow" flag was enabled, so it launches', 'landbot.messages[' + message.key + ']');

            _this2.endFlowFlag = false;
            return _Observable.Observable.of(message).delay(0);
          }

          _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Message awaits for "end-flow" event and launches', 'landbot.messages[' + message.key + ']');

          // Mensajes a la espera de un evento de fin de flujo
          return _Observable.Observable.of(message).delayWhen(function () {
            return _Observable.Observable.fromEvent(_this2.ee, 'hu-lb-message-flow-end');
          });

          /**
           * El resto de mensajes aparecen tras el delay propio de animaciones
           */
        } else {

          _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Message awaits for animations timing and launches', 'landbot.messages[' + message.key + ']');

          // return Observable.of(message).delay(0);
          return _Observable.Observable.of(message).delay(_this2.animationsDelay);
        }
      }).subscribe(function (message) {
        if (message === null) return;

        var msg = _this2.processedMessage(message);
        if (msg.author === 'brand') {
          // Only brand messages are rendered

          // Fetch agent data if not in store
          var agentID = msg.data.samurai;
          if (agentID > 0) {
            if (!_this2.state.agentsInfo[agentID]) _this2.ee.emit('hu-query-get-agent', agentID);
          }

          _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Message render', 'landbot.messages[' + msg.data.key + ']');
          // console.debug(`%cLandbot debug: rendering message <${msg.data.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue');
          var animate = true;
          _this2.appendMessage(msg, animate);
        }
      });

      // timeSpan determina el tiempo necesario de espera para asegurar la llegada de mensajes ordenados
      var timeSpan = 1250;
      var reception$ = _Observable.Observable.fromEvent(this.ee, 'hu-receive-message');
      reception$.subscribe({
        next: function next(v) {
          if (v) _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Message received', 'landbot.messages[' + v.key + ']').append(v, 'landbot.messages[' + v.key + ']');
          // console.debug(`%cLandbot debug: received new message <${v.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue')
          // console.debug(v)
        }
      });

      // MESSAGES RECEIVED FROM FIREBASE
      var messageReception$ = reception$.bufferWhen(function () {
        return _Observable.Observable.fromEvent(_this2.ee, 'hu-receive-message').debounceTime(timeSpan); // Resetea el tiempo cada vez que llega uno nuevo
      }).subscribe(function (data) {
        // Mensajes ordenados
        var messages = data.filter(function (m) {
          return m;
        }).filter(function (m) {
          return m.samurai !== undefined;
        }).filter(_this2.messagesFilter)
        // .filter(m => !this.getReferralFilter(m))
        .sort(function (a, b) {
          return a.timestamp - b.timestamp;
        }).map(function (m) {
          return JSON.parse(JSON.stringify(m));
        });

        for (var i = 0; i < messages.length; i++) {
          var msg = messages[i];
          if (msg !== null && i === messages.length - 1) {
            // This is the last message in a group of incoming messages
            msg.role = _this2.addRoleType(msg, 'end-flow');

            _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Message defined as "end-flow"', 'landbot.messages[' + msg.key + ']');

            // Proactive message can't be referral
            if (msg.type === 'referral' && messages[i - 1]) {
              if (messages[i - 1].samurai !== undefined) {
                // En este punto, el objeto mensaje puede contener más objetos, de modo que necesita
                // ser convertido en un objeto "puro"
                var _messages2 = messages[i - 1],
                    extra = _messages2.extra,
                    key = _messages2.key,
                    message = _messages2.message,
                    role = _messages2.role,
                    samurai = _messages2.samurai,
                    type = _messages2.type;

                var _msg = { data: { extra: extra, key: key, message: message, role: role, samurai: samurai, type: type } };
                _this2.ee.emit('hu-receive-last-group-message', _msg);

                _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Previous message emitted as last group message', 'landbot.messages[' + key + ']');
              } else _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Message is referral but none is emitted as last group message', 'landbot.messages[' + msg.key + ']', 'warn');
            } else {
              // En este punto sigue siendo un objeto "puro"
              _this2.ee.emit('hu-receive-last-group-message', _this2.processedMessage(msg));

              _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Message emitted as last group message', 'landbot.messages[' + msg.key + ']');
            }
          }
          queueMessagesRender$.next(msg);
        }
      });

      // SENT MESSAGES RENDERED IMMEDIATELY
      var sending$ = _Observable.Observable.fromEvent(this.ee, 'hu-sending-message').subscribe(function (message) {
        if (message.render === false) return;
        // this.addRoleType(message, 'end-flow');
        var animate = true;
        _this2.disableInput(function () {
          _this2.appendMessage(_this2.processedMessage(message), animate);

          // ENGAGE PROTOCOL --------------------------------------------
          // Protocolo empleado en la conexión inicial a firebase,
          // donde se simula un mensaje de typing durante dicha conexión.
          // if (!this.state.fixed) {
          //   // queueMessagesRender$.next(null);
          //   this.ee.emit('hu-receive-message', {
          //     key: `engage_${this.engageIndex++}`,
          //     type: 'text',
          //     message: CONFIG.text.error,
          //     samurai: -1,
          //     role: ['engage'],
          //     extra: { hide_textbox: true },
          //   });
          // }
          // END ENGAGE PROTOCOL ----------------------------------------
        });
      });

      this.ee.on('hu-receive-ghost-message', function (message) {
        var animate = true;
        _this2.appendMessage(_this2.processedMessage(message), animate);
      });

      this.ee.on('hu-initial-chat', function (messages) {
        if (_this2.initialChatFlag) {
          _this2.initialChatFlag = false;
          var _messages = messages.filter(_this2.messagesFilter).map(_this2.processedMessage);
          _this2.renderInitialChat(_messages);
          _this2.onMessagesChunk(_messages);
        }
      });

      this.ee.on('hu-reset-chat', function () {
        _this2.ee.emit('hu-lb-message-flow-end');
        _this2.initialChatFlag = false;
        _this2.restarting = true;
        // Null resets messages animations flow
        queueMessagesRender$.next(null);

        var receiverReady$ = _Observable.Observable.fromEvent(_this2.ee, 'hu-lb-receiver-ready');
        var initialChat$ = _Observable.Observable.fromEvent(_this2.ee, 'hu-initial-chat');
        var newMessage$ = _Observable.Observable.fromEvent(_this2.ee, 'hu-receive-message');

        // Receive initial chat
        _Observable.Observable.merge(receiverReady$, initialChat$).distinctUntilChanged().pairwise().first().subscribe({
          next: function next(v) {
            if (_this2.restarting) {
              // Race with "Receive new message"
              _this2.restarting = false;
              var messages = v.filter(function (w) {
                return w;
              })[0].filter(_this2.messagesFilter).map(_this2.processedMessage);
              _this2.renderInitialChat(messages);
              _this2.onMessagesChunk(messages);
            }
          }
        });

        // Receive new message
        _Observable.Observable.merge(receiverReady$, newMessage$).distinctUntilChanged().pairwise().first().subscribe({
          next: function next(v) {
            if (_this2.restarting) {
              // Race with "Receive initial chat"
              _this2.restarting = false;
            }
          }
        });

        // Hide Old chat button
        if (_this2.moreMessagesButton) Velocity(_this2.moreMessagesButton, { opacity: 0 }, { duration: 500 });
        _this2.setState({ disabled: true }, function () {
          _this2.scrollBottom(350, 'top');
          _this2.inputAnimation$.next('input_out');
        });
        setTimeout(function () {
          _this2.setState({
            messagesList: [],
            hasOldMessages: false
          }, function () {
            return _this2.ee.emit('hu-lb-receiver-ready');
          });
        }, 600);
        // Velocity(
        //   document.querySelectorAll('#hu-messages-container .hu-message'),
        //   { opacity: 0.5 },
        //   { duration: 500, complete: () => {
        //     this.setState({
        //       messagesList: [],
        //     }, () => {
        //       console.log(this.state.messagesList);

        //     });
        //   }}
        // );
      });

      this.ee.on('hu-old-chat', function (messages) {
        _this2.concatOldMessages(messages.filter(_this2.messagesFilter).map(_this2.processedMessage));
      });

      // BRAND MESSAGE ANIMATION FLOW
      this.brandMessageAnimation$ = new _Subject.Subject();
      this.brandMessageAnimation$ = this.brandMessageAnimation$.concatMap(function (message) {
        return _Observable.Observable.from(['avatar_in', 'bubble_left_in', 'typing_on', 'typing_off', 'bubble_resize', 'input_enable', 'flow_end']).concatMap(function (step) {
          switch (step) {
            case 'avatar_in':
              _this2.scrollBottom(250);
              return _Observable.Observable.of(step).delayWhen(function () {
                return _Observable.Observable.merge(_Observable.Observable.fromEvent(_this2.ee, 'hu-lb-avatar-translation-end'), _Observable.Observable.timer(250));
              }).first();
            case 'bubble_left_in':
              return _Observable.Observable.of(step).delayWhen(function () {
                return _Observable.Observable.merge(_Observable.Observable.fromEvent(_this2.ee, 'hu-lb-bubble-in'), _Observable.Observable.timer(250) // Verificado
                );
              }).first();
            case 'typing_on':
              /////// TYPING ///////
              /**
               * Un mensaje con typing puede o no tener typing según su
               * función o condiciones externas
               */
              if (message.typing) {
                if (_this2.hasRoleType(message, 'engage')) {
                  _this2.typingState$.next({ key: message.key, state: message.typingDelay });

                  // El flag de fin de engage indica que el mensaje real ya ha sido renderizado
                  if (_this2.endEngageFlag) {
                    _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': End Engage Flag was True. Disabling typing...', 'landbot.messages[' + message.key + ']');

                    _this2.endEngageFlag = false;
                    return _Observable.Observable.of(step).delay(0);
                  } else {
                    _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Typing enabled till timer || engage-end event received', 'landbot.messages[' + message.key + ']');

                    return _Observable.Observable.of(step).delayWhen(function () {
                      return _Observable.Observable.merge(_Observable.Observable.timer(message.typingDelay),
                      // Observable.fromEvent(this.ee, 'hu-lb-key-arrowdown')
                      _Observable.Observable.fromEvent(_this2.ee, 'hu-lb-engage-end'));
                    });
                  }
                }

                if (_this2.props.typing) {
                  _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Typing enabled', 'landbot.messages[' + message.key + ']');

                  _this2.typingState$.next({ key: message.key, state: message.typingDelay });
                  return _Observable.Observable.of(step).delayWhen(function () {
                    return _Observable.Observable.merge(_Observable.Observable.timer(message.typingDelay), _Observable.Observable.fromEvent(_this2.ee, 'hu-lb-key-arrowdown'));
                  });
                }

                return _Observable.Observable.of(step).delay(0);

                /**
                 * Mensajes sin typing
                 */
              } else {
                _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Typing disabled', 'landbot.messages[' + message.key + ']');

                _this2.typingState$.next({ key: message.key, state: false });
                return _Observable.Observable.of(step).delay(0);
              }
            case 'typing_off':
              _this2.endEngageFlag = false;
              _this2.typingState$.next({ key: message.key, state: false });
              return _Observable.Observable.of(step).delay(0);
            case 'bubble_resize':
              return _Observable.Observable.of(step).delayWhen(function () {
                return _Observable.Observable.merge(_Observable.Observable.fromEvent(_this2.ee, 'hu-lb-bubble-resize-end'), _Observable.Observable.timer(0));
              }).first();
            case 'input_enable':
              _this2.inputAnimation$.next('input_enable');
              return _Observable.Observable.of(step).delayWhen(function () {
                return _Observable.Observable.merge(_Observable.Observable.fromEvent(_this2.ee, 'hu-lb-input-resize-end'), _Observable.Observable.timer(0));
              }).first();
            case 'flow_end':
              _this2.ee.emit('hu-lb-message-flow-end');
              return _Observable.Observable.of(step).delay(0);
            default:
              return _Observable.Observable.of(step).delay(0);
          }
        });
      });

      // USER MESSAGE ANIMATION FLOW
      this.userMessageAnimation$ = new _Subject.Subject();
      this.userMessageAnimation$ = this.userMessageAnimation$.concatMap(function (message) {
        return _Observable.Observable.from(['input_out', 'bubble_right_in', 'bubble_resize', 'flow_end']).concatMap(function (step) {
          switch (step) {
            case 'input_out':
              _this2.inputAnimation$.next('input_out');
              return _Observable.Observable.of(step).delay(0);
            case 'bubble_right_in':
              return _Observable.Observable.of(step).delayWhen(function () {
                return _Observable.Observable.merge(_Observable.Observable.fromEvent(_this2.ee, 'hu-lb-bubble-in'), _Observable.Observable.timer(350) // En realidad este tiempo es el de input_out
                );
              }).first();
            case 'bubble_resize':
              return _Observable.Observable.of(step).delayWhen(function () {
                return _Observable.Observable.merge(_Observable.Observable.fromEvent(_this2.ee, 'hu-lb-bubble-resize-end'), _Observable.Observable.timer(350));
              }).first();
            case 'flow_end':
              // ENGAGE PROTOCOL --------------------------------------------
              if (!_this2.state.fixed) {
                setTimeout(function () {
                  queueMessagesRender$.next(null);
                  queueMessagesRender$.next({
                    key: 'engage_' + _this2.engageIndex++,
                    type: 'text',
                    message: _Config2.default.text.error,
                    samurai: -1,
                    role: ['engage', 'end-flow'],
                    extra: { hide_textbox: true }
                  });
                }, 500);
              }
              // ENGAGE PROTOCOL --------------------------------------------
              _this2.ee.emit('hu-lb-message-flow-end');
              return _Observable.Observable.of(step).delay(0);
            default:
              return _Observable.Observable.of(step).delay(0);
          }
        });
      });

      // this.ee.on('hu-remove-message', (messagesInfo) => {
      //   messagesInfo.messages.forEach((message) => {
      //     this.removeMessage(message);
      //   });
      // });

      this.ee.on('hu-get-stored-agents', function (agentsData) {
        _this2.setState({
          agentsInfo: agentsData
        });
      });

      this.ee.on('hu-get-agent', function (agentInfo) {
        var agentsInfo = _this2.state.agentsInfo;

        var _agentsInfo = JSON.parse(JSON.stringify(agentsInfo));
        _agentsInfo[agentInfo.samurai] = {
          name: agentInfo.name,
          avatar: agentInfo.avatar
        };
        _this2.setState({
          agentsInfo: _agentsInfo
        });
      });

      // this.ee.on('hu-scroll-button-click', () => {
      //   this.onScrollButtonClick();
      // });

      this.ee.on('hu-lb-engage-end', function () {
        _this2.endEngageFlag = true;
      });

      this.ee.on('hu-error-sending-message', function () {
        _this2.ee.emit('hu-receive-message', {
          key: _ChatUtils2.default.randomKey(20),
          type: 'text',
          message: _Config2.default.text.error,
          samurai: -1,
          role: ['error', 'end-flow'],
          extra: { hide_textbox: true, typing: false }
        });
      });

      // NOT USED
      // this.ee.on('hu-lb-temp-data', ({ field, value }) => {
      //   temp_data[field] = value;
      // });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ee.emit('hu-landbot-ready');
    }
  }, {
    key: 'hasRoleType',
    value: function hasRoleType(msg, type) {
      if (!msg) return false;
      var _role = msg.role || [];
      try {
        if (typeof type === 'string') return _role.indexOf(type) > -1;
        // else  // Array
        //   return
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'addRoleType',
    value: function addRoleType(msg, type) {
      var _role = msg.role || [];
      try {
        if (typeof type === 'string') return _role.indexOf(type) > -1 ? _role : _role.concat(type);else // Array
          return _role.concat(type.filter(function (t) {
            return _role.indexOf(t) === -1;
          }));
      } catch (e) {
        return _role;
      }
    }
  }, {
    key: 'removeRoleType',
    value: function removeRoleType(msg, type) {
      var index = msg.role.indexOf(type);
      index > -1 ? msg.role.splice(index, 1) : null;
    }
  }, {
    key: 'isExtraWelcome',
    value: function isExtraWelcome(data) {
      try {
        return !!data.extra.welcome;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getTypingDelay',
    value: function getTypingDelay(prevMessage, message) {
      var typing = 0;
      // Desactivación individual
      if (!this.isTyping(message)) {
        typing = 0;
        // Primer mensaje de bot
      } else if (prevMessage === null || prevMessage.samurai === undefined || this.hasRoleType(prevMessage, 'end-flow')) typing = 100;
      // Resto de mensajes
      else {
          var text = prevMessage.type === 'dialog' ? prevMessage.title ? prevMessage.title : ' ' : prevMessage.message ? prevMessage.message : ' ';
          var words = text.replace(/\s+/g, ' ').split(' ').length;
          typing = Math.min(200 * words, 1500); // 5 sec maximum
        }
      var currDelay = prevMessage ? prevMessage.typingDelay ? prevMessage.typingDelay : 0 : 0;
      return { typing: typing, currDelay: currDelay };
    }
  }, {
    key: 'getAgentsInfo',
    value: function getAgentsInfo() {
      this.ee.emit('hu-query-stored-agents');
    }
  }, {
    key: 'isTyping',
    value: function isTyping(data) {
      var _isTyping = true;
      var _data = data.extra || {};
      if (_data) _isTyping = typeof _data.typing === 'boolean' ? _data.typing : true;
      return _isTyping;
    }
  }, {
    key: 'userMoveScroll',
    value: function userMoveScroll(e) {
      Velocity(this.messagesContainer, 'stop', { mobileHA: this.mobileHA });
      var scrollPosition = this.messagesContainer.scrollHeight - this.messagesContainer.clientHeight;
      if (this.messagesContainer.scrollTop >= scrollPosition - 30) this.scrollAuto = true;else this.scrollAuto = false;
    }
  }, {
    key: 'scrollBottom',
    value: function scrollBottom() {
      var tspan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'bottom';

      if (this.scrollAuto) {
        Velocity(this.messagesContainer, 'stop', { mobileHA: this.mobileHA });
        Velocity(direction === 'top' ? this.scrollTopFixer : this.scrollFixer, 'scroll', {
          duration: tspan,
          container: this.messagesContainer,
          mobileHA: this.mobileHA
        });
      }
    }
  }, {
    key: 'showBackButton',
    value: function showBackButton() {
      var keywords = this.props.keywords;

      var result = false;
      for (var k in keywords) {
        if (keywords[k] === 'back') result = true;
      }return result;
    }
  }, {
    key: 'processedMessage',
    value: function processedMessage(message) {
      return {
        key: message.key,
        author: message.samurai !== undefined ? 'brand' : 'user',
        data: message, // All message data coming from firebase
        message_id: message.message_id
      };
    }
  }, {
    key: 'messagesFilter',
    value: function messagesFilter(message) {
      return ['text', 'referral', 'dialog', 'menu', 'image', 'multiple_images', 'iframe'].indexOf(message.type) > -1;
    }
  }, {
    key: 'appendMessage',
    value: function appendMessage(message) {
      var _this3 = this;

      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var messagesList = this.state.messagesList.slice();
      message.animate = animate;
      var lastMessage = messagesList[messagesList.length - 1];
      var engageReplacement = false;

      // Aplicar reordenación
      if (lastMessage) if (lastMessage.timestamp > message.timestamp) {
        // Una vez aplicada reordenación, podemos reducir la espera a 1seg

      }

      if (lastMessage) {
        if (this.hasRoleType(lastMessage.data, 'engage')) {
          // Last message replacement
          messagesList[messagesList.length - 1] = message;
          engageReplacement = true;
        } else messagesList.push(message);
      } else messagesList.push(message);

      if (message.data.samurai === undefined) {
        // No input changes
        this.setState({
          messagesList: messagesList
        });

        _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': [' + message.data.key + '] User message => No input changes', 'landbot.input');
      } else if (message.data.samurai >= 0) {
        // Fixed text input (assigned agent)
        this.setState({
          messagesList: messagesList,
          disabled: false,
          input_motion: true,
          input_type: 'text',
          fixed: true
        }, function () {
          _ChatUtils2.default.disableInput();
        });

        _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': [' + message.data.key + '] Agent message => Input fixed', 'landbot.input');
      } else {
        // Input changes
        var state = {};
        var disabled = true;
        var fixed = this.getExtraTextareaFixed(message.data);
        if (fixed) {
          // Fixed from extra
          state = {
            messagesList: messagesList,
            disabled: false,
            input_motion: true,
            input_type: 'text',
            fixed: true
          };

          _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': [' + message.data.key + '] Bot message => Input fixed', 'landbot.input');
        } else if (this.getReferralFilter(message.data)) {
          // Cuando se recibe un referral pero en realidad está oculto porque se encuentra
          // en plan starter+, éste machaca las opciones de input. En este caso las mantiene.
          disabled = this.state.disabled;
          state = {
            messagesList: messagesList,
            backButton: false
          };

          _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': [' + message.data.key + '] Bot message => (Referral) No input changes', 'landbot.input');
        } else {
          // Default behavior
          disabled = this.getDisabledInput(message);
          state = {
            messagesList: messagesList,
            disabled: disabled,
            input_motion: disabled ? false : true,
            input_type: this.getInputType(message.data),
            field: this.getInputField(message.data),
            field_type: this.getFieldType(message.data),
            buttons: message.data.buttons,
            payloads: message.data.payloads,
            extra: message.data.extra,
            backButton: !this.hasRoleType(message.data, 'welcome') && !this.hasRoleType(message.data, 'revisit') && !this.isExtraWelcome(message.data) && message.data.type !== 'referral' && this.showBackButton(),
            fixed: false
          };
        }
        this.setState(state, function () {
          if (!disabled && !fixed) {
            if (engageReplacement) {
              _this3.inputAnimation$.next('input_enable');
            }
            _ChatUtils2.default.enableInput();
          }
        });

        _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': [' + message.data.key + '] Bot message => Input ' + this.getInputType(message.data), 'landbot.input');
      }
    }
  }, {
    key: 'renderInitialChat',
    value: function renderInitialChat(messages) {
      var _this4 = this;

      if (messages.length === 0) return;

      var hasOldMessages = messages.length >= 20;
      var lastMessage = messages[messages.length - 1];

      /**
       * En lugar de utilizar lastMessage, intentaré utilizar el último mensaje
       * escrito por brand. Si es de bot, nada, pero si es de agente, se 
       * establece un input fixed.
       */
      var lastBrandMessage = this.getLastBrandMessage(messages);

      if ( // Fixed text input (assigned agent)
      lastBrandMessage.data.samurai >= 0 || this.getExtraTextareaFixed(lastBrandMessage.data)) this.setState({
        messagesList: messages,
        hasOldMessages: hasOldMessages,
        disabled: false,
        input_motion: true,
        input_type: 'text',
        fixed: true
      }, function () {
        _ChatUtils2.default.disableInput();
        setTimeout(function () {
          _this4.inputAnimation$.next('input_enable');
        }, 100);
      });else if (lastMessage.data.samurai === undefined) // No input changes
        this.setState({
          messagesList: messages,
          hasOldMessages: hasOldMessages
        });else {
        // Input changes
        var state = {};
        var disabled = true;
        var fixed = this.getExtraTextareaFixed(lastMessage.data);
        if (fixed) // Fixed from extra
          state = {
            messagesList: messages,
            hasOldMessages: hasOldMessages,
            disabled: false,
            input_motion: true,
            input_type: 'text',
            fixed: true
          };else {
          // Default behavior
          disabled = this.getDisabledInput(lastMessage);
          state = {
            messagesList: messages,
            hasOldMessages: hasOldMessages,
            disabled: disabled,
            input_type: this.getInputType(lastMessage.data),
            field: this.getInputField(lastMessage.data),
            field_type: this.getFieldType(lastMessage.data),
            buttons: lastMessage.data.buttons,
            payloads: lastMessage.data.payloads,
            extra: lastMessage.data.extra,
            backButton: !this.hasRoleType(lastMessage.data, 'welcome') && !this.hasRoleType(lastMessage.data, 'revisit') && !this.isExtraWelcome(lastMessage.data) && lastMessage.data.type !== 'referral' && this.showBackButton(),
            fixed: false
          };
        }
        this.setState(state, function () {
          if (!disabled) {
            _ChatUtils2.default.enableInput();
            setTimeout(function () {
              _this4.inputAnimation$.next('input_enable');
            }, 100);
          } else {
            setTimeout(function () {
              _this4.scrollBottom(350);
            }, 100);
          }
        });
      }
    }
  }, {
    key: 'concatOldMessages',
    value: function concatOldMessages(messages) {
      var messagesList = this.state.messagesList.slice();
      if (messages.length !== 0) {
        this.setState({
          messagesList: messages.concat(messagesList),
          hasOldMessages: true,
          loadingOldMessages: false
        });
      } else {
        this.setState({
          hasOldMessages: false,
          loadingOldMessages: false
        });
      }
    }

    /**
     * Returns last brand message from a list of messages
     * @param {Array} messages - Processed messages
     */

  }, {
    key: 'getLastBrandMessage',
    value: function getLastBrandMessage(messages) {
      var i = 1;
      var lastBrandMessage = messages[messages.length - i];
      while (lastBrandMessage.data.samurai === undefined && i < messages.length - 1 || lastBrandMessage.data.samurai !== undefined && this.getReferralFilter(lastBrandMessage.data)) {
        i += 1;
        lastBrandMessage = messages[messages.length - i];
      }
      return lastBrandMessage;
    }
  }, {
    key: 'onMessagesChunk',
    value: function onMessagesChunk(messages) {
      var msg = messages[messages.length - 1];
      var _msg = this.getLastBrandMessage(messages);
      if (!msg) return;
      if (msg.data.samurai !== undefined) {
        // brand message
        _Logger2.default.append('Message emitted as last group message ' + _DateUtils2.default.format(new Date(), 'HH:mm:ss.ff'), 'landbot.messages[' + _msg.data.key + ']').append(_msg, 'landbot.messages[' + _msg.data.key + ']');
        this.ee.emit('hu-receive-last-group-message', _msg);
      } else {
        // user message: Used to detect humanTakeOver
        _Logger2.default.append('Message emitted as last brand message ' + _DateUtils2.default.format(new Date(), 'HH:mm:ss.ff'), 'landbot.messages[' + _msg.data.key + ']').append(msg, 'landbot.messages[' + _msg.data.key + ']');
        this.ee.emit('hu-receive-last-brand-message', _msg);
      }
    }
  }, {
    key: 'removeMessage',
    value: function removeMessage() {
      // TODO
      var messagesList = this.state.messagesList.slice();
      this.setState({
        messagesList: messagesList
      });
    }
  }, {
    key: 'queryOldMessages',
    value: function queryOldMessages() {
      if (!this.state.loadingOldMessages) {
        this.ee.emit('hu-query-old-messages');
        this.setState({
          loadingOldMessages: true
        });
      }
    }
  }, {
    key: 'getInputType',
    value: function getInputType(data) {
      var isMenu = ['dialog', 'menu'].indexOf(data.type) > -1;
      var isReferral = this.getInputReferral(data);
      var field = this.getInputField(data);
      var multi = this.getInputMulti(data);
      var hideTextbox = this.getInputHidetextbox(data);
      var input_type = 'none';
      if (isReferral) input_type = 'referral';else if (isMenu) input_type = multi ? 'multi' : 'menu';else if (field) input_type = 'field';else if (!hideTextbox) input_type = 'text';
      return input_type;
    }
  }, {
    key: 'getReferralFilter',
    value: function getReferralFilter(data) {
      // true if referral is disabled, false if visible
      try {
        return data.type === 'referral' && data.extra.referral === false;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getInputReferral',
    value: function getInputReferral(data) {
      try {
        return data.type === 'referral' && data.extra.referral !== false;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getInputField',
    value: function getInputField(data) {
      try {
        return data.extra.textarea.field;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getFieldType',
    value: function getFieldType(data) {
      try {
        return data.extra.textarea.type;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: 'getInputMulti',
    value: function getInputMulti(data) {
      try {
        return data.extra.buttons.multi;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getInputHidetextbox',
    value: function getInputHidetextbox(data) {
      try {
        return data.extra.hide_textbox;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getExtraTextareaFixed',
    value: function getExtraTextareaFixed(data) {
      try {
        return data.extra.textarea.fixed;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'disableInput',
    value: function disableInput(callback) {
      if (!this.state.fixed) {
        _ChatUtils2.default.disableInput();
        this.setState({
          disabled: true
        }, callback);
      } else {
        callback();
      }
    }
  }, {
    key: 'getDisabledInput',
    value: function getDisabledInput(message) {
      var disabled = this.getInputType(message.data) === 'none' || message.data.samurai === undefined;
      return disabled;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var ee = this.ee;
      var _props = this.props,
          isMobile = _props.isMobile,
          avatar_shape = _props.avatar_shape,
          logo = _props.logo,
          brand_name = _props.brand_name,
          tagline = _props.tagline,
          keywords = _props.keywords,
          branding = _props.branding,
          typing = _props.typing,
          widget_hide_header = _props.widget_hide_header;
      var _state = this.state,
          messagesList = _state.messagesList,
          agentsInfo = _state.agentsInfo,
          hasOldMessages = _state.hasOldMessages,
          loadingOldMessages = _state.loadingOldMessages,
          disabled = _state.disabled,
          input_motion = _state.input_motion,
          input_type = _state.input_type,
          field = _state.field,
          field_type = _state.field_type,
          buttons = _state.buttons,
          payloads = _state.payloads,
          extra = _state.extra,
          backButton = _state.backButton,
          fixed = _state.fixed;

      var disableInput = this.disableInput.bind(this);
      var sendMessage = _ChatUtils2.default.sendMessage.bind(this);
      var lastMessage = messagesList[messagesList.length - 1];

      return _react2.default.createElement(
        'div',
        { id: 'hu-messenger', className: '' + (disabled ? ' hu-no-keywords' : '') + (branding ? '' : ' hu-no-referral') + (fixed ? ' hu-input-fixed' : '') },
        _react2.default.createElement(
          'div',
          {
            id: 'hu-messages-container',
            onTouchMove: function onTouchMove(e) {
              _this5.userMoveScroll(e);
            },
            onWheel: function onWheel(e) {
              _this5.userMoveScroll(e);
            },
            ref: function ref(elem) {
              _this5.messagesContainer = elem;
            }
          },
          _react2.default.createElement('div', {
            id: 'scroll-top-fixer',
            ref: function ref(elem) {
              _this5.scrollTopFixer = elem;
            }
          }),
          !widget_hide_header && _react2.default.createElement(
            'div',
            { id: 'hu-header-mobile', className: 'hu-a-center' },
            _react2.default.createElement('img', { 'class': 'hu-header-logo', src: logo, alt: '' }),
            _react2.default.createElement(
              'h1',
              { 'class': 'hu-header-brand_name hu-w-bold hu-s-20 hu-color_header-text' },
              brand_name
            ),
            _react2.default.createElement(
              'p',
              { 'class': 'hu-header-tagline hu-s-14 hu-x-ellipsis hu-color_header-text', title: 'Get more leads using chatbots \uFFFD\uFFFD' },
              tagline
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hu-messages-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'hu-old-chat' },
              hasOldMessages && _react2.default.createElement(
                'button',
                {
                  className: 'more-messages hu-color_contrast hu-border-color_contrast hu-s-15',
                  ref: function ref(elem) {
                    _this5.moreMessagesButton = elem;
                  },
                  onClick: this.queryOldMessages.bind(this),
                  tabIndex: -1
                },
                _react2.default.createElement(
                  'span',
                  { className: 'more-messages-text' },
                  'Load more...'
                )
              )
            ),
            messagesList.map(function (message, index, list) {
              if (message.message_id) return _react2.default.createElement(_Message2.default, {
                avatar_shape: avatar_shape,
                key: message.message_id,
                author: message.author,
                data: message.data,
                animate: message.animate,
                list: list,
                agentsInfo: agentsInfo,
                isMobile: isMobile,
                mobileHA: _this5.mobileHA,
                ee: ee,
                brandMessageAnimation$: _this5.brandMessageAnimation$,
                userMessageAnimation$: _this5.userMessageAnimation$,
                scrollBottom: _this5.scrollBottom.bind(_this5)
              });else return _react2.default.createElement(_Message2.default, {
                avatar_shape: avatar_shape,
                key: message.key,
                author: message.author,
                data: message.data,
                animate: message.animate,
                list: list,
                agentsInfo: agentsInfo,
                isMobile: isMobile,
                mobileHA: _this5.mobileHA,
                ee: ee,
                brandMessageAnimation$: _this5.brandMessageAnimation$,
                userMessageAnimation$: _this5.userMessageAnimation$,
                scrollBottom: _this5.scrollBottom.bind(_this5)
              });
            }),
            _react2.default.createElement(
              _InputBase2.default,
              {
                ee: this.ee,
                disabled: disabled,
                mobileHA: this.mobileHA,
                inputAnimation$: this.inputAnimation$,
                scrollBottom: this.scrollBottom.bind(this)
              },
              !fixed && _react2.default.createElement(_InputBox2.default, {
                disabled: disabled,
                input_motion: input_motion,
                sendMessage: sendMessage,
                input_type: input_type,
                field: field,
                field_type: field_type,
                buttons: buttons,
                payloads: payloads,
                extra: extra,
                backButton: backButton,
                emoji: 'hu-message-input',
                lastMessage: lastMessage,
                ee: ee
              })
            ),
            _react2.default.createElement('div', {
              id: 'scroll-bottom-fixer',
              ref: function ref(elem) {
                _this5.scrollFixer = elem;
              }
            })
          )
        ),
        fixed && _react2.default.createElement(
          _FixedInputBase2.default,
          {
            ee: this.ee,
            disabled: disabled,
            mobileHA: this.mobileHA,
            inputAnimation$: this.inputAnimation$,
            scrollBottom: this.scrollBottom.bind(this)
          },
          _react2.default.createElement(_InputBox2.default, {
            disabled: disabled,
            input_motion: input_motion,
            sendMessage: sendMessage,
            input_type: input_type,
            backButton: false,
            fixed: fixed,
            emoji: 'hu-footer-input-fixed',
            ee: ee
          })
        ),
        _react2.default.createElement(
          _MobileInputBase2.default,
          {
            ee: this.ee,
            disabled: disabled,
            mobileHA: this.mobileHA,
            inputAnimation$: this.inputAnimation$,
            scrollBottom: this.scrollBottom.bind(this)
          },
          _react2.default.createElement(_InputBox2.default, {
            brand_name: brand_name,
            branding: branding,
            keywords: keywords,
            typing: typing,
            disabled: disabled,
            input_motion: input_motion,
            sendMessage: sendMessage,
            input_type: input_type,
            field: field,
            field_type: field_type,
            buttons: buttons,
            payloads: payloads,
            extra: extra,
            backButton: fixed ? false : backButton,
            fixed: fixed,
            lastMessage: lastMessage,
            ee: ee
          })
        ),
        _react2.default.createElement('div', { id: 'hu-msn-sandbox' }),
        _react2.default.createElement('div', { id: 'hu-input-sandbox' }),
        _react2.default.createElement('div', { id: 'hu-mobile-input-sandbox' })
      );
    }
  }]);

  return Messenger;
}(_react2.default.Component);

exports.default = Messenger;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(5);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription_1.Subscription));
exports.SubjectSubscription = SubjectSubscription;
//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__(42);
var ObjectUnsubscribedError_1 = __webpack_require__(43);
/**
 * @class BehaviorSubject<T>
 */
var BehaviorSubject = (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(Subject_1.Subject));
exports.BehaviorSubject = BehaviorSubject;
//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var from_1 = __webpack_require__(100);
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromObservable_1 = __webpack_require__(101);
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__(16);
var isArrayLike_1 = __webpack_require__(36);
var isPromise_1 = __webpack_require__(37);
var PromiseObservable_1 = __webpack_require__(102);
var IteratorObservable_1 = __webpack_require__(103);
var ArrayObservable_1 = __webpack_require__(7);
var ArrayLikeObservable_1 = __webpack_require__(104);
var iterator_1 = __webpack_require__(22);
var Observable_1 = __webpack_require__(1);
var observeOn_1 = __webpack_require__(105);
var observable_1 = __webpack_require__(18);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromObservable = (function (_super) {
    __extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */
    FromObservable.create = function (ish, scheduler) {
        if (ish != null) {
            if (typeof ish[observable_1.observable] === 'function') {
                if (ish instanceof Observable_1.Observable && !scheduler) {
                    return ish;
                }
                return new FromObservable(ish, scheduler);
            }
            else if (isArray_1.isArray(ish)) {
                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
            }
            else if (isPromise_1.isPromise(ish)) {
                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
            }
            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
            }
            else if (isArrayLike_1.isArrayLike(ish)) {
                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
            }
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    FromObservable.prototype._subscribe = function (subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            return ish[observable_1.observable]().subscribe(subscriber);
        }
        else {
            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
        }
    };
    return FromObservable;
}(Observable_1.Observable));
exports.FromObservable = FromObservable;
//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(4);
var Observable_1 = __webpack_require__(1);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable = (function (_super) {
    __extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */
    PromiseObservable.create = function (promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    PromiseObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.error(err);
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
        else {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
    };
    return PromiseObservable;
}(Observable_1.Observable));
exports.PromiseObservable = PromiseObservable;
function dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.error(err);
    }
}
//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(4);
var Observable_1 = __webpack_require__(1);
var iterator_1 = __webpack_require__(22);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable = (function (_super) {
    __extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) {
            throw new Error('iterator cannot be null.');
        }
        this.iterator = getIterator(iterator);
    }
    IteratorObservable.create = function (iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function (state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') {
                iterator.return();
            }
            return;
        }
        this.schedule(state);
    };
    IteratorObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) {
            return scheduler.schedule(IteratorObservable.dispatch, 0, {
                index: index, iterator: iterator, subscriber: subscriber
            });
        }
        else {
            do {
                var result = iterator.next();
                if (result.done) {
                    subscriber.complete();
                    break;
                }
                else {
                    subscriber.next(result.value);
                }
                if (subscriber.closed) {
                    if (typeof iterator.return === 'function') {
                        iterator.return();
                    }
                    break;
                }
            } while (true);
        }
    };
    return IteratorObservable;
}(Observable_1.Observable));
exports.IteratorObservable = IteratorObservable;
var StringIterator = (function () {
    function StringIterator(str, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = str.length; }
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
    StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}());
var ArrayIterator = (function () {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = toLength(arr); }
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
    ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}());
function getIterator(obj) {
    var i = obj[iterator_1.iterator];
    if (!i && typeof obj === 'string') {
        return new StringIterator(obj);
    }
    if (!i && obj.length !== undefined) {
        return new ArrayIterator(obj);
    }
    if (!i) {
        throw new TypeError('object is not iterable');
    }
    return obj[iterator_1.iterator]();
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) {
        return 0;
    }
    if (len === 0 || !numberIsFinite(len)) {
        return len;
    }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) {
        return 0;
    }
    if (len > maxSafeInteger) {
        return maxSafeInteger;
    }
    return len;
}
function numberIsFinite(value) {
    return typeof value === 'number' && root_1.root.isFinite(value);
}
function sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) {
        return valueAsNumber;
    }
    if (isNaN(valueAsNumber)) {
        return valueAsNumber;
    }
    return valueAsNumber < 0 ? -1 : 1;
}
//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__(1);
var ScalarObservable_1 = __webpack_require__(20);
var EmptyObservable_1 = __webpack_require__(21);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable = (function (_super) {
    __extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function (arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (length === 1) {
            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
        }
        else {
            return new ArrayLikeObservable(arrayLike, scheduler);
        }
    };
    ArrayLikeObservable.dispatch = function (state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) {
            return;
        }
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayLikeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) {
            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < length && !subscriber.closed; i++) {
                subscriber.next(arrayLike[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}(Observable_1.Observable));
exports.ArrayLikeObservable = ArrayLikeObservable;
//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
var Notification_1 = __webpack_require__(44);
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return this.lift(new ObserveOnOperator(scheduler, delay));
}
exports.observeOn = observeOn;
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
exports.ObserveOnOperator = ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification_1.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}(Subscriber_1.Subscriber));
exports.ObserveOnSubscriber = ObserveOnSubscriber;
var ObserveOnMessage = (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
exports.ObserveOnMessage = ObserveOnMessage;
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var of_1 = __webpack_require__(107);
Observable_1.Observable.of = of_1.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__(7);
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var timer_1 = __webpack_require__(109);
Observable_1.Observable.timer = timer_1.timer;
//# sourceMappingURL=timer.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TimerObservable_1 = __webpack_require__(110);
exports.timer = TimerObservable_1.TimerObservable.create;
//# sourceMappingURL=timer.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isNumeric_1 = __webpack_require__(111);
var Observable_1 = __webpack_require__(1);
var async_1 = __webpack_require__(29);
var isScheduler_1 = __webpack_require__(8);
var isDate_1 = __webpack_require__(45);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var TimerObservable = (function (_super) {
    __extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) { dueTime = 0; }
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if (isNumeric_1.isNumeric(period)) {
            this.period = Number(period) < 1 && 1 || Number(period);
        }
        else if (isScheduler_1.isScheduler(period)) {
            scheduler = period;
        }
        if (!isScheduler_1.isScheduler(scheduler)) {
            scheduler = async_1.async;
        }
        this.scheduler = scheduler;
        this.dueTime = isDate_1.isDate(dueTime) ?
            (+dueTime - this.scheduler.now()) :
            dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */
    TimerObservable.create = function (initialDelay, period, scheduler) {
        if (initialDelay === void 0) { initialDelay = 0; }
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function (state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) {
            return;
        }
        else if (period === -1) {
            return subscriber.complete();
        }
        state.index = index + 1;
        action.schedule(state, period);
    };
    TimerObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index, period: period, subscriber: subscriber
        });
    };
    return TimerObservable;
}(Observable_1.Observable));
exports.TimerObservable = TimerObservable;
//# sourceMappingURL=TimerObservable.js.map

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__(16);
function isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
exports.isNumeric = isNumeric;
;
//# sourceMappingURL=isNumeric.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__(4);
var Action_1 = __webpack_require__(113);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.pending = false;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return root_1.root.clearInterval(id) && undefined || undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            // Dequeue if the action didn't reschedule itself. Don't call
            // unsubscribe(), because the action could reschedule later.
            // For example:
            // ```
            // scheduler.schedule(function doWork(counter) {
            //   /* ... I'm a busy worker bee ... */
            //   var originalAction = this;
            //   /* wait 100ms before rescheduling the action */
            //   setTimeout(function () {
            //     originalAction.schedule(counter + 1);
            //   }, 100);
            // }, 1000);
            // ```
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action_1.Action));
exports.AsyncAction = AsyncAction;
//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(5);
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */
var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(Subscription_1.Subscription));
exports.Action = Action;
//# sourceMappingURL=Action.js.map

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Scheduler_1 = __webpack_require__(115);
var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */
        this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */
        this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler_1.Scheduler));
exports.AsyncScheduler = AsyncScheduler;
//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */
var Scheduler = (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var startWith_1 = __webpack_require__(117);
Observable_1.Observable.prototype.startWith = startWith_1.startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__(7);
var ScalarObservable_1 = __webpack_require__(20);
var EmptyObservable_1 = __webpack_require__(21);
var concat_1 = __webpack_require__(118);
var isScheduler_1 = __webpack_require__(8);
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i - 0] = arguments[_i];
    }
    var scheduler = array[array.length - 1];
    if (isScheduler_1.isScheduler(scheduler)) {
        array.pop();
    }
    else {
        scheduler = null;
    }
    var len = array.length;
    if (len === 1) {
        return concat_1.concatStatic(new ScalarObservable_1.ScalarObservable(array[0], scheduler), this);
    }
    else if (len > 1) {
        return concat_1.concatStatic(new ArrayObservable_1.ArrayObservable(array, scheduler), this);
    }
    else {
        return concat_1.concatStatic(new EmptyObservable_1.EmptyObservable(scheduler), this);
    }
}
exports.startWith = startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var isScheduler_1 = __webpack_require__(8);
var ArrayObservable_1 = __webpack_require__(7);
var mergeAll_1 = __webpack_require__(35);
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return this.lift.call(concatStatic.apply(void 0, [this].concat(observables)));
}
exports.concat = concat;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */
function concatStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var scheduler = null;
    var args = observables;
    if (isScheduler_1.isScheduler(args[observables.length - 1])) {
        scheduler = args.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new mergeAll_1.MergeAllOperator(1));
}
exports.concatStatic = concatStatic;
//# sourceMappingURL=concat.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var concatMap_1 = __webpack_require__(120);
Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__(121);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return this.lift(new mergeMap_1.MergeMapOperator(project, resultSelector, 1));
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var subscribeToResult_1 = __webpack_require__(13);
var OuterSubscriber_1 = __webpack_require__(12);
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return this.lift(new MergeMapOperator(project, resultSelector, concurrent));
}
exports.mergeMap = mergeMap;
var MergeMapOperator = (function () {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}());
exports.MergeMapOperator = MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapSubscriber = MergeMapSubscriber;
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var delay_1 = __webpack_require__(123);
Observable_1.Observable.prototype.delay = delay_1.delay;
//# sourceMappingURL=delay.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__(29);
var isDate_1 = __webpack_require__(45);
var Subscriber_1 = __webpack_require__(2);
var Notification_1 = __webpack_require__(44);
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteDelay = isDate_1.isDate(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return this.lift(new DelayOperator(delayFor, scheduler));
}
exports.delay = delay;
var DelayOperator = (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelaySubscriber = (function (_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(Notification_1.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(Notification_1.Notification.createComplete());
    };
    return DelaySubscriber;
}(Subscriber_1.Subscriber));
var DelayMessage = (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var delayWhen_1 = __webpack_require__(125);
Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
var Observable_1 = __webpack_require__(1);
var OuterSubscriber_1 = __webpack_require__(12);
var subscribeToResult_1 = __webpack_require__(13);
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return new SubscriptionDelayObservable(this, subscriptionDelay)
            .lift(new DelayWhenOperator(delayDurationSelector));
    }
    return this.lift(new DelayWhenOperator(delayDurationSelector));
}
exports.delayWhen = delayWhen;
var DelayWhenOperator = (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelayWhenSubscriber = (function (_super) {
    __extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelayObservable = (function (_super) {
    __extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(Observable_1.Observable));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelaySubscriber = (function (_super) {
    __extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var bufferWhen_1 = __webpack_require__(127);
Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__(5);
var tryCatch_1 = __webpack_require__(11);
var errorObject_1 = __webpack_require__(6);
var OuterSubscriber_1 = __webpack_require__(12);
var subscribeToResult_1 = __webpack_require__(13);
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return this.lift(new BufferWhenOperator(closingSelector));
}
exports.bufferWhen = bufferWhen;
var BufferWhenOperator = (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferWhenSubscriber = (function (_super) {
    __extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            closingSubscription = new Subscription_1.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var debounceTime_1 = __webpack_require__(129);
Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
var async_1 = __webpack_require__(29);
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new DebounceTimeOperator(dueTime, scheduler));
}
exports.debounceTime = debounceTime;
var DebounceTimeOperator = (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceTimeSubscriber = (function (_super) {
    __extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(0);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Observable = __webpack_require__(1);

__webpack_require__(19);

__webpack_require__(34);

__webpack_require__(38);

__webpack_require__(23);

__webpack_require__(131);

__webpack_require__(39);

var _Logger = __webpack_require__(26);

var _Logger2 = _interopRequireDefault(_Logger);

var _RichTextApp = __webpack_require__(133);

var _RichTextApp2 = _interopRequireDefault(_RichTextApp);

var _DateUtils = __webpack_require__(27);

var _DateUtils2 = _interopRequireDefault(_DateUtils);

var _SpecialUtils = __webpack_require__(46);

var _SpecialUtils2 = _interopRequireDefault(_SpecialUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import Rx from 'rxjs';


/**
 * Notas:
 * ---
 * Para entender el flujo de renderizado del mensaje,
 * ver la función shouldComponentUpdate, donde se definen
 * aquellos estados que permiten actualizar el contenido.
 * De otro modo, el mensaje no actualizará su estado como
 * uno espera.
 */

var Message = function (_React$Component) {
  _inherits(Message, _React$Component);

  function Message(props) {
    _classCallCheck(this, Message);

    var _this = _possibleConstructorReturn(this, (Message.__proto__ || Object.getPrototypeOf(Message)).call(this, props));

    _this.state = {
      avatar_shape: props.avatar_shape,
      // key: props.key,
      author: props.author,
      timestamp: props.data.timestamp || Date.now(),
      data: props.data,
      list: props.list,
      agentsInfo: props.agentsInfo,
      // Animation data
      animate: props.animate,
      typing$: props.data.typing,
      // Image messages (ghost message)
      url: props.data.type === 'image' ? typeof props.data.url === 'string' ? props.data.url : _this.getUrls([props.data.url])[0] : props.data.url, // iframe messages
      urls: props.data.type === 'multiple_images' ? typeof props.data.urls[0] === 'string' ? props.data.urls : _this.getUrls(props.data.urls) : [],
      avatarVisibility: true,
      eval: false,
      extraClass: props.data.extra ? props.data.extra.extraClass || '' : ''
    };

    _this.messageElement = null;
    _this.messageInfo = null;
    _this.messageContentRef = null;
    _this.messageInnerContent = null;
    _this.bubbleElem = null;
    _this.motion = false; // Animado
    _this.mobileHA = props.mobileHA || false;
    _this.engageEndFlag = false;
    _this.animationsDelay = 500;
    _this.ee = props.ee;
    _this.setupListeners();

    _this.scrollBottom = props.scrollBottom;
    _this.fadeOut = _this.fadeOut.bind(_this);

    _this.animations$ = props.author === 'brand' ? props.brandMessageAnimation$ : props.userMessageAnimation$;

    var subscription = null;
    if (_this.props.animate) subscription = _this.animations$.subscribe({
      next: function next(step) {
        // En estos pasos hay que realizar las acciones del siguiente paso,
        // ya que representan el fin de dicho paso.
        switch (step) {
          // brand messages cases
          case 'bubble_left_in':
            // this.setUserMessageSize();
            break;
          case 'typing_on':
            break;
          case 'typing_off':
            _this.setBubbleSize();
            break;
          case 'bubble_resize':
            break;
          // user messages cases
          case 'input_out':
            _this.setUserMessageSize();
            break;
          case 'bubble_right_in':
            break;
          case 'bubble_resize':
            break;
          // common cases
          case 'flow_end':
            subscription.unsubscribe();
            break;
        }
      }
    });

    _this.animations$.next(_this.props.data);
    return _this;
  }

  // getUrl() {
  //   const { type, url, urls } = this.props.data;
  //   if (type === 'image') {
  //     return (typeof url === 'string') ? url : this.getUrls([url])[0];
  //   } else if (type === 'multiple_images') {
  //     // Si el tipo del primer elemento es string, ya es una url válida. De lo contrario es un File.
  //     return (typeof urls[0] === 'string') ? urls : this.getUrls(urls);
  //   }
  // }

  _createClass(Message, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this2 = this;

      var mounted$ = _Observable.Observable.fromEvent(this.ee, 'hu-lb-message-mounted');
      var responded$ = _Observable.Observable.fromEvent(this.ee, 'hu-lb-response-avatar-coords');

      var motion$ = _Observable.Observable.merge(mounted$, responded$).distinctUntilChanged().pairwise().map(function (a) {
        return a.filter(function (a) {
          return a !== undefined;
        })[0];
      }).first().subscribe({
        next: function next(coords) {
          if (_this2.motion && !_this2.rendered) {
            _this2.rendered = true;
            _this2.setAvatarTranslation(coords);
          }
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setupMountedListeners();
      this.ee.emit('hu-lb-message-mounted');

      // Un mensaje sin animaciones es renderizado 'on Mount'
      if (!this.motion) this.rendered = true;

      // Execute js injection
      if (!this.state.eval) this.executeScripts();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.ee.removeListener('hu-reset-chat', this.fadeOut);
      // this.messageElement.style = '';
      // this.messageContentRef.style = '';
      // this.messageInnerContent.style = '';
      this.messageElement.removeAttribute('style');
      this.messageContentRef.removeAttribute('style');
      this.messageInnerContent.removeAttribute('style');
    }
  }, {
    key: 'setupMountedListeners',
    value: function setupMountedListeners() {
      var _this3 = this;

      _Observable.Observable.fromEvent(this.ee, 'hu-lb-query-avatar-coords').subscribe({
        next: function next(key) {
          if (!_this3.messageElement) return;
          if (key === _this3.state.data.key) {
            var coords = _this3.messageElement.offsetTop + _this3.messageElement.offsetHeight;
            _this3.ee.emit('hu-lb-response-avatar-coords', coords);
            // Siempre que alguien me pida las coordenadas, oculto mi avatar.
            _this3.setState({
              avatarVisibility: false
            });
          }
        }
      });

      // Typing state
      var typing$ = this.state.typing$;

      var key = this.props.data.key;
      if (typing$) {
        typing$.subscribe({
          next: function next(v) {
            if (v.key === key) {
              if (v.state === false) {

                _Logger2.default.append(['%c' + _DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Typing OFF', 'color:blue'], 'landbot.messages[' + key + ']');

                // console.debug(`%cLandbot debug: Typing OFF <${this.props.data.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue')
                // this.setBubbleSize();
                _this3.ee.emit('hu-lb-bubble-typing-end');
              } else {

                _Logger2.default.append(['%c' + _DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Typing ON', 'color:blue'], 'landbot.messages[' + key + ']');

                // console.debug(`%cLandbot debug: Typing ON <${this.props.data.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue')
                _this3.setState({
                  typing$: v.state
                });
              }
            }
          }
        });
      }
      // else  // Esto lo acabo de descomentar, veremos a ver...
      //   this.setBubbleSize();

      // Fade out on reset chat
      this.ee.on('hu-reset-chat', this.fadeOut);
    }
  }, {
    key: 'fadeOut',
    value: function fadeOut() {
      Velocity(this.messageElement, { opacity: 0 }, { duration: 500 });
    }
  }, {
    key: 'DOMVirtualizer',
    value: function DOMVirtualizer(elem) {
      if (elem instanceof Node === false) return null;

      switch (elem.nodeName) {
        case '#text':
          return elem.textContent;
          break;
        case 'SPAN':
          return _react2.default.createElement(
            'span',
            { className: elem.className },
            elem.textContent
          );
          break;
        case 'A':
          return _react2.default.createElement(
            'a',
            { className: elem.className, href: elem.href, target: '_blank' },
            elem.textContent
          );
          break;
        case 'DIV':
          return _react2.default.createElement('div', { className: elem.className, dangerouslySetInnerHTML: { __html: elem.innerHTML } });
          break;
        case 'BR':
          return _react2.default.createElement('br', null);
        default:
          break;
      }
    }

    /**
     * getUrls
     * @param {Array} files Array of files to be processed
     */

  }, {
    key: 'getUrls',
    value: function getUrls(files) {
      var _this4 = this;

      var _urls = [];

      var _loop = function _loop(i) {
        var reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = function (e) {
          _urls[i] = e.target.result;
          _this4.setState({
            url: _urls[0],
            urls: _urls
          });
        };
      };

      for (var i = 0; i < files.length; i++) {
        _loop(i);
      }
      return Array(files.length).fill(null);
    }
  }, {
    key: 'messageEnvironment',
    value: function messageEnvironment(key) {
      var list = this.props.list;

      var i = this.getMessageIndex(key);
      if (i === -1) return {
        prev: undefined,
        next: undefined
      };else return {
        prev: list[i - 1],
        next: list[i + 1]
      };
    }
  }, {
    key: 'getMessageIndex',
    value: function getMessageIndex(key) {
      var list = this.props.list;

      var i = 0;
      for (i; i < list.length; i++) {
        if (list[i].key === key) return i;
      }
      return -1;
    }
  }, {
    key: 'getInfoRelativeCoords',
    value: function getInfoRelativeCoords(prevCoords) {
      if (!this.messageElement) return 0;
      return prevCoords - (this.messageElement.offsetTop + this.messageElement.offsetHeight);
    }
  }, {
    key: 'setAvatarTranslation',
    value: function setAvatarTranslation(prevCoords) {
      var _this5 = this;

      if (!this.messageInfo) return;
      // console.debug(`%cLandbot debug: Avatar shown <${this.props.data.key}> ${DateUtils.format(new Date(), 'HH:mm:ss.ff')}`, 'color:blue')
      var elem = this.messageInfo;
      var value = this.getInfoRelativeCoords(prevCoords);
      elem.style.transition = 'transform 0ms';
      elem.style.visibility = 'hidden';
      elem.style.transform = 'translateY(' + value + 'px)';
      elem.style.visibility = '';

      elem.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'transform') {
          _this5.ee.emit('hu-lb-avatar-translation-end');
        }
      });

      // Set timeout fix for next frame animation
      setTimeout(function () {
        elem.style.transition = 'transform .25s';
        elem.style.transform = 'translateY(0px)';
      }, 10);
    }
  }, {
    key: 'setBubbleSize',
    value: function setBubbleSize() {
      var _this6 = this;

      if (!this.bubbleElem) return;
      var elem = this.bubbleElem;

      // No animation in mobile
      // if (this.props.isMobile) {
      //   this.setState({
      //     typing$: false,
      //   }, () => {
      //     elem.style.width = 'auto';
      //     elem.style.height = 'auto';
      //     this.ee.emit('hu-lb-bubble-resize-end');
      //     this.messageInnerContent.style.display = 'inline-block';
      //     this.messageInnerContent.style.opacity = '1';
      //   });
      //   this.scrollBottom(250);
      //   return;
      // }

      // Usamos sandbox para calcular altura y anchura del elemento
      var parent = this.bubbleElem.parentElement;
      var parentWidth = getComputedStyle(parent).width;
      var vElem = document.createElement('div');
      vElem.className = this.props.data.extra ? this.props.data.extra.extraClass || '' : '';
      // vElem.style.width = `${parseInt(parentWidth) - 32}px`; // 32 por el margen de 16 horizontal
      vElem.style.width = parseInt(parentWidth) + 'px'; // Probemos sin la resta
      var vTarget = elem.cloneNode(true);
      vTarget.className = vTarget.className.replace(/\styping/, '');
      vTarget.style.width = 'auto';
      vTarget.style.height = 'auto';
      vTarget.style.overflow = 'visible';
      vElem.appendChild(vTarget);
      document.getElementById('hu-msn-sandbox').appendChild(vElem);

      var width = getComputedStyle(vTarget).width;
      var height = getComputedStyle(vTarget).height;

      this.setState({
        typing$: false
      }, function () {
        Velocity(elem, { width: width, height: height }, { duration: 250, mobileHA: _this6.mobileHA, complete: function complete() {
            _this6.ee.emit('hu-lb-bubble-resize-end');
            Velocity(_this6.messageInnerContent, { opacity: 1 }, { duration: 150, display: 'inline-block', mobileHA: _this6.mobileHA });
            setTimeout(function () {
              elem.style.width = 'auto';
              elem.style.height = 'auto';
            }, 200);
          } });
      });

      this.scrollBottom(250);
      document.getElementById('hu-msn-sandbox').innerHTML = '';
    }
  }, {
    key: 'setUserMessageSize',
    value: function setUserMessageSize() {
      var _this7 = this;

      var elem = this.messageElement;

      var height = getComputedStyle(elem.childNodes[0]).height;
      Velocity(elem, { height: height }, { duration: 350, mobileHA: this.mobileHA, complete: function complete() {
          _this7.ee.emit('hu-lb-bubble-resize-end');
          setTimeout(function () {
            elem.style.height = 'auto';
          }, 400);
        } });

      this.scrollBottom(350);
    }
  }, {
    key: 'executeScripts',
    value: function executeScripts() {
      var div = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.messageInnerContent;

      if (!div) return;
      if (!this.props.animate) return;
      var scripts = div.getElementsByTagName('script');
      for (var i = 0; i < scripts.length; i++) {
        eval(scripts[i].textContent);
      }this.setState({
        eval: true
      });
    }
  }, {
    key: 'getElHeight',
    value: function getElHeight() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var vTarget = document.createElement('p');
      document.getElementById('hu-msn-sandbox').appendChild(vTarget);
      var height = Math.floor(parseInt(getComputedStyle(vTarget).lineHeight)) + offset + 'px';
      document.getElementById('hu-msn-sandbox').innerHTML = '';
      return height;
    }

    /**
     * agentsInfo: {
     *  avatar: 
     *  name:
     * }
     */

  }, {
    key: 'getAgent',
    value: function getAgent() {
      var _props = this.props,
          data = _props.data,
          agentsInfo = _props.agentsInfo;

      var defaultAvatar = UmiCoreConfig.staticUrl + 'landbot/files/lb-default-avatar.jpg';
      var defaultName = 'landbot';
      if (data.samurai > 0) return agentsInfo[data.samurai] ? agentsInfo[data.samurai] : { avatar: defaultAvatar, name: defaultName };else return defaultAvatar;
    }
  }, {
    key: 'onBubbleClick',
    value: function onBubbleClick() {
      // Simulación de ArrowDown press para interrumpir el typing
      if (this.state.typing$) this.ee.emit('hu-lb-key-arrowdown');
    }
  }, {
    key: 'getYoutubeURL',
    value: function getYoutubeURL(url) {
      var video_id = '';
      var result = '';
      var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length == 11) {
        video_id = match[2];
        result = 'https://www.youtube.com/embed/' + video_id;
      }
      return result;
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var changeStates = ['url', 'avatarVisibility', 'eval', 'extraClass', 'typing$'];
      var update = false;
      for (var i = 0; i < changeStates.length; i++) {
        if (this.state[changeStates[i]] !== nextState[changeStates[i]]) {
          // console.log(this.props.data.key);
          // console.log('STATE CHANGE')
          // console.log(changeStates[i])
          update = true;
        }
      }
      if (JSON.stringify(this.state.urls) !== JSON.stringify(nextState.urls)) {
        // console.log(this.props.data.key);
        // console.log('URLS CHANGE')
        // console.log('urls')
        update = true;
      }

      var _props2 = this.props,
          data = _props2.data,
          avatar_shape = _props2.avatar_shape;

      var changeData = ['message', 'title'];
      for (var _i = 0; _i < changeData.length; _i++) {
        if (this.props.data[changeData[_i]] !== nextProps.data[changeData[_i]]) {
          // console.log(this.props.data.key);
          // console.log('PROPS CHANGE')
          // console.log(changeData[i])
          update = true;
        }
      }
      if (this.props.avatar_shape !== nextProps.avatar_shape) {
        update = true;
      }
      if (JSON.stringify(this.props.agentsInfo) !== JSON.stringify(nextProps.agentsInfo)) update = true;
      if (JSON.stringify(this.props.data.role) !== JSON.stringify(nextProps.data.role)) update = true;

      return update;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var key = this.props.data.key;
      // Send typing interruption when role is not engage anymore
      var _role = prevProps.data.role ? prevProps.data.role : [];
      var role_ = this.props.data.role ? this.props.data.role : [];

      if (_role.indexOf('engage') > -1 && role_.indexOf('engage') === -1) {
        if (this.props.data.type === 'image') this.setState({
          url: this.props.data.url
        });
        if (this.props.data.type === 'multiple_images') this.setState({
          urls: this.props.data.urls
        });

        this.ee.emit('hu-lb-engage-end');
        _Logger2.default.append(_DateUtils2.default.format(new Date(), 'HH:mm:ss.ff') + ': Sent endEngage event', 'landbot.messages[' + key + ']');

        this.executeScripts();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var ee = this.ee;
      var _props3 = this.props,
          avatar_shape = _props3.avatar_shape,
          author = _props3.author,
          data = _props3.data,
          list = _props3.list,
          agentsInfo = _props3.agentsInfo,
          animate = _props3.animate;
      var key = data.key,
          type = data.type,
          message = data.message,
          title = data.title,
          file_name = data.file_name,
          brand = data.brand,
          url_referral = data.url_referral;
      var _state = this.state,
          timestamp = _state.timestamp,
          typing$ = _state.typing$;
      var _state2 = this.state,
          url = _state2.url,
          urls = _state2.urls,
          avatarVisibility = _state2.avatarVisibility;

      var extraClass = data.extra ? data.extra.extraClass || '' : '';

      // Si no hay timestamp, es generado con el instante actual
      var date = _DateUtils2.default.format(timestamp, 'HH:mm');

      // Rich Text
      var auxNode = document.createElement('p');
      var sections = null;

      // MESSAGE CONTENT
      var messageContent = null;
      switch (type) {
        case 'text':
          sections = _RichTextApp2.default.transform(auxNode, message);
          messageContent = _react2.default.createElement(
            'p',
            { className: 'hu-message-text ' + (author === 'brand' ? 'hu-color_bot-message-text' : 'hu-color_user-message-text'), ref: function ref(elem) {
                _this8.messageInnerContent = elem;
              } },
            sections ? sections.map(function (elem) {
              return _this8.DOMVirtualizer(elem);
            }) : ''
          );
          break;
        case 'referral':
          // sections = richText.transform(auxNode, _message);
          messageContent = _react2.default.createElement(
            'p',
            { className: 'hu-message-text ' + (author === 'brand' ? 'hu-color_bot-message-text' : 'hu-color_user-message-text'), ref: function ref(elem) {
                _this8.messageInnerContent = elem;
              } },
            'Feel free to share this landbot on:',
            _react2.default.createElement(
              'div',
              { className: 'referral-buttons' },
              _react2.default.createElement(
                'a',
                { href: _SpecialUtils2.default.getReferralUrl('facebook', { brand: brand, url_referral: url_referral }), target: '_blank', className: 'menu-button referral-facebook hu-a-center hu-s-13' },
                _react2.default.createElement(
                  'svg',
                  { style: 'width:24px;height:24px', viewBox: '0 0 24 24' },
                  _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z' })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  'Facebook'
                )
              ),
              _react2.default.createElement(
                'a',
                { href: _SpecialUtils2.default.getReferralUrl('twitter', { brand: brand, url_referral: url_referral }), target: '_blank', className: 'menu-button referral-twitter hu-a-center hu-s-13' },
                _react2.default.createElement(
                  'svg',
                  { style: 'width:24px;height:24px', viewBox: '0 0 24 24' },
                  _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z' })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  'Twitter'
                )
              ),
              _react2.default.createElement(
                'a',
                { href: _SpecialUtils2.default.getReferralUrl('linkedin', { brand: brand, url_referral: url_referral }), target: '_blank', className: 'menu-button referral-linkedin hu-a-center hu-s-13' },
                _react2.default.createElement(
                  'svg',
                  { style: 'width:24px;height:24px', viewBox: '0 0 24 24' },
                  _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3A2,2 0 0,1 7,5A2,2 0 0,1 5,7A2,2 0 0,1 3,5A2,2 0 0,1 5,3Z' })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  'LinkedIn'
                )
              ),
              _react2.default.createElement(
                'a',
                { href: _SpecialUtils2.default.getReferralUrl('whatsapp', { brand: brand, url_referral: url_referral }), target: '_blank', className: 'menu-button referral-whatsapp hu-a-center hu-s-13' },
                _react2.default.createElement(
                  'svg',
                  { style: 'width:24px;height:24px', viewBox: '0 0 24 24' },
                  _react2.default.createElement('path', { fill: '#FFFFFF', d: 'M16.75,13.96C17,14.09 17.16,14.16 17.21,14.26C17.27,14.37 17.25,14.87 17,15.44C16.8,16 15.76,16.54 15.3,16.56C14.84,16.58 14.83,16.92 12.34,15.83C9.85,14.74 8.35,12.08 8.23,11.91C8.11,11.74 7.27,10.53 7.31,9.3C7.36,8.08 8,7.5 8.26,7.26C8.5,7 8.77,6.97 8.94,7H9.41C9.56,7 9.77,6.94 9.96,7.45L10.65,9.32C10.71,9.45 10.75,9.6 10.66,9.76L10.39,10.17L10,10.59C9.88,10.71 9.74,10.84 9.88,11.09C10,11.35 10.5,12.18 11.2,12.87C12.11,13.75 12.91,14.04 13.15,14.17C13.39,14.31 13.54,14.29 13.69,14.13L14.5,13.19C14.69,12.94 14.85,13 15.08,13.08L16.75,13.96M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C10.03,22 8.2,21.43 6.65,20.45L2,22L3.55,17.35C2.57,15.8 2,13.97 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.72 4.54,15.31 5.46,16.61L4.5,19.5L7.39,18.54C8.69,19.46 10.28,20 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z' })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  'WhatsApp'
                )
              )
            )
          );
          break;
        case 'dialog':
        case 'menu':
          sections = _RichTextApp2.default.transform(auxNode, title);
          messageContent = _react2.default.createElement(
            'p',
            { className: 'hu-message-text ' + (author === 'brand' ? 'hu-color_bot-message-text' : 'hu-color_user-message-text'), ref: function ref(elem) {
                _this8.messageInnerContent = elem;
              } },
            sections ? sections.map(function (elem) {
              return _this8.DOMVirtualizer(elem);
            }) : ''
          );
          break;
        case 'image':
          messageContent = _react2.default.createElement(
            'div',
            { className: 'hu-message-image', ref: function ref(elem) {
                _this8.messageInnerContent = elem;
              } },
            url !== null && _react2.default.createElement(
              'a',
              { className: 'image-anchor', href: url, target: '_blank' },
              _react2.default.createElement('img', { src: url, alt: file_name })
            )
          );
          break;
        case 'multiple_images':
          messageContent = _react2.default.createElement(
            'div',
            { className: 'hu-message-image', ref: function ref(elem) {
                _this8.messageInnerContent = elem;
              } },
            urls.map(function (url) {
              if (url !== null) {
                return _react2.default.createElement(
                  'a',
                  { className: 'image-anchor', href: url, target: '_blank' },
                  _react2.default.createElement('img', { src: url, alt: file_name })
                );
              } else return null;
            })
          );
          break;
        case 'iframe':
          messageContent = _react2.default.createElement(
            'div',
            { className: 'hu-message-iframe', ref: function ref(elem) {
                _this8.messageInnerContent = elem;
              } },
            data.url && _react2.default.createElement('iframe', { type: 'text/html', width: '640', height: '360', src: this.getYoutubeURL(data.url), frameborder: '0' })
          );
          break;
      }

      // MESSAGE ANIMATIONS

      var _messageEnvironment = this.messageEnvironment(key),
          prev = _messageEnvironment.prev,
          next = _messageEnvironment.next;

      var motion = this.motion;
      var rendered = this.rendered;
      var left_in = false;
      var splitter = false;
      var _coords = 0;
      var _avatarVisibility = avatarVisibility;
      var isAgent = data.samurai > 0;
      var agent = this.getAgent();

      if (animate && author === 'brand') {
        /**
         * Mensajes de brand
         * 
         * Pasos:
         * left_in -> true si mensaje anterior == user
         * avatarVisibility -> true si mensaje posterior == user
         */
        if (prev !== undefined) {
          if (prev.author === 'user') {
            left_in = true;
          } else if (prev.author === 'brand') {
            if (prev.data.samurai !== data.samurai) {
              left_in = true;
            } else {
              left_in = false;
              ee.emit('hu-lb-avatar-translation-end');
            }
            // AVATAR MOVES
            if (!rendered && !motion) this.motion = true;
            ee.emit('hu-lb-query-avatar-coords', prev.key);
          }
        } else left_in = true;
      } else if (animate && author === 'user') {}
      /**
       * Mensajes de user
       */


      // La visibilidad del avatar no depende de "animate"
      if (next !== undefined) {
        if (next.author === 'user') {
          _avatarVisibility = true;
        } else if (next.author === 'brand') {
          if (data.samurai !== next.data.samurai) {
            _avatarVisibility = true;
            splitter = true;
          } else {
            _avatarVisibility = false;
          }
        }
      }

      var animateNames = ['animate', 'left-in'];
      var animateClasses = [animate, left_in].map(function (item, i) {
        return item ? animateNames[i] : false;
      }).filter(function (item) {
        return item;
      }).join(' ');

      // MESSAGE RENDER
      return _react2.default.createElement(
        'div',
        {
          id: key,
          className: 'hu-message ' + author + ' ' + animateClasses + ' ' + extraClass + (splitter ? ' splitter' : ''),
          'data-author': '',
          ref: function ref(msg) {
            _this8.messageElement = msg;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'hu-message-container' },
          _react2.default.createElement(
            'div',
            { className: 'hu-message-margin' },
            _react2.default.createElement(
              'div',
              {
                className: 'hu-message-info' + (_avatarVisibility ? ' visible' : ''),
                ref: function ref(elem) {
                  _this8.messageInfo = elem;
                }
              },
              author === 'brand' && _react2.default.createElement('div', {
                className: 'hu-message-avatar hu-background-color_contrast-fade ' + avatar_shape + (isAgent ? ' agent' : ''),
                style: isAgent ? { backgroundImage: 'url(' + agent.avatar + ')' } : {}
              }),
              _react2.default.createElement(
                'div',
                { className: 'hu-message-date hu-a-center hu-s-10 hu-color_contrast' },
                _react2.default.createElement(
                  'span',
                  null,
                  isAgent ? agent.name : date
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'hu-message-content',
                ref: function ref(elem) {
                  _this8.messageContentRef = elem;
                }
              },
              _react2.default.createElement(
                'div',
                {
                  className: 'hu-message-bubble' + (typing$ ? ' typing' : '') + (author === 'brand' ? ' hu-background-color_bot-message-background' : ' hu-background-color_user-message-background'),
                  ref: function ref(elem) {
                    _this8.bubbleElem = elem;
                  },
                  onClick: this.onBubbleClick.bind(this)
                },
                author === 'brand' && _react2.default.createElement(
                  'div',
                  { className: 'typing-spinner', style: { height: this.getElHeight(), width: typing$ ? 'auto' : 0 } },
                  _react2.default.createElement('div', { className: 'ball hu-background-color_accent' }),
                  _react2.default.createElement('div', { className: 'ball hu-background-color_accent' }),
                  _react2.default.createElement('div', { className: 'ball hu-background-color_accent' })
                ),
                messageContent
              )
            )
          )
        )
      );
    }
  }]);

  return Message;
}(_react2.default.Component);

exports.default = Message;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__(1);
var map_1 = __webpack_require__(132);
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__(2);
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    if (typeof project !== 'function') {
        throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
    }
    return this.lift(new MapOperator(project, thisArg));
}
exports.map = map;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
exports.MapOperator = MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=map.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**************************************************************
  RICH TEXT CLASS
  - Description: App for string conversion to DOM
***************************************************************/
var RichTextApp = function RichTextApp(options) {

  this.DEFAULTS = {
    linkify: {
      enable: true,
      class: 'hu-link',
      class_big: 'hu-big'
    },
    code: {
      enable: true,
      class: 'hu-code'
    },
    html: {
      enable: false
    },
    symbols: {
      '*': {
        class: 'hu-bold'
      },
      '_': {
        class: 'hu-italic'
      }
    }
  };

  this.extendDefaults = function (defaults, options) {
    for (var key in options) {
      if (options.hasOwnProperty(key) && defaults.hasOwnProperty(key)) {
        defaults[key] = options[key];
      }
    }
    return defaults;
  };

  this.options = this.extendDefaults(this.DEFAULTS, options);

  this.transform = function (node, input) {
    if (node instanceof Node === false) {
      throw new Error('[RichText]: 1st argument must be a Node');
      return;
    }
    if (typeof input !== 'string') {
      throw new Error('[RichText]: 2nd argument must be a String');
      return;
    }
    node.innerHTML = '';
    if (input == '') return;

    var self = this;

    var transformer = new RichTextApp.Transformer(input, this.options);
    // HTML Inyection: {html}<script>alert('Hehe')</script>{/html}
    if (this.options.html.enable) transformer.htmlInjection();
    // Code blocks: ```Code```
    if (this.options.code.enable) transformer.codify();
    // División por línea
    transformer.divideByLine();
    // Procesamiento de cada item
    transformer.domify();
    // Linkify if enabled
    if (this.options.linkify.enable === true) transformer.linkify();

    var sections = transformer.sections;
    // Final step: Append all items to selected HTML element
    for (var i = 0; i < sections.length; i++) {
      node.appendChild(sections[i]);
    }

    return sections;
  };
};

/**************************************************************
  TRANSFORMER CLASS
  - Description: Contains all information about target transform
***************************************************************/
RichTextApp.Transformer = function (str, options) {
  this.raw = str;
  this.sections = [str];
  this.utils = new RichTextApp.Utils(options);

  this.htmlInjection = function () {
    var self = this;
    var reg = new RegExp(/{html}([\s\S]*?){\/html}/g);
    this.sections = this.utils.splitStringFocus(this.sections, reg);
    this.sections = this.sections.map(function (it) {
      return self.utils.convertToHtml(it, reg);
    });
  };

  this.codify = function () {
    var self = this;
    var reg = new RegExp(/```([\s\S]*?)```/g);
    this.sections = this.utils.splitStringFocus(this.sections, reg);
    this.sections = this.sections.map(function (it) {
      return self.utils.convertToCode(it, reg);
    });
  };

  this.divideByLine = function () {
    this.sections = this.utils.splitStringFocus(this.sections, '\n');
  };

  this.domify = function () {
    var self = this;
    this.sections = this.sections.map(function (it, i) {
      return self.utils.domifyString(it);
    });
    this.sections = this.utils.levelUpArray(this.sections);
  };

  this.linkify = function () {
    var self = this;
    this.sections = this.sections.map(function (it, i) {
      return self.utils.linkifyNode(it);
    });
    this.sections = this.utils.levelUpArray(this.sections);
  };
};

/**************************************************************
  FORMAT NODE CLASS
  - Description: Basic Unit that contains symbols info
***************************************************************/
RichTextApp.FormatNode = function (params) {
  this.index = params.index > -1 ? params.index : -1;
  this.symbols = params.symbols || [];

  this.hasSymbol = function (sym) {
    return this.symbols.indexOf(sym) > -1;
  };

  this.removeSymbol = function (sym) {
    this.symbols = this.symbols.filter(function (el, i) {
      return el != sym;
    });
  };
};

/**************************************************************
  UTILS CLASS
  - Description: Functions and utilities
***************************************************************/
RichTextApp.Utils = function (options) {

  this.symbols = options.symbols;
  this.symbolsArr = Object.keys(options.symbols);
  this.linkify = options.linkify;
  this.code = options.code;

  /**
   * When val='b' Converts ['abc'] into ['a', 'b', 'c']
   * @param  {Array} arr Array to be converted
   * @param  {String} val Split value
   * @return {Array}
   */
  this.splitStringFocus = function (arr, val) {
    var reg = val instanceof RegExp ? val : new RegExp(val, 'g');
    var _arr = arr.map(function (el, i) {
      // ['abc']
      if (typeof el == 'string') return el.replace(reg, '¡çÇ!$&¡çÇ!').split('¡çÇ!');else return el;
    });
    _arr = this.levelUpArray(_arr.slice(0)); // ['a','b','c']
    return _arr;
  };

  /**
   * When array contains an array element, levelUp that array. Example:
   * [['a','b'], 'c'] => ['a', 'b', 'c']
   * @param  {Array} arr Input array
   * @return {Array}
   */
  this.levelUpArray = function (arr) {
    for (var i = 0; i < arr.length; i++) {
      // [['a','b','c']]
      if (arr[i] instanceof Array) {
        arr.splice.apply(arr, [i, 1].concat(arr[i]));
      } else if (arr[i].textContent == '' && arr[i].tagName != 'BR' && arr[i].innerHTML == '' || arr[i] == '') {
        arr.splice(i--, 1);
      }
    } // ['a','b','c']
    return arr;
  };

  /**
   * Converts strings to arrays of strings separated by format
   * @param  {String} str
   * @return {Array}
   */
  this.domifyString = function (str) {
    if (typeof str !== 'string') return str;
    if (str == '\n') return document.createElement('br');

    var formatNodes = this.getFormatNodes(str);
    formatNodes = this.cleanFormatNodes(formatNodes.slice(0));
    // Dividir cadena en secciones
    var sections = this.getNodeSections(str, formatNodes);
    // Transformar en span cada sección, según símbolo.
    var dirtyNodes = this.nodeProcessor(sections, formatNodes);
    return dirtyNodes;
  };

  /**
   * Get symbol nodes
   * @param  {String} str Processed string
   * @return {Array} Nodes
   */
  this.getFormatNodes = function (str) {
    var self = this;
    var openingChar = ['', ' ', '\n', '\t', '(', '[', '{', '\'', '\"', '\`', '¡', '¿'];
    var closingChar = [/*'',*/' ', '\n', '\t', ')', ']', '}', '\'', '\"', '\`', '!', '?', ',', '.', ';', ':'];
    // formatNodes guarda los nodos encontrados en la cadena
    var formatNodes = [],
        lastIndexWasSymbol = false;
    for (var i = 0; i < str.length; i++) {
      // Busco si existe alguna coincidencia del símbolo encontrado con nuestro diccionario de símbolos
      var discover = this.discoverSymbol(str.slice(i));
      if (discover.state == true) {
        // Comprobar si es un símbolo de cierre:
        var lastNode = formatNodes[formatNodes.length - 1];
        // - Comprobando si coincide con algún símbolo del último nodo
        var isClosingSymbol = lastNode ? lastNode.symbols.indexOf(discover.symbol) > -1 : false;
        if (isClosingSymbol == true) {
          var futureSymbols = function futureSymbols(sample) {
            if (!sample || sample == '') return true;
            var re = self.composeRegExp(self.symbolsArr, 'exclusive');
            return sample.match(re) != null;
          };

          // Si es símbolo de cierre, nuevo nodo con substracción
          // Pero sólo si es final de palabra, para evitar conversiones indeseadas de símbolos internos:
          // Es final de palabra si:
          // - El índice posterior es un espacio vacío o en blanco o caracter de cierre.
          // - Los caracteres futuros corresponden a símbolos únicamente.

          var nextChar = str.charAt(i + discover.symbol.length);
          var hasFutureSymbols = futureSymbols(str.slice(i + discover.symbol.length).split(self.composeRegExp(closingChar))[0]);
          if (hasFutureSymbols || closingChar.indexOf(nextChar) > -1) {
            formatNodes.push(this.createSubstractorNode(discover.symbol, i, lastNode));
          }

          lastIndexWasSymbol = true;
        } else {
          // Si no es de cierre, nuevo nodo con adición
          // Pero sólo si es comienzo de palabra, para evitar conversiones indeseadas de símbolos internos:
          // Es comienzo de palabra si:
          // - El índice anterior corresponde a un símbolo.
          // - El índice anterior es un espacio vacío o en blanco o caracter de apertura.

          var prevChar = str.charAt(i - 1);
          if (lastIndexWasSymbol || openingChar.indexOf(prevChar) > -1) {
            formatNodes.push(this.createAdderNode(discover.symbol, i, lastNode));
            lastIndexWasSymbol = true;
          }
        }
      } else {
        lastIndexWasSymbol = false;
      }
      // Salta tantas posiciones como longitud de símbolo;
      i += discover.symbol ? discover.symbol.length - 1 : 0;
    }

    // Definición de primer nodo, aunque no tenga símbolo
    if (!formatNodes[0] || formatNodes[0].index != 0) {
      formatNodes.unshift(new RichTextApp.FormatNode({ index: 0, symbols: [] }));
    }
    return formatNodes;
  };

  /**
   * Búsqueda de símbolos.
   * - Dada una cadena '*' y unos símbolos {'*':{}}
   * - La función devuelve {state:true, symbol:'*'}
   * @param  {String} str
   * @return {Object}  Ejemplo: {state:Boolean, symbol:String}
   */
  this.discoverSymbol = function (str) {
    // Voy descartando hasta que queda un resultado
    var matches = this.symbolsArr;
    var symbol;

    matches = matches.filter(function (el, i) {
      return el == str.slice(0, el.length);
    });
    // Selecciono la concordancia de mayor longitud
    symbol = matches.sort(function (a, b) {
      return b.length - a.length;
    })[0];

    return {
      state: symbol != undefined,
      symbol: symbol
    };
  };

  /*
   * - Cada nodo añade o quita un único símbolo.
   * - Un nodo substractor está formado por los símbolos anteriores menos el coincidente.
   * - Un nodo sumador está formado por los símbolos anteriores más el añadido.
   */
  this.createSubstractorNode = function (symbol, i, node) {
    return new RichTextApp.FormatNode({
      index: i,
      symbols: node.symbols.slice(0).filter(function (el, i) {
        return el != symbol;
      })
    });
  };

  this.createAdderNode = function (symbol, i, node) {
    return new RichTextApp.FormatNode({
      index: i,
      symbols: node ? function () {
        var _node = node.symbols.slice(0);
        _node.push(symbol);
        return _node;
      }() : [symbol]
    });
  };

  /**
   * La limpieza de nodos se basa en los siguientes principios:
   * -
   */
  this.cleanFormatNodes = function (nodes) {
    var pointer = nodes.length - 1;
    if (!nodes[pointer]) return nodes;
    if (nodes[pointer].symbols.length == 0) return nodes;

    var cleanNodes = nodes.slice(0);
    // Si el último nodo tiene símbolos, éstos no tienen terminación
    // Selección de símbolos del último nodo.
    var symbols = nodes[pointer].symbols;
    var done = symbols.map(function () {
      return false;
    });

    while (pointer > -1) {
      for (var i = 0; i < symbols.length; i++) {
        // Elimina el/los símbolos afectados
        if (!cleanNodes[pointer].hasSymbol(symbols[i])) done[i] = true;
        if (!done[i]) cleanNodes[pointer].removeSymbol(symbols[i]);
      }
      if (cleanNodes[pointer + 1]) {
        if (JSON.stringify(cleanNodes[pointer + 1].symbols) == JSON.stringify(cleanNodes[pointer].symbols)) {
          // Remove duplicated node
          cleanNodes.splice(pointer + 1, 1);
        }
      }
      pointer--;
    }
    return cleanNodes;
  };

  // Devuelve la cadena dividida en secciones
  // - Cada sección es la determinada por los índices de cada nodo
  /**
   * [description]
   * @param  {[type]} str   [description]
   * @param  {[type]} nodes [description]
   * @return {[type]}       [description]
   */
  this.getNodeSections = function (str, nodes) {
    var sections = [];
    for (var i = 0; i < nodes.length; i++) {
      var start = nodes[i].index;
      var end = nodes[i + 1] ? nodes[i + 1].index : str.length;
      sections.push(str.slice(start, end));
    }
    return sections;
  };

  /**
   *
   * @param  {Array} sections Ej: ['*hola']
   * @param  {Array} nodes Array of FormatNodes
   * @return {Array} ['<span>hola</span>', '']
   */
  this.nodeProcessor = function (sections, nodes) {
    var self = this;
    return sections.map(function (el, i) {
      var _symbols = nodes[i - 1] ? nodes[i - 1].symbols : false;
      return self.spanify(el, nodes[i].symbols, _symbols);
    });
  };

  /**
   * Conversión a nodo de texto si es un nodo sin formato.
   * Conversión a span si el nodo es cerrado.
   * Un nodo es cerrado si un símbolo del nodo actual coincide con un símbolo del nodo anterior.
   * @param  {String} str       Contenido del span
   * @param  {Array} symArray  ['*', '_']
   * @param  {Array} _symArray ['*']
   * @return {HTMLElement} or {Node}
   */
  this.spanify = function (str, symArray, _symArray) {
    var self = this;
    if (typeof str !== 'string') return str;
    // Eliminación de símbolos
    var pattern, re;
    // // Los símbolos del nodo anterior también deben ser borrados
    pattern = _symArray ? symArray.concat(_symArray) : symArray;
    re = this.composeRegExp(pattern, 'begins');
    str = str.replace(re, '');

    // Span classes
    var classes = symArray.map(function (el) {
      return self.symbols[el].class;
    });

    if (classes.length > 0) {
      var span = document.createElement('span');
      span.className = 'rich-text ' + classes.join(' ');
      span.textContent = str;
      return span;
    } else {
      return document.createTextNode(str);
    }
  };

  this.escapeRegExp = function (str) {
    if (!str) return '';
    var specials = ["-", "[", "]", "/", "{", "}", "(", ")", "*", "+", "?", ".", "\\", "^", "$", "|"];
    var regex = RegExp('[' + specials.join('\\') + ']', 'g');
    return str.replace(regex, "\\$&");
  };

  /**
   * Returns a RegExp based in an array with following structure:
   * / ^(arr[0]|arr[1]|...|arr[n])* /g
   * Taking into account special characters
   * @param  {Array} arr All array elements are included in RegExp
   * @param {String} type 'begins',
   * @return {RegExp}
   */
  this.composeRegExp = function (arr, type) {
    var self = this;
    if (type === 'begins') return new RegExp('^(' + arr.map(function (el) {
      return self.escapeRegExp(el);
    }).join('|') + ')+', 'g');else if (type === 'exclusive') return new RegExp('^(' + arr.map(function (el) {
      return self.escapeRegExp(el);
    }).join('|') + ')+$', 'g');else return new RegExp('(' + arr.map(function (el) {
      return self.escapeRegExp(el);
    }).join('|') + ')+', 'g');
  };

  /**
   * Converts strings with a certain pattern to an HTMLElement
   * @param  {String} str Input string
   * @return {HTMLElement} or {String}
   */
  this.convertToCode = function (str, reg) {
    if (typeof str !== 'string' || str === '') return str;

    var match = str.match(reg);
    if (match === null) return str;else {
      var span = document.createElement('span');
      span.className = 'rich-text ' + this.code.class;
      span.textContent = str.replace(reg, '$1');
      return span;
    }
  };

  /**
   * Converts strings with a certain pattern to an HTMLElement
   * @param  {String} str Input string
   * @return {HTMLElement} or {String}
   */
  this.convertToHtml = function (str, reg) {
    if (typeof str !== 'string' || str === '') return str;

    var match = str.match(reg);
    if (match === null) return str;else {
      var div = document.createElement('div');
      div.className = 'rich-text rich-text-noop';
      div.innerHTML = str.replace(reg, '$1').trim();
      return div;
    }
  };

  /**
   * Given a html element, detects links and transform into anchors.
   * @param  {Node} str Input HTMLElement
   * @return {Node} Processed node
   */
  this.linkifyNode = function (elem) {
    if (elem.className && elem.className.indexOf('rich-text-noop') > -1) return elem;

    var self = this;
    // Pattern:
    // - protocol: '(http(s)?(:\/\/))?(www\.)?',
    // - mail check: '([-\w\.]+@)?',
    // - domain: '(?:(?:[-\w\.]+',
    // - tld: '(\.(?:nl|se|no|es|milru|fr|es|uk|ca|de|jp|au|us|ch|it|io|org|com|net|int|edu|mil|arpa)))|',
    // - ipv4: '(?:(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3})|(?:localhost)(?:[0-9]{1,5})?))',
    // - params: '([-a-zA-Z0-9:%_\+.~#?&//=@]*)' // Added '@'
    // - stylizers: '(?:(?:\[.+?\])*(?:!!)*)'
    var str = elem.textContent;
    var pattern = /(http(s)?(:\/\/))?(www\.)?([-\w\.]+@)?(?:(?:[-\w\.]+(\.(?:nl|se|no|es|milru|fr|es|uk|ca|de|jp|au|us|ch|it|io|org|com|net|int|edu|mil|arpa|ly|in)))|(?:(?:(?:[0-9]{1,3}\.){3}[0-9]{1,3})|(?:localhost)(?:[0-9]{1,5})?))([-a-zA-Z0-9:%_\+.~#?&//=@]*)(?:(?:\[.+?\])*(?:!!)*)/gi;

    var match,
        aux_str = str,
        sections = [];
    // ["enlace1.com y enlace2.com y enlace1.com"]
    while (match = pattern.exec(aux_str)) {
      var bef = document.createTextNode(aux_str.slice(0, match.index));
      var link = generateLink(aux_str.slice(match.index, match.index + match[0].length));

      sections.push(bef, link);
      aux_str = aux_str.slice(match.index + match[0].length);
      // Reset index, as aux_str length has changed
      pattern.lastIndex = 0;
    }
    if (sections.length > 0 && aux_str != '') {
      sections.push(document.createTextNode(aux_str));
    }

    function generateLink(url) {
      var isTitle = url.slice(url.length - 2, url.length) == '!!';
      var hasContent = url.match(/\[.*\]/g) != null;
      var isHttp = url.slice(0, 4) == 'http';
      var isMail = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(url);
      var anchor = document.createElement('a');

      // Classes
      var b = isTitle ? self.linkify.class + ' ' + self.linkify.class_big : self.linkify.class;

      // Content:
      // · http://www.helloumi.com[helloumi]!!
      var c = isTitle ? url.slice(0, url.length - 2) : url;
      // · http://www.helloumi.com[helloumi]
      c = hasContent ? c.replace(/(^.*)\[(.*)\](.*)/g, '$2') : c;

      // Reference:
      // · www.helloumi.com[helloumi]!!
      var a = isTitle ? url.slice(0, url.length - 2) : url;
      // · www.helloumi.com[helloumi]
      a = hasContent ? a.replace(/(^.*)\[(.*)\](.*)/g, "$1") : a;
      // · www.helloumi.com
      a = isHttp || isMail ? a : 'http://'.concat(a);
      // · http://www.helloumi.com
      a = isMail ? 'mailto:'.concat(a) : a;

      anchor.className = 'rich-text ' + b;
      anchor.href = a;
      anchor.target = isMail ? '_top' : '_blank';
      anchor.textContent = c;
      return anchor;
    }

    // Final step: Append all items to selected HTML element
    if (sections.length > 0) {
      elem.innerHTML = '';
      if (elem instanceof HTMLElement) {
        for (var i = 0; i < sections.length; i++) {
          if (sections[i].textContent != '') elem.appendChild(sections[i]);
        }
      } else return sections;
    }
    return [elem];
  };
};

RichTextApp.VERSION = '2.0.5';

// INSTANCE
var richText = new RichTextApp({
  linkify: {
    enable: true,
    class: 'hu-link',
    class_big: 'hu-size-big'
  },
  code: {
    enable: true,
    class: 'hu-code'
  },
  html: {
    enable: true
  },
  symbols: {
    '*': { class: 'hu-w-bold' },
    '_': { class: 'hu-st-italic' },
    '%h1': { class: 'hu-s-20' },
    '%c1': { class: 'hu-color_accent' },
    '%c2': { class: 'hu-color_dark' }
  }
});
exports.default = richText;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputBase = function (_React$Component) {
  _inherits(InputBase, _React$Component);

  function InputBase(props) {
    _classCallCheck(this, InputBase);

    var _this = _possibleConstructorReturn(this, (InputBase.__proto__ || Object.getPrototypeOf(InputBase)).call(this, props));

    _this.state = {
      visible: false
    };
    _this.ee = props.ee;
    _this.scrollBottom = props.scrollBottom;
    _this.mobileHA = props.mobileHA;
    _this.inputAnimation$ = props.inputAnimation$;

    _this.inputBaseElem = null;
    return _this;
  }

  _createClass(InputBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.inputAnimation$.subscribe({
        next: function next(v) {
          if (_this2.props.disabled === false) {
            if (v === 'input_enable') {
              if (!_this2.state.visible) _this2.setInputSize();
            } else if (v === 'input_in') {
              _this2.setState({ visible: true }, function () {
                return _this2.ee.emit('hu-lb-input-focus');
              });
            }
          } else {
            if (v === 'input_out') {
              // this.setState({ visible: false }, () => this.setInputSize(0));
              _this2.fixInputSize();
              _this2.setState({ visible: false });
            }
          }
        }
      });
    }
  }, {
    key: 'fixInputSize',
    value: function fixInputSize() {
      var elem = this.inputBoxElem;
      if (!elem) return;
      var height = getComputedStyle(elem).height;
      elem.style.height = height;
    }
  }, {
    key: 'setInputSize',
    value: function setInputSize(size) {
      var _this3 = this;

      var elem = this.inputBoxElem;
      if (!elem) return;
      if (size === 0) {
        Velocity(elem, { height: 0 }, { duration: 350, delay: 350, mobileHA: this.mobileHA });
      } else {
        var parent = elem.parentElement;
        var parentWidth = getComputedStyle(parent).width;
        var vParent = document.createElement('div');
        vParent.id = parent.id;
        vParent.style.width = parseInt(parentWidth) + 'px';
        var vTarget = elem.cloneNode(true);
        vTarget.style.height = 'auto';
        vParent.appendChild(vTarget);
        document.getElementById('hu-input-sandbox').appendChild(vParent);
        var height = getComputedStyle(vTarget).height;

        Velocity(elem, { height: height }, { duration: 350, mobileHA: this.mobileHA, complete: function complete() {
            _this3.inputAnimation$.next('input_in');
            setTimeout(function () {
              if (_this3.props.disabled === false) {
                elem.style.height = 'auto';
              }
            }, 200);
          } });

        this.scrollBottom(350);
        document.getElementById('hu-input-sandbox').innerHTML = '';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var visible = this.state.visible;

      return _react2.default.createElement(
        'div',
        {
          id: 'hu-message-input',
          className: visible ? 'enabled' : '',
          ref: function ref(elem) {
            return _this4.inputBaseElem = elem;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'hu-input-box', ref: function ref(elem) {
              return _this4.inputBoxElem = elem;
            } },
          this.props.children
        )
      );
    }
  }]);

  return InputBase;
}(_react2.default.Component);

exports.default = InputBase;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FixedInputBase = function (_React$Component) {
  _inherits(FixedInputBase, _React$Component);

  function FixedInputBase(props) {
    _classCallCheck(this, FixedInputBase);

    var _this = _possibleConstructorReturn(this, (FixedInputBase.__proto__ || Object.getPrototypeOf(FixedInputBase)).call(this, props));

    _this.state = {
      visible: false
    };
    _this.ee = props.ee;
    _this.scrollBottom = props.scrollBottom;
    _this.mobileHA = props.mobileHA;
    _this.inputAnimation$ = props.inputAnimation$;

    _this.inputBaseElem = null;
    return _this;
  }

  _createClass(FixedInputBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.inputAnimation$.subscribe({
        next: function next(v) {
          if (_this2.props.disabled === false) {
            if (v === 'input_enable') {
              if (!_this2.state.visible) _this2.setInputSize();
            } else if (v === 'input_in') {
              _this2.setState({ visible: true });
            }
          } else {
            if (v === 'input_out') {
              // this.setState({ visible: false }, () => this.setInputSize(0));
              _this2.fixInputSize();
              _this2.setState({ visible: false });
            }
          }
        }
      });
    }
  }, {
    key: 'fixInputSize',
    value: function fixInputSize() {
      var elem = this.inputBoxElem;
      if (!elem) return;
      var height = getComputedStyle(elem).height;
      elem.style.height = height;
    }
  }, {
    key: 'setInputSize',
    value: function setInputSize(size) {
      var _this3 = this;

      var elem = this.inputBoxElem;
      if (!elem) return;
      if (size === 0) {
        Velocity(elem, { height: 0 }, { duration: 350, delay: 350, mobileHA: this.mobileHA });
      } else {
        var parent = elem.parentElement;
        var parentWidth = getComputedStyle(parent).width;
        var vParent = document.createElement('div');
        vParent.id = parent.id;
        vParent.style.width = parseInt(parentWidth) + 'px';
        var vTarget = elem.cloneNode(true);
        vTarget.style.height = 'auto';
        vParent.appendChild(vTarget);
        document.getElementById('hu-input-sandbox').appendChild(vParent);
        var height = getComputedStyle(vTarget).height;

        Velocity(elem, { height: height }, { duration: 350, mobileHA: this.mobileHA, complete: function complete() {
            _this3.inputAnimation$.next('input_in');
            setTimeout(function () {
              if (_this3.props.disabled === false) {
                // ?
                elem.style.height = 'auto';
              } // ?
            }, 200);
          } });

        this.scrollBottom(350);
        document.getElementById('hu-input-sandbox').innerHTML = '';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var visible = this.state.visible;

      return _react2.default.createElement(
        'div',
        {
          id: 'hu-footer-input-fixed',
          className: visible ? 'enabled' : '',
          ref: function ref(elem) {
            return _this4.inputBaseElem = elem;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'hu-input-box', ref: function ref(elem) {
              return _this4.inputBoxElem = elem;
            } },
          this.props.children
        )
      );
    }
  }]);

  return FixedInputBase;
}(_react2.default.Component);

exports.default = FixedInputBase;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileInputBase = function (_React$Component) {
  _inherits(MobileInputBase, _React$Component);

  function MobileInputBase(props) {
    _classCallCheck(this, MobileInputBase);

    var _this = _possibleConstructorReturn(this, (MobileInputBase.__proto__ || Object.getPrototypeOf(MobileInputBase)).call(this, props));

    _this.state = {
      visible: false
    };
    _this.ee = props.ee;
    _this.scrollBottom = props.scrollBottom;
    _this.mobileHA = props.mobileHA;
    _this.inputAnimation$ = props.inputAnimation$;

    _this.inputBaseElem = null;
    return _this;
  }

  _createClass(MobileInputBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.inputAnimation$.subscribe({
        next: function next(v) {
          if (_this2.props.disabled === false) {
            if (v === 'input_enable') {
              if (!_this2.state.visible) _this2.setInputSize();
            } else if (v === 'input_in') {
              _this2.setState({ visible: true }, function () {
                return _this2.ee.emit('hu-lb-input-focus');
              });
            }
          } else {
            if (v === 'input_out') {
              _this2.setState({ visible: false }, function () {
                return _this2.setInputSize(0);
              });
            }
          }
        }
      });
    }
  }, {
    key: 'setInputSize',
    value: function setInputSize(size) {
      var elem = this.inputBoxElem;
      if (size === 0) {
        Velocity(elem, { height: 0 }, { duration: 350, mobileHA: this.mobileHA });
      } else {
        var parent = elem.parentElement;
        var parentWidth = getComputedStyle(parent).width;
        var vParent = document.createElement('div');
        vParent.id = parent.id;
        vParent.style.width = parseInt(parentWidth) + 'px';
        var vTarget = elem.cloneNode(true);
        vTarget.style.height = 'auto';
        vParent.appendChild(vTarget);
        document.getElementById('hu-mobile-input-sandbox').appendChild(vParent);
        var height = getComputedStyle(vTarget).height;

        Velocity(elem, { height: height }, { duration: 350, mobileHA: this.mobileHA, complete: function complete() {
            setTimeout(function () {
              // Esto está bien, ya que no se trata de un input de altura variable.
              elem.style.height = 'auto';
            }, 200);
          } });

        this.props.scrollBottom(350);
        document.getElementById('hu-mobile-input-sandbox').innerHTML = '';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var visible = this.state.visible;

      return _react2.default.createElement(
        'div',
        {
          id: 'hu-footer-input-mobile',
          className: visible ? 'enabled' : '',
          ref: function ref(elem) {
            return _this3.inputBaseElem = elem;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'hu-input-box', ref: function ref(elem) {
              return _this3.inputBoxElem = elem;
            } },
          this.props.children
        )
      );
    }
  }]);

  return MobileInputBase;
}(_react2.default.Component);

exports.default = MobileInputBase;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Config = __webpack_require__(3);

var _Config2 = _interopRequireDefault(_Config);

var _InputText = __webpack_require__(138);

var _InputText2 = _interopRequireDefault(_InputText);

var _InputMenu = __webpack_require__(142);

var _InputMenu2 = _interopRequireDefault(_InputMenu);

var _InputMulti = __webpack_require__(143);

var _InputMulti2 = _interopRequireDefault(_InputMulti);

var _InputReferral = __webpack_require__(144);

var _InputReferral2 = _interopRequireDefault(_InputReferral);

var _TypingSwitchMobile = __webpack_require__(145);

var _TypingSwitchMobile2 = _interopRequireDefault(_TypingSwitchMobile);

var _KeywordSelector = __webpack_require__(30);

var _KeywordSelector2 = _interopRequireDefault(_KeywordSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputBox = function (_React$Component) {
  _inherits(InputBox, _React$Component);

  function InputBox(props) {
    _classCallCheck(this, InputBox);

    var _this = _possibleConstructorReturn(this, (InputBox.__proto__ || Object.getPrototypeOf(InputBox)).call(this, props));

    _this.state = {
      brand_name: props.brand_name,
      branding: props.branding,
      keywords: props.keywords,
      typing: props.typing,
      disabled: props.disabled,
      input_motion: props.input_motion,
      sendMessage: props.sendMessage,
      input_type: props.input_type, // text, field, menu, multi
      field: props.field,
      buttons: props.buttons,
      payloads: props.payloads,
      extra: props.extra,
      backButton: props.backButton
    };
    _this.textSubmitHandler = _this.textSubmitHandler.bind(_this);
    _this.buttonSubmitHandler = _this.buttonSubmitHandler.bind(_this);
    _this.backButtonElem = null;
    _this.ee = props.ee;

    _this.remountID = '0';
    return _this;
  }

  /**
   * Remount algorithm. This parameter ensures a refresh in every input
   * for each incoming message, avoiding repeated behaviors from identical
   * buttons inputs.
   */


  _createClass(InputBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.disabled === true && nextProps.disabled === false) this.remountID = Math.random().toString();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          typing = _props.typing,
          disabled = _props.disabled,
          input_motion = _props.input_motion,
          input_type = _props.input_type,
          field = _props.field,
          buttons = _props.buttons,
          payloads = _props.payloads,
          extra = _props.extra;


      if (typing === nextProps.typing &&
      // disabled === true &&
      disabled === nextProps.disabled &&
      // input_motion === false &&
      input_type === nextProps.input_type && field === nextProps.field && this.compareObjects(buttons, nextProps.buttons) && this.compareObjects(payloads, nextProps.payloads) && this.compareObjects(extra, nextProps.extra)) {
        return false;
      }
      //     console.log(`===========================
      // ${disabled === nextProps.disabled}
      // ${input_motion === false}
      // ${input_type === nextProps.input_type}
      // ${field === nextProps.field}
      // ${this.compareObjects(buttons, nextProps.buttons)}
      // ${this.compareObjects(payloads, nextProps.payloads)}
      // ${this.compareObjects(extra, nextProps.extra)}
      // `)
      return true;
    }
  }, {
    key: 'compareObjects',
    value: function compareObjects(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  }, {
    key: 'getExtraTextareaData',
    value: function getExtraTextareaData(data) {
      return {
        field: this.getExtraField(data),
        type: this.getExtraType(data),
        value: this.getExtraValue(data),
        fixed: this.getExtraFixed(data)
      };
    }
  }, {
    key: 'getExtraField',
    value: function getExtraField(data) {
      try {
        return data.textarea.field;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getExtraType',
    value: function getExtraType(data) {
      try {
        return data.textarea.type;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: 'getExtraValue',
    value: function getExtraValue(data) {
      try {
        return data.textarea.value;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: 'getExtraFixed',
    value: function getExtraFixed(data) {
      try {
        return data.textarea.fixed;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: 'getExtraButtonsData',
    value: function getExtraButtonsData(data) {
      return {
        dual_buttons: this.getExtraDualButtons(data),
        pile_up: this.getExtraPileUp(data),
        includes: this.getExtraIncludes(data),
        images: this.getExtraImages(data),
        icons: this.getExtraIcons(data),
        multi: this.getExtraMulti(data),
        search: this.getExtraSearch(data)
      };
    }
  }, {
    key: 'getExtraDualButtons',
    value: function getExtraDualButtons(data) {
      try {
        return data.buttons.dual_buttons;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getExtraPileUp',
    value: function getExtraPileUp(data) {
      try {
        return data.buttons.pile_up;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getExtraIncludes',
    value: function getExtraIncludes(data) {
      try {
        return data.buttons.includes;
      } catch (e) {
        return [];
      }
    }
  }, {
    key: 'getExtraImages',
    value: function getExtraImages(data) {
      try {
        return data.buttons.images;
      } catch (e) {
        return [];
      }
    }
  }, {
    key: 'getExtraIcons',
    value: function getExtraIcons(data) {
      try {
        return data.buttons.icons;
      } catch (e) {
        return [];
      }
    }
  }, {
    key: 'getExtraMulti',
    value: function getExtraMulti(data) {
      try {
        return data.buttons.multi;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'getExtraSearch',
    value: function getExtraSearch(data) {
      try {
        return data.buttons.search;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: 'buttonSubmitHandler',
    value: function buttonSubmitHandler(text, payload) {
      if (this.props.disabled) return;
      this.props.sendMessage(text, payload);
    }
  }, {
    key: 'textSubmitHandler',
    value: function textSubmitHandler(text) {
      var images = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var image_flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (this.props.disabled) return;
      this.props.sendMessage(text, null, images, image_flags);
    }
  }, {
    key: 'backClick',
    value: function backClick(text) {
      if (this.props.disabled) return;
      this.props.sendMessage('#back');
      this.backButtonElem.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var disabled = this.props.disabled;
      var _props2 = this.props,
          brand_name = _props2.brand_name,
          branding = _props2.branding,
          keywords = _props2.keywords,
          typing = _props2.typing,
          input_motion = _props2.input_motion,
          input_type = _props2.input_type,
          field = _props2.field,
          field_type = _props2.field_type,
          _props2$buttons = _props2.buttons,
          buttons = _props2$buttons === undefined ? [] : _props2$buttons,
          _props2$payloads = _props2.payloads,
          payloads = _props2$payloads === undefined ? [] : _props2$payloads,
          extra = _props2.extra,
          backButton = _props2.backButton,
          lastMessage = _props2.lastMessage;


      var _backButton = _react2.default.createElement(
        'div',
        { className: 'hu-input-back' },
        _react2.default.createElement(
          'button',
          {
            className: 'back-button hu-color_contrast hu-border-color_contrast not-selectable hu-s-10',
            onClick: this.backClick.bind(this),
            tabIndex: buttons ? Object.keys(buttons).length + 1 : 5,
            ref: function ref(elem) {
              _this2.backButtonElem = elem;
            }
          },
          _react2.default.createElement(
            'span',
            { className: 'left-arrow' },
            _react2.default.createElement(
              'svg',
              { className: 'hu-fill_contrast', xmlns: 'http://www.w3.org/2000/svg' },
              _react2.default.createElement('path', { d: 'M 11.78125 2.28125 L 2.78125 11.28125 L 2.09375 12 L 2.78125 12.71875 L 11.78125 21.71875 L 13.21875 20.28125 L 5.9375 13 L 22 13 L 22 11 L 5.9375 11 L 13.21875 3.71875 Z ' })
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'back-text hu-t-uppercase' },
            _Config2.default.text.back
          )
        )
      );
      var textareaData = this.getExtraTextareaData(extra);
      var buttonsData = this.getExtraButtonsData(extra);
      var input = null;

      switch (input_type) {
        case 'text':
          input = _react2.default.createElement(_InputText2.default, {
            key: this.remountID,
            emoji: this.props.emoji,
            field_type: field_type,
            fixed: this.props.fixed,
            textareaData: textareaData,
            textSubmitHandler: this.textSubmitHandler,
            ee: this.ee
          });
          break;
        case 'field':
          input = _react2.default.createElement(_InputText2.default, {
            key: this.remountID,
            emoji: this.props.emoji,
            field: field,
            field_type: field_type,
            textareaData: textareaData,
            textSubmitHandler: this.textSubmitHandler,
            ee: this.ee
          });
          break;
        case 'menu':
          input = _react2.default.createElement(_InputMenu2.default, {
            key: this.remountID,
            buttons: buttons,
            payloads: payloads,
            buttonsData: buttonsData,
            buttonSubmitHandler: this.buttonSubmitHandler,
            clicked: false
          });
          break;
        case 'multi':
          input = _react2.default.createElement(_InputMulti2.default, {
            key: this.remountID,
            buttons: buttons,
            payloads: payloads,
            buttonsData: buttonsData,
            buttonSubmitHandler: this.buttonSubmitHandler,
            clicked: false
          });
          break;
        case 'referral':
          var brand = '';
          try {
            brand = lastMessage.data.brand;
          } catch (e) {}
          input = (0, _InputReferral2.default)(brand);
          break;
        default:
          _backButton = null;
          input = null;
          break;
      }

      if (input_motion) {
        if (input_type == 'menu' && buttons.length == 0) return _react2.default.createElement('div', { className: 'hu-input-container' });
        return _react2.default.createElement(
          'div',
          { className: 'hu-input-container ' + input_type },
          brand_name && branding && _react2.default.createElement(
            'div',
            { className: 'hu-mobile-powered-by' },
            _react2.default.createElement(
              'p',
              { className: 'powered-by-text hu-a-center hu-color_contrast hu-s-12' },
              _react2.default.createElement(
                'a',
                { className: 'hu-border-color_contrast', target: '_blank', href: _Config.referralFooterURL },
                'Create your own ',
                _react2.default.createElement(
                  'b',
                  null,
                  'Landbot'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hu-input-header' },
            backButton && _backButton,
            keywords && _react2.default.createElement(_KeywordSelector2.default, {
              keywords: keywords,
              ee: this.ee
            }),
            typing !== undefined && _react2.default.createElement(_TypingSwitchMobile2.default, {
              ee: this.ee,
              typing: typing
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'hu-input-body' },
            input
          )
        );
      } else {
        return _react2.default.createElement('div', { className: 'hu-input-container' });
      }
    }
  }]);

  return InputBox;
}(_react2.default.Component);

exports.default = InputBox;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Config = __webpack_require__(3);

var _Config2 = _interopRequireDefault(_Config);

var _ImagesPreview = __webpack_require__(139);

var _ImagesPreview2 = _interopRequireDefault(_ImagesPreview);

var _HuEmoji = __webpack_require__(140);

var _HuEmoji2 = _interopRequireDefault(_HuEmoji);

__webpack_require__(141);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputText = function (_React$Component) {
  _inherits(InputText, _React$Component);

  function InputText(props) {
    _classCallCheck(this, InputText);

    var _this = _possibleConstructorReturn(this, (InputText.__proto__ || Object.getPrototypeOf(InputText)).call(this, props));

    _this.state = {
      field: props.field,
      field_type: props.field_type,
      textSubmitHandler: props.textSubmitHandler,
      textareaData: props.textareaData,
      mode: 'text', // text | image
      text: props.textareaData.value ? _this.getValue(props.textareaData.value) : '',
      empty: props.textareaData.value ? !_this.getValue(props.textareaData.value) : true,
      images: [],
      image_flags: []
    };
    _this.fields = ['name', 'phone', 'email', 'postal code', 'address', 'country', 'birthdate'];
    _this.field_types = ['text', 'number', 'email', 'date', 'tel', 'location', 'image'];
    _this.input = null;
    _this.imagesInput = null;
    _this.inputContainer = null;
    _this.buttonsContainer = null;
    _this.emojiButton = null;
    _this.emojisAttached = false; // false or HuEmoji instance
    _this.autocomplete = null;

    _this.setInputFocus = _this.setInputFocus.bind(_this);
    _this.setFocusWithChar = _this.setFocusWithChar.bind(_this);
    _this.ee = props.ee;

    _this.isIE = _this.checkIE();
    return _this;
  }

  _createClass(InputText, [{
    key: 'checkIE',
    value: function checkIE() {
      var ieversion = false;
      var detectIEregexp = null;
      if (navigator.userAgent.indexOf('MSIE') != -1) detectIEregexp = /MSIE (\d+\.\d+);/; //test for MSIE x.x
      else // if no "MSIE" string in userAgent
        detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/; //test for rv:x.x or rv x.x where Trident string exists

      if (detectIEregexp.test(navigator.userAgent)) //if some form of IE
        ieversion = parseInt(RegExp.$1);
      return ieversion;
    }
  }, {
    key: 'getValue',
    value: function getValue(value) {
      if (value.charAt(0) === '$') return temp_data[value.substring(1)] || '';
      return value;
    }
  }, {
    key: 'getPlaceholder',
    value: function getPlaceholder() {
      var fieldIndex = this.fields.indexOf(this.props.field);
      if (fieldIndex > -1) return _Config2.default.text.inline_input_placeholder.replace('@field', _Config2.default.text.fields[fieldIndex]);
      return _Config2.default.text.text_input_placeholder;
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      if (this.inputContainer.className.indexOf('focus') === -1) this.inputContainer.className += ' focus';
    }
  }, {
    key: 'onTextareaClick',
    value: function onTextareaClick(e) {
      if (this.state.mode === 'text' && this.buttonsContainer ? !this.buttonsContainer.contains(e.target) : true) this.setInputFocus();
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      if (this.input) {
        this.input.blur();
        this.inputContainer.className = this.inputContainer.className.replace(/\sfocus/g, '');
      }
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var key = e.keyCode || e.which;
      if (key == 13) {
        if (!e.shiftKey) {
          e.preventDefault();
          if (!this.state.empty) this.send();
        } else {
          // contenteditable fixes
          e.preventDefault();
          var sel = window.getSelection();
          var caretNode = sel.anchorNode;
          var offset = sel.anchorOffset;
          var text = caretNode.textContent;
          var _text = text.slice(0, offset);
          var text_ = text.slice(offset) || ' ';
          caretNode.textContent = _text + '\n' + text_;
          // Restore caret position
          var range = document.createRange();
          range.setStart(caretNode, offset + 1);
          range.setEnd(caretNode, offset + 1);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    }
  }, {
    key: 'onInputKeyDown',
    value: function onInputKeyDown(e) {
      var key = e.keyCode || e.which;
      if (key == 13) {
        e.preventDefault();
        if (!this.state.empty) {
          this.send();
          var trash = document.querySelectorAll('.pac-container');
          for (var i = 0; i < trash.length; i++) {
            trash[i].parentElement.removeChild(trash[i]);
          }
        }
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      if (e.target) this.setState({
        text: typeof e.target.value === 'string' ? e.target.value : e.target.textContent,
        empty: typeof e.target.value === 'string' ? e.target.value === '' : e.target.textContent === ''
      });else if (typeof e === 'string' && document.activeElement === this.input) {
        this.setState({
          text: e,
          empty: e === ''
        });
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var text = '';
      if (window.clipboardData && window.clipboardData.getData) text = window.clipboardData.getData('Text');else text = e.clipboardData.getData('text/plain');
      document.execCommand('inserttext', false, text);
      e.preventDefault();
    }
  }, {
    key: 'send',
    value: function send() {
      if (this.emojisAttached) this.emojisAttached.hide();
      var _state = this.state,
          images = _state.images,
          image_flags = _state.image_flags;

      var text = this.input ? this.input.value || this.state.text : this.state.text;
      if (text === '' && images.length == 0) return;

      // Submit
      this.props.textSubmitHandler(text, images, image_flags);

      // Save temp variables
      if (this.props.textareaData.field) temp_data[this.props.textareaData.field] = text;

      this.setState({
        mode: 'text',
        text: '',
        empty: true,
        images: [],
        image_flags: []
      });
      if (!this.props.fixed) this.onBlur();
    }
  }, {
    key: 'setInputFocus',
    value: function setInputFocus() {
      if (this.input) {
        this.input.focus();
        this.input.click();
      }
    }
  }, {
    key: 'setFocusWithChar',
    value: function setFocusWithChar(char) {
      if (document.activeElement !== this.input && this.input) {
        this.input.focus();
        this.onChange('' + this.state.text + char);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ee.on('hu-lb-input-focus', this.setInputFocus);
      this.ee.on('hu-lb-text-focus', this.setFocusWithChar);

      // Init Google Places Api
      if (this.props.field_type === 'location') this.initializeLocationAutocomplete();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.ee.removeListener('hu-lb-input-focus', this.setInputFocus);
      this.ee.removeListener('hu-lb-text-focus', this.setFocusWithChar);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.input) this.input.focus();
      this.setState({
        mode: 'text',
        text: '',
        empty: true,
        images: [],
        image_flags: []
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.field_type === 'location' && prevProps.field_type !== 'location') this.initializeLocationAutocomplete();
    }
  }, {
    key: 'initializeLocationAutocomplete',
    value: function initializeLocationAutocomplete() {
      var _this2 = this;

      if (this.autocomplete !== null || isMobile || this.input instanceof HTMLInputElement === false) return;
      this.autocomplete = new google.maps.places.Autocomplete(this.input);
      this.autocomplete.addListener('place_changed', function () {
        _this2.onChange(_this2.autocomplete.getPlace().formatted_address);
      });
    }
  }, {
    key: 'attachImage',
    value: function attachImage(e) {
      if (e.target.files.length > 5) return;
      this.setState({
        empty: false,
        mode: 'image',
        images: e.target.files,
        image_flags: Array(this.imagesInput.files.length).fill(true)
      });
    }
  }, {
    key: 'attachEmojis',
    value: function attachEmojis() {
      if (this.emojisAttached === false) {
        this.emojisAttached = new _HuEmoji2.default(this.input, this.emojiButton,
        // this.inputContainer,
        document.getElementById(this.props.emoji), {
          pages: ['People', 'Nature', 'Food', 'Activity', 'Travel', 'Objects', 'Symbols', 'Flags'],
          search: true,
          preview: true,
          height: '300px',
          positionX: 'right',
          positionY: 'bottom',
          offsetY: -285, // -305
          offsetX: 56,
          spritesUrl: 'https://storage.googleapis.com/static.helloumi.com/daisho/img/sprite-icons.png'
        });
        this.emojisAttached.show();
      }
    }
  }, {
    key: 'removeImage',
    value: function removeImage(key) {
      var _state2 = this.state,
          images = _state2.images,
          image_flags = _state2.image_flags;

      var noImagesLeft = false;
      var _image_flags = image_flags.slice();
      for (var i = 0; i < images.length; i++) {
        if (images[i].name === key) {
          _image_flags[i] = false;
        }
      }
      // If images_flags = [false, ...false]
      if (_image_flags.every(function (e) {
        return !e;
      })) noImagesLeft = true;

      if (noImagesLeft) {
        this.setState({
          mode: 'text',
          empty: true,
          images: [],
          image_flags: _image_flags
        });
        if (this.imagesInput) this.imagesInput.value = '';
      } else this.setState({
        image_flags: _image_flags
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state3 = this.state,
          mode = _state3.mode,
          text = _state3.text,
          empty = _state3.empty,
          images = _state3.images,
          image_flags = _state3.image_flags;
      var _props = this.props,
          field = _props.field,
          field_type = _props.field_type;

      var placeholder = this.getPlaceholder();
      var textareaType = this.fields.indexOf(field) > -1 ? 'hu-textarea-light' : 'hu-textarea-heavy';

      var specialType = this.field_types.indexOf(field_type) > -1 && ['text', 'image'].indexOf(field_type) === -1 ? field_type : false;
      if (specialType === 'date') placeholder = '';

      var showImageInput = ['text', 'image'].indexOf(field_type) > -1 || this.props.fixed || false;

      var showEmojiInput = ['text'].indexOf(field_type) > -1 || this.props.fixed || false;

      var sendButton = _react2.default.createElement(
        'button',
        { className: 'send', onClick: this.send.bind(this), tabIndex: 2 },
        _react2.default.createElement(
          'svg',
          { xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', x: '3650', y: '3688' },
          _react2.default.createElement('path', { fill: '', d: 'M1.1 21.757l22.7-9.73L1.1 2.3l.012 7.912 13.623 1.816-13.623 1.817-.01 7.912z' })
        )
      );
      var attachButton = _react2.default.createElement(
        'div',
        { className: 'attach', tabIndex: 3, onClick: function onClick() {
            _this3.imagesInput.click();
          } },
        _react2.default.createElement(
          'svg',
          { className: 'hu-fill_contrast', xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', x: '3650', y: '3688', viewBox: '0 0 35 30' },
          _react2.default.createElement('path', { fill: '', d: 'M32.8,0c0.6,0,1.1,0.2,1.6,0.6C34.8,1,35,1.6,35,2.2v25.6c0,0.6-0.2,1.1-0.6,1.6C34,29.8,33.4,30,32.8,30 H2.2c-0.6,0-1.1-0.2-1.6-0.6C0.2,29,0,28.4,0,27.8V2.2C0,1.6,0.2,1,0.6,0.6C1,0.2,1.6,0,2.2,0H32.8z M23.8,15c0.4,0,0.8,0.2,1,0.5 l7.7,8.3V3.4c0-0.6-0.3-0.9-1-0.9h-28c-0.6,0-0.9,0.3-1,0.9v20.3l9.8-11.9c0.4-0.4,0.9-0.6,1.3-0.6c0.6,0,1,0.2,1.3,0.5l4.2,4.6 l0.3,0.3c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.9-0.4l1.4-1.2C23.1,15.1,23.4,15,23.8,15L23.8,15z M28.9,11.4 c-0.7,0.7-1.6,1.1-2.7,1.1c-1,0-1.9-0.4-2.7-1.1c-0.7-0.7-1.1-1.6-1.1-2.7c0-1,0.4-1.9,1.1-2.7C24.3,5.4,25.2,5,26.2,5 c1,0,1.9,0.4,2.7,1.1C29.6,6.8,30,7.7,30,8.8C30,9.8,29.6,10.7,28.9,11.4z' })
        ),
        _react2.default.createElement('input', {
          className: 'hide',
          type: 'file',
          multiple: 'multiple',
          ref: function ref(input) {
            return _this3.imagesInput = input;
          },
          onChange: function onChange(e) {
            _this3.attachImage(e);
          }
        })
      );
      var emojiButton = _react2.default.createElement(
        'div',
        { className: 'emoji', tabIndex: 4, onClick: this.attachEmojis.bind(this), ref: function ref(elem) {
            _this3.emojiButton = elem;
          } },
        _react2.default.createElement(
          'svg',
          { className: 'hu-fill_contrast', xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', x: '3650', y: '3688', viewBox: '0 0 34 34' },
          _react2.default.createElement('path', { fill: '', d: 'M17.1,34.3C7.7,34.3,0,26.6,0,17.1S7.7,0,17.1,0s17.1,7.7,17.1,17.1S26.6,34.3,17.1,34.3z M17.1,2.9 C9.3,2.9,2.9,9.3,2.9,17.1s6.4,14.3,14.3,14.3S31.4,25,31.4,17.1S25,2.9,17.1,2.9z M11.4,14.3c-1.6,0-2.9-1.3-2.9-2.9 s1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9S13,14.3,11.4,14.3z M17.1,27.1c-3.8,0-7.1-2.4-8.2-6c-0.2-0.8,0.2-1.5,0.9-1.8 c0.7-0.2,1.5,0.2,1.8,0.9c0.7,2.4,2.9,4,5.4,4s4.7-1.6,5.4-4c0.2-0.8,1-1.2,1.8-0.9c0.7,0.2,1.2,1,0.9,1.8 C24.2,24.7,20.9,27.1,17.1,27.1z M22.9,14.3c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9S24.4,14.3,22.9,14.3z' })
        )
      );

      var inputElement = null;
      if (mode === 'text') inputElement = !specialType && !this.isIE ? _react2.default.createElement(
        'div',
        {
          className: 'hu-textarea hu-color_textarea-text',
          contentEditable: true,
          tabIndex: 1,
          placeholder: placeholder,
          ref: function ref(input) {
            _this3.input = input;
          },
          onInput: function onInput(e) {
            _this3.onChange(e);
          },
          onKeyDown: function onKeyDown(e) {
            _this3.onKeyDown(e);
          },
          onFocus: this.onFocus.bind(this),
          onBlur: this.onBlur.bind(this),
          onPaste: this.onPaste,
          suppressContentEditableWarning: true,
          'data-gramm_editor': 'false'
        },
        text
      ) : _react2.default.createElement('input', {
        className: 'hu-textarea hu-color_textarea-text',
        contentEditable: true,
        tabIndex: 1,
        placeholder: placeholder,
        ref: function ref(input) {
          _this3.input = input;
        },
        onInput: function onInput(e) {
          _this3.onChange(e);
        },
        onChange: function onChange(e) {
          _this3.onChange(e);
        },
        onKeyDown: function onKeyDown(e) {
          _this3.onInputKeyDown(e);
        },
        onFocus: this.onFocus.bind(this),
        onBlur: this.onBlur.bind(this)
        //onPaste={this.onPaste}
        //suppressContentEditableWarning
        , 'data-gramm_editor': 'false',
        value: text,
        type: specialType
      });else if (mode === 'image') {
        inputElement = _react2.default.createElement(_ImagesPreview2.default, {
          images: images,
          image_flags: image_flags,
          removeImage: this.removeImage.bind(this)
        });
      }

      return _react2.default.createElement(
        'div',
        { className: '' + textareaType + (empty ? ' empty' : '') },
        _react2.default.createElement(
          'div',
          {
            className: 'hu-textarea-input-container hu-background-color_textarea-background ' + mode,
            ref: function ref(elem) {
              _this3.inputContainer = elem;
            },
            onClick: this.onTextareaClick.bind(this)
          },
          inputElement,
          _react2.default.createElement(
            'div',
            {
              className: 'hu-textarea-buttons',
              ref: function ref(elem) {
                _this3.buttonsContainer = elem;
              }
            },
            sendButton,
            _react2.default.createElement(
              'div',
              { className: 'attachments' },
              showImageInput && attachButton,
              this.props.emoji && showEmojiInput && emojiButton
            )
          )
        ),
        _react2.default.createElement('div', { className: 'separator hu-background-color_inline-input' }),
        _react2.default.createElement(
          'span',
          { className: 'hu-textarea-footer-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase' },
          _Config2.default.text.input_text_help
        )
      );
    }
  }]);

  return InputText;
}(_react2.default.Component);

exports.default = InputText;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImagesPreview = function (_React$Component) {
  _inherits(ImagesPreview, _React$Component);

  function ImagesPreview(props) {
    _classCallCheck(this, ImagesPreview);

    var _this = _possibleConstructorReturn(this, (ImagesPreview.__proto__ || Object.getPrototypeOf(ImagesPreview)).call(this, props));

    _this.state = {
      imagesList: Array.from(props.images).map(function (file) {
        return {
          key: file.name,
          url: null
        };
      })
    };
    _this.showThumbnails();
    return _this;
  }

  _createClass(ImagesPreview, [{
    key: "showThumbnails",
    value: function showThumbnails(nextProps) {
      var _this2 = this;

      var _ref = nextProps || this.props,
          images = _ref.images;

      var imagesList = this.state.imagesList;

      var _imagesList = imagesList.slice();

      var _loop = function _loop(i) {
        var reader = new FileReader();
        reader.readAsDataURL(images[i]);
        reader.onload = function (e) {
          _imagesList[i].url = e.target.result;
          _this2.setState({ imagesList: _imagesList });
        };
      };

      for (var i = 0; i < images.length; i++) {
        _loop(i);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextImages = nextProps.images;
      if (!this.compareFileList(nextImages, this.props.images)) {
        this.setState({
          imagesList: Array.from(nextImages).map(function (file) {
            return {
              key: file.name,
              url: null
            };
          })
        });
        this.showThumbnails(nextProps);
      }
    }

    // True: equals, False: different

  }, {
    key: "compareFileList",
    value: function compareFileList(fileListA, fileListB) {
      if (fileListA.length !== fileListB.length) return false;
      for (var i = 0; i < fileListA.length; i++) {
        if (fileListA[i].name !== fileListB[i].name) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          images = _props.images,
          image_flags = _props.image_flags,
          removeImage = _props.removeImage;
      var imagesList = this.state.imagesList;


      return _react2.default.createElement(
        "div",
        { className: "hu-images-preview" },
        imagesList.map(function (file, index) {
          if (image_flags[index]) {
            return _react2.default.createElement(
              "div",
              {
                className: "thumbnail",
                key: file.key,
                style: file.url && "background-image: url(" + file.url + ");"
              },
              _react2.default.createElement(
                "div",
                { className: "thumbnail-button" },
                _react2.default.createElement(
                  "svg",
                  { className: "hu-fill_accent",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    x: "3650",
                    y: "3688",
                    viewBox: "0 0 610 610",
                    onclick: function onclick() {
                      removeImage(file.key);
                    }
                  },
                  _react2.default.createElement("path", { fill: true, d: "M387.128,170.748L306,251.915l-81.128-81.167l-54.124,54.124L251.915,306l-81.128,81.128l54.085,54.086L306,360.086 l81.128,81.128l54.086-54.086L360.086,306l81.128-81.128L387.128,170.748z M522.38,89.62 c-119.493-119.493-313.267-119.493-432.76,0c-119.493,119.493-119.493,313.267,0,432.76 c119.493,119.493,313.267,119.493,432.76,0C641.873,402.888,641.873,209.113,522.38,89.62z M468.295,468.295 c-89.62,89.619-234.932,89.619-324.551,0c-89.62-89.62-89.62-234.932,0-324.551c89.62-89.62,234.931-89.62,324.551,0 C557.914,233.363,557.914,378.637,468.295,468.295z" })
                )
              )
            );
          } else {
            return null;
          }
        })
      );
    }
  }]);

  return ImagesPreview;
}(_react2.default.Component);

exports.default = ImagesPreview;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var HuEmoji = function HuEmoji(input, trigger, attach, options) {

    /* CONSTRUCTOR ********************************************/

    this.DEFAULTS = {
        pages: ['People', 'Nature', 'Food', 'Activity', 'Travel', 'Objects', 'Symbols', 'Flags'],
        search: false,
        preview: false,
        width: '325px',
        height: '200px',
        positionY: 'top',
        positionX: 'right',
        offsetY: 0,
        offsetX: 0,
        spritesUrl: ''
    };

    this.options = this.extendDefaults(this.DEFAULTS, options);

    // Error handlers
    // --------------

    // input error
    if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object') throw new TypeError('input must be an object, type ' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)) + ' was given instead.');

    // trigger error
    if ((typeof trigger === 'undefined' ? 'undefined' : _typeof(trigger)) !== 'object') throw new TypeError('trigger must be an object, type ' + (typeof trigger === 'undefined' ? 'undefined' : _typeof(trigger)) + ' was given instead.');

    // attach error
    if ((typeof attach === 'undefined' ? 'undefined' : _typeof(attach)) !== 'object') throw new TypeError('attach must be an object, type ' + (typeof attach === 'undefined' ? 'undefined' : _typeof(attach)) + ' was given instead.');

    // options error
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') throw new TypeError('options must be an object, type ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + ' was given instead.');

    // page doesn't exist
    this.options.pages.map(function (page, index) {
        if (HuEmoji.emojiPages.indexOf(page) < 0) throw new TypeError('options.page "' + this.options.pages[index] + '" doesn\'t exist. Try these: ' + HuEmoji.emojiPages);
    });

    // search is not boolean
    if (typeof this.options.search !== 'boolean') throw new TypeError('options.search must be a boolean, type ' + _typeof(this.options.search) + ' was given instead.');

    // preview is not boolean
    if (typeof this.options.preview !== 'boolean') throw new TypeError('options.preview must be a boolean, type ' + _typeof(this.options.preview) + ' was given instead.');

    // positionY error
    if (HuEmoji.positionYValues.indexOf(this.options.positionY) < 0) throw new TypeError('options.positionY value "' + this.options.positionY + '" not available, try these: ' + HuEmoji.positionYValues);

    // positionX error
    if (HuEmoji.positionXValues.indexOf(this.options.positionX) < 0) throw new TypeError('options.positionX value "' + this.options.positionX + '" not available, try these: ' + HuEmoji.positionXValues);

    // offsetY | offsetX is not number
    if (typeof this.options.offsetY !== 'number' || typeof this.options.offsetX !== 'number') throw new TypeError('options.offset must be a number');

    // spritesUrl is not string
    if (typeof this.options.spritesUrl !== 'string') throw new TypeError('options.spritesUrl must be a string, type ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + ' was given instead.');

    this.input = input;
    this.trigger = trigger;
    this.attach = attach;
    this.container = null;
    this.tabs = null;
    this.search = null;
    this.pagesScroll = null;
    this.checkScroll = true;
    this.preview = null;

    this.init();
};

HuEmoji.VERSION = '1.0.1';

/* CONSTANTS ********************************************/
HuEmoji.positionYValues = ['top', 'bottom'];
HuEmoji.positionXValues = ['left', 'center', 'right'];
HuEmoji.emojiPages = ['People', 'Nature', 'Food', 'Activity', 'Travel', 'Objects', 'Symbols', 'Flags'];
HuEmoji.contamination = 15;
/********************************************************/

/**
 * Merge defaults with input options
 * @param  {Object} defaults Default options
 * @param  {Object} options User input options
 * @return {Object} Object with merged options
 */
HuEmoji.prototype.extendDefaults = function (defaults, options) {
    for (var key in options) {
        if (options.hasOwnProperty(key) && defaults.hasOwnProperty(key)) {
            defaults[key] = options[key];
        }
    }
    return defaults;
};

/**
 * Toggle emoji picker
 * @param  {Object} e Mouse click event
 */
HuEmoji.prototype.toggle = function (e) {
    if (this.container.contains(e.target)) return;
    var state = this.container.style.display === 'block';
    if (state === true) this.hide();else this.show();
};

/**
 * Show emoji picker
 */
HuEmoji.prototype.show = function () {
    this.container.style.display = 'block';
    if (this.options.search) this.search.focus();
    // On first show, calc scroll positions
    if (this.pagesScroll == null) this.pagesScroll = this.getAllPagesPosition();
};

/**
 * Hide emoji picker
 */
HuEmoji.prototype.hide = function () {
    this.container.style.display = 'none';
    // Cancel search
    if (this.search) this.cancelSearch();
};

/**
 * Hide emoji picker on click outside
 * @param  {Object} e Mouse click event
 */
HuEmoji.prototype.globalHide = function (e) {
    if (this.container.contains(e.target) || this.trigger.contains(e.target)) return;
    if (this.container.style.display == 'block') this.hide();
};

HuEmoji.prototype.setInput = function (elem) {
    this.input = elem;
};

/**
 * Set emoji picker position (initial)
 */
HuEmoji.prototype.setContainerPosition = function () {
    var isTop = this.options.positionY == 'top';
    var isBottom = this.options.positionY == 'bottom';
    var isLeft = this.options.positionX == 'left';
    var isCenter = this.options.positionX == 'center';
    var isRight = this.options.positionX == 'right';
    if (isTop) this.container.style.bottom = this.options.offsetY + 'px';else if (isBottom) this.container.style.top = this.options.offsetY + 'px';
    if (isLeft) this.container.style.right = this.options.offsetX + 'px';else if (isCenter) {
        this.container.style.left = 0;
        this.container.style.right = 0;
        this.container.style.margin = '0 auto';
    } else if (isRight) this.container.style.left = this.options.offsetX + 'px';
};

/**
 * Set emoji picker position (update)
 * @param  {Number} offsetY Y axis increment
 * @param  {Number} offsetX X axis increment
 */
HuEmoji.prototype.updateContainerPosition = function (offsetY, offsetX) {
    var isTop = this.options.positionY == 'top';
    var isBottom = this.options.positionY == 'bottom';
    var isLeft = this.options.positionX == 'left';
    var isRight = this.options.positionX == 'right';
    if (isTop) this.container.style.bottom = this.options.offsetY + offsetY + 'px';else if (isBottom) this.container.style.top = this.options.offsetY + offsetY + 'px';
    if (isLeft) this.container.style.right = this.options.offsetX + offsetX + 'px';else if (isRight) this.container.style.left = this.options.offsetX + offsetX + 'px';
};

/**
 * Select emojis page directly or from topbar tab
 * @param  {String|Object} e Page name | Mouse click event
 */
HuEmoji.prototype.selectPage = function (e) {
    // Cancel search
    if (this.search) this.cancelSearch();

    var page = e.target ? e.target.parentNode.getAttribute('data-tab') || e.target.getAttribute('data-tab') : e;
    // Set active tab class
    this.pageClassHandler(page);
    // Scrolls to page
    this.checkScroll = false; // checkScroll vuelve a ser true tras un cierto delay
    this.container.querySelector('section').scrollTop = this.getPagePosition(page);
};

/**
 * Set topbar tabs classes when page changes
 * @param  {String} page Page name
 */
HuEmoji.prototype.pageClassHandler = function (page) {
    var activeTabs = this.tabs.querySelectorAll('li.hu-active');
    for (var tab = 0; tab < activeTabs.length; tab++) {
        activeTabs[tab].className = activeTabs[tab].className.replace(' hu-active', '');
    }
    var selectedTab = this.tabs.querySelector('[data-tab="' + page + '"]');
    selectedTab.className += ' hu-active';
};

/**
 * On scroll handler
 */
HuEmoji.prototype.scrollListener = function (e) {
    // this.checkScroll = true;
    if (this.checkScroll) {
        this.checkScroll = false;
        var currentScroll = e.target.scrollTop;
        var page = this.getPageFromScroll(currentScroll);
        this.pageClassHandler(page);
    }
    setTimeout(function () {
        this.checkScroll = true;
    }, 200);
};

/**
 * Get emoji pages scroll position
 * @return {Array} Array with all pages scroll position
 */
HuEmoji.prototype.getAllPagesPosition = function () {
    var pages = this.options.pages;
    var pagesPosition = [];
    for (var page in pages) {
        var position = this.container.querySelector('#page_' + pages[page]).offsetTop;
        if (this.options.search === true) position -= 91;else position -= 49;
        pagesPosition.push(position);
    }
    return pagesPosition;
};

/**
 * Get a specific page scroll position
 * @param  {String} page Page name
 * @return {Number} Page scroll position
 */
HuEmoji.prototype.getPagePosition = function (page) {
    var position = this.container.querySelector('#page_' + page).offsetTop;
    if (this.options.search === true) position -= 91;else position -= 49;
    return position + 1;
};

/**
 * Get which page matches current scroll position
 * @param  {Number} scroll Scroll position
 * @return {String} Page name
 */
HuEmoji.prototype.getPageFromScroll = function (scroll) {
    var pages = this.options.pages;
    var page = null;
    for (var i = pages.length - 1; i > -1; i--) {
        if (scroll > this.pagesScroll[i]) {
            page = pages[i];
            break;
        }
    }
    return page !== null ? page : pages[0];
};

/**
 * On search input change handler
 */
HuEmoji.prototype.searchListener = function (e) {
    var search = e.target.value.toLowerCase();
    var matches = [];
    if (search != '') {
        var matches = this.getObjectsFromJSON(HuEmoji.EMOJIS, search);
        this.showSearchPage();
        this.fillSearchPage(matches);
    } else {
        this.hideSearchPage();
    }
};

/**
 * Show search page and hide standard pages
 */
HuEmoji.prototype.showSearchPage = function () {
    for (var i = 0; i < this.options.pages.length; i++) {
        var page = this.container.querySelector('#page_' + this.options.pages[i]);
        if (page.className.indexOf('hu-hidden') == -1) page.className += ' hu-hidden';
    }
    var searchPage = this.container.querySelector('#page_Search');
    if (searchPage.className.indexOf('hu-hidden') == -1) return;else searchPage.className = searchPage.className.replace(' hu-hidden', '');
};

/**
 * Hide search page and show standard pages
 */
HuEmoji.prototype.hideSearchPage = function () {
    for (var i = 0; i < this.options.pages.length; i++) {
        var page = this.container.querySelector('#page_' + this.options.pages[i]);
        if (page.className.indexOf('hu-hidden') > -1) {
            page.className = page.className.replace(' hu-hidden', '');
        }
    }
    var searchPage = this.container.querySelector('#page_Search');
    if (searchPage.className.indexOf('hu-hidden') > -1) return;else searchPage.className += ' hu-hidden';
};

/**
 * Fill search page with matching emojis
 * @param  {Array} matches Array of matching emojis
 */
HuEmoji.prototype.fillSearchPage = function (matches) {
    var emojisSearchList = this.container.querySelector('#page_Search .hu-emoji-list-items');
    emojisSearchList.innerHTML = '';
    for (var item in matches) {
        var span = document.createElement('span');
        span.className = 'hu-emoji';
        span.textContent = matches[item].value;
        span.setAttribute('data-name', matches[item].name);
        span.setAttribute('data-value', matches[item].value);
        span.addEventListener('click', this.pickEmoji.bind(this));
        span.addEventListener('mouseenter', this.previewOn.bind(this));
        span.addEventListener('mouseleave', this.previewOff.bind(this));
        var spanWrapper = document.createElement('div');
        spanWrapper.className = 'hu-emoji-item';
        spanWrapper.appendChild(span);
        emojisSearchList.appendChild(spanWrapper);
    }
    this.alignmentTrick(emojisSearchList, HuEmoji.contamination);
};

/**
 * Cancel search by deleting search value and trigger keyup
 */
HuEmoji.prototype.cancelSearch = function () {
    this.search.value = '';
    var clickEvent = document.createEvent('HTMLEvents');
    clickEvent.initEvent('keyup', false, true);
    this.search.dispatchEvent(clickEvent);
};

/**
 * Add 'c' elements in emojis 'page' to perform center alignment
 * @param  {Object} pageElem Emojis page container
 * @param  {Number} c Number of contaminating elements
 */
HuEmoji.prototype.alignmentTrick = function (pageElem, c) {
    for (var i = 0; i < c; i++) {
        var span = document.createElement('div');
        span.className = 'hu-emoji-item';
        pageElem.appendChild(span);
    }
};

/**
 * Get array of matching emojis from a search string
 * @param  {Object|Array} obj Object|Array of emojis
 * @param  {String} val Matching value
 * @return {Array} Array of matching emojis
 */
HuEmoji.prototype.getObjectsFromJSON = function (obj, val) {
    var objects = [];
    for (var i in obj) {
        if (!obj.hasOwnProperty(i)) continue;
        if (_typeof(obj[i]) == 'object') {
            objects = objects.concat(this.getObjectsFromJSON(obj[i], val));
        } else if (obj[i].indexOf(val) > -1) {
            objects.push(obj);
        }
    }
    return objects;
};

HuEmoji.prototype.placeCaretAtEnd = function (el) {
    el.focus();
    if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (typeof document.body.createTextRange != "undefined") {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
    }
};

/**
 * On emoji mouse click handler
 */
HuEmoji.prototype.pickEmoji = function (e) {
    var emoji = e.target.getAttribute('data-value');
    this.insertEmoji(emoji, this.input);
    if (this.input.value !== undefined) this.input.focus();else {
        // CONTENTEDITABLE enters here...
        this.placeCaretAtEnd(this.input);
    }
};

/**
 * Insert emoji clicked on plugin defined input
 * @param  {String} emoji Emoji content
 * @param  {Object} input Plugin input
 */
HuEmoji.prototype.insertEmoji = function (emoji, input) {
    var startPosition,
        endPosition,
        offset = emoji.length;
    if (document.selection) {
        input.focus();
        var sel = document.selection.createRange();
        sel.text = emoji;
    } else if (input.selectionStart || input.selectionStart == '0') {
        var startPosition = input.selectionStart;
        var endPosition = input.selectionEnd;
        input.value = input.value.substring(0, startPosition) + emoji + input.value.substring(endPosition, input.value.length);
        this.triggerEvent(input, 'input');
        // Restore cursor
        input.focus();
        input.setSelectionRange(startPosition + offset, endPosition + offset);
    } else {
        // CONTENTEDITABLE enters here...
        if (input.value === undefined) input.textContent += emoji;else input.value += emoji;
        this.triggerEvent(input, 'input');
    }
};

HuEmoji.prototype.triggerEvent = function (el, type) {
    if ('createEvent' in document) {
        var e = document.createEvent('HTMLEvents');
        e.initEvent(type, false, true);
        el.dispatchEvent(e);
    } else {
        // IE 8
        var e = document.createEventObject();
        e.eventType = type;
        el.fireEvent('on' + e.eventType, e);
    }
};

/**
 * Show emoji preview
 * @param  {String|Object} e Emoji hovered | Mouse click event
 */
HuEmoji.prototype.previewOn = function (e) {
    var imageElem = this.preview.querySelector('.hu-emoji-preview-image');
    var titleElem = this.preview.querySelector('.hu-emoji-preview-title');
    var nameElem = this.preview.querySelector('.hu-emoji-preview-name');
    var image = e.target || e;
    var name = image.getAttribute('data-name');
    var title = name.slice(1, name.length - 1);

    imageElem.innerHTML = image.outerHTML;
    titleElem.textContent = title;
    nameElem.textContent = name;
};

/**
 * Hide emoji preview
 */
HuEmoji.prototype.previewOff = function () {
    var imageElem = this.preview.querySelector('.hu-emoji-preview-image');
    var titleElem = this.preview.querySelector('.hu-emoji-preview-title');
    var nameElem = this.preview.querySelector('.hu-emoji-preview-name');

    imageElem.innerHTML = '';
    titleElem.innerHTML = '';
    nameElem.innerHTML = '';
};

// ================================
// EMOJI PICKER BUILDER
// ================================

HuEmoji.prototype.init = function () {

    var wrapper, header, emojiTypes, searchElem, body, emojiList, footer, previewElem;

    // Create container
    this.container = document.createElement('div');
    this.container.className = 'hu-emoji-container';
    this.container.style.display = 'none';
    if (this.options.width) this.container.style.width = this.options.width;
    if (this.options.height) this.container.style.height = this.options.height;
    this.setContainerPosition();

    // Create wrapper
    wrapper = document.createElement('div');
    wrapper.className = 'hu-emoji-wrapper';

    // Create header
    header = document.createElement('header');
    emojiTypes = document.createElement('div');
    emojiTypes.className = 'hu-emoji-types';
    // Tabs
    this.tabs = emojiTypes;
    emojiTypes.appendChild(this.getEmojiTopbar());
    header.appendChild(emojiTypes);
    // Append search input
    if (this.options.search === true) {
        searchElem = document.createElement('div');
        searchElem.className = 'hu-emoji-search';
        var input = document.createElement('input');
        input.setAttribute('placeholder', 'Search emojis');
        // input.addEventListener('change', this.searchListener.bind(this));
        input.addEventListener('keyup', this.searchListener.bind(this));
        input.addEventListener('paste', this.searchListener.bind(this));
        searchElem.appendChild(input);
        this.search = input;
        header.appendChild(searchElem);
    }

    // Create body
    body = document.createElement('section');
    body.addEventListener('scroll', this.scrollListener.bind(this));
    var emojiListContainer = document.createElement('div');
    emojiListContainer.className = 'hu-emoji-list';
    body.appendChild(emojiListContainer);

    // Create all pages
    for (var page in this.options.pages) {
        emojiListContainer.appendChild(this.getEmojiPage(this.options.pages[page]));
    }
    // Create search page
    if (this.options.search === true) {
        emojiListContainer.appendChild(this.getSearchPage());
    }

    // Create footer
    footer = document.createElement('footer');
    // Create preview
    if (this.options.preview === true) {
        previewElem = document.createElement('div');
        previewElem.className = 'hu-emoji-preview';
        var previewImage = document.createElement('div');
        previewImage.className = 'hu-emoji-preview-image';
        var previewInfo = document.createElement('div');
        previewInfo.className = 'hu-emoji-preview-info';
        var previewTitle = document.createElement('h4');
        previewTitle.className = 'hu-emoji-preview-title';
        var previewName = document.createElement('p');
        previewName.className = 'hu-emoji-preview-name';
        previewInfo.appendChild(previewTitle);
        previewInfo.appendChild(previewName);
        previewElem.appendChild(previewImage);
        previewElem.appendChild(previewInfo);

        this.preview = previewElem;
        footer.appendChild(previewElem);
    }

    // Mount everything
    wrapper.appendChild(header);
    wrapper.appendChild(body);
    wrapper.appendChild(footer);

    this.container.appendChild(wrapper);

    // Inject container
    this.attach.appendChild(this.container);

    this.selectPage(this.options.pages[0]);

    // Emoji picker toggler
    this.trigger.addEventListener('click', this.toggle.bind(this));

    // GLOBAL CLICK TOGGLER
    document.addEventListener('click', this.globalHide.bind(this));
};

/**
 * Build an emojis page
 * @param  {String} emojiType Page name
 * @return {Object} Emojis page HTML
 */
HuEmoji.prototype.getEmojiPage = function (emojiType) {
    var pageElem = document.createElement('div');
    pageElem.className = 'hu-emoji-list-page';
    pageElem.id = 'page_' + emojiType;

    var title = document.createElement('h3');
    title.className = 'hu-emoji-list-type';
    title.textContent = emojiType;
    pageElem.appendChild(title);

    var emojisList = document.createElement('div');
    emojisList.className = 'hu-emoji-list-items';

    for (var item in HuEmoji.EMOJIS[emojiType]) {
        var span = document.createElement('span');
        span.className = 'hu-emoji';
        span.textContent = HuEmoji.EMOJIS[emojiType][item].value;
        span.setAttribute('data-name', HuEmoji.EMOJIS[emojiType][item].name);
        span.setAttribute('data-value', HuEmoji.EMOJIS[emojiType][item].value);
        span.addEventListener('click', this.pickEmoji.bind(this));
        span.addEventListener('mouseenter', this.previewOn.bind(this));
        span.addEventListener('mouseleave', this.previewOff.bind(this));
        var spanWrapper = document.createElement('div');
        spanWrapper.className = 'hu-emoji-item';
        spanWrapper.appendChild(span);
        emojisList.appendChild(spanWrapper);
    }
    this.alignmentTrick(emojisList, HuEmoji.contamination);

    pageElem.appendChild(emojisList);
    return pageElem;
};

/**
 * Build emojis search page
 * @return {Object} Emojis page HTML
 */
HuEmoji.prototype.getSearchPage = function () {
    var pageElem = document.createElement('div');
    pageElem.className = 'hu-emoji-list-page hu-hidden';
    pageElem.id = 'page_Search';

    var title = document.createElement('h3');
    title.className = 'hu-emoji-list-type';
    title.textContent = 'Search results';
    pageElem.appendChild(title);

    var emojisList = document.createElement('div');
    emojisList.className = 'hu-emoji-list-items';

    pageElem.appendChild(emojisList);
    return pageElem;
};

/**
 * Build emojis topbar tabs
 * @return {Object} Emojis topbar tabs HTML
 */
HuEmoji.prototype.getEmojiTopbar = function () {
    var list = document.createElement('ul');
    for (var page in this.options.pages) {
        var item = document.createElement('li');
        item.setAttribute('data-tab', this.options.pages[page]);
        item.addEventListener('click', this.selectPage.bind(this));
        var content = document.createElement('div');
        content.className = 'icon hu-tab-' + this.options.pages[page];
        content.style.backgroundImage = 'url(' + this.options.spritesUrl + ')';
        item.appendChild(content);
        list.appendChild(item);
    }
    return list;
};

// ================================
// EMOJIS LIST
// ================================

HuEmoji.EMOJIS = {
    "People": [{
        "name": ":grinning:",
        "value": "😀"
    }, {
        "name": ":grin:",
        "value": "😁"
    }, {
        "name": ":joy:",
        "value": "😂"
    }, {
        "name": ":smiley:",
        "value": "😃"
    }, {
        "name": ":smile:",
        "value": "😄"
    }, {
        "name": ":sweat_smile:",
        "value": "😅"
    }, {
        "name": ":laughing:",
        "value": "😆"
    }, {
        "name": ":innocent:",
        "value": "😇"
    }, {
        "name": ":smiling_imp:",
        "value": "😈"
    }, {
        "name": ":wink:",
        "value": "😉"
    }, {
        "name": ":blush:",
        "value": "😊"
    }, {
        "name": ":yum:",
        "value": "😋"
    }, {
        "name": ":relieved:",
        "value": "😌"
    }, {
        "name": ":heart_eyes:",
        "value": "😍"
    }, {
        "name": ":sunglasses:",
        "value": "😎"
    }, {
        "name": ":smirk:",
        "value": "😏"
    }, {
        "name": ":neutral_face:",
        "value": "😐"
    }, {
        "name": ":expressionless:",
        "value": "😑"
    }, {
        "name": ":unamused:",
        "value": "😒"
    }, {
        "name": ":sweat:",
        "value": "😓"
    }, {
        "name": ":pensive:",
        "value": "😔"
    }, {
        "name": ":confused:",
        "value": "😕"
    }, {
        "name": ":confounded:",
        "value": "😖"
    }, {
        "name": ":kissing:",
        "value": "😗"
    }, {
        "name": ":kissing_heart:",
        "value": "😘"
    }, {
        "name": ":kissing_smiling_eyes:",
        "value": "😙"
    }, {
        "name": ":kissing_closed_eyes:",
        "value": "😚"
    }, {
        "name": ":stuck_out_tongue:",
        "value": "😛"
    }, {
        "name": ":stuck_out_tongue_winking_eye:",
        "value": "😜"
    }, {
        "name": ":stuck_out_tongue_closed_eyes:",
        "value": "😝"
    }, {
        "name": ":disappointed:",
        "value": "😞"
    }, {
        "name": ":worried:",
        "value": "😟"
    }, {
        "name": ":angry:",
        "value": "😠"
    }, {
        "name": ":rage:",
        "value": "😡"
    }, {
        "name": ":cry:",
        "value": "😢"
    }, {
        "name": ":persevere:",
        "value": "😣"
    }, {
        "name": ":triumph:",
        "value": "😤"
    }, {
        "name": ":disappointed_relieved:",
        "value": "😥"
    }, {
        "name": ":frowning:",
        "value": "😦"
    }, {
        "name": ":anguished:",
        "value": "😧"
    }, {
        "name": ":fearful:",
        "value": "😨"
    }, {
        "name": ":weary:",
        "value": "😩"
    }, {
        "name": ":sleepy:",
        "value": "😪"
    }, {
        "name": ":tired_face:",
        "value": "😫"
    }, {
        "name": ":grimacing:",
        "value": "😬"
    }, {
        "name": ":sob:",
        "value": "😭"
    }, {
        "name": ":open_mouth:",
        "value": "😮"
    }, {
        "name": ":hushed:",
        "value": "😯"
    }, {
        "name": ":cold_sweat:",
        "value": "😰"
    }, {
        "name": ":scream:",
        "value": "😱"
    }, {
        "name": ":astonished:",
        "value": "😲"
    }, {
        "name": ":flushed:",
        "value": "😳"
    }, {
        "name": ":sleeping:",
        "value": "😴"
    }, {
        "name": ":dizzy_face:",
        "value": "😵"
    }, {
        "name": ":no_mouth:",
        "value": "😶"
    }, {
        "name": ":mask:",
        "value": "😷"
    }, {
        "name": ":smile_cat:",
        "value": "😸"
    }, {
        "name": ":joy_cat:",
        "value": "😹"
    }, {
        "name": ":smiley_cat:",
        "value": "😺"
    }, {
        "name": ":heart_eyes_cat:",
        "value": "😻"
    }, {
        "name": ":smirk_cat:",
        "value": "😼"
    }, {
        "name": ":kissing_cat:",
        "value": "😽"
    }, {
        "name": ":pouting_cat:",
        "value": "😾"
    }, {
        "name": ":crying_cat_face:",
        "value": "😿"
    }, {
        "name": ":scream_cat:",
        "value": "🙀"
    }, {
        "name": ":slightly_frowning_face:",
        "value": "🙁"
    }, {
        "name": ":slightly_smiling_face:",
        "value": "🙂"
    }, {
        "name": ":upside_down_face:",
        "value": "🙃"
    }, {
        "name": ":face_with_rolling_eyes:",
        "value": "🙄"
    }, {
        "name": ":no_good:",
        "value": "🙅"
    }, {
        "name": ":ok_woman:",
        "value": "🙆"
    }, {
        "name": ":bow:",
        "value": "🙇"
    }, {
        "name": ":see_no_evil:",
        "value": "🙈"
    }, {
        "name": ":hear_no_evil:",
        "value": "🙉"
    }, {
        "name": ":speak_no_evil:",
        "value": "🙊"
    }, {
        "name": ":raising_hand:",
        "value": "🙋"
    }, {
        "name": ":raised_hands:",
        "value": "🙌"
    }, {
        "name": ":person_frowning:",
        "value": "🙍"
    }, {
        "name": ":person_with_pouting_face:",
        "value": "🙎"
    }, {
        "name": ":pray:",
        "value": "🙏"
    }, {
        "name": ":rowboat:",
        "value": "🚣"
    }, {
        "name": ":bicyclist:",
        "value": "🚴"
    }, {
        "name": ":mountain_bicyclist:",
        "value": "🚵"
    }, {
        "name": ":walking:",
        "value": "🚶"
    }, {
        "name": ":shopping_bags:",
        "value": "🛍"
    }, {
        "name": ":zipper_mouth_face:",
        "value": "🤐"
    }, {
        "name": ":money_mouth_face:",
        "value": "🤑"
    }, {
        "name": ":face_with_thermometer:",
        "value": "🤒"
    }, {
        "name": ":nerd_face:",
        "value": "🤓"
    }, {
        "name": ":thinking_face:",
        "value": "🤔"
    }, {
        "name": ":face_with_head_bandage:",
        "value": "🤕"
    }, {
        "name": ":robot_face:",
        "value": "🤖"
    }, {
        "name": ":hugging_face:",
        "value": "🤗"
    }, {
        "name": ":the_horns:",
        "value": "🤘"
    }, {
        "name": ":man-man-boy:",
        "value": "👨‍👨‍👦"
    }, {
        "name": ":man-man-boy-boy:",
        "value": "👨‍👨‍👦‍👦"
    }, {
        "name": ":man-man-girl:",
        "value": "👨‍👨‍👧"
    }, {
        "name": ":man-man-girl-boy:",
        "value": "👨‍👨‍👧‍👦"
    }, {
        "name": ":man-man-girl-girl:",
        "value": "👨‍👨‍👧‍👧"
    }, {
        "name": ":man-woman-boy-boy:",
        "value": "👨‍👩‍👦‍👦"
    }, {
        "name": ":man-woman-girl:",
        "value": "👨‍👩‍👧"
    }, {
        "name": ":man-woman-girl-boy:",
        "value": "👨‍👩‍👧‍👦"
    }, {
        "name": ":man-woman-girl-girl:",
        "value": "👨‍👩‍👧‍👧"
    }, {
        "name": ":man-heart-man:",
        "value": "👨‍❤️‍👨"
    }, {
        "name": ":man-kiss-man:",
        "value": "👨‍❤️‍💋‍👨"
    }, {
        "name": ":woman-woman-boy:",
        "value": "👩‍👩‍👦"
    }, {
        "name": ":woman-woman-boy-boy:",
        "value": "👩‍👩‍👦‍👦"
    }, {
        "name": ":woman-woman-girl:",
        "value": "👩‍👩‍👧"
    }, {
        "name": ":woman-woman-girl-boy:",
        "value": "👩‍👩‍👧‍👦"
    }, {
        "name": ":woman-woman-girl-girl:",
        "value": "👩‍👩‍👧‍👧"
    }, {
        "name": ":woman-heart-woman:",
        "value": "👩‍❤️‍👩"
    }, {
        "name": ":woman-kiss-woman:",
        "value": "👩‍❤️‍💋‍👩"
    }, {
        "name": ":umbrella:",
        "value": "☂"
    }, {
        "name": ":umbrella_with_rain_drops:",
        "value": "☔"
    }, {
        "name": ":point_up:",
        "value": "☝"
    }, {
        "name": ":skull_and_crossbones:",
        "value": "☠"
    }, {
        "name": ":white_frowning_face:",
        "value": "☹"
    }, {
        "name": ":relaxed:",
        "value": "☺"
    }, {
        "name": ":spades:",
        "value": "♠"
    }, {
        "name": ":clubs:",
        "value": "♣"
    }, {
        "name": ":hearts:",
        "value": "♥"
    }, {
        "name": ":diamonds:",
        "value": "♦"
    }, {
        "name": ":helmet_with_white_cross:",
        "value": "⛑"
    }, {
        "name": ":umbrella_on_ground:",
        "value": "⛱"
    }, {
        "name": ":skier:",
        "value": "⛷"
    }, {
        "name": ":person_with_ball:",
        "value": "⛹"
    }, {
        "name": ":fist:",
        "value": "✊"
    }, {
        "name": ":hand:",
        "value": "✋"
    }, {
        "name": ":v:",
        "value": "✌"
    }, {
        "name": ":writing_hand:",
        "value": "✍"
    }, {
        "name": ":sparkles:",
        "value": "✨"
    }, {
        "name": ":mahjong:",
        "value": "🀄"
    }, {
        "name": ":black_joker:",
        "value": "🃏"
    }, {
        "name": ":cyclone:",
        "value": "🌀"
    }, {
        "name": ":closed_umbrella:",
        "value": "🌂"
    }, {
        "name": ":stars:",
        "value": "🌠"
    }, {
        "name": ":thermometer:",
        "value": "🌡"
    }, {
        "name": ":jack_o_lantern:",
        "value": "🎃"
    }, {
        "name": ":christmas_tree:",
        "value": "🎄"
    }, {
        "name": ":santa:",
        "value": "🎅"
    }, {
        "name": ":fireworks:",
        "value": "🎆"
    }, {
        "name": ":sparkler:",
        "value": "🎇"
    }, {
        "name": ":school_satchel:",
        "value": "🎒"
    }, {
        "name": ":mortar_board:",
        "value": "🎓"
    }, {
        "name": ":art:",
        "value": "🎨"
    }, {
        "name": ":tophat:",
        "value": "🎩"
    }, {
        "name": ":circus_tent:",
        "value": "🎪"
    }, {
        "name": ":performing_arts:",
        "value": "🎭"
    }, {
        "name": ":slot_machine:",
        "value": "🎰"
    }, {
        "name": ":flower_playing_cards:",
        "value": "🎴"
    }, {
        "name": ":snowboarder:",
        "value": "🏂"
    }, {
        "name": ":runner:",
        "value": "🏃"
    }, {
        "name": ":surfer:",
        "value": "🏄"
    }, {
        "name": ":horse_racing:",
        "value": "🏇"
    }, {
        "name": ":swimmer:",
        "value": "🏊"
    }, {
        "name": ":weight_lifter:",
        "value": "🏋"
    }, {
        "name": ":golfer:",
        "value": "🏌"
    }, {
        "name": ":racing_motorcycle:",
        "value": "🏍"
    }, {
        "name": ":racing_car:",
        "value": "🏎"
    }, {
        "name": ":amphora:",
        "value": "🏺"
    }, {
        "name": ":skin-tone-2:",
        "value": "🏻"
    }, {
        "name": ":skin-tone-3:",
        "value": "🏼"
    }, {
        "name": ":skin-tone-4:",
        "value": "🏽"
    }, {
        "name": ":skin-tone-5:",
        "value": "🏾"
    }, {
        "name": ":skin-tone-6:",
        "value": "🏿"
    }, {
        "name": ":eyes:",
        "value": "👀"
    }, {
        "name": ":eye:",
        "value": "👁"
    }, {
        "name": ":ear:",
        "value": "👂"
    }, {
        "name": ":nose:",
        "value": "👃"
    }, {
        "name": ":lips:",
        "value": "👄"
    }, {
        "name": ":tongue:",
        "value": "👅"
    }, {
        "name": ":point_up_2:",
        "value": "👆"
    }, {
        "name": ":point_down:",
        "value": "👇"
    }, {
        "name": ":point_left:",
        "value": "👈"
    }, {
        "name": ":point_right:",
        "value": "👉"
    }, {
        "name": ":facepunch:",
        "value": "👊"
    }, {
        "name": ":wave:",
        "value": "👋"
    }, {
        "name": ":ok_hand:",
        "value": "👌"
    }, {
        "name": ":+1:",
        "value": "👍"
    }, {
        "name": ":-1:",
        "value": "👎"
    }, {
        "name": ":clap:",
        "value": "👏"
    }, {
        "name": ":open_hands:",
        "value": "👐"
    }, {
        "name": ":crown:",
        "value": "👑"
    }, {
        "name": ":womans_hat:",
        "value": "👒"
    }, {
        "name": ":eyeglasses:",
        "value": "👓"
    }, {
        "name": ":necktie:",
        "value": "👔"
    }, {
        "name": ":shirt:",
        "value": "👕"
    }, {
        "name": ":jeans:",
        "value": "👖"
    }, {
        "name": ":dress:",
        "value": "👗"
    }, {
        "name": ":kimono:",
        "value": "👘"
    }, {
        "name": ":bikini:",
        "value": "👙"
    }, {
        "name": ":womans_clothes:",
        "value": "👚"
    }, {
        "name": ":purse:",
        "value": "👛"
    }, {
        "name": ":handbag:",
        "value": "👜"
    }, {
        "name": ":pouch:",
        "value": "👝"
    }, {
        "name": ":mans_shoe:",
        "value": "👞"
    }, {
        "name": ":athletic_shoe:",
        "value": "👟"
    }, {
        "name": ":high_heel:",
        "value": "👠"
    }, {
        "name": ":sandal:",
        "value": "👡"
    }, {
        "name": ":boot:",
        "value": "👢"
    }, {
        "name": ":footprints:",
        "value": "👣"
    }, {
        "name": ":bust_in_silhouette:",
        "value": "👤"
    }, {
        "name": ":busts_in_silhouette:",
        "value": "👥"
    }, {
        "name": ":boy:",
        "value": "👦"
    }, {
        "name": ":girl:",
        "value": "👧"
    }, {
        "name": ":man:",
        "value": "👨"
    }, {
        "name": ":woman:",
        "value": "👩"
    }, {
        "name": ":family:",
        "value": "👪"
    }, {
        "name": ":couple:",
        "value": "👫"
    }, {
        "name": ":two_men_holding_hands:",
        "value": "👬"
    }, {
        "name": ":two_women_holding_hands:",
        "value": "👭"
    }, {
        "name": ":cop:",
        "value": "👮"
    }, {
        "name": ":dancers:",
        "value": "👯"
    }, {
        "name": ":bride_with_veil:",
        "value": "👰"
    }, {
        "name": ":person_with_blond_hair:",
        "value": "👱"
    }, {
        "name": ":man_with_gua_pi_mao:",
        "value": "👲"
    }, {
        "name": ":man_with_turban:",
        "value": "👳"
    }, {
        "name": ":older_man:",
        "value": "👴"
    }, {
        "name": ":older_woman:",
        "value": "👵"
    }, {
        "name": ":baby:",
        "value": "👶"
    }, {
        "name": ":construction_worker:",
        "value": "👷"
    }, {
        "name": ":princess:",
        "value": "👸"
    }, {
        "name": ":japanese_ogre:",
        "value": "👹"
    }, {
        "name": ":japanese_goblin:",
        "value": "👺"
    }, {
        "name": ":ghost:",
        "value": "👻"
    }, {
        "name": ":angel:",
        "value": "👼"
    }, {
        "name": ":alien:",
        "value": "👽"
    }, {
        "name": ":space_invader:",
        "value": "👾"
    }, {
        "name": ":imp:",
        "value": "👿"
    }, {
        "name": ":skull:",
        "value": "💀"
    }, {
        "name": ":information_desk_person:",
        "value": "💁"
    }, {
        "name": ":guardsman:",
        "value": "💂"
    }, {
        "name": ":dancer:",
        "value": "💃"
    }, {
        "name": ":lipstick:",
        "value": "💄"
    }, {
        "name": ":nail_care:",
        "value": "💅"
    }, {
        "name": ":massage:",
        "value": "💆"
    }, {
        "name": ":haircut:",
        "value": "💇"
    }, {
        "name": ":barber:",
        "value": "💈"
    }, {
        "name": ":kiss:",
        "value": "💋"
    }, {
        "name": ":love_letter:",
        "value": "💌"
    }, {
        "name": ":ring:",
        "value": "💍"
    }, {
        "name": ":gem:",
        "value": "💎"
    }, {
        "name": ":couplekiss:",
        "value": "💏"
    }, {
        "name": ":couple_with_heart:",
        "value": "💑"
    }, {
        "name": ":anger:",
        "value": "💢"
    }, {
        "name": ":bomb:",
        "value": "💣"
    }, {
        "name": ":zzz:",
        "value": "💤"
    }, {
        "name": ":boom:",
        "value": "💥"
    }, {
        "name": ":sweat_drops:",
        "value": "💦"
    }, {
        "name": ":dash:",
        "value": "💨"
    }, {
        "name": ":hankey:",
        "value": "💩"
    }, {
        "name": ":muscle:",
        "value": "💪"
    }, {
        "name": ":dizzy:",
        "value": "💫"
    }, {
        "name": ":currency_exchange:",
        "value": "💱"
    }, {
        "name": ":heavy_dollar_sign:",
        "value": "💲"
    }, {
        "name": ":chart:",
        "value": "💹"
    }, {
        "name": ":prayer_beads:",
        "value": "📿"
    }, {
        "name": ":hole:",
        "value": "🕳"
    }, {
        "name": ":man_in_business_suit_levitating:",
        "value": "🕴"
    }, {
        "name": ":sleuth_or_spy:",
        "value": "🕵"
    }, {
        "name": ":dark_sunglasses:",
        "value": "🕶"
    }, {
        "name": ":raised_hand_with_fingers_splayed:",
        "value": "🖐"
    }, {
        "name": ":middle_finger:",
        "value": "🖕"
    }, {
        "name": ":spock-hand:",
        "value": "🖖"
    }, {
        "name": ":frame_with_picture:",
        "value": "🖼"
    }, {
        "name": ":speaking_head_in_silhouette:",
        "value": "🗣"
    }],
    "Nature": [{
        "name": ":sunny:",
        "value": "☀"
    }, {
        "name": ":cloud:",
        "value": "☁"
    }, {
        "name": ":snowman:",
        "value": "☃"
    }, {
        "name": ":comet:",
        "value": "☄"
    }, {
        "name": ":shamrock:",
        "value": "☘"
    }, {
        "name": ":zap:",
        "value": "⚡"
    }, {
        "name": ":snowman_without_snow:",
        "value": "⛄"
    }, {
        "name": ":partly_sunny:",
        "value": "⛅"
    }, {
        "name": ":thunder_cloud_and_rain:",
        "value": "⛈"
    }, {
        "name": ":snowflake:",
        "value": "❄"
    }, {
        "name": ":star:",
        "value": "⭐"
    }, {
        "name": ":rainbow:",
        "value": "🌈"
    }, {
        "name": ":ocean:",
        "value": "🌊"
    }, {
        "name": ":earth_africa:",
        "value": "🌍"
    }, {
        "name": ":earth_americas:",
        "value": "🌎"
    }, {
        "name": ":earth_asia:",
        "value": "🌏"
    }, {
        "name": ":new_moon:",
        "value": "🌑"
    }, {
        "name": ":waxing_crescent_moon:",
        "value": "🌒"
    }, {
        "name": ":first_quarter_moon:",
        "value": "🌓"
    }, {
        "name": ":moon:",
        "value": "🌔"
    }, {
        "name": ":full_moon:",
        "value": "🌕"
    }, {
        "name": ":waning_gibbous_moon:",
        "value": "🌖"
    }, {
        "name": ":last_quarter_moon:",
        "value": "🌗"
    }, {
        "name": ":waning_crescent_moon:",
        "value": "🌘"
    }, {
        "name": ":crescent_moon:",
        "value": "🌙"
    }, {
        "name": ":new_moon_with_face:",
        "value": "🌚"
    }, {
        "name": ":first_quarter_moon_with_face:",
        "value": "🌛"
    }, {
        "name": ":last_quarter_moon_with_face:",
        "value": "🌜"
    }, {
        "name": ":full_moon_with_face:",
        "value": "🌝"
    }, {
        "name": ":sun_with_face:",
        "value": "🌞"
    }, {
        "name": ":star2:",
        "value": "🌟"
    }, {
        "name": ":mostly_sunny:",
        "value": "🌤"
    }, {
        "name": ":barely_sunny:",
        "value": "🌥"
    }, {
        "name": ":partly_sunny_rain:",
        "value": "🌦"
    }, {
        "name": ":rain_cloud:",
        "value": "🌧"
    }, {
        "name": ":snow_cloud:",
        "value": "🌨"
    }, {
        "name": ":lightning:",
        "value": "🌩"
    }, {
        "name": ":tornado:",
        "value": "🌪"
    }, {
        "name": ":fog:",
        "value": "🌫"
    }, {
        "name": ":wind_blowing_face:",
        "value": "🌬"
    }, {
        "name": ":seedling:",
        "value": "🌱"
    }, {
        "name": ":evergreen_tree:",
        "value": "🌲"
    }, {
        "name": ":deciduous_tree:",
        "value": "🌳"
    }, {
        "name": ":palm_tree:",
        "value": "🌴"
    }, {
        "name": ":cactus:",
        "value": "🌵"
    }, {
        "name": ":tulip:",
        "value": "🌷"
    }, {
        "name": ":cherry_blossom:",
        "value": "🌸"
    }, {
        "name": ":rose:",
        "value": "🌹"
    }, {
        "name": ":hibiscus:",
        "value": "🌺"
    }, {
        "name": ":sunflower:",
        "value": "🌻"
    }, {
        "name": ":blossom:",
        "value": "🌼"
    }, {
        "name": ":ear_of_rice:",
        "value": "🌾"
    }, {
        "name": ":herb:",
        "value": "🌿"
    }, {
        "name": ":four_leaf_clover:",
        "value": "🍀"
    }, {
        "name": ":maple_leaf:",
        "value": "🍁"
    }, {
        "name": ":fallen_leaf:",
        "value": "🍂"
    }, {
        "name": ":leaves:",
        "value": "🍃"
    }, {
        "name": ":rosette:",
        "value": "🏵"
    }, {
        "name": ":rat:",
        "value": "🐀"
    }, {
        "name": ":mouse2:",
        "value": "🐁"
    }, {
        "name": ":ox:",
        "value": "🐂"
    }, {
        "name": ":water_buffalo:",
        "value": "🐃"
    }, {
        "name": ":cow2:",
        "value": "🐄"
    }, {
        "name": ":tiger2:",
        "value": "🐅"
    }, {
        "name": ":leopard:",
        "value": "🐆"
    }, {
        "name": ":rabbit2:",
        "value": "🐇"
    }, {
        "name": ":cat2:",
        "value": "🐈"
    }, {
        "name": ":dragon:",
        "value": "🐉"
    }, {
        "name": ":crocodile:",
        "value": "🐊"
    }, {
        "name": ":whale2:",
        "value": "🐋"
    }, {
        "name": ":snail:",
        "value": "🐌"
    }, {
        "name": ":snake:",
        "value": "🐍"
    }, {
        "name": ":racehorse:",
        "value": "🐎"
    }, {
        "name": ":ram:",
        "value": "🐏"
    }, {
        "name": ":goat:",
        "value": "🐐"
    }, {
        "name": ":sheep:",
        "value": "🐑"
    }, {
        "name": ":monkey:",
        "value": "🐒"
    }, {
        "name": ":rooster:",
        "value": "🐓"
    }, {
        "name": ":chicken:",
        "value": "🐔"
    }, {
        "name": ":dog2:",
        "value": "🐕"
    }, {
        "name": ":pig2:",
        "value": "🐖"
    }, {
        "name": ":boar:",
        "value": "🐗"
    }, {
        "name": ":elephant:",
        "value": "🐘"
    }, {
        "name": ":octopus:",
        "value": "🐙"
    }, {
        "name": ":shell:",
        "value": "🐚"
    }, {
        "name": ":bug:",
        "value": "🐛"
    }, {
        "name": ":ant:",
        "value": "🐜"
    }, {
        "name": ":bee:",
        "value": "🐝"
    }, {
        "name": ":beetle:",
        "value": "🐞"
    }, {
        "name": ":fish:",
        "value": "🐟"
    }, {
        "name": ":tropical_fish:",
        "value": "🐠"
    }, {
        "name": ":blowfish:",
        "value": "🐡"
    }, {
        "name": ":turtle:",
        "value": "🐢"
    }, {
        "name": ":hatching_chick:",
        "value": "🐣"
    }, {
        "name": ":baby_chick:",
        "value": "🐤"
    }, {
        "name": ":hatched_chick:",
        "value": "🐥"
    }, {
        "name": ":bird:",
        "value": "🐦"
    }, {
        "name": ":penguin:",
        "value": "🐧"
    }, {
        "name": ":koala:",
        "value": "🐨"
    }, {
        "name": ":poodle:",
        "value": "🐩"
    }, {
        "name": ":dromedary_camel:",
        "value": "🐪"
    }, {
        "name": ":camel:",
        "value": "🐫"
    }, {
        "name": ":dolphin:",
        "value": "🐬"
    }, {
        "name": ":mouse:",
        "value": "🐭"
    }, {
        "name": ":cow:",
        "value": "🐮"
    }, {
        "name": ":tiger:",
        "value": "🐯"
    }, {
        "name": ":rabbit:",
        "value": "🐰"
    }, {
        "name": ":cat:",
        "value": "🐱"
    }, {
        "name": ":dragon_face:",
        "value": "🐲"
    }, {
        "name": ":whale:",
        "value": "🐳"
    }, {
        "name": ":horse:",
        "value": "🐴"
    }, {
        "name": ":monkey_face:",
        "value": "🐵"
    }, {
        "name": ":dog:",
        "value": "🐶"
    }, {
        "name": ":pig:",
        "value": "🐷"
    }, {
        "name": ":frog:",
        "value": "🐸"
    }, {
        "name": ":hamster:",
        "value": "🐹"
    }, {
        "name": ":wolf:",
        "value": "🐺"
    }, {
        "name": ":bear:",
        "value": "🐻"
    }, {
        "name": ":panda_face:",
        "value": "🐼"
    }, {
        "name": ":pig_nose:",
        "value": "🐽"
    }, {
        "name": ":feet:",
        "value": "🐾"
    }, {
        "name": ":chipmunk:",
        "value": "🐿"
    }, {
        "name": ":bouquet:",
        "value": "💐"
    }, {
        "name": ":droplet:",
        "value": "💧"
    }, {
        "name": ":white_flower:",
        "value": "💮"
    }, {
        "name": ":fire:",
        "value": "🔥"
    }, {
        "name": ":dove_of_peace:",
        "value": "🕊"
    }, {
        "name": ":spider:",
        "value": "🕷"
    }, {
        "name": ":spider_web:",
        "value": "🕸"
    }, {
        "name": ":crab:",
        "value": "🦀"
    }, {
        "name": ":lion_face:",
        "value": "🦁"
    }, {
        "name": ":scorpion:",
        "value": "🦂"
    }, {
        "name": ":turkey:",
        "value": "🦃"
    }, {
        "name": ":unicorn_face:",
        "value": "🦄"
    }],
    "Food": [{
        "name": ":coffee:",
        "value": "☕"
    }, {
        "name": ":hotdog:",
        "value": "🌭"
    }, {
        "name": ":taco:",
        "value": "🌮"
    }, {
        "name": ":burrito:",
        "value": "🌯"
    }, {
        "name": ":chestnut:",
        "value": "🌰"
    }, {
        "name": ":hot_pepper:",
        "value": "🌶"
    }, {
        "name": ":corn:",
        "value": "🌽"
    }, {
        "name": ":mushroom:",
        "value": "🍄"
    }, {
        "name": ":tomato:",
        "value": "🍅"
    }, {
        "name": ":eggplant:",
        "value": "🍆"
    }, {
        "name": ":grapes:",
        "value": "🍇"
    }, {
        "name": ":melon:",
        "value": "🍈"
    }, {
        "name": ":watermelon:",
        "value": "🍉"
    }, {
        "name": ":tangerine:",
        "value": "🍊"
    }, {
        "name": ":lemon:",
        "value": "🍋"
    }, {
        "name": ":banana:",
        "value": "🍌"
    }, {
        "name": ":pineapple:",
        "value": "🍍"
    }, {
        "name": ":apple:",
        "value": "🍎"
    }, {
        "name": ":green_apple:",
        "value": "🍏"
    }, {
        "name": ":pear:",
        "value": "🍐"
    }, {
        "name": ":peach:",
        "value": "🍑"
    }, {
        "name": ":cherries:",
        "value": "🍒"
    }, {
        "name": ":strawberry:",
        "value": "🍓"
    }, {
        "name": ":hamburger:",
        "value": "🍔"
    }, {
        "name": ":pizza:",
        "value": "🍕"
    }, {
        "name": ":meat_on_bone:",
        "value": "🍖"
    }, {
        "name": ":poultry_leg:",
        "value": "🍗"
    }, {
        "name": ":rice_cracker:",
        "value": "🍘"
    }, {
        "name": ":rice_ball:",
        "value": "🍙"
    }, {
        "name": ":rice:",
        "value": "🍚"
    }, {
        "name": ":curry:",
        "value": "🍛"
    }, {
        "name": ":ramen:",
        "value": "🍜"
    }, {
        "name": ":spaghetti:",
        "value": "🍝"
    }, {
        "name": ":bread:",
        "value": "🍞"
    }, {
        "name": ":fries:",
        "value": "🍟"
    }, {
        "name": ":sweet_potato:",
        "value": "🍠"
    }, {
        "name": ":dango:",
        "value": "🍡"
    }, {
        "name": ":oden:",
        "value": "🍢"
    }, {
        "name": ":sushi:",
        "value": "🍣"
    }, {
        "name": ":fried_shrimp:",
        "value": "🍤"
    }, {
        "name": ":fish_cake:",
        "value": "🍥"
    }, {
        "name": ":icecream:",
        "value": "🍦"
    }, {
        "name": ":shaved_ice:",
        "value": "🍧"
    }, {
        "name": ":ice_cream:",
        "value": "🍨"
    }, {
        "name": ":doughnut:",
        "value": "🍩"
    }, {
        "name": ":cookie:",
        "value": "🍪"
    }, {
        "name": ":chocolate_bar:",
        "value": "🍫"
    }, {
        "name": ":candy:",
        "value": "🍬"
    }, {
        "name": ":lollipop:",
        "value": "🍭"
    }, {
        "name": ":custard:",
        "value": "🍮"
    }, {
        "name": ":honey_pot:",
        "value": "🍯"
    }, {
        "name": ":cake:",
        "value": "🍰"
    }, {
        "name": ":bento:",
        "value": "🍱"
    }, {
        "name": ":stew:",
        "value": "🍲"
    }, {
        "name": ":egg:",
        "value": "🍳"
    }, {
        "name": ":fork_and_knife:",
        "value": "🍴"
    }, {
        "name": ":tea:",
        "value": "🍵"
    }, {
        "name": ":sake:",
        "value": "🍶"
    }, {
        "name": ":wine_glass:",
        "value": "🍷"
    }, {
        "name": ":cocktail:",
        "value": "🍸"
    }, {
        "name": ":tropical_drink:",
        "value": "🍹"
    }, {
        "name": ":beer:",
        "value": "🍺"
    }, {
        "name": ":beers:",
        "value": "🍻"
    }, {
        "name": ":baby_bottle:",
        "value": "🍼"
    }, {
        "name": ":knife_fork_plate:",
        "value": "🍽"
    }, {
        "name": ":champagne:",
        "value": "🍾"
    }, {
        "name": ":popcorn:",
        "value": "🍿"
    }, {
        "name": ":birthday:",
        "value": "🎂"
    }, {
        "name": ":hocho:",
        "value": "🔪"
    }, {
        "name": ":cheese_wedge:",
        "value": "🧀"
    }],
    "Activity": [{
        "name": ":soccer:",
        "value": "⚽"
    }, {
        "name": ":baseball:",
        "value": "⚾"
    }, {
        "name": ":golf:",
        "value": "⛳"
    }, {
        "name": ":ice_skate:",
        "value": "⛸"
    }, {
        "name": ":medal:",
        "value": "🎖"
    }, {
        "name": ":fishing_pole_and_fish:",
        "value": "🎣"
    }, {
        "name": ":video_game:",
        "value": "🎮"
    }, {
        "name": ":dart:",
        "value": "🎯"
    }, {
        "name": ":8ball:",
        "value": "🎱"
    }, {
        "name": ":game_die:",
        "value": "🎲"
    }, {
        "name": ":bowling:",
        "value": "🎳"
    }, {
        "name": ":running_shirt_with_sash:",
        "value": "🎽"
    }, {
        "name": ":tennis:",
        "value": "🎾"
    }, {
        "name": ":ski:",
        "value": "🎿"
    }, {
        "name": ":basketball:",
        "value": "🏀"
    }, {
        "name": ":sports_medal:",
        "value": "🏅"
    }, {
        "name": ":trophy:",
        "value": "🏆"
    }, {
        "name": ":football:",
        "value": "🏈"
    }, {
        "name": ":rugby_football:",
        "value": "🏉"
    }, {
        "name": ":cricket_bat_and_ball:",
        "value": "🏏"
    }, {
        "name": ":volleyball:",
        "value": "🏐"
    }, {
        "name": ":field_hockey_stick_and_ball:",
        "value": "🏑"
    }, {
        "name": ":ice_hockey_stick_and_puck:",
        "value": "🏒"
    }, {
        "name": ":table_tennis_paddle_and_ball:",
        "value": "🏓"
    }, {
        "name": ":badminton_racquet_and_shuttlecock:",
        "value": "🏸"
    }, {
        "name": ":joystick:",
        "value": "🕹"
    }],
    "Travel": [{
        "name": ":hotsprings:",
        "value": "♨"
    }, {
        "name": ":anchor:",
        "value": "⚓"
    }, {
        "name": ":shinto_shrine:",
        "value": "⛩"
    }, {
        "name": ":church:",
        "value": "⛪"
    }, {
        "name": ":mountain:",
        "value": "⛰"
    }, {
        "name": ":fountain:",
        "value": "⛲"
    }, {
        "name": ":ferry:",
        "value": "⛴"
    }, {
        "name": ":boat:",
        "value": "⛵"
    }, {
        "name": ":tent:",
        "value": "⛺"
    }, {
        "name": ":fuelpump:",
        "value": "⛽"
    }, {
        "name": ":airplane:",
        "value": "✈"
    }, {
        "name": ":foggy:",
        "value": "🌁"
    }, {
        "name": ":night_with_stars:",
        "value": "🌃"
    }, {
        "name": ":sunrise_over_mountains:",
        "value": "🌄"
    }, {
        "name": ":sunrise:",
        "value": "🌅"
    }, {
        "name": ":city_sunset:",
        "value": "🌆"
    }, {
        "name": ":city_sunrise:",
        "value": "🌇"
    }, {
        "name": ":bridge_at_night:",
        "value": "🌉"
    }, {
        "name": ":volcano:",
        "value": "🌋"
    }, {
        "name": ":milky_way:",
        "value": "🌌"
    }, {
        "name": ":globe_with_meridians:",
        "value": "🌐"
    }, {
        "name": ":carousel_horse:",
        "value": "🎠"
    }, {
        "name": ":ferris_wheel:",
        "value": "🎡"
    }, {
        "name": ":roller_coaster:",
        "value": "🎢"
    }, {
        "name": ":snow_capped_mountain:",
        "value": "🏔"
    }, {
        "name": ":camping:",
        "value": "🏕"
    }, {
        "name": ":beach_with_umbrella:",
        "value": "🏖"
    }, {
        "name": ":building_construction:",
        "value": "🏗"
    }, {
        "name": ":house_buildings:",
        "value": "🏘"
    }, {
        "name": ":cityscape:",
        "value": "🏙"
    }, {
        "name": ":derelict_house_building:",
        "value": "🏚"
    }, {
        "name": ":classical_building:",
        "value": "🏛"
    }, {
        "name": ":desert:",
        "value": "🏜"
    }, {
        "name": ":desert_island:",
        "value": "🏝"
    }, {
        "name": ":national_park:",
        "value": "🏞"
    }, {
        "name": ":stadium:",
        "value": "🏟"
    }, {
        "name": ":house:",
        "value": "🏠"
    }, {
        "name": ":house_with_garden:",
        "value": "🏡"
    }, {
        "name": ":office:",
        "value": "🏢"
    }, {
        "name": ":post_office:",
        "value": "🏣"
    }, {
        "name": ":european_post_office:",
        "value": "🏤"
    }, {
        "name": ":hospital:",
        "value": "🏥"
    }, {
        "name": ":bank:",
        "value": "🏦"
    }, {
        "name": ":hotel:",
        "value": "🏨"
    }, {
        "name": ":love_hotel:",
        "value": "🏩"
    }, {
        "name": ":convenience_store:",
        "value": "🏪"
    }, {
        "name": ":school:",
        "value": "🏫"
    }, {
        "name": ":department_store:",
        "value": "🏬"
    }, {
        "name": ":factory:",
        "value": "🏭"
    }, {
        "name": ":japanese_castle:",
        "value": "🏯"
    }, {
        "name": ":european_castle:",
        "value": "🏰"
    }, {
        "name": ":wedding:",
        "value": "💒"
    }, {
        "name": ":seat:",
        "value": "💺"
    }, {
        "name": ":kaaba:",
        "value": "🕋"
    }, {
        "name": ":mosque:",
        "value": "🕌"
    }, {
        "name": ":synagogue:",
        "value": "🕍"
    }, {
        "name": ":world_map:",
        "value": "🗺"
    }, {
        "name": ":mount_fuji:",
        "value": "🗻"
    }, {
        "name": ":tokyo_tower:",
        "value": "🗼"
    }, {
        "name": ":statue_of_liberty:",
        "value": "🗽"
    }, {
        "name": ":japan:",
        "value": "🗾"
    }, {
        "name": ":rocket:",
        "value": "🚀"
    }, {
        "name": ":helicopter:",
        "value": "🚁"
    }, {
        "name": ":steam_locomotive:",
        "value": "🚂"
    }, {
        "name": ":railway_car:",
        "value": "🚃"
    }, {
        "name": ":bullettrain_side:",
        "value": "🚄"
    }, {
        "name": ":bullettrain_front:",
        "value": "🚅"
    }, {
        "name": ":train2:",
        "value": "🚆"
    }, {
        "name": ":metro:",
        "value": "🚇"
    }, {
        "name": ":light_rail:",
        "value": "🚈"
    }, {
        "name": ":station:",
        "value": "🚉"
    }, {
        "name": ":tram:",
        "value": "🚊"
    }, {
        "name": ":train:",
        "value": "🚋"
    }, {
        "name": ":bus:",
        "value": "🚌"
    }, {
        "name": ":oncoming_bus:",
        "value": "🚍"
    }, {
        "name": ":trolleybus:",
        "value": "🚎"
    }, {
        "name": ":busstop:",
        "value": "🚏"
    }, {
        "name": ":minibus:",
        "value": "🚐"
    }, {
        "name": ":ambulance:",
        "value": "🚑"
    }, {
        "name": ":fire_engine:",
        "value": "🚒"
    }, {
        "name": ":police_car:",
        "value": "🚓"
    }, {
        "name": ":oncoming_police_car:",
        "value": "🚔"
    }, {
        "name": ":taxi:",
        "value": "🚕"
    }, {
        "name": ":oncoming_taxi:",
        "value": "🚖"
    }, {
        "name": ":car:",
        "value": "🚗"
    }, {
        "name": ":oncoming_automobile:",
        "value": "🚘"
    }, {
        "name": ":blue_car:",
        "value": "🚙"
    }, {
        "name": ":truck:",
        "value": "🚚"
    }, {
        "name": ":articulated_lorry:",
        "value": "🚛"
    }, {
        "name": ":tractor:",
        "value": "🚜"
    }, {
        "name": ":monorail:",
        "value": "🚝"
    }, {
        "name": ":mountain_railway:",
        "value": "🚞"
    }, {
        "name": ":suspension_railway:",
        "value": "🚟"
    }, {
        "name": ":mountain_cableway:",
        "value": "🚠"
    }, {
        "name": ":aerial_tramway:",
        "value": "🚡"
    }, {
        "name": ":ship:",
        "value": "🚢"
    }, {
        "name": ":speedboat:",
        "value": "🚤"
    }, {
        "name": ":traffic_light:",
        "value": "🚥"
    }, {
        "name": ":vertical_traffic_light:",
        "value": "🚦"
    }, {
        "name": ":construction:",
        "value": "🚧"
    }, {
        "name": ":rotating_light:",
        "value": "🚨"
    }, {
        "name": ":bike:",
        "value": "🚲"
    }, {
        "name": ":motorway:",
        "value": "🛣"
    }, {
        "name": ":railway_track:",
        "value": "🛤"
    }, {
        "name": ":motor_boat:",
        "value": "🛥"
    }, {
        "name": ":small_airplane:",
        "value": "🛩"
    }, {
        "name": ":airplane_departure:",
        "value": "🛫"
    }, {
        "name": ":airplane_arriving:",
        "value": "🛬"
    }, {
        "name": ":satellite:",
        "value": "🛰"
    }, {
        "name": ":passenger_ship:",
        "value": "🛳"
    }],
    "Objects": [{
        "name": ":watch:",
        "value": "⌚"
    }, {
        "name": ":hourglass:",
        "value": "⌛"
    }, {
        "name": ":keyboard:",
        "value": "⌨"
    }, {
        "name": ":alarm_clock:",
        "value": "⏰"
    }, {
        "name": ":stopwatch:",
        "value": "⏱"
    }, {
        "name": ":timer_clock:",
        "value": "⏲"
    }, {
        "name": ":hourglass_flowing_sand:",
        "value": "⏳"
    }, {
        "name": ":phone:",
        "value": "☎"
    }, {
        "name": ":hammer_and_pick:",
        "value": "⚒"
    }, {
        "name": ":crossed_swords:",
        "value": "⚔"
    }, {
        "name": ":scales:",
        "value": "⚖"
    }, {
        "name": ":alembic:",
        "value": "⚗"
    }, {
        "name": ":gear:",
        "value": "⚙"
    }, {
        "name": ":coffin:",
        "value": "⚰"
    }, {
        "name": ":funeral_urn:",
        "value": "⚱"
    }, {
        "name": ":pick:",
        "value": "⛏"
    }, {
        "name": ":chains:",
        "value": "⛓"
    }, {
        "name": ":scissors:",
        "value": "✂"
    }, {
        "name": ":email:",
        "value": "✉"
    }, {
        "name": ":pencil2:",
        "value": "✏"
    }, {
        "name": ":black_nib:",
        "value": "✒"
    }, {
        "name": ":ribbon:",
        "value": "🎀"
    }, {
        "name": ":gift:",
        "value": "🎁"
    }, {
        "name": ":balloon:",
        "value": "🎈"
    }, {
        "name": ":tada:",
        "value": "🎉"
    }, {
        "name": ":confetti_ball:",
        "value": "🎊"
    }, {
        "name": ":tanabata_tree:",
        "value": "🎋"
    }, {
        "name": ":bamboo:",
        "value": "🎍"
    }, {
        "name": ":dolls:",
        "value": "🎎"
    }, {
        "name": ":flags:",
        "value": "🎏"
    }, {
        "name": ":wind_chime:",
        "value": "🎐"
    }, {
        "name": ":rice_scene:",
        "value": "🎑"
    }, {
        "name": ":reminder_ribbon:",
        "value": "🎗"
    }, {
        "name": ":studio_microphone:",
        "value": "🎙"
    }, {
        "name": ":level_slider:",
        "value": "🎚"
    }, {
        "name": ":control_knobs:",
        "value": "🎛"
    }, {
        "name": ":film_frames:",
        "value": "🎞"
    }, {
        "name": ":admission_tickets:",
        "value": "🎟"
    }, {
        "name": ":microphone:",
        "value": "🎤"
    }, {
        "name": ":movie_camera:",
        "value": "🎥"
    }, {
        "name": ":headphones:",
        "value": "🎧"
    }, {
        "name": ":ticket:",
        "value": "🎫"
    }, {
        "name": ":clapper:",
        "value": "🎬"
    }, {
        "name": ":musical_note:",
        "value": "🎵"
    }, {
        "name": ":notes:",
        "value": "🎶"
    }, {
        "name": ":saxophone:",
        "value": "🎷"
    }, {
        "name": ":guitar:",
        "value": "🎸"
    }, {
        "name": ":musical_keyboard:",
        "value": "🎹"
    }, {
        "name": ":trumpet:",
        "value": "🎺"
    }, {
        "name": ":violin:",
        "value": "🎻"
    }, {
        "name": ":musical_score:",
        "value": "🎼"
    }, {
        "name": ":izakaya_lantern:",
        "value": "🏮"
    }, {
        "name": ":label:",
        "value": "🏷"
    }, {
        "name": ":bow_and_arrow:",
        "value": "🏹"
    }, {
        "name": ":syringe:",
        "value": "💉"
    }, {
        "name": ":pill:",
        "value": "💊"
    }, {
        "name": ":bulb:",
        "value": "💡"
    }, {
        "name": ":moneybag:",
        "value": "💰"
    }, {
        "name": ":credit_card:",
        "value": "💳"
    }, {
        "name": ":yen:",
        "value": "💴"
    }, {
        "name": ":dollar:",
        "value": "💵"
    }, {
        "name": ":euro:",
        "value": "💶"
    }, {
        "name": ":pound:",
        "value": "💷"
    }, {
        "name": ":money_with_wings:",
        "value": "💸"
    }, {
        "name": ":computer:",
        "value": "💻"
    }, {
        "name": ":briefcase:",
        "value": "💼"
    }, {
        "name": ":minidisc:",
        "value": "💽"
    }, {
        "name": ":floppy_disk:",
        "value": "💾"
    }, {
        "name": ":cd:",
        "value": "💿"
    }, {
        "name": ":dvd:",
        "value": "📀"
    }, {
        "name": ":file_folder:",
        "value": "📁"
    }, {
        "name": ":open_file_folder:",
        "value": "📂"
    }, {
        "name": ":page_with_curl:",
        "value": "📃"
    }, {
        "name": ":page_facing_up:",
        "value": "📄"
    }, {
        "name": ":date:",
        "value": "📅"
    }, {
        "name": ":calendar:",
        "value": "📆"
    }, {
        "name": ":card_index:",
        "value": "📇"
    }, {
        "name": ":chart_with_upwards_trend:",
        "value": "📈"
    }, {
        "name": ":chart_with_downwards_trend:",
        "value": "📉"
    }, {
        "name": ":bar_chart:",
        "value": "📊"
    }, {
        "name": ":clipboard:",
        "value": "📋"
    }, {
        "name": ":pushpin:",
        "value": "📌"
    }, {
        "name": ":round_pushpin:",
        "value": "📍"
    }, {
        "name": ":paperclip:",
        "value": "📎"
    }, {
        "name": ":straight_ruler:",
        "value": "📏"
    }, {
        "name": ":triangular_ruler:",
        "value": "📐"
    }, {
        "name": ":bookmark_tabs:",
        "value": "📑"
    }, {
        "name": ":ledger:",
        "value": "📒"
    }, {
        "name": ":notebook:",
        "value": "📓"
    }, {
        "name": ":notebook_with_decorative_cover:",
        "value": "📔"
    }, {
        "name": ":closed_book:",
        "value": "📕"
    }, {
        "name": ":book:",
        "value": "📖"
    }, {
        "name": ":green_book:",
        "value": "📗"
    }, {
        "name": ":blue_book:",
        "value": "📘"
    }, {
        "name": ":orange_book:",
        "value": "📙"
    }, {
        "name": ":books:",
        "value": "📚"
    }, {
        "name": ":scroll:",
        "value": "📜"
    }, {
        "name": ":memo:",
        "value": "📝"
    }, {
        "name": ":telephone_receiver:",
        "value": "📞"
    }, {
        "name": ":pager:",
        "value": "📟"
    }, {
        "name": ":fax:",
        "value": "📠"
    }, {
        "name": ":satellite_antenna:",
        "value": "📡"
    }, {
        "name": ":outbox_tray:",
        "value": "📤"
    }, {
        "name": ":inbox_tray:",
        "value": "📥"
    }, {
        "name": ":package:",
        "value": "📦"
    }, {
        "name": ":e-mail:",
        "value": "📧"
    }, {
        "name": ":incoming_envelope:",
        "value": "📨"
    }, {
        "name": ":envelope_with_arrow:",
        "value": "📩"
    }, {
        "name": ":mailbox_closed:",
        "value": "📪"
    }, {
        "name": ":mailbox:",
        "value": "📫"
    }, {
        "name": ":mailbox_with_mail:",
        "value": "📬"
    }, {
        "name": ":mailbox_with_no_mail:",
        "value": "📭"
    }, {
        "name": ":postbox:",
        "value": "📮"
    }, {
        "name": ":newspaper:",
        "value": "📰"
    }, {
        "name": ":iphone:",
        "value": "📱"
    }, {
        "name": ":calling:",
        "value": "📲"
    }, {
        "name": ":camera:",
        "value": "📷"
    }, {
        "name": ":camera_with_flash:",
        "value": "📸"
    }, {
        "name": ":video_camera:",
        "value": "📹"
    }, {
        "name": ":tv:",
        "value": "📺"
    }, {
        "name": ":radio:",
        "value": "📻"
    }, {
        "name": ":vhs:",
        "value": "📼"
    }, {
        "name": ":film_projector:",
        "value": "📽"
    }, {
        "name": ":battery:",
        "value": "🔋"
    }, {
        "name": ":electric_plug:",
        "value": "🔌"
    }, {
        "name": ":mag:",
        "value": "🔍"
    }, {
        "name": ":mag_right:",
        "value": "🔎"
    }, {
        "name": ":lock_with_ink_pen:",
        "value": "🔏"
    }, {
        "name": ":closed_lock_with_key:",
        "value": "🔐"
    }, {
        "name": ":key:",
        "value": "🔑"
    }, {
        "name": ":lock:",
        "value": "🔒"
    }, {
        "name": ":unlock:",
        "value": "🔓"
    }, {
        "name": ":bookmark:",
        "value": "🔖"
    }, {
        "name": ":link:",
        "value": "🔗"
    }, {
        "name": ":flashlight:",
        "value": "🔦"
    }, {
        "name": ":wrench:",
        "value": "🔧"
    }, {
        "name": ":hammer:",
        "value": "🔨"
    }, {
        "name": ":nut_and_bolt:",
        "value": "🔩"
    }, {
        "name": ":gun:",
        "value": "🔫"
    }, {
        "name": ":microscope:",
        "value": "🔬"
    }, {
        "name": ":telescope:",
        "value": "🔭"
    }, {
        "name": ":crystal_ball:",
        "value": "🔮"
    }, {
        "name": ":candle:",
        "value": "🕯"
    }, {
        "name": ":mantelpiece_clock:",
        "value": "🕰"
    }, {
        "name": ":linked_paperclips:",
        "value": "🖇"
    }, {
        "name": ":lower_left_ballpoint_pen:",
        "value": "🖊"
    }, {
        "name": ":lower_left_fountain_pen:",
        "value": "🖋"
    }, {
        "name": ":lower_left_paintbrush:",
        "value": "🖌"
    }, {
        "name": ":lower_left_crayon:",
        "value": "🖍"
    }, {
        "name": ":desktop_computer:",
        "value": "🖥"
    }, {
        "name": ":printer:",
        "value": "🖨"
    }, {
        "name": ":three_button_mouse:",
        "value": "🖱"
    }, {
        "name": ":trackball:",
        "value": "🖲"
    }, {
        "name": ":card_index_dividers:",
        "value": "🗂"
    }, {
        "name": ":card_file_box:",
        "value": "🗃"
    }, {
        "name": ":file_cabinet:",
        "value": "🗄"
    }, {
        "name": ":wastebasket:",
        "value": "🗑"
    }, {
        "name": ":spiral_note_pad:",
        "value": "🗒"
    }, {
        "name": ":spiral_calendar_pad:",
        "value": "🗓"
    }, {
        "name": ":compression:",
        "value": "🗜"
    }, {
        "name": ":old_key:",
        "value": "🗝"
    }, {
        "name": ":rolled_up_newspaper:",
        "value": "🗞"
    }, {
        "name": ":dagger_knife:",
        "value": "🗡"
    }, {
        "name": ":ballot_box_with_ballot:",
        "value": "🗳"
    }, {
        "name": ":moyai:",
        "value": "🗿"
    }, {
        "name": ":door:",
        "value": "🚪"
    }, {
        "name": ":smoking:",
        "value": "🚬"
    }, {
        "name": ":toilet:",
        "value": "🚽"
    }, {
        "name": ":shower:",
        "value": "🚿"
    }, {
        "name": ":bath:",
        "value": "🛀"
    }, {
        "name": ":bathtub:",
        "value": "🛁"
    }, {
        "name": ":couch_and_lamp:",
        "value": "🛋"
    }, {
        "name": ":sleeping_accommodation:",
        "value": "🛌"
    }, {
        "name": ":bellhop_bell:",
        "value": "🛎"
    }, {
        "name": ":bed:",
        "value": "🛏"
    }, {
        "name": ":hammer_and_wrench:",
        "value": "🛠"
    }, {
        "name": ":shield:",
        "value": "🛡"
    }, {
        "name": ":oil_drum:",
        "value": "🛢"
    }],
    "Symbols": [{
        "name": ":copyright:",
        "value": "©"
    }, {
        "name": ":registered:",
        "value": "®"
    }, {
        "name": ":bangbang:",
        "value": "‼"
    }, {
        "name": ":interrobang:",
        "value": "⁉"
    }, {
        "name": ":tm:",
        "value": "™"
    }, {
        "name": ":information_source:",
        "value": "ℹ"
    }, {
        "name": ":left_right_arrow:",
        "value": "↔"
    }, {
        "name": ":arrow_up_down:",
        "value": "↕"
    }, {
        "name": ":arrow_upper_left:",
        "value": "↖"
    }, {
        "name": ":arrow_upper_right:",
        "value": "↗"
    }, {
        "name": ":arrow_lower_right:",
        "value": "↘"
    }, {
        "name": ":arrow_lower_left:",
        "value": "↙"
    }, {
        "name": ":leftwards_arrow_with_hook:",
        "value": "↩"
    }, {
        "name": ":arrow_right_hook:",
        "value": "↪"
    }, {
        "name": ":eject:",
        "value": "⏏"
    }, {
        "name": ":fast_forward:",
        "value": "⏩"
    }, {
        "name": ":rewind:",
        "value": "⏪"
    }, {
        "name": ":arrow_double_up:",
        "value": "⏫"
    }, {
        "name": ":arrow_double_down:",
        "value": "⏬"
    }, {
        "name": ":black_right_pointing_double_triangle_with_vertical_bar:",
        "value": "⏭"
    }, {
        "name": ":black_left_pointing_double_triangle_with_vertical_bar:",
        "value": "⏮"
    }, {
        "name": ":black_right_pointing_triangle_with_double_vertical_bar:",
        "value": "⏯"
    }, {
        "name": ":double_vertical_bar:",
        "value": "⏸"
    }, {
        "name": ":black_square_for_stop:",
        "value": "⏹"
    }, {
        "name": ":black_circle_for_record:",
        "value": "⏺"
    }, {
        "name": ":m:",
        "value": "Ⓜ"
    }, {
        "name": ":black_small_square:",
        "value": "▪"
    }, {
        "name": ":white_small_square:",
        "value": "▫"
    }, {
        "name": ":arrow_forward:",
        "value": "▶"
    }, {
        "name": ":arrow_backward:",
        "value": "◀"
    }, {
        "name": ":white_medium_square:",
        "value": "◻"
    }, {
        "name": ":black_medium_square:",
        "value": "◼"
    }, {
        "name": ":white_medium_small_square:",
        "value": "◽"
    }, {
        "name": ":black_medium_small_square:",
        "value": "◾"
    }, {
        "name": ":ballot_box_with_check:",
        "value": "☑"
    }, {
        "name": ":radioactive_sign:",
        "value": "☢"
    }, {
        "name": ":biohazard_sign:",
        "value": "☣"
    }, {
        "name": ":orthodox_cross:",
        "value": "☦"
    }, {
        "name": ":star_and_crescent:",
        "value": "☪"
    }, {
        "name": ":peace_symbol:",
        "value": "☮"
    }, {
        "name": ":yin_yang:",
        "value": "☯"
    }, {
        "name": ":wheel_of_dharma:",
        "value": "☸"
    }, {
        "name": ":aries:",
        "value": "♈"
    }, {
        "name": ":taurus:",
        "value": "♉"
    }, {
        "name": ":gemini:",
        "value": "♊"
    }, {
        "name": ":cancer:",
        "value": "♋"
    }, {
        "name": ":leo:",
        "value": "♌"
    }, {
        "name": ":virgo:",
        "value": "♍"
    }, {
        "name": ":libra:",
        "value": "♎"
    }, {
        "name": ":scorpius:",
        "value": "♏"
    }, {
        "name": ":sagittarius:",
        "value": "♐"
    }, {
        "name": ":capricorn:",
        "value": "♑"
    }, {
        "name": ":aquarius:",
        "value": "♒"
    }, {
        "name": ":pisces:",
        "value": "♓"
    }, {
        "name": ":recycle:",
        "value": "♻"
    }, {
        "name": ":wheelchair:",
        "value": "♿"
    }, {
        "name": ":atom_symbol:",
        "value": "⚛"
    }, {
        "name": ":fleur_de_lis:",
        "value": "⚜"
    }, {
        "name": ":warning:",
        "value": "⚠"
    }, {
        "name": ":white_circle:",
        "value": "⚪"
    }, {
        "name": ":black_circle:",
        "value": "⚫"
    }, {
        "name": ":ophiuchus:",
        "value": "⛎"
    }, {
        "name": ":no_entry:",
        "value": "⛔"
    }, {
        "name": ":white_check_mark:",
        "value": "✅"
    }, {
        "name": ":heavy_check_mark:",
        "value": "✔"
    }, {
        "name": ":heavy_multiplication_x:",
        "value": "✖"
    }, {
        "name": ":latin_cross:",
        "value": "✝"
    }, {
        "name": ":star_of_david:",
        "value": "✡"
    }, {
        "name": ":eight_spoked_asterisk:",
        "value": "✳"
    }, {
        "name": ":eight_pointed_black_star:",
        "value": "✴"
    }, {
        "name": ":sparkle:",
        "value": "❇"
    }, {
        "name": ":x:",
        "value": "❌"
    }, {
        "name": ":negative_squared_cross_mark:",
        "value": "❎"
    }, {
        "name": ":question:",
        "value": "❓"
    }, {
        "name": ":grey_question:",
        "value": "❔"
    }, {
        "name": ":grey_exclamation:",
        "value": "❕"
    }, {
        "name": ":exclamation:",
        "value": "❗"
    }, {
        "name": ":heavy_heart_exclamation_mark_ornament:",
        "value": "❣"
    }, {
        "name": ":heart:",
        "value": "❤"
    }, {
        "name": ":heavy_plus_sign:",
        "value": "➕"
    }, {
        "name": ":heavy_minus_sign:",
        "value": "➖"
    }, {
        "name": ":heavy_division_sign:",
        "value": "➗"
    }, {
        "name": ":arrow_right:",
        "value": "➡"
    }, {
        "name": ":curly_loop:",
        "value": "➰"
    }, {
        "name": ":loop:",
        "value": "➿"
    }, {
        "name": ":arrow_heading_up:",
        "value": "⤴"
    }, {
        "name": ":arrow_heading_down:",
        "value": "⤵"
    }, {
        "name": ":arrow_left:",
        "value": "⬅"
    }, {
        "name": ":arrow_up:",
        "value": "⬆"
    }, {
        "name": ":arrow_down:",
        "value": "⬇"
    }, {
        "name": ":black_large_square:",
        "value": "⬛"
    }, {
        "name": ":white_large_square:",
        "value": "⬜"
    }, {
        "name": ":o:",
        "value": "⭕"
    }, {
        "name": ":wavy_dash:",
        "value": "〰"
    }, {
        "name": ":part_alternation_mark:",
        "value": "〽"
    }, {
        "name": ":congratulations:",
        "value": "㊗"
    }, {
        "name": ":secret:",
        "value": "㊙"
    }, {
        "name": ":a:",
        "value": "🅰"
    }, {
        "name": ":b:",
        "value": "🅱"
    }, {
        "name": ":o2:",
        "value": "🅾"
    }, {
        "name": ":parking:",
        "value": "🅿"
    }, {
        "name": ":ab:",
        "value": "🆎"
    }, {
        "name": ":cl:",
        "value": "🆑"
    }, {
        "name": ":cool:",
        "value": "🆒"
    }, {
        "name": ":free:",
        "value": "🆓"
    }, {
        "name": ":id:",
        "value": "🆔"
    }, {
        "name": ":new:",
        "value": "🆕"
    }, {
        "name": ":ng:",
        "value": "🆖"
    }, {
        "name": ":ok:",
        "value": "🆗"
    }, {
        "name": ":sos:",
        "value": "🆘"
    }, {
        "name": ":up:",
        "value": "🆙"
    }, {
        "name": ":vs:",
        "value": "🆚"
    }, {
        "name": ":koko:",
        "value": "🈁"
    }, {
        "name": ":sa:",
        "value": "🈂"
    }, {
        "name": ":u7121:",
        "value": "🈚"
    }, {
        "name": ":u6307:",
        "value": "🈯"
    }, {
        "name": ":u7981:",
        "value": "🈲"
    }, {
        "name": ":u7a7a:",
        "value": "🈳"
    }, {
        "name": ":u5408:",
        "value": "🈴"
    }, {
        "name": ":u6e80:",
        "value": "🈵"
    }, {
        "name": ":u6709:",
        "value": "🈶"
    }, {
        "name": ":u6708:",
        "value": "🈷"
    }, {
        "name": ":u7533:",
        "value": "🈸"
    }, {
        "name": ":u5272:",
        "value": "🈹"
    }, {
        "name": ":u55b6:",
        "value": "🈺"
    }, {
        "name": ":ideograph_advantage:",
        "value": "🉐"
    }, {
        "name": ":accept:",
        "value": "🉑"
    }, {
        "name": ":crossed_flags:",
        "value": "🎌"
    }, {
        "name": ":cinema:",
        "value": "🎦"
    }, {
        "name": ":checkered_flag:",
        "value": "🏁"
    }, {
        "name": ":atm:",
        "value": "🏧"
    }, {
        "name": ":waving_white_flag:",
        "value": "🏳"
    }, {
        "name": ":waving_black_flag:",
        "value": "🏴"
    }, {
        "name": ":heartbeat:",
        "value": "💓"
    }, {
        "name": ":broken_heart:",
        "value": "💔"
    }, {
        "name": ":two_hearts:",
        "value": "💕"
    }, {
        "name": ":sparkling_heart:",
        "value": "💖"
    }, {
        "name": ":heartpulse:",
        "value": "💗"
    }, {
        "name": ":cupid:",
        "value": "💘"
    }, {
        "name": ":blue_heart:",
        "value": "💙"
    }, {
        "name": ":green_heart:",
        "value": "💚"
    }, {
        "name": ":yellow_heart:",
        "value": "💛"
    }, {
        "name": ":purple_heart:",
        "value": "💜"
    }, {
        "name": ":gift_heart:",
        "value": "💝"
    }, {
        "name": ":revolving_hearts:",
        "value": "💞"
    }, {
        "name": ":heart_decoration:",
        "value": "💟"
    }, {
        "name": ":diamond_shape_with_a_dot_inside:",
        "value": "💠"
    }, {
        "name": ":speech_balloon:",
        "value": "💬"
    }, {
        "name": ":thought_balloon:",
        "value": "💭"
    }, {
        "name": ":100:",
        "value": "💯"
    }, {
        "name": ":name_badge:",
        "value": "📛"
    }, {
        "name": ":loudspeaker:",
        "value": "📢"
    }, {
        "name": ":mega:",
        "value": "📣"
    }, {
        "name": ":postal_horn:",
        "value": "📯"
    }, {
        "name": ":vibration_mode:",
        "value": "📳"
    }, {
        "name": ":mobile_phone_off:",
        "value": "📴"
    }, {
        "name": ":no_mobile_phones:",
        "value": "📵"
    }, {
        "name": ":signal_strength:",
        "value": "📶"
    }, {
        "name": ":twisted_rightwards_arrows:",
        "value": "🔀"
    }, {
        "name": ":repeat:",
        "value": "🔁"
    }, {
        "name": ":repeat_one:",
        "value": "🔂"
    }, {
        "name": ":arrows_clockwise:",
        "value": "🔃"
    }, {
        "name": ":arrows_counterclockwise:",
        "value": "🔄"
    }, {
        "name": ":low_brightness:",
        "value": "🔅"
    }, {
        "name": ":high_brightness:",
        "value": "🔆"
    }, {
        "name": ":mute:",
        "value": "🔇"
    }, {
        "name": ":speaker:",
        "value": "🔈"
    }, {
        "name": ":sound:",
        "value": "🔉"
    }, {
        "name": ":loud_sound:",
        "value": "🔊"
    }, {
        "name": ":bell:",
        "value": "🔔"
    }, {
        "name": ":no_bell:",
        "value": "🔕"
    }, {
        "name": ":radio_button:",
        "value": "🔘"
    }, {
        "name": ":back:",
        "value": "🔙"
    }, {
        "name": ":end:",
        "value": "🔚"
    }, {
        "name": ":on:",
        "value": "🔛"
    }, {
        "name": ":soon:",
        "value": "🔜"
    }, {
        "name": ":top:",
        "value": "🔝"
    }, {
        "name": ":underage:",
        "value": "🔞"
    }, {
        "name": ":keycap_ten:",
        "value": "🔟"
    }, {
        "name": ":capital_abcd:",
        "value": "🔠"
    }, {
        "name": ":abcd:",
        "value": "🔡"
    }, {
        "name": ":1234:",
        "value": "🔢"
    }, {
        "name": ":symbols:",
        "value": "🔣"
    }, {
        "name": ":abc:",
        "value": "🔤"
    }, {
        "name": ":six_pointed_star:",
        "value": "🔯"
    }, {
        "name": ":beginner:",
        "value": "🔰"
    }, {
        "name": ":trident:",
        "value": "🔱"
    }, {
        "name": ":black_square_button:",
        "value": "🔲"
    }, {
        "name": ":white_square_button:",
        "value": "🔳"
    }, {
        "name": ":red_circle:",
        "value": "🔴"
    }, {
        "name": ":large_blue_circle:",
        "value": "🔵"
    }, {
        "name": ":large_orange_diamond:",
        "value": "🔶"
    }, {
        "name": ":large_blue_diamond:",
        "value": "🔷"
    }, {
        "name": ":small_orange_diamond:",
        "value": "🔸"
    }, {
        "name": ":small_blue_diamond:",
        "value": "🔹"
    }, {
        "name": ":small_red_triangle:",
        "value": "🔺"
    }, {
        "name": ":small_red_triangle_down:",
        "value": "🔻"
    }, {
        "name": ":arrow_up_small:",
        "value": "🔼"
    }, {
        "name": ":arrow_down_small:",
        "value": "🔽"
    }, {
        "name": ":om_symbol:",
        "value": "🕉"
    }, {
        "name": ":menorah_with_nine_branches:",
        "value": "🕎"
    }, {
        "name": ":clock1:",
        "value": "🕐"
    }, {
        "name": ":clock2:",
        "value": "🕑"
    }, {
        "name": ":clock3:",
        "value": "🕒"
    }, {
        "name": ":clock4:",
        "value": "🕓"
    }, {
        "name": ":clock5:",
        "value": "🕔"
    }, {
        "name": ":clock6:",
        "value": "🕕"
    }, {
        "name": ":clock7:",
        "value": "🕖"
    }, {
        "name": ":clock8:",
        "value": "🕗"
    }, {
        "name": ":clock9:",
        "value": "🕘"
    }, {
        "name": ":clock10:",
        "value": "🕙"
    }, {
        "name": ":clock11:",
        "value": "🕚"
    }, {
        "name": ":clock12:",
        "value": "🕛"
    }, {
        "name": ":clock130:",
        "value": "🕜"
    }, {
        "name": ":clock230:",
        "value": "🕝"
    }, {
        "name": ":clock330:",
        "value": "🕞"
    }, {
        "name": ":clock430:",
        "value": "🕟"
    }, {
        "name": ":clock530:",
        "value": "🕠"
    }, {
        "name": ":clock630:",
        "value": "🕡"
    }, {
        "name": ":clock730:",
        "value": "🕢"
    }, {
        "name": ":clock830:",
        "value": "🕣"
    }, {
        "name": ":clock930:",
        "value": "🕤"
    }, {
        "name": ":clock1030:",
        "value": "🕥"
    }, {
        "name": ":clock1130:",
        "value": "🕦"
    }, {
        "name": ":clock1230:",
        "value": "🕧"
    }, {
        "name": ":left_speech_bubble:",
        "value": "🗨"
    }, {
        "name": ":right_anger_bubble:",
        "value": "🗯"
    }, {
        "name": ":triangular_flag_on_post:",
        "value": "🚩"
    }, {
        "name": ":no_entry_sign:",
        "value": "🚫"
    }, {
        "name": ":no_smoking:",
        "value": "🚭"
    }, {
        "name": ":put_litter_in_its_place:",
        "value": "🚮"
    }, {
        "name": ":do_not_litter:",
        "value": "🚯"
    }, {
        "name": ":potable_water:",
        "value": "🚰"
    }, {
        "name": ":non-potable_water:",
        "value": "🚱"
    }, {
        "name": ":no_bicycles:",
        "value": "🚳"
    }, {
        "name": ":no_pedestrians:",
        "value": "🚷"
    }, {
        "name": ":children_crossing:",
        "value": "🚸"
    }, {
        "name": ":mens:",
        "value": "🚹"
    }, {
        "name": ":womens:",
        "value": "🚺"
    }, {
        "name": ":restroom:",
        "value": "🚻"
    }, {
        "name": ":baby_symbol:",
        "value": "🚼"
    }, {
        "name": ":wc:",
        "value": "🚾"
    }, {
        "name": ":passport_control:",
        "value": "🛂"
    }, {
        "name": ":customs:",
        "value": "🛃"
    }, {
        "name": ":baggage_claim:",
        "value": "🛄"
    }, {
        "name": ":left_luggage:",
        "value": "🛅"
    }, {
        "name": ":place_of_worship:",
        "value": "🛐"
    }],
    "Flags": [{
        "name": ":flag-ac:",
        "value": "🇦🇨"
    }, {
        "name": ":flag-ad:",
        "value": "🇦🇩"
    }, {
        "name": ":flag-ae:",
        "value": "🇦🇪"
    }, {
        "name": ":flag-af:",
        "value": "🇦🇫"
    }, {
        "name": ":flag-ag:",
        "value": "🇦🇬"
    }, {
        "name": ":flag-ai:",
        "value": "🇦🇮"
    }, {
        "name": ":flag-al:",
        "value": "🇦🇱"
    }, {
        "name": ":flag-am:",
        "value": "🇦🇲"
    }, {
        "name": ":flag-ao:",
        "value": "🇦🇴"
    }, {
        "name": ":flag-aq:",
        "value": "🇦🇶"
    }, {
        "name": ":flag-ar:",
        "value": "🇦🇷"
    }, {
        "name": ":flag-as:",
        "value": "🇦🇸"
    }, {
        "name": ":flag-at:",
        "value": "🇦🇹"
    }, {
        "name": ":flag-au:",
        "value": "🇦🇺"
    }, {
        "name": ":flag-aw:",
        "value": "🇦🇼"
    }, {
        "name": ":flag-ax:",
        "value": "🇦🇽"
    }, {
        "name": ":flag-az:",
        "value": "🇦🇿"
    }, {
        "name": ":flag-ba:",
        "value": "🇧🇦"
    }, {
        "name": ":flag-bb:",
        "value": "🇧🇧"
    }, {
        "name": ":flag-bd:",
        "value": "🇧🇩"
    }, {
        "name": ":flag-be:",
        "value": "🇧🇪"
    }, {
        "name": ":flag-bf:",
        "value": "🇧🇫"
    }, {
        "name": ":flag-bg:",
        "value": "🇧🇬"
    }, {
        "name": ":flag-bh:",
        "value": "🇧🇭"
    }, {
        "name": ":flag-bi:",
        "value": "🇧🇮"
    }, {
        "name": ":flag-bj:",
        "value": "🇧🇯"
    }, {
        "name": ":flag-bl:",
        "value": "🇧🇱"
    }, {
        "name": ":flag-bm:",
        "value": "🇧🇲"
    }, {
        "name": ":flag-bn:",
        "value": "🇧🇳"
    }, {
        "name": ":flag-bo:",
        "value": "🇧🇴"
    }, {
        "name": ":flag-bq:",
        "value": "🇧🇶"
    }, {
        "name": ":flag-br:",
        "value": "🇧🇷"
    }, {
        "name": ":flag-bs:",
        "value": "🇧🇸"
    }, {
        "name": ":flag-bt:",
        "value": "🇧🇹"
    }, {
        "name": ":flag-bv:",
        "value": "🇧🇻"
    }, {
        "name": ":flag-bw:",
        "value": "🇧🇼"
    }, {
        "name": ":flag-by:",
        "value": "🇧🇾"
    }, {
        "name": ":flag-bz:",
        "value": "🇧🇿"
    }, {
        "name": ":flag-ca:",
        "value": "🇨🇦"
    }, {
        "name": ":flag-cc:",
        "value": "🇨🇨"
    }, {
        "name": ":flag-cd:",
        "value": "🇨🇩"
    }, {
        "name": ":flag-cf:",
        "value": "🇨🇫"
    }, {
        "name": ":flag-cg:",
        "value": "🇨🇬"
    }, {
        "name": ":flag-ch:",
        "value": "🇨🇭"
    }, {
        "name": ":flag-ci:",
        "value": "🇨🇮"
    }, {
        "name": ":flag-ck:",
        "value": "🇨🇰"
    }, {
        "name": ":flag-cl:",
        "value": "🇨🇱"
    }, {
        "name": ":flag-cm:",
        "value": "🇨🇲"
    }, {
        "name": ":flag-cn:",
        "value": "🇨🇳"
    }, {
        "name": ":flag-co:",
        "value": "🇨🇴"
    }, {
        "name": ":flag-cp:",
        "value": "🇨🇵"
    }, {
        "name": ":flag-cr:",
        "value": "🇨🇷"
    }, {
        "name": ":flag-cu:",
        "value": "🇨🇺"
    }, {
        "name": ":flag-cv:",
        "value": "🇨🇻"
    }, {
        "name": ":flag-cw:",
        "value": "🇨🇼"
    }, {
        "name": ":flag-cx:",
        "value": "🇨🇽"
    }, {
        "name": ":flag-cy:",
        "value": "🇨🇾"
    }, {
        "name": ":flag-cz:",
        "value": "🇨🇿"
    }, {
        "name": ":flag-de:",
        "value": "🇩🇪"
    }, {
        "name": ":flag-dg:",
        "value": "🇩🇬"
    }, {
        "name": ":flag-dj:",
        "value": "🇩🇯"
    }, {
        "name": ":flag-dk:",
        "value": "🇩🇰"
    }, {
        "name": ":flag-dm:",
        "value": "🇩🇲"
    }, {
        "name": ":flag-do:",
        "value": "🇩🇴"
    }, {
        "name": ":flag-dz:",
        "value": "🇩🇿"
    }, {
        "name": ":flag-ea:",
        "value": "🇪🇦"
    }, {
        "name": ":flag-ec:",
        "value": "🇪🇨"
    }, {
        "name": ":flag-ee:",
        "value": "🇪🇪"
    }, {
        "name": ":flag-eg:",
        "value": "🇪🇬"
    }, {
        "name": ":flag-eh:",
        "value": "🇪🇭"
    }, {
        "name": ":flag-er:",
        "value": "🇪🇷"
    }, {
        "name": ":flag-es:",
        "value": "🇪🇸"
    }, {
        "name": ":flag-et:",
        "value": "🇪🇹"
    }, {
        "name": ":flag-eu:",
        "value": "🇪🇺"
    }, {
        "name": ":flag-fi:",
        "value": "🇫🇮"
    }, {
        "name": ":flag-fj:",
        "value": "🇫🇯"
    }, {
        "name": ":flag-fk:",
        "value": "🇫🇰"
    }, {
        "name": ":flag-fm:",
        "value": "🇫🇲"
    }, {
        "name": ":flag-fo:",
        "value": "🇫🇴"
    }, {
        "name": ":flag-fr:",
        "value": "🇫🇷"
    }, {
        "name": ":flag-ga:",
        "value": "🇬🇦"
    }, {
        "name": ":flag-gb:",
        "value": "🇬🇧"
    }, {
        "name": ":flag-gd:",
        "value": "🇬🇩"
    }, {
        "name": ":flag-ge:",
        "value": "🇬🇪"
    }, {
        "name": ":flag-gf:",
        "value": "🇬🇫"
    }, {
        "name": ":flag-gg:",
        "value": "🇬🇬"
    }, {
        "name": ":flag-gh:",
        "value": "🇬🇭"
    }, {
        "name": ":flag-gi:",
        "value": "🇬🇮"
    }, {
        "name": ":flag-gl:",
        "value": "🇬🇱"
    }, {
        "name": ":flag-gm:",
        "value": "🇬🇲"
    }, {
        "name": ":flag-gn:",
        "value": "🇬🇳"
    }, {
        "name": ":flag-gp:",
        "value": "🇬🇵"
    }, {
        "name": ":flag-gq:",
        "value": "🇬🇶"
    }, {
        "name": ":flag-gr:",
        "value": "🇬🇷"
    }, {
        "name": ":flag-gs:",
        "value": "🇬🇸"
    }, {
        "name": ":flag-gt:",
        "value": "🇬🇹"
    }, {
        "name": ":flag-gu:",
        "value": "🇬🇺"
    }, {
        "name": ":flag-gw:",
        "value": "🇬🇼"
    }, {
        "name": ":flag-gy:",
        "value": "🇬🇾"
    }, {
        "name": ":flag-hk:",
        "value": "🇭🇰"
    }, {
        "name": ":flag-hm:",
        "value": "🇭🇲"
    }, {
        "name": ":flag-hn:",
        "value": "🇭🇳"
    }, {
        "name": ":flag-hr:",
        "value": "🇭🇷"
    }, {
        "name": ":flag-ht:",
        "value": "🇭🇹"
    }, {
        "name": ":flag-hu:",
        "value": "🇭🇺"
    }, {
        "name": ":flag-ic:",
        "value": "🇮🇨"
    }, {
        "name": ":flag-id:",
        "value": "🇮🇩"
    }, {
        "name": ":flag-ie:",
        "value": "🇮🇪"
    }, {
        "name": ":flag-il:",
        "value": "🇮🇱"
    }, {
        "name": ":flag-im:",
        "value": "🇮🇲"
    }, {
        "name": ":flag-in:",
        "value": "🇮🇳"
    }, {
        "name": ":flag-io:",
        "value": "🇮🇴"
    }, {
        "name": ":flag-iq:",
        "value": "🇮🇶"
    }, {
        "name": ":flag-ir:",
        "value": "🇮🇷"
    }, {
        "name": ":flag-is:",
        "value": "🇮🇸"
    }, {
        "name": ":flag-it:",
        "value": "🇮🇹"
    }, {
        "name": ":flag-je:",
        "value": "🇯🇪"
    }, {
        "name": ":flag-jm:",
        "value": "🇯🇲"
    }, {
        "name": ":flag-jo:",
        "value": "🇯🇴"
    }, {
        "name": ":flag-jp:",
        "value": "🇯🇵"
    }, {
        "name": ":flag-ke:",
        "value": "🇰🇪"
    }, {
        "name": ":flag-kg:",
        "value": "🇰🇬"
    }, {
        "name": ":flag-kh:",
        "value": "🇰🇭"
    }, {
        "name": ":flag-ki:",
        "value": "🇰🇮"
    }, {
        "name": ":flag-km:",
        "value": "🇰🇲"
    }, {
        "name": ":flag-kn:",
        "value": "🇰🇳"
    }, {
        "name": ":flag-kp:",
        "value": "🇰🇵"
    }, {
        "name": ":flag-kr:",
        "value": "🇰🇷"
    }, {
        "name": ":flag-kw:",
        "value": "🇰🇼"
    }, {
        "name": ":flag-ky:",
        "value": "🇰🇾"
    }, {
        "name": ":flag-kz:",
        "value": "🇰🇿"
    }, {
        "name": ":flag-la:",
        "value": "🇱🇦"
    }, {
        "name": ":flag-lb:",
        "value": "🇱🇧"
    }, {
        "name": ":flag-lc:",
        "value": "🇱🇨"
    }, {
        "name": ":flag-li:",
        "value": "🇱🇮"
    }, {
        "name": ":flag-lk:",
        "value": "🇱🇰"
    }, {
        "name": ":flag-lr:",
        "value": "🇱🇷"
    }, {
        "name": ":flag-ls:",
        "value": "🇱🇸"
    }, {
        "name": ":flag-lt:",
        "value": "🇱🇹"
    }, {
        "name": ":flag-lu:",
        "value": "🇱🇺"
    }, {
        "name": ":flag-lv:",
        "value": "🇱🇻"
    }, {
        "name": ":flag-ly:",
        "value": "🇱🇾"
    }, {
        "name": ":flag-ma:",
        "value": "🇲🇦"
    }, {
        "name": ":flag-mc:",
        "value": "🇲🇨"
    }, {
        "name": ":flag-md:",
        "value": "🇲🇩"
    }, {
        "name": ":flag-me:",
        "value": "🇲🇪"
    }, {
        "name": ":flag-mf:",
        "value": "🇲🇫"
    }, {
        "name": ":flag-mg:",
        "value": "🇲🇬"
    }, {
        "name": ":flag-mh:",
        "value": "🇲🇭"
    }, {
        "name": ":flag-mk:",
        "value": "🇲🇰"
    }, {
        "name": ":flag-ml:",
        "value": "🇲🇱"
    }, {
        "name": ":flag-mm:",
        "value": "🇲🇲"
    }, {
        "name": ":flag-mn:",
        "value": "🇲🇳"
    }, {
        "name": ":flag-mo:",
        "value": "🇲🇴"
    }, {
        "name": ":flag-mp:",
        "value": "🇲🇵"
    }, {
        "name": ":flag-mq:",
        "value": "🇲🇶"
    }, {
        "name": ":flag-mr:",
        "value": "🇲🇷"
    }, {
        "name": ":flag-ms:",
        "value": "🇲🇸"
    }, {
        "name": ":flag-mt:",
        "value": "🇲🇹"
    }, {
        "name": ":flag-mu:",
        "value": "🇲🇺"
    }, {
        "name": ":flag-mv:",
        "value": "🇲🇻"
    }, {
        "name": ":flag-mw:",
        "value": "🇲🇼"
    }, {
        "name": ":flag-mx:",
        "value": "🇲🇽"
    }, {
        "name": ":flag-my:",
        "value": "🇲🇾"
    }, {
        "name": ":flag-mz:",
        "value": "🇲🇿"
    }, {
        "name": ":flag-na:",
        "value": "🇳🇦"
    }, {
        "name": ":flag-nc:",
        "value": "🇳🇨"
    }, {
        "name": ":flag-ne:",
        "value": "🇳🇪"
    }, {
        "name": ":flag-nf:",
        "value": "🇳🇫"
    }, {
        "name": ":flag-ng:",
        "value": "🇳🇬"
    }, {
        "name": ":flag-ni:",
        "value": "🇳🇮"
    }, {
        "name": ":flag-nl:",
        "value": "🇳🇱"
    }, {
        "name": ":flag-no:",
        "value": "🇳🇴"
    }, {
        "name": ":flag-np:",
        "value": "🇳🇵"
    }, {
        "name": ":flag-nr:",
        "value": "🇳🇷"
    }, {
        "name": ":flag-nu:",
        "value": "🇳🇺"
    }, {
        "name": ":flag-nz:",
        "value": "🇳🇿"
    }, {
        "name": ":flag-om:",
        "value": "🇴🇲"
    }, {
        "name": ":flag-pa:",
        "value": "🇵🇦"
    }, {
        "name": ":flag-pe:",
        "value": "🇵🇪"
    }, {
        "name": ":flag-pf:",
        "value": "🇵🇫"
    }, {
        "name": ":flag-pg:",
        "value": "🇵🇬"
    }, {
        "name": ":flag-ph:",
        "value": "🇵🇭"
    }, {
        "name": ":flag-pk:",
        "value": "🇵🇰"
    }, {
        "name": ":flag-pl:",
        "value": "🇵🇱"
    }, {
        "name": ":flag-pm:",
        "value": "🇵🇲"
    }, {
        "name": ":flag-pn:",
        "value": "🇵🇳"
    }, {
        "name": ":flag-pr:",
        "value": "🇵🇷"
    }, {
        "name": ":flag-ps:",
        "value": "🇵🇸"
    }, {
        "name": ":flag-pt:",
        "value": "🇵🇹"
    }, {
        "name": ":flag-pw:",
        "value": "🇵🇼"
    }, {
        "name": ":flag-py:",
        "value": "🇵🇾"
    }, {
        "name": ":flag-qa:",
        "value": "🇶🇦"
    }, {
        "name": ":flag-re:",
        "value": "🇷🇪"
    }, {
        "name": ":flag-ro:",
        "value": "🇷🇴"
    }, {
        "name": ":flag-rs:",
        "value": "🇷🇸"
    }, {
        "name": ":flag-ru:",
        "value": "🇷🇺"
    }, {
        "name": ":flag-rw:",
        "value": "🇷🇼"
    }, {
        "name": ":flag-sa:",
        "value": "🇸🇦"
    }, {
        "name": ":flag-sb:",
        "value": "🇸🇧"
    }, {
        "name": ":flag-sc:",
        "value": "🇸🇨"
    }, {
        "name": ":flag-sd:",
        "value": "🇸🇩"
    }, {
        "name": ":flag-se:",
        "value": "🇸🇪"
    }, {
        "name": ":flag-sg:",
        "value": "🇸🇬"
    }, {
        "name": ":flag-sh:",
        "value": "🇸🇭"
    }, {
        "name": ":flag-si:",
        "value": "🇸🇮"
    }, {
        "name": ":flag-sj:",
        "value": "🇸🇯"
    }, {
        "name": ":flag-sk:",
        "value": "🇸🇰"
    }, {
        "name": ":flag-sl:",
        "value": "🇸🇱"
    }, {
        "name": ":flag-sm:",
        "value": "🇸🇲"
    }, {
        "name": ":flag-sn:",
        "value": "🇸🇳"
    }, {
        "name": ":flag-so:",
        "value": "🇸🇴"
    }, {
        "name": ":flag-sr:",
        "value": "🇸🇷"
    }, {
        "name": ":flag-ss:",
        "value": "🇸🇸"
    }, {
        "name": ":flag-st:",
        "value": "🇸🇹"
    }, {
        "name": ":flag-sv:",
        "value": "🇸🇻"
    }, {
        "name": ":flag-sx:",
        "value": "🇸🇽"
    }, {
        "name": ":flag-sy:",
        "value": "🇸🇾"
    }, {
        "name": ":flag-sz:",
        "value": "🇸🇿"
    }, {
        "name": ":flag-ta:",
        "value": "🇹🇦"
    }, {
        "name": ":flag-tc:",
        "value": "🇹🇨"
    }, {
        "name": ":flag-td:",
        "value": "🇹🇩"
    }, {
        "name": ":flag-tf:",
        "value": "🇹🇫"
    }, {
        "name": ":flag-tg:",
        "value": "🇹🇬"
    }, {
        "name": ":flag-th:",
        "value": "🇹🇭"
    }, {
        "name": ":flag-tj:",
        "value": "🇹🇯"
    }, {
        "name": ":flag-tk:",
        "value": "🇹🇰"
    }, {
        "name": ":flag-tl:",
        "value": "🇹🇱"
    }, {
        "name": ":flag-tm:",
        "value": "🇹🇲"
    }, {
        "name": ":flag-tn:",
        "value": "🇹🇳"
    }, {
        "name": ":flag-to:",
        "value": "🇹🇴"
    }, {
        "name": ":flag-tr:",
        "value": "🇹🇷"
    }, {
        "name": ":flag-tt:",
        "value": "🇹🇹"
    }, {
        "name": ":flag-tv:",
        "value": "🇹🇻"
    }, {
        "name": ":flag-tw:",
        "value": "🇹🇼"
    }, {
        "name": ":flag-tz:",
        "value": "🇹🇿"
    }, {
        "name": ":flag-ua:",
        "value": "🇺🇦"
    }, {
        "name": ":flag-ug:",
        "value": "🇺🇬"
    }, {
        "name": ":flag-um:",
        "value": "🇺🇲"
    }, {
        "name": ":flag-us:",
        "value": "🇺🇸"
    }, {
        "name": ":flag-uy:",
        "value": "🇺🇾"
    }, {
        "name": ":flag-uz:",
        "value": "🇺🇿"
    }, {
        "name": ":flag-va:",
        "value": "🇻🇦"
    }, {
        "name": ":flag-vc:",
        "value": "🇻🇨"
    }, {
        "name": ":flag-ve:",
        "value": "🇻🇪"
    }, {
        "name": ":flag-vg:",
        "value": "🇻🇬"
    }, {
        "name": ":flag-vi:",
        "value": "🇻🇮"
    }, {
        "name": ":flag-vn:",
        "value": "🇻🇳"
    }, {
        "name": ":flag-vu:",
        "value": "🇻🇺"
    }, {
        "name": ":flag-wf:",
        "value": "🇼🇫"
    }, {
        "name": ":flag-ws:",
        "value": "🇼🇸"
    }, {
        "name": ":flag-xk:",
        "value": "🇽🇰"
    }, {
        "name": ":flag-ye:",
        "value": "🇾🇪"
    }, {
        "name": ":flag-yt:",
        "value": "🇾🇹"
    }, {
        "name": ":flag-za:",
        "value": "🇿🇦"
    }, {
        "name": ":flag-zm:",
        "value": "🇿🇲"
    }, {
        "name": ":flag-zw:",
        "value": "🇿🇼"
    }]
};

exports.default = HuEmoji;

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Config = __webpack_require__(3);

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *  buttons: {
 *    0: "Option 0",
 *    1: "Option 1",  
 *  }
 *  payloads: {...buttons},
 *  buttonsData: {
 *    dual_buttons: true,
 *    icons: {0: "none", 1: "none"},
 *    images: {0: "", 1: ""},
 *    includes: {0: "none", 1: "none"},
 *    multi: false,
 *    pile_up: false
 *  }
 */
var InputMenu = function (_React$Component) {
  _inherits(InputMenu, _React$Component);

  function InputMenu(props) {
    _classCallCheck(this, InputMenu);

    var _this = _possibleConstructorReturn(this, (InputMenu.__proto__ || Object.getPrototypeOf(InputMenu)).call(this, props));

    _this.state = {
      buttons: props.buttons,
      payloads: props.payloads,
      buttonsData: props.buttonsData,
      buttonSubmitHandler: props.buttonSubmitHandler,
      search_filter: '',
      filter_results: props.buttons instanceof Array ? props.buttons.map(function (b) {
        return b.toLowerCase();
      }) : Object.keys(props.buttons).map(function (b) {
        return props.buttons[b].toLowerCase();
      })
    };
    _this.buttonsContainer = null;
    return _this;
  }

  _createClass(InputMenu, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _props = this.props,
          buttons = _props.buttons,
          payloads = _props.payloads,
          buttonsData = _props.buttonsData;

      if (!this.compareObjects(buttons, nextProps.buttons) || !this.compareObjects(payloads, nextProps.payloads) || !this.compareObjects(buttonsData, nextProps.buttonsData)) return true;
      var _state = this.state,
          search_filter = _state.search_filter,
          filter_results = _state.filter_results;

      if (search_filter !== nextState.search_filter || !this.compareObjects(filter_results, nextState.filter_results)) return true;
      return false;
    }
  }, {
    key: 'compareObjects',
    value: function compareObjects(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    }
  }, {
    key: 'clickHandler',
    value: function clickHandler(index) {
      var _props2 = this.props,
          buttons = _props2.buttons,
          payloads = _props2.payloads;

      var _buttons = buttons instanceof Array ? buttons : Object.keys(buttons).map(function (b) {
        return buttons[b];
      });
      var _payloads = null;
      if (payloads) _payloads = payloads instanceof Array ? payloads : Object.keys(payloads).map(function (b) {
        return payloads[b];
      });else _payloads = buttons instanceof Array ? buttons : Object.keys(buttons).map(function (b) {
        return buttons[b];
      });
      this.props.buttonSubmitHandler(_buttons[index], _payloads[index]);
      var btn = this.buttonsContainer.querySelector('.menu-button[data-key="' + index + '"]');
      btn.className += ' clicked';
      btn.blur();
    }
  }, {
    key: 'onSearchInput',
    value: function onSearchInput(e) {
      this.setState({
        search_filter: e.target.value,
        filter_results: this.getMatches(e.target.value)
      });
    }
  }, {
    key: 'getMatches',
    value: function getMatches(value) {
      var buttons = this.props.buttons;

      var _buttons = buttons instanceof Array ? buttons.map(function (b) {
        return b.toLowerCase();
      }) : Object.keys(buttons).map(function (b) {
        return buttons[b].toLowerCase();
      });
      var matches = _buttons.filter(function (b) {
        return b.indexOf(value.toLowerCase()) > -1;
      });
      return matches;
    }
  }, {
    key: 'mountIncludes',
    value: function mountIncludes(key) {
      var _props$buttonsData = this.props.buttonsData,
          includes = _props$buttonsData.includes,
          icons = _props$buttonsData.icons,
          images = _props$buttonsData.images;

      if (includes) switch (includes[key]) {
        case 'icon':
          if (icons) return _react2.default.createElement(
            'div',
            { className: 'include-icon-container' },
            _react2.default.createElement('i', { className: 'fi ' + icons[key] })
          );else return null;
        case 'image':
          if (images) return _react2.default.createElement(
            'div',
            { className: 'include-image-container' },
            _react2.default.createElement('div', {
              className: 'include-image',
              style: 'background-image: url(' + images[key] + ')'
            })
          );else return null;
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          buttons = _props3.buttons,
          buttonsData = _props3.buttonsData;
      var _state2 = this.state,
          clicked = _state2.clicked,
          search_filter = _state2.search_filter,
          filter_results = _state2.filter_results;
      var dual = buttonsData.dual,
          pile_up = buttonsData.pile_up,
          search = buttonsData.search;

      var _buttons = buttons instanceof Array ? buttons : Object.keys(buttons).map(function (b) {
        return buttons[b];
      });
      var extra_classes = function extra_classes() {
        var classes = '';
        if (buttonsData.dual_buttons) classes = classes.concat(' dual');
        if (buttonsData.pile_up) classes = classes.concat(' pileup');
        return classes;
      };

      if (!search) return _react2.default.createElement(
        'div',
        { className: 'hu-input-menu' },
        _react2.default.createElement(
          'span',
          { className: 'hu-input-menu-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase' },
          _Config2.default.text.input_menu_help
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'hu-input-menu-buttons' + extra_classes(),
            ref: function ref(elem) {
              _this2.buttonsContainer = elem;
            }
          },
          _buttons.map(function (key, index) {
            return _react2.default.createElement(
              'button',
              {
                key: Math.random() // A different key forces update button and delete 'clicked' class
                , onClick: function onClick() {
                  _this2.clickHandler(index);
                },
                className: 'menu-button ' + (buttonsData.includes ? buttonsData.includes[index] : '') + ' hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark',
                'data-key': index,
                tabIndex: index + 1
              },
              _this2.mountIncludes(index),
              _react2.default.createElement(
                'span',
                { className: 'button-text' },
                key
              )
            );
          })
        )
      );else return _react2.default.createElement(
        'div',
        { className: 'hu-input-menu' },
        _react2.default.createElement(
          'span',
          { className: 'hu-input-menu-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase' },
          _Config2.default.text.input_instant_search_help
        ),
        _react2.default.createElement(
          'div',
          { className: 'hu-drop-search' },
          _react2.default.createElement(
            'div',
            { className: 'drop-search-input-container' },
            _react2.default.createElement('input', {
              className: 'drop-search-input hu-color_contrast hu-s-14',
              type: 'text',
              placeholder: _Config2.default.text.search,
              value: search_filter,
              onInput: function onInput(e) {
                return _this2.onSearchInput(e);
              }
            }),
            _react2.default.createElement('i', { className: 'fi magnification-lens hu-color_contrast' })
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'hu-input-menu-buttons' + extra_classes(),
              ref: function ref(elem) {
                _this2.buttonsContainer = elem;
              }
            },
            _buttons.map(function (key, index) {
              return filter_results.indexOf(key.toLowerCase()) > -1 && _react2.default.createElement(
                'button',
                {
                  key: Math.random() // A different key forces update button and delete 'clicked' class
                  , onClick: function onClick() {
                    _this2.clickHandler(index);
                  },
                  className: 'menu-button ' + (buttonsData.includes ? buttonsData.includes[index] : '') + ' hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark',
                  'data-key': index,
                  tabIndex: index + 1
                },
                _this2.mountIncludes(index),
                _react2.default.createElement(
                  'span',
                  { className: 'button-text' },
                  key
                )
              );
            })
          )
        )
      );
    }
  }]);

  return InputMenu;
}(_react2.default.Component);

exports.default = InputMenu;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Config = __webpack_require__(3);

var _Config2 = _interopRequireDefault(_Config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputMulti = function (_React$Component) {
  _inherits(InputMulti, _React$Component);

  function InputMulti(props) {
    _classCallCheck(this, InputMulti);

    var _this = _possibleConstructorReturn(this, (InputMulti.__proto__ || Object.getPrototypeOf(InputMulti)).call(this, props));

    _this.state = {
      buttons: props.buttons,
      payloads: props.payloads,
      buttonsData: props.buttonsData,
      buttonSubmitHandler: props.buttonSubmitHandler,
      checks: props.buttons instanceof Array ? props.buttons.map(function (b) {
        return false;
      }) : Object.keys(props.buttons).map(function (b) {
        return false;
      }),
      search_filter: '',
      filter_results: props.buttons instanceof Array ? props.buttons.map(function (b) {
        return b.toLowerCase();
      }) : Object.keys(props.buttons).map(function (b) {
        return props.buttons[b].toLowerCase();
      })
    };
    _this.checksContainer = null;
    _this.submitButton = null;
    return _this;
  }

  _createClass(InputMulti, [{
    key: 'clickHandler',
    value: function clickHandler(index) {
      var buttons = this.props.buttons;

      var checks = this.state.checks.slice();
      checks[index] = !checks[index];
      this.setState({
        checks: checks
      });
    }
  }, {
    key: 'submitHandler',
    value: function submitHandler() {
      var _props = this.props,
          buttons = _props.buttons,
          payloads = _props.payloads;
      var checks = this.state.checks;

      var _buttons = buttons instanceof Array ? buttons : Object.keys(buttons).map(function (b) {
        return buttons[b];
      });
      var _payloads = null;
      if (payloads) _payloads = payloads instanceof Array ? payloads : Object.keys(payloads).map(function (b) {
        return payloads[b];
      });else _payloads = buttons instanceof Array ? buttons : Object.keys(buttons).map(function (b) {
        return buttons[b];
      });
      this.props.buttonSubmitHandler(_buttons.filter(function (c, i) {
        return checks[i];
      }).join(', '), _payloads.filter(function (c, i) {
        return checks[i];
      }).join(', '));
    }
  }, {
    key: 'onSearchInput',
    value: function onSearchInput(e) {
      this.setState({
        search_filter: e.target.value,
        filter_results: this.getMatches(e.target.value)
      });
    }
  }, {
    key: 'getMatches',
    value: function getMatches(value) {
      var buttons = this.props.buttons;

      var _buttons = buttons instanceof Array ? buttons.map(function (b) {
        return b.toLowerCase();
      }) : Object.keys(buttons).map(function (b) {
        return buttons[b].toLowerCase();
      });
      var matches = _buttons.filter(function (b) {
        return b.indexOf(value.toLowerCase()) > -1;
      });
      return matches;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          buttons = _props2.buttons,
          buttonsData = _props2.buttonsData;
      var _state = this.state,
          checks = _state.checks,
          search_filter = _state.search_filter,
          filter_results = _state.filter_results;
      var search = buttonsData.search;

      var _buttons = buttons instanceof Array ? buttons : Object.keys(buttons).map(function (b) {
        return buttons[b];
      });
      var disabled = checks.every(function (c) {
        return !c;
      });

      var inputFooter = _react2.default.createElement(
        'div',
        { className: 'hu-input-multi-footer hu-a-center' },
        _react2.default.createElement(
          'button',
          {
            className: 'submit-button hu-background-color_button-background hu-color_button-text hu-border-color_button-text',
            onClick: this.submitHandler.bind(this),
            ref: function ref(elem) {
              _this2.submitButton = elem;
            },
            disabled: disabled
          },
          _react2.default.createElement(
            'span',
            { className: 'submit-text' },
            _Config2.default.text.send
          ),
          _react2.default.createElement(
            'span',
            { className: 'right-arrow' },
            _react2.default.createElement(
              'svg',
              { className: 'hu-fill_button-text', xmlns: 'http://www.w3.org/2000/svg' },
              _react2.default.createElement('path', { d: 'M 11.78125 2.28125 L 2.78125 11.28125 L 2.09375 12 L 2.78125 12.71875 L 11.78125 21.71875 L 13.21875 20.28125 L 5.9375 13 L 22 13 L 22 11 L 5.9375 11 L 13.21875 3.71875 Z ' })
            )
          )
        )
      );

      if (!search) return _react2.default.createElement(
        'div',
        { className: 'hu-input-multi' },
        _react2.default.createElement(
          'span',
          { className: 'hu-input-multi-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase' },
          _Config2.default.text.input_multi_help
        ),
        _react2.default.createElement(
          'div',
          { className: 'hu-buttons-container' },
          _react2.default.createElement(
            'div',
            { className: 'hu-input-multi-buttons', ref: function ref(elem) {
                _this2.checksContainer = elem;
              } },
            _buttons.map(function (key, index) {
              return _react2.default.createElement(
                'div',
                {
                  className: 'multi-button hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark' + (checks[index] ? ' active' : ''),
                  'data-key': index,
                  onClick: function onClick() {
                    _this2.clickHandler(index);
                  }
                },
                _react2.default.createElement(
                  'div',
                  { className: 'check-block' },
                  _react2.default.createElement('input', { className: 'check-input', type: 'checkbox', 'data-key': index, checked: checks[index] }),
                  _react2.default.createElement('label', { className: 'check-label' })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'button-text' },
                  key
                )
              );
            })
          )
        ),
        inputFooter
      );else return _react2.default.createElement(
        'div',
        { className: 'hu-input-multi' },
        _react2.default.createElement(
          'span',
          { className: 'hu-input-multi-info not-selectable hu-s-10 hu-color_contrast hu-t-uppercase' },
          _Config2.default.text.input_instant_search_help
        ),
        _react2.default.createElement(
          'div',
          { className: 'hu-drop-search' },
          _react2.default.createElement(
            'div',
            { className: 'drop-search-input-container' },
            _react2.default.createElement('input', {
              className: 'drop-search-input hu-color_contrast hu-s-14',
              type: 'text',
              placeholder: _Config2.default.text.search,
              value: search_filter,
              onInput: function onInput(e) {
                return _this2.onSearchInput(e);
              }
            }),
            _react2.default.createElement('i', { className: 'fi magnification-lens hu-color_contrast' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'hu-buttons-container' },
            _react2.default.createElement(
              'div',
              { className: 'hu-input-multi-buttons', ref: function ref(elem) {
                  _this2.checksContainer = elem;
                } },
              _buttons.map(function (key, index) {
                return (filter_results.indexOf(key.toLowerCase()) > -1 || checks[index]) && _react2.default.createElement(
                  'div',
                  {
                    className: 'multi-button hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark' + (checks[index] ? ' active' : ''),
                    'data-key': index,
                    onClick: function onClick() {
                      _this2.clickHandler(index);
                    }
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'check-block' },
                    _react2.default.createElement('input', { className: 'check-input', type: 'checkbox', 'data-key': index, checked: checks[index] }),
                    _react2.default.createElement('label', { className: 'check-label' })
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'button-text' },
                    key
                  )
                );
              })
            )
          )
        ),
        inputFooter
      );
    }
  }]);

  return InputMulti;
}(_react2.default.Component);

exports.default = InputMulti;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InputReferral(brand) {
  return _react2.default.createElement(
    "div",
    { className: "hu-input-menu hu-input-referral" },
    _react2.default.createElement(
      "span",
      { className: "hu-input-menu-info not-selectable hu-s-15 hu-color_contrast" },
      "Want to create your own? It's easy, beautiful and free"
    ),
    _react2.default.createElement(
      "div",
      { className: "hu-input-menu-buttons" },
      _react2.default.createElement(
        "a",
        {
          href: "http://landbot.io/powered-by?utm_source=" + brand + "&amp;utm_medium=customers&amp;utm_campaign=goodbye",
          className: "menu-button hu-color_button-text hu-background-color_button-background hu-border-color_button-background-dark",
          target: "_blank"
        },
        _react2.default.createElement(
          "svg",
          { width: "31px", height: "27px", viewBox: "0 0 31 27", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
          _react2.default.createElement(
            "g",
            { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            _react2.default.createElement("path", { className: "hu-fill_button-text", d: "M30.0011525,5.51999975 C30.4811549,6.6800055 30.7211525,7.89999325 30.7211525,9.17999959 C30.7211525,10.5800065 30.4311554,11.8999933 29.8511525,13.1399994 C29.2711497,14.3800056 28.4611578,15.429995 27.4211526,16.2899993 C26.6611489,16.9900027 24.7011686,18.7799848 21.5411529,21.659999 C18.5811382,24.3600124 16.7711564,26.0099958 16.1111531,26.6099988 C15.8911521,26.7899997 15.6411546,26.8799988 15.3611532,26.8799988 C15.0811518,26.8799988 14.8311543,26.7899997 14.6111532,26.6099988 C13.6311484,25.7299944 11.0611742,23.3800181 6.90115356,19.5599991 C4.92114375,17.7599902 3.7911551,16.7400005 3.51115371,16.4999993 C3.43115331,16.4199989 3.34115422,16.3399997 3.24115372,16.2599993 C2.22114867,15.399995 1.4311566,14.3550055 0.871153829,13.1249994 C0.311151054,11.8949933 0.0211539665,10.5900064 0.00115386744,9.20999959 C-0.0188462317,7.94999334 0.221151358,6.7300056 0.721153835,5.54999975 C1.18115611,4.4299942 1.84114949,3.44000415 2.70115375,2.57999988 C4.38116207,0.859991362 6.39114188,0 8.73115348,0 C10.0111598,0 11.2261476,0.279997187 12.3761533,0.839999962 C13.526159,1.40000274 14.521149,2.1899948 15.3611532,3.20999986 C16.2011573,2.1899948 17.1961473,1.40000274 18.346153,0.839999962 C19.4961587,0.279997187 20.7111465,0 21.9911529,0 C24.3311645,0 26.3411443,0.849991462 28.0211526,2.54999989 C28.8811569,3.41000415 29.5411502,4.3999942 30.0011525,5.51999975 Z M17.0411531,4.79999979 C16.621151,5.36000256 16.0611566,5.63999975 15.3611532,5.63999975 C14.6611497,5.63999975 14.1011553,5.36000256 13.6811533,4.79999979 C13.0811503,4.01999592 12.3461577,3.41000205 11.4761534,2.96999987 C10.606149,2.52999769 9.69115823,2.3099999 8.73115348,2.3099999 C7.03114505,2.3099999 5.56115982,2.93999357 4.32115367,4.19999981 C3.6811505,4.84000298 3.19115542,5.57999555 2.85115374,6.41999971 C2.47115186,7.30000407 2.29115367,8.22999473 2.31115376,9.20999959 C2.31115376,10.2300046 2.52115165,11.2049948 2.94115374,12.1349995 C3.36115582,13.0650041 3.96114979,13.8499962 4.74115366,14.4899994 C4.78115385,14.5499996 4.86115305,14.6199989 4.98115364,14.6999993 C5.00115374,14.7199994 5.02115354,14.7499991 5.04115364,14.7899993 C5.40115543,15.1100009 6.34114598,15.9599924 7.86115352,17.3399992 L9.30115345,18.6599992 C12.1811677,21.2800121 14.2011474,23.1199937 15.3611532,24.1799989 C16.2811577,23.3399948 17.8211423,21.9400088 19.981153,19.9799991 C22.6811664,17.4799867 24.6511466,15.6800048 25.8911527,14.5799993 L25.9511527,14.5199994 C26.7111565,13.8999963 27.3111504,13.130004 27.7511526,12.2099995 C28.1911548,11.2499947 28.4111526,10.2400048 28.4111526,9.17999959 C28.4111526,8.19999473 28.2311544,7.27000408 27.8711526,6.38999971 C27.5311509,5.54999555 27.0411559,4.81000298 26.4011527,4.16999981 C25.1611465,2.92999367 23.6911613,2.3099999 21.9911529,2.3099999 C21.0311481,2.3099999 20.1161573,2.52499774 19.246153,2.95499987 C18.3761487,3.385002 17.6411561,3.99999582 17.0411531,4.79999979 Z", id: "\uE6A4", fill: "#FFFFFF" })
          )
        ),
        _react2.default.createElement(
          "span",
          { className: "button-text" },
          "Create a Landbot"
        )
      )
    )
  );
}

exports.default = InputReferral;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypingSwitchMobile = function (_React$Component) {
  _inherits(TypingSwitchMobile, _React$Component);

  function TypingSwitchMobile(props) {
    _classCallCheck(this, TypingSwitchMobile);

    var _this = _possibleConstructorReturn(this, (TypingSwitchMobile.__proto__ || Object.getPrototypeOf(TypingSwitchMobile)).call(this, props));

    _this.state = {
      typing: props.typing
    };
    _this.ee = props.ee;
    return _this;
  }

  _createClass(TypingSwitchMobile, [{
    key: 'onClick',
    value: function onClick() {
      var newState = !this.props.typing;
      if (newState === false) this.ee.emit('hu-lb-key-arrowdown');

      setGlobalState({
        typing: newState
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var typing = this.props.typing;

      return _react2.default.createElement(
        'div',
        { className: 'hu-mobile-skip-pause' },
        typing ? // SKIP PAUSE
        _react2.default.createElement(
          'button',
          { className: 'skip-pause-button skip-btn hu-border-color_contrast hu-flex hu-items-center', onClick: this.onClick.bind(this) },
          _react2.default.createElement(
            'p',
            { className: 'hu-color_contrast hu-s-10 hu-t-uppercase' },
            'Skip pauses'
          ),
          _react2.default.createElement(
            'svg',
            { width: '27px', height: '23px', viewBox: '0 0 27 23', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
            _react2.default.createElement(
              'g',
              { stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
              _react2.default.createElement(
                'g',
                { transform: 'translate(-152.000000, -956.000000)', fill: '#5D4161' },
                _react2.default.createElement('path', { className: 'hu-fill_contrast', d: 'M163.0876,978.49 C162.867599,978.209999 162.7776,977.890002 162.8176,977.53 C162.857601,977.169998 163.017599,976.880001 163.2976,976.66 L174.7276,967.450001 L163.3576,958.300001 C163.077599,958.08 162.917601,957.790003 162.8776,957.430001 C162.8376,957.069999 162.927599,956.750002 163.1476,956.470001 C163.367601,956.19 163.657599,956.030001 164.0176,955.990001 C164.377602,955.950001 164.697599,956.04 164.9776,956.260001 L177.6376,966.430001 C177.977601,966.690002 178.1476,967.029998 178.1476,967.450001 C178.1476,967.870003 177.977601,968.209999 177.6376,968.47 L164.9176,978.7 C164.677599,978.900001 164.407602,979 164.1076,979 C163.687598,979 163.347602,978.830002 163.0876,978.49 Z M153.187601,978.49 C152.9676,978.209999 152.877601,977.890002 152.917601,977.53 C152.957601,977.169998 153.117599,976.880001 153.397601,976.66 L164.8276,967.450001 L153.457601,958.300001 C153.177599,958.08 153.017601,957.790003 152.977601,957.430001 C152.937601,957.069999 153.0276,956.750002 153.247601,956.470001 C153.467602,956.19 153.757599,956.030001 154.117601,955.990001 C154.477603,955.950001 154.797599,956.04 155.077601,956.260001 L167.7376,966.430001 C168.077602,966.690002 168.2476,967.029998 168.2476,967.450001 C168.2476,967.870003 168.077602,968.209999 167.7376,968.47 L155.017601,978.7 C154.7776,978.900001 154.507602,979 154.207601,979 C153.787599,979 153.447602,978.830002 153.187601,978.49 Z', id: '\uE617' })
              )
            )
          )
        ) : // APPLY PAUSE
        _react2.default.createElement(
          'button',
          { className: 'skip-pause-button apply-btn hu-border-color_contrast hu-flex hu-items-center', onClick: this.onClick.bind(this) },
          _react2.default.createElement(
            'p',
            { className: 'hu-color_button-text hu-s-10 hu-t-uppercase' },
            'Apply pauses'
          ),
          _react2.default.createElement(
            'svg',
            { width: '24px', height: '5px', viewBox: '0 0 24 5', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
            _react2.default.createElement(
              'g',
              { stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
              _react2.default.createElement(
                'g',
                { transform: 'translate(-154.000000, -965.000000)', fill: '#5D4161' },
                _react2.default.createElement('path', { className: 'hu-fill_button-text', d: 'M154.552601,966.115001 C154.182599,966.485002 153.997601,966.939998 153.997601,967.480001 C153.997601,968.020003 154.182599,968.474999 154.552601,968.845 C154.922603,969.215002 155.377598,969.4 155.917601,969.4 C156.457603,969.4 156.912599,969.215002 157.282601,968.845 C157.652602,968.474999 157.837601,968.020003 157.837601,967.480001 C157.837601,966.939998 157.652602,966.485002 157.282601,966.115001 C156.912599,965.744999 156.457603,965.560001 155.917601,965.560001 C155.377598,965.560001 154.922603,965.744999 154.552601,966.115001 Z M164.1526,966.115001 C163.782598,966.485002 163.5976,966.939998 163.5976,967.480001 C163.5976,968.020003 163.782598,968.474999 164.1526,968.845 C164.522602,969.215002 164.977598,969.4 165.5176,969.4 C166.057603,969.4 166.512598,969.215002 166.8826,968.845 C167.252602,968.474999 167.4376,968.020003 167.4376,967.480001 C167.4376,966.939998 167.252602,966.485002 166.8826,966.115001 C166.512598,965.744999 166.057603,965.560001 165.5176,965.560001 C164.977598,965.560001 164.522602,965.744999 164.1526,966.115001 Z M173.7526,966.115001 C173.382598,966.485002 173.1976,966.939998 173.1976,967.480001 C173.1976,968.020003 173.382598,968.474999 173.7526,968.845 C174.122602,969.215002 174.577597,969.4 175.1176,969.4 C175.657603,969.4 176.112598,969.215002 176.4826,968.845 C176.852602,968.474999 177.0376,968.020003 177.0376,967.480001 C177.0376,966.939998 176.852602,966.485002 176.4826,966.115001 C176.112598,965.744999 175.657603,965.560001 175.1176,965.560001 C174.577597,965.560001 174.122602,965.744999 173.7526,966.115001 Z', id: '\uE647' })
              )
            )
          )
        )
      );
    }
  }]);

  return TypingSwitchMobile;
}(_react2.default.Component);

exports.default = TypingSwitchMobile;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressBar = function (_React$Component) {
  _inherits(ProgressBar, _React$Component);

  function ProgressBar(props) {
    _classCallCheck(this, ProgressBar);

    var _this = _possibleConstructorReturn(this, (ProgressBar.__proto__ || Object.getPrototypeOf(ProgressBar)).call(this, props));

    _this.state = {
      progress: props.progress,
      step: 0
    };
    window.setProgress = _this.setProgress.bind(_this);
    return _this;
  }

  _createClass(ProgressBar, [{
    key: 'setProgress',
    value: function setProgress(n, m) {
      var progress = this.props.progress;

      this.setState(Object.assign({ step: n }, m !== undefined ? { progress: m } : {}));
    }
  }, {
    key: 'render',
    value: function render(_ref, _ref2) {
      var progress = _ref2.progress,
          step = _ref2.step;

      _objectDestructuringEmpty(_ref);

      var doc = document.documentElement;
      var viewWidth = doc.clientWidth;
      var progressPercent = parseInt(step * 100 / progress);
      var minLeftPercent = 60 * 100 / viewWidth;
      var maxLeftPercent = (viewWidth - 60) * 100 / viewWidth;
      var leftPos = null;
      if (progressPercent < minLeftPercent) leftPos = 'calc(' + minLeftPercent + '% - 60px)';else if (progressPercent < maxLeftPercent) leftPos = 'calc(' + progressPercent + '% - 60px)';else leftPos = 'calc(' + maxLeftPercent + '% - 60px)';

      return typeof progress === 'number' && _react2.default.createElement(
        'div',
        {
          id: 'hu-bot-progress-bar',
          'data-step': '' + (progress === step ? 'last' : step)
        },
        _react2.default.createElement(
          'style',
          null,
          '#hu-bot-progress-bar::after { width: ' + progressPercent + '%; }\n.progress-bar-label { left: ' + leftPos + '; }'
        ),
        _react2.default.createElement(
          'div',
          { className: 'progress-bar-label hu-color_dark' },
          _react2.default.createElement(
            'svg',
            { width: '10px', height: '3px', viewBox: '0 0 10 3', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
            _react2.default.createElement(
              'g',
              { id: 'Page-1', stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
              _react2.default.createElement(
                'g',
                { id: 'Group-Copy', transform: 'translate(-71.000000, -89.000000)', fill: '#0A4359' },
                _react2.default.createElement('path', { d: 'M68,91.6612983 L71.0318827,91.6612983 C72.3951688,91.6612983 73.6919908,91.0723536 74.5890805,90.0458162 L74.6525451,89.9731938 C75.2675982,89.2693902 76.3367428,89.1974437 77.0405464,89.8124967 C77.1213362,89.8830988 77.195229,89.9612236 77.2612271,90.0458162 L77.2612271,90.0458162 C78.0566243,91.0653113 79.2775215,91.6612983 80.5705904,91.6612983 Z', id: 'Rectangle-4' })
              )
            )
          ),
          progress === step ? _react2.default.createElement(
            'span',
            null,
            'Done! \uD83C\uDF89'
          ) : _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'b',
              { className: 'hu-color_accent' },
              progress - step,
              ' '
            ),
            progress - step === 1 ? 'step' : 'steps',
            ' to finish'
          )
        )
      );
    }
  }]);

  return ProgressBar;
}(_react2.default.Component);

exports.default = ProgressBar;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Config = __webpack_require__(3);

var _KeywordSelector = __webpack_require__(30);

var _KeywordSelector2 = _interopRequireDefault(_KeywordSelector);

var _TypingSwitch = __webpack_require__(148);

var _TypingSwitch2 = _interopRequireDefault(_TypingSwitch);

var _ScrollButton = __webpack_require__(47);

var _ScrollButton2 = _interopRequireDefault(_ScrollButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer(props) {
    _classCallCheck(this, Footer);

    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

    _this.state = {
      brand_name: props.brand_name,
      keywords: props.keywords,
      branding: props.branding,
      typing: props.typing
    };
    _this.ee = props.ee;
    return _this;
  }

  _createClass(Footer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          brand_name = _props.brand_name,
          keywords = _props.keywords,
          branding = _props.branding,
          typing = _props.typing;


      return _react2.default.createElement(
        'footer',
        { id: 'hu-footer' },
        _react2.default.createElement(_KeywordSelector2.default, {
          keywords: keywords,
          ee: this.ee
        }),
        _react2.default.createElement(_TypingSwitch2.default, {
          typing: typing,
          ee: this.ee
        }),
        branding && _react2.default.createElement(
          'div',
          { className: 'hu-mobile-powered-by' },
          _react2.default.createElement(
            'p',
            { className: 'powered-by-text hu-a-center hu-color_contrast hu-s-12' },
            'Powered by ',
            _react2.default.createElement(
              'a',
              { className: 'hu-border-color_contrast', target: '_blank', href: _Config.referralFooterURL },
              _react2.default.createElement(
                'b',
                null,
                'Landbot.io'
              )
            )
          )
        )
      );
    }
  }]);

  return Footer;
}(_react2.default.Component);

exports.default = Footer;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TypingSwitch = function (_React$Component) {
  _inherits(TypingSwitch, _React$Component);

  function TypingSwitch(props) {
    _classCallCheck(this, TypingSwitch);

    var _this = _possibleConstructorReturn(this, (TypingSwitch.__proto__ || Object.getPrototypeOf(TypingSwitch)).call(this, props));

    _this.state = {
      typing: props.typing
    };
    _this.ee = props.ee;
    return _this;
  }

  _createClass(TypingSwitch, [{
    key: 'onClick',
    value: function onClick() {
      var newState = !this.props.typing;
      if (newState === false) this.ee.emit('hu-lb-key-arrowdown');

      setGlobalState({
        typing: newState
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var typing = this.props.typing;

      return _react2.default.createElement(
        'div',
        { className: 'hu-skip-pause hu-flex hu-items-center hu-a-right' },
        typing ? // SKIP PAUSE
        _react2.default.createElement(
          'button',
          { className: 'skip-pause-button skip-btn hu-border-color_contrast', onClick: this.onClick.bind(this) },
          _react2.default.createElement(
            'svg',
            { width: '27px', height: '23px', viewBox: '0 0 27 23', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
            _react2.default.createElement(
              'g',
              { stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
              _react2.default.createElement(
                'g',
                { transform: 'translate(-152.000000, -956.000000)', fill: '#5D4161' },
                _react2.default.createElement('path', { className: 'hu-fill_contrast', d: 'M163.0876,978.49 C162.867599,978.209999 162.7776,977.890002 162.8176,977.53 C162.857601,977.169998 163.017599,976.880001 163.2976,976.66 L174.7276,967.450001 L163.3576,958.300001 C163.077599,958.08 162.917601,957.790003 162.8776,957.430001 C162.8376,957.069999 162.927599,956.750002 163.1476,956.470001 C163.367601,956.19 163.657599,956.030001 164.0176,955.990001 C164.377602,955.950001 164.697599,956.04 164.9776,956.260001 L177.6376,966.430001 C177.977601,966.690002 178.1476,967.029998 178.1476,967.450001 C178.1476,967.870003 177.977601,968.209999 177.6376,968.47 L164.9176,978.7 C164.677599,978.900001 164.407602,979 164.1076,979 C163.687598,979 163.347602,978.830002 163.0876,978.49 Z M153.187601,978.49 C152.9676,978.209999 152.877601,977.890002 152.917601,977.53 C152.957601,977.169998 153.117599,976.880001 153.397601,976.66 L164.8276,967.450001 L153.457601,958.300001 C153.177599,958.08 153.017601,957.790003 152.977601,957.430001 C152.937601,957.069999 153.0276,956.750002 153.247601,956.470001 C153.467602,956.19 153.757599,956.030001 154.117601,955.990001 C154.477603,955.950001 154.797599,956.04 155.077601,956.260001 L167.7376,966.430001 C168.077602,966.690002 168.2476,967.029998 168.2476,967.450001 C168.2476,967.870003 168.077602,968.209999 167.7376,968.47 L155.017601,978.7 C154.7776,978.900001 154.507602,979 154.207601,979 C153.787599,979 153.447602,978.830002 153.187601,978.49 Z', id: '\uE617' })
              )
            )
          )
        ) : // APPLY PAUSE
        _react2.default.createElement(
          'button',
          { className: 'skip-pause-button apply-btn hu-border-color_contrast', onClick: this.onClick.bind(this) },
          _react2.default.createElement(
            'svg',
            { width: '24px', height: '5px', viewBox: '0 0 24 5', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
            _react2.default.createElement(
              'g',
              { stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
              _react2.default.createElement(
                'g',
                { transform: 'translate(-154.000000, -965.000000)', fill: '#5D4161' },
                _react2.default.createElement('path', { className: 'hu-fill_accent', d: 'M154.552601,966.115001 C154.182599,966.485002 153.997601,966.939998 153.997601,967.480001 C153.997601,968.020003 154.182599,968.474999 154.552601,968.845 C154.922603,969.215002 155.377598,969.4 155.917601,969.4 C156.457603,969.4 156.912599,969.215002 157.282601,968.845 C157.652602,968.474999 157.837601,968.020003 157.837601,967.480001 C157.837601,966.939998 157.652602,966.485002 157.282601,966.115001 C156.912599,965.744999 156.457603,965.560001 155.917601,965.560001 C155.377598,965.560001 154.922603,965.744999 154.552601,966.115001 Z M164.1526,966.115001 C163.782598,966.485002 163.5976,966.939998 163.5976,967.480001 C163.5976,968.020003 163.782598,968.474999 164.1526,968.845 C164.522602,969.215002 164.977598,969.4 165.5176,969.4 C166.057603,969.4 166.512598,969.215002 166.8826,968.845 C167.252602,968.474999 167.4376,968.020003 167.4376,967.480001 C167.4376,966.939998 167.252602,966.485002 166.8826,966.115001 C166.512598,965.744999 166.057603,965.560001 165.5176,965.560001 C164.977598,965.560001 164.522602,965.744999 164.1526,966.115001 Z M173.7526,966.115001 C173.382598,966.485002 173.1976,966.939998 173.1976,967.480001 C173.1976,968.020003 173.382598,968.474999 173.7526,968.845 C174.122602,969.215002 174.577597,969.4 175.1176,969.4 C175.657603,969.4 176.112598,969.215002 176.4826,968.845 C176.852602,968.474999 177.0376,968.020003 177.0376,967.480001 C177.0376,966.939998 176.852602,966.485002 176.4826,966.115001 C176.112598,965.744999 175.657603,965.560001 175.1176,965.560001 C174.577597,965.560001 174.122602,965.744999 173.7526,966.115001 Z', id: '\uE647' })
              )
            )
          )
        ),
        typing ? _react2.default.createElement(
          'p',
          { className: 'hu-color_contrast hu-s-12 hu-t-uppercase' },
          'Skip pause',
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { className: 'skip-text-sub hu-s-10 hu-w-bold' },
            'between messages'
          )
        ) : _react2.default.createElement(
          'p',
          { className: 'hu-color_contrast hu-s-12 hu-t-uppercase' },
          'Apply pause',
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { className: 'skip-text-sub hu-s-10 hu-w-bold' },
            'between messages'
          )
        )
      );
    }
  }]);

  return TypingSwitch;
}(_react2.default.Component);

exports.default = TypingSwitch;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KeyboardDriver = function () {
  function KeyboardDriver(options) {
    _classCallCheck(this, KeyboardDriver);

    this.container = document;
    this.shortcuts = options.shortcuts;
    this.ee = options.ee;

    this.setupListeners();
  }

  _createClass(KeyboardDriver, [{
    key: 'setupListeners',
    value: function setupListeners() {
      var _this = this;

      this.container.addEventListener('keydown', function (e) {
        var key = e.keyCode || e.which;
        if (key === 40) // ArrowDown
          _this.ee.emit('hu-lb-key-arrowdown');
      });

      this.container.addEventListener('keypress', function (e) {
        var char = String.fromCharCode(e.keyCode || e.which || null);
        if (/[a-zA-Z0-9]/.test(char)) _this.ee.emit('hu-lb-text-focus', char);
      });
    }
  }]);

  return KeyboardDriver;
}();

exports.default = KeyboardDriver;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BackgroundVideo = __webpack_require__(151);

var _BackgroundVideo2 = _interopRequireDefault(_BackgroundVideo);

var _BackgroundImage = __webpack_require__(152);

var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);

var _BackgroundGradient = __webpack_require__(153);

var _BackgroundGradient2 = _interopRequireDefault(_BackgroundGradient);

var _BackgroundColor = __webpack_require__(154);

var _BackgroundColor2 = _interopRequireDefault(_BackgroundColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Background = function (_React$Component) {
  _inherits(Background, _React$Component);

  function Background(props) {
    _classCallCheck(this, Background);

    var _this = _possibleConstructorReturn(this, (Background.__proto__ || Object.getPrototypeOf(Background)).call(this, props));

    _this.state = {
      staticUrl: props.staticUrl,
      background_type: props.background_type,
      background_image_url: props.background_image_url,
      background_color: props.background_color,
      gradient_from: props.gradient_from,
      gradient_to: props.gradient_to,
      video_texture: props.video_texture,
      videoname: props.videoname,
      video_url: props.video_url,
      widget_hide_background: props.widget_hide_background
    };
    return _this;
  }

  _createClass(Background, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          staticUrl = _props.staticUrl,
          background_type = _props.background_type,
          background_image_url = _props.background_image_url,
          background_color = _props.background_color,
          gradient_from = _props.gradient_from,
          gradient_to = _props.gradient_to,
          video_texture = _props.video_texture,
          videoname = _props.videoname,
          video_url = _props.video_url,
          widget_hide_background = _props.widget_hide_background;


      return !widget_hide_background && _react2.default.createElement(
        'div',
        { id: 'hu-background' },
        _react2.default.createElement(_BackgroundVideo2.default, {
          staticUrl: staticUrl,
          background_type: background_type,
          videoname: videoname,
          video_url: video_url
        }),
        _react2.default.createElement(_BackgroundImage2.default, {
          staticUrl: staticUrl,
          background_type: background_type,
          background_image_url: background_image_url
        }),
        _react2.default.createElement(_BackgroundGradient2.default, {
          background_type: background_type,
          gradient_from: gradient_from,
          gradient_to: gradient_to
        }),
        _react2.default.createElement(_BackgroundColor2.default, {
          background_type: background_type,
          background_color: background_color
        })
      );
    }
  }]);

  return Background;
}(_react2.default.Component);

exports.default = Background;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundVideo = function (_React$Component) {
  _inherits(BackgroundVideo, _React$Component);

  function BackgroundVideo(props) {
    _classCallCheck(this, BackgroundVideo);

    var _this = _possibleConstructorReturn(this, (BackgroundVideo.__proto__ || Object.getPrototypeOf(BackgroundVideo)).call(this, props));

    _this.state = {
      staticUrl: props.staticUrl,
      background_type: props.background_type,
      videoname: props.videoname,
      video_url: props.video_url
    };
    _this.videoPromise = null;
    _this.backgroundRef = null;
    _this.videoRef = null;
    return _this;
  }

  _createClass(BackgroundVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var background_type = this.props.background_type;

      var selected = background_type === 'video';

      if (selected) this.mountSources();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          staticUrl = _props.staticUrl,
          background_type = _props.background_type,
          videoname = _props.videoname,
          video_url = _props.video_url;

      var selected = background_type === 'video';
      var bg = this.backgroundRef;
      var video = this.videoRef;

      if (background_type !== nextProps.background_type && nextProps.background_type === 'video') {
        // OFF => ON
        this.mountSources(nextProps.videoname);
      } else if (background_type !== nextProps.background_type && this.props.background_type === 'video') {// ON => OFF
        // this.videoPromise.then(() => {
        //   video.pause();
        // });
      } else if (background_type === 'video') {
        // ON => ON
        if (videoname !== nextProps.videoname) {
          // videoname Change
          this.mountSources(nextProps.videoname);
          // const sources = video.getElementsByTagName('source');
          // let url = '';
          // // this.videoPromise.then(() => {
          // //   video.pause();
          // // });
          // video.setAttribute('poster', `${staticUrl}landbot/video/${nextProps.videoname}.jpg`);
          // for (let i = 0; i < sources.length; i++) {
          //   url = sources[i].getAttribute('src').replace(/(landbot\/video\/)(?:\w+)(\.mp4|\.webm)/g, `$1${nextProps.videoname}$2`);
          //   sources[i].setAttribute('src', url);
          // }
          // video.load();
          // video.play();
        }
      } else {// OFF => OFF
          // Nothing
        }

      if (nextProps.background_type !== 'video') bg.className = bg.className.replace(/\sselected/g, '');else bg.className = 'hu-background-video' + ' selected';
      return false;
    }
  }, {
    key: 'mountSources',
    value: function mountSources() {
      var videoname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.videoname;
      var _props2 = this.props,
          staticUrl = _props2.staticUrl,
          background_type = _props2.background_type,
          video_url = _props2.video_url;

      var bg = this.backgroundRef;
      var video = this.videoRef;
      var sources = video.getElementsByTagName('source');
      var url = '';
      // this.videoPromise.then(() => {
      //   video.pause();
      // });
      video.setAttribute('poster', staticUrl + 'landbot/video/' + videoname + '.jpg');
      for (var i = 0; i < sources.length; i++) {
        url = sources[i].getAttribute('data-src').replace(/(landbot\/video\/)(?:\w+)(\.mp4|\.webm)/g, '$1' + videoname + '$2');
        sources[i].setAttribute('src', url);
      }
      video.load();
      video.play();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          staticUrl = _props3.staticUrl,
          background_type = _props3.background_type,
          videoname = _props3.videoname,
          video_url = _props3.video_url;

      var selected = background_type === 'video';
      var overlay = _react2.default.createElement('div', { className: 'background-video-filter selected' });

      if (video_url !== null) return _react2.default.createElement(
        'div',
        { className: selected ? 'hu-background-video selected' : 'hu-background-video', ref: function ref(el) {
            return _this2.backgroundRef = el;
          } },
        _react2.default.createElement(
          'video',
          { id: 'bgvid', playsInline: true, autoPlay: true, muted: true, loop: true, ref: function ref(el) {
              _this2.videoRef = el;
            } },
          _react2.default.createElement('source', { src: video_url, type: 'video/mp4' })
        ),
        overlay
      );else return _react2.default.createElement(
        'div',
        { className: selected ? 'hu-background-video selected' : 'hu-background-video', ref: function ref(el) {
            return _this2.backgroundRef = el;
          } },
        _react2.default.createElement(
          'video',
          { id: 'bgvid', playsInline: true, autoPlay: true, muted: true, loop: true, poster: staticUrl + 'landbot/video/' + videoname + '.jpg', ref: function ref(el) {
              _this2.videoRef = el;
            } },
          _react2.default.createElement('source', { 'data-src': staticUrl + 'landbot/video/' + videoname + '.webm', type: 'video/webm' }),
          _react2.default.createElement('source', { 'data-src': staticUrl + 'landbot/video/' + videoname + '.mp4', type: 'video/mp4' })
        ),
        overlay
      );
    }
  }]);

  return BackgroundVideo;
}(_react2.default.Component);

/*********** Not posible with REACT ***********
<!--[if lt IE 9]>
<script>document.createElement("video");</script>
<![endif]-->
***********************************************/

exports.default = BackgroundVideo;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundImage = function (_React$Component) {
  _inherits(BackgroundImage, _React$Component);

  function BackgroundImage(props) {
    _classCallCheck(this, BackgroundImage);

    var _this = _possibleConstructorReturn(this, (BackgroundImage.__proto__ || Object.getPrototypeOf(BackgroundImage)).call(this, props));

    _this.state = {
      staticUrl: props.staticUrl,
      background_type: props.background_type,
      background_image_url: props.background_image_url
    };
    return _this;
  }

  _createClass(BackgroundImage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var bg = document.querySelector('#hu-background .hu-background-image');
      if (nextProps.background_type !== 'image') bg.className = bg.className.replace(/\sselected/g, '');else bg.className = 'hu-background-image' + ' selected';
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var background_type = this.props.background_type;

      var selected = background_type === 'image';

      return _react2.default.createElement(
        'div',
        { className: selected ? 'hu-background-image selected' : 'hu-background-image' },
        _react2.default.createElement('div', { className: 'background-image-filter selected' })
      );
    }
  }]);

  return BackgroundImage;
}(_react2.default.Component);

exports.default = BackgroundImage;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundGradient = function (_React$Component) {
  _inherits(BackgroundGradient, _React$Component);

  function BackgroundGradient(props) {
    _classCallCheck(this, BackgroundGradient);

    var _this = _possibleConstructorReturn(this, (BackgroundGradient.__proto__ || Object.getPrototypeOf(BackgroundGradient)).call(this, props));

    _this.state = {
      background_type: props.background_type,
      gradient_from: props.gradient_from,
      gradient_to: props.gradient_to
    };
    return _this;
  }

  _createClass(BackgroundGradient, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var bg = document.querySelector('#hu-background .hu-background-gradient');
      if (nextProps.background_type !== 'gradient') bg.className = bg.className.replace(/\sselected/g, '');else bg.className = 'hu-background-gradient' + ' selected';
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          background_type = _props.background_type,
          gradient_from = _props.gradient_from,
          gradient_to = _props.gradient_to;

      var selected = background_type === 'gradient';

      return _react2.default.createElement('div', { className: selected ? 'hu-background-gradient selected' : 'hu-background-gradient' });
    }
  }]);

  return BackgroundGradient;
}(_react2.default.Component);

exports.default = BackgroundGradient;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BackgroundColor = function (_React$Component) {
  _inherits(BackgroundColor, _React$Component);

  function BackgroundColor(props) {
    _classCallCheck(this, BackgroundColor);

    var _this = _possibleConstructorReturn(this, (BackgroundColor.__proto__ || Object.getPrototypeOf(BackgroundColor)).call(this, props));

    _this.state = {
      background_type: props.background_type,
      background_color: props.background_color
    };
    return _this;
  }

  _createClass(BackgroundColor, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var bg = document.querySelector('#hu-background .hu-background-color');
      if (nextProps.background_type !== 'color') bg.className = bg.className.replace(/\sselected/g, '');else bg.className = 'hu-background-color' + ' selected';
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          background_type = _props.background_type,
          background_color = _props.background_color;

      var selected = background_type === 'color';

      return _react2.default.createElement('div', { className: selected ? 'hu-background-color selected' : 'hu-background-color' });
    }
  }]);

  return BackgroundColor;
}(_react2.default.Component);

exports.default = BackgroundColor;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FilterImage = __webpack_require__(156);

var _FilterImage2 = _interopRequireDefault(_FilterImage);

var _FilterGradient = __webpack_require__(157);

var _FilterGradient2 = _interopRequireDefault(_FilterGradient);

var _FilterColor = __webpack_require__(158);

var _FilterColor2 = _interopRequireDefault(_FilterColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_React$Component) {
  _inherits(Filter, _React$Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this.state = {
      staticUrl: props.staticUrl,
      filter_type: props.filter_type,
      filter_color: props.filter_color,
      filter_gradient_from: props.filter_gradient_from,
      filter_gradient_to: props.filter_gradient_to,
      filter_image_url: props.filter_image_url,
      widget_hide_background: props.widget_hide_background
    };
    return _this;
  }

  _createClass(Filter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var filter = document.getElementById('hu-filter');
      if (!filter) return;
      if (nextProps.filter_type === 'none') filter.className = filter.className.replace(/active/g, '');else filter.className = 'active';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          staticUrl = _props.staticUrl,
          filter_type = _props.filter_type,
          filter_color = _props.filter_color,
          filter_gradient_from = _props.filter_gradient_from,
          filter_gradient_to = _props.filter_gradient_to,
          filter_image_url = _props.filter_image_url,
          widget_hide_background = _props.widget_hide_background;

      var active = filter_type !== 'none';

      return !widget_hide_background && _react2.default.createElement(
        'div',
        { id: 'hu-filter', className: active ? 'active' : '' },
        _react2.default.createElement(_FilterGradient2.default, {
          filter_type: filter_type,
          filter_gradient_from: filter_gradient_from,
          filter_gradient_to: filter_gradient_to
        }),
        _react2.default.createElement(_FilterColor2.default, {
          filter_type: filter_type,
          filter_color: filter_color
        }),
        _react2.default.createElement(_FilterImage2.default, {
          filter_type: filter_type,
          filter_image_url: filter_image_url
        })
      );
    }
  }]);

  return Filter;
}(_react2.default.Component);

exports.default = Filter;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterImage = function (_React$Component) {
  _inherits(FilterImage, _React$Component);

  function FilterImage(props) {
    _classCallCheck(this, FilterImage);

    var _this = _possibleConstructorReturn(this, (FilterImage.__proto__ || Object.getPrototypeOf(FilterImage)).call(this, props));

    _this.state = {
      filter_type: props.filter_type,
      filter_gradient_from: props.filter_gradient_from,
      filter_gradient_to: props.filter_gradient_to
    };
    return _this;
  }

  _createClass(FilterImage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var bg = document.querySelector('#hu-filter .hu-filter-image');
      if (nextProps.filter_type !== 'image') bg.className = bg.className.replace(/\sselected/g, '');else bg.className = 'hu-filter-image' + ' selected';
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var filter_type = this.props.filter_type;

      var selected = filter_type === 'image';

      return _react2.default.createElement('div', { className: selected ? 'hu-filter-image selected' : 'hu-filter-image' });
    }
  }]);

  return FilterImage;
}(_react2.default.Component);

exports.default = FilterImage;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterGradient = function (_React$Component) {
  _inherits(FilterGradient, _React$Component);

  function FilterGradient(props) {
    _classCallCheck(this, FilterGradient);

    var _this = _possibleConstructorReturn(this, (FilterGradient.__proto__ || Object.getPrototypeOf(FilterGradient)).call(this, props));

    _this.state = {
      filter_type: props.filter_type,
      filter_gradient_from: props.filter_gradient_from,
      filter_gradient_to: props.filter_gradient_to
    };
    return _this;
  }

  _createClass(FilterGradient, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var bg = document.querySelector('#hu-filter .hu-filter-gradient');
      if (nextProps.filter_type !== 'gradient') bg.className = bg.className.replace(/\sselected/g, '');else bg.className = 'hu-filter-gradient' + ' selected';
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var filter_type = this.props.filter_type;

      var selected = filter_type === 'gradient';

      return _react2.default.createElement('div', { className: selected ? 'hu-filter-gradient selected' : 'hu-filter-gradient' });
    }
  }]);

  return FilterGradient;
}(_react2.default.Component);

exports.default = FilterGradient;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterColor = function (_React$Component) {
  _inherits(FilterColor, _React$Component);

  function FilterColor(props) {
    _classCallCheck(this, FilterColor);

    var _this = _possibleConstructorReturn(this, (FilterColor.__proto__ || Object.getPrototypeOf(FilterColor)).call(this, props));

    _this.state = {
      filter_type: props.filter_type,
      filter_color: props.filter_color
    };
    return _this;
  }

  _createClass(FilterColor, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var bg = document.querySelector('#hu-filter .hu-filter-color');
      if (nextProps.filter_type !== 'color') bg.className = bg.className.replace(/\sselected/g, '');else bg.className = 'hu-filter-color' + ' selected';
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var filter_type = this.props.filter_type;

      var selected = filter_type === 'color';

      return _react2.default.createElement('div', { className: selected ? 'hu-filter-color selected' : 'hu-filter-color' });
    }
  }]);

  return FilterColor;
}(_react2.default.Component);

exports.default = FilterColor;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// landbot-2.1.0.js